import './index.css';var d1 = Object.defineProperty;
var f1 = (e, t, r) => t in e ? d1(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r;
var Bn = (e, t, r) => f1(e, typeof t != "symbol" ? t + "" : t, r);
import * as Q from "react";
import G, { useRef as ce, useEffect as ge, useMemo as ae, useState as me, useCallback as Le, createContext as $e, useContext as Oe, useDebugValue as uf, useLayoutEffect as pi, forwardRef as na, Fragment as jt, isValidElement as pm, cloneElement as p1, createElement as m1, useId as xt, useReducer as Co, useSyncExternalStore as h1, createRef as Wa, useImperativeHandle as g1, Children as v1 } from "react";
import { batch as y1, useDispatch as b1, useSelector as w1, useStore as x1, shallowEqual as Ya } from "react-redux";
import * as _1 from "react-dom";
import mm, { createPortal as hm, flushSync as zt } from "react-dom";
import * as Ec from "react/jsx-runtime";
import { jsxs as ue, jsx as L, Fragment as Gt } from "react/jsx-runtime";
const er = (e) => e.status === 200, S1 = () => !!navigator.userAgent.match(/FBAN|FBAV/i), E1 = () => !!navigator.userAgent.match(/Line\/[\d.]+\/IAB/i), T1 = () => ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document, gm = (e) => {
  let t, r, n = "";
  if (typeof e == "string" || typeof e == "number")
    n += e;
  else if (typeof e == "object")
    if (Array.isArray(e)) {
      const o = e.length;
      for (t = 0; t < o; t++)
        e[t] && (r = gm(e[t])) && (n && (n += " "), n += r);
    } else
      for (r in e)
        e[r] && (n && (n += " "), n += r);
  return n;
}, V = (...e) => {
  let t = 0, r, n, o = "";
  const a = e.length;
  for (; t < a; t++)
    (r = e[t]) && (n = gm(r)) && (o && (o += " "), o += n);
  return o;
};
var k1 = /^-?(?:\d+(?:\.\d*)?|\.\d+)(?:e[+-]?\d+)?$/i, Ll = Math.ceil, Dr = Math.floor, or = "[BigNumber Error] ", df = or + "Number primitive has more than 15 significant digits: ", Lr = 1e14, De = 14, $l = 9007199254740991, Wl = [1, 10, 100, 1e3, 1e4, 1e5, 1e6, 1e7, 1e8, 1e9, 1e10, 1e11, 1e12, 1e13], jn = 1e7, Wt = 1e9;
function vm(e) {
  var t, r, n, o = g.prototype = { constructor: g, toString: null, valueOf: null }, a = new g(1), i = 20, s = 4, l = -7, u = 21, c = -1e7, p = 1e7, d = !1, f = 1, m = 0, v = {
    prefix: "",
    groupSize: 3,
    secondaryGroupSize: 0,
    groupSeparator: ",",
    decimalSeparator: ".",
    fractionGroupSize: 0,
    fractionGroupSeparator: " ",
    // non-breaking space
    suffix: ""
  }, h = "0123456789abcdefghijklmnopqrstuvwxyz", _ = !0;
  function g(y, w) {
    var S, k, T, R, I, C, A, D, N = this;
    if (!(N instanceof g)) return new g(y, w);
    if (w == null) {
      if (y && y._isBigNumber === !0) {
        N.s = y.s, !y.c || y.e > p ? N.c = N.e = null : y.e < c ? N.c = [N.e = 0] : (N.e = y.e, N.c = y.c.slice());
        return;
      }
      if ((C = typeof y == "number") && y * 0 == 0) {
        if (N.s = 1 / y < 0 ? (y = -y, -1) : 1, y === ~~y) {
          for (R = 0, I = y; I >= 10; I /= 10, R++) ;
          R > p ? N.c = N.e = null : (N.e = R, N.c = [y]);
          return;
        }
        D = String(y);
      } else {
        if (!k1.test(D = String(y))) return n(N, D, C);
        N.s = D.charCodeAt(0) == 45 ? (D = D.slice(1), -1) : 1;
      }
      (R = D.indexOf(".")) > -1 && (D = D.replace(".", "")), (I = D.search(/e/i)) > 0 ? (R < 0 && (R = I), R += +D.slice(I + 1), D = D.substring(0, I)) : R < 0 && (R = D.length);
    } else {
      if (bt(w, 2, h.length, "Base"), w == 10 && _)
        return N = new g(y), O(N, i + N.e + 1, s);
      if (D = String(y), C = typeof y == "number") {
        if (y * 0 != 0) return n(N, D, C, w);
        if (N.s = 1 / y < 0 ? (D = D.slice(1), -1) : 1, g.DEBUG && D.replace(/^0\.0*|\./, "").length > 15)
          throw Error(df + y);
      } else
        N.s = D.charCodeAt(0) === 45 ? (D = D.slice(1), -1) : 1;
      for (S = h.slice(0, w), R = I = 0, A = D.length; I < A; I++)
        if (S.indexOf(k = D.charAt(I)) < 0) {
          if (k == ".") {
            if (I > R) {
              R = A;
              continue;
            }
          } else if (!T && (D == D.toUpperCase() && (D = D.toLowerCase()) || D == D.toLowerCase() && (D = D.toUpperCase()))) {
            T = !0, I = -1, R = 0;
            continue;
          }
          return n(N, String(y), C, w);
        }
      C = !1, D = r(D, w, 10, N.s), (R = D.indexOf(".")) > -1 ? D = D.replace(".", "") : R = D.length;
    }
    for (I = 0; D.charCodeAt(I) === 48; I++) ;
    for (A = D.length; D.charCodeAt(--A) === 48; ) ;
    if (D = D.slice(I, ++A)) {
      if (A -= I, C && g.DEBUG && A > 15 && (y > $l || y !== Dr(y)))
        throw Error(df + N.s * y);
      if ((R = R - I - 1) > p)
        N.c = N.e = null;
      else if (R < c)
        N.c = [N.e = 0];
      else {
        if (N.e = R, N.c = [], I = (R + 1) % De, R < 0 && (I += De), I < A) {
          for (I && N.c.push(+D.slice(0, I)), A -= De; I < A; )
            N.c.push(+D.slice(I, I += De));
          I = De - (D = D.slice(I)).length;
        } else
          I -= A;
        for (; I--; D += "0") ;
        N.c.push(+D);
      }
    } else
      N.c = [N.e = 0];
  }
  g.clone = vm, g.ROUND_UP = 0, g.ROUND_DOWN = 1, g.ROUND_CEIL = 2, g.ROUND_FLOOR = 3, g.ROUND_HALF_UP = 4, g.ROUND_HALF_DOWN = 5, g.ROUND_HALF_EVEN = 6, g.ROUND_HALF_CEIL = 7, g.ROUND_HALF_FLOOR = 8, g.EUCLID = 9, g.config = g.set = function(y) {
    var w, S;
    if (y != null)
      if (typeof y == "object") {
        if (y.hasOwnProperty(w = "DECIMAL_PLACES") && (S = y[w], bt(S, 0, Wt, w), i = S), y.hasOwnProperty(w = "ROUNDING_MODE") && (S = y[w], bt(S, 0, 8, w), s = S), y.hasOwnProperty(w = "EXPONENTIAL_AT") && (S = y[w], S && S.pop ? (bt(S[0], -Wt, 0, w), bt(S[1], 0, Wt, w), l = S[0], u = S[1]) : (bt(S, -Wt, Wt, w), l = -(u = S < 0 ? -S : S))), y.hasOwnProperty(w = "RANGE"))
          if (S = y[w], S && S.pop)
            bt(S[0], -Wt, -1, w), bt(S[1], 1, Wt, w), c = S[0], p = S[1];
          else if (bt(S, -Wt, Wt, w), S)
            c = -(p = S < 0 ? -S : S);
          else
            throw Error(or + w + " cannot be zero: " + S);
        if (y.hasOwnProperty(w = "CRYPTO"))
          if (S = y[w], S === !!S)
            if (S)
              if (typeof crypto < "u" && crypto && (crypto.getRandomValues || crypto.randomBytes))
                d = S;
              else
                throw d = !S, Error(or + "crypto unavailable");
            else
              d = S;
          else
            throw Error(or + w + " not true or false: " + S);
        if (y.hasOwnProperty(w = "MODULO_MODE") && (S = y[w], bt(S, 0, 9, w), f = S), y.hasOwnProperty(w = "POW_PRECISION") && (S = y[w], bt(S, 0, Wt, w), m = S), y.hasOwnProperty(w = "FORMAT"))
          if (S = y[w], typeof S == "object") v = S;
          else throw Error(or + w + " not an object: " + S);
        if (y.hasOwnProperty(w = "ALPHABET"))
          if (S = y[w], typeof S == "string" && !/^.?$|[+\-.\s]|(.).*\1/.test(S))
            _ = S.slice(0, 10) == "0123456789", h = S;
          else
            throw Error(or + w + " invalid: " + S);
      } else
        throw Error(or + "Object expected: " + y);
    return {
      DECIMAL_PLACES: i,
      ROUNDING_MODE: s,
      EXPONENTIAL_AT: [l, u],
      RANGE: [c, p],
      CRYPTO: d,
      MODULO_MODE: f,
      POW_PRECISION: m,
      FORMAT: v,
      ALPHABET: h
    };
  }, g.isBigNumber = function(y) {
    if (!y || y._isBigNumber !== !0) return !1;
    if (!g.DEBUG) return !0;
    var w, S, k = y.c, T = y.e, R = y.s;
    e: if ({}.toString.call(k) == "[object Array]") {
      if ((R === 1 || R === -1) && T >= -Wt && T <= Wt && T === Dr(T)) {
        if (k[0] === 0) {
          if (T === 0 && k.length === 1) return !0;
          break e;
        }
        if (w = (T + 1) % De, w < 1 && (w += De), String(k[0]).length == w) {
          for (w = 0; w < k.length; w++)
            if (S = k[w], S < 0 || S >= Lr || S !== Dr(S)) break e;
          if (S !== 0) return !0;
        }
      }
    } else if (k === null && T === null && (R === null || R === 1 || R === -1))
      return !0;
    throw Error(or + "Invalid BigNumber: " + y);
  }, g.maximum = g.max = function() {
    return x(arguments, -1);
  }, g.minimum = g.min = function() {
    return x(arguments, 1);
  }, g.random = function() {
    var y = 9007199254740992, w = Math.random() * y & 2097151 ? function() {
      return Dr(Math.random() * y);
    } : function() {
      return (Math.random() * 1073741824 | 0) * 8388608 + (Math.random() * 8388608 | 0);
    };
    return function(S) {
      var k, T, R, I, C, A = 0, D = [], N = new g(a);
      if (S == null ? S = i : bt(S, 0, Wt), I = Ll(S / De), d)
        if (crypto.getRandomValues) {
          for (k = crypto.getRandomValues(new Uint32Array(I *= 2)); A < I; )
            C = k[A] * 131072 + (k[A + 1] >>> 11), C >= 9e15 ? (T = crypto.getRandomValues(new Uint32Array(2)), k[A] = T[0], k[A + 1] = T[1]) : (D.push(C % 1e14), A += 2);
          A = I / 2;
        } else if (crypto.randomBytes) {
          for (k = crypto.randomBytes(I *= 7); A < I; )
            C = (k[A] & 31) * 281474976710656 + k[A + 1] * 1099511627776 + k[A + 2] * 4294967296 + k[A + 3] * 16777216 + (k[A + 4] << 16) + (k[A + 5] << 8) + k[A + 6], C >= 9e15 ? crypto.randomBytes(7).copy(k, A) : (D.push(C % 1e14), A += 7);
          A = I / 7;
        } else
          throw d = !1, Error(or + "crypto unavailable");
      if (!d)
        for (; A < I; )
          C = w(), C < 9e15 && (D[A++] = C % 1e14);
      for (I = D[--A], S %= De, I && S && (C = Wl[De - S], D[A] = Dr(I / C) * C); D[A] === 0; D.pop(), A--) ;
      if (A < 0)
        D = [R = 0];
      else {
        for (R = -1; D[0] === 0; D.splice(0, 1), R -= De) ;
        for (A = 1, C = D[0]; C >= 10; C /= 10, A++) ;
        A < De && (R -= De - A);
      }
      return N.e = R, N.c = D, N;
    };
  }(), g.sum = function() {
    for (var y = 1, w = arguments, S = new g(w[0]); y < w.length; ) S = S.plus(w[y++]);
    return S;
  }, r = /* @__PURE__ */ function() {
    var y = "0123456789";
    function w(S, k, T, R) {
      for (var I, C = [0], A, D = 0, N = S.length; D < N; ) {
        for (A = C.length; A--; C[A] *= k) ;
        for (C[0] += R.indexOf(S.charAt(D++)), I = 0; I < C.length; I++)
          C[I] > T - 1 && (C[I + 1] == null && (C[I + 1] = 0), C[I + 1] += C[I] / T | 0, C[I] %= T);
      }
      return C.reverse();
    }
    return function(S, k, T, R, I) {
      var C, A, D, N, M, W, B, j, q = S.indexOf("."), se = i, te = s;
      for (q >= 0 && (N = m, m = 0, S = S.replace(".", ""), j = new g(k), W = j.pow(S.length - q), m = N, j.c = w(
        wn(Or(W.c), W.e, "0"),
        10,
        T,
        y
      ), j.e = j.c.length), B = w(S, k, T, I ? (C = h, y) : (C = y, h)), D = N = B.length; B[--N] == 0; B.pop()) ;
      if (!B[0]) return C.charAt(0);
      if (q < 0 ? --D : (W.c = B, W.e = D, W.s = R, W = t(W, j, se, te, T), B = W.c, M = W.r, D = W.e), A = D + se + 1, q = B[A], N = T / 2, M = M || A < 0 || B[A + 1] != null, M = te < 4 ? (q != null || M) && (te == 0 || te == (W.s < 0 ? 3 : 2)) : q > N || q == N && (te == 4 || M || te == 6 && B[A - 1] & 1 || te == (W.s < 0 ? 8 : 7)), A < 1 || !B[0])
        S = M ? wn(C.charAt(1), -se, C.charAt(0)) : C.charAt(0);
      else {
        if (B.length = A, M)
          for (--T; ++B[--A] > T; )
            B[A] = 0, A || (++D, B = [1].concat(B));
        for (N = B.length; !B[--N]; ) ;
        for (q = 0, S = ""; q <= N; S += C.charAt(B[q++])) ;
        S = wn(S, D, C.charAt(0));
      }
      return S;
    };
  }(), t = /* @__PURE__ */ function() {
    function y(k, T, R) {
      var I, C, A, D, N = 0, M = k.length, W = T % jn, B = T / jn | 0;
      for (k = k.slice(); M--; )
        A = k[M] % jn, D = k[M] / jn | 0, I = B * A + D * W, C = W * A + I % jn * jn + N, N = (C / R | 0) + (I / jn | 0) + B * D, k[M] = C % R;
      return N && (k = [N].concat(k)), k;
    }
    function w(k, T, R, I) {
      var C, A;
      if (R != I)
        A = R > I ? 1 : -1;
      else
        for (C = A = 0; C < R; C++)
          if (k[C] != T[C]) {
            A = k[C] > T[C] ? 1 : -1;
            break;
          }
      return A;
    }
    function S(k, T, R, I) {
      for (var C = 0; R--; )
        k[R] -= C, C = k[R] < T[R] ? 1 : 0, k[R] = C * I + k[R] - T[R];
      for (; !k[0] && k.length > 1; k.splice(0, 1)) ;
    }
    return function(k, T, R, I, C) {
      var A, D, N, M, W, B, j, q, se, te, le, ke, at, _t, Pt, pe, Z, Pe = k.s == T.s ? 1 : -1, J = k.c, Ne = T.c;
      if (!J || !J[0] || !Ne || !Ne[0])
        return new g(
          // Return NaN if either NaN, or both Infinity or 0.
          !k.s || !T.s || (J ? Ne && J[0] == Ne[0] : !Ne) ? NaN : (
            // Return ±0 if x is ±0 or y is ±Infinity, or return ±Infinity as y is ±0.
            J && J[0] == 0 || !Ne ? Pe * 0 : Pe / 0
          )
        );
      for (q = new g(Pe), se = q.c = [], D = k.e - T.e, Pe = R + D + 1, C || (C = Lr, D = Nr(k.e / De) - Nr(T.e / De), Pe = Pe / De | 0), N = 0; Ne[N] == (J[N] || 0); N++) ;
      if (Ne[N] > (J[N] || 0) && D--, Pe < 0)
        se.push(1), M = !0;
      else {
        for (_t = J.length, pe = Ne.length, N = 0, Pe += 2, W = Dr(C / (Ne[0] + 1)), W > 1 && (Ne = y(Ne, W, C), J = y(J, W, C), pe = Ne.length, _t = J.length), at = pe, te = J.slice(0, pe), le = te.length; le < pe; te[le++] = 0) ;
        Z = Ne.slice(), Z = [0].concat(Z), Pt = Ne[0], Ne[1] >= C / 2 && Pt++;
        do {
          if (W = 0, A = w(Ne, te, pe, le), A < 0) {
            if (ke = te[0], pe != le && (ke = ke * C + (te[1] || 0)), W = Dr(ke / Pt), W > 1)
              for (W >= C && (W = C - 1), B = y(Ne, W, C), j = B.length, le = te.length; w(B, te, j, le) == 1; )
                W--, S(B, pe < j ? Z : Ne, j, C), j = B.length, A = 1;
            else
              W == 0 && (A = W = 1), B = Ne.slice(), j = B.length;
            if (j < le && (B = [0].concat(B)), S(te, B, le, C), le = te.length, A == -1)
              for (; w(Ne, te, pe, le) < 1; )
                W++, S(te, pe < le ? Z : Ne, le, C), le = te.length;
          } else A === 0 && (W++, te = [0]);
          se[N++] = W, te[0] ? te[le++] = J[at] || 0 : (te = [J[at]], le = 1);
        } while ((at++ < _t || te[0] != null) && Pe--);
        M = te[0] != null, se[0] || se.splice(0, 1);
      }
      if (C == Lr) {
        for (N = 1, Pe = se[0]; Pe >= 10; Pe /= 10, N++) ;
        O(q, R + (q.e = N + D * De - 1) + 1, I, M);
      } else
        q.e = D, q.r = +M;
      return q;
    };
  }();
  function b(y, w, S, k) {
    var T, R, I, C, A;
    if (S == null ? S = s : bt(S, 0, 8), !y.c) return y.toString();
    if (T = y.c[0], I = y.e, w == null)
      A = Or(y.c), A = k == 1 || k == 2 && (I <= l || I >= u) ? rs(A, I) : wn(A, I, "0");
    else if (y = O(new g(y), w, S), R = y.e, A = Or(y.c), C = A.length, k == 1 || k == 2 && (w <= R || R <= l)) {
      for (; C < w; A += "0", C++) ;
      A = rs(A, R);
    } else if (w -= I, A = wn(A, R, "0"), R + 1 > C) {
      if (--w > 0) for (A += "."; w--; A += "0") ;
    } else if (w += R - C, w > 0)
      for (R + 1 == C && (A += "."); w--; A += "0") ;
    return y.s < 0 && T ? "-" + A : A;
  }
  function x(y, w) {
    for (var S, k, T = 1, R = new g(y[0]); T < y.length; T++)
      k = new g(y[T]), (!k.s || (S = so(R, k)) === w || S === 0 && R.s === w) && (R = k);
    return R;
  }
  function E(y, w, S) {
    for (var k = 1, T = w.length; !w[--T]; w.pop()) ;
    for (T = w[0]; T >= 10; T /= 10, k++) ;
    return (S = k + S * De - 1) > p ? y.c = y.e = null : S < c ? y.c = [y.e = 0] : (y.e = S, y.c = w), y;
  }
  n = /* @__PURE__ */ function() {
    var y = /^(-?)0([xbo])(?=\w[\w.]*$)/i, w = /^([^.]+)\.$/, S = /^\.([^.]+)$/, k = /^-?(Infinity|NaN)$/, T = /^\s*\+(?=[\w.])|^\s+|\s+$/g;
    return function(R, I, C, A) {
      var D, N = C ? I : I.replace(T, "");
      if (k.test(N))
        R.s = isNaN(N) ? null : N < 0 ? -1 : 1;
      else {
        if (!C && (N = N.replace(y, function(M, W, B) {
          return D = (B = B.toLowerCase()) == "x" ? 16 : B == "b" ? 2 : 8, !A || A == D ? W : M;
        }), A && (D = A, N = N.replace(w, "$1").replace(S, "0.$1")), I != N))
          return new g(N, D);
        if (g.DEBUG)
          throw Error(or + "Not a" + (A ? " base " + A : "") + " number: " + I);
        R.s = null;
      }
      R.c = R.e = null;
    };
  }();
  function O(y, w, S, k) {
    var T, R, I, C, A, D, N, M = y.c, W = Wl;
    if (M) {
      e: {
        for (T = 1, C = M[0]; C >= 10; C /= 10, T++) ;
        if (R = w - T, R < 0)
          R += De, I = w, A = M[D = 0], N = Dr(A / W[T - I - 1] % 10);
        else if (D = Ll((R + 1) / De), D >= M.length)
          if (k) {
            for (; M.length <= D; M.push(0)) ;
            A = N = 0, T = 1, R %= De, I = R - De + 1;
          } else
            break e;
        else {
          for (A = C = M[D], T = 1; C >= 10; C /= 10, T++) ;
          R %= De, I = R - De + T, N = I < 0 ? 0 : Dr(A / W[T - I - 1] % 10);
        }
        if (k = k || w < 0 || // Are there any non-zero digits after the rounding digit?
        // The expression  n % pows10[d - j - 1]  returns all digits of n to the right
        // of the digit at j, e.g. if n is 908714 and j is 2, the expression gives 714.
        M[D + 1] != null || (I < 0 ? A : A % W[T - I - 1]), k = S < 4 ? (N || k) && (S == 0 || S == (y.s < 0 ? 3 : 2)) : N > 5 || N == 5 && (S == 4 || k || S == 6 && // Check whether the digit to the left of the rounding digit is odd.
        (R > 0 ? I > 0 ? A / W[T - I] : 0 : M[D - 1]) % 10 & 1 || S == (y.s < 0 ? 8 : 7)), w < 1 || !M[0])
          return M.length = 0, k ? (w -= y.e + 1, M[0] = W[(De - w % De) % De], y.e = -w || 0) : M[0] = y.e = 0, y;
        if (R == 0 ? (M.length = D, C = 1, D--) : (M.length = D + 1, C = W[De - R], M[D] = I > 0 ? Dr(A / W[T - I] % W[I]) * C : 0), k)
          for (; ; )
            if (D == 0) {
              for (R = 1, I = M[0]; I >= 10; I /= 10, R++) ;
              for (I = M[0] += C, C = 1; I >= 10; I /= 10, C++) ;
              R != C && (y.e++, M[0] == Lr && (M[0] = 1));
              break;
            } else {
              if (M[D] += C, M[D] != Lr) break;
              M[D--] = 0, C = 1;
            }
        for (R = M.length; M[--R] === 0; M.pop()) ;
      }
      y.e > p ? y.c = y.e = null : y.e < c && (y.c = [y.e = 0]);
    }
    return y;
  }
  function P(y) {
    var w, S = y.e;
    return S === null ? y.toString() : (w = Or(y.c), w = S <= l || S >= u ? rs(w, S) : wn(w, S, "0"), y.s < 0 ? "-" + w : w);
  }
  return o.absoluteValue = o.abs = function() {
    var y = new g(this);
    return y.s < 0 && (y.s = 1), y;
  }, o.comparedTo = function(y, w) {
    return so(this, new g(y, w));
  }, o.decimalPlaces = o.dp = function(y, w) {
    var S, k, T, R = this;
    if (y != null)
      return bt(y, 0, Wt), w == null ? w = s : bt(w, 0, 8), O(new g(R), y + R.e + 1, w);
    if (!(S = R.c)) return null;
    if (k = ((T = S.length - 1) - Nr(this.e / De)) * De, T = S[T]) for (; T % 10 == 0; T /= 10, k--) ;
    return k < 0 && (k = 0), k;
  }, o.dividedBy = o.div = function(y, w) {
    return t(this, new g(y, w), i, s);
  }, o.dividedToIntegerBy = o.idiv = function(y, w) {
    return t(this, new g(y, w), 0, 1);
  }, o.exponentiatedBy = o.pow = function(y, w) {
    var S, k, T, R, I, C, A, D, N, M = this;
    if (y = new g(y), y.c && !y.isInteger())
      throw Error(or + "Exponent not an integer: " + P(y));
    if (w != null && (w = new g(w)), C = y.e > 14, !M.c || !M.c[0] || M.c[0] == 1 && !M.e && M.c.length == 1 || !y.c || !y.c[0])
      return N = new g(Math.pow(+P(M), C ? y.s * (2 - ts(y)) : +P(y))), w ? N.mod(w) : N;
    if (A = y.s < 0, w) {
      if (w.c ? !w.c[0] : !w.s) return new g(NaN);
      k = !A && M.isInteger() && w.isInteger(), k && (M = M.mod(w));
    } else {
      if (y.e > 9 && (M.e > 0 || M.e < -1 || (M.e == 0 ? M.c[0] > 1 || C && M.c[1] >= 24e7 : M.c[0] < 8e13 || C && M.c[0] <= 9999975e7)))
        return R = M.s < 0 && ts(y) ? -0 : 0, M.e > -1 && (R = 1 / R), new g(A ? 1 / R : R);
      m && (R = Ll(m / De + 2));
    }
    for (C ? (S = new g(0.5), A && (y.s = 1), D = ts(y)) : (T = Math.abs(+P(y)), D = T % 2), N = new g(a); ; ) {
      if (D) {
        if (N = N.times(M), !N.c) break;
        R ? N.c.length > R && (N.c.length = R) : k && (N = N.mod(w));
      }
      if (T) {
        if (T = Dr(T / 2), T === 0) break;
        D = T % 2;
      } else if (y = y.times(S), O(y, y.e + 1, 1), y.e > 14)
        D = ts(y);
      else {
        if (T = +P(y), T === 0) break;
        D = T % 2;
      }
      M = M.times(M), R ? M.c && M.c.length > R && (M.c.length = R) : k && (M = M.mod(w));
    }
    return k ? N : (A && (N = a.div(N)), w ? N.mod(w) : R ? O(N, m, s, I) : N);
  }, o.integerValue = function(y) {
    var w = new g(this);
    return y == null ? y = s : bt(y, 0, 8), O(w, w.e + 1, y);
  }, o.isEqualTo = o.eq = function(y, w) {
    return so(this, new g(y, w)) === 0;
  }, o.isFinite = function() {
    return !!this.c;
  }, o.isGreaterThan = o.gt = function(y, w) {
    return so(this, new g(y, w)) > 0;
  }, o.isGreaterThanOrEqualTo = o.gte = function(y, w) {
    return (w = so(this, new g(y, w))) === 1 || w === 0;
  }, o.isInteger = function() {
    return !!this.c && Nr(this.e / De) > this.c.length - 2;
  }, o.isLessThan = o.lt = function(y, w) {
    return so(this, new g(y, w)) < 0;
  }, o.isLessThanOrEqualTo = o.lte = function(y, w) {
    return (w = so(this, new g(y, w))) === -1 || w === 0;
  }, o.isNaN = function() {
    return !this.s;
  }, o.isNegative = function() {
    return this.s < 0;
  }, o.isPositive = function() {
    return this.s > 0;
  }, o.isZero = function() {
    return !!this.c && this.c[0] == 0;
  }, o.minus = function(y, w) {
    var S, k, T, R, I = this, C = I.s;
    if (y = new g(y, w), w = y.s, !C || !w) return new g(NaN);
    if (C != w)
      return y.s = -w, I.plus(y);
    var A = I.e / De, D = y.e / De, N = I.c, M = y.c;
    if (!A || !D) {
      if (!N || !M) return N ? (y.s = -w, y) : new g(M ? I : NaN);
      if (!N[0] || !M[0])
        return M[0] ? (y.s = -w, y) : new g(N[0] ? I : (
          // IEEE 754 (2008) 6.3: n - n = -0 when rounding to -Infinity
          s == 3 ? -0 : 0
        ));
    }
    if (A = Nr(A), D = Nr(D), N = N.slice(), C = A - D) {
      for ((R = C < 0) ? (C = -C, T = N) : (D = A, T = M), T.reverse(), w = C; w--; T.push(0)) ;
      T.reverse();
    } else
      for (k = (R = (C = N.length) < (w = M.length)) ? C : w, C = w = 0; w < k; w++)
        if (N[w] != M[w]) {
          R = N[w] < M[w];
          break;
        }
    if (R && (T = N, N = M, M = T, y.s = -y.s), w = (k = M.length) - (S = N.length), w > 0) for (; w--; N[S++] = 0) ;
    for (w = Lr - 1; k > C; ) {
      if (N[--k] < M[k]) {
        for (S = k; S && !N[--S]; N[S] = w) ;
        --N[S], N[k] += Lr;
      }
      N[k] -= M[k];
    }
    for (; N[0] == 0; N.splice(0, 1), --D) ;
    return N[0] ? E(y, N, D) : (y.s = s == 3 ? -1 : 1, y.c = [y.e = 0], y);
  }, o.modulo = o.mod = function(y, w) {
    var S, k, T = this;
    return y = new g(y, w), !T.c || !y.s || y.c && !y.c[0] ? new g(NaN) : !y.c || T.c && !T.c[0] ? new g(T) : (f == 9 ? (k = y.s, y.s = 1, S = t(T, y, 0, 3), y.s = k, S.s *= k) : S = t(T, y, 0, f), y = T.minus(S.times(y)), !y.c[0] && f == 1 && (y.s = T.s), y);
  }, o.multipliedBy = o.times = function(y, w) {
    var S, k, T, R, I, C, A, D, N, M, W, B, j, q, se, te = this, le = te.c, ke = (y = new g(y, w)).c;
    if (!le || !ke || !le[0] || !ke[0])
      return !te.s || !y.s || le && !le[0] && !ke || ke && !ke[0] && !le ? y.c = y.e = y.s = null : (y.s *= te.s, !le || !ke ? y.c = y.e = null : (y.c = [0], y.e = 0)), y;
    for (k = Nr(te.e / De) + Nr(y.e / De), y.s *= te.s, A = le.length, M = ke.length, A < M && (j = le, le = ke, ke = j, T = A, A = M, M = T), T = A + M, j = []; T--; j.push(0)) ;
    for (q = Lr, se = jn, T = M; --T >= 0; ) {
      for (S = 0, W = ke[T] % se, B = ke[T] / se | 0, I = A, R = T + I; R > T; )
        D = le[--I] % se, N = le[I] / se | 0, C = B * D + N * W, D = W * D + C % se * se + j[R] + S, S = (D / q | 0) + (C / se | 0) + B * N, j[R--] = D % q;
      j[R] = S;
    }
    return S ? ++k : j.splice(0, 1), E(y, j, k);
  }, o.negated = function() {
    var y = new g(this);
    return y.s = -y.s || null, y;
  }, o.plus = function(y, w) {
    var S, k = this, T = k.s;
    if (y = new g(y, w), w = y.s, !T || !w) return new g(NaN);
    if (T != w)
      return y.s = -w, k.minus(y);
    var R = k.e / De, I = y.e / De, C = k.c, A = y.c;
    if (!R || !I) {
      if (!C || !A) return new g(T / 0);
      if (!C[0] || !A[0]) return A[0] ? y : new g(C[0] ? k : T * 0);
    }
    if (R = Nr(R), I = Nr(I), C = C.slice(), T = R - I) {
      for (T > 0 ? (I = R, S = A) : (T = -T, S = C), S.reverse(); T--; S.push(0)) ;
      S.reverse();
    }
    for (T = C.length, w = A.length, T - w < 0 && (S = A, A = C, C = S, w = T), T = 0; w; )
      T = (C[--w] = C[w] + A[w] + T) / Lr | 0, C[w] = Lr === C[w] ? 0 : C[w] % Lr;
    return T && (C = [T].concat(C), ++I), E(y, C, I);
  }, o.precision = o.sd = function(y, w) {
    var S, k, T, R = this;
    if (y != null && y !== !!y)
      return bt(y, 1, Wt), w == null ? w = s : bt(w, 0, 8), O(new g(R), y, w);
    if (!(S = R.c)) return null;
    if (T = S.length - 1, k = T * De + 1, T = S[T]) {
      for (; T % 10 == 0; T /= 10, k--) ;
      for (T = S[0]; T >= 10; T /= 10, k++) ;
    }
    return y && R.e + 1 > k && (k = R.e + 1), k;
  }, o.shiftedBy = function(y) {
    return bt(y, -$l, $l), this.times("1e" + y);
  }, o.squareRoot = o.sqrt = function() {
    var y, w, S, k, T, R = this, I = R.c, C = R.s, A = R.e, D = i + 4, N = new g("0.5");
    if (C !== 1 || !I || !I[0])
      return new g(!C || C < 0 && (!I || I[0]) ? NaN : I ? R : 1 / 0);
    if (C = Math.sqrt(+P(R)), C == 0 || C == 1 / 0 ? (w = Or(I), (w.length + A) % 2 == 0 && (w += "0"), C = Math.sqrt(+w), A = Nr((A + 1) / 2) - (A < 0 || A % 2), C == 1 / 0 ? w = "5e" + A : (w = C.toExponential(), w = w.slice(0, w.indexOf("e") + 1) + A), S = new g(w)) : S = new g(C + ""), S.c[0]) {
      for (A = S.e, C = A + D, C < 3 && (C = 0); ; )
        if (T = S, S = N.times(T.plus(t(R, T, D, 1))), Or(T.c).slice(0, C) === (w = Or(S.c)).slice(0, C))
          if (S.e < A && --C, w = w.slice(C - 3, C + 1), w == "9999" || !k && w == "4999") {
            if (!k && (O(T, T.e + i + 2, 0), T.times(T).eq(R))) {
              S = T;
              break;
            }
            D += 4, C += 4, k = 1;
          } else {
            (!+w || !+w.slice(1) && w.charAt(0) == "5") && (O(S, S.e + i + 2, 1), y = !S.times(S).eq(R));
            break;
          }
    }
    return O(S, S.e + i + 1, s, y);
  }, o.toExponential = function(y, w) {
    return y != null && (bt(y, 0, Wt), y++), b(this, y, w, 1);
  }, o.toFixed = function(y, w) {
    return y != null && (bt(y, 0, Wt), y = y + this.e + 1), b(this, y, w);
  }, o.toFormat = function(y, w, S) {
    var k, T = this;
    if (S == null)
      y != null && w && typeof w == "object" ? (S = w, w = null) : y && typeof y == "object" ? (S = y, y = w = null) : S = v;
    else if (typeof S != "object")
      throw Error(or + "Argument not an object: " + S);
    if (k = T.toFixed(y, w), T.c) {
      var R, I = k.split("."), C = +S.groupSize, A = +S.secondaryGroupSize, D = S.groupSeparator || "", N = I[0], M = I[1], W = T.s < 0, B = W ? N.slice(1) : N, j = B.length;
      if (A && (R = C, C = A, A = R, j -= R), C > 0 && j > 0) {
        for (R = j % C || C, N = B.substr(0, R); R < j; R += C) N += D + B.substr(R, C);
        A > 0 && (N += D + B.slice(R)), W && (N = "-" + N);
      }
      k = M ? N + (S.decimalSeparator || "") + ((A = +S.fractionGroupSize) ? M.replace(
        new RegExp("\\d{" + A + "}\\B", "g"),
        "$&" + (S.fractionGroupSeparator || "")
      ) : M) : N;
    }
    return (S.prefix || "") + k + (S.suffix || "");
  }, o.toFraction = function(y) {
    var w, S, k, T, R, I, C, A, D, N, M, W, B = this, j = B.c;
    if (y != null && (C = new g(y), !C.isInteger() && (C.c || C.s !== 1) || C.lt(a)))
      throw Error(or + "Argument " + (C.isInteger() ? "out of range: " : "not an integer: ") + P(C));
    if (!j) return new g(B);
    for (w = new g(a), D = S = new g(a), k = A = new g(a), W = Or(j), R = w.e = W.length - B.e - 1, w.c[0] = Wl[(I = R % De) < 0 ? De + I : I], y = !y || C.comparedTo(w) > 0 ? R > 0 ? w : D : C, I = p, p = 1 / 0, C = new g(W), A.c[0] = 0; N = t(C, w, 0, 1), T = S.plus(N.times(k)), T.comparedTo(y) != 1; )
      S = k, k = T, D = A.plus(N.times(T = D)), A = T, w = C.minus(N.times(T = w)), C = T;
    return T = t(y.minus(S), k, 0, 1), A = A.plus(T.times(D)), S = S.plus(T.times(k)), A.s = D.s = B.s, R = R * 2, M = t(D, k, R, s).minus(B).abs().comparedTo(
      t(A, S, R, s).minus(B).abs()
    ) < 1 ? [D, k] : [A, S], p = I, M;
  }, o.toNumber = function() {
    return +P(this);
  }, o.toPrecision = function(y, w) {
    return y != null && bt(y, 1, Wt), b(this, y, w, 2);
  }, o.toString = function(y) {
    var w, S = this, k = S.s, T = S.e;
    return T === null ? k ? (w = "Infinity", k < 0 && (w = "-" + w)) : w = "NaN" : (y == null ? w = T <= l || T >= u ? rs(Or(S.c), T) : wn(Or(S.c), T, "0") : y === 10 && _ ? (S = O(new g(S), i + T + 1, s), w = wn(Or(S.c), S.e, "0")) : (bt(y, 2, h.length, "Base"), w = r(wn(Or(S.c), T, "0"), 10, y, k, !0)), k < 0 && S.c[0] && (w = "-" + w)), w;
  }, o.valueOf = o.toJSON = function() {
    return P(this);
  }, o._isBigNumber = !0, o[Symbol.toStringTag] = "BigNumber", o[Symbol.for("nodejs.util.inspect.custom")] = o.valueOf, e != null && g.set(e), g;
}
function Nr(e) {
  var t = e | 0;
  return e > 0 || e === t ? t : t - 1;
}
function Or(e) {
  for (var t, r, n = 1, o = e.length, a = e[0] + ""; n < o; ) {
    for (t = e[n++] + "", r = De - t.length; r--; t = "0" + t) ;
    a += t;
  }
  for (o = a.length; a.charCodeAt(--o) === 48; ) ;
  return a.slice(0, o + 1 || 1);
}
function so(e, t) {
  var r, n, o = e.c, a = t.c, i = e.s, s = t.s, l = e.e, u = t.e;
  if (!i || !s) return null;
  if (r = o && !o[0], n = a && !a[0], r || n) return r ? n ? 0 : -s : i;
  if (i != s) return i;
  if (r = i < 0, n = l == u, !o || !a) return n ? 0 : !o ^ r ? 1 : -1;
  if (!n) return l > u ^ r ? 1 : -1;
  for (s = (l = o.length) < (u = a.length) ? l : u, i = 0; i < s; i++) if (o[i] != a[i]) return o[i] > a[i] ^ r ? 1 : -1;
  return l == u ? 0 : l > u ^ r ? 1 : -1;
}
function bt(e, t, r, n) {
  if (e < t || e > r || e !== Dr(e))
    throw Error(or + (n || "Argument") + (typeof e == "number" ? e < t || e > r ? " out of range: " : " not an integer: " : " not a primitive number: ") + String(e));
}
function ts(e) {
  var t = e.c.length - 1;
  return Nr(e.e / De) == t && e.c[t] % 2 != 0;
}
function rs(e, t) {
  return (e.length > 1 ? e.charAt(0) + "." + e.slice(1) : e) + (t < 0 ? "e" : "e+") + t;
}
function wn(e, t, r) {
  var n, o;
  if (t < 0) {
    for (o = r + "."; ++t; o += r) ;
    e = o + e;
  } else if (n = e.length, ++t > n) {
    for (o = r, t -= n; --t; o += r) ;
    e += o;
  } else t < n && (e = e.slice(0, t) + "." + e.slice(t));
  return e;
}
var qa = vm();
const O1 = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 translate-y-48",
  enterTo: "opacity-100 translate-y-0"
}, D1 = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 -translate-y-48",
  enterTo: "opacity-100 translate-y-0"
}, N1 = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-y-0",
  leaveTo: "opacity-0 translate-y-48"
}, C1 = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-y-0",
  leaveTo: "opacity-0 -translate-y-48"
}, P1 = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 translate-x-48",
  enterTo: "opacity-100 translate-x-0"
}, M1 = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-x-0",
  leaveTo: "opacity-0 translate-x-48"
}, R1 = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0 -translate-x-48",
  enterTo: "opacity-100 translate-x-0"
}, A1 = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100 translate-x-0",
  leaveTo: "opacity-0 -translate-x-48"
}, T5 = {
  enter: "transition-all duration-300",
  enterFrom: "opacity-0",
  enterTo: "opacity-100"
}, k5 = {
  leave: "transition-all duration-300",
  leaveFrom: "opacity-100",
  leaveTo: "opacity-0"
}, I1 = 300, O5 = {
  AccessKeyConflict: "access key conflict",
  AccountNotFound: "account not found",
  EntityNotFound: "entity not found",
  AccountEntityNotFound: "account entity not found",
  AlreadyRest: "already reset",
  EmptyEntityList: "empty entity list",
  EmptyRoleList: "empty role list",
  EmpowerNonAccountPrivilege: "empowering non-account privilege in account assignment",
  InvalidAccessKey: "invalid accessKey",
  InvalidAddress: "invalid address",
  InvalidAuthDomain: "invalid auth domain",
  InvalidEntity: "invalid entity",
  InvalidMessage: "invalid message",
  InvalidPrivilege: "invalid privilege",
  InvalidPublicKey: "invalid publicKey",
  InvalidRefreshToken: "invalid refreshToken",
  InvalidSecret: "invalid secret",
  InvalidSignature: "invalid signature",
  InvalidToken: "invalid token",
  InvalidPayAmount: "invalid pay amount",
  InvalidFileUpload: "invalid file upload",
  InvalidAgent: "invalid agent",
  NotFoundCredential: "credential not found",
  RequestExpired: "request expired",
  TokenNotFound: "token not found",
  IpAddressNotFound: "ip address not found",
  ValidationError: "validation error",
  InvalidDateRange: "invalid date range",
  PhoneSpecNotFound: "phone spec not found",
  MissingAccessKey: "missing access key",
  PrivilegeNotFound: "privilege not found",
  InvalidPeriod: "invalid period",
  Auth: {
    AccountSuspended: "unauthorized:account suspended",
    AccountFrozen: "unauthorized:account frozen",
    AccountClosed: "unauthorized:account closed",
    Required: "unauthorized:authorisation required",
    IdentityNotFound: "unauthorized:identity not found",
    InvalidSignature: "unauthorized:invalid signature",
    InvalidCredential: "unauthorized:invalid access credentials",
    InvalidPublicKey: "unauthorized:invalid public key",
    InvalidAccount: "unauthorized:invalid account",
    InActiveAccount: "unauthorized:no active account",
    InvalidToken: "unauthorized:invalid token",
    TokenExpired: "unauthorized:token expired",
    TokenInvalidated: "unauthorized:token invalidated",
    RequiredPrivilege: "unauthorized:privilege required",
    UnSupportedGrantType: "unsupported grant type:",
    FailedGranted: "grant failed",
    IpAddressRestricted: "ip restricted"
  },
  Bulk: {
    ErrorSort: "bulk sort error",
    ErrorCreating: "bulk create error",
    ErrorUpdating: "bulk update error",
    InvalidAction: "invalid action"
  },
  PublicKey: {
    NotMatchSignature: "public key does not match signature",
    NotRegistered: "public key not registered"
  },
  GameProvider: {
    NotFound: "game provider not found",
    SourceRefNotFound: "source ref not found",
    InvalidMemberId: "invalid member id",
    InvalidSortPriority: "invalid sort priority"
  },
  Wallet: {
    NotFound: "wallet not found",
    InsufficientFunds: "insufficient funds"
  },
  WalletTx: {
    NotFound: "tx not found",
    InvalidAmount: "invalid tx amount",
    TransactionDuplicate: "duplicate transaction",
    AlreadyCanceled: "already canceled",
    AlreadySettled: "already settled",
    InvalidTransactAmount: "invalid transact amount",
    InsufficientBalance: "insufficient balance"
  },
  ClaimReward: {
    InvalidClaimPeriod: "invalid claim period",
    UnableRedeem: "unable to redeem",
    AlreadyClaimed: "already claimed",
    NotConfigured: "not configured"
  },
  Notification: {
    NotFound: "notification not found",
    AlreadySent: "already sent",
    Sending: "is being sent",
    NearScheduleUpdateUnable: "unable to update near schedule notification",
    UnableToDestroy: "unable to destroy notification",
    InvalidScheduledTime: "invalid scheduled time",
    InvalidStatusSchedule: "invalid status for schedule time",
    InvalidScheduledTimeRecipient: "invalid scheduled time to add recipient",
    ScheduledNotifFailInstantBroadcast: "scheduled notification fail instant broadcast",
    SendAllActive: "send all active, adding recipients blocked",
    RecipientExists: "recipients exists, send all active blocked",
    UnableToUpdateScheduled: "unable to update scheduled notification"
  },
  NotifSubscription: {
    NotFound: "subscriber not found"
  },
  AccountInvite: {
    InviteCancelled: "invite cancelled",
    AlreadyInvite: "invite already used",
    InvalidInviteToken: "invalid invite token",
    ErrorPersonCreation: "error creating person"
  },
  Member: {
    EntityNotCreated: "member entity not created",
    CannotLoadEntity: "cannot load entity",
    NotFound: "member not found",
    InvalidPhone: "invalid phone",
    PhoneConflict: "phone is in use",
    EmailConflict: "email is in use",
    EmailNotFound: "email not found",
    ExistBankAccount: "bank account exists",
    AlreadyVerifiedPhone: "phone already verified",
    NotFoundReferralCode: "referral code not found",
    MaxReferralReached: "max referral reached",
    ChainReferralLoop: "chain referral loop",
    AlreadyReferral: "already referred",
    SelfReferralError: "self-referral error"
  },
  Person: {
    InvalidPrivilegeKey: "invalid privilege key",
    EmailConflict: "email conflict",
    NotFound: "person not found",
    NotExistEntity: "entity does not exist with the person id: ",
    SelfDisabledNotAllowed: "not allowed self disabled"
  },
  User: {
    EntityNotCreated: "person entity not created",
    CannotLoadEntity: "cannot load entity",
    NotFound: "person not found",
    AccountRequired: "account required"
  },
  Misc: {
    ResolveAppRootFolder: "cannot resolve application root folder"
  },
  Media: {
    AssetNotFound: "asset not found",
    FailedAuthorS3: "aws s3 bucket access failed",
    InvalidConfig: "invalid media repo config",
    InvalidRepoName: "invalid repository name",
    InvalidFileNumber: "invalid number of files received",
    NotExists: "media repo dir does not exist"
  },
  SMSProvider: {
    NotFound: "sms provider not found",
    InvalidSender: "invalid sender",
    SendFail: "send sms fail"
  },
  SMSCloud: {
    F0001: "The appkey does not exist",
    F0002: "The appcode does not exist",
    F0003: "The phone number does not exist",
    F0004: "The sign is not completed",
    F0005: "The timestamp is not completed",
    F0006: "appkey does not exist",
    F0007: "The account has been closed",
    F0008: "Sign test failed",
    F0009: "No business under the account number",
    F0010: "The business does not exist",
    F0011: "More than 1,000 mobile numbers",
    F0012: "Timestamp is not a number",
    F0013: "Timestamp is expired due to more than 5 minutes",
    F0014: "The request ip is not on the whitelist",
    F0015: "Not sufficient funds",
    F0016: "The mobile phone number is invalid",
    F0017: "There is no business available",
    F0022: "The parameter msg is not filled in",
    F0023: "The msg is over 1,000 words",
    F0024: "Extend is not pure digital",
    F0025: "Content signature is not reported/not signed",
    F0039: "Parameter sms is not completed",
    F0040: "The parameter sms is in an incorrect format",
    F0041: "More than 1,000 text messages",
    F0050: "No data",
    F0100: "Unknown error"
  },
  VerifyRequest: {
    NotFound: "code not found",
    CodeExpired: "code expired",
    CodeConsumed: "code already consumed",
    NotVerifyYet: "not verify yet",
    CodeIncorrect: "code incorrect",
    RateLimited: "request rate limited."
  },
  Phone: {
    NotAllowed: "phone not allowed"
  },
  Role: {
    NotFoundPrivilege: "privilege not found in role",
    NameInUse: "role name in use"
  },
  Category: {
    Required: "category required",
    NotFound: "not found",
    Invalid: "invalid category",
    ExistGame: "exist game",
    SlugAlreadyExist: "slug already exist"
  },
  SortingItem: {
    NotFound: "item not found",
    Invalid: "invalid sorting item",
    SortingError: "sorting item error",
    OutOfBound: "sorting item out of bound",
    InvalidSortNumber: "invalid sorting number"
  },
  Game: {
    NotFound: "game not found",
    InvalidRank: "invalid rank",
    Maintenance: "game maintenance",
    InActive: "game in active",
    ProviderRefNotFound: "provider ref not found"
  },
  Model: {
    NotFound: "model not found"
  },
  Tag: {
    NotFound: "tag not found",
    Invalid: "invalid tag item"
  },
  FundingTx: {
    AlreadyError: "funding tx already error",
    AlreadyCompleted: "funding tx already completed",
    InProcessing: "funding tx in processing",
    NotAllowStatus: "funding tx status not allowed",
    NotPending: "funding tx not in pending",
    NotWithdraw: "funding tx not withdraw",
    NotDeposit: "funding tx not deposit",
    Rejected: "funding tx rejected",
    NotFound: "funding tx not found",
    InvalidStatusForApproval: "invalid status for approval",
    InvalidTypeForApproval: "invalid type for approval"
  },
  BankAccount: {
    NotFound: "bank account not found",
    AccountNoNotFound: "bank account number not found",
    AccountNumberExists: "account number exists"
  },
  BankInfo: {
    BankKeyNotFound: "bank key not found"
  },
  Taggable: {
    InvalidData: "invalid taggable data"
  },
  Payment: {
    InvalidMethod: "invalid payment method",
    NotEnabledMethod: "payment method not enabled"
  },
  Transfer: {
    SrcWalletNotFound: "source wallet not found",
    DstWalletNotFound: "destination wallet not found",
    DifferentMember: "different member",
    DifferentAccount: "different account",
    Restricted: "restricted"
  },
  Image: {
    DimensionInvalid: "image dimension is invalid",
    DimensionSettingInvalid: "image dimension setting is invalid"
  },
  IpWhitelist: {
    NotFound: "ip whitelist not found",
    AlreadyExists: "ip whitelist already exists"
  },
  JobBatch: {
    InvalidStatus: "invalid job batch status",
    NoJobRegenerated: "no accruals regenerated"
  },
  Group: {
    OnlyManualAssign: "only manual assign allowed",
    MemberAccountMismatch: "member and group account mismatch",
    ErrorUpdating: "Error updating groups",
    NoMembers: "no members"
  },
  ReferralSetting: {
    NotConfigure: "referral setting not configure",
    CommissionRateInvalid: "commission rate invalid"
  },
  ReferralCommission: {
    AmountNotAvailable: "amount not available",
    MinimumClaimAmount: "minimum claim amount:"
  },
  Referee: {
    NotEnoughDeposit: "not enough deposit",
    NoTurnoverAvailable: "no turnover available"
  }
}, D5 = /^0\d{9}$/, N5 = /^0\d{10}$/, ym = "push-notification-register-status", vu = "push-notification-member-register", lo = {
  OPEN_LINK_NEW_TAB: "open-link-new-tab",
  // open a link in new tab
  OPEN_LINK_CURRENT_PAGE: "open-link-current-page",
  // open a link in current page
  OPEN_LINK_NEW_WINDOW: "open-link-new-window",
  // open a link in new window
  LOAD_PAGE: "load-page"
  // open current page
}, F1 = new qa(0), C5 = new qa(1), L1 = (e = I1) => new Promise((t) => setTimeout(t, e)), $1 = async (e) => {
  try {
    return await navigator.clipboard.writeText(e), Promise.resolve();
  } catch {
    return Promise.reject("Failed to copy to clipboard!");
  }
}, ff = (e, t) => t == null ? "" : e ? e(t) : t;
function W1(e, t = 0) {
  return mi(e).toFormat(t);
}
function Y1(e) {
  return mi(e).toFormat(2, qa.ROUND_DOWN);
}
const P5 = (e) => {
  switch (typeof e) {
    case "number":
      return e;
    default:
      return B1(e) ? Number(e) : 0;
  }
}, B1 = (e) => !isNaN(e) && isFinite(e), j1 = (e, t) => {
  if (!e && e !== 0) return t;
  typeof e == "string" && (e = e.trim().replace(/,/g, ""));
  const r = qa.isBigNumber(e) ? e : new qa(e);
  return !r.isFinite() || r.isNaN() ? t : r;
}, mi = (e, t = F1) => j1(e, t), M5 = (e, t) => {
  let r = e.replace(/\D/g, "");
  return r[0] === "0" && t && (r = String(t) + r.slice(1)), r[0] !== "+" && (r = "+" + r), r;
}, R5 = (e, t) => {
  let r = e;
  return r[0] === "+" && (r = r.replace("+" + t, "0")), r;
}, A5 = async ({
  memberId: e,
  accountId: t,
  notificationURI: r,
  notificationTestParam: n,
  publicUrl: o
}) => {
  try {
    if (!("serviceWorker" in navigator)) return;
    const a = await navigator.serviceWorker.getRegistration(`${o}/service-worker.js`);
    if (!a) return;
    const i = await navigator.serviceWorker.ready;
    if (!i || !await i.pushManager.getSubscription() || !r) return;
    const u = new URLSearchParams(window.location.search).get(n ?? ""), c = await fetch(r + "/notification/info", { method: "GET" }), {
      result: { subscribeEndpoint: p, vapidKey: d }
    } = await c.json();
    if (p) {
      let f = await a.pushManager.getSubscription();
      if (!f && d) {
        let m = !1;
        try {
          f = await a.pushManager.subscribe({
            userVisibleOnly: !0,
            applicationServerKey: d
          });
        } catch (v) {
          "message" in v && v.message.startsWith("Registration failed - A subscription with a different applicationServerKey") && (m = !0);
        }
        m && f && await f.unsubscribe();
      }
      if (f) {
        const m = window.location.hostname ?? "";
        try {
          await fetch(r + p, {
            method: "POST",
            body: JSON.stringify({
              subscription: f,
              accountId: t,
              client: u ?? m,
              memberId: e
            }),
            headers: {
              "Content-Type": "application/json"
            }
          }), sessionStorage.setItem(vu, e);
        } catch (v) {
          console.error(v);
        }
      }
    }
  } catch (a) {
    console.error("updatePushSubscription error ", a);
  }
}, bm = "%[a-f0-9]{2}", pf = new RegExp("(" + bm + ")|([^%]+?)", "gi"), mf = new RegExp("(" + bm + ")+", "gi");
function Tc(e, t) {
  try {
    return [decodeURIComponent(e.join(""))];
  } catch {
  }
  if (e.length === 1)
    return e;
  t = t || 1;
  const r = e.slice(0, t), n = e.slice(t);
  return Array.prototype.concat.call([], Tc(r), Tc(n));
}
function U1(e) {
  try {
    return decodeURIComponent(e);
  } catch {
    let t = e.match(pf) || [];
    for (let r = 1; r < t.length; r++)
      e = Tc(t, r).join(""), t = e.match(pf) || [];
    return e;
  }
}
function H1(e) {
  const t = {
    "%FE%FF": "��",
    "%FF%FE": "��"
  };
  let r = mf.exec(e);
  for (; r; ) {
    try {
      t[r[0]] = decodeURIComponent(r[0]);
    } catch {
      const o = U1(r[0]);
      o !== r[0] && (t[r[0]] = o);
    }
    r = mf.exec(e);
  }
  t["%C2"] = "�";
  const n = Object.keys(t);
  for (const o of n)
    e = e.replace(new RegExp(o, "g"), t[o]);
  return e;
}
function V1(e) {
  if (typeof e != "string")
    throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");
  try {
    return decodeURIComponent(e);
  } catch {
    return H1(e);
  }
}
function wm(e, t) {
  if (!(typeof e == "string" && typeof t == "string"))
    throw new TypeError("Expected the arguments to be of type `string`");
  if (e === "" || t === "")
    return [];
  const r = e.indexOf(t);
  return r === -1 ? [] : [
    e.slice(0, r),
    e.slice(r + t.length)
  ];
}
function z1(e, t) {
  const r = {};
  if (Array.isArray(t))
    for (const n of t) {
      const o = Object.getOwnPropertyDescriptor(e, n);
      o != null && o.enumerable && Object.defineProperty(r, n, o);
    }
  else
    for (const n of Reflect.ownKeys(e)) {
      const o = Object.getOwnPropertyDescriptor(e, n);
      if (o.enumerable) {
        const a = e[n];
        t(n, a, e) && Object.defineProperty(r, n, o);
      }
    }
  return r;
}
const q1 = (e) => e == null, G1 = (e) => encodeURIComponent(e).replaceAll(/[!'()*]/g, (t) => `%${t.charCodeAt(0).toString(16).toUpperCase()}`), kc = Symbol("encodeFragmentIdentifier");
function Q1(e) {
  switch (e.arrayFormat) {
    case "index":
      return (t) => (r, n) => {
        const o = r.length;
        return n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
          ...r,
          [Dt(t, e), "[", o, "]"].join("")
        ] : [
          ...r,
          [Dt(t, e), "[", Dt(o, e), "]=", Dt(n, e)].join("")
        ];
      };
    case "bracket":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Dt(t, e), "[]"].join("")
      ] : [
        ...r,
        [Dt(t, e), "[]=", Dt(n, e)].join("")
      ];
    case "colon-list-separator":
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        [Dt(t, e), ":list="].join("")
      ] : [
        ...r,
        [Dt(t, e), ":list=", Dt(n, e)].join("")
      ];
    case "comma":
    case "separator":
    case "bracket-separator": {
      const t = e.arrayFormat === "bracket-separator" ? "[]=" : "=";
      return (r) => (n, o) => o === void 0 || e.skipNull && o === null || e.skipEmptyString && o === "" ? n : (o = o === null ? "" : o, n.length === 0 ? [[Dt(r, e), t, Dt(o, e)].join("")] : [[n, Dt(o, e)].join(e.arrayFormatSeparator)]);
    }
    default:
      return (t) => (r, n) => n === void 0 || e.skipNull && n === null || e.skipEmptyString && n === "" ? r : n === null ? [
        ...r,
        Dt(t, e)
      ] : [
        ...r,
        [Dt(t, e), "=", Dt(n, e)].join("")
      ];
  }
}
function K1(e) {
  let t;
  switch (e.arrayFormat) {
    case "index":
      return (r, n, o) => {
        if (t = /\[(\d*)]$/.exec(r), r = r.replace(/\[\d*]$/, ""), !t) {
          o[r] = n;
          return;
        }
        o[r] === void 0 && (o[r] = {}), o[r][t[1]] = n;
      };
    case "bracket":
      return (r, n, o) => {
        if (t = /(\[])$/.exec(r), r = r.replace(/\[]$/, ""), !t) {
          o[r] = n;
          return;
        }
        if (o[r] === void 0) {
          o[r] = [n];
          return;
        }
        o[r] = [...o[r], n];
      };
    case "colon-list-separator":
      return (r, n, o) => {
        if (t = /(:list)$/.exec(r), r = r.replace(/:list$/, ""), !t) {
          o[r] = n;
          return;
        }
        if (o[r] === void 0) {
          o[r] = [n];
          return;
        }
        o[r] = [...o[r], n];
      };
    case "comma":
    case "separator":
      return (r, n, o) => {
        const a = typeof n == "string" && n.includes(e.arrayFormatSeparator), i = typeof n == "string" && !a && Tn(n, e).includes(e.arrayFormatSeparator);
        n = i ? Tn(n, e) : n;
        const s = a || i ? n.split(e.arrayFormatSeparator).map((l) => Tn(l, e)) : n === null ? n : Tn(n, e);
        o[r] = s;
      };
    case "bracket-separator":
      return (r, n, o) => {
        const a = /(\[])$/.test(r);
        if (r = r.replace(/\[]$/, ""), !a) {
          o[r] = n && Tn(n, e);
          return;
        }
        const i = n === null ? [] : n.split(e.arrayFormatSeparator).map((s) => Tn(s, e));
        if (o[r] === void 0) {
          o[r] = i;
          return;
        }
        o[r] = [...o[r], ...i];
      };
    default:
      return (r, n, o) => {
        if (o[r] === void 0) {
          o[r] = n;
          return;
        }
        o[r] = [...[o[r]].flat(), n];
      };
  }
}
function xm(e) {
  if (typeof e != "string" || e.length !== 1)
    throw new TypeError("arrayFormatSeparator must be single character string");
}
function Dt(e, t) {
  return t.encode ? t.strict ? G1(e) : encodeURIComponent(e) : e;
}
function Tn(e, t) {
  return t.decode ? V1(e) : e;
}
function _m(e) {
  return Array.isArray(e) ? e.sort() : typeof e == "object" ? _m(Object.keys(e)).sort((t, r) => Number(t) - Number(r)).map((t) => e[t]) : e;
}
function Sm(e) {
  const t = e.indexOf("#");
  return t !== -1 && (e = e.slice(0, t)), e;
}
function X1(e) {
  let t = "";
  const r = e.indexOf("#");
  return r !== -1 && (t = e.slice(r)), t;
}
function hf(e, t) {
  return t.parseNumbers && !Number.isNaN(Number(e)) && typeof e == "string" && e.trim() !== "" ? e = Number(e) : t.parseBooleans && e !== null && (e.toLowerCase() === "true" || e.toLowerCase() === "false") && (e = e.toLowerCase() === "true"), e;
}
function yu(e) {
  e = Sm(e);
  const t = e.indexOf("?");
  return t === -1 ? "" : e.slice(t + 1);
}
function bu(e, t) {
  t = {
    decode: !0,
    sort: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    parseNumbers: !1,
    parseBooleans: !1,
    ...t
  }, xm(t.arrayFormatSeparator);
  const r = K1(t), n = /* @__PURE__ */ Object.create(null);
  if (typeof e != "string" || (e = e.trim().replace(/^[?#&]/, ""), !e))
    return n;
  for (const o of e.split("&")) {
    if (o === "")
      continue;
    const a = t.decode ? o.replaceAll("+", " ") : o;
    let [i, s] = wm(a, "=");
    i === void 0 && (i = a), s = s === void 0 ? null : ["comma", "separator", "bracket-separator"].includes(t.arrayFormat) ? s : Tn(s, t), r(Tn(i, t), s, n);
  }
  for (const [o, a] of Object.entries(n))
    if (typeof a == "object" && a !== null)
      for (const [i, s] of Object.entries(a))
        a[i] = hf(s, t);
    else
      n[o] = hf(a, t);
  return t.sort === !1 ? n : (t.sort === !0 ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce((o, a) => {
    const i = n[a];
    return o[a] = i && typeof i == "object" && !Array.isArray(i) ? _m(i) : i, o;
  }, /* @__PURE__ */ Object.create(null));
}
function Em(e, t) {
  if (!e)
    return "";
  t = {
    encode: !0,
    strict: !0,
    arrayFormat: "none",
    arrayFormatSeparator: ",",
    ...t
  }, xm(t.arrayFormatSeparator);
  const r = (i) => t.skipNull && q1(e[i]) || t.skipEmptyString && e[i] === "", n = Q1(t), o = {};
  for (const [i, s] of Object.entries(e))
    r(i) || (o[i] = s);
  const a = Object.keys(o);
  return t.sort !== !1 && a.sort(t.sort), a.map((i) => {
    const s = e[i];
    return s === void 0 ? "" : s === null ? Dt(i, t) : Array.isArray(s) ? s.length === 0 && t.arrayFormat === "bracket-separator" ? Dt(i, t) + "[]" : s.reduce(n(i), []).join("&") : Dt(i, t) + "=" + Dt(s, t);
  }).filter((i) => i.length > 0).join("&");
}
function Tm(e, t) {
  var o;
  t = {
    decode: !0,
    ...t
  };
  let [r, n] = wm(e, "#");
  return r === void 0 && (r = e), {
    url: ((o = r == null ? void 0 : r.split("?")) == null ? void 0 : o[0]) ?? "",
    query: bu(yu(e), t),
    ...t && t.parseFragmentIdentifier && n ? { fragmentIdentifier: Tn(n, t) } : {}
  };
}
function km(e, t) {
  t = {
    encode: !0,
    strict: !0,
    [kc]: !0,
    ...t
  };
  const r = Sm(e.url).split("?")[0] || "", n = yu(e.url), o = {
    ...bu(n, { sort: !1 }),
    ...e.query
  };
  let a = Em(o, t);
  a && (a = `?${a}`);
  let i = X1(e.url);
  if (typeof e.fragmentIdentifier == "string") {
    const s = new URL(r);
    s.hash = e.fragmentIdentifier, i = t[kc] ? s.hash : `#${e.fragmentIdentifier}`;
  }
  return `${r}${a}${i}`;
}
function Om(e, t, r) {
  r = {
    parseFragmentIdentifier: !0,
    [kc]: !1,
    ...r
  };
  const { url: n, query: o, fragmentIdentifier: a } = Tm(e, r);
  return km({
    url: n,
    query: z1(o, t),
    fragmentIdentifier: a
  }, r);
}
function Z1(e, t, r) {
  const n = Array.isArray(t) ? (o) => !t.includes(o) : (o, a) => !t(o, a);
  return Om(e, n, r);
}
const J1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  exclude: Z1,
  extract: yu,
  parse: bu,
  parseUrl: Tm,
  pick: Om,
  stringify: Em,
  stringifyUrl: km
}, Symbol.toStringTag, { value: "Module" })), Mr = (e) => {
  if (!e) return "";
  const t = {};
  return Object.entries(e).forEach(([r, n], o) => {
    r !== "count" && (typeof n == "number" && (t[r] = n.toString()), t[r] = n);
  }), "?" + J1.stringify(t);
};
var Ee = /* @__PURE__ */ ((e) => (e.DateTime = "datetime", e.Number = "number", e.BigNumber = "bignumber", e))(Ee || {});
const ao = {
  createdAt: Ee.DateTime,
  updatedAt: Ee.DateTime,
  deletedAt: Ee.DateTime
};
var ev = /* @__PURE__ */ ((e) => (e.Active = "active", e.Suspended = "suspended", e.Frozen = "frozen", e.Closed = "closed", e))(ev || {}), tv = /* @__PURE__ */ ((e) => (e.Account = "account", e.Platform = "platform", e))(tv || {}), rv = /* @__PURE__ */ ((e) => (e.Deposit = "deposit", e.Withdrawal = "withdrawal", e.Reversal = "reversal", e.AggregateBet = "aggregate-bet", e.Mint = "mint", e.AdjustBalance = "adjust-balance", e.DailyBonus = "daily-bonus", e.Transfer = "transfer", e.CashBack = "cash-back", e.Turnover = "turnover", e.CreditLoss = "credit-loss", e))(rv || {}), nv = /* @__PURE__ */ ((e) => (e.DailyBonus = "daily-bonus", e.InstantCashBack = "cash-back-instant", e.DailyCashBack = "cash-back-daily", e.WeeklyCashBack = "cash-back-weekly", e.MonthlyCashBack = "cash-back-monthly", e.ReferralCommission = "referral-commission", e.ExternalBonus = "external-bonus", e))(nv || {});
const ov = {
  ...ao,
  balance: Ee.BigNumber
}, av = {
  balance: Ee.Number,
  lastClaimedAt: Ee.DateTime,
  currentPeriodResetDate: Ee.DateTime,
  nextPeriodResetDate: Ee.DateTime
}, iv = {
  ...ao,
  primaryWallet: ov,
  referredAt: Ee.DateTime,
  referralQualifiedAt: Ee.DateTime
}, sv = {
  ...ao,
  member: iv
}, I5 = {
  content: {}
}, F5 = {
  balance: Ee.BigNumber,
  amount: Ee.BigNumber
};
var lv = /* @__PURE__ */ ((e) => (e.Uncategorized = "uncategorized", e))(lv || {}), cv = /* @__PURE__ */ ((e) => (e.NATIVE = "native", e.REDIRECT = "redirect", e.NEW_WINDOW = "new-window", e))(cv || {}), uo = /* @__PURE__ */ ((e) => (e.Pending = "pending", e.Processing = "processing", e.PendingAudit = "pending-audit", e.Completed = "completed", e.Error = "error", e.Timeout = "timeout", e.Cancelled = "cancelled", e.PendingProof = "pending-proof", e))(uo || {}), Wo = /* @__PURE__ */ ((e) => (e.Deposit = "deposit", e.Withdraw = "withdraw", e.Adjustment = "adjustment", e.Transfer = "transfer", e.Promotion = "promotion", e.Turnover = "turnover", e.CreditLoss = "credit-loss", e.Commission = "commission", e))(Wo || {});
const uv = {
  ...ao,
  playAmt: Ee.BigNumber,
  earnAmt: Ee.BigNumber,
  timestamp: Ee.DateTime
}, Dm = {
  ...ao,
  reqAmount: Ee.BigNumber,
  netAmount: Ee.BigNumber
};
var dv = /* @__PURE__ */ ((e) => (e.DEFAULT = "default", e.SECRET = "secret", e.INSTANT = "instant", e.DAILY = "daily", e.WEEKLY = "weekly", e.MONTHLY = "monthly", e))(dv || {}), fv = /* @__PURE__ */ ((e) => (e.DAILY_BONUS = "daily-bonus", e.INSTANT_CASH_BACK = "instant-cash-back", e.DAILY_CASH_BACK = "daily-cash-back", e.WEEKLY_CASH_BACK = "weekly-cash-back", e.MONTHLY_CASH_BACK = "monthly-cash-back", e))(fv || {}), pv = /* @__PURE__ */ ((e) => (e.Instant = "instant", e.Daily = "daily", e.Weekly = "weekly", e.Monthly = "monthly", e))(pv || {}), mv = /* @__PURE__ */ ((e) => (e.Active = "active", e.Inactive = "inactive", e))(mv || {}), hv = /* @__PURE__ */ ((e) => (e.REDIRECT = "redirect", e.NATIVE = "native", e))(hv || {}), gv = /* @__PURE__ */ ((e) => (e.Amb = "amb", e))(gv || {}), vv = /* @__PURE__ */ ((e) => (e.Active = "active", e.Inactive = "inactive", e))(vv || {}), yv = /* @__PURE__ */ ((e) => (e.Active = "active", e.InActive = "inactive", e))(yv || {});
const L5 = {
  ...ao
}, $5 = {
  ...ao
};
var bv = /* @__PURE__ */ ((e) => (e.ExternalLinks = "external-links", e.CashBackTNC = "cash-back-tnc", e))(bv || {}), wv = /* @__PURE__ */ ((e) => (e.Generic = "generic", e))(wv || {}), xv = /* @__PURE__ */ ((e) => (e.GtrPay = "gtrpay", e.TopPay = "toppay", e.PapayaPay = "papaya", e.Mint = "mint", e))(xv || {}), _v = /* @__PURE__ */ ((e) => (e.BankTransfer = "bank-transfer", e.BankTransferZero = "bank-transfer-zero", e.BankTransferNative = "bank-transfer-native", e.QrCode = "qr-code", e))(_v || {}), Sv = /* @__PURE__ */ ((e) => (e.BankTransfer = "bank-transfer", e))(Sv || {}), Ev = /* @__PURE__ */ ((e) => (e.NotRequired = "not-required", e.Supported = "supported", e.NotSupported = "not-supported", e))(Ev || {});
const W5 = {};
var Tv = /* @__PURE__ */ ((e) => (e.Commission = "commission", e))(Tv || {});
const kv = {
  minComAmt: Ee.Number,
  minDepAmt: Ee.Number
}, gf = {
  level: Ee.Number,
  date: Ee.DateTime,
  claimedAt: Ee.DateTime,
  amount: Ee.BigNumber,
  turnover: Ee.BigNumber
}, Ov = {
  income: {
    todayIncome: Ee.BigNumber,
    ytdIncome: Ee.BigNumber,
    lifeTime: Ee.BigNumber
  },
  directReferral: {
    todayRegistration: Ee.Number,
    ytdRegistration: Ee.Number,
    lifeTimeRegistration: Ee.Number,
    todayFTD: Ee.Number,
    ytdFTD: Ee.Number,
    lifeTimeFTD: Ee.Number
  },
  teamReferral: {
    todayRegistration: Ee.Number,
    ytdRegistration: Ee.Number,
    lifeTimeRegistration: Ee.Number,
    todayFTD: Ee.Number,
    ytdFTD: Ee.Number,
    lifeTimeFTD: Ee.Number
  }
};
var Dv = /* @__PURE__ */ ((e) => (e.Active = "active", e.Inactive = "inactive", e))(Dv || {}), Nv = /* @__PURE__ */ ((e) => (e.Deposit = "deposit", e.Withdraw = "withdraw", e))(Nv || {}), Cv = /* @__PURE__ */ ((e) => (e.BankTransfer = "bank-transfer", e.BankTransferNative = "bank-transfer-native", e.BankTransferZero = "bank-transfer-zero", e.CardPayment = "card-payment", e.FastPayment = "fast-payment", e.LinePay = "line-pay", e.PromptPay = "prompt-pay", e.QrCard = "qr-card", e.QrCode = "qr-code", e.TrueMoney = "true-money", e.TrueMoneyQrCode = "true-money-qr-code", e))(Cv || {}), Pv = /* @__PURE__ */ ((e) => (e.AirPay = "air-pay", e.BankTransfer = "bank-transfer", e.Dolfin = "dolfin", e.LinePay = "line-pay", e.TrueMoney = "true-money", e))(Pv || {}), Mv = /* @__PURE__ */ ((e) => (e.GtrQr = "gtrpay/qr-code", e.GtrBank = "gtrpay/bank-transfer", e.TopQr = "toppay/qr-code", e.TopBank = "toppay/bank-transfer", e.TopBankNative = "toppay/bank-transfer-native", e.AiBankTransfer = "aipay/bank-transfer", e.AiQrCode = "aipay/qr-code", e.AiTrueMoney = "aipay/true-money", e.AiTrueMoneyQrCode = "aipay/true-money-qr-code", e.VcTrueMoney = "vcpay/true-money", e.VcPromptPay = "vcpay/prompt-pay", e.VcLinePay = "vcpay/line-pay", e.VcQrCode = "vcpay/qr-code", e.VcQrCard = "vcpay/qr-card", e.VcBank = "vcpay/bank-transfer", e.PapayaBankTransfer = "papaya/bank-transfer", e.PapayaQrCode = "papaya/qr-code", e.PapayaTrueMoney = "papaya/true-money", e.WePayBankTransfer = "wepay/bank-transfer", e.WePayQrCode = "wepay/qr-code", e.EtPayQrCode = "etpay/qr-code", e.EtPayBankTransfer = "etpay/bank-transfer", e.EtPayFastPayment = "etpay/fast-payment", e.EtPayTrueMoney = "etpay/true-money", e.HpPayBankTransfer = "hppay/bank-transfer", e.HpPayPromptPay = "hppay/prompt-pay", e.HsPayBankTransfer = "hspay/bank-transfer", e.HsPayBankTransferNative = "hspay/bank-transfer-native", e.HsPayBankTransferZero = "hspay/bank-transfer-zero", e.HsPayPromptPay = "hspay/prompt-pay", e.HtPayQrCode = "htpay/qr-code", e.HtPayTrueMoney = "htpay/true-money", e.HtPayLinePay = "htpay/line-pay", e.HtPayCardPayment = "htpay/card-payment", e.HtPayBankTransfer = "htpay/bank-transfer", e.HtPayDolfin = "htpay/dolfin", e.HtPayAirPay = "htpay/air-pay", e.SpPayTrueMoney = "sppay/true-money", e.SpPayPromptPay = "sppay/prompt-pay", e.SpPayBankTransfer = "sppay/bank-transfer", e.SsPayBankTransfer = "sspay/bank-transfer", e.SsPayBankTransferZero = "sspay/bank-transfer-zero", e.SsPayBankTransferNative = "sspay/bank-transfer-native", e.JyPayQrCode = "jypay/qr-code", e.JyPayTrueMoney = "jypay/true-money", e.JyPayBankTransfer = "jypay/bank-transfer", e.JyPayPromptPay = "jypay/prompt-pay", e.AzPayQrCode = "azpay/qr-code", e.AzPayBankTransfer = "azpay/bank-transfer", e.AzPayBankTransferZero = "azpay/bank-transfer-zero", e.WtPayBankTransfer = "wtpay/bank-transfer", e.WtPayBankTransferNative = "wtpay/bank-transfer-native", e.WtPayPromptPay = "wtpay/prompt-pay", e.MintDeposit = "mint/simulate-deposit", e))(Mv || {});
const Rv = {
  ...ao,
  min: Ee.BigNumber,
  max: Ee.BigNumber
}, vf = {
  self: sv,
  latestDepositAmount: Ee.Number
};
var Av = /* @__PURE__ */ ((e) => (e.DEPOSIT_SUCCESS = "deposit-success", e.BALANCE_CHANGED = "balance-changed", e))(Av || {});
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
var Nm;
function ie() {
  return Nm.apply(null, arguments);
}
function Iv(e) {
  Nm = e;
}
function Yr(e) {
  return e instanceof Array || Object.prototype.toString.call(e) === "[object Array]";
}
function xo(e) {
  return e != null && Object.prototype.toString.call(e) === "[object Object]";
}
function ze(e, t) {
  return Object.prototype.hasOwnProperty.call(e, t);
}
function wu(e) {
  if (Object.getOwnPropertyNames)
    return Object.getOwnPropertyNames(e).length === 0;
  var t;
  for (t in e)
    if (ze(e, t))
      return !1;
  return !0;
}
function ar(e) {
  return e === void 0;
}
function Cn(e) {
  return typeof e == "number" || Object.prototype.toString.call(e) === "[object Number]";
}
function hi(e) {
  return e instanceof Date || Object.prototype.toString.call(e) === "[object Date]";
}
function Cm(e, t) {
  var r = [], n, o = e.length;
  for (n = 0; n < o; ++n)
    r.push(t(e[n], n));
  return r;
}
function Qn(e, t) {
  for (var r in t)
    ze(t, r) && (e[r] = t[r]);
  return ze(t, "toString") && (e.toString = t.toString), ze(t, "valueOf") && (e.valueOf = t.valueOf), e;
}
function mn(e, t, r, n) {
  return Jm(e, t, r, n, !0).utc();
}
function Fv() {
  return {
    empty: !1,
    unusedTokens: [],
    unusedInput: [],
    overflow: -2,
    charsLeftOver: 0,
    nullInput: !1,
    invalidEra: null,
    invalidMonth: null,
    invalidFormat: !1,
    userInvalidated: !1,
    iso: !1,
    parsedDateParts: [],
    era: null,
    meridiem: null,
    rfc2822: !1,
    weekdayMismatch: !1
  };
}
function Re(e) {
  return e._pf == null && (e._pf = Fv()), e._pf;
}
var Oc;
Array.prototype.some ? Oc = Array.prototype.some : Oc = function(e) {
  var t = Object(this), r = t.length >>> 0, n;
  for (n = 0; n < r; n++)
    if (n in t && e.call(this, t[n], n, t))
      return !0;
  return !1;
};
function xu(e) {
  var t = null, r = !1, n = e._d && !isNaN(e._d.getTime());
  if (n && (t = Re(e), r = Oc.call(t.parsedDateParts, function(o) {
    return o != null;
  }), n = t.overflow < 0 && !t.empty && !t.invalidEra && !t.invalidMonth && !t.invalidWeekday && !t.weekdayMismatch && !t.nullInput && !t.invalidFormat && !t.userInvalidated && (!t.meridiem || t.meridiem && r), e._strict && (n = n && t.charsLeftOver === 0 && t.unusedTokens.length === 0 && t.bigHour === void 0)), Object.isFrozen == null || !Object.isFrozen(e))
    e._isValid = n;
  else
    return n;
  return e._isValid;
}
function Qs(e) {
  var t = mn(NaN);
  return e != null ? Qn(Re(t), e) : Re(t).userInvalidated = !0, t;
}
var yf = ie.momentProperties = [], Yl = !1;
function _u(e, t) {
  var r, n, o, a = yf.length;
  if (ar(t._isAMomentObject) || (e._isAMomentObject = t._isAMomentObject), ar(t._i) || (e._i = t._i), ar(t._f) || (e._f = t._f), ar(t._l) || (e._l = t._l), ar(t._strict) || (e._strict = t._strict), ar(t._tzm) || (e._tzm = t._tzm), ar(t._isUTC) || (e._isUTC = t._isUTC), ar(t._offset) || (e._offset = t._offset), ar(t._pf) || (e._pf = Re(t)), ar(t._locale) || (e._locale = t._locale), a > 0)
    for (r = 0; r < a; r++)
      n = yf[r], o = t[n], ar(o) || (e[n] = o);
  return e;
}
function gi(e) {
  _u(this, e), this._d = new Date(e._d != null ? e._d.getTime() : NaN), this.isValid() || (this._d = /* @__PURE__ */ new Date(NaN)), Yl === !1 && (Yl = !0, ie.updateOffset(this), Yl = !1);
}
function Br(e) {
  return e instanceof gi || e != null && e._isAMomentObject != null;
}
function Pm(e) {
  ie.suppressDeprecationWarnings === !1 && typeof console < "u" && console.warn && console.warn("Deprecation warning: " + e);
}
function Ar(e, t) {
  var r = !0;
  return Qn(function() {
    if (ie.deprecationHandler != null && ie.deprecationHandler(null, e), r) {
      var n = [], o, a, i, s = arguments.length;
      for (a = 0; a < s; a++) {
        if (o = "", typeof arguments[a] == "object") {
          o += `
[` + a + "] ";
          for (i in arguments[0])
            ze(arguments[0], i) && (o += i + ": " + arguments[0][i] + ", ");
          o = o.slice(0, -2);
        } else
          o = arguments[a];
        n.push(o);
      }
      Pm(
        e + `
Arguments: ` + Array.prototype.slice.call(n).join("") + `
` + new Error().stack
      ), r = !1;
    }
    return t.apply(this, arguments);
  }, t);
}
var bf = {};
function Mm(e, t) {
  ie.deprecationHandler != null && ie.deprecationHandler(e, t), bf[e] || (Pm(t), bf[e] = !0);
}
ie.suppressDeprecationWarnings = !1;
ie.deprecationHandler = null;
function hn(e) {
  return typeof Function < "u" && e instanceof Function || Object.prototype.toString.call(e) === "[object Function]";
}
function Lv(e) {
  var t, r;
  for (r in e)
    ze(e, r) && (t = e[r], hn(t) ? this[r] = t : this["_" + r] = t);
  this._config = e, this._dayOfMonthOrdinalParseLenient = new RegExp(
    (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source
  );
}
function Dc(e, t) {
  var r = Qn({}, e), n;
  for (n in t)
    ze(t, n) && (xo(e[n]) && xo(t[n]) ? (r[n] = {}, Qn(r[n], e[n]), Qn(r[n], t[n])) : t[n] != null ? r[n] = t[n] : delete r[n]);
  for (n in e)
    ze(e, n) && !ze(t, n) && xo(e[n]) && (r[n] = Qn({}, r[n]));
  return r;
}
function Su(e) {
  e != null && this.set(e);
}
var Nc;
Object.keys ? Nc = Object.keys : Nc = function(e) {
  var t, r = [];
  for (t in e)
    ze(e, t) && r.push(t);
  return r;
};
var $v = {
  sameDay: "[Today at] LT",
  nextDay: "[Tomorrow at] LT",
  nextWeek: "dddd [at] LT",
  lastDay: "[Yesterday at] LT",
  lastWeek: "[Last] dddd [at] LT",
  sameElse: "L"
};
function Wv(e, t, r) {
  var n = this._calendar[e] || this._calendar.sameElse;
  return hn(n) ? n.call(t, r) : n;
}
function ln(e, t, r) {
  var n = "" + Math.abs(e), o = t - n.length, a = e >= 0;
  return (a ? r ? "+" : "" : "-") + Math.pow(10, Math.max(0, o)).toString().substr(1) + n;
}
var Eu = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, ns = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, Bl = {}, Uo = {};
function xe(e, t, r, n) {
  var o = n;
  typeof n == "string" && (o = function() {
    return this[n]();
  }), e && (Uo[e] = o), t && (Uo[t[0]] = function() {
    return ln(o.apply(this, arguments), t[1], t[2]);
  }), r && (Uo[r] = function() {
    return this.localeData().ordinal(
      o.apply(this, arguments),
      e
    );
  });
}
function Yv(e) {
  return e.match(/\[[\s\S]/) ? e.replace(/^\[|\]$/g, "") : e.replace(/\\/g, "");
}
function Bv(e) {
  var t = e.match(Eu), r, n;
  for (r = 0, n = t.length; r < n; r++)
    Uo[t[r]] ? t[r] = Uo[t[r]] : t[r] = Yv(t[r]);
  return function(o) {
    var a = "", i;
    for (i = 0; i < n; i++)
      a += hn(t[i]) ? t[i].call(o, e) : t[i];
    return a;
  };
}
function ys(e, t) {
  return e.isValid() ? (t = Rm(t, e.localeData()), Bl[t] = Bl[t] || Bv(t), Bl[t](e)) : e.localeData().invalidDate();
}
function Rm(e, t) {
  var r = 5;
  function n(o) {
    return t.longDateFormat(o) || o;
  }
  for (ns.lastIndex = 0; r >= 0 && ns.test(e); )
    e = e.replace(
      ns,
      n
    ), ns.lastIndex = 0, r -= 1;
  return e;
}
var jv = {
  LTS: "h:mm:ss A",
  LT: "h:mm A",
  L: "MM/DD/YYYY",
  LL: "MMMM D, YYYY",
  LLL: "MMMM D, YYYY h:mm A",
  LLLL: "dddd, MMMM D, YYYY h:mm A"
};
function Uv(e) {
  var t = this._longDateFormat[e], r = this._longDateFormat[e.toUpperCase()];
  return t || !r ? t : (this._longDateFormat[e] = r.match(Eu).map(function(n) {
    return n === "MMMM" || n === "MM" || n === "DD" || n === "dddd" ? n.slice(1) : n;
  }).join(""), this._longDateFormat[e]);
}
var Hv = "Invalid date";
function Vv() {
  return this._invalidDate;
}
var zv = "%d", qv = /\d{1,2}/;
function Gv(e) {
  return this._ordinal.replace("%d", e);
}
var Qv = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  ss: "%d seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  w: "a week",
  ww: "%d weeks",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years"
};
function Kv(e, t, r, n) {
  var o = this._relativeTime[r];
  return hn(o) ? o(e, t, r, n) : o.replace(/%d/i, e);
}
function Xv(e, t) {
  var r = this._relativeTime[e > 0 ? "future" : "past"];
  return hn(r) ? r(t) : r.replace(/%s/i, t);
}
var wf = {
  D: "date",
  dates: "date",
  date: "date",
  d: "day",
  days: "day",
  day: "day",
  e: "weekday",
  weekdays: "weekday",
  weekday: "weekday",
  E: "isoWeekday",
  isoweekdays: "isoWeekday",
  isoweekday: "isoWeekday",
  DDD: "dayOfYear",
  dayofyears: "dayOfYear",
  dayofyear: "dayOfYear",
  h: "hour",
  hours: "hour",
  hour: "hour",
  ms: "millisecond",
  milliseconds: "millisecond",
  millisecond: "millisecond",
  m: "minute",
  minutes: "minute",
  minute: "minute",
  M: "month",
  months: "month",
  month: "month",
  Q: "quarter",
  quarters: "quarter",
  quarter: "quarter",
  s: "second",
  seconds: "second",
  second: "second",
  gg: "weekYear",
  weekyears: "weekYear",
  weekyear: "weekYear",
  GG: "isoWeekYear",
  isoweekyears: "isoWeekYear",
  isoweekyear: "isoWeekYear",
  w: "week",
  weeks: "week",
  week: "week",
  W: "isoWeek",
  isoweeks: "isoWeek",
  isoweek: "isoWeek",
  y: "year",
  years: "year",
  year: "year"
};
function Ir(e) {
  return typeof e == "string" ? wf[e] || wf[e.toLowerCase()] : void 0;
}
function Tu(e) {
  var t = {}, r, n;
  for (n in e)
    ze(e, n) && (r = Ir(n), r && (t[r] = e[n]));
  return t;
}
var Zv = {
  date: 9,
  day: 11,
  weekday: 11,
  isoWeekday: 11,
  dayOfYear: 4,
  hour: 13,
  millisecond: 16,
  minute: 14,
  month: 8,
  quarter: 7,
  second: 15,
  weekYear: 1,
  isoWeekYear: 1,
  week: 5,
  isoWeek: 5,
  year: 1
};
function Jv(e) {
  var t = [], r;
  for (r in e)
    ze(e, r) && t.push({ unit: r, priority: Zv[r] });
  return t.sort(function(n, o) {
    return n.priority - o.priority;
  }), t;
}
var Am = /\d/, wr = /\d\d/, Im = /\d{3}/, ku = /\d{4}/, Ks = /[+-]?\d{6}/, vt = /\d\d?/, Fm = /\d\d\d\d?/, Lm = /\d\d\d\d\d\d?/, Xs = /\d{1,3}/, Ou = /\d{1,4}/, Zs = /[+-]?\d{1,6}/, oa = /\d+/, Js = /[+-]?\d+/, ey = /Z|[+-]\d\d:?\d\d/gi, el = /Z|[+-]\d\d(?::?\d\d)?/gi, ty = /[+-]?\d+(\.\d{1,3})?/, vi = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, aa = /^[1-9]\d?/, Du = /^([1-9]\d|\d)/, Os;
Os = {};
function de(e, t, r) {
  Os[e] = hn(t) ? t : function(n, o) {
    return n && r ? r : t;
  };
}
function ry(e, t) {
  return ze(Os, e) ? Os[e](t._strict, t._locale) : new RegExp(ny(e));
}
function ny(e) {
  return Dn(
    e.replace("\\", "").replace(
      /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
      function(t, r, n, o, a) {
        return r || n || o || a;
      }
    )
  );
}
function Dn(e) {
  return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function Cr(e) {
  return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
}
function We(e) {
  var t = +e, r = 0;
  return t !== 0 && isFinite(t) && (r = Cr(t)), r;
}
var Cc = {};
function ut(e, t) {
  var r, n = t, o;
  for (typeof e == "string" && (e = [e]), Cn(t) && (n = function(a, i) {
    i[t] = We(a);
  }), o = e.length, r = 0; r < o; r++)
    Cc[e[r]] = n;
}
function yi(e, t) {
  ut(e, function(r, n, o, a) {
    o._w = o._w || {}, t(r, o._w, o, a);
  });
}
function oy(e, t, r) {
  t != null && ze(Cc, e) && Cc[e](t, r._a, r, e);
}
function tl(e) {
  return e % 4 === 0 && e % 100 !== 0 || e % 400 === 0;
}
var qt = 0, kn = 1, rn = 2, It = 3, Wr = 4, On = 5, go = 6, ay = 7, iy = 8;
xe("Y", 0, 0, function() {
  var e = this.year();
  return e <= 9999 ? ln(e, 4) : "+" + e;
});
xe(0, ["YY", 2], 0, function() {
  return this.year() % 100;
});
xe(0, ["YYYY", 4], 0, "year");
xe(0, ["YYYYY", 5], 0, "year");
xe(0, ["YYYYYY", 6, !0], 0, "year");
de("Y", Js);
de("YY", vt, wr);
de("YYYY", Ou, ku);
de("YYYYY", Zs, Ks);
de("YYYYYY", Zs, Ks);
ut(["YYYYY", "YYYYYY"], qt);
ut("YYYY", function(e, t) {
  t[qt] = e.length === 2 ? ie.parseTwoDigitYear(e) : We(e);
});
ut("YY", function(e, t) {
  t[qt] = ie.parseTwoDigitYear(e);
});
ut("Y", function(e, t) {
  t[qt] = parseInt(e, 10);
});
function Ba(e) {
  return tl(e) ? 366 : 365;
}
ie.parseTwoDigitYear = function(e) {
  return We(e) + (We(e) > 68 ? 1900 : 2e3);
};
var $m = ia("FullYear", !0);
function sy() {
  return tl(this.year());
}
function ia(e, t) {
  return function(r) {
    return r != null ? (Wm(this, e, r), ie.updateOffset(this, t), this) : Ga(this, e);
  };
}
function Ga(e, t) {
  if (!e.isValid())
    return NaN;
  var r = e._d, n = e._isUTC;
  switch (t) {
    case "Milliseconds":
      return n ? r.getUTCMilliseconds() : r.getMilliseconds();
    case "Seconds":
      return n ? r.getUTCSeconds() : r.getSeconds();
    case "Minutes":
      return n ? r.getUTCMinutes() : r.getMinutes();
    case "Hours":
      return n ? r.getUTCHours() : r.getHours();
    case "Date":
      return n ? r.getUTCDate() : r.getDate();
    case "Day":
      return n ? r.getUTCDay() : r.getDay();
    case "Month":
      return n ? r.getUTCMonth() : r.getMonth();
    case "FullYear":
      return n ? r.getUTCFullYear() : r.getFullYear();
    default:
      return NaN;
  }
}
function Wm(e, t, r) {
  var n, o, a, i, s;
  if (!(!e.isValid() || isNaN(r))) {
    switch (n = e._d, o = e._isUTC, t) {
      case "Milliseconds":
        return void (o ? n.setUTCMilliseconds(r) : n.setMilliseconds(r));
      case "Seconds":
        return void (o ? n.setUTCSeconds(r) : n.setSeconds(r));
      case "Minutes":
        return void (o ? n.setUTCMinutes(r) : n.setMinutes(r));
      case "Hours":
        return void (o ? n.setUTCHours(r) : n.setHours(r));
      case "Date":
        return void (o ? n.setUTCDate(r) : n.setDate(r));
      case "FullYear":
        break;
      default:
        return;
    }
    a = r, i = e.month(), s = e.date(), s = s === 29 && i === 1 && !tl(a) ? 28 : s, o ? n.setUTCFullYear(a, i, s) : n.setFullYear(a, i, s);
  }
}
function ly(e) {
  return e = Ir(e), hn(this[e]) ? this[e]() : this;
}
function cy(e, t) {
  if (typeof e == "object") {
    e = Tu(e);
    var r = Jv(e), n, o = r.length;
    for (n = 0; n < o; n++)
      this[r[n].unit](e[r[n].unit]);
  } else if (e = Ir(e), hn(this[e]))
    return this[e](t);
  return this;
}
function uy(e, t) {
  return (e % t + t) % t;
}
var Ot;
Array.prototype.indexOf ? Ot = Array.prototype.indexOf : Ot = function(e) {
  var t;
  for (t = 0; t < this.length; ++t)
    if (this[t] === e)
      return t;
  return -1;
};
function Nu(e, t) {
  if (isNaN(e) || isNaN(t))
    return NaN;
  var r = uy(t, 12);
  return e += (t - r) / 12, r === 1 ? tl(e) ? 29 : 28 : 31 - r % 7 % 2;
}
xe("M", ["MM", 2], "Mo", function() {
  return this.month() + 1;
});
xe("MMM", 0, 0, function(e) {
  return this.localeData().monthsShort(this, e);
});
xe("MMMM", 0, 0, function(e) {
  return this.localeData().months(this, e);
});
de("M", vt, aa);
de("MM", vt, wr);
de("MMM", function(e, t) {
  return t.monthsShortRegex(e);
});
de("MMMM", function(e, t) {
  return t.monthsRegex(e);
});
ut(["M", "MM"], function(e, t) {
  t[kn] = We(e) - 1;
});
ut(["MMM", "MMMM"], function(e, t, r, n) {
  var o = r._locale.monthsParse(e, n, r._strict);
  o != null ? t[kn] = o : Re(r).invalidMonth = e;
});
var dy = "January_February_March_April_May_June_July_August_September_October_November_December".split(
  "_"
), Ym = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), Bm = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, fy = vi, py = vi;
function my(e, t) {
  return e ? Yr(this._months) ? this._months[e.month()] : this._months[(this._months.isFormat || Bm).test(t) ? "format" : "standalone"][e.month()] : Yr(this._months) ? this._months : this._months.standalone;
}
function hy(e, t) {
  return e ? Yr(this._monthsShort) ? this._monthsShort[e.month()] : this._monthsShort[Bm.test(t) ? "format" : "standalone"][e.month()] : Yr(this._monthsShort) ? this._monthsShort : this._monthsShort.standalone;
}
function gy(e, t, r) {
  var n, o, a, i = e.toLocaleLowerCase();
  if (!this._monthsParse)
    for (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = [], n = 0; n < 12; ++n)
      a = mn([2e3, n]), this._shortMonthsParse[n] = this.monthsShort(
        a,
        ""
      ).toLocaleLowerCase(), this._longMonthsParse[n] = this.months(a, "").toLocaleLowerCase();
  return r ? t === "MMM" ? (o = Ot.call(this._shortMonthsParse, i), o !== -1 ? o : null) : (o = Ot.call(this._longMonthsParse, i), o !== -1 ? o : null) : t === "MMM" ? (o = Ot.call(this._shortMonthsParse, i), o !== -1 ? o : (o = Ot.call(this._longMonthsParse, i), o !== -1 ? o : null)) : (o = Ot.call(this._longMonthsParse, i), o !== -1 ? o : (o = Ot.call(this._shortMonthsParse, i), o !== -1 ? o : null));
}
function vy(e, t, r) {
  var n, o, a;
  if (this._monthsParseExact)
    return gy.call(this, e, t, r);
  for (this._monthsParse || (this._monthsParse = [], this._longMonthsParse = [], this._shortMonthsParse = []), n = 0; n < 12; n++) {
    if (o = mn([2e3, n]), r && !this._longMonthsParse[n] && (this._longMonthsParse[n] = new RegExp(
      "^" + this.months(o, "").replace(".", "") + "$",
      "i"
    ), this._shortMonthsParse[n] = new RegExp(
      "^" + this.monthsShort(o, "").replace(".", "") + "$",
      "i"
    )), !r && !this._monthsParse[n] && (a = "^" + this.months(o, "") + "|^" + this.monthsShort(o, ""), this._monthsParse[n] = new RegExp(a.replace(".", ""), "i")), r && t === "MMMM" && this._longMonthsParse[n].test(e))
      return n;
    if (r && t === "MMM" && this._shortMonthsParse[n].test(e))
      return n;
    if (!r && this._monthsParse[n].test(e))
      return n;
  }
}
function jm(e, t) {
  if (!e.isValid())
    return e;
  if (typeof t == "string") {
    if (/^\d+$/.test(t))
      t = We(t);
    else if (t = e.localeData().monthsParse(t), !Cn(t))
      return e;
  }
  var r = t, n = e.date();
  return n = n < 29 ? n : Math.min(n, Nu(e.year(), r)), e._isUTC ? e._d.setUTCMonth(r, n) : e._d.setMonth(r, n), e;
}
function Um(e) {
  return e != null ? (jm(this, e), ie.updateOffset(this, !0), this) : Ga(this, "Month");
}
function yy() {
  return Nu(this.year(), this.month());
}
function by(e) {
  return this._monthsParseExact ? (ze(this, "_monthsRegex") || Hm.call(this), e ? this._monthsShortStrictRegex : this._monthsShortRegex) : (ze(this, "_monthsShortRegex") || (this._monthsShortRegex = fy), this._monthsShortStrictRegex && e ? this._monthsShortStrictRegex : this._monthsShortRegex);
}
function wy(e) {
  return this._monthsParseExact ? (ze(this, "_monthsRegex") || Hm.call(this), e ? this._monthsStrictRegex : this._monthsRegex) : (ze(this, "_monthsRegex") || (this._monthsRegex = py), this._monthsStrictRegex && e ? this._monthsStrictRegex : this._monthsRegex);
}
function Hm() {
  function e(l, u) {
    return u.length - l.length;
  }
  var t = [], r = [], n = [], o, a, i, s;
  for (o = 0; o < 12; o++)
    a = mn([2e3, o]), i = Dn(this.monthsShort(a, "")), s = Dn(this.months(a, "")), t.push(i), r.push(s), n.push(s), n.push(i);
  t.sort(e), r.sort(e), n.sort(e), this._monthsRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._monthsShortRegex = this._monthsRegex, this._monthsStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._monthsShortStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function xy(e, t, r, n, o, a, i) {
  var s;
  return e < 100 && e >= 0 ? (s = new Date(e + 400, t, r, n, o, a, i), isFinite(s.getFullYear()) && s.setFullYear(e)) : s = new Date(e, t, r, n, o, a, i), s;
}
function Qa(e) {
  var t, r;
  return e < 100 && e >= 0 ? (r = Array.prototype.slice.call(arguments), r[0] = e + 400, t = new Date(Date.UTC.apply(null, r)), isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e)) : t = new Date(Date.UTC.apply(null, arguments)), t;
}
function Ds(e, t, r) {
  var n = 7 + t - r, o = (7 + Qa(e, 0, n).getUTCDay() - t) % 7;
  return -o + n - 1;
}
function Vm(e, t, r, n, o) {
  var a = (7 + r - n) % 7, i = Ds(e, n, o), s = 1 + 7 * (t - 1) + a + i, l, u;
  return s <= 0 ? (l = e - 1, u = Ba(l) + s) : s > Ba(e) ? (l = e + 1, u = s - Ba(e)) : (l = e, u = s), {
    year: l,
    dayOfYear: u
  };
}
function Ka(e, t, r) {
  var n = Ds(e.year(), t, r), o = Math.floor((e.dayOfYear() - n - 1) / 7) + 1, a, i;
  return o < 1 ? (i = e.year() - 1, a = o + Nn(i, t, r)) : o > Nn(e.year(), t, r) ? (a = o - Nn(e.year(), t, r), i = e.year() + 1) : (i = e.year(), a = o), {
    week: a,
    year: i
  };
}
function Nn(e, t, r) {
  var n = Ds(e, t, r), o = Ds(e + 1, t, r);
  return (Ba(e) - n + o) / 7;
}
xe("w", ["ww", 2], "wo", "week");
xe("W", ["WW", 2], "Wo", "isoWeek");
de("w", vt, aa);
de("ww", vt, wr);
de("W", vt, aa);
de("WW", vt, wr);
yi(
  ["w", "ww", "W", "WW"],
  function(e, t, r, n) {
    t[n.substr(0, 1)] = We(e);
  }
);
function _y(e) {
  return Ka(e, this._week.dow, this._week.doy).week;
}
var Sy = {
  dow: 0,
  // Sunday is the first day of the week.
  doy: 6
  // The week that contains Jan 6th is the first week of the year.
};
function Ey() {
  return this._week.dow;
}
function Ty() {
  return this._week.doy;
}
function ky(e) {
  var t = this.localeData().week(this);
  return e == null ? t : this.add((e - t) * 7, "d");
}
function Oy(e) {
  var t = Ka(this, 1, 4).week;
  return e == null ? t : this.add((e - t) * 7, "d");
}
xe("d", 0, "do", "day");
xe("dd", 0, 0, function(e) {
  return this.localeData().weekdaysMin(this, e);
});
xe("ddd", 0, 0, function(e) {
  return this.localeData().weekdaysShort(this, e);
});
xe("dddd", 0, 0, function(e) {
  return this.localeData().weekdays(this, e);
});
xe("e", 0, 0, "weekday");
xe("E", 0, 0, "isoWeekday");
de("d", vt);
de("e", vt);
de("E", vt);
de("dd", function(e, t) {
  return t.weekdaysMinRegex(e);
});
de("ddd", function(e, t) {
  return t.weekdaysShortRegex(e);
});
de("dddd", function(e, t) {
  return t.weekdaysRegex(e);
});
yi(["dd", "ddd", "dddd"], function(e, t, r, n) {
  var o = r._locale.weekdaysParse(e, n, r._strict);
  o != null ? t.d = o : Re(r).invalidWeekday = e;
});
yi(["d", "e", "E"], function(e, t, r, n) {
  t[n] = We(e);
});
function Dy(e, t) {
  return typeof e != "string" ? e : isNaN(e) ? (e = t.weekdaysParse(e), typeof e == "number" ? e : null) : parseInt(e, 10);
}
function Ny(e, t) {
  return typeof e == "string" ? t.weekdaysParse(e) % 7 || 7 : isNaN(e) ? null : e;
}
function Cu(e, t) {
  return e.slice(t, 7).concat(e.slice(0, t));
}
var Cy = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), zm = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), Py = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), My = vi, Ry = vi, Ay = vi;
function Iy(e, t) {
  var r = Yr(this._weekdays) ? this._weekdays : this._weekdays[e && e !== !0 && this._weekdays.isFormat.test(t) ? "format" : "standalone"];
  return e === !0 ? Cu(r, this._week.dow) : e ? r[e.day()] : r;
}
function Fy(e) {
  return e === !0 ? Cu(this._weekdaysShort, this._week.dow) : e ? this._weekdaysShort[e.day()] : this._weekdaysShort;
}
function Ly(e) {
  return e === !0 ? Cu(this._weekdaysMin, this._week.dow) : e ? this._weekdaysMin[e.day()] : this._weekdaysMin;
}
function $y(e, t, r) {
  var n, o, a, i = e.toLocaleLowerCase();
  if (!this._weekdaysParse)
    for (this._weekdaysParse = [], this._shortWeekdaysParse = [], this._minWeekdaysParse = [], n = 0; n < 7; ++n)
      a = mn([2e3, 1]).day(n), this._minWeekdaysParse[n] = this.weekdaysMin(
        a,
        ""
      ).toLocaleLowerCase(), this._shortWeekdaysParse[n] = this.weekdaysShort(
        a,
        ""
      ).toLocaleLowerCase(), this._weekdaysParse[n] = this.weekdays(a, "").toLocaleLowerCase();
  return r ? t === "dddd" ? (o = Ot.call(this._weekdaysParse, i), o !== -1 ? o : null) : t === "ddd" ? (o = Ot.call(this._shortWeekdaysParse, i), o !== -1 ? o : null) : (o = Ot.call(this._minWeekdaysParse, i), o !== -1 ? o : null) : t === "dddd" ? (o = Ot.call(this._weekdaysParse, i), o !== -1 || (o = Ot.call(this._shortWeekdaysParse, i), o !== -1) ? o : (o = Ot.call(this._minWeekdaysParse, i), o !== -1 ? o : null)) : t === "ddd" ? (o = Ot.call(this._shortWeekdaysParse, i), o !== -1 || (o = Ot.call(this._weekdaysParse, i), o !== -1) ? o : (o = Ot.call(this._minWeekdaysParse, i), o !== -1 ? o : null)) : (o = Ot.call(this._minWeekdaysParse, i), o !== -1 || (o = Ot.call(this._weekdaysParse, i), o !== -1) ? o : (o = Ot.call(this._shortWeekdaysParse, i), o !== -1 ? o : null));
}
function Wy(e, t, r) {
  var n, o, a;
  if (this._weekdaysParseExact)
    return $y.call(this, e, t, r);
  for (this._weekdaysParse || (this._weekdaysParse = [], this._minWeekdaysParse = [], this._shortWeekdaysParse = [], this._fullWeekdaysParse = []), n = 0; n < 7; n++) {
    if (o = mn([2e3, 1]).day(n), r && !this._fullWeekdaysParse[n] && (this._fullWeekdaysParse[n] = new RegExp(
      "^" + this.weekdays(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._shortWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysShort(o, "").replace(".", "\\.?") + "$",
      "i"
    ), this._minWeekdaysParse[n] = new RegExp(
      "^" + this.weekdaysMin(o, "").replace(".", "\\.?") + "$",
      "i"
    )), this._weekdaysParse[n] || (a = "^" + this.weekdays(o, "") + "|^" + this.weekdaysShort(o, "") + "|^" + this.weekdaysMin(o, ""), this._weekdaysParse[n] = new RegExp(a.replace(".", ""), "i")), r && t === "dddd" && this._fullWeekdaysParse[n].test(e))
      return n;
    if (r && t === "ddd" && this._shortWeekdaysParse[n].test(e))
      return n;
    if (r && t === "dd" && this._minWeekdaysParse[n].test(e))
      return n;
    if (!r && this._weekdaysParse[n].test(e))
      return n;
  }
}
function Yy(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = Ga(this, "Day");
  return e != null ? (e = Dy(e, this.localeData()), this.add(e - t, "d")) : t;
}
function By(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
  return e == null ? t : this.add(e - t, "d");
}
function jy(e) {
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    var t = Ny(e, this.localeData());
    return this.day(this.day() % 7 ? t : t - 7);
  } else
    return this.day() || 7;
}
function Uy(e) {
  return this._weekdaysParseExact ? (ze(this, "_weekdaysRegex") || Pu.call(this), e ? this._weekdaysStrictRegex : this._weekdaysRegex) : (ze(this, "_weekdaysRegex") || (this._weekdaysRegex = My), this._weekdaysStrictRegex && e ? this._weekdaysStrictRegex : this._weekdaysRegex);
}
function Hy(e) {
  return this._weekdaysParseExact ? (ze(this, "_weekdaysRegex") || Pu.call(this), e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex) : (ze(this, "_weekdaysShortRegex") || (this._weekdaysShortRegex = Ry), this._weekdaysShortStrictRegex && e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex);
}
function Vy(e) {
  return this._weekdaysParseExact ? (ze(this, "_weekdaysRegex") || Pu.call(this), e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex) : (ze(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Ay), this._weekdaysMinStrictRegex && e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex);
}
function Pu() {
  function e(c, p) {
    return p.length - c.length;
  }
  var t = [], r = [], n = [], o = [], a, i, s, l, u;
  for (a = 0; a < 7; a++)
    i = mn([2e3, 1]).day(a), s = Dn(this.weekdaysMin(i, "")), l = Dn(this.weekdaysShort(i, "")), u = Dn(this.weekdays(i, "")), t.push(s), r.push(l), n.push(u), o.push(s), o.push(l), o.push(u);
  t.sort(e), r.sort(e), n.sort(e), o.sort(e), this._weekdaysRegex = new RegExp("^(" + o.join("|") + ")", "i"), this._weekdaysShortRegex = this._weekdaysRegex, this._weekdaysMinRegex = this._weekdaysRegex, this._weekdaysStrictRegex = new RegExp(
    "^(" + n.join("|") + ")",
    "i"
  ), this._weekdaysShortStrictRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  ), this._weekdaysMinStrictRegex = new RegExp(
    "^(" + t.join("|") + ")",
    "i"
  );
}
function Mu() {
  return this.hours() % 12 || 12;
}
function zy() {
  return this.hours() || 24;
}
xe("H", ["HH", 2], 0, "hour");
xe("h", ["hh", 2], 0, Mu);
xe("k", ["kk", 2], 0, zy);
xe("hmm", 0, 0, function() {
  return "" + Mu.apply(this) + ln(this.minutes(), 2);
});
xe("hmmss", 0, 0, function() {
  return "" + Mu.apply(this) + ln(this.minutes(), 2) + ln(this.seconds(), 2);
});
xe("Hmm", 0, 0, function() {
  return "" + this.hours() + ln(this.minutes(), 2);
});
xe("Hmmss", 0, 0, function() {
  return "" + this.hours() + ln(this.minutes(), 2) + ln(this.seconds(), 2);
});
function qm(e, t) {
  xe(e, 0, 0, function() {
    return this.localeData().meridiem(
      this.hours(),
      this.minutes(),
      t
    );
  });
}
qm("a", !0);
qm("A", !1);
function Gm(e, t) {
  return t._meridiemParse;
}
de("a", Gm);
de("A", Gm);
de("H", vt, Du);
de("h", vt, aa);
de("k", vt, aa);
de("HH", vt, wr);
de("hh", vt, wr);
de("kk", vt, wr);
de("hmm", Fm);
de("hmmss", Lm);
de("Hmm", Fm);
de("Hmmss", Lm);
ut(["H", "HH"], It);
ut(["k", "kk"], function(e, t, r) {
  var n = We(e);
  t[It] = n === 24 ? 0 : n;
});
ut(["a", "A"], function(e, t, r) {
  r._isPm = r._locale.isPM(e), r._meridiem = e;
});
ut(["h", "hh"], function(e, t, r) {
  t[It] = We(e), Re(r).bigHour = !0;
});
ut("hmm", function(e, t, r) {
  var n = e.length - 2;
  t[It] = We(e.substr(0, n)), t[Wr] = We(e.substr(n)), Re(r).bigHour = !0;
});
ut("hmmss", function(e, t, r) {
  var n = e.length - 4, o = e.length - 2;
  t[It] = We(e.substr(0, n)), t[Wr] = We(e.substr(n, 2)), t[On] = We(e.substr(o)), Re(r).bigHour = !0;
});
ut("Hmm", function(e, t, r) {
  var n = e.length - 2;
  t[It] = We(e.substr(0, n)), t[Wr] = We(e.substr(n));
});
ut("Hmmss", function(e, t, r) {
  var n = e.length - 4, o = e.length - 2;
  t[It] = We(e.substr(0, n)), t[Wr] = We(e.substr(n, 2)), t[On] = We(e.substr(o));
});
function qy(e) {
  return (e + "").toLowerCase().charAt(0) === "p";
}
var Gy = /[ap]\.?m?\.?/i, Qy = ia("Hours", !0);
function Ky(e, t, r) {
  return e > 11 ? r ? "pm" : "PM" : r ? "am" : "AM";
}
var Qm = {
  calendar: $v,
  longDateFormat: jv,
  invalidDate: Hv,
  ordinal: zv,
  dayOfMonthOrdinalParse: qv,
  relativeTime: Qv,
  months: dy,
  monthsShort: Ym,
  week: Sy,
  weekdays: Cy,
  weekdaysMin: Py,
  weekdaysShort: zm,
  meridiemParse: Gy
}, yt = {}, xa = {}, Xa;
function Xy(e, t) {
  var r, n = Math.min(e.length, t.length);
  for (r = 0; r < n; r += 1)
    if (e[r] !== t[r])
      return r;
  return n;
}
function xf(e) {
  return e && e.toLowerCase().replace("_", "-");
}
function Zy(e) {
  for (var t = 0, r, n, o, a; t < e.length; ) {
    for (a = xf(e[t]).split("-"), r = a.length, n = xf(e[t + 1]), n = n ? n.split("-") : null; r > 0; ) {
      if (o = rl(a.slice(0, r).join("-")), o)
        return o;
      if (n && n.length >= r && Xy(a, n) >= r - 1)
        break;
      r--;
    }
    t++;
  }
  return Xa;
}
function Jy(e) {
  return !!(e && e.match("^[^/\\\\]*$"));
}
function rl(e) {
  var t = null, r;
  if (yt[e] === void 0 && typeof module < "u" && module && module.exports && Jy(e))
    try {
      t = Xa._abbr, r = require, r("./locale/" + e), eo(t);
    } catch {
      yt[e] = null;
    }
  return yt[e];
}
function eo(e, t) {
  var r;
  return e && (ar(t) ? r = Mn(e) : r = Ru(e, t), r ? Xa = r : typeof console < "u" && console.warn && console.warn(
    "Locale " + e + " not found. Did you forget to load it?"
  )), Xa._abbr;
}
function Ru(e, t) {
  if (t !== null) {
    var r, n = Qm;
    if (t.abbr = e, yt[e] != null)
      Mm(
        "defineLocaleOverride",
        "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
      ), n = yt[e]._config;
    else if (t.parentLocale != null)
      if (yt[t.parentLocale] != null)
        n = yt[t.parentLocale]._config;
      else if (r = rl(t.parentLocale), r != null)
        n = r._config;
      else
        return xa[t.parentLocale] || (xa[t.parentLocale] = []), xa[t.parentLocale].push({
          name: e,
          config: t
        }), null;
    return yt[e] = new Su(Dc(n, t)), xa[e] && xa[e].forEach(function(o) {
      Ru(o.name, o.config);
    }), eo(e), yt[e];
  } else
    return delete yt[e], null;
}
function eb(e, t) {
  if (t != null) {
    var r, n, o = Qm;
    yt[e] != null && yt[e].parentLocale != null ? yt[e].set(Dc(yt[e]._config, t)) : (n = rl(e), n != null && (o = n._config), t = Dc(o, t), n == null && (t.abbr = e), r = new Su(t), r.parentLocale = yt[e], yt[e] = r), eo(e);
  } else
    yt[e] != null && (yt[e].parentLocale != null ? (yt[e] = yt[e].parentLocale, e === eo() && eo(e)) : yt[e] != null && delete yt[e]);
  return yt[e];
}
function Mn(e) {
  var t;
  if (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
    return Xa;
  if (!Yr(e)) {
    if (t = rl(e), t)
      return t;
    e = [e];
  }
  return Zy(e);
}
function tb() {
  return Nc(yt);
}
function Au(e) {
  var t, r = e._a;
  return r && Re(e).overflow === -2 && (t = r[kn] < 0 || r[kn] > 11 ? kn : r[rn] < 1 || r[rn] > Nu(r[qt], r[kn]) ? rn : r[It] < 0 || r[It] > 24 || r[It] === 24 && (r[Wr] !== 0 || r[On] !== 0 || r[go] !== 0) ? It : r[Wr] < 0 || r[Wr] > 59 ? Wr : r[On] < 0 || r[On] > 59 ? On : r[go] < 0 || r[go] > 999 ? go : -1, Re(e)._overflowDayOfYear && (t < qt || t > rn) && (t = rn), Re(e)._overflowWeeks && t === -1 && (t = ay), Re(e)._overflowWeekday && t === -1 && (t = iy), Re(e).overflow = t), e;
}
var rb = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, nb = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, ob = /Z|[+-]\d\d(?::?\d\d)?/, os = [
  ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
  ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
  ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
  ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
  ["YYYY-DDD", /\d{4}-\d{3}/],
  ["YYYY-MM", /\d{4}-\d\d/, !1],
  ["YYYYYYMMDD", /[+-]\d{10}/],
  ["YYYYMMDD", /\d{8}/],
  ["GGGG[W]WWE", /\d{4}W\d{3}/],
  ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
  ["YYYYDDD", /\d{7}/],
  ["YYYYMM", /\d{6}/, !1],
  ["YYYY", /\d{4}/, !1]
], jl = [
  ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
  ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
  ["HH:mm:ss", /\d\d:\d\d:\d\d/],
  ["HH:mm", /\d\d:\d\d/],
  ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
  ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
  ["HHmmss", /\d\d\d\d\d\d/],
  ["HHmm", /\d\d\d\d/],
  ["HH", /\d\d/]
], ab = /^\/?Date\((-?\d+)/i, ib = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, sb = {
  UT: 0,
  GMT: 0,
  EDT: -4 * 60,
  EST: -5 * 60,
  CDT: -5 * 60,
  CST: -6 * 60,
  MDT: -6 * 60,
  MST: -7 * 60,
  PDT: -7 * 60,
  PST: -8 * 60
};
function Km(e) {
  var t, r, n = e._i, o = rb.exec(n) || nb.exec(n), a, i, s, l, u = os.length, c = jl.length;
  if (o) {
    for (Re(e).iso = !0, t = 0, r = u; t < r; t++)
      if (os[t][1].exec(o[1])) {
        i = os[t][0], a = os[t][2] !== !1;
        break;
      }
    if (i == null) {
      e._isValid = !1;
      return;
    }
    if (o[3]) {
      for (t = 0, r = c; t < r; t++)
        if (jl[t][1].exec(o[3])) {
          s = (o[2] || " ") + jl[t][0];
          break;
        }
      if (s == null) {
        e._isValid = !1;
        return;
      }
    }
    if (!a && s != null) {
      e._isValid = !1;
      return;
    }
    if (o[4])
      if (ob.exec(o[4]))
        l = "Z";
      else {
        e._isValid = !1;
        return;
      }
    e._f = i + (s || "") + (l || ""), Fu(e);
  } else
    e._isValid = !1;
}
function lb(e, t, r, n, o, a) {
  var i = [
    cb(e),
    Ym.indexOf(t),
    parseInt(r, 10),
    parseInt(n, 10),
    parseInt(o, 10)
  ];
  return a && i.push(parseInt(a, 10)), i;
}
function cb(e) {
  var t = parseInt(e, 10);
  return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
}
function ub(e) {
  return e.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}
function db(e, t, r) {
  if (e) {
    var n = zm.indexOf(e), o = new Date(
      t[0],
      t[1],
      t[2]
    ).getDay();
    if (n !== o)
      return Re(r).weekdayMismatch = !0, r._isValid = !1, !1;
  }
  return !0;
}
function fb(e, t, r) {
  if (e)
    return sb[e];
  if (t)
    return 0;
  var n = parseInt(r, 10), o = n % 100, a = (n - o) / 100;
  return a * 60 + o;
}
function Xm(e) {
  var t = ib.exec(ub(e._i)), r;
  if (t) {
    if (r = lb(
      t[4],
      t[3],
      t[2],
      t[5],
      t[6],
      t[7]
    ), !db(t[1], r, e))
      return;
    e._a = r, e._tzm = fb(t[8], t[9], t[10]), e._d = Qa.apply(null, e._a), e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), Re(e).rfc2822 = !0;
  } else
    e._isValid = !1;
}
function pb(e) {
  var t = ab.exec(e._i);
  if (t !== null) {
    e._d = /* @__PURE__ */ new Date(+t[1]);
    return;
  }
  if (Km(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  if (Xm(e), e._isValid === !1)
    delete e._isValid;
  else
    return;
  e._strict ? e._isValid = !1 : ie.createFromInputFallback(e);
}
ie.createFromInputFallback = Ar(
  "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
  function(e) {
    e._d = /* @__PURE__ */ new Date(e._i + (e._useUTC ? " UTC" : ""));
  }
);
function Yo(e, t, r) {
  return e ?? t ?? r;
}
function mb(e) {
  var t = new Date(ie.now());
  return e._useUTC ? [
    t.getUTCFullYear(),
    t.getUTCMonth(),
    t.getUTCDate()
  ] : [t.getFullYear(), t.getMonth(), t.getDate()];
}
function Iu(e) {
  var t, r, n = [], o, a, i;
  if (!e._d) {
    for (o = mb(e), e._w && e._a[rn] == null && e._a[kn] == null && hb(e), e._dayOfYear != null && (i = Yo(e._a[qt], o[qt]), (e._dayOfYear > Ba(i) || e._dayOfYear === 0) && (Re(e)._overflowDayOfYear = !0), r = Qa(i, 0, e._dayOfYear), e._a[kn] = r.getUTCMonth(), e._a[rn] = r.getUTCDate()), t = 0; t < 3 && e._a[t] == null; ++t)
      e._a[t] = n[t] = o[t];
    for (; t < 7; t++)
      e._a[t] = n[t] = e._a[t] == null ? t === 2 ? 1 : 0 : e._a[t];
    e._a[It] === 24 && e._a[Wr] === 0 && e._a[On] === 0 && e._a[go] === 0 && (e._nextDay = !0, e._a[It] = 0), e._d = (e._useUTC ? Qa : xy).apply(
      null,
      n
    ), a = e._useUTC ? e._d.getUTCDay() : e._d.getDay(), e._tzm != null && e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm), e._nextDay && (e._a[It] = 24), e._w && typeof e._w.d < "u" && e._w.d !== a && (Re(e).weekdayMismatch = !0);
  }
}
function hb(e) {
  var t, r, n, o, a, i, s, l, u;
  t = e._w, t.GG != null || t.W != null || t.E != null ? (a = 1, i = 4, r = Yo(
    t.GG,
    e._a[qt],
    Ka(gt(), 1, 4).year
  ), n = Yo(t.W, 1), o = Yo(t.E, 1), (o < 1 || o > 7) && (l = !0)) : (a = e._locale._week.dow, i = e._locale._week.doy, u = Ka(gt(), a, i), r = Yo(t.gg, e._a[qt], u.year), n = Yo(t.w, u.week), t.d != null ? (o = t.d, (o < 0 || o > 6) && (l = !0)) : t.e != null ? (o = t.e + a, (t.e < 0 || t.e > 6) && (l = !0)) : o = a), n < 1 || n > Nn(r, a, i) ? Re(e)._overflowWeeks = !0 : l != null ? Re(e)._overflowWeekday = !0 : (s = Vm(r, n, o, a, i), e._a[qt] = s.year, e._dayOfYear = s.dayOfYear);
}
ie.ISO_8601 = function() {
};
ie.RFC_2822 = function() {
};
function Fu(e) {
  if (e._f === ie.ISO_8601) {
    Km(e);
    return;
  }
  if (e._f === ie.RFC_2822) {
    Xm(e);
    return;
  }
  e._a = [], Re(e).empty = !0;
  var t = "" + e._i, r, n, o, a, i, s = t.length, l = 0, u, c;
  for (o = Rm(e._f, e._locale).match(Eu) || [], c = o.length, r = 0; r < c; r++)
    a = o[r], n = (t.match(ry(a, e)) || [])[0], n && (i = t.substr(0, t.indexOf(n)), i.length > 0 && Re(e).unusedInput.push(i), t = t.slice(
      t.indexOf(n) + n.length
    ), l += n.length), Uo[a] ? (n ? Re(e).empty = !1 : Re(e).unusedTokens.push(a), oy(a, n, e)) : e._strict && !n && Re(e).unusedTokens.push(a);
  Re(e).charsLeftOver = s - l, t.length > 0 && Re(e).unusedInput.push(t), e._a[It] <= 12 && Re(e).bigHour === !0 && e._a[It] > 0 && (Re(e).bigHour = void 0), Re(e).parsedDateParts = e._a.slice(0), Re(e).meridiem = e._meridiem, e._a[It] = gb(
    e._locale,
    e._a[It],
    e._meridiem
  ), u = Re(e).era, u !== null && (e._a[qt] = e._locale.erasConvertYear(u, e._a[qt])), Iu(e), Au(e);
}
function gb(e, t, r) {
  var n;
  return r == null ? t : e.meridiemHour != null ? e.meridiemHour(t, r) : (e.isPM != null && (n = e.isPM(r), n && t < 12 && (t += 12), !n && t === 12 && (t = 0)), t);
}
function vb(e) {
  var t, r, n, o, a, i, s = !1, l = e._f.length;
  if (l === 0) {
    Re(e).invalidFormat = !0, e._d = /* @__PURE__ */ new Date(NaN);
    return;
  }
  for (o = 0; o < l; o++)
    a = 0, i = !1, t = _u({}, e), e._useUTC != null && (t._useUTC = e._useUTC), t._f = e._f[o], Fu(t), xu(t) && (i = !0), a += Re(t).charsLeftOver, a += Re(t).unusedTokens.length * 10, Re(t).score = a, s ? a < n && (n = a, r = t) : (n == null || a < n || i) && (n = a, r = t, i && (s = !0));
  Qn(e, r || t);
}
function yb(e) {
  if (!e._d) {
    var t = Tu(e._i), r = t.day === void 0 ? t.date : t.day;
    e._a = Cm(
      [t.year, t.month, r, t.hour, t.minute, t.second, t.millisecond],
      function(n) {
        return n && parseInt(n, 10);
      }
    ), Iu(e);
  }
}
function bb(e) {
  var t = new gi(Au(Zm(e)));
  return t._nextDay && (t.add(1, "d"), t._nextDay = void 0), t;
}
function Zm(e) {
  var t = e._i, r = e._f;
  return e._locale = e._locale || Mn(e._l), t === null || r === void 0 && t === "" ? Qs({ nullInput: !0 }) : (typeof t == "string" && (e._i = t = e._locale.preparse(t)), Br(t) ? new gi(Au(t)) : (hi(t) ? e._d = t : Yr(r) ? vb(e) : r ? Fu(e) : wb(e), xu(e) || (e._d = null), e));
}
function wb(e) {
  var t = e._i;
  ar(t) ? e._d = new Date(ie.now()) : hi(t) ? e._d = new Date(t.valueOf()) : typeof t == "string" ? pb(e) : Yr(t) ? (e._a = Cm(t.slice(0), function(r) {
    return parseInt(r, 10);
  }), Iu(e)) : xo(t) ? yb(e) : Cn(t) ? e._d = new Date(t) : ie.createFromInputFallback(e);
}
function Jm(e, t, r, n, o) {
  var a = {};
  return (t === !0 || t === !1) && (n = t, t = void 0), (r === !0 || r === !1) && (n = r, r = void 0), (xo(e) && wu(e) || Yr(e) && e.length === 0) && (e = void 0), a._isAMomentObject = !0, a._useUTC = a._isUTC = o, a._l = r, a._i = e, a._f = t, a._strict = n, bb(a);
}
function gt(e, t, r, n) {
  return Jm(e, t, r, n, !1);
}
var xb = Ar(
  "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = gt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e < this ? this : e : Qs();
  }
), _b = Ar(
  "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
  function() {
    var e = gt.apply(null, arguments);
    return this.isValid() && e.isValid() ? e > this ? this : e : Qs();
  }
);
function eh(e, t) {
  var r, n;
  if (t.length === 1 && Yr(t[0]) && (t = t[0]), !t.length)
    return gt();
  for (r = t[0], n = 1; n < t.length; ++n)
    (!t[n].isValid() || t[n][e](r)) && (r = t[n]);
  return r;
}
function Sb() {
  var e = [].slice.call(arguments, 0);
  return eh("isBefore", e);
}
function Eb() {
  var e = [].slice.call(arguments, 0);
  return eh("isAfter", e);
}
var Tb = function() {
  return Date.now ? Date.now() : +/* @__PURE__ */ new Date();
}, _a = [
  "year",
  "quarter",
  "month",
  "week",
  "day",
  "hour",
  "minute",
  "second",
  "millisecond"
];
function kb(e) {
  var t, r = !1, n, o = _a.length;
  for (t in e)
    if (ze(e, t) && !(Ot.call(_a, t) !== -1 && (e[t] == null || !isNaN(e[t]))))
      return !1;
  for (n = 0; n < o; ++n)
    if (e[_a[n]]) {
      if (r)
        return !1;
      parseFloat(e[_a[n]]) !== We(e[_a[n]]) && (r = !0);
    }
  return !0;
}
function Ob() {
  return this._isValid;
}
function Db() {
  return Gr(NaN);
}
function nl(e) {
  var t = Tu(e), r = t.year || 0, n = t.quarter || 0, o = t.month || 0, a = t.week || t.isoWeek || 0, i = t.day || 0, s = t.hour || 0, l = t.minute || 0, u = t.second || 0, c = t.millisecond || 0;
  this._isValid = kb(t), this._milliseconds = +c + u * 1e3 + // 1000
  l * 6e4 + // 1000 * 60
  s * 1e3 * 60 * 60, this._days = +i + a * 7, this._months = +o + n * 3 + r * 12, this._data = {}, this._locale = Mn(), this._bubble();
}
function bs(e) {
  return e instanceof nl;
}
function Pc(e) {
  return e < 0 ? Math.round(-1 * e) * -1 : Math.round(e);
}
function Nb(e, t, r) {
  var n = Math.min(e.length, t.length), o = Math.abs(e.length - t.length), a = 0, i;
  for (i = 0; i < n; i++)
    We(e[i]) !== We(t[i]) && a++;
  return a + o;
}
function th(e, t) {
  xe(e, 0, 0, function() {
    var r = this.utcOffset(), n = "+";
    return r < 0 && (r = -r, n = "-"), n + ln(~~(r / 60), 2) + t + ln(~~r % 60, 2);
  });
}
th("Z", ":");
th("ZZ", "");
de("Z", el);
de("ZZ", el);
ut(["Z", "ZZ"], function(e, t, r) {
  r._useUTC = !0, r._tzm = Lu(el, e);
});
var Cb = /([\+\-]|\d\d)/gi;
function Lu(e, t) {
  var r = (t || "").match(e), n, o, a;
  return r === null ? null : (n = r[r.length - 1] || [], o = (n + "").match(Cb) || ["-", 0, 0], a = +(o[1] * 60) + We(o[2]), a === 0 ? 0 : o[0] === "+" ? a : -a);
}
function $u(e, t) {
  var r, n;
  return t._isUTC ? (r = t.clone(), n = (Br(e) || hi(e) ? e.valueOf() : gt(e).valueOf()) - r.valueOf(), r._d.setTime(r._d.valueOf() + n), ie.updateOffset(r, !1), r) : gt(e).local();
}
function Mc(e) {
  return -Math.round(e._d.getTimezoneOffset());
}
ie.updateOffset = function() {
};
function Pb(e, t, r) {
  var n = this._offset || 0, o;
  if (!this.isValid())
    return e != null ? this : NaN;
  if (e != null) {
    if (typeof e == "string") {
      if (e = Lu(el, e), e === null)
        return this;
    } else Math.abs(e) < 16 && !r && (e = e * 60);
    return !this._isUTC && t && (o = Mc(this)), this._offset = e, this._isUTC = !0, o != null && this.add(o, "m"), n !== e && (!t || this._changeInProgress ? oh(
      this,
      Gr(e - n, "m"),
      1,
      !1
    ) : this._changeInProgress || (this._changeInProgress = !0, ie.updateOffset(this, !0), this._changeInProgress = null)), this;
  } else
    return this._isUTC ? n : Mc(this);
}
function Mb(e, t) {
  return e != null ? (typeof e != "string" && (e = -e), this.utcOffset(e, t), this) : -this.utcOffset();
}
function Rb(e) {
  return this.utcOffset(0, e);
}
function Ab(e) {
  return this._isUTC && (this.utcOffset(0, e), this._isUTC = !1, e && this.subtract(Mc(this), "m")), this;
}
function Ib() {
  if (this._tzm != null)
    this.utcOffset(this._tzm, !1, !0);
  else if (typeof this._i == "string") {
    var e = Lu(ey, this._i);
    e != null ? this.utcOffset(e) : this.utcOffset(0, !0);
  }
  return this;
}
function Fb(e) {
  return this.isValid() ? (e = e ? gt(e).utcOffset() : 0, (this.utcOffset() - e) % 60 === 0) : !1;
}
function Lb() {
  return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
}
function $b() {
  if (!ar(this._isDSTShifted))
    return this._isDSTShifted;
  var e = {}, t;
  return _u(e, this), e = Zm(e), e._a ? (t = e._isUTC ? mn(e._a) : gt(e._a), this._isDSTShifted = this.isValid() && Nb(e._a, t.toArray()) > 0) : this._isDSTShifted = !1, this._isDSTShifted;
}
function Wb() {
  return this.isValid() ? !this._isUTC : !1;
}
function Yb() {
  return this.isValid() ? this._isUTC : !1;
}
function rh() {
  return this.isValid() ? this._isUTC && this._offset === 0 : !1;
}
var Bb = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, jb = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
function Gr(e, t) {
  var r = e, n = null, o, a, i;
  return bs(e) ? r = {
    ms: e._milliseconds,
    d: e._days,
    M: e._months
  } : Cn(e) || !isNaN(+e) ? (r = {}, t ? r[t] = +e : r.milliseconds = +e) : (n = Bb.exec(e)) ? (o = n[1] === "-" ? -1 : 1, r = {
    y: 0,
    d: We(n[rn]) * o,
    h: We(n[It]) * o,
    m: We(n[Wr]) * o,
    s: We(n[On]) * o,
    ms: We(Pc(n[go] * 1e3)) * o
    // the millisecond decimal point is included in the match
  }) : (n = jb.exec(e)) ? (o = n[1] === "-" ? -1 : 1, r = {
    y: co(n[2], o),
    M: co(n[3], o),
    w: co(n[4], o),
    d: co(n[5], o),
    h: co(n[6], o),
    m: co(n[7], o),
    s: co(n[8], o)
  }) : r == null ? r = {} : typeof r == "object" && ("from" in r || "to" in r) && (i = Ub(
    gt(r.from),
    gt(r.to)
  ), r = {}, r.ms = i.milliseconds, r.M = i.months), a = new nl(r), bs(e) && ze(e, "_locale") && (a._locale = e._locale), bs(e) && ze(e, "_isValid") && (a._isValid = e._isValid), a;
}
Gr.fn = nl.prototype;
Gr.invalid = Db;
function co(e, t) {
  var r = e && parseFloat(e.replace(",", "."));
  return (isNaN(r) ? 0 : r) * t;
}
function _f(e, t) {
  var r = {};
  return r.months = t.month() - e.month() + (t.year() - e.year()) * 12, e.clone().add(r.months, "M").isAfter(t) && --r.months, r.milliseconds = +t - +e.clone().add(r.months, "M"), r;
}
function Ub(e, t) {
  var r;
  return e.isValid() && t.isValid() ? (t = $u(t, e), e.isBefore(t) ? r = _f(e, t) : (r = _f(t, e), r.milliseconds = -r.milliseconds, r.months = -r.months), r) : { milliseconds: 0, months: 0 };
}
function nh(e, t) {
  return function(r, n) {
    var o, a;
    return n !== null && !isNaN(+n) && (Mm(
      t,
      "moment()." + t + "(period, number) is deprecated. Please use moment()." + t + "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
    ), a = r, r = n, n = a), o = Gr(r, n), oh(this, o, e), this;
  };
}
function oh(e, t, r, n) {
  var o = t._milliseconds, a = Pc(t._days), i = Pc(t._months);
  e.isValid() && (n = n ?? !0, i && jm(e, Ga(e, "Month") + i * r), a && Wm(e, "Date", Ga(e, "Date") + a * r), o && e._d.setTime(e._d.valueOf() + o * r), n && ie.updateOffset(e, a || i));
}
var Hb = nh(1, "add"), Vb = nh(-1, "subtract");
function ah(e) {
  return typeof e == "string" || e instanceof String;
}
function zb(e) {
  return Br(e) || hi(e) || ah(e) || Cn(e) || Gb(e) || qb(e) || e === null || e === void 0;
}
function qb(e) {
  var t = xo(e) && !wu(e), r = !1, n = [
    "years",
    "year",
    "y",
    "months",
    "month",
    "M",
    "days",
    "day",
    "d",
    "dates",
    "date",
    "D",
    "hours",
    "hour",
    "h",
    "minutes",
    "minute",
    "m",
    "seconds",
    "second",
    "s",
    "milliseconds",
    "millisecond",
    "ms"
  ], o, a, i = n.length;
  for (o = 0; o < i; o += 1)
    a = n[o], r = r || ze(e, a);
  return t && r;
}
function Gb(e) {
  var t = Yr(e), r = !1;
  return t && (r = e.filter(function(n) {
    return !Cn(n) && ah(e);
  }).length === 0), t && r;
}
function Qb(e) {
  var t = xo(e) && !wu(e), r = !1, n = [
    "sameDay",
    "nextDay",
    "lastDay",
    "nextWeek",
    "lastWeek",
    "sameElse"
  ], o, a;
  for (o = 0; o < n.length; o += 1)
    a = n[o], r = r || ze(e, a);
  return t && r;
}
function Kb(e, t) {
  var r = e.diff(t, "days", !0);
  return r < -6 ? "sameElse" : r < -1 ? "lastWeek" : r < 0 ? "lastDay" : r < 1 ? "sameDay" : r < 2 ? "nextDay" : r < 7 ? "nextWeek" : "sameElse";
}
function Xb(e, t) {
  arguments.length === 1 && (arguments[0] ? zb(arguments[0]) ? (e = arguments[0], t = void 0) : Qb(arguments[0]) && (t = arguments[0], e = void 0) : (e = void 0, t = void 0));
  var r = e || gt(), n = $u(r, this).startOf("day"), o = ie.calendarFormat(this, n) || "sameElse", a = t && (hn(t[o]) ? t[o].call(this, r) : t[o]);
  return this.format(
    a || this.localeData().calendar(o, this, gt(r))
  );
}
function Zb() {
  return new gi(this);
}
function Jb(e, t) {
  var r = Br(e) ? e : gt(e);
  return this.isValid() && r.isValid() ? (t = Ir(t) || "millisecond", t === "millisecond" ? this.valueOf() > r.valueOf() : r.valueOf() < this.clone().startOf(t).valueOf()) : !1;
}
function ew(e, t) {
  var r = Br(e) ? e : gt(e);
  return this.isValid() && r.isValid() ? (t = Ir(t) || "millisecond", t === "millisecond" ? this.valueOf() < r.valueOf() : this.clone().endOf(t).valueOf() < r.valueOf()) : !1;
}
function tw(e, t, r, n) {
  var o = Br(e) ? e : gt(e), a = Br(t) ? t : gt(t);
  return this.isValid() && o.isValid() && a.isValid() ? (n = n || "()", (n[0] === "(" ? this.isAfter(o, r) : !this.isBefore(o, r)) && (n[1] === ")" ? this.isBefore(a, r) : !this.isAfter(a, r))) : !1;
}
function rw(e, t) {
  var r = Br(e) ? e : gt(e), n;
  return this.isValid() && r.isValid() ? (t = Ir(t) || "millisecond", t === "millisecond" ? this.valueOf() === r.valueOf() : (n = r.valueOf(), this.clone().startOf(t).valueOf() <= n && n <= this.clone().endOf(t).valueOf())) : !1;
}
function nw(e, t) {
  return this.isSame(e, t) || this.isAfter(e, t);
}
function ow(e, t) {
  return this.isSame(e, t) || this.isBefore(e, t);
}
function aw(e, t, r) {
  var n, o, a;
  if (!this.isValid())
    return NaN;
  if (n = $u(e, this), !n.isValid())
    return NaN;
  switch (o = (n.utcOffset() - this.utcOffset()) * 6e4, t = Ir(t), t) {
    case "year":
      a = ws(this, n) / 12;
      break;
    case "month":
      a = ws(this, n);
      break;
    case "quarter":
      a = ws(this, n) / 3;
      break;
    case "second":
      a = (this - n) / 1e3;
      break;
    case "minute":
      a = (this - n) / 6e4;
      break;
    case "hour":
      a = (this - n) / 36e5;
      break;
    case "day":
      a = (this - n - o) / 864e5;
      break;
    case "week":
      a = (this - n - o) / 6048e5;
      break;
    default:
      a = this - n;
  }
  return r ? a : Cr(a);
}
function ws(e, t) {
  if (e.date() < t.date())
    return -ws(t, e);
  var r = (t.year() - e.year()) * 12 + (t.month() - e.month()), n = e.clone().add(r, "months"), o, a;
  return t - n < 0 ? (o = e.clone().add(r - 1, "months"), a = (t - n) / (n - o)) : (o = e.clone().add(r + 1, "months"), a = (t - n) / (o - n)), -(r + a) || 0;
}
ie.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
ie.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
function iw() {
  return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
}
function sw(e) {
  if (!this.isValid())
    return null;
  var t = e !== !0, r = t ? this.clone().utc() : this;
  return r.year() < 0 || r.year() > 9999 ? ys(
    r,
    t ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
  ) : hn(Date.prototype.toISOString) ? t ? this.toDate().toISOString() : new Date(this.valueOf() + this.utcOffset() * 60 * 1e3).toISOString().replace("Z", ys(r, "Z")) : ys(
    r,
    t ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
  );
}
function lw() {
  if (!this.isValid())
    return "moment.invalid(/* " + this._i + " */)";
  var e = "moment", t = "", r, n, o, a;
  return this.isLocal() || (e = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone", t = "Z"), r = "[" + e + '("]', n = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY", o = "-MM-DD[T]HH:mm:ss.SSS", a = t + '[")]', this.format(r + n + o + a);
}
function cw(e) {
  e || (e = this.isUtc() ? ie.defaultFormatUtc : ie.defaultFormat);
  var t = ys(this, e);
  return this.localeData().postformat(t);
}
function uw(e, t) {
  return this.isValid() && (Br(e) && e.isValid() || gt(e).isValid()) ? Gr({ to: this, from: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function dw(e) {
  return this.from(gt(), e);
}
function fw(e, t) {
  return this.isValid() && (Br(e) && e.isValid() || gt(e).isValid()) ? Gr({ from: this, to: e }).locale(this.locale()).humanize(!t) : this.localeData().invalidDate();
}
function pw(e) {
  return this.to(gt(), e);
}
function ih(e) {
  var t;
  return e === void 0 ? this._locale._abbr : (t = Mn(e), t != null && (this._locale = t), this);
}
var sh = Ar(
  "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
  function(e) {
    return e === void 0 ? this.localeData() : this.locale(e);
  }
);
function lh() {
  return this._locale;
}
var Ns = 1e3, Ho = 60 * Ns, Cs = 60 * Ho, ch = (365 * 400 + 97) * 24 * Cs;
function Vo(e, t) {
  return (e % t + t) % t;
}
function uh(e, t, r) {
  return e < 100 && e >= 0 ? new Date(e + 400, t, r) - ch : new Date(e, t, r).valueOf();
}
function dh(e, t, r) {
  return e < 100 && e >= 0 ? Date.UTC(e + 400, t, r) - ch : Date.UTC(e, t, r);
}
function mw(e) {
  var t, r;
  if (e = Ir(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? dh : uh, e) {
    case "year":
      t = r(this.year(), 0, 1);
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3,
        1
      );
      break;
    case "month":
      t = r(this.year(), this.month(), 1);
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday()
      );
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1)
      );
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date());
      break;
    case "hour":
      t = this._d.valueOf(), t -= Vo(
        t + (this._isUTC ? 0 : this.utcOffset() * Ho),
        Cs
      );
      break;
    case "minute":
      t = this._d.valueOf(), t -= Vo(t, Ho);
      break;
    case "second":
      t = this._d.valueOf(), t -= Vo(t, Ns);
      break;
  }
  return this._d.setTime(t), ie.updateOffset(this, !0), this;
}
function hw(e) {
  var t, r;
  if (e = Ir(e), e === void 0 || e === "millisecond" || !this.isValid())
    return this;
  switch (r = this._isUTC ? dh : uh, e) {
    case "year":
      t = r(this.year() + 1, 0, 1) - 1;
      break;
    case "quarter":
      t = r(
        this.year(),
        this.month() - this.month() % 3 + 3,
        1
      ) - 1;
      break;
    case "month":
      t = r(this.year(), this.month() + 1, 1) - 1;
      break;
    case "week":
      t = r(
        this.year(),
        this.month(),
        this.date() - this.weekday() + 7
      ) - 1;
      break;
    case "isoWeek":
      t = r(
        this.year(),
        this.month(),
        this.date() - (this.isoWeekday() - 1) + 7
      ) - 1;
      break;
    case "day":
    case "date":
      t = r(this.year(), this.month(), this.date() + 1) - 1;
      break;
    case "hour":
      t = this._d.valueOf(), t += Cs - Vo(
        t + (this._isUTC ? 0 : this.utcOffset() * Ho),
        Cs
      ) - 1;
      break;
    case "minute":
      t = this._d.valueOf(), t += Ho - Vo(t, Ho) - 1;
      break;
    case "second":
      t = this._d.valueOf(), t += Ns - Vo(t, Ns) - 1;
      break;
  }
  return this._d.setTime(t), ie.updateOffset(this, !0), this;
}
function gw() {
  return this._d.valueOf() - (this._offset || 0) * 6e4;
}
function vw() {
  return Math.floor(this.valueOf() / 1e3);
}
function yw() {
  return new Date(this.valueOf());
}
function bw() {
  var e = this;
  return [
    e.year(),
    e.month(),
    e.date(),
    e.hour(),
    e.minute(),
    e.second(),
    e.millisecond()
  ];
}
function ww() {
  var e = this;
  return {
    years: e.year(),
    months: e.month(),
    date: e.date(),
    hours: e.hours(),
    minutes: e.minutes(),
    seconds: e.seconds(),
    milliseconds: e.milliseconds()
  };
}
function xw() {
  return this.isValid() ? this.toISOString() : null;
}
function _w() {
  return xu(this);
}
function Sw() {
  return Qn({}, Re(this));
}
function Ew() {
  return Re(this).overflow;
}
function Tw() {
  return {
    input: this._i,
    format: this._f,
    locale: this._locale,
    isUTC: this._isUTC,
    strict: this._strict
  };
}
xe("N", 0, 0, "eraAbbr");
xe("NN", 0, 0, "eraAbbr");
xe("NNN", 0, 0, "eraAbbr");
xe("NNNN", 0, 0, "eraName");
xe("NNNNN", 0, 0, "eraNarrow");
xe("y", ["y", 1], "yo", "eraYear");
xe("y", ["yy", 2], 0, "eraYear");
xe("y", ["yyy", 3], 0, "eraYear");
xe("y", ["yyyy", 4], 0, "eraYear");
de("N", Wu);
de("NN", Wu);
de("NNN", Wu);
de("NNNN", Fw);
de("NNNNN", Lw);
ut(
  ["N", "NN", "NNN", "NNNN", "NNNNN"],
  function(e, t, r, n) {
    var o = r._locale.erasParse(e, n, r._strict);
    o ? Re(r).era = o : Re(r).invalidEra = e;
  }
);
de("y", oa);
de("yy", oa);
de("yyy", oa);
de("yyyy", oa);
de("yo", $w);
ut(["y", "yy", "yyy", "yyyy"], qt);
ut(["yo"], function(e, t, r, n) {
  var o;
  r._locale._eraYearOrdinalRegex && (o = e.match(r._locale._eraYearOrdinalRegex)), r._locale.eraYearOrdinalParse ? t[qt] = r._locale.eraYearOrdinalParse(e, o) : t[qt] = parseInt(e, 10);
});
function kw(e, t) {
  var r, n, o, a = this._eras || Mn("en")._eras;
  for (r = 0, n = a.length; r < n; ++r) {
    switch (typeof a[r].since) {
      case "string":
        o = ie(a[r].since).startOf("day"), a[r].since = o.valueOf();
        break;
    }
    switch (typeof a[r].until) {
      case "undefined":
        a[r].until = 1 / 0;
        break;
      case "string":
        o = ie(a[r].until).startOf("day").valueOf(), a[r].until = o.valueOf();
        break;
    }
  }
  return a;
}
function Ow(e, t, r) {
  var n, o, a = this.eras(), i, s, l;
  for (e = e.toUpperCase(), n = 0, o = a.length; n < o; ++n)
    if (i = a[n].name.toUpperCase(), s = a[n].abbr.toUpperCase(), l = a[n].narrow.toUpperCase(), r)
      switch (t) {
        case "N":
        case "NN":
        case "NNN":
          if (s === e)
            return a[n];
          break;
        case "NNNN":
          if (i === e)
            return a[n];
          break;
        case "NNNNN":
          if (l === e)
            return a[n];
          break;
      }
    else if ([i, s, l].indexOf(e) >= 0)
      return a[n];
}
function Dw(e, t) {
  var r = e.since <= e.until ? 1 : -1;
  return t === void 0 ? ie(e.since).year() : ie(e.since).year() + (t - e.offset) * r;
}
function Nw() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].name;
  return "";
}
function Cw() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].narrow;
  return "";
}
function Pw() {
  var e, t, r, n = this.localeData().eras();
  for (e = 0, t = n.length; e < t; ++e)
    if (r = this.clone().startOf("day").valueOf(), n[e].since <= r && r <= n[e].until || n[e].until <= r && r <= n[e].since)
      return n[e].abbr;
  return "";
}
function Mw() {
  var e, t, r, n, o = this.localeData().eras();
  for (e = 0, t = o.length; e < t; ++e)
    if (r = o[e].since <= o[e].until ? 1 : -1, n = this.clone().startOf("day").valueOf(), o[e].since <= n && n <= o[e].until || o[e].until <= n && n <= o[e].since)
      return (this.year() - ie(o[e].since).year()) * r + o[e].offset;
  return this.year();
}
function Rw(e) {
  return ze(this, "_erasNameRegex") || Yu.call(this), e ? this._erasNameRegex : this._erasRegex;
}
function Aw(e) {
  return ze(this, "_erasAbbrRegex") || Yu.call(this), e ? this._erasAbbrRegex : this._erasRegex;
}
function Iw(e) {
  return ze(this, "_erasNarrowRegex") || Yu.call(this), e ? this._erasNarrowRegex : this._erasRegex;
}
function Wu(e, t) {
  return t.erasAbbrRegex(e);
}
function Fw(e, t) {
  return t.erasNameRegex(e);
}
function Lw(e, t) {
  return t.erasNarrowRegex(e);
}
function $w(e, t) {
  return t._eraYearOrdinalRegex || oa;
}
function Yu() {
  var e = [], t = [], r = [], n = [], o, a, i, s, l, u = this.eras();
  for (o = 0, a = u.length; o < a; ++o)
    i = Dn(u[o].name), s = Dn(u[o].abbr), l = Dn(u[o].narrow), t.push(i), e.push(s), r.push(l), n.push(i), n.push(s), n.push(l);
  this._erasRegex = new RegExp("^(" + n.join("|") + ")", "i"), this._erasNameRegex = new RegExp("^(" + t.join("|") + ")", "i"), this._erasAbbrRegex = new RegExp("^(" + e.join("|") + ")", "i"), this._erasNarrowRegex = new RegExp(
    "^(" + r.join("|") + ")",
    "i"
  );
}
xe(0, ["gg", 2], 0, function() {
  return this.weekYear() % 100;
});
xe(0, ["GG", 2], 0, function() {
  return this.isoWeekYear() % 100;
});
function ol(e, t) {
  xe(0, [e, e.length], 0, t);
}
ol("gggg", "weekYear");
ol("ggggg", "weekYear");
ol("GGGG", "isoWeekYear");
ol("GGGGG", "isoWeekYear");
de("G", Js);
de("g", Js);
de("GG", vt, wr);
de("gg", vt, wr);
de("GGGG", Ou, ku);
de("gggg", Ou, ku);
de("GGGGG", Zs, Ks);
de("ggggg", Zs, Ks);
yi(
  ["gggg", "ggggg", "GGGG", "GGGGG"],
  function(e, t, r, n) {
    t[n.substr(0, 2)] = We(e);
  }
);
yi(["gg", "GG"], function(e, t, r, n) {
  t[n] = ie.parseTwoDigitYear(e);
});
function Ww(e) {
  return fh.call(
    this,
    e,
    this.week(),
    this.weekday() + this.localeData()._week.dow,
    this.localeData()._week.dow,
    this.localeData()._week.doy
  );
}
function Yw(e) {
  return fh.call(
    this,
    e,
    this.isoWeek(),
    this.isoWeekday(),
    1,
    4
  );
}
function Bw() {
  return Nn(this.year(), 1, 4);
}
function jw() {
  return Nn(this.isoWeekYear(), 1, 4);
}
function Uw() {
  var e = this.localeData()._week;
  return Nn(this.year(), e.dow, e.doy);
}
function Hw() {
  var e = this.localeData()._week;
  return Nn(this.weekYear(), e.dow, e.doy);
}
function fh(e, t, r, n, o) {
  var a;
  return e == null ? Ka(this, n, o).year : (a = Nn(e, n, o), t > a && (t = a), Vw.call(this, e, t, r, n, o));
}
function Vw(e, t, r, n, o) {
  var a = Vm(e, t, r, n, o), i = Qa(a.year, 0, a.dayOfYear);
  return this.year(i.getUTCFullYear()), this.month(i.getUTCMonth()), this.date(i.getUTCDate()), this;
}
xe("Q", 0, "Qo", "quarter");
de("Q", Am);
ut("Q", function(e, t) {
  t[kn] = (We(e) - 1) * 3;
});
function zw(e) {
  return e == null ? Math.ceil((this.month() + 1) / 3) : this.month((e - 1) * 3 + this.month() % 3);
}
xe("D", ["DD", 2], "Do", "date");
de("D", vt, aa);
de("DD", vt, wr);
de("Do", function(e, t) {
  return e ? t._dayOfMonthOrdinalParse || t._ordinalParse : t._dayOfMonthOrdinalParseLenient;
});
ut(["D", "DD"], rn);
ut("Do", function(e, t) {
  t[rn] = We(e.match(vt)[0]);
});
var ph = ia("Date", !0);
xe("DDD", ["DDDD", 3], "DDDo", "dayOfYear");
de("DDD", Xs);
de("DDDD", Im);
ut(["DDD", "DDDD"], function(e, t, r) {
  r._dayOfYear = We(e);
});
function qw(e) {
  var t = Math.round(
    (this.clone().startOf("day") - this.clone().startOf("year")) / 864e5
  ) + 1;
  return e == null ? t : this.add(e - t, "d");
}
xe("m", ["mm", 2], 0, "minute");
de("m", vt, Du);
de("mm", vt, wr);
ut(["m", "mm"], Wr);
var Gw = ia("Minutes", !1);
xe("s", ["ss", 2], 0, "second");
de("s", vt, Du);
de("ss", vt, wr);
ut(["s", "ss"], On);
var Qw = ia("Seconds", !1);
xe("S", 0, 0, function() {
  return ~~(this.millisecond() / 100);
});
xe(0, ["SS", 2], 0, function() {
  return ~~(this.millisecond() / 10);
});
xe(0, ["SSS", 3], 0, "millisecond");
xe(0, ["SSSS", 4], 0, function() {
  return this.millisecond() * 10;
});
xe(0, ["SSSSS", 5], 0, function() {
  return this.millisecond() * 100;
});
xe(0, ["SSSSSS", 6], 0, function() {
  return this.millisecond() * 1e3;
});
xe(0, ["SSSSSSS", 7], 0, function() {
  return this.millisecond() * 1e4;
});
xe(0, ["SSSSSSSS", 8], 0, function() {
  return this.millisecond() * 1e5;
});
xe(0, ["SSSSSSSSS", 9], 0, function() {
  return this.millisecond() * 1e6;
});
de("S", Xs, Am);
de("SS", Xs, wr);
de("SSS", Xs, Im);
var Kn, mh;
for (Kn = "SSSS"; Kn.length <= 9; Kn += "S")
  de(Kn, oa);
function Kw(e, t) {
  t[go] = We(("0." + e) * 1e3);
}
for (Kn = "S"; Kn.length <= 9; Kn += "S")
  ut(Kn, Kw);
mh = ia("Milliseconds", !1);
xe("z", 0, 0, "zoneAbbr");
xe("zz", 0, 0, "zoneName");
function Xw() {
  return this._isUTC ? "UTC" : "";
}
function Zw() {
  return this._isUTC ? "Coordinated Universal Time" : "";
}
var re = gi.prototype;
re.add = Hb;
re.calendar = Xb;
re.clone = Zb;
re.diff = aw;
re.endOf = hw;
re.format = cw;
re.from = uw;
re.fromNow = dw;
re.to = fw;
re.toNow = pw;
re.get = ly;
re.invalidAt = Ew;
re.isAfter = Jb;
re.isBefore = ew;
re.isBetween = tw;
re.isSame = rw;
re.isSameOrAfter = nw;
re.isSameOrBefore = ow;
re.isValid = _w;
re.lang = sh;
re.locale = ih;
re.localeData = lh;
re.max = _b;
re.min = xb;
re.parsingFlags = Sw;
re.set = cy;
re.startOf = mw;
re.subtract = Vb;
re.toArray = bw;
re.toObject = ww;
re.toDate = yw;
re.toISOString = sw;
re.inspect = lw;
typeof Symbol < "u" && Symbol.for != null && (re[Symbol.for("nodejs.util.inspect.custom")] = function() {
  return "Moment<" + this.format() + ">";
});
re.toJSON = xw;
re.toString = iw;
re.unix = vw;
re.valueOf = gw;
re.creationData = Tw;
re.eraName = Nw;
re.eraNarrow = Cw;
re.eraAbbr = Pw;
re.eraYear = Mw;
re.year = $m;
re.isLeapYear = sy;
re.weekYear = Ww;
re.isoWeekYear = Yw;
re.quarter = re.quarters = zw;
re.month = Um;
re.daysInMonth = yy;
re.week = re.weeks = ky;
re.isoWeek = re.isoWeeks = Oy;
re.weeksInYear = Uw;
re.weeksInWeekYear = Hw;
re.isoWeeksInYear = Bw;
re.isoWeeksInISOWeekYear = jw;
re.date = ph;
re.day = re.days = Yy;
re.weekday = By;
re.isoWeekday = jy;
re.dayOfYear = qw;
re.hour = re.hours = Qy;
re.minute = re.minutes = Gw;
re.second = re.seconds = Qw;
re.millisecond = re.milliseconds = mh;
re.utcOffset = Pb;
re.utc = Rb;
re.local = Ab;
re.parseZone = Ib;
re.hasAlignedHourOffset = Fb;
re.isDST = Lb;
re.isLocal = Wb;
re.isUtcOffset = Yb;
re.isUtc = rh;
re.isUTC = rh;
re.zoneAbbr = Xw;
re.zoneName = Zw;
re.dates = Ar(
  "dates accessor is deprecated. Use date instead.",
  ph
);
re.months = Ar(
  "months accessor is deprecated. Use month instead",
  Um
);
re.years = Ar(
  "years accessor is deprecated. Use year instead",
  $m
);
re.zone = Ar(
  "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
  Mb
);
re.isDSTShifted = Ar(
  "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
  $b
);
function Jw(e) {
  return gt(e * 1e3);
}
function ex() {
  return gt.apply(null, arguments).parseZone();
}
function hh(e) {
  return e;
}
var qe = Su.prototype;
qe.calendar = Wv;
qe.longDateFormat = Uv;
qe.invalidDate = Vv;
qe.ordinal = Gv;
qe.preparse = hh;
qe.postformat = hh;
qe.relativeTime = Kv;
qe.pastFuture = Xv;
qe.set = Lv;
qe.eras = kw;
qe.erasParse = Ow;
qe.erasConvertYear = Dw;
qe.erasAbbrRegex = Aw;
qe.erasNameRegex = Rw;
qe.erasNarrowRegex = Iw;
qe.months = my;
qe.monthsShort = hy;
qe.monthsParse = vy;
qe.monthsRegex = wy;
qe.monthsShortRegex = by;
qe.week = _y;
qe.firstDayOfYear = Ty;
qe.firstDayOfWeek = Ey;
qe.weekdays = Iy;
qe.weekdaysMin = Ly;
qe.weekdaysShort = Fy;
qe.weekdaysParse = Wy;
qe.weekdaysRegex = Uy;
qe.weekdaysShortRegex = Hy;
qe.weekdaysMinRegex = Vy;
qe.isPM = qy;
qe.meridiem = Ky;
function Ps(e, t, r, n) {
  var o = Mn(), a = mn().set(n, t);
  return o[r](a, e);
}
function gh(e, t, r) {
  if (Cn(e) && (t = e, e = void 0), e = e || "", t != null)
    return Ps(e, t, r, "month");
  var n, o = [];
  for (n = 0; n < 12; n++)
    o[n] = Ps(e, n, r, "month");
  return o;
}
function Bu(e, t, r, n) {
  typeof e == "boolean" ? (Cn(t) && (r = t, t = void 0), t = t || "") : (t = e, r = t, e = !1, Cn(t) && (r = t, t = void 0), t = t || "");
  var o = Mn(), a = e ? o._week.dow : 0, i, s = [];
  if (r != null)
    return Ps(t, (r + a) % 7, n, "day");
  for (i = 0; i < 7; i++)
    s[i] = Ps(t, (i + a) % 7, n, "day");
  return s;
}
function tx(e, t) {
  return gh(e, t, "months");
}
function rx(e, t) {
  return gh(e, t, "monthsShort");
}
function nx(e, t, r) {
  return Bu(e, t, r, "weekdays");
}
function ox(e, t, r) {
  return Bu(e, t, r, "weekdaysShort");
}
function ax(e, t, r) {
  return Bu(e, t, r, "weekdaysMin");
}
eo("en", {
  eras: [
    {
      since: "0001-01-01",
      until: 1 / 0,
      offset: 1,
      name: "Anno Domini",
      narrow: "AD",
      abbr: "AD"
    },
    {
      since: "0000-12-31",
      until: -1 / 0,
      offset: 1,
      name: "Before Christ",
      narrow: "BC",
      abbr: "BC"
    }
  ],
  dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
  ordinal: function(e) {
    var t = e % 10, r = We(e % 100 / 10) === 1 ? "th" : t === 1 ? "st" : t === 2 ? "nd" : t === 3 ? "rd" : "th";
    return e + r;
  }
});
ie.lang = Ar(
  "moment.lang is deprecated. Use moment.locale instead.",
  eo
);
ie.langData = Ar(
  "moment.langData is deprecated. Use moment.localeData instead.",
  Mn
);
var xn = Math.abs;
function ix() {
  var e = this._data;
  return this._milliseconds = xn(this._milliseconds), this._days = xn(this._days), this._months = xn(this._months), e.milliseconds = xn(e.milliseconds), e.seconds = xn(e.seconds), e.minutes = xn(e.minutes), e.hours = xn(e.hours), e.months = xn(e.months), e.years = xn(e.years), this;
}
function vh(e, t, r, n) {
  var o = Gr(t, r);
  return e._milliseconds += n * o._milliseconds, e._days += n * o._days, e._months += n * o._months, e._bubble();
}
function sx(e, t) {
  return vh(this, e, t, 1);
}
function lx(e, t) {
  return vh(this, e, t, -1);
}
function Sf(e) {
  return e < 0 ? Math.floor(e) : Math.ceil(e);
}
function cx() {
  var e = this._milliseconds, t = this._days, r = this._months, n = this._data, o, a, i, s, l;
  return e >= 0 && t >= 0 && r >= 0 || e <= 0 && t <= 0 && r <= 0 || (e += Sf(Rc(r) + t) * 864e5, t = 0, r = 0), n.milliseconds = e % 1e3, o = Cr(e / 1e3), n.seconds = o % 60, a = Cr(o / 60), n.minutes = a % 60, i = Cr(a / 60), n.hours = i % 24, t += Cr(i / 24), l = Cr(yh(t)), r += l, t -= Sf(Rc(l)), s = Cr(r / 12), r %= 12, n.days = t, n.months = r, n.years = s, this;
}
function yh(e) {
  return e * 4800 / 146097;
}
function Rc(e) {
  return e * 146097 / 4800;
}
function ux(e) {
  if (!this.isValid())
    return NaN;
  var t, r, n = this._milliseconds;
  if (e = Ir(e), e === "month" || e === "quarter" || e === "year")
    switch (t = this._days + n / 864e5, r = this._months + yh(t), e) {
      case "month":
        return r;
      case "quarter":
        return r / 3;
      case "year":
        return r / 12;
    }
  else
    switch (t = this._days + Math.round(Rc(this._months)), e) {
      case "week":
        return t / 7 + n / 6048e5;
      case "day":
        return t + n / 864e5;
      case "hour":
        return t * 24 + n / 36e5;
      case "minute":
        return t * 1440 + n / 6e4;
      case "second":
        return t * 86400 + n / 1e3;
      case "millisecond":
        return Math.floor(t * 864e5) + n;
      default:
        throw new Error("Unknown unit " + e);
    }
}
function Rn(e) {
  return function() {
    return this.as(e);
  };
}
var bh = Rn("ms"), dx = Rn("s"), fx = Rn("m"), px = Rn("h"), mx = Rn("d"), hx = Rn("w"), gx = Rn("M"), vx = Rn("Q"), yx = Rn("y"), bx = bh;
function wx() {
  return Gr(this);
}
function xx(e) {
  return e = Ir(e), this.isValid() ? this[e + "s"]() : NaN;
}
function Po(e) {
  return function() {
    return this.isValid() ? this._data[e] : NaN;
  };
}
var _x = Po("milliseconds"), Sx = Po("seconds"), Ex = Po("minutes"), Tx = Po("hours"), kx = Po("days"), Ox = Po("months"), Dx = Po("years");
function Nx() {
  return Cr(this.days() / 7);
}
var En = Math.round, Bo = {
  ss: 44,
  // a few seconds to seconds
  s: 45,
  // seconds to minute
  m: 45,
  // minutes to hour
  h: 22,
  // hours to day
  d: 26,
  // days to month/week
  w: null,
  // weeks to month
  M: 11
  // months to year
};
function Cx(e, t, r, n, o) {
  return o.relativeTime(t || 1, !!r, e, n);
}
function Px(e, t, r, n) {
  var o = Gr(e).abs(), a = En(o.as("s")), i = En(o.as("m")), s = En(o.as("h")), l = En(o.as("d")), u = En(o.as("M")), c = En(o.as("w")), p = En(o.as("y")), d = a <= r.ss && ["s", a] || a < r.s && ["ss", a] || i <= 1 && ["m"] || i < r.m && ["mm", i] || s <= 1 && ["h"] || s < r.h && ["hh", s] || l <= 1 && ["d"] || l < r.d && ["dd", l];
  return r.w != null && (d = d || c <= 1 && ["w"] || c < r.w && ["ww", c]), d = d || u <= 1 && ["M"] || u < r.M && ["MM", u] || p <= 1 && ["y"] || ["yy", p], d[2] = t, d[3] = +e > 0, d[4] = n, Cx.apply(null, d);
}
function Mx(e) {
  return e === void 0 ? En : typeof e == "function" ? (En = e, !0) : !1;
}
function Rx(e, t) {
  return Bo[e] === void 0 ? !1 : t === void 0 ? Bo[e] : (Bo[e] = t, e === "s" && (Bo.ss = t - 1), !0);
}
function Ax(e, t) {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var r = !1, n = Bo, o, a;
  return typeof e == "object" && (t = e, e = !1), typeof e == "boolean" && (r = e), typeof t == "object" && (n = Object.assign({}, Bo, t), t.s != null && t.ss == null && (n.ss = t.s - 1)), o = this.localeData(), a = Px(this, !r, n, o), r && (a = o.pastFuture(+this, a)), o.postformat(a);
}
var Ul = Math.abs;
function Ao(e) {
  return (e > 0) - (e < 0) || +e;
}
function al() {
  if (!this.isValid())
    return this.localeData().invalidDate();
  var e = Ul(this._milliseconds) / 1e3, t = Ul(this._days), r = Ul(this._months), n, o, a, i, s = this.asSeconds(), l, u, c, p;
  return s ? (n = Cr(e / 60), o = Cr(n / 60), e %= 60, n %= 60, a = Cr(r / 12), r %= 12, i = e ? e.toFixed(3).replace(/\.?0+$/, "") : "", l = s < 0 ? "-" : "", u = Ao(this._months) !== Ao(s) ? "-" : "", c = Ao(this._days) !== Ao(s) ? "-" : "", p = Ao(this._milliseconds) !== Ao(s) ? "-" : "", l + "P" + (a ? u + a + "Y" : "") + (r ? u + r + "M" : "") + (t ? c + t + "D" : "") + (o || n || e ? "T" : "") + (o ? p + o + "H" : "") + (n ? p + n + "M" : "") + (e ? p + i + "S" : "")) : "P0D";
}
var He = nl.prototype;
He.isValid = Ob;
He.abs = ix;
He.add = sx;
He.subtract = lx;
He.as = ux;
He.asMilliseconds = bh;
He.asSeconds = dx;
He.asMinutes = fx;
He.asHours = px;
He.asDays = mx;
He.asWeeks = hx;
He.asMonths = gx;
He.asQuarters = vx;
He.asYears = yx;
He.valueOf = bx;
He._bubble = cx;
He.clone = wx;
He.get = xx;
He.milliseconds = _x;
He.seconds = Sx;
He.minutes = Ex;
He.hours = Tx;
He.days = kx;
He.weeks = Nx;
He.months = Ox;
He.years = Dx;
He.humanize = Ax;
He.toISOString = al;
He.toString = al;
He.toJSON = al;
He.locale = ih;
He.localeData = lh;
He.toIsoString = Ar(
  "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
  al
);
He.lang = sh;
xe("X", 0, 0, "unix");
xe("x", 0, 0, "valueOf");
de("x", Js);
de("X", ty);
ut("X", function(e, t, r) {
  r._d = new Date(parseFloat(e) * 1e3);
});
ut("x", function(e, t, r) {
  r._d = new Date(We(e));
});
//! moment.js
ie.version = "2.30.1";
Iv(gt);
ie.fn = re;
ie.min = Sb;
ie.max = Eb;
ie.now = Tb;
ie.utc = mn;
ie.unix = Jw;
ie.months = tx;
ie.isDate = hi;
ie.locale = eo;
ie.invalid = Qs;
ie.duration = Gr;
ie.isMoment = Br;
ie.weekdays = nx;
ie.parseZone = ex;
ie.localeData = Mn;
ie.isDuration = bs;
ie.monthsShort = rx;
ie.weekdaysMin = ax;
ie.defineLocale = Ru;
ie.updateLocale = eb;
ie.locales = tb;
ie.weekdaysShort = ox;
ie.normalizeUnits = Ir;
ie.relativeTimeRounding = Mx;
ie.relativeTimeThreshold = Rx;
ie.calendarFormat = Kb;
ie.prototype = re;
ie.HTML5_FMT = {
  DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
  // <input type="datetime-local" />
  DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
  // <input type="datetime-local" step="1" />
  DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
  // <input type="datetime-local" step="0.001" />
  DATE: "YYYY-MM-DD",
  // <input type="date" />
  TIME: "HH:mm",
  // <input type="time" />
  TIME_SECONDS: "HH:mm:ss",
  // <input type="time" step="1" />
  TIME_MS: "HH:mm:ss.SSS",
  // <input type="time" step="0.001" />
  WEEK: "GGGG-[W]WW",
  // <input type="week" />
  MONTH: "YYYY-MM"
  // <input type="month" />
};
const Ac = (e, t) => {
  var n;
  const r = (n = e == null ? void 0 : e.entries) == null ? void 0 : n.map((o) => Za(t, o));
  return {
    ...e,
    entries: r
    // models,
  };
}, wh = (e, t) => {
  const r = Za(t, e == null ? void 0 : e.model);
  return {
    ...e,
    model: r
  };
}, xh = (e, t) => {
  if (!t) return e;
  const r = Za(t, e);
  return {
    ...e,
    ...r
  };
}, Za = (e, t) => {
  if (t == null) return t;
  const r = { ...t };
  for (const n in e) {
    const o = e[n], a = r[n];
    switch (o) {
      case Ee.DateTime: {
        typeof a == "string" ? r[n] = ie(a) : typeof a == "number" && (r[n] = ie.unix(a));
        break;
      }
      case Ee.Number: {
        if (typeof a == "string") {
          const i = parseFloat(a);
          isFinite(i) && !isNaN(i) && (r[n] = i);
        }
        break;
      }
      case Ee.BigNumber:
        a != null && (r[n] = mi(a));
        break;
      default:
        if (Array.isArray(a)) {
          r[n] = a.map((i) => Za(o, i));
          break;
        }
        typeof o == "object" && (r[n] = Za(o, a));
        break;
    }
  }
  return r;
}, dt = (e) => (t) => !e || typeof t.result == "boolean" ? t.result : "entries" in t.result || "models" in t.result ? Ac(t.result, e) : "model" in t.result ? Array.isArray(t.result.model) ? Ac(t.result, e) : wh(t.result, e) : xh(t.result, e), Ef = (e) => (t) => Ac(t.result, e), Y5 = (e) => (t) => wh(t.result, e), B5 = (e) => (t) => xh(t.result, e), Ix = (e) => ({
  token_type: e.token_type,
  access_token: e.access_token,
  refresh_token: e.refresh_token,
  expires_at: e.expires_at,
  refresh_expires_at: e.refresh_expires_at,
  expires_in: e.expires_in,
  refresh_expires_in: e.refresh_expires_in
});
/*! @license DOMPurify 3.1.6 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/3.1.6/LICENSE */
const {
  entries: _h,
  setPrototypeOf: Tf,
  isFrozen: Fx,
  getPrototypeOf: Lx,
  getOwnPropertyDescriptor: $x
} = Object;
let {
  freeze: rr,
  seal: Rr,
  create: Sh
} = Object, {
  apply: Ic,
  construct: Fc
} = typeof Reflect < "u" && Reflect;
rr || (rr = function(t) {
  return t;
});
Rr || (Rr = function(t) {
  return t;
});
Ic || (Ic = function(t, r, n) {
  return t.apply(r, n);
});
Fc || (Fc = function(t, r) {
  return new t(...r);
});
const as = vr(Array.prototype.forEach), kf = vr(Array.prototype.pop), Sa = vr(Array.prototype.push), xs = vr(String.prototype.toLowerCase), Hl = vr(String.prototype.toString), Of = vr(String.prototype.match), Ea = vr(String.prototype.replace), Wx = vr(String.prototype.indexOf), Yx = vr(String.prototype.trim), $r = vr(Object.prototype.hasOwnProperty), Xt = vr(RegExp.prototype.test), Ta = Bx(TypeError);
function vr(e) {
  return function(t) {
    for (var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), o = 1; o < r; o++)
      n[o - 1] = arguments[o];
    return Ic(e, t, n);
  };
}
function Bx(e) {
  return function() {
    for (var t = arguments.length, r = new Array(t), n = 0; n < t; n++)
      r[n] = arguments[n];
    return Fc(e, r);
  };
}
function Fe(e, t) {
  let r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : xs;
  Tf && Tf(e, null);
  let n = t.length;
  for (; n--; ) {
    let o = t[n];
    if (typeof o == "string") {
      const a = r(o);
      a !== o && (Fx(t) || (t[n] = a), o = a);
    }
    e[o] = !0;
  }
  return e;
}
function jx(e) {
  for (let t = 0; t < e.length; t++)
    $r(e, t) || (e[t] = null);
  return e;
}
function fo(e) {
  const t = Sh(null);
  for (const [r, n] of _h(e))
    $r(e, r) && (Array.isArray(n) ? t[r] = jx(n) : n && typeof n == "object" && n.constructor === Object ? t[r] = fo(n) : t[r] = n);
  return t;
}
function ka(e, t) {
  for (; e !== null; ) {
    const n = $x(e, t);
    if (n) {
      if (n.get)
        return vr(n.get);
      if (typeof n.value == "function")
        return vr(n.value);
    }
    e = Lx(e);
  }
  function r() {
    return null;
  }
  return r;
}
const Df = rr(["a", "abbr", "acronym", "address", "area", "article", "aside", "audio", "b", "bdi", "bdo", "big", "blink", "blockquote", "body", "br", "button", "canvas", "caption", "center", "cite", "code", "col", "colgroup", "content", "data", "datalist", "dd", "decorator", "del", "details", "dfn", "dialog", "dir", "div", "dl", "dt", "element", "em", "fieldset", "figcaption", "figure", "font", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "head", "header", "hgroup", "hr", "html", "i", "img", "input", "ins", "kbd", "label", "legend", "li", "main", "map", "mark", "marquee", "menu", "menuitem", "meter", "nav", "nobr", "ol", "optgroup", "option", "output", "p", "picture", "pre", "progress", "q", "rp", "rt", "ruby", "s", "samp", "section", "select", "shadow", "small", "source", "spacer", "span", "strike", "strong", "style", "sub", "summary", "sup", "table", "tbody", "td", "template", "textarea", "tfoot", "th", "thead", "time", "tr", "track", "tt", "u", "ul", "var", "video", "wbr"]), Vl = rr(["svg", "a", "altglyph", "altglyphdef", "altglyphitem", "animatecolor", "animatemotion", "animatetransform", "circle", "clippath", "defs", "desc", "ellipse", "filter", "font", "g", "glyph", "glyphref", "hkern", "image", "line", "lineargradient", "marker", "mask", "metadata", "mpath", "path", "pattern", "polygon", "polyline", "radialgradient", "rect", "stop", "style", "switch", "symbol", "text", "textpath", "title", "tref", "tspan", "view", "vkern"]), zl = rr(["feBlend", "feColorMatrix", "feComponentTransfer", "feComposite", "feConvolveMatrix", "feDiffuseLighting", "feDisplacementMap", "feDistantLight", "feDropShadow", "feFlood", "feFuncA", "feFuncB", "feFuncG", "feFuncR", "feGaussianBlur", "feImage", "feMerge", "feMergeNode", "feMorphology", "feOffset", "fePointLight", "feSpecularLighting", "feSpotLight", "feTile", "feTurbulence"]), Ux = rr(["animate", "color-profile", "cursor", "discard", "font-face", "font-face-format", "font-face-name", "font-face-src", "font-face-uri", "foreignobject", "hatch", "hatchpath", "mesh", "meshgradient", "meshpatch", "meshrow", "missing-glyph", "script", "set", "solidcolor", "unknown", "use"]), ql = rr(["math", "menclose", "merror", "mfenced", "mfrac", "mglyph", "mi", "mlabeledtr", "mmultiscripts", "mn", "mo", "mover", "mpadded", "mphantom", "mroot", "mrow", "ms", "mspace", "msqrt", "mstyle", "msub", "msup", "msubsup", "mtable", "mtd", "mtext", "mtr", "munder", "munderover", "mprescripts"]), Hx = rr(["maction", "maligngroup", "malignmark", "mlongdiv", "mscarries", "mscarry", "msgroup", "mstack", "msline", "msrow", "semantics", "annotation", "annotation-xml", "mprescripts", "none"]), Nf = rr(["#text"]), Cf = rr(["accept", "action", "align", "alt", "autocapitalize", "autocomplete", "autopictureinpicture", "autoplay", "background", "bgcolor", "border", "capture", "cellpadding", "cellspacing", "checked", "cite", "class", "clear", "color", "cols", "colspan", "controls", "controlslist", "coords", "crossorigin", "datetime", "decoding", "default", "dir", "disabled", "disablepictureinpicture", "disableremoteplayback", "download", "draggable", "enctype", "enterkeyhint", "face", "for", "headers", "height", "hidden", "high", "href", "hreflang", "id", "inputmode", "integrity", "ismap", "kind", "label", "lang", "list", "loading", "loop", "low", "max", "maxlength", "media", "method", "min", "minlength", "multiple", "muted", "name", "nonce", "noshade", "novalidate", "nowrap", "open", "optimum", "pattern", "placeholder", "playsinline", "popover", "popovertarget", "popovertargetaction", "poster", "preload", "pubdate", "radiogroup", "readonly", "rel", "required", "rev", "reversed", "role", "rows", "rowspan", "spellcheck", "scope", "selected", "shape", "size", "sizes", "span", "srclang", "start", "src", "srcset", "step", "style", "summary", "tabindex", "title", "translate", "type", "usemap", "valign", "value", "width", "wrap", "xmlns", "slot"]), Gl = rr(["accent-height", "accumulate", "additive", "alignment-baseline", "ascent", "attributename", "attributetype", "azimuth", "basefrequency", "baseline-shift", "begin", "bias", "by", "class", "clip", "clippathunits", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cx", "cy", "d", "dx", "dy", "diffuseconstant", "direction", "display", "divisor", "dur", "edgemode", "elevation", "end", "fill", "fill-opacity", "fill-rule", "filter", "filterunits", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "fx", "fy", "g1", "g2", "glyph-name", "glyphref", "gradientunits", "gradienttransform", "height", "href", "id", "image-rendering", "in", "in2", "k", "k1", "k2", "k3", "k4", "kerning", "keypoints", "keysplines", "keytimes", "lang", "lengthadjust", "letter-spacing", "kernelmatrix", "kernelunitlength", "lighting-color", "local", "marker-end", "marker-mid", "marker-start", "markerheight", "markerunits", "markerwidth", "maskcontentunits", "maskunits", "max", "mask", "media", "method", "mode", "min", "name", "numoctaves", "offset", "operator", "opacity", "order", "orient", "orientation", "origin", "overflow", "paint-order", "path", "pathlength", "patterncontentunits", "patterntransform", "patternunits", "points", "preservealpha", "preserveaspectratio", "primitiveunits", "r", "rx", "ry", "radius", "refx", "refy", "repeatcount", "repeatdur", "restart", "result", "rotate", "scale", "seed", "shape-rendering", "specularconstant", "specularexponent", "spreadmethod", "startoffset", "stddeviation", "stitchtiles", "stop-color", "stop-opacity", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke", "stroke-width", "style", "surfacescale", "systemlanguage", "tabindex", "targetx", "targety", "transform", "transform-origin", "text-anchor", "text-decoration", "text-rendering", "textlength", "type", "u1", "u2", "unicode", "values", "viewbox", "visibility", "version", "vert-adv-y", "vert-origin-x", "vert-origin-y", "width", "word-spacing", "wrap", "writing-mode", "xchannelselector", "ychannelselector", "x", "x1", "x2", "xmlns", "y", "y1", "y2", "z", "zoomandpan"]), Pf = rr(["accent", "accentunder", "align", "bevelled", "close", "columnsalign", "columnlines", "columnspan", "denomalign", "depth", "dir", "display", "displaystyle", "encoding", "fence", "frame", "height", "href", "id", "largeop", "length", "linethickness", "lspace", "lquote", "mathbackground", "mathcolor", "mathsize", "mathvariant", "maxsize", "minsize", "movablelimits", "notation", "numalign", "open", "rowalign", "rowlines", "rowspacing", "rowspan", "rspace", "rquote", "scriptlevel", "scriptminsize", "scriptsizemultiplier", "selection", "separator", "separators", "stretchy", "subscriptshift", "supscriptshift", "symmetric", "voffset", "width", "xmlns"]), is = rr(["xlink:href", "xml:id", "xlink:title", "xml:space", "xmlns:xlink"]), Vx = Rr(/\{\{[\w\W]*|[\w\W]*\}\}/gm), zx = Rr(/<%[\w\W]*|[\w\W]*%>/gm), qx = Rr(/\${[\w\W]*}/gm), Gx = Rr(/^data-[\-\w.\u00B7-\uFFFF]/), Qx = Rr(/^aria-[\-\w]+$/), Eh = Rr(
  /^(?:(?:(?:f|ht)tps?|mailto|tel|callto|sms|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i
  // eslint-disable-line no-useless-escape
), Kx = Rr(/^(?:\w+script|data):/i), Xx = Rr(
  /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g
  // eslint-disable-line no-control-regex
), Th = Rr(/^html$/i), Zx = Rr(/^[a-z][.\w]*(-[.\w]+)+$/i);
var Mf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  MUSTACHE_EXPR: Vx,
  ERB_EXPR: zx,
  TMPLIT_EXPR: qx,
  DATA_ATTR: Gx,
  ARIA_ATTR: Qx,
  IS_ALLOWED_URI: Eh,
  IS_SCRIPT_OR_DATA: Kx,
  ATTR_WHITESPACE: Xx,
  DOCTYPE_NAME: Th,
  CUSTOM_ELEMENT: Zx
});
const Oa = {
  element: 1,
  attribute: 2,
  text: 3,
  cdataSection: 4,
  entityReference: 5,
  // Deprecated
  entityNode: 6,
  // Deprecated
  progressingInstruction: 7,
  comment: 8,
  document: 9,
  documentType: 10,
  documentFragment: 11,
  notation: 12
  // Deprecated
}, Jx = function() {
  return typeof window > "u" ? null : window;
}, e_ = function(t, r) {
  if (typeof t != "object" || typeof t.createPolicy != "function")
    return null;
  let n = null;
  const o = "data-tt-policy-suffix";
  r && r.hasAttribute(o) && (n = r.getAttribute(o));
  const a = "dompurify" + (n ? "#" + n : "");
  try {
    return t.createPolicy(a, {
      createHTML(i) {
        return i;
      },
      createScriptURL(i) {
        return i;
      }
    });
  } catch {
    return console.warn("TrustedTypes policy " + a + " could not be created."), null;
  }
};
function kh() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Jx();
  const t = (he) => kh(he);
  if (t.version = "3.1.6", t.removed = [], !e || !e.document || e.document.nodeType !== Oa.document)
    return t.isSupported = !1, t;
  let {
    document: r
  } = e;
  const n = r, o = n.currentScript, {
    DocumentFragment: a,
    HTMLTemplateElement: i,
    Node: s,
    Element: l,
    NodeFilter: u,
    NamedNodeMap: c = e.NamedNodeMap || e.MozNamedAttrMap,
    HTMLFormElement: p,
    DOMParser: d,
    trustedTypes: f
  } = e, m = l.prototype, v = ka(m, "cloneNode"), h = ka(m, "remove"), _ = ka(m, "nextSibling"), g = ka(m, "childNodes"), b = ka(m, "parentNode");
  if (typeof i == "function") {
    const he = r.createElement("template");
    he.content && he.content.ownerDocument && (r = he.content.ownerDocument);
  }
  let x, E = "";
  const {
    implementation: O,
    createNodeIterator: P,
    createDocumentFragment: y,
    getElementsByTagName: w
  } = r, {
    importNode: S
  } = n;
  let k = {};
  t.isSupported = typeof _h == "function" && typeof b == "function" && O && O.createHTMLDocument !== void 0;
  const {
    MUSTACHE_EXPR: T,
    ERB_EXPR: R,
    TMPLIT_EXPR: I,
    DATA_ATTR: C,
    ARIA_ATTR: A,
    IS_SCRIPT_OR_DATA: D,
    ATTR_WHITESPACE: N,
    CUSTOM_ELEMENT: M
  } = Mf;
  let {
    IS_ALLOWED_URI: W
  } = Mf, B = null;
  const j = Fe({}, [...Df, ...Vl, ...zl, ...ql, ...Nf]);
  let q = null;
  const se = Fe({}, [...Cf, ...Gl, ...Pf, ...is]);
  let te = Object.seal(Sh(null, {
    tagNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    attributeNameCheck: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: null
    },
    allowCustomizedBuiltInElements: {
      writable: !0,
      configurable: !1,
      enumerable: !0,
      value: !1
    }
  })), le = null, ke = null, at = !0, _t = !0, Pt = !1, pe = !0, Z = !1, Pe = !0, J = !1, Ne = !1, St = !1, Et = !1, Ft = !1, nr = !1, Xr = !0, vn = !1;
  const yn = "user-content-";
  let Zr = !0, xr = !1, Mt = {}, Kt = null;
  const bn = Fe({}, ["annotation-xml", "audio", "colgroup", "desc", "foreignobject", "head", "iframe", "math", "mi", "mn", "mo", "ms", "mtext", "noembed", "noframes", "noscript", "plaintext", "script", "style", "svg", "template", "thead", "title", "video", "xmp"]);
  let _r = null;
  const Ln = Fe({}, ["audio", "video", "img", "source", "image", "track"]);
  let $ = null;
  const K = Fe({}, ["alt", "class", "for", "id", "label", "name", "pattern", "placeholder", "role", "summary", "title", "value", "style", "xmlns"]), z = "http://www.w3.org/1998/Math/MathML", be = "http://www.w3.org/2000/svg", Ce = "http://www.w3.org/1999/xhtml";
  let ve = Ce, we = !1, Se = null;
  const Je = Fe({}, [z, be, Ce], Hl);
  let et = null;
  const Lt = ["application/xhtml+xml", "text/html"], $n = "text/html";
  let mt = null, Sr = null;
  const Jr = r.createElement("form"), io = function(Y) {
    return Y instanceof RegExp || Y instanceof Function;
  }, Wn = function() {
    let Y = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!(Sr && Sr === Y)) {
      if ((!Y || typeof Y != "object") && (Y = {}), Y = fo(Y), et = // eslint-disable-next-line unicorn/prefer-includes
      Lt.indexOf(Y.PARSER_MEDIA_TYPE) === -1 ? $n : Y.PARSER_MEDIA_TYPE, mt = et === "application/xhtml+xml" ? Hl : xs, B = $r(Y, "ALLOWED_TAGS") ? Fe({}, Y.ALLOWED_TAGS, mt) : j, q = $r(Y, "ALLOWED_ATTR") ? Fe({}, Y.ALLOWED_ATTR, mt) : se, Se = $r(Y, "ALLOWED_NAMESPACES") ? Fe({}, Y.ALLOWED_NAMESPACES, Hl) : Je, $ = $r(Y, "ADD_URI_SAFE_ATTR") ? Fe(
        fo(K),
        // eslint-disable-line indent
        Y.ADD_URI_SAFE_ATTR,
        // eslint-disable-line indent
        mt
        // eslint-disable-line indent
      ) : K, _r = $r(Y, "ADD_DATA_URI_TAGS") ? Fe(
        fo(Ln),
        // eslint-disable-line indent
        Y.ADD_DATA_URI_TAGS,
        // eslint-disable-line indent
        mt
        // eslint-disable-line indent
      ) : Ln, Kt = $r(Y, "FORBID_CONTENTS") ? Fe({}, Y.FORBID_CONTENTS, mt) : bn, le = $r(Y, "FORBID_TAGS") ? Fe({}, Y.FORBID_TAGS, mt) : {}, ke = $r(Y, "FORBID_ATTR") ? Fe({}, Y.FORBID_ATTR, mt) : {}, Mt = $r(Y, "USE_PROFILES") ? Y.USE_PROFILES : !1, at = Y.ALLOW_ARIA_ATTR !== !1, _t = Y.ALLOW_DATA_ATTR !== !1, Pt = Y.ALLOW_UNKNOWN_PROTOCOLS || !1, pe = Y.ALLOW_SELF_CLOSE_IN_ATTR !== !1, Z = Y.SAFE_FOR_TEMPLATES || !1, Pe = Y.SAFE_FOR_XML !== !1, J = Y.WHOLE_DOCUMENT || !1, Et = Y.RETURN_DOM || !1, Ft = Y.RETURN_DOM_FRAGMENT || !1, nr = Y.RETURN_TRUSTED_TYPE || !1, St = Y.FORCE_BODY || !1, Xr = Y.SANITIZE_DOM !== !1, vn = Y.SANITIZE_NAMED_PROPS || !1, Zr = Y.KEEP_CONTENT !== !1, xr = Y.IN_PLACE || !1, W = Y.ALLOWED_URI_REGEXP || Eh, ve = Y.NAMESPACE || Ce, te = Y.CUSTOM_ELEMENT_HANDLING || {}, Y.CUSTOM_ELEMENT_HANDLING && io(Y.CUSTOM_ELEMENT_HANDLING.tagNameCheck) && (te.tagNameCheck = Y.CUSTOM_ELEMENT_HANDLING.tagNameCheck), Y.CUSTOM_ELEMENT_HANDLING && io(Y.CUSTOM_ELEMENT_HANDLING.attributeNameCheck) && (te.attributeNameCheck = Y.CUSTOM_ELEMENT_HANDLING.attributeNameCheck), Y.CUSTOM_ELEMENT_HANDLING && typeof Y.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements == "boolean" && (te.allowCustomizedBuiltInElements = Y.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements), Z && (_t = !1), Ft && (Et = !0), Mt && (B = Fe({}, Nf), q = [], Mt.html === !0 && (Fe(B, Df), Fe(q, Cf)), Mt.svg === !0 && (Fe(B, Vl), Fe(q, Gl), Fe(q, is)), Mt.svgFilters === !0 && (Fe(B, zl), Fe(q, Gl), Fe(q, is)), Mt.mathMl === !0 && (Fe(B, ql), Fe(q, Pf), Fe(q, is))), Y.ADD_TAGS && (B === j && (B = fo(B)), Fe(B, Y.ADD_TAGS, mt)), Y.ADD_ATTR && (q === se && (q = fo(q)), Fe(q, Y.ADD_ATTR, mt)), Y.ADD_URI_SAFE_ATTR && Fe($, Y.ADD_URI_SAFE_ATTR, mt), Y.FORBID_CONTENTS && (Kt === bn && (Kt = fo(Kt)), Fe(Kt, Y.FORBID_CONTENTS, mt)), Zr && (B["#text"] = !0), J && Fe(B, ["html", "head", "body"]), B.table && (Fe(B, ["tbody"]), delete le.tbody), Y.TRUSTED_TYPES_POLICY) {
        if (typeof Y.TRUSTED_TYPES_POLICY.createHTML != "function")
          throw Ta('TRUSTED_TYPES_POLICY configuration option must provide a "createHTML" hook.');
        if (typeof Y.TRUSTED_TYPES_POLICY.createScriptURL != "function")
          throw Ta('TRUSTED_TYPES_POLICY configuration option must provide a "createScriptURL" hook.');
        x = Y.TRUSTED_TYPES_POLICY, E = x.createHTML("");
      } else
        x === void 0 && (x = e_(f, o)), x !== null && typeof E == "string" && (E = x.createHTML(""));
      rr && rr(Y), Sr = Y;
    }
  }, ga = Fe({}, ["mi", "mo", "mn", "ms", "mtext"]), zi = Fe({}, ["foreignobject", "annotation-xml"]), qi = Fe({}, ["title", "style", "font", "a", "script"]), Gi = Fe({}, [...Vl, ...zl, ...Ux]), va = Fe({}, [...ql, ...Hx]), Rl = function(Y) {
    let ne = b(Y);
    (!ne || !ne.tagName) && (ne = {
      namespaceURI: ve,
      tagName: "template"
    });
    const fe = xs(Y.tagName), lt = xs(ne.tagName);
    return Se[Y.namespaceURI] ? Y.namespaceURI === be ? ne.namespaceURI === Ce ? fe === "svg" : ne.namespaceURI === z ? fe === "svg" && (lt === "annotation-xml" || ga[lt]) : !!Gi[fe] : Y.namespaceURI === z ? ne.namespaceURI === Ce ? fe === "math" : ne.namespaceURI === be ? fe === "math" && zi[lt] : !!va[fe] : Y.namespaceURI === Ce ? ne.namespaceURI === be && !zi[lt] || ne.namespaceURI === z && !ga[lt] ? !1 : !va[fe] && (qi[fe] || !Gi[fe]) : !!(et === "application/xhtml+xml" && Se[Y.namespaceURI]) : !1;
  }, Er = function(Y) {
    Sa(t.removed, {
      element: Y
    });
    try {
      b(Y).removeChild(Y);
    } catch {
      h(Y);
    }
  }, Ro = function(Y, ne) {
    try {
      Sa(t.removed, {
        attribute: ne.getAttributeNode(Y),
        from: ne
      });
    } catch {
      Sa(t.removed, {
        attribute: null,
        from: ne
      });
    }
    if (ne.removeAttribute(Y), Y === "is" && !q[Y])
      if (Et || Ft)
        try {
          Er(ne);
        } catch {
        }
      else
        try {
          ne.setAttribute(Y, "");
        } catch {
        }
  }, ya = function(Y) {
    let ne = null, fe = null;
    if (St)
      Y = "<remove></remove>" + Y;
    else {
      const Rt = Of(Y, /^[\r\n\t ]+/);
      fe = Rt && Rt[0];
    }
    et === "application/xhtml+xml" && ve === Ce && (Y = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + Y + "</body></html>");
    const lt = x ? x.createHTML(Y) : Y;
    if (ve === Ce)
      try {
        ne = new d().parseFromString(lt, et);
      } catch {
      }
    if (!ne || !ne.documentElement) {
      ne = O.createDocument(ve, "template", null);
      try {
        ne.documentElement.innerHTML = we ? E : lt;
      } catch {
      }
    }
    const $t = ne.body || ne.documentElement;
    return Y && fe && $t.insertBefore(r.createTextNode(fe), $t.childNodes[0] || null), ve === Ce ? w.call(ne, J ? "html" : "body")[0] : J ? ne.documentElement : $t;
  }, Qi = function(Y) {
    return P.call(
      Y.ownerDocument || Y,
      Y,
      // eslint-disable-next-line no-bitwise
      u.SHOW_ELEMENT | u.SHOW_COMMENT | u.SHOW_TEXT | u.SHOW_PROCESSING_INSTRUCTION | u.SHOW_CDATA_SECTION,
      null
    );
  }, Ki = function(Y) {
    return Y instanceof p && (typeof Y.nodeName != "string" || typeof Y.textContent != "string" || typeof Y.removeChild != "function" || !(Y.attributes instanceof c) || typeof Y.removeAttribute != "function" || typeof Y.setAttribute != "function" || typeof Y.namespaceURI != "string" || typeof Y.insertBefore != "function" || typeof Y.hasChildNodes != "function");
  }, Xi = function(Y) {
    return typeof s == "function" && Y instanceof s;
  }, Fr = function(Y, ne, fe) {
    k[Y] && as(k[Y], (lt) => {
      lt.call(t, ne, fe, Sr);
    });
  }, ba = function(Y) {
    let ne = null;
    if (Fr("beforeSanitizeElements", Y, null), Ki(Y))
      return Er(Y), !0;
    const fe = mt(Y.nodeName);
    if (Fr("uponSanitizeElement", Y, {
      tagName: fe,
      allowedTags: B
    }), Y.hasChildNodes() && !Xi(Y.firstElementChild) && Xt(/<[/\w]/g, Y.innerHTML) && Xt(/<[/\w]/g, Y.textContent) || Y.nodeType === Oa.progressingInstruction || Pe && Y.nodeType === Oa.comment && Xt(/<[/\w]/g, Y.data))
      return Er(Y), !0;
    if (!B[fe] || le[fe]) {
      if (!le[fe] && wa(fe) && (te.tagNameCheck instanceof RegExp && Xt(te.tagNameCheck, fe) || te.tagNameCheck instanceof Function && te.tagNameCheck(fe)))
        return !1;
      if (Zr && !Kt[fe]) {
        const lt = b(Y) || Y.parentNode, $t = g(Y) || Y.childNodes;
        if ($t && lt) {
          const Rt = $t.length;
          for (let Ut = Rt - 1; Ut >= 0; --Ut) {
            const F = v($t[Ut], !0);
            F.__removalCount = (Y.__removalCount || 0) + 1, lt.insertBefore(F, _(Y));
          }
        }
      }
      return Er(Y), !0;
    }
    return Y instanceof l && !Rl(Y) || (fe === "noscript" || fe === "noembed" || fe === "noframes") && Xt(/<\/no(script|embed|frames)/i, Y.innerHTML) ? (Er(Y), !0) : (Z && Y.nodeType === Oa.text && (ne = Y.textContent, as([T, R, I], (lt) => {
      ne = Ea(ne, lt, " ");
    }), Y.textContent !== ne && (Sa(t.removed, {
      element: Y.cloneNode()
    }), Y.textContent = ne)), Fr("afterSanitizeElements", Y, null), !1);
  }, Zi = function(Y, ne, fe) {
    if (Xr && (ne === "id" || ne === "name") && (fe in r || fe in Jr))
      return !1;
    if (!(_t && !ke[ne] && Xt(C, ne))) {
      if (!(at && Xt(A, ne))) {
        if (!q[ne] || ke[ne]) {
          if (
            // First condition does a very basic check if a) it's basically a valid custom element tagname AND
            // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
            !(wa(Y) && (te.tagNameCheck instanceof RegExp && Xt(te.tagNameCheck, Y) || te.tagNameCheck instanceof Function && te.tagNameCheck(Y)) && (te.attributeNameCheck instanceof RegExp && Xt(te.attributeNameCheck, ne) || te.attributeNameCheck instanceof Function && te.attributeNameCheck(ne)) || // Alternative, second condition checks if it's an `is`-attribute, AND
            // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
            ne === "is" && te.allowCustomizedBuiltInElements && (te.tagNameCheck instanceof RegExp && Xt(te.tagNameCheck, fe) || te.tagNameCheck instanceof Function && te.tagNameCheck(fe)))
          ) return !1;
        } else if (!$[ne]) {
          if (!Xt(W, Ea(fe, N, ""))) {
            if (!((ne === "src" || ne === "xlink:href" || ne === "href") && Y !== "script" && Wx(fe, "data:") === 0 && _r[Y])) {
              if (!(Pt && !Xt(D, Ea(fe, N, "")))) {
                if (fe)
                  return !1;
              }
            }
          }
        }
      }
    }
    return !0;
  }, wa = function(Y) {
    return Y !== "annotation-xml" && Of(Y, M);
  }, Ji = function(Y) {
    Fr("beforeSanitizeAttributes", Y, null);
    const {
      attributes: ne
    } = Y;
    if (!ne)
      return;
    const fe = {
      attrName: "",
      attrValue: "",
      keepAttr: !0,
      allowedAttributes: q
    };
    let lt = ne.length;
    for (; lt--; ) {
      const $t = ne[lt], {
        name: Rt,
        namespaceURI: Ut,
        value: F
      } = $t, H = mt(Rt);
      let U = Rt === "value" ? F : Yx(F);
      if (fe.attrName = H, fe.attrValue = U, fe.keepAttr = !0, fe.forceKeepAttr = void 0, Fr("uponSanitizeAttribute", Y, fe), U = fe.attrValue, Pe && Xt(/((--!?|])>)|<\/(style|title)/i, U)) {
        Ro(Rt, Y);
        continue;
      }
      if (fe.forceKeepAttr || (Ro(Rt, Y), !fe.keepAttr))
        continue;
      if (!pe && Xt(/\/>/i, U)) {
        Ro(Rt, Y);
        continue;
      }
      Z && as([T, R, I], (_e) => {
        U = Ea(U, _e, " ");
      });
      const X = mt(Y.nodeName);
      if (Zi(X, H, U)) {
        if (vn && (H === "id" || H === "name") && (Ro(Rt, Y), U = yn + U), x && typeof f == "object" && typeof f.getAttributeType == "function" && !Ut)
          switch (f.getAttributeType(X, H)) {
            case "TrustedHTML": {
              U = x.createHTML(U);
              break;
            }
            case "TrustedScriptURL": {
              U = x.createScriptURL(U);
              break;
            }
          }
        try {
          Ut ? Y.setAttributeNS(Ut, Rt, U) : Y.setAttribute(Rt, U), Ki(Y) ? Er(Y) : kf(t.removed);
        } catch {
        }
      }
    }
    Fr("afterSanitizeAttributes", Y, null);
  }, Al = function he(Y) {
    let ne = null;
    const fe = Qi(Y);
    for (Fr("beforeSanitizeShadowDOM", Y, null); ne = fe.nextNode(); )
      Fr("uponSanitizeShadowNode", ne, null), !ba(ne) && (ne.content instanceof a && he(ne.content), Ji(ne));
    Fr("afterSanitizeShadowDOM", Y, null);
  };
  return t.sanitize = function(he) {
    let Y = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, ne = null, fe = null, lt = null, $t = null;
    if (we = !he, we && (he = "<!-->"), typeof he != "string" && !Xi(he))
      if (typeof he.toString == "function") {
        if (he = he.toString(), typeof he != "string")
          throw Ta("dirty is not a string, aborting");
      } else
        throw Ta("toString is not a function");
    if (!t.isSupported)
      return he;
    if (Ne || Wn(Y), t.removed = [], typeof he == "string" && (xr = !1), xr) {
      if (he.nodeName) {
        const F = mt(he.nodeName);
        if (!B[F] || le[F])
          throw Ta("root node is forbidden and cannot be sanitized in-place");
      }
    } else if (he instanceof s)
      ne = ya("<!---->"), fe = ne.ownerDocument.importNode(he, !0), fe.nodeType === Oa.element && fe.nodeName === "BODY" || fe.nodeName === "HTML" ? ne = fe : ne.appendChild(fe);
    else {
      if (!Et && !Z && !J && // eslint-disable-next-line unicorn/prefer-includes
      he.indexOf("<") === -1)
        return x && nr ? x.createHTML(he) : he;
      if (ne = ya(he), !ne)
        return Et ? null : nr ? E : "";
    }
    ne && St && Er(ne.firstChild);
    const Rt = Qi(xr ? he : ne);
    for (; lt = Rt.nextNode(); )
      ba(lt) || (lt.content instanceof a && Al(lt.content), Ji(lt));
    if (xr)
      return he;
    if (Et) {
      if (Ft)
        for ($t = y.call(ne.ownerDocument); ne.firstChild; )
          $t.appendChild(ne.firstChild);
      else
        $t = ne;
      return (q.shadowroot || q.shadowrootmode) && ($t = S.call(n, $t, !0)), $t;
    }
    let Ut = J ? ne.outerHTML : ne.innerHTML;
    return J && B["!doctype"] && ne.ownerDocument && ne.ownerDocument.doctype && ne.ownerDocument.doctype.name && Xt(Th, ne.ownerDocument.doctype.name) && (Ut = "<!DOCTYPE " + ne.ownerDocument.doctype.name + `>
` + Ut), Z && as([T, R, I], (F) => {
      Ut = Ea(Ut, F, " ");
    }), x && nr ? x.createHTML(Ut) : Ut;
  }, t.setConfig = function() {
    let he = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    Wn(he), Ne = !0;
  }, t.clearConfig = function() {
    Sr = null, Ne = !1;
  }, t.isValidAttribute = function(he, Y, ne) {
    Sr || Wn({});
    const fe = mt(he), lt = mt(Y);
    return Zi(fe, lt, ne);
  }, t.addHook = function(he, Y) {
    typeof Y == "function" && (k[he] = k[he] || [], Sa(k[he], Y));
  }, t.removeHook = function(he) {
    if (k[he])
      return kf(k[he]);
  }, t.removeHooks = function(he) {
    k[he] && (k[he] = []);
  }, t.removeAllHooks = function() {
    k = {};
  }, t;
}
var t_ = kh();
function r_(e) {
  return t_.sanitize(e);
}
const n_ = (e) => /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/.test(e), sa = (e, t) => {
  const r = (u) => u.split(".").map(Number), [n, o, a] = r(e), [i, s, l] = r(t);
  return n > i ? 1 : n < i ? -1 : o > s ? 1 : o < s ? -1 : a > l ? 1 : a < l ? -1 : 0;
}, o_ = (e, t) => sa(e, t) === 1, a_ = (e, t) => sa(e, t) >= 0, i_ = (e, t) => sa(e, t) === -1, s_ = (e, t) => sa(e, t) <= 0, l_ = (e, t) => sa(e, t) === 0, c_ = {
  validate: n_,
  compare: sa,
  gt: o_,
  gte: a_,
  lt: i_,
  lte: s_,
  eq: l_
}, u_ = c_, d_ = (e, t) => JSON.stringify({
  value: e,
  version: t
}), Rf = (e) => ({
  setItem: (t, r, n) => {
    n && (r = d_(r, n)), e.setItem(t, r);
  },
  getItem: (t) => {
    const r = e.getItem(t);
    if (!r)
      return null;
    try {
      const n = JSON.parse(r);
      return "version" in n ? n.value : r;
    } catch {
      return r;
    }
  },
  getVersion: (t) => {
    const r = e.getItem(t);
    if (!r)
      return null;
    try {
      const n = JSON.parse(r);
      return "version" in n ? n.version : null;
    } catch {
      return null;
    }
  },
  invalidate: (t, r) => {
    const n = Oh.local.getVersion(t);
    if (n)
      u_.eq(n, r) || e.removeItem(t);
    else
      return !1;
  }
}), Oh = {
  local: Rf(localStorage),
  session: Rf(sessionStorage)
}, j5 = Oh, U5 = (e) => e.charAt(0).toUpperCase() + e.slice(1), H5 = (e) => {
  let t = e;
  return t.charAt(t.length - 1) === "/" && (t = t.slice(0, -1)), t = t.replace(/\/\//g, "/"), t;
}, ju = "-";
function f_(e) {
  const t = m_(e), {
    conflictingClassGroups: r,
    conflictingClassGroupModifiers: n
  } = e;
  function o(i) {
    const s = i.split(ju);
    return s[0] === "" && s.length !== 1 && s.shift(), Dh(s, t) || p_(i);
  }
  function a(i, s) {
    const l = r[i] || [];
    return s && n[i] ? [...l, ...n[i]] : l;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function Dh(e, t) {
  var i;
  if (e.length === 0)
    return t.classGroupId;
  const r = e[0], n = t.nextPart.get(r), o = n ? Dh(e.slice(1), n) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(ju);
  return (i = t.validators.find(({
    validator: s
  }) => s(a))) == null ? void 0 : i.classGroupId;
}
const Af = /^\[(.+)\]$/;
function p_(e) {
  if (Af.test(e)) {
    const t = Af.exec(e)[1], r = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (r)
      return "arbitrary.." + r;
  }
}
function m_(e) {
  const {
    theme: t,
    prefix: r
  } = e, n = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  return g_(Object.entries(e.classGroups), r).forEach(([a, i]) => {
    Lc(i, n, a, t);
  }), n;
}
function Lc(e, t, r, n) {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : If(t, o);
      a.classGroupId = r;
      return;
    }
    if (typeof o == "function") {
      if (h_(o)) {
        Lc(o(n), t, r, n);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: r
      });
      return;
    }
    Object.entries(o).forEach(([a, i]) => {
      Lc(i, If(t, a), r, n);
    });
  });
}
function If(e, t) {
  let r = e;
  return t.split(ju).forEach((n) => {
    r.nextPart.has(n) || r.nextPart.set(n, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), r = r.nextPart.get(n);
  }), r;
}
function h_(e) {
  return e.isThemeGetter;
}
function g_(e, t) {
  return t ? e.map(([r, n]) => {
    const o = n.map((a) => typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(([i, s]) => [t + i, s])) : a);
    return [r, o];
  }) : e;
}
function v_(e) {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, r = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map();
  function o(a, i) {
    r.set(a, i), t++, t > e && (t = 0, n = r, r = /* @__PURE__ */ new Map());
  }
  return {
    get(a) {
      let i = r.get(a);
      if (i !== void 0)
        return i;
      if ((i = n.get(a)) !== void 0)
        return o(a, i), i;
    },
    set(a, i) {
      r.has(a) ? r.set(a, i) : o(a, i);
    }
  };
}
const Nh = "!";
function y_(e) {
  const t = e.separator, r = t.length === 1, n = t[0], o = t.length;
  return function(i) {
    const s = [];
    let l = 0, u = 0, c;
    for (let v = 0; v < i.length; v++) {
      let h = i[v];
      if (l === 0) {
        if (h === n && (r || i.slice(v, v + o) === t)) {
          s.push(i.slice(u, v)), u = v + o;
          continue;
        }
        if (h === "/") {
          c = v;
          continue;
        }
      }
      h === "[" ? l++ : h === "]" && l--;
    }
    const p = s.length === 0 ? i : i.substring(u), d = p.startsWith(Nh), f = d ? p.substring(1) : p, m = c && c > u ? c - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: d,
      baseClassName: f,
      maybePostfixModifierPosition: m
    };
  };
}
function b_(e) {
  if (e.length <= 1)
    return e;
  const t = [];
  let r = [];
  return e.forEach((n) => {
    n[0] === "[" ? (t.push(...r.sort(), n), r = []) : r.push(n);
  }), t.push(...r.sort()), t;
}
function w_(e) {
  return {
    cache: v_(e.cacheSize),
    splitModifiers: y_(e),
    ...f_(e)
  };
}
const x_ = /\s+/;
function __(e, t) {
  const {
    splitModifiers: r,
    getClassGroupId: n,
    getConflictingClassGroupIds: o
  } = t, a = /* @__PURE__ */ new Set();
  return e.trim().split(x_).map((i) => {
    const {
      modifiers: s,
      hasImportantModifier: l,
      baseClassName: u,
      maybePostfixModifierPosition: c
    } = r(i);
    let p = n(c ? u.substring(0, c) : u), d = !!c;
    if (!p) {
      if (!c)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      if (p = n(u), !p)
        return {
          isTailwindClass: !1,
          originalClassName: i
        };
      d = !1;
    }
    const f = b_(s).join(":");
    return {
      isTailwindClass: !0,
      modifierId: l ? f + Nh : f,
      classGroupId: p,
      originalClassName: i,
      hasPostfixModifier: d
    };
  }).reverse().filter((i) => {
    if (!i.isTailwindClass)
      return !0;
    const {
      modifierId: s,
      classGroupId: l,
      hasPostfixModifier: u
    } = i, c = s + l;
    return a.has(c) ? !1 : (a.add(c), o(l, u).forEach((p) => a.add(s + p)), !0);
  }).reverse().map((i) => i.originalClassName).join(" ");
}
function S_() {
  let e = 0, t, r, n = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (r = Ch(t)) && (n && (n += " "), n += r);
  return n;
}
function Ch(e) {
  if (typeof e == "string")
    return e;
  let t, r = "";
  for (let n = 0; n < e.length; n++)
    e[n] && (t = Ch(e[n])) && (r && (r += " "), r += t);
  return r;
}
function E_(e, ...t) {
  let r, n, o, a = i;
  function i(l) {
    const u = t.reduce((c, p) => p(c), e());
    return r = w_(u), n = r.cache.get, o = r.cache.set, a = s, s(l);
  }
  function s(l) {
    const u = n(l);
    if (u)
      return u;
    const c = __(l, r);
    return o(l, c), c;
  }
  return function() {
    return a(S_.apply(null, arguments));
  };
}
function ht(e) {
  const t = (r) => r[e] || [];
  return t.isThemeGetter = !0, t;
}
const Ph = /^\[(?:([a-z-]+):)?(.+)\]$/i, T_ = /^\d+\/\d+$/, k_ = /* @__PURE__ */ new Set(["px", "full", "screen"]), O_ = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, D_ = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, N_ = /^(rgba?|hsla?|hwb|(ok)?(lab|lch))\(.+\)$/, C_ = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, P_ = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
function _n(e) {
  return vo(e) || k_.has(e) || T_.test(e);
}
function Un(e) {
  return la(e, "length", W_);
}
function vo(e) {
  return !!e && !Number.isNaN(Number(e));
}
function ss(e) {
  return la(e, "number", vo);
}
function Da(e) {
  return !!e && Number.isInteger(Number(e));
}
function M_(e) {
  return e.endsWith("%") && vo(e.slice(0, -1));
}
function Me(e) {
  return Ph.test(e);
}
function Hn(e) {
  return O_.test(e);
}
const R_ = /* @__PURE__ */ new Set(["length", "size", "percentage"]);
function A_(e) {
  return la(e, R_, Mh);
}
function I_(e) {
  return la(e, "position", Mh);
}
const F_ = /* @__PURE__ */ new Set(["image", "url"]);
function L_(e) {
  return la(e, F_, B_);
}
function $_(e) {
  return la(e, "", Y_);
}
function Na() {
  return !0;
}
function la(e, t, r) {
  const n = Ph.exec(e);
  return n ? n[1] ? typeof t == "string" ? n[1] === t : t.has(n[1]) : r(n[2]) : !1;
}
function W_(e) {
  return D_.test(e) && !N_.test(e);
}
function Mh() {
  return !1;
}
function Y_(e) {
  return C_.test(e);
}
function B_(e) {
  return P_.test(e);
}
function j_() {
  const e = ht("colors"), t = ht("spacing"), r = ht("blur"), n = ht("brightness"), o = ht("borderColor"), a = ht("borderRadius"), i = ht("borderSpacing"), s = ht("borderWidth"), l = ht("contrast"), u = ht("grayscale"), c = ht("hueRotate"), p = ht("invert"), d = ht("gap"), f = ht("gradientColorStops"), m = ht("gradientColorStopPositions"), v = ht("inset"), h = ht("margin"), _ = ht("opacity"), g = ht("padding"), b = ht("saturate"), x = ht("scale"), E = ht("sepia"), O = ht("skew"), P = ht("space"), y = ht("translate"), w = () => ["auto", "contain", "none"], S = () => ["auto", "hidden", "clip", "visible", "scroll"], k = () => ["auto", Me, t], T = () => [Me, t], R = () => ["", _n, Un], I = () => ["auto", vo, Me], C = () => ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"], A = () => ["solid", "dashed", "dotted", "double", "none"], D = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], N = () => ["start", "end", "center", "between", "around", "evenly", "stretch"], M = () => ["", "0", Me], W = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], B = () => [vo, ss], j = () => [vo, Me];
  return {
    cacheSize: 500,
    separator: ":",
    theme: {
      colors: [Na],
      spacing: [_n, Un],
      blur: ["none", "", Hn, Me],
      brightness: B(),
      borderColor: [e],
      borderRadius: ["none", "", "full", Hn, Me],
      borderSpacing: T(),
      borderWidth: R(),
      contrast: B(),
      grayscale: M(),
      hueRotate: j(),
      invert: M(),
      gap: T(),
      gradientColorStops: [e],
      gradientColorStopPositions: [M_, Un],
      inset: k(),
      margin: k(),
      opacity: B(),
      padding: T(),
      saturate: B(),
      scale: B(),
      sepia: M(),
      skew: j(),
      space: T(),
      translate: T()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Me]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [Hn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": W()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": W()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [...C(), Me]
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: S()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": S()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": S()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: w()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": w()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": w()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Da, Me]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: k()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Me]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: M()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: M()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Da, Me]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [Na]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Da, Me]
        }, Me]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": I()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": I()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [Na]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Da, Me]
        }, Me]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": I()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": I()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Me]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Me]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [d]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [d]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [d]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal", ...N()]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...N(), "baseline"]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [...N(), "baseline"]
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [g]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [g]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [g]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [g]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [g]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [g]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [g]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [g]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [g]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [h]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [h]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [h]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [h]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [h]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [h]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [h]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [h]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [h]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [P]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [P]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", "svw", "lvw", "dvw", Me, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [Me, t, "min", "max", "fit"]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [Me, t, "none", "full", "min", "max", "fit", "prose", {
          screen: [Hn]
        }, Hn]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Me, t, "auto", "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": [Me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Me, t, "min", "max", "fit", "svh", "lvh", "dvh"]
      }],
      /**
       * Size
       * @see https://tailwindcss.com/docs/size
       */
      size: [{
        size: [Me, t, "auto", "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", Hn, Un]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ss]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Na]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Me]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", vo, ss]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", _n, Me]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Me]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Me]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [_]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [_]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...A(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", _n, Un]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", _n, Me]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: T()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Me]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Me]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [_]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [...C(), I_]
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", A_]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, L_]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [m]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [f]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [f]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [f]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [a]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [a]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [a]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [a]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [a]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [a]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [a]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [a]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [a]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [a]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [a]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [a]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [a]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [a]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [a]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [_]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...A(), "hidden"]
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [_]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: A()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [o]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [o]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [o]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [o]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [o]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [o]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [o]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [o]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: ["", ...A()]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [_n, Me]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [_n, Un]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: R()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [_]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [_n, Un]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", Hn, $_]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [Na]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [_]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...D(), "plus-lighter", "plus-darker"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": D()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [r]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [n]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", Hn, Me]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [c]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [p]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [b]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [E]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [r]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [n]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [c]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [p]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [_]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [b]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [E]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [i]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [i]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [i]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Me]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: j()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Me]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: j()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Me]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [x]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [x]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [x]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Da, Me]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [y]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [y]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [O]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [O]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Me]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Me]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": T()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": T()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": T()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": T()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": T()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": T()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": T()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": T()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": T()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": T()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": T()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": T()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": T()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": T()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": T()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": T()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": T()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": T()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Me]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [_n, Un, ss]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const ls = /* @__PURE__ */ E_(j_), U_ = (e, t, r, n) => {
  const o = { ...e ?? {}, ...t ?? {} };
  return Object.keys(t ?? {}).forEach((a) => {
    if (a[a.length - 1] === "&") {
      const i = a.slice(0, a.length - 1);
      o[i] = ls(o[i], o[a]);
    }
  }), n && Object.keys(o).forEach((a) => {
    const i = n == null ? void 0 : n.variant;
    if (i && a !== `${a}_${i}`) {
      const l = o[`${a}_${i}`];
      o[a] = ls(o[a], l);
    }
    const s = n == null ? void 0 : n.modifier;
    if (s && a !== `${a}:${s}`) {
      const l = o[`${a}:${s}`];
      o[a] = ls(o[a], l);
    }
    if (s && i && a !== `${a}_${i}:${s}`) {
      const l = o[`${a}_${i}:${s}`];
      o[a] = ls(o[a], l);
    }
  }), Object.keys(o).forEach((a) => {
    (a.includes("&") || a.includes(":") || a.includes("_")) && delete o[a];
  }), {
    ...o,
    root: V(r, o.root)
  };
};
function H_(e) {
  return {
    login: e.mutation({
      invalidatesTags: ["self"],
      query: ({ client_id: t, client_secret: r, grant_type: n = "password", account: o }) => ({
        url: "/oauth/access_token",
        method: "POST",
        body: {
          client_id: t,
          client_secret: r,
          grant_type: n,
          account: o
        },
        validateStatus: er
      }),
      transformResponse: (t) => Ix(t)
    })
  };
}
function V_(e) {
  return {
    getProfile: e.query({
      providesTags: ["self"],
      query: () => ({
        url: "self/profile",
        validateStatus: er
      }),
      transformResponse: dt(vf)
    }),
    getProfileWithToken: e.query({
      providesTags: ["self"],
      query: (t) => ({
        url: "self/profile",
        validateStatus: er,
        headers: {
          Authorization: `Bearer ${t}`
        }
      }),
      transformResponse: dt(vf)
    })
  };
}
function z_(e) {
  return {
    updatePassword: e.mutation({
      invalidatesTags: ["password"],
      query: (t) => ({
        url: "/member/password",
        validateStatus: er,
        method: "POST",
        body: t
      }),
      transformResponse: dt()
    })
  };
}
const q_ = ["account", "self", "password"], Ff = {
  reducerPath: "authApi",
  tagTypes: q_,
  endpoints: (e) => ({
    ...H_(e),
    ...V_(e),
    ...z_(e)
  })
};
function G_(e) {
  const t = ce(e);
  return ge(() => {
    t.current = e;
  }), ae(() => (...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
const Q_ = (e) => {
  const t = ce(e);
  ge(() => {
    t.current = e;
  }), ge(() => {
    if (t.current)
      return Object.entries(t.current).forEach(([r, n]) => {
        window.addEventListener(r, n);
      }), () => {
        Object.entries(t.current).forEach(([r, n]) => {
          window.removeEventListener(r, n);
        });
      };
  }, []);
}, V5 = Q_, Ms = (e) => `pk-${e}`, Rh = (e, t) => {
  localStorage.setItem(Ms(e), t.toISOString());
}, K_ = (e) => {
  const t = localStorage.getItem(Ms(e));
  return t ? ie(t) : null;
}, X_ = (e) => {
  const [t, r] = me();
  ge(() => {
    const a = K_(e);
    a && r(a);
  }, [e]);
  const n = G_(() => {
    const a = t ? ie().isAfter(t) : !0;
    return a && localStorage.removeItem(Ms(e)), a;
  }), o = Le(
    (a) => {
      Rh(e, a), r(a);
    },
    [e]
  );
  return { check: n, updateDueAt: o, dueAt: t, key: Ms(e) };
}, Z_ = X_;
var Tt = {};
/**
 * @license React
 * react-dom-test-utils.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Lf;
function J_() {
  if (Lf) return Tt;
  Lf = 1;
  var e = G, t = mm;
  function r($) {
    var K = $, z = $;
    if ($.alternate) for (; K.return; ) K = K.return;
    else {
      $ = K;
      do
        K = $, K.flags & 4098 && (z = K.return), $ = K.return;
      while ($);
    }
    return K.tag === 3 ? z : null;
  }
  function n($) {
    if (r($) !== $) throw Error("Unable to find node on an unmounted component.");
  }
  function o($) {
    var K = $.alternate;
    if (!K) {
      if (K = r($), K === null) throw Error("Unable to find node on an unmounted component.");
      return K !== $ ? null : $;
    }
    for (var z = $, be = K; ; ) {
      var Ce = z.return;
      if (Ce === null) break;
      var ve = Ce.alternate;
      if (ve === null) {
        if (be = Ce.return, be !== null) {
          z = be;
          continue;
        }
        break;
      }
      if (Ce.child === ve.child) {
        for (ve = Ce.child; ve; ) {
          if (ve === z) return n(Ce), $;
          if (ve === be) return n(Ce), K;
          ve = ve.sibling;
        }
        throw Error("Unable to find node on an unmounted component.");
      }
      if (z.return !== be.return) z = Ce, be = ve;
      else {
        for (var we = !1, Se = Ce.child; Se; ) {
          if (Se === z) {
            we = !0, z = Ce, be = ve;
            break;
          }
          if (Se === be) {
            we = !0, be = Ce, z = ve;
            break;
          }
          Se = Se.sibling;
        }
        if (!we) {
          for (Se = ve.child; Se; ) {
            if (Se === z) {
              we = !0, z = ve, be = Ce;
              break;
            }
            if (Se === be) {
              we = !0, be = ve, z = Ce;
              break;
            }
            Se = Se.sibling;
          }
          if (!we) throw Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
        }
      }
      if (z.alternate !== be) throw Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
    }
    if (z.tag !== 3) throw Error("Unable to find node on an unmounted component.");
    return z.stateNode.current === z ? $ : K;
  }
  var a = Object.assign;
  function i($) {
    var K = $.keyCode;
    return "charCode" in $ ? ($ = $.charCode, $ === 0 && K === 13 && ($ = 13)) : $ = K, $ === 10 && ($ = 13), 32 <= $ || $ === 13 ? $ : 0;
  }
  function s() {
    return !0;
  }
  function l() {
    return !1;
  }
  function u($) {
    function K(z, be, Ce, ve, we) {
      this._reactName = z, this._targetInst = Ce, this.type = be, this.nativeEvent = ve, this.target = we, this.currentTarget = null;
      for (var Se in $) $.hasOwnProperty(Se) && (z = $[Se], this[Se] = z ? z(ve) : ve[Se]);
      return this.isDefaultPrevented = (ve.defaultPrevented != null ? ve.defaultPrevented : ve.returnValue === !1) ? s : l, this.isPropagationStopped = l, this;
    }
    return a(K.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var z = this.nativeEvent;
      z && (z.preventDefault ? z.preventDefault() : typeof z.returnValue != "unknown" && (z.returnValue = !1), this.isDefaultPrevented = s);
    }, stopPropagation: function() {
      var z = this.nativeEvent;
      z && (z.stopPropagation ? z.stopPropagation() : typeof z.cancelBubble != "unknown" && (z.cancelBubble = !0), this.isPropagationStopped = s);
    }, persist: function() {
    }, isPersistent: s }), K;
  }
  var c = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function($) {
    return $.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, p = u(c), d = a({}, c, { view: 0, detail: 0 });
  u(d);
  var f, m, v, h = a({}, d, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: S, button: 0, buttons: 0, relatedTarget: function($) {
    return $.relatedTarget === void 0 ? $.fromElement === $.srcElement ? $.toElement : $.fromElement : $.relatedTarget;
  }, movementX: function($) {
    return "movementX" in $ ? $.movementX : ($ !== v && (v && $.type === "mousemove" ? (f = $.screenX - v.screenX, m = $.screenY - v.screenY) : m = f = 0, v = $), f);
  }, movementY: function($) {
    return "movementY" in $ ? $.movementY : m;
  } });
  u(h);
  var _ = a({}, h, { dataTransfer: 0 });
  u(_);
  var g = a({}, d, { relatedTarget: 0 });
  u(g);
  var b = a({}, c, { animationName: 0, elapsedTime: 0, pseudoElement: 0 });
  u(b);
  var x = a({}, c, { clipboardData: function($) {
    return "clipboardData" in $ ? $.clipboardData : window.clipboardData;
  } });
  u(x);
  var E = a({}, c, { data: 0 });
  u(E);
  var O = { Esc: "Escape", Spacebar: " ", Left: "ArrowLeft", Up: "ArrowUp", Right: "ArrowRight", Down: "ArrowDown", Del: "Delete", Win: "OS", Menu: "ContextMenu", Apps: "ContextMenu", Scroll: "ScrollLock", MozPrintableKey: "Unidentified" }, P = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, y = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function w($) {
    var K = this.nativeEvent;
    return K.getModifierState ? K.getModifierState($) : ($ = y[$]) ? !!K[$] : !1;
  }
  function S() {
    return w;
  }
  var k = a({}, d, { key: function($) {
    if ($.key) {
      var K = O[$.key] || $.key;
      if (K !== "Unidentified") return K;
    }
    return $.type === "keypress" ? ($ = i($), $ === 13 ? "Enter" : String.fromCharCode($)) : $.type === "keydown" || $.type === "keyup" ? P[$.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: S, charCode: function($) {
    return $.type === "keypress" ? i($) : 0;
  }, keyCode: function($) {
    return $.type === "keydown" || $.type === "keyup" ? $.keyCode : 0;
  }, which: function($) {
    return $.type === "keypress" ? i($) : $.type === "keydown" || $.type === "keyup" ? $.keyCode : 0;
  } });
  u(k);
  var T = a({}, h, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 });
  u(T);
  var R = a({}, d, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: S });
  u(R);
  var I = a({}, c, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 });
  u(I);
  var C = a({}, h, { deltaX: function($) {
    return "deltaX" in $ ? $.deltaX : "wheelDeltaX" in $ ? -$.wheelDeltaX : 0;
  }, deltaY: function($) {
    return "deltaY" in $ ? $.deltaY : "wheelDeltaY" in $ ? -$.wheelDeltaY : "wheelDelta" in $ ? -$.wheelDelta : 0;
  }, deltaZ: 0, deltaMode: 0 });
  u(C);
  function A($, K, z, be, Ce, ve, we, Se, Je) {
    var et = Array.prototype.slice.call(arguments, 3);
    try {
      K.apply(z, et);
    } catch (Lt) {
      this.onError(Lt);
    }
  }
  var D = !1, N = null, M = !1, W = null, B = { onError: function($) {
    D = !0, N = $;
  } };
  function j($, K, z, be, Ce, ve, we, Se, Je) {
    D = !1, N = null, A.apply(B, arguments);
  }
  function q($, K, z, be, Ce, ve, we, Se, Je) {
    if (j.apply(this, arguments), D) {
      if (D) {
        var et = N;
        D = !1, N = null;
      } else throw Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
      M || (M = !0, W = et);
    }
  }
  var se = Array.isArray, te = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events, le = te[0], ke = te[1], at = te[2], _t = te[3], Pt = te[4], pe = e.unstable_act;
  function Z() {
  }
  function Pe($, K) {
    if (!$) return [];
    if ($ = o($), !$) return [];
    for (var z = $, be = []; ; ) {
      if (z.tag === 5 || z.tag === 6 || z.tag === 1 || z.tag === 0) {
        var Ce = z.stateNode;
        K(Ce) && be.push(Ce);
      }
      if (z.child) z.child.return = z, z = z.child;
      else {
        if (z === $) return be;
        for (; !z.sibling; ) {
          if (!z.return || z.return === $) return be;
          z = z.return;
        }
        z.sibling.return = z.return, z = z.sibling;
      }
    }
  }
  function J($, K) {
    if ($ && !$._reactInternals) {
      var z = String($);
      throw $ = se($) ? "an array" : $ && $.nodeType === 1 && $.tagName ? "a DOM node" : z === "[object Object]" ? "object with keys {" + Object.keys($).join(", ") + "}" : z, Error(K + "(...): the first argument must be a React class instance. Instead received: " + ($ + "."));
    }
  }
  function Ne($) {
    return !(!$ || $.nodeType !== 1 || !$.tagName);
  }
  function St($) {
    return Ne($) ? !1 : $ != null && typeof $.render == "function" && typeof $.setState == "function";
  }
  function Et($, K) {
    return St($) ? $._reactInternals.type === K : !1;
  }
  function Ft($, K) {
    return J($, "findAllInRenderedTree"), $ ? Pe($._reactInternals, K) : [];
  }
  function nr($, K) {
    return J($, "scryRenderedDOMComponentsWithClass"), Ft($, function(z) {
      if (Ne(z)) {
        var be = z.className;
        typeof be != "string" && (be = z.getAttribute("class") || "");
        var Ce = be.split(/\s+/);
        if (!se(K)) {
          if (K === void 0) throw Error("TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.");
          K = K.split(/\s+/);
        }
        return K.every(function(ve) {
          return Ce.indexOf(ve) !== -1;
        });
      }
      return !1;
    });
  }
  function Xr($, K) {
    return J($, "scryRenderedDOMComponentsWithTag"), Ft($, function(z) {
      return Ne(z) && z.tagName.toUpperCase() === K.toUpperCase();
    });
  }
  function vn($, K) {
    return J($, "scryRenderedComponentsWithType"), Ft($, function(z) {
      return Et(z, K);
    });
  }
  function yn($, K, z) {
    var be = $.type || "unknown-event";
    $.currentTarget = ke(z), q(be, K, void 0, $), $.currentTarget = null;
  }
  function Zr($, K, z) {
    for (var be = []; $; ) {
      be.push($);
      do
        $ = $.return;
      while ($ && $.tag !== 5);
      $ = $ || null;
    }
    for ($ = be.length; 0 < $--; ) K(be[$], "captured", z);
    for ($ = 0; $ < be.length; $++) K(be[$], "bubbled", z);
  }
  function xr($, K) {
    var z = $.stateNode;
    if (!z) return null;
    var be = at(z);
    if (!be) return null;
    z = be[K];
    e: switch (K) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (be = !be.disabled) || ($ = $.type, be = !($ === "button" || $ === "input" || $ === "select" || $ === "textarea")), $ = !be;
        break e;
      default:
        $ = !1;
    }
    if ($) return null;
    if (z && typeof z != "function") throw Error("Expected `" + K + "` listener to be a function, instead got a value of `" + typeof z + "` type.");
    return z;
  }
  function Mt($, K, z) {
    $ && z && z._reactName && (K = xr($, z._reactName)) && (z._dispatchListeners == null && (z._dispatchListeners = []), z._dispatchInstances == null && (z._dispatchInstances = []), z._dispatchListeners.push(K), z._dispatchInstances.push($));
  }
  function Kt($, K, z) {
    var be = z._reactName;
    K === "captured" && (be += "Capture"), (K = xr($, be)) && (z._dispatchListeners == null && (z._dispatchListeners = []), z._dispatchInstances == null && (z._dispatchInstances = []), z._dispatchListeners.push(K), z._dispatchInstances.push($));
  }
  var bn = {}, _r = /* @__PURE__ */ new Set(["mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave"]);
  function Ln($) {
    return function(K, z) {
      if (e.isValidElement(K)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a React element. Pass the DOM node you wish to simulate the event on instead. Note that TestUtils.Simulate will not work if you are using shallow rendering.");
      if (St(K)) throw Error("TestUtils.Simulate expected a DOM node as the first argument but received a component instance. Pass the DOM node you wish to simulate the event on instead.");
      var be = "on" + $[0].toUpperCase() + $.slice(1), Ce = new Z();
      Ce.target = K, Ce.type = $.toLowerCase();
      var ve = le(K), we = new p(be, Ce.type, ve, Ce, K);
      we.persist(), a(we, z), _r.has($) ? we && we._reactName && Mt(we._targetInst, null, we) : we && we._reactName && Zr(we._targetInst, Kt, we), t.unstable_batchedUpdates(function() {
        if (_t(K), we) {
          var Se = we._dispatchListeners, Je = we._dispatchInstances;
          if (se(Se)) for (var et = 0; et < Se.length && !we.isPropagationStopped(); et++) yn(we, Se[et], Je[et]);
          else Se && yn(we, Se, Je);
          we._dispatchListeners = null, we._dispatchInstances = null, we.isPersistent() || we.constructor.release(we);
        }
        if (M) throw Se = W, M = !1, W = null, Se;
      }), Pt();
    };
  }
  return "blur cancel click close contextMenu copy cut auxClick doubleClick dragEnd dragStart drop focus input invalid keyDown keyPress keyUp mouseDown mouseUp paste pause play pointerCancel pointerDown pointerUp rateChange reset resize seeked submit touchCancel touchEnd touchStart volumeChange drag dragEnter dragExit dragLeave dragOver mouseMove mouseOut mouseOver pointerMove pointerOut pointerOver scroll toggle touchMove wheel abort animationEnd animationIteration animationStart canPlay canPlayThrough durationChange emptied encrypted ended error gotPointerCapture load loadedData loadedMetadata loadStart lostPointerCapture playing progress seeking stalled suspend timeUpdate transitionEnd waiting mouseEnter mouseLeave pointerEnter pointerLeave change select beforeInput compositionEnd compositionStart compositionUpdate".split(" ").forEach(function($) {
    bn[$] = Ln($);
  }), Tt.Simulate = bn, Tt.act = pe, Tt.findAllInRenderedTree = Ft, Tt.findRenderedComponentWithType = function($, K) {
    if (J($, "findRenderedComponentWithType"), $ = vn($, K), $.length !== 1) throw Error("Did not find exactly one match (found: " + $.length + ") for componentType:" + K);
    return $[0];
  }, Tt.findRenderedDOMComponentWithClass = function($, K) {
    if (J($, "findRenderedDOMComponentWithClass"), $ = nr($, K), $.length !== 1) throw Error("Did not find exactly one match (found: " + $.length + ") for class:" + K);
    return $[0];
  }, Tt.findRenderedDOMComponentWithTag = function($, K) {
    if (J($, "findRenderedDOMComponentWithTag"), $ = Xr($, K), $.length !== 1) throw Error("Did not find exactly one match (found: " + $.length + ") for tag:" + K);
    return $[0];
  }, Tt.isCompositeComponent = St, Tt.isCompositeComponentWithType = Et, Tt.isDOMComponent = Ne, Tt.isDOMComponentElement = function($) {
    return !!($ && e.isValidElement($) && $.tagName);
  }, Tt.isElement = function($) {
    return e.isValidElement($);
  }, Tt.isElementOfType = function($, K) {
    return e.isValidElement($) && $.type === K;
  }, Tt.mockComponent = function($, K) {
    return K = K || $.mockTagName || "div", $.prototype.render.mockImplementation(function() {
      return e.createElement(K, null, this.props.children);
    }), this;
  }, Tt.nativeTouchData = function($, K) {
    return { touches: [{ pageX: $, pageY: K }] };
  }, Tt.renderIntoDocument = function($) {
    var K = document.createElement("div");
    return t.render($, K);
  }, Tt.scryRenderedComponentsWithType = vn, Tt.scryRenderedDOMComponentsWithClass = nr, Tt.scryRenderedDOMComponentsWithTag = Xr, Tt.traverseTwoPhase = Zr, Tt;
}
var kt = {};
/**
 * @license React
 * react-dom-test-utils.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $f;
function eS() {
  return $f || ($f = 1, process.env.NODE_ENV !== "production" && function() {
    var e = G, t = mm, r = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(F) {
      {
        for (var H = arguments.length, U = new Array(H > 1 ? H - 1 : 0), X = 1; X < H; X++)
          U[X - 1] = arguments[X];
        a("warn", F, U);
      }
    }
    function o(F) {
      {
        for (var H = arguments.length, U = new Array(H > 1 ? H - 1 : 0), X = 1; X < H; X++)
          U[X - 1] = arguments[X];
        a("error", F, U);
      }
    }
    function a(F, H, U) {
      {
        var X = r.ReactDebugCurrentFrame, _e = X.getStackAddendum();
        _e !== "" && (H += "%s", U = U.concat([_e]));
        var Be = U.map(function(wt) {
          return String(wt);
        });
        Be.unshift("Warning: " + H), Function.prototype.apply.call(console[F], console, Be);
      }
    }
    function i(F) {
      return F._reactInternals;
    }
    var s = 0, l = 1, u = 3, c = 5, p = 6, d = (
      /*                      */
      0
    ), f = (
      /*                    */
      2
    ), m = (
      /*                    */
      4096
    );
    r.ReactCurrentOwner;
    function v(F) {
      var H = F, U = F;
      if (F.alternate)
        for (; H.return; )
          H = H.return;
      else {
        var X = H;
        do
          H = X, (H.flags & (f | m)) !== d && (U = H.return), X = H.return;
        while (X);
      }
      return H.tag === u ? U : null;
    }
    function h(F) {
      if (v(F) !== F)
        throw new Error("Unable to find node on an unmounted component.");
    }
    function _(F) {
      var H = F.alternate;
      if (!H) {
        var U = v(F);
        if (U === null)
          throw new Error("Unable to find node on an unmounted component.");
        return U !== F ? null : F;
      }
      for (var X = F, _e = H; ; ) {
        var Be = X.return;
        if (Be === null)
          break;
        var wt = Be.alternate;
        if (wt === null) {
          var Tr = Be.return;
          if (Tr !== null) {
            X = _e = Tr;
            continue;
          }
          break;
        }
        if (Be.child === wt.child) {
          for (var kr = Be.child; kr; ) {
            if (kr === X)
              return h(Be), F;
            if (kr === _e)
              return h(Be), H;
            kr = kr.sibling;
          }
          throw new Error("Unable to find node on an unmounted component.");
        }
        if (X.return !== _e.return)
          X = Be, _e = wt;
        else {
          for (var dr = !1, Ht = Be.child; Ht; ) {
            if (Ht === X) {
              dr = !0, X = Be, _e = wt;
              break;
            }
            if (Ht === _e) {
              dr = !0, _e = Be, X = wt;
              break;
            }
            Ht = Ht.sibling;
          }
          if (!dr) {
            for (Ht = wt.child; Ht; ) {
              if (Ht === X) {
                dr = !0, X = wt, _e = Be;
                break;
              }
              if (Ht === _e) {
                dr = !0, _e = wt, X = Be;
                break;
              }
              Ht = Ht.sibling;
            }
            if (!dr)
              throw new Error("Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue.");
          }
        }
        if (X.alternate !== _e)
          throw new Error("Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue.");
      }
      if (X.tag !== u)
        throw new Error("Unable to find node on an unmounted component.");
      return X.stateNode.current === X ? F : H;
    }
    var g = Object.assign;
    function b(F) {
      var H, U = F.keyCode;
      return "charCode" in F ? (H = F.charCode, H === 0 && U === 13 && (H = 13)) : H = U, H === 10 && (H = 13), H >= 32 || H === 13 ? H : 0;
    }
    function x() {
      return !0;
    }
    function E() {
      return !1;
    }
    function O(F) {
      function H(U, X, _e, Be, wt) {
        this._reactName = U, this._targetInst = _e, this.type = X, this.nativeEvent = Be, this.target = wt, this.currentTarget = null;
        for (var Tr in F)
          if (F.hasOwnProperty(Tr)) {
            var kr = F[Tr];
            kr ? this[Tr] = kr(Be) : this[Tr] = Be[Tr];
          }
        var dr = Be.defaultPrevented != null ? Be.defaultPrevented : Be.returnValue === !1;
        return dr ? this.isDefaultPrevented = x : this.isDefaultPrevented = E, this.isPropagationStopped = E, this;
      }
      return g(H.prototype, {
        preventDefault: function() {
          this.defaultPrevented = !0;
          var U = this.nativeEvent;
          U && (U.preventDefault ? U.preventDefault() : typeof U.returnValue != "unknown" && (U.returnValue = !1), this.isDefaultPrevented = x);
        },
        stopPropagation: function() {
          var U = this.nativeEvent;
          U && (U.stopPropagation ? U.stopPropagation() : typeof U.cancelBubble != "unknown" && (U.cancelBubble = !0), this.isPropagationStopped = x);
        },
        /**
         * We release all dispatched `SyntheticEvent`s after each event loop, adding
         * them back into the pool. This allows a way to hold onto a reference that
         * won't be added back into the pool.
         */
        persist: function() {
        },
        /**
         * Checks if this event should be released back into the pool.
         *
         * @return {boolean} True if this should not be released, false otherwise.
         */
        isPersistent: x
      }), H;
    }
    var P = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(F) {
        return F.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, y = O(P), w = g({}, P, {
      view: 0,
      detail: 0
    });
    O(w);
    var S, k, T;
    function R(F) {
      F !== T && (T && F.type === "mousemove" ? (S = F.screenX - T.screenX, k = F.screenY - T.screenY) : (S = 0, k = 0), T = F);
    }
    var I = g({}, w, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: te,
      button: 0,
      buttons: 0,
      relatedTarget: function(F) {
        return F.relatedTarget === void 0 ? F.fromElement === F.srcElement ? F.toElement : F.fromElement : F.relatedTarget;
      },
      movementX: function(F) {
        return "movementX" in F ? F.movementX : (R(F), S);
      },
      movementY: function(F) {
        return "movementY" in F ? F.movementY : k;
      }
    });
    O(I);
    var C = g({}, I, {
      dataTransfer: 0
    });
    O(C);
    var A = g({}, w, {
      relatedTarget: 0
    });
    O(A);
    var D = g({}, P, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    });
    O(D);
    var N = g({}, P, {
      clipboardData: function(F) {
        return "clipboardData" in F ? F.clipboardData : window.clipboardData;
      }
    });
    O(N);
    var M = g({}, P, {
      data: 0
    });
    O(M);
    var W = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, B = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    };
    function j(F) {
      if (F.key) {
        var H = W[F.key] || F.key;
        if (H !== "Unidentified")
          return H;
      }
      if (F.type === "keypress") {
        var U = b(F);
        return U === 13 ? "Enter" : String.fromCharCode(U);
      }
      return F.type === "keydown" || F.type === "keyup" ? B[F.keyCode] || "Unidentified" : "";
    }
    var q = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    };
    function se(F) {
      var H = this, U = H.nativeEvent;
      if (U.getModifierState)
        return U.getModifierState(F);
      var X = q[F];
      return X ? !!U[X] : !1;
    }
    function te(F) {
      return se;
    }
    var le = g({}, w, {
      key: j,
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: te,
      // Legacy Interface
      charCode: function(F) {
        return F.type === "keypress" ? b(F) : 0;
      },
      keyCode: function(F) {
        return F.type === "keydown" || F.type === "keyup" ? F.keyCode : 0;
      },
      which: function(F) {
        return F.type === "keypress" ? b(F) : F.type === "keydown" || F.type === "keyup" ? F.keyCode : 0;
      }
    });
    O(le);
    var ke = g({}, I, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    });
    O(ke);
    var at = g({}, w, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: te
    });
    O(at);
    var _t = g({}, P, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    });
    O(_t);
    var Pt = g({}, I, {
      deltaX: function(F) {
        return "deltaX" in F ? F.deltaX : (
          // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
          "wheelDeltaX" in F ? -F.wheelDeltaX : 0
        );
      },
      deltaY: function(F) {
        return "deltaY" in F ? F.deltaY : (
          // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
          "wheelDeltaY" in F ? -F.wheelDeltaY : (
            // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
            "wheelDelta" in F ? -F.wheelDelta : 0
          )
        );
      },
      deltaZ: 0,
      // Browsers without "deltaMode" is reporting in raw wheel delta where one
      // notch on the scroll is always +/- 120, roughly equivalent to pixels.
      // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
      // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
      deltaMode: 0
    });
    O(Pt);
    var pe = 1;
    function Z(F, H, U, X, _e, Be, wt, Tr, kr) {
      var dr = Array.prototype.slice.call(arguments, 3);
      try {
        H.apply(U, dr);
      } catch (Ht) {
        this.onError(Ht);
      }
    }
    var Pe = Z;
    if (typeof window < "u" && typeof window.dispatchEvent == "function" && typeof document < "u" && typeof document.createEvent == "function") {
      var J = document.createElement("react");
      Pe = function(H, U, X, _e, Be, wt, Tr, kr, dr) {
        if (typeof document > "u" || document === null)
          throw new Error("The `document` global was defined when React was initialized, but is not defined anymore. This can happen in a test environment if a component schedules an update from an asynchronous callback, but the test has already finished running. To solve this, you can either unmount the component at the end of your test (and ensure that any asynchronous operations get canceled in `componentWillUnmount`), or you can change the test itself to be asynchronous.");
        var Ht = document.createEvent("Event"), Il = !1, rf = !0, c1 = window.event, nf = Object.getOwnPropertyDescriptor(window, "event");
        function of() {
          J.removeEventListener(Fl, af, !1), typeof window.event < "u" && window.hasOwnProperty("event") && (window.event = c1);
        }
        var u1 = Array.prototype.slice.call(arguments, 3);
        function af() {
          Il = !0, of(), U.apply(X, u1), rf = !1;
        }
        var Yn, sf = !1, lf = !1;
        function cf(es) {
          if (Yn = es.error, sf = !0, Yn === null && es.colno === 0 && es.lineno === 0 && (lf = !0), es.defaultPrevented && Yn != null && typeof Yn == "object")
            try {
              Yn._suppressLogging = !0;
            } catch {
            }
        }
        var Fl = "react-" + (H || "invokeguardedcallback");
        if (window.addEventListener("error", cf), J.addEventListener(Fl, af, !1), Ht.initEvent(Fl, !1, !1), J.dispatchEvent(Ht), nf && Object.defineProperty(window, "event", nf), Il && rf && (sf ? lf && (Yn = new Error("A cross-origin error was thrown. React doesn't have access to the actual error object in development. See https://reactjs.org/link/crossorigin-error for more information.")) : Yn = new Error(`An error was thrown inside one of your components, but React doesn't know what it was. This is likely due to browser flakiness. React does its best to preserve the "Pause on exceptions" behavior of the DevTools, which requires some DEV-mode only tricks. It's possible that these don't work in your browser. Try triggering the error in production mode, or switching to a modern browser. If you suspect that this is actually an issue with React, please file an issue.`), this.onError(Yn)), window.removeEventListener("error", cf), !Il)
          return of(), Z.apply(this, arguments);
      };
    }
    var Ne = Pe, St = !1, Et = null, Ft = !1, nr = null, Xr = {
      onError: function(F) {
        St = !0, Et = F;
      }
    };
    function vn(F, H, U, X, _e, Be, wt, Tr, kr) {
      St = !1, Et = null, Ne.apply(Xr, arguments);
    }
    function yn(F, H, U, X, _e, Be, wt, Tr, kr) {
      if (vn.apply(this, arguments), St) {
        var dr = xr();
        Ft || (Ft = !0, nr = dr);
      }
    }
    function Zr() {
      if (Ft) {
        var F = nr;
        throw Ft = !1, nr = null, F;
      }
    }
    function xr() {
      if (St) {
        var F = Et;
        return St = !1, Et = null, F;
      } else
        throw new Error("clearCaughtError was called but no error was captured. This error is likely caused by a bug in React. Please file an issue.");
    }
    var Mt = Array.isArray;
    function Kt(F) {
      return Mt(F);
    }
    var bn = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, _r = bn.Events, Ln = _r[0], $ = _r[1], K = _r[2], z = _r[3], be = _r[4], Ce = e.unstable_act;
    function ve(F) {
    }
    var we = !1;
    function Se(F, H) {
      if (!F)
        return [];
      var U = _(F);
      if (!U)
        return [];
      for (var X = U, _e = []; ; ) {
        if (X.tag === c || X.tag === p || X.tag === l || X.tag === s) {
          var Be = X.stateNode;
          H(Be) && _e.push(Be);
        }
        if (X.child) {
          X.child.return = X, X = X.child;
          continue;
        }
        if (X === U)
          return _e;
        for (; !X.sibling; ) {
          if (!X.return || X.return === U)
            return _e;
          X = X.return;
        }
        X.sibling.return = X.return, X = X.sibling;
      }
    }
    function Je(F, H) {
      if (F && !i(F)) {
        var U, X = String(F);
        throw Kt(F) ? U = "an array" : F && F.nodeType === pe && F.tagName ? U = "a DOM node" : X === "[object Object]" ? U = "object with keys {" + Object.keys(F).join(", ") + "}" : U = X, new Error(H + "(...): the first argument must be a React class instance. " + ("Instead received: " + U + "."));
      }
    }
    function et(F) {
      var H = document.createElement("div");
      return t.render(F, H);
    }
    function Lt(F) {
      return e.isValidElement(F);
    }
    function $n(F, H) {
      return e.isValidElement(F) && F.type === H;
    }
    function mt(F) {
      return !!(F && F.nodeType === pe && F.tagName);
    }
    function Sr(F) {
      return !!(F && e.isValidElement(F) && F.tagName);
    }
    function Jr(F) {
      return mt(F) ? !1 : F != null && typeof F.render == "function" && typeof F.setState == "function";
    }
    function io(F, H) {
      if (!Jr(F))
        return !1;
      var U = i(F), X = U.type;
      return X === H;
    }
    function Wn(F, H) {
      if (Je(F, "findAllInRenderedTree"), !F)
        return [];
      var U = i(F);
      return Se(U, H);
    }
    function ga(F, H) {
      return Je(F, "scryRenderedDOMComponentsWithClass"), Wn(F, function(U) {
        if (mt(U)) {
          var X = U.className;
          typeof X != "string" && (X = U.getAttribute("class") || "");
          var _e = X.split(/\s+/);
          if (!Kt(H)) {
            if (H === void 0)
              throw new Error("TestUtils.scryRenderedDOMComponentsWithClass expects a className as a second argument.");
            H = H.split(/\s+/);
          }
          return H.every(function(Be) {
            return _e.indexOf(Be) !== -1;
          });
        }
        return !1;
      });
    }
    function zi(F, H) {
      Je(F, "findRenderedDOMComponentWithClass");
      var U = ga(F, H);
      if (U.length !== 1)
        throw new Error("Did not find exactly one match (found: " + U.length + ") for class:" + H);
      return U[0];
    }
    function qi(F, H) {
      return Je(F, "scryRenderedDOMComponentsWithTag"), Wn(F, function(U) {
        return mt(U) && U.tagName.toUpperCase() === H.toUpperCase();
      });
    }
    function Gi(F, H) {
      Je(F, "findRenderedDOMComponentWithTag");
      var U = qi(F, H);
      if (U.length !== 1)
        throw new Error("Did not find exactly one match (found: " + U.length + ") for tag:" + H);
      return U[0];
    }
    function va(F, H) {
      return Je(F, "scryRenderedComponentsWithType"), Wn(F, function(U) {
        return io(U, H);
      });
    }
    function Rl(F, H) {
      Je(F, "findRenderedComponentWithType");
      var U = va(F, H);
      if (U.length !== 1)
        throw new Error("Did not find exactly one match (found: " + U.length + ") for componentType:" + H);
      return U[0];
    }
    function Er(F, H) {
      return we || (we = !0, n(`ReactTestUtils.mockComponent() is deprecated. Use shallow rendering or jest.mock() instead.

See https://reactjs.org/link/test-utils-mock-component for more information.`)), H = H || F.mockTagName || "div", F.prototype.render.mockImplementation(function() {
        return e.createElement(H, null, this.props.children);
      }), this;
    }
    function Ro(F, H) {
      return {
        touches: [{
          pageX: F,
          pageY: H
        }]
      };
    }
    function ya(F, H, U) {
      var X = F.type || "unknown-event";
      F.currentTarget = $(U), yn(X, H, void 0, F), F.currentTarget = null;
    }
    function Qi(F) {
      var H = F._dispatchListeners, U = F._dispatchInstances;
      if (Kt(H))
        for (var X = 0; X < H.length && !F.isPropagationStopped(); X++)
          ya(F, H[X], U[X]);
      else H && ya(F, H, U);
      F._dispatchListeners = null, F._dispatchInstances = null;
    }
    var Ki = function(F) {
      F && (Qi(F), F.isPersistent() || F.constructor.release(F));
    };
    function Xi(F) {
      return F === "button" || F === "input" || F === "select" || F === "textarea";
    }
    function Fr(F) {
      do
        F = F.return;
      while (F && F.tag !== c);
      return F || null;
    }
    function ba(F, H, U) {
      for (var X = []; F; )
        X.push(F), F = Fr(F);
      var _e;
      for (_e = X.length; _e-- > 0; )
        H(X[_e], "captured", U);
      for (_e = 0; _e < X.length; _e++)
        H(X[_e], "bubbled", U);
    }
    function Zi(F, H, U) {
      switch (F) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          return !!(U.disabled && Xi(H));
        default:
          return !1;
      }
    }
    function wa(F, H) {
      var U = F.stateNode;
      if (!U)
        return null;
      var X = K(U);
      if (!X)
        return null;
      var _e = X[H];
      if (Zi(H, F.type, X))
        return null;
      if (_e && typeof _e != "function")
        throw new Error("Expected `" + H + "` listener to be a function, instead got a value of `" + typeof _e + "` type.");
      return _e;
    }
    function Ji(F, H, U) {
      var X = H._reactName;
      return U === "captured" && (X += "Capture"), wa(F, X);
    }
    function Al(F, H, U) {
      if (F && U && U._reactName) {
        var X = U._reactName, _e = wa(F, X);
        _e && (U._dispatchListeners == null && (U._dispatchListeners = []), U._dispatchInstances == null && (U._dispatchInstances = []), U._dispatchListeners.push(_e), U._dispatchInstances.push(F));
      }
    }
    function he(F, H, U) {
      F || o("Dispatching inst must not be null");
      var X = Ji(F, U, H);
      X && (U._dispatchListeners == null && (U._dispatchListeners = []), U._dispatchInstances == null && (U._dispatchInstances = []), U._dispatchListeners.push(X), U._dispatchInstances.push(F));
    }
    function Y(F) {
      F && F._reactName && Al(F._targetInst, null, F);
    }
    function ne(F) {
      F && F._reactName && ba(F._targetInst, he, F);
    }
    var fe = {}, lt = /* @__PURE__ */ new Set(["mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave"]);
    function $t(F) {
      return function(H, U) {
        if (e.isValidElement(H))
          throw new Error("TestUtils.Simulate expected a DOM node as the first argument but received a React element. Pass the DOM node you wish to simulate the event on instead. Note that TestUtils.Simulate will not work if you are using shallow rendering.");
        if (Jr(H))
          throw new Error("TestUtils.Simulate expected a DOM node as the first argument but received a component instance. Pass the DOM node you wish to simulate the event on instead.");
        var X = "on" + F[0].toUpperCase() + F.slice(1), _e = new ve();
        _e.target = H, _e.type = F.toLowerCase();
        var Be = Ln(H), wt = new y(X, _e.type, Be, _e, H);
        wt.persist(), g(wt, U), lt.has(F) ? Y(wt) : ne(wt), t.unstable_batchedUpdates(function() {
          z(H), Ki(wt), Zr();
        }), be();
      };
    }
    var Rt = ["blur", "cancel", "click", "close", "contextMenu", "copy", "cut", "auxClick", "doubleClick", "dragEnd", "dragStart", "drop", "focus", "input", "invalid", "keyDown", "keyPress", "keyUp", "mouseDown", "mouseUp", "paste", "pause", "play", "pointerCancel", "pointerDown", "pointerUp", "rateChange", "reset", "resize", "seeked", "submit", "touchCancel", "touchEnd", "touchStart", "volumeChange", "drag", "dragEnter", "dragExit", "dragLeave", "dragOver", "mouseMove", "mouseOut", "mouseOver", "pointerMove", "pointerOut", "pointerOver", "scroll", "toggle", "touchMove", "wheel", "abort", "animationEnd", "animationIteration", "animationStart", "canPlay", "canPlayThrough", "durationChange", "emptied", "encrypted", "ended", "error", "gotPointerCapture", "load", "loadedData", "loadedMetadata", "loadStart", "lostPointerCapture", "playing", "progress", "seeking", "stalled", "suspend", "timeUpdate", "transitionEnd", "waiting", "mouseEnter", "mouseLeave", "pointerEnter", "pointerLeave", "change", "select", "beforeInput", "compositionEnd", "compositionStart", "compositionUpdate"];
    function Ut() {
      Rt.forEach(function(F) {
        fe[F] = $t(F);
      });
    }
    Ut(), kt.Simulate = fe, kt.act = Ce, kt.findAllInRenderedTree = Wn, kt.findRenderedComponentWithType = Rl, kt.findRenderedDOMComponentWithClass = zi, kt.findRenderedDOMComponentWithTag = Gi, kt.isCompositeComponent = Jr, kt.isCompositeComponentWithType = io, kt.isDOMComponent = mt, kt.isDOMComponentElement = Sr, kt.isElement = Lt, kt.isElementOfType = $n, kt.mockComponent = Er, kt.nativeTouchData = Ro, kt.renderIntoDocument = et, kt.scryRenderedComponentsWithType = va, kt.scryRenderedDOMComponentsWithClass = ga, kt.scryRenderedDOMComponentsWithTag = qi, kt.traverseTwoPhase = ba;
  }()), kt;
}
process.env.NODE_ENV === "production" ? J_() : eS();
const Wf = (e, t) => {
  if (e)
    return (t == null ? void 0 : t[e]) ?? e;
}, tS = (e, t, r) => {
  var i, s, l, u, c;
  const { defaultErrorMessage: n, errorMessageMap: o, errorMessageResolver: a } = r;
  if (a) {
    const p = a(t);
    if (p) {
      e == null || e.error(p);
      return;
    }
  }
  if ((s = (i = t == null ? void 0 : t.data) == null ? void 0 : i.error) != null && s.errors) {
    let p = 0, d = "";
    for (const f in t.data.error.errors)
      p === 0 && (d = t.data.error.errors[f].message ?? ((l = t.data.error.errors[f]) == null ? void 0 : l.msg) ?? t.data.error.message ?? "validation error"), p++;
    e == null || e.error(`${Wf(d, o)} ${p > 1 ? `(+${p - 1})` : ""}`);
  } else
    e == null || e.error(Wf((c = (u = t == null ? void 0 : t.data) == null ? void 0 : u.error) == null ? void 0 : c.message, o) ?? n ?? "");
};
function z5(e) {
  return { handleApiResponse: Le(
    (r, n) => {
      const {
        toastError: o = !0,
        toastSuccess: a = !0,
        defaultErrorMessage: i,
        onError: s,
        errorMessageMap: l,
        successMessage: u,
        onSuccess: c,
        redirect: p,
        errorMessageResolver: d
      } = n ?? {}, { toast: f, navigate: m } = e ?? {};
      if ("data" in r)
        a && u && (f == null || f.success(u)), c == null || c(r.data), p && (m == null || m(p));
      else if ("error" in r) {
        const v = r.error;
        o && tS(f, v, {
          defaultErrorMessage: i,
          errorMessageMap: l,
          errorMessageResolver: d
        }), s == null || s(v);
      } else
        console.log("unable to parse api response: " + JSON.stringify(r));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ) };
}
const rS = (e, t) => ({
  query: {
    ...e.query,
    offset: t
  }
}), nS = (e) => {
  if ("entries" in e)
    return e.entries;
}, oS = (e) => {
  if ("meta" in e) {
    const t = e.meta;
    return !t.count || t.count && t.offset + t.limit >= t.count ? void 0 : t.offset + t.limit;
  }
}, aS = (e) => e.query.offset, iS = (e, t, r) => {
  const {
    combineParams: n = rS,
    getNextPageParam: o = oS,
    transformResponse: a = nS,
    resolvePageIndex: i = aS,
    initialPageParam: s = 0,
    onError: l,
    skip: u
  } = r || {}, [c, p] = me({}), [d, f] = me(s), [m, v] = me(s), [h, _] = me(!1), g = async (y, w) => {
    try {
      const S = n(y, w);
      _(!0);
      const k = await e(S);
      if (k.data) {
        const T = o(k.data);
        f(T);
        const R = i(S), I = a(k.data);
        p((C) => ({ ...C, [R]: I }));
      }
      if (k.error)
        throw k.error;
    } catch (S) {
      l == null || l(S);
    } finally {
      _(!1);
    }
  };
  ge(() => {
    u || (p({}), f(s), v(s), g(t, s).then(() => {
    }));
  }, [JSON.stringify(t), u]);
  const b = ae(() => !!d, [d]), x = () => {
    d !== void 0 && (g(t, d).then(() => {
    }), v(d), f(void 0));
  }, E = ae(() => Object.keys(c).sort((w, S) => parseInt(w) - parseInt(S)).reduce((w, S) => [...w, ...c[S]], []), [c]), O = ae(() => h && d !== m, [m, h, d]), P = ae(() => h && d === m, [m, h, d]);
  return {
    fetchNextPage: x,
    hasNextPage: b,
    isFetchingNextPage: O,
    isFetchingInitialPage: P,
    data: E
  };
}, q5 = iS, sS = (e, t) => {
  ge(() => {
    var r;
    (r = e.current) == null || r.scrollTo(0, 0);
  }, [t, e]);
}, G5 = sS, lS = ({ margin: e = "-1px 0px 0px 0px", threshold: t = [1] }) => {
  const r = ce(null), [n, o] = me(!1);
  return ge(() => {
    if (!r.current)
      return;
    if (!("IntersectionObserver" in window)) {
      o(!0);
      return;
    }
    const a = new IntersectionObserver(
      ([i]) => {
        o(i.intersectionRatio < 1);
      },
      {
        threshold: t,
        rootMargin: e
      }
    );
    return a.observe(r.current), () => a.disconnect();
  }, [e, t]), { ref: r, isSticky: n };
}, Q5 = lS, K5 = {
  Page: {
    classes: {
      root: ""
    }
  },
  BottomNavigation: {
    classes: {
      root: "",
      container: "px-4 rounded-t-[40px] shadow-[0px_4px_4px_0px_#00000040] border border-[#FFFFFF3D] border-b-[transparent] bg-[radial-gradient(33.48%_103.75%_at_52.2%_0%,rgba(174,92,255,1)_0%,rgba(42,28,91,0.97)_100%)]"
    }
  },
  BottomNavigationAction: {
    classes: {
      root: "",
      label: "transition-color text-[#816ED9] text-[12px] leading-4 font-bold mt-1",
      indicator: "opacity-0 transition-opacity bg-[#B8C3FF] shadow-[0px_-1px_8px_0px_#B8C3FF40]",
      indicatorShadow: "opacity-0 transition-opacity bg-[linear-gradient(180deg,_rgba(147,120,255,0)_0%,rgba(147,120,255,0.25)_100%)]",
      // Variants: primary
      root_primary: `!h-[90px] !justify-start pt-4 w-[90px] bg-purple-800 rounded-full -translate-y-[8px] self-end
        shadow-[0px_8px_8px_0px_#00000054,0px_8px_16px_0px_#00000026,4px_4px_8px_0px_#FFFFFF40_inset,-4px_-4px_16px_0px_#00000080_inset]
        `,
      "root_primary:active": `!h-[90px] !justify-start pt-4 w-[90px] bg-purple-800 rounded-full -translate-y-[8px] self-end
        shadow-[0px_8px_8px_0px_#00000054,0px_8px_16px_0px_#00000026,4px_4px_8px_0px_#FFFFFF40_inset,-4px_-4px_16px_0px_#00000080_inset]
        `,
      label_primary: "text-[18px] drop-shadow-[#00000040] text-transparent bg-clip-text font-semibold bg-gradient-to-b from-[#F3F3FF] to-[#B8BAFB] line-height-[22px]",
      // Variants: normal
      "label_normal:active": "text-[#B8C3FF]",
      "indicator_normal:active": "opacity-100",
      "indicatorShadow_normal:active": "!opacity-50"
    }
  },
  // Inputs
  TextField: {
    classes: {
      root: "",
      input: `p-4 border-2 transition-colors border-[#4e46b2] text-xl placeholder-[#CFBFF2] focus:border-[#6c6ce8] text-[#CFBFF2] rounded-xl outline-0 w-full bg-transparent
       bg-[radial-gradient(52.2%_100%_at_50.75%_100%,rgba(99,53,168,0.5)_0%,rgba(52,34,107,0.25)_100%)]
       shadow-[0px_4px_4px_0px_#00000040,0px_0px_16px_0px_#0057FF1A_inset]
      `,
      "input:sm": "h-[40px] text-sm leading-6",
      "input:md": "h-[48px] text-lg leading-6",
      "input:lg": "h-[56px] text-xl leading-6",
      "input:xl": "h-[70px] text-xl leading-6",
      iconContainer: "absolute",
      "iconContainer:sm": "left-2 top-2 mr-2 max-h-6 max-w-6",
      "iconContainer:md": "left-3 top-2 mr-2 max-h-6 max-w-6",
      "iconContainer:lg": "left-4 top-3 mr-2 max-h-8 max-w-8",
      "iconContainer:xl": "left-4 top-4 mr-2 max-h-8 max-w-8",
      // Variants: normal
      // Variants: disabled
      input_disabled: "opacity-60 cursor-not-allowed",
      // Variants: error
      input_error: "border-rose-500 focus:border-rose-500"
    }
  },
  CodeField: {
    classes: {
      root: ""
    }
  },
  Button: {
    classes: {
      root: "transition-all w-full flex justify-center items-center disabled:opacity-90 disabled:pointer-events-none",
      "root:sm": "h-[40px] text-sm leading-6",
      "root:md": "h-[48px] text-lg leading-6",
      "root:lg": "h-[56px] text-xl leading-6",
      "root:xl": "h-[70px] text-xl leading-6",
      spinner: "",
      "spinner:sm": "h-4 w-4",
      "spinner:md": "h-5 w-5",
      "spinner:lg": "h-8 w-8",
      "spinner:xl": "h-10 w-10",
      label: "flex items-center justify-center gap-x-2 font-bold [text-shadow:1px_1px_0px_rgba(0,0,0,0.25)]",
      // Variants: primary
      root_primary: `rounded-[32px] border border-[#6549c6]
        bg-[radial-gradient(45.41%_100%_at_50%_0%,#9D4EF8_0%,#411EB9_100%)]
        active:translate-y-0.5
        active:bg-[radial-gradient(45.41%_100%_at_50%_0%,_#461DB9_0%,_#4600DB_100%)]
        active:shadow-[0px_0px_16px_0px_rgba(0,_0,_0,_0.20)_inset,_0px_0px_4px_0px_rgba(0,_0,_0,_0.25)]
        shadow-[0_0_16px_0_rgba(255,255,255,0.20)_inset,0_2px_0_0_#291871,0_4px_4px_0px_rgba(0,0,0,0.25)]
      `,
      label_primary: "text-white",
      // Variants: secondary
      root_secondary: `rounded-[32px] border border-[#3a2765]
        bg-[radial-gradient(47.88%_51.87%_at_50%_48.12%,_rgba(23,_22,_67,_0.50)_0%,_rgba(52,_51,_134,_0.50)_100%)]
        shadow-[0px_4px_8px_0px_rgba(242,_189,_255,_0.15)_inset,_0px_4px_4px_0px_rgba(0,_0,_0,_0.25)]
        active:bg-[radial-gradient(47.88%_51.87%_at_50%_48.12%,_rgba(23,_22,_67,_0.90)_0%,_rgba(52,_51,_134,_0.50)_100%)]
        active:shadow-[0px_0px_4px_0px_#00000040,0px_4px_8px_0px_#00000026_inset]
        active:translate-y-0.5
      `,
      label_secondary: "text-[#C7C7EC]",
      // Variants: danger
      root_danger: `rounded-[32px] border border-[#d5376d]
        bg-[radial-gradient(45.41%_100%_at_50%_0%,#FF67AA_0%,#CC0A4C_100%)]
        active:bg-[radial-gradient(47.88%_51.87%_at_50%_48.12%,_rgba(255,_64,_96,_0.90)_0%,_rgba(255,_64,_96,_0.50)_100%)]
        shadow-[0px_0px_16px_0px_#FFFFFF33_inset,0px_4px_4px_0px_#00000040,0px_2px_0px_0px_#8C0F37]
        active:shadow-[0px_0px_4px_0px_#00000040,0px_4px_8px_0px_#00000026_inset]
        active:translate-y-0.5
      `,
      label_danger: "[text-shadow:1px_1px_0px_rgba(0,0,0,0.25)] text-transparent bg-[linear-gradient(180deg,#FFFFFF_90%,#B7B4FE_98.85%)] bg-clip-text",
      // Variants: yellow
      root_yellow: `rounded-[32px] border border-[#F7D452]
        bg-[radial-gradient(45.41%_100%_at_50%_0%,#F1D7B7_0%,#E09F64_100%)]
        active:bg-[radial-gradient(45.41%_100%_at_50%_0%,#A65028_0%,#C8672E_100%)]
        shadow-[0px_0px_16px_0px_#FFFFFF33_inset,0px_2px_0px_0px_#6C3722,0px_4px_4px_0px_#0000003F]
        active:shadow-[0px_0px_16px_0px_#00000033_inset,0px_0px_4px_0px_#0000003F]
        active:border-[#b57259]
        active:translate-y-0.5
      `,
      label_yellow: `
        bg-[linear-gradient(181deg,#6C3722_0.61%,#3A1A10_98.85%)]
        bg-clip-text
        text-transparent
        [text-shadow:1px_1px_0px_rgba(0,0,0,0.25)]
      `
    }
  },
  Drawer: {
    classes: {
      root: "fixed top-0 left-0 z-20 h-full w-full overflow-y-hidden flex flex-col",
      backDrop: "absolute top-0 left-0 h-full w-full z-[21] bg-black/50 transition duration-300 data-[closed]:opacity-0 ",
      drawerTop: "flex h-8 justify-center",
      drawerBody: "",
      container: "z-[22] max-h-[calc(100dvh-40px)] flex flex-col w-full rounded-t-[32px] bg-[radial-gradient(50%_100%_at_50%_0%,#1F0E67_0%,#141240_100%)] shadow-[0px_-8px_24px_0px_rgba(0,0,0,0.5)]",
      safeZone: "pb-14 px-10",
      // Variants: full-screen
      "container_full-screen": "!max-h-dvh h-full !rounded-none transition-all"
    }
  },
  DrawerTitle: {
    classes: {
      root: "mb-6",
      title: "bg-[linear-gradient(180deg,#F3F3FF_12.82%,#B8BAFB_58.21%)] bg-clip-text text-[32px] font-semibold text-transparent",
      subTitle: "text-center text-lg tracking-[-0.6px] text-[#B3A2D7]",
      backButtonWrapper: "left-0 top-1",
      closeButtonWrapper: "right-0 top-1"
    }
  },
  PageTitle: {
    classes: {
      root: "",
      label: "text-3xl font-semibold bg-gradient-to-b from-[#F3F3FF] to-[#B8BAFB] inline-block text-transparent bg-clip-text"
    }
  },
  CopyWrapper: {
    classes: {
      root: "bg-[rgba(255,255,255,0.1)] rounded-lg",
      icon: "m-1 mr-0 bg-[rgba(0,0,0,0.25)] rounded-lg p-1",
      label: "m-1.5 text-lg font-semibold bg-[linear-gradient(180deg,#F3F3FF_12.82%,#B8BAFB_58.21%)] inline-block text-transparent bg-clip-text"
    }
  },
  Checkbox: {
    classes: {
      root: "h-fit w-fit",
      input: "appearance-none",
      symbol: "pointer-events-none",
      "symbol:sm": "h-4 w-4",
      "symbol:md": "h-5 w-5",
      "symbol:lg": "h-8 w-8",
      "input:sm": "h-8 w-8 rounded-lg",
      "input:md": "h-10 w-10 rounded-[10px]",
      "input:lg": "h-12 w-12 rounded-xl",
      "root:sm": "!h-8 w-8 ",
      "root:md": "!h-10 w-10",
      "root:lg": "!h-12 w-12",
      input_filled: "checked:border-[#30595e] border-[#FFFFFF0D] checked:bg-[#00000040] checked:border-2 border bg-[#FFFFFF0D]",
      input_outlined: "checked:border-[#30595e] border-[#FFFFFF0D]  checked:border-2 border"
    }
  },
  BackButton: {
    classes: {
      root: "w-[40px] h-[40px] transition ease-in-out delay-150",
      root_circular: `border border-[#3a2765] rounded-full
      bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.16)_0%,rgba(63,62,112,0.16)_100%)]
      hover:bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.25)_0%,rgba(63,62,112,0.25)_100%)]
      active:bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.35)_0%,rgba(63,62,112,0.35)_100%)]
      shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]`,
      root_squared: "rounded-lg bg-[rgba(0,0,0,0.25)] active:bg-[rgba(0,0,0,0.45)] hover:bg-[rgba(0,0,0,0.35)]",
      icon: "bg-transparent mx-auto"
    }
  },
  LanguageSelector: {
    classes: {
      arrow: "text-[#B3A2D7]",
      "arrow:sm": "w-4 h-4 mr-2",
      "arrow:md": "w-5 h-5 mr-2",
      "arrow:lg": "w-5 h-5 mr-2",
      "arrow:xl": "w-6 h-6 mr-2",
      title: "text-[#B8BAFB] text-[32px] font-bold [text-shadow:0px_1px_0px_rgba(0,0,0,0.20)]",
      flag: "object-cover object-center rounded-full border border-[rgba(255,255,255,0.25)]",
      "flag:sm": "ml-1 w-8 h-8",
      "flag:md": "w-9 h-9",
      "flag:lg": "w-10 h-10",
      "flag:xl": "-ml-1.5 w-14 h-14"
    }
  },
  List: {
    classes: {
      root: "rounded-3xl bg-white bg-opacity-[0.03] border  border-[rgba(255,255,255,0.10)] divide-y divide-[rgba(255,255,255,0.10)] shadow-[0px_8px_16px_0px_rgba(0,0,0,0.10)]"
    }
  },
  Select: {
    classes: {
      root: "flex w-full flex-col gap-2",
      label: "text-white text-xl font-bold",
      select: "text-[#CFBFF2] px-4 rounded-xl border-2 border-[#4e46b2] bg-[radial-gradient(52.2%_100%_at_50.75%_100%,rgba(99,53,168,0.5)_0%,rgba(52,34,107,0.25)_100%)] shadow-[0px_8px_16px_0px_rgba(0,0,0,0.25)]",
      "select:sm": "h-[40px] text-sm leading-6",
      "select:md": "h-[48px] text-lg leading-6",
      "select:lg": "h-[56px] text-xl leading-6",
      "select:xl": "h-[70px] text-xl leading-6",
      optionsContainer: "mt-2 w-[var(--button-width)] divide-y divide-[#53346e] origin-top rounded-lg bg-[radial-gradient(46.81%_58.96%_at_50%_0%,#3B2A7E_0%,#151E51_100%)] transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 z-30 shadow-[0px_8px_16px_0px_rgba(0,0,0,0.25)]",
      option: "text-[#CFBFF2] px-4 py-2 text-left text-xl",
      selectedOption: "font-medium",
      errorText: "text-rose-500",
      helperText: "text-[#CFBFF2] text-sm my-1 text-right px-2"
    }
  },
  Dialog: {
    classes: {
      root: "focus:outline-none",
      backDrop: "fixed inset-0 bg-black/50 backdrop-blur-2xl z-10",
      containerWrapper: "fixed inset-0 flex w-screen items-center justify-center p-4 z-[11]",
      container: "data-[closed]:transform-[scale(95%)] shadow-[0px_-8px_24px_0px_rgba(0,0,0,0.50)] w-full max-w-sm rounded-2xl border-2 border-[#FFFFFF19] bg-[radial-gradient(50%_100%_at_50%_0%,_#1F0E67_0%,#141240_100%)] p-5 duration-300 ease-out data-[closed]:opacity-0 z-[12]",
      title: "text-gradient-content-fancy mb-6 text-center text-xl leading-6 font-semibold"
    }
  },
  Transaction: {
    classes: {
      root: "p-6",
      label: "text-lg font-semibold bg-[linear-gradient(180deg,#F3F3FF_12.82%,#B8BAFB_58.21%)] inline-block text-transparent bg-clip-text",
      timestamp: "text-[rgba(179,162,215,1)] text-xs font-normal mt-1",
      currency: "text-base text-[rgba(236,236,255,1)] opacity-40 leading-5 mt-0.5",
      amount: "text-lg font-semibold leading-tight",
      amount_positive: "text-[#22C17B]",
      amount_negative: "text-[#FF4060]",
      extraSubtitle: "text-[#B3A2D7]"
    }
  },
  StatusChip: {
    classes: {
      root: "h-[25px] relative border  rounded-2xl w-fit px-2 py-1",
      label: "text-sm font-medium inline-block text-transparent bg-clip-text",
      root_green: "bg-[linear-gradient(277.01deg,#02735B1A,#1EFE831A)] border-[rgba(30,254,168,0.25)]",
      label_green: "bg-[linear-gradient(11.33deg,#239B75_-6.8%,#1EFE83_110.81%)]",
      root_yellow: "bg-[linear-gradient(277.01deg,rgba(194,161,61,0.1)_-5.57%,rgba(254,168,30,0.1)_97.29%)] border-[#FECD1E40]",
      label_yellow: "bg-[linear-gradient(11.33deg,#9B6923,#FEC61E)]",
      root_blue: "bg-[linear-gradient(277.01deg,rgba(61,162,194,0.1)_-5.57%,rgba(30,202,254,0.1)_97.29%)] border-[#1ECAFE40]",
      label_blue: "bg-[linear-gradient(11.33deg,#237F9B,#1ECAFE)]",
      root_rose: "bg-[linear-gradient(277.01deg,rgba(115,2,29,0.1)_-5.57%,rgba(254,30,82,0.1)_97.29%)] border-[#FE1E5240]",
      label_rose: "bg-[linear-gradient(11.33deg,#9B233F_-6.8%,#FE1E52_110.81%)]",
      root_gray: "bg-[linear-gradient(277.01deg,rgba(71,71,71,0.1)_-5.57%,rgba(142,142,142,0.1)_97.29%)] border-[#8E8E8E40]",
      label_gray: "bg-[linear-gradient(11.33deg,#5F5F5F_-6.8%,#8E8E8E_110.81%)]",
      "root_pending-audit": "bg-[linear-gradient(277.01deg,rgba(194,161,61,0.1)_-5.57%,rgba(254,168,30,0.1)_97.29%)] border-[#FECD1E40]",
      "label_pending-audit": "bg-[linear-gradient(11.33deg,#9B6923,#FEC61E)]"
    }
  },
  Card: {
    classes: {
      root: "bg-[#0A062D]",
      "root:sm": "rounded-sm",
      "root:md": "rounded-md",
      "root:lg": "rounded-lg",
      "root:xl": "rounded-2xl",
      root_primary: "border border-white border-opacity-10"
    }
  },
  TabNavigation: {
    classes: {
      root: "flex gap-2",
      "root:horizontal": "flex-row",
      "root:vertical": "flex-col",
      tab: "flex-shrink-0"
    }
  },
  SelectOptions: {
    classes: {
      image: "max-h-12 object-center object-contain",
      image_circular: "h-8 w-8 flex-shrink-0 rounded-full border border-[rgba(255,255,255,0.25)] object-cover object-center"
    }
  },
  EmptyState: {
    classes: {
      root: "flex flex-col justify-center items-center rounded-3xl bg-white bg-opacity-[0.03] border border-[rgba(255,255,255,0.10)] shadow-[0px_8px_16px_0px_rgba(0,0,0,0.10)]",
      title: "text-[#B8BAFB]",
      subTitle: "text-[#B3A2D7]",
      // Variants: sm
      "root:sm": "py-4 px-4 rounded-2xl",
      "title:sm": "text-base",
      "subTitle:sm": "text-sm",
      // Variants: md
      "root:md": "py-6 px-4 rounded-3xl",
      "title:md": "text-lg",
      "subTitle:md": "text-sm",
      // Variants: lg
      "root:lg": "py-6 px-4 rounded-3xl",
      "title:lg": "text-xl",
      "subTitle:lg": "text-base"
    }
  },
  Skeleton: {
    classes: {
      root: "animate-pulse bg-[#1f2051] rounded-md w-full h-full"
    }
  }
}, X5 = {
  Page: {
    classes: {
      root: ""
    }
  },
  BottomNavigation: {
    classes: {
      root: "",
      container: "h-[56px] px-[10px] flex items-center justify-between bg-bottomMenu"
    }
  },
  BottomNavigationAction: {
    classes: {
      root: "h-[56px] w-[56px]",
      label: "transition-[color,font-weight] text-content-secondary text-[12px] leading-3 mt-1 mb-[10px]",
      indicator: "opacity-0 h-[1px] rounded-t-sm transition-opacity bg-content-base shadow-[0px_-1px_8px_0px_rgba(184,195,255,0.25)]",
      indicatorShadow: "opacity-0 transition-opacity bg-[linear-gradient(180deg,_rgba(147,120,255,0)_0%,rgba(147,120,255,0.25)_100%)]",
      // Variants: primary
      root_primary: `!h-[90px] !justify-start pt-4 w-[90px] rounded-full -translate-y-[8px] self-end
        shadow-[0px_8px_8px_0px_#00000054,0px_8px_16px_0px_#00000026,4px_4px_8px_0px_#FFFFFF40_inset,-4px_-4px_16px_0px_#00000080_inset]
        `,
      "root_primary:active": `!h-[90px] !justify-start pt-4 w-[90px] rounded-full -translate-y-[8px] self-end
        shadow-[0px_8px_8px_0px_#00000054,0px_8px_16px_0px_#00000026,4px_4px_8px_0px_#FFFFFF40_inset,-4px_-4px_16px_0px_#00000080_inset]
        `,
      label_primary: "text-[18px] drop-shadow-[#00000040] font-semibold text-content-secondary line-height-[22px]",
      // Variants: normal
      "label_normal:active": "font-bold text-content-base",
      "indicator_normal:active": "opacity-100",
      "indicatorShadow_normal:active": "!opacity-50"
    }
  },
  // Inputs
  TextField: {
    classes: {
      root: "w-full",
      input: "text-content-base bg-darkBrand-800 placeholder-content-secondary border-border-base border focus:border-accentBrand-400 outline-0 px-4 w-full",
      "input:sm": "h-[40px] text-base leading-5 rounded-md",
      "input:md": "h-[48px] text-base leading-5 rounded-md",
      "input:lg": "h-[50px] text-base leading-5 rounded-md",
      "input:xl": "h-[50px] text-2xl leading-5 rounded-md",
      iconContainer: "absolute",
      "iconContainer:sm": "left-2 top-2 mr-2 max-h-6 max-w-6",
      "iconContainer:md": "left-3 top-2 mr-2 max-h-6 max-w-6",
      "iconContainer:lg": "left-4 top-3 mr-2 max-h-8 max-w-8",
      "iconContainer:xl": "left-4 top-4 mr-2 max-h-8 max-w-8",
      // Variants: normal
      // Variants: disabled
      input_disabled: "opacity-60 cursor-not-allowed",
      // Variants: error
      input_error: "border-error-base"
    }
  },
  CodeField: {
    classes: {
      root: "",
      input: "appearance-none",
      input_ghost: "!border-0 !border-b-2 !rounded-none ![background:unset]"
    }
  },
  NumberField: {
    classes: {
      root: "",
      inputContainer: "relative text-white flex w-full flex-row items-center border-border-base border focus-within:border-accentBrand-400 bg-darkBrand-800 px-4 outline-0",
      "inputContainer:sm": "h-[50px] rounded-md text-2xl",
      "inputContainer:md": "h-[50px] rounded-md text-2xl",
      "inputContainer:lg": "h-[50px] rounded-md text-2xl",
      inputContainerError: "border-error-base",
      currency: "absolute right-3 text-base text-content-secondary"
    }
  },
  FieldHelperText: {
    classes: {
      root: "text-xs mt-1 leading-4 text-right transition-[max-height]",
      helperText: "text-content-secondary",
      errorText: "text-error-base"
    }
  },
  Button: {
    classes: {
      root: "transition-all duration-200 will-change-auto w-full flex justify-center items-center disabled:pointer-events-none",
      "root:sm": "h-[26px] text-[12px] leading-[16px] rounded-md",
      "root:md": "h-[40px] text-base leading-[19px] rounded-lg",
      "root:lg": "h-[50px] text-base leading-[19px] rounded-lg",
      "root:xl": "h-[70px] text-lg leading-6 rounded-lg",
      spinner: "text-accentBrand-200",
      "spinner:sm": "h-4 w-4",
      "spinner:md": "h-5 w-5",
      "spinner:lg": "h-6 w-6",
      "spinner:xl": "h-10 w-10",
      label: "flex items-center justify-center gap-x-2 font-bold",
      // Variants: primary
      root_primary: `
        bg-grdPrimary
        active:bg-grdPrimaryAlt
        disabled:bg-primary-base disabled:opacity-40 disabled:[background-image:none]
      `,
      label_primary: "text-content-base drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)]",
      // Variants: secondary
      root_secondary: `
        bg-secondary-dark
        active:bg-secondary-darker
        disabled:opacity-50
      `,
      label_secondary: "text-content-base [text-shadow:1px_1px_0px_rgba(0,0,0,0.25)]",
      // Variants: danger
      root_danger: `
        bg-error-base
        active:bg-error-darker
        disabled:opacity-40
      `,
      label_danger: "drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)] text-[#EBE9FF]",
      // Variants: yellow
      root_yellow: `
        bg-[#E8BC89]
        active:bg-[#E09F64]
        disabled:opacity-50
      `,
      label_yellow: "text-[#6C3722]",
      // Variants: contained
      root_contained: `
        bg-darkBrand-800
        border-border-base
        border
        disabled:opacity-40
      `,
      // Variants: green
      root_green: `
        bg-success-base
        active:bg-success-darker
        disabled:opacity-40
      `,
      label_green: "text-content-base drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)]",
      //Variant: pink
      root_pink: `
      bg-[#EA1865]
      active:bg-[#EA1865]
      disabled:opacity-40
    `,
      label_pink: "text-white drop-shadow-[1px_0px_2px_rgba(0,0,0,0.60)]",
      // Shiny effect
      shinyWrapper: "overflow-hidden",
      "shinyWrapper:sm": "rounded-md",
      "shinyWrapper:md": "rounded-lg",
      "shinyWrapper:lg": "rounded-lg",
      "shinyWrapper:xl": "rounded-lg",
      shiny: "w-[190px] pointer-events-none h-full bg-[linear-gradient(110deg,_rgba(255,_255,_255,_0.00)_25.38%,_rgba(255,_255,_255,_0.75)_53.96%,_rgba(255,_255,_255,_0.00)_83.85%)]"
    }
  },
  ButtonIcon: {
    classes: {
      root: "transition-all duration-200 will-change-auto flex justify-center items-center disabled:pointer-events-none",
      "root:sm": "h-5 w-5 rounded",
      "root:md": "h-8 w-8 rounded-md",
      "root:lg": "h-11 w-11 rounded-md",
      "icon:sm": "h-3.5 w-3.5",
      "icon:md": "h-6 w-6",
      "icon:lg": "h-6 w-6",
      // Variants: contained
      root_contained: `
        bg-darkBrand-700
        active:bg-darkBrand-600
        disabled:opacity-40
      `,
      // Variants: ghost
      root_ghost: `
        text-content-base
        active:text-content-secondary
        disabled:opacity-50
      `
    }
  },
  Drawer: {
    classes: {
      root: "fixed top-0 left-0 z-20 h-full w-full overflow-y-hidden flex flex-col",
      backDrop: "absolute blur top-0 left-0 h-full w-full z-[21] bg-backdrop transition duration-300 data-[closed]:opacity-0 ",
      drawerTop: "flex h-8 justify-center",
      drawerBody: "",
      container: "z-[22] border-t border-border-base max-h-[calc(100dvh-40px)] flex flex-col w-full rounded-t-[20px] bg-dialog",
      safeZone: "pb-8 px-5",
      // Variants: full-screen
      "container_full-screen": "!max-h-dvh h-full !rounded-none transition-all"
    }
  },
  DrawerTitle: {
    classes: {
      root: "my-4",
      title: "text-[28px] font-bold leading-[34px] text-content-base",
      "title:sm": "text-[18px] leading-[22px]",
      "title:md": "text-[22px] leading-[27px]",
      "title:lg": "text-[28px] leading-[34px]",
      subTitle: "text-center text-sm tracking-[-0.6px] text-content-secondary",
      backButtonWrapper: "left-0 top-0",
      closeButtonWrapper: "right-0 top-0"
    }
  },
  PageTitle: {
    classes: {
      root: "",
      root_solid: "pb-2 pt-2",
      label: "text-[22px] font-semibold leading-[27px] inline-block content-base",
      labelOverlay: "",
      star: "",
      // Variants: gradient-yellow
      "root_gradient-yellow": "pb-1",
      "label_gradient-yellow": "inline-block h-[35px] w-fit text-center text-[26px] font-bold leading-[34px] text-[#6420A9] [-webkit-text-stroke:0.5px_rgb(100,_32,_169)] [text-shadow:0_-2px_#fdf3c8,0px_2px_4.3px_rgba(0,0,0,0.20),0px_1px_0px_#6420A9]",
      "labelOverlay_gradient-yellow": "inline-block h-[35px] w-fit  bg-[radial-gradient(73.07%_107.87%_at_50.18%_1.14%,_#F7D452_0%,_#BA83FD_100%)] bg-clip-text text-center text-[26px] font-bold leading-[34px] text-transparent",
      "star_gradient-yellow": "",
      // Variants: gradient-purple
      "root_gradient-purple": "",
      "label_gradient-purple": "text-darkBrand-600 pt-[1px] pl-[0.5px] text-2xl font-bold leading-8 [text-shadow:0px_2px_0px_rgba(0,0,0,0.20),0px_1px_0px_currentColor] [-webkit-text-stroke:0.5px_currentColor]",
      "labelOverlay_gradient-purple": "text-2xl font-bold leading-8 bg-pageTitle bg-clip-text text-transparent"
    }
  },
  CopyWrapper: {
    classes: {
      root: "bg-[rgba(255,255,255,0.1)] rounded-lg",
      icon: "m-1 mr-0 bg-[rgba(0,0,0,0.25)] rounded-lg p-1",
      label: "m-1.5 text-lg font-semibold bg-[linear-gradient(180deg,#F3F3FF_12.82%,#B8BAFB_58.21%)] inline-block text-transparent bg-clip-text"
    }
  },
  Checkbox: {
    classes: {
      root: "h-fit w-fit flex justify-center items-center",
      input: "appearance-none rounded-full",
      symbol: "pointer-events-none [filter:drop-shadow(0.5px_1px_0px_rgba(0, 0, 0, 0.40)]",
      "symbol:sm": "h-[18px] w-[18px]",
      "symbol:md": "h-[18px] w-[18px]",
      "symbol:lg": "h-[18px] w-[18px]",
      "input:sm": "!h-[22px] !w-[22px]",
      "input:md": "!h-[22px] !w-[22px]",
      "input:lg": "!h-[22px] !w-[22px]",
      "root:sm": "!h-8 w-8 ",
      "root:md": "!h-8 w-8",
      "root:lg": "!h-8 w-8",
      input_filled: "border-border-base checked:bg-darkBrand-600 border-2 ",
      input_outlined: "checked:border-border-base border-border-base border-2"
    }
  },
  BackButton: {
    classes: {
      root: "w-[40px] h-[40px] transition ease-in-out delay-150",
      root_circular: `border border-[#3a2765] rounded-full
      bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.16)_0%,rgba(63,62,112,0.16)_100%)]
      hover:bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.25)_0%,rgba(63,62,112,0.25)_100%)]
      active:bg-[radial-gradient(50%_100%_at_50%_0%,rgba(81,79,144,0.35)_0%,rgba(63,62,112,0.35)_100%)]
      shadow-[0px_4px_4px_0px_rgba(0,0,0,0.25)]`,
      root_squared: "rounded-lg bg-[rgba(0,0,0,0.25)] active:bg-[rgba(0,0,0,0.45)] hover:bg-[rgba(0,0,0,0.35)]",
      icon: "bg-transparent mx-auto"
    }
  },
  LanguageSelector: {
    classes: {
      root: "flex items-center w-full px-2",
      "root:sm": "h-5 w-5 rounded",
      "root:md": "h-8 w-8 rounded-md",
      "root:lg": "h-11 w-11 rounded-md",
      arrow: "text-[#B3A2D7]",
      "arrow:sm": "w-2 h-2 ml-auto",
      "arrow:md": "w-3 h-3 ml-auto",
      "arrow:lg": "w-3 h-3 ml-auto",
      "arrow:xl": "w-3 h-3 ml-auto",
      label: "text-[#EBE9FF] mr-2",
      "label:sm": "text-sm",
      "label:md": "text-sm",
      "label:lg": "text-sm",
      flag: "object-cover object-center rounded-full",
      "flag:sm": "w-5 h-5",
      "flag:md": "w-5 h-5",
      "flag:lg": "w-5 h-5",
      "flag:xl": "w-5 h-5"
    }
  },
  List: {
    classes: {
      root: "rounded-md bg-white bg-opacity-[0.04] border border-[#FFFFFF0F] divide-y divide-[#FFFFFF14]"
    }
  },
  Select: {
    classes: {
      root: "flex w-full flex-col gap-2",
      label: "text-content-base text-xl font-bold",
      select: "text-content-base bg-darkBrand-800 placeholder-content-secondary border-border-base border focus:border-accentBrand-400  outline-0 px-4",
      "select:sm": "h-[40px] text-base leading-5 rounded-md",
      "select:md": "h-[48px] text-base leading-5 rounded-md",
      "select:lg": "h-[50px] text-base leading-5 rounded-md",
      "select:xl": "h-[50px] text-2xl leading-5 rounded-md",
      optionsContainer: "mt-2 w-[var(--button-width)] origin-top rounded-lg bg-darkBrand-800 transition duration-200 ease-out data-[closed]:scale-95 data-[closed]:opacity-0 z-30 shadow-[0px_8px_16px_0px_rgba(0,0,0,0.25)]",
      option: "text-content-base px-4 py-2 text-left text-base active:bg-white active:bg-opacity-5",
      selectedOption: "font-medium",
      errorText: "text-error-base",
      helperText: "text-content-secondary text-sm my-1 text-right px-2",
      iconDropdown: "w-[18px] h-[18px ]"
    }
  },
  Dialog: {
    classes: {
      root: "focus:outline-none",
      backDrop: "fixed inset-0 bg-backdrop backdrop-blur z-10",
      containerWrapper: "fixed inset-0 flex w-screen items-center justify-center p-4 z-[11]",
      container: "data-[closed]:transform-[scale(95%)] shadow-[0px_-8px_24px_0px_rgba(0,0,0,0.50)] w-full max-w-sm rounded-md border-1 border-white/10 bg-dialog px-4 py-5 duration-300 ease-out data-[closed]:opacity-0 z-[12]",
      title: "text-white mb-6 text-center text-xl leading-6 font-semibold"
    }
  },
  Transaction: {
    classes: {
      root: "p-4",
      label: "text-sm font-bold text-content-base inline-block",
      timestamp: "text-xs font-normal text-content-base",
      currency: "text-sm leading-4",
      amount: "text-sm font-bold leading-5",
      amount_positive: "text-success-base",
      amount_negative: "!text-error-base",
      extraSubtitle: "text-content-secondary text-xs",
      idLabel: "text-content-secondary text-xs leading-4"
    }
  },
  StatusChip: {
    classes: {
      root: "h-[18px] relative border flex items-center border-border-transparent rounded-[4px] w-fit px-2 py-0",
      label: "text-[10px] leading-4 inline-block text-content-base",
      dot: "w-1.5 h-1.5 flex-shrink-0 rounded-full mr-1.5",
      dot_green: "bg-success-base",
      dot_yellow: "bg-warning-base",
      dot_blue: "bg-informative-base",
      dot_rose: "bg-error-base",
      dot_gray: "bg-secondary-lighter",
      "dot_pending-audit": "bg-secondary-light"
    }
  },
  Card: {
    classes: {
      root: "bg-card",
      "root:sm": "rounded-sm",
      "root:md": "rounded-md",
      "root:lg": "rounded-lg",
      "root:xl": "rounded-2xl",
      root_primary: "border border-white border-opacity-10"
    }
  },
  TabNavigation: {
    classes: {
      root: "flex gap-1.5",
      "root:horizontal": "flex-row",
      "root:vertical": "flex-col",
      tab: "flex-shrink-0"
    }
  },
  SelectOptions: {
    classes: {
      image: "max-h-12 object-center object-contain",
      image_circular: "h-8 w-8 flex-shrink-0 rounded-full border border-[rgba(255,255,255,0.25)] object-cover object-center"
    }
  },
  EmptyState: {
    classes: {
      root: "flex flex-col justify-center items-center rounded-md bg-white bg-opacity-[0.03] border border-[rgba(255,255,255,0.10)] shadow-[0px_8px_16px_0px_rgba(0,0,0,0.10)]",
      title: "text-content-secondary",
      subTitle: "text-content-secondary",
      // Variants: sm
      "root:sm": "py-4 px-4 rounded-sm",
      "title:sm": "text-sm",
      "subTitle:sm": "text-xs",
      // Variants: md
      "root:md": "py-4 px-4 rounded-md",
      "title:md": "text-sm",
      "subTitle:md": "text-xs",
      // Variants: lg
      "root:lg": "py-4 px-4 rounded-md",
      "title:lg": "text-base",
      "subTitle:lg": "text-xs"
    }
  },
  Skeleton: {
    classes: {
      root: "animate-pulse bg-darkBrand-800 rounded-md w-full h-full"
    }
  }
}, Uu = $e({
  preset: null
}), Z5 = Uu.Provider, J5 = Uu.Consumer, Ge = (e, t, r, n) => {
  const { preset: o } = Oe(Uu);
  return {
    themeClasses: ae(() => {
      var i;
      return U_(
        (i = o == null ? void 0 : o[e]) == null ? void 0 : i.classes,
        t,
        r,
        n
      );
    }, [e, o, t, r, n])
  };
};
function cS(e) {
  return {
    createRegister: e.mutation({
      invalidatesTags: ["register"],
      query: (t) => ({
        url: "/register/create",
        method: "POST",
        body: t,
        validateStatus: er
      }),
      transformResponse: (t, r, n) => {
        const a = dt({
          nextRequestAt: Ee.DateTime,
          expiredAt: Ee.DateTime
        })(t);
        try {
          Rh(n.phone, a.nextRequestAt);
        } catch (i) {
          console.error("Failed to persist due at", i);
        }
        return a;
      }
    }),
    submitRegister: e.mutation({
      invalidatesTags: ["register"],
      query: (t) => ({
        url: "/register/submit",
        method: "POST",
        body: t,
        validateStatus: er
      }),
      transformResponse: dt()
    }),
    verifyOTP: e.mutation({
      invalidatesTags: ["register"],
      query: (t) => ({
        url: "/register/verify",
        method: "POST",
        body: t,
        validateStatus: er
      }),
      transformResponse: dt()
    })
  };
}
function uS(e) {
  return {
    getInfo: e.query({
      providesTags: ["info"],
      query: ({ query: t }) => ({
        url: `/info${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt()
    })
  };
}
function dS(e) {
  return {
    getServerConfig: e.query({
      providesTags: ["serverConfig"],
      queryFn: async ({ env: t, group: r, name: n }) => {
        const o = (/* @__PURE__ */ new Date()).getTime();
        return {
          data: await fetch(
            `https://raw.githubusercontent.com/99techteam/kz-config/main/groups/${r}/${n}/${t}.json?t=` + o,
            {
              cache: "no-store"
            }
          ).then((i) => i.json())
        };
      }
    })
  };
}
const fS = ["register", "info", "serverConfig"], Yf = {
  reducerPath: "publicApi",
  tagTypes: fS,
  endpoints: (e) => ({
    ...cS(e),
    ...uS(e),
    ...dS(e)
  })
};
function pS(e) {
  return {
    getAccountVariable: e.query({
      providesTags: ["account-variables"],
      query: ({ query: t }) => ({
        url: `/member/account-variables${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt()
    })
  };
}
function mS(e) {
  return {
    addBankAccount: e.mutation({
      query: (t) => ({
        url: "/member/bank-account/create",
        validateStatus: er,
        method: "POST",
        body: t
      }),
      transformResponse: dt()
    })
  };
}
function hS(e) {
  return {
    getDepositMethods: e.query({
      providesTags: ["deposit-methods"],
      query: () => ({
        url: "/member/deposit-methods",
        validateStatus: er
      }),
      transformResponse: dt(Rv)
    })
  };
}
function gS(e) {
  return {
    getGameList: e.query({
      providesTags: ["games"],
      query: ({ query: t }) => ({
        url: `/member/game/list${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt()
    }),
    getGameGateway: e.query({
      providesTags: ["games", "game-providers"],
      query: ({ query: t }) => ({
        url: `/member/game/gateway${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt()
    }),
    getGameProviderList: e.query({
      providesTags: ["game-providers"],
      query: ({ query: t }) => ({
        url: `/member/game/providers${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt()
    }),
    getGameProviderStats: e.query({
      providesTags: ["game-providers"],
      query: () => ({
        url: "/member/game/stats",
        method: "GET",
        validateStatus: er
      }),
      transformResponse: dt()
    }),
    getGameCategoryList: e.query({
      providesTags: ["game-categories"],
      query: ({ query: t }) => ({
        url: `/member/category/list${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt()
    }),
    getGameRecentList: e.query({
      providesTags: ["game-recent"],
      query: ({ query: t }) => ({
        url: `/member/game/recent${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt()
    })
  };
}
function vS(e) {
  return {
    getReferralInfo: e.query({
      providesTags: ["referral"],
      query: () => ({
        url: "/member/referral/info",
        method: "GET"
      }),
      transformResponse: dt(kv)
    }),
    getReferralAvailableClaim: e.query({
      query: () => ({
        url: "/member/referral/claim/available",
        method: "GET"
      }),
      transformResponse: dt({
        availableAmount: Ee.BigNumber
      })
    }),
    claimReferral: e.mutation({
      invalidatesTags: ["referral", "referral-stats", "referral-tx"],
      query: () => ({
        url: "/member/referral/claim",
        method: "POST"
      })
    }),
    getReferralOverall: e.query({
      providesTags: ["referral-stats"],
      query: () => ({
        url: "/member/referral/overall",
        method: "GET"
      }),
      transformResponse: dt(Ov)
    }),
    getReferralTxHistory: e.query({
      providesTags: ["referral-tx"],
      query: ({ query: t }) => ({
        url: `/member/referral/tx/list${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt(gf)
    }),
    getReferralFriendHistory: e.query({
      providesTags: ["referral-friend"],
      query: ({ query: t }) => ({
        url: `/member/referral/friend/list${Mr(t)}`,
        method: "GET"
      }),
      transformResponse: dt(gf)
    })
  };
}
function yS(e) {
  return {
    getRewardsStatus: e.query({
      //controlled fetch
      query: () => ({
        url: "/member/wallet/reward/status",
        method: "GET"
      }),
      transformResponse: dt(av)
    }),
    claimReward: e.mutation({
      invalidatesTags: ["rewards"],
      query: ({ query: t }) => ({
        url: `/member/wallet/reward/claim${Mr(t)}`,
        validateStatus: er,
        method: "POST"
      }),
      transformResponse: dt(Dm)
    })
  };
}
function bS(e) {
  return {
    getTermConditions: e.query({
      providesTags: ["term-conditions"],
      query: () => ({
        url: "/member/terms-and-conditions",
        method: "GET"
      }),
      transformResponse: dt()
    })
  };
}
function wS(e) {
  return {
    topup: e.mutation({
      invalidatesTags: ["funding-tx"],
      query: (t) => ({
        url: "/member/topup",
        validateStatus: er,
        method: "POST",
        body: t
      }),
      transformResponse: dt()
    }),
    uploadProof: e.mutation({
      query: ({ fundingTxId: t, file: r }) => {
        const n = new FormData();
        return n.append("files", r), {
          url: `/member/topup/${t}/proof`,
          method: "POST",
          body: n,
          formData: !0
        };
      },
      transformResponse: dt()
    })
  };
}
function xS(e) {
  return {
    getFundingHistory: e.query({
      providesTags: ["funding-tx"],
      query: ({ query: t }) => ({
        url: `/member/funding/tx/list${Mr(t)}`,
        validateStatus: er
      }),
      transformResponse: Ef(Dm)
    }),
    getBettingHistory: e.query({
      providesTags: ["game-tx"],
      query: ({ query: t }) => ({
        url: `/member/game/tx/list${Mr(t)}`,
        validateStatus: er
      }),
      transformResponse: Ef(uv)
    })
  };
}
function _S(e) {
  return {
    withdraw: e.mutation({
      invalidatesTags: ["funding-tx"],
      query: (t) => ({
        url: "/member/withdraw",
        validateStatus: er,
        method: "POST",
        body: t
      }),
      transformResponse: dt()
    })
  };
}
const SS = [
  "funding-tx",
  "game-tx",
  "bank-account",
  "games",
  "game-providers",
  "game-categories",
  "game-recent",
  "rewards",
  "deposit-methods",
  "term-conditions",
  "referral",
  "referral-tx",
  "referral-friend",
  "referral-stats",
  "account-variables"
], Bf = {
  reducerPath: "siteApi",
  tagTypes: SS,
  endpoints: (e) => ({
    ...mS(e),
    ...wS(e),
    ...xS(e),
    ..._S(e),
    ...gS(e),
    ...yS(e),
    ...hS(e),
    ...bS(e),
    ...vS(e),
    ...pS(e)
  })
};
function $c(e) {
  return `Minified Redux error #${e}; visit https://redux.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var Ql = () => Math.random().toString(36).substring(7).split("").join("."), ES = {
  INIT: `@@redux/INIT${/* @__PURE__ */ Ql()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ Ql()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${Ql()}`
}, ja = ES;
function So(e) {
  if (typeof e != "object" || e === null)
    return !1;
  let t = e;
  for (; Object.getPrototypeOf(t) !== null; )
    t = Object.getPrototypeOf(t);
  return Object.getPrototypeOf(e) === t || Object.getPrototypeOf(e) === null;
}
function TS(e) {
  if (e === void 0)
    return "undefined";
  if (e === null)
    return "null";
  const t = typeof e;
  switch (t) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function":
      return t;
  }
  if (Array.isArray(e))
    return "array";
  if (DS(e))
    return "date";
  if (OS(e))
    return "error";
  const r = kS(e);
  switch (r) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return r;
  }
  return Object.prototype.toString.call(e).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function kS(e) {
  return typeof e.constructor == "function" ? e.constructor.name : null;
}
function OS(e) {
  return e instanceof Error || typeof e.message == "string" && e.constructor && typeof e.constructor.stackTraceLimit == "number";
}
function DS(e) {
  return e instanceof Date ? !0 : typeof e.toDateString == "function" && typeof e.getDate == "function" && typeof e.setDate == "function";
}
function NS(e) {
  let t = typeof e;
  return process.env.NODE_ENV !== "production" && (t = TS(e)), t;
}
function jf(e) {
  typeof console < "u" && typeof console.error == "function" && console.error(e);
  try {
    throw new Error(e);
  } catch {
  }
}
function CS(e, t, r, n) {
  const o = Object.keys(t), a = r && r.type === ja.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (o.length === 0)
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  if (!So(e))
    return `The ${a} has unexpected type of "${NS(e)}". Expected argument to be an object with the following keys: "${o.join('", "')}"`;
  const i = Object.keys(e).filter((s) => !t.hasOwnProperty(s) && !n[s]);
  if (i.forEach((s) => {
    n[s] = !0;
  }), !(r && r.type === ja.REPLACE) && i.length > 0)
    return `Unexpected ${i.length > 1 ? "keys" : "key"} "${i.join('", "')}" found in ${a}. Expected to find one of the known reducer keys instead: "${o.join('", "')}". Unexpected keys will be ignored.`;
}
function PS(e) {
  Object.keys(e).forEach((t) => {
    const r = e[t];
    if (typeof r(void 0, {
      type: ja.INIT
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? $c(12) : `The slice reducer for key "${t}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    if (typeof r(void 0, {
      type: ja.PROBE_UNKNOWN_ACTION()
    }) > "u")
      throw new Error(process.env.NODE_ENV === "production" ? $c(13) : `The slice reducer for key "${t}" returned undefined when probed with a random type. Don't try to handle '${ja.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
  });
}
function MS(e) {
  const t = Object.keys(e), r = {};
  for (let i = 0; i < t.length; i++) {
    const s = t[i];
    process.env.NODE_ENV !== "production" && typeof e[s] > "u" && jf(`No reducer provided for key "${s}"`), typeof e[s] == "function" && (r[s] = e[s]);
  }
  const n = Object.keys(r);
  let o;
  process.env.NODE_ENV !== "production" && (o = {});
  let a;
  try {
    PS(r);
  } catch (i) {
    a = i;
  }
  return function(s = {}, l) {
    if (a)
      throw a;
    if (process.env.NODE_ENV !== "production") {
      const p = CS(s, r, l, o);
      p && jf(p);
    }
    let u = !1;
    const c = {};
    for (let p = 0; p < n.length; p++) {
      const d = n[p], f = r[d], m = s[d], v = f(m, l);
      if (typeof v > "u") {
        const h = l && l.type;
        throw new Error(process.env.NODE_ENV === "production" ? $c(14) : `When called with an action of type ${h ? `"${String(h)}"` : "(unknown type)"}, the slice reducer for key "${d}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      c[d] = v, u = u || v !== m;
    }
    return u = u || n.length !== Object.keys(s).length, u ? c : s;
  };
}
function Ah(e) {
  return So(e) && "type" in e && typeof e.type == "string";
}
var Hu = Symbol.for("immer-nothing"), Ua = Symbol.for("immer-draftable"), cr = Symbol.for("immer-state"), Ih = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function Ct(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const r = Ih[e], n = typeof r == "function" ? r.apply(null, t) : r;
    throw new Error(`[Immer] ${n}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Eo = Object.getPrototypeOf;
function jr(e) {
  return !!e && !!e[cr];
}
function Ur(e) {
  var t;
  return e ? Fh(e) || Array.isArray(e) || !!e[Ua] || !!((t = e.constructor) != null && t[Ua]) || bi(e) || wi(e) : !1;
}
var RS = Object.prototype.constructor.toString();
function Fh(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Eo(e);
  if (t === null)
    return !0;
  const r = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return r === Object ? !0 : typeof r == "function" && Function.toString.call(r) === RS;
}
function AS(e) {
  return jr(e) || Ct(15, e), e[cr].base_;
}
function Ja(e, t) {
  To(e) === 0 ? Reflect.ownKeys(e).forEach((r) => {
    t(r, e[r], e);
  }) : e.forEach((r, n) => t(n, r, e));
}
function To(e) {
  const t = e[cr];
  return t ? t.type_ : Array.isArray(e) ? 1 : bi(e) ? 2 : wi(e) ? 3 : 0;
}
function ei(e, t) {
  return To(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function Kl(e, t) {
  return To(e) === 2 ? e.get(t) : e[t];
}
function Lh(e, t, r) {
  const n = To(e);
  n === 2 ? e.set(t, r) : n === 3 ? e.add(r) : e[t] = r;
}
function IS(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function bi(e) {
  return e instanceof Map;
}
function wi(e) {
  return e instanceof Set;
}
function po(e) {
  return e.copy_ || e.base_;
}
function Wc(e, t) {
  if (bi(e))
    return new Map(e);
  if (wi(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const r = Fh(e);
  if (t === !0 || t === "class_only" && !r) {
    const n = Object.getOwnPropertyDescriptors(e);
    delete n[cr];
    let o = Reflect.ownKeys(n);
    for (let a = 0; a < o.length; a++) {
      const i = o[a], s = n[i];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (n[i] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: e[i]
      });
    }
    return Object.create(Eo(e), n);
  } else {
    const n = Eo(e);
    if (n !== null && r)
      return { ...e };
    const o = Object.create(n);
    return Object.assign(o, e);
  }
}
function Vu(e, t = !1) {
  return il(e) || jr(e) || !Ur(e) || (To(e) > 1 && (e.set = e.add = e.clear = e.delete = FS), Object.freeze(e), t && Object.entries(e).forEach(([r, n]) => Vu(n, !0))), e;
}
function FS() {
  Ct(2);
}
function il(e) {
  return Object.isFrozen(e);
}
var Yc = {};
function ko(e) {
  const t = Yc[e];
  return t || Ct(0, e), t;
}
function LS(e, t) {
  Yc[e] || (Yc[e] = t);
}
var ti;
function $h() {
  return ti;
}
function $S(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function Uf(e, t) {
  t && (ko("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Bc(e) {
  jc(e), e.drafts_.forEach(WS), e.drafts_ = null;
}
function jc(e) {
  e === ti && (ti = e.parent_);
}
function Hf(e) {
  return ti = $S(ti, e);
}
function WS(e) {
  const t = e[cr];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function Vf(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const r = t.drafts_[0];
  return e !== void 0 && e !== r ? (r[cr].modified_ && (Bc(t), Ct(4)), Ur(e) && (e = Rs(t, e), t.parent_ || As(t, e)), t.patches_ && ko("Patches").generateReplacementPatches_(
    r[cr].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = Rs(t, r, []), Bc(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== Hu ? e : void 0;
}
function Rs(e, t, r) {
  if (il(t))
    return t;
  const n = t[cr];
  if (!n)
    return Ja(
      t,
      (o, a) => zf(e, n, t, o, a, r)
    ), t;
  if (n.scope_ !== e)
    return t;
  if (!n.modified_)
    return As(e, n.base_, !0), n.base_;
  if (!n.finalized_) {
    n.finalized_ = !0, n.scope_.unfinalizedDrafts_--;
    const o = n.copy_;
    let a = o, i = !1;
    n.type_ === 3 && (a = new Set(o), o.clear(), i = !0), Ja(
      a,
      (s, l) => zf(e, n, o, s, l, r, i)
    ), As(e, o, !1), r && e.patches_ && ko("Patches").generatePatches_(
      n,
      r,
      e.patches_,
      e.inversePatches_
    );
  }
  return n.copy_;
}
function zf(e, t, r, n, o, a, i) {
  if (process.env.NODE_ENV !== "production" && o === r && Ct(5), jr(o)) {
    const s = a && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !ei(t.assigned_, n) ? a.concat(n) : void 0, l = Rs(e, o, s);
    if (Lh(r, n, l), jr(l))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else i && r.add(o);
  if (Ur(o) && !il(o)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    Rs(e, o), (!t || !t.scope_.parent_) && typeof n != "symbol" && Object.prototype.propertyIsEnumerable.call(r, n) && As(e, o);
  }
}
function As(e, t, r = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && Vu(t, r);
}
function YS(e, t) {
  const r = Array.isArray(e), n = {
    type_: r ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : $h(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let o = n, a = zu;
  r && (o = [n], a = ri);
  const { revoke: i, proxy: s } = Proxy.revocable(o, a);
  return n.draft_ = s, n.revoke_ = i, s;
}
var zu = {
  get(e, t) {
    if (t === cr)
      return e;
    const r = po(e);
    if (!ei(r, t))
      return BS(e, r, t);
    const n = r[t];
    return e.finalized_ || !Ur(n) ? n : n === Xl(e.base_, t) ? (Zl(e), e.copy_[t] = Hc(n, e)) : n;
  },
  has(e, t) {
    return t in po(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(po(e));
  },
  set(e, t, r) {
    const n = Wh(po(e), t);
    if (n != null && n.set)
      return n.set.call(e.draft_, r), !0;
    if (!e.modified_) {
      const o = Xl(po(e), t), a = o == null ? void 0 : o[cr];
      if (a && a.base_ === r)
        return e.copy_[t] = r, e.assigned_[t] = !1, !0;
      if (IS(r, o) && (r !== void 0 || ei(e.base_, t)))
        return !0;
      Zl(e), Uc(e);
    }
    return e.copy_[t] === r && // special case: handle new props with value 'undefined'
    (r !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(r) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = r, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return Xl(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, Zl(e), Uc(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const r = po(e), n = Reflect.getOwnPropertyDescriptor(r, t);
    return n && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: n.enumerable,
      value: r[t]
    };
  },
  defineProperty() {
    Ct(11);
  },
  getPrototypeOf(e) {
    return Eo(e.base_);
  },
  setPrototypeOf() {
    Ct(12);
  }
}, ri = {};
Ja(zu, (e, t) => {
  ri[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
ri.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && Ct(13), ri.set.call(this, e, t, void 0);
};
ri.set = function(e, t, r) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && Ct(14), zu.set.call(this, e[0], t, r, e[0]);
};
function Xl(e, t) {
  const r = e[cr];
  return (r ? po(r) : e)[t];
}
function BS(e, t, r) {
  var o;
  const n = Wh(t, r);
  return n ? "value" in n ? n.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (o = n.get) == null ? void 0 : o.call(e.draft_)
  ) : void 0;
}
function Wh(e, t) {
  if (!(t in e))
    return;
  let r = Eo(e);
  for (; r; ) {
    const n = Object.getOwnPropertyDescriptor(r, t);
    if (n)
      return n;
    r = Eo(r);
  }
}
function Uc(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Uc(e.parent_));
}
function Zl(e) {
  e.copy_ || (e.copy_ = Wc(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var jS = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, r, n) => {
      if (typeof t == "function" && typeof r != "function") {
        const a = r;
        r = t;
        const i = this;
        return function(l = a, ...u) {
          return i.produce(l, (c) => r.call(this, c, ...u));
        };
      }
      typeof r != "function" && Ct(6), n !== void 0 && typeof n != "function" && Ct(7);
      let o;
      if (Ur(t)) {
        const a = Hf(this), i = Hc(t, void 0);
        let s = !0;
        try {
          o = r(i), s = !1;
        } finally {
          s ? Bc(a) : jc(a);
        }
        return Uf(a, n), Vf(o, a);
      } else if (!t || typeof t != "object") {
        if (o = r(t), o === void 0 && (o = t), o === Hu && (o = void 0), this.autoFreeze_ && Vu(o, !0), n) {
          const a = [], i = [];
          ko("Patches").generateReplacementPatches_(t, o, a, i), n(a, i);
        }
        return o;
      } else
        Ct(1, t);
    }, this.produceWithPatches = (t, r) => {
      if (typeof t == "function")
        return (i, ...s) => this.produceWithPatches(i, (l) => t(l, ...s));
      let n, o;
      return [this.produce(t, r, (i, s) => {
        n = i, o = s;
      }), n, o];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    Ur(e) || Ct(8), jr(e) && (e = Yh(e));
    const t = Hf(this), r = Hc(e, void 0);
    return r[cr].isManual_ = !0, jc(t), r;
  }
  finishDraft(e, t) {
    const r = e && e[cr];
    (!r || !r.isManual_) && Ct(9);
    const { scope_: n } = r;
    return Uf(n, t), Vf(void 0, n);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let r;
    for (r = t.length - 1; r >= 0; r--) {
      const o = t[r];
      if (o.path.length === 0 && o.op === "replace") {
        e = o.value;
        break;
      }
    }
    r > -1 && (t = t.slice(r + 1));
    const n = ko("Patches").applyPatches_;
    return jr(e) ? n(e, t) : this.produce(
      e,
      (o) => n(o, t)
    );
  }
};
function Hc(e, t) {
  const r = bi(e) ? ko("MapSet").proxyMap_(e, t) : wi(e) ? ko("MapSet").proxySet_(e, t) : YS(e, t);
  return (t ? t.scope_ : $h()).drafts_.push(r), r;
}
function Yh(e) {
  return jr(e) || Ct(10, e), Bh(e);
}
function Bh(e) {
  if (!Ur(e) || il(e))
    return e;
  const t = e[cr];
  let r;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, r = Wc(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    r = Wc(e, !0);
  return Ja(r, (n, o) => {
    Lh(r, n, Bh(o));
  }), t && (t.finalized_ = !1), r;
}
function US() {
  process.env.NODE_ENV !== "production" && Ih.push(
    'Sets cannot have "replace" patches.',
    function(d) {
      return "Unsupported patch operation: " + d;
    },
    function(d) {
      return "Cannot apply patch, path doesn't resolve: " + d;
    },
    "Patching reserved attributes like __proto__, prototype and constructor is not allowed"
  );
  const t = "replace", r = "add", n = "remove";
  function o(d, f, m, v) {
    switch (d.type_) {
      case 0:
      case 2:
        return i(
          d,
          f,
          m,
          v
        );
      case 1:
        return a(d, f, m, v);
      case 3:
        return s(
          d,
          f,
          m,
          v
        );
    }
  }
  function a(d, f, m, v) {
    let { base_: h, assigned_: _ } = d, g = d.copy_;
    g.length < h.length && ([h, g] = [g, h], [m, v] = [v, m]);
    for (let b = 0; b < h.length; b++)
      if (_[b] && g[b] !== h[b]) {
        const x = f.concat([b]);
        m.push({
          op: t,
          path: x,
          // Need to maybe clone it, as it can in fact be the original value
          // due to the base/copy inversion at the start of this function
          value: p(g[b])
        }), v.push({
          op: t,
          path: x,
          value: p(h[b])
        });
      }
    for (let b = h.length; b < g.length; b++) {
      const x = f.concat([b]);
      m.push({
        op: r,
        path: x,
        // Need to maybe clone it, as it can in fact be the original value
        // due to the base/copy inversion at the start of this function
        value: p(g[b])
      });
    }
    for (let b = g.length - 1; h.length <= b; --b) {
      const x = f.concat([b]);
      v.push({
        op: n,
        path: x
      });
    }
  }
  function i(d, f, m, v) {
    const { base_: h, copy_: _ } = d;
    Ja(d.assigned_, (g, b) => {
      const x = Kl(h, g), E = Kl(_, g), O = b ? ei(h, g) ? t : r : n;
      if (x === E && O === t)
        return;
      const P = f.concat(g);
      m.push(O === n ? { op: O, path: P } : { op: O, path: P, value: E }), v.push(
        O === r ? { op: n, path: P } : O === n ? { op: r, path: P, value: p(x) } : { op: t, path: P, value: p(x) }
      );
    });
  }
  function s(d, f, m, v) {
    let { base_: h, copy_: _ } = d, g = 0;
    h.forEach((b) => {
      if (!_.has(b)) {
        const x = f.concat([g]);
        m.push({
          op: n,
          path: x,
          value: b
        }), v.unshift({
          op: r,
          path: x,
          value: b
        });
      }
      g++;
    }), g = 0, _.forEach((b) => {
      if (!h.has(b)) {
        const x = f.concat([g]);
        m.push({
          op: r,
          path: x,
          value: b
        }), v.unshift({
          op: n,
          path: x,
          value: b
        });
      }
      g++;
    });
  }
  function l(d, f, m, v) {
    m.push({
      op: t,
      path: [],
      value: f === Hu ? void 0 : f
    }), v.push({
      op: t,
      path: [],
      value: d
    });
  }
  function u(d, f) {
    return f.forEach((m) => {
      const { path: v, op: h } = m;
      let _ = d;
      for (let E = 0; E < v.length - 1; E++) {
        const O = To(_);
        let P = v[E];
        typeof P != "string" && typeof P != "number" && (P = "" + P), (O === 0 || O === 1) && (P === "__proto__" || P === "constructor") && Ct(19), typeof _ == "function" && P === "prototype" && Ct(19), _ = Kl(_, P), typeof _ != "object" && Ct(18, v.join("/"));
      }
      const g = To(_), b = c(m.value), x = v[v.length - 1];
      switch (h) {
        case t:
          switch (g) {
            case 2:
              return _.set(x, b);
            case 3:
              Ct(16);
            default:
              return _[x] = b;
          }
        case r:
          switch (g) {
            case 1:
              return x === "-" ? _.push(b) : _.splice(x, 0, b);
            case 2:
              return _.set(x, b);
            case 3:
              return _.add(b);
            default:
              return _[x] = b;
          }
        case n:
          switch (g) {
            case 1:
              return _.splice(x, 1);
            case 2:
              return _.delete(x);
            case 3:
              return _.delete(m.value);
            default:
              return delete _[x];
          }
        default:
          Ct(17, h);
      }
    }), d;
  }
  function c(d) {
    if (!Ur(d))
      return d;
    if (Array.isArray(d))
      return d.map(c);
    if (bi(d))
      return new Map(
        Array.from(d.entries()).map(([m, v]) => [m, c(v)])
      );
    if (wi(d))
      return new Set(Array.from(d).map(c));
    const f = Object.create(Eo(d));
    for (const m in d)
      f[m] = c(d[m]);
    return ei(d, Ua) && (f[Ua] = d[Ua]), f;
  }
  function p(d) {
    return jr(d) ? c(d) : d;
  }
  LS("Patches", {
    applyPatches_: u,
    generatePatches_: o,
    generateReplacementPatches_: l
  });
}
var yr = new jS(), xi = yr.produce, jh = yr.produceWithPatches.bind(
  yr
);
yr.setAutoFreeze.bind(yr);
yr.setUseStrictShallowCopy.bind(yr);
var qf = yr.applyPatches.bind(yr);
yr.createDraft.bind(yr);
yr.finishDraft.bind(yr);
var HS = (e, t, r) => {
  if (t.length === 1 && t[0] === r) {
    let n = !1;
    try {
      const o = {};
      e(o) === o && (n = !0);
    } catch {
    }
    if (n) {
      let o;
      try {
        throw new Error();
      } catch (a) {
        ({ stack: o } = a);
      }
      console.warn(
        `The result function returned its own inputs without modification. e.g
\`createSelector([state => state.todos], todos => todos)\`
This could lead to inefficient memoization and unnecessary re-renders.
Ensure transformation logic is in the result function, and extraction logic is in the input selectors.`,
        { stack: o }
      );
    }
  }
}, VS = (e, t, r) => {
  const { memoize: n, memoizeOptions: o } = t, { inputSelectorResults: a, inputSelectorResultsCopy: i } = e, s = n(() => ({}), ...o);
  if (!(s.apply(null, a) === s.apply(null, i))) {
    let u;
    try {
      throw new Error();
    } catch (c) {
      ({ stack: u } = c);
    }
    console.warn(
      `An input selector returned a different result when passed same arguments.
This means your output selector will likely run more frequently than intended.
Avoid returning a new reference inside your input selector, e.g.
\`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)\``,
      {
        arguments: r,
        firstInputs: a,
        secondInputs: i,
        stack: u
      }
    );
  }
}, zS = {
  inputStabilityCheck: "once",
  identityFunctionCheck: "once"
};
function qS(e, t = `expected a function, instead received ${typeof e}`) {
  if (typeof e != "function")
    throw new TypeError(t);
}
function GS(e, t = `expected an object, instead received ${typeof e}`) {
  if (typeof e != "object")
    throw new TypeError(t);
}
function QS(e, t = "expected all items to be functions, instead received the following types: ") {
  if (!e.every((r) => typeof r == "function")) {
    const r = e.map(
      (n) => typeof n == "function" ? `function ${n.name || "unnamed"}()` : typeof n
    ).join(", ");
    throw new TypeError(`${t}[${r}]`);
  }
}
var Gf = (e) => Array.isArray(e) ? e : [e];
function KS(e) {
  const t = Array.isArray(e[0]) ? e[0] : e;
  return QS(
    t,
    "createSelector expects all input-selectors to be functions, but received the following types: "
  ), t;
}
function Qf(e, t) {
  const r = [], { length: n } = e;
  for (let o = 0; o < n; o++)
    r.push(e[o].apply(null, t));
  return r;
}
var XS = (e, t) => {
  const { identityFunctionCheck: r, inputStabilityCheck: n } = {
    ...zS,
    ...t
  };
  return {
    identityFunctionCheck: {
      shouldRun: r === "always" || r === "once" && e,
      run: HS
    },
    inputStabilityCheck: {
      shouldRun: n === "always" || n === "once" && e,
      run: VS
    }
  };
}, ZS = class {
  constructor(e) {
    this.value = e;
  }
  deref() {
    return this.value;
  }
}, JS = typeof WeakRef < "u" ? WeakRef : ZS, e2 = 0, Kf = 1;
function cs() {
  return {
    s: e2,
    v: void 0,
    o: null,
    p: null
  };
}
function ni(e, t = {}) {
  let r = cs();
  const { resultEqualityCheck: n } = t;
  let o, a = 0;
  function i() {
    var p;
    let s = r;
    const { length: l } = arguments;
    for (let d = 0, f = l; d < f; d++) {
      const m = arguments[d];
      if (typeof m == "function" || typeof m == "object" && m !== null) {
        let v = s.o;
        v === null && (s.o = v = /* @__PURE__ */ new WeakMap());
        const h = v.get(m);
        h === void 0 ? (s = cs(), v.set(m, s)) : s = h;
      } else {
        let v = s.p;
        v === null && (s.p = v = /* @__PURE__ */ new Map());
        const h = v.get(m);
        h === void 0 ? (s = cs(), v.set(m, s)) : s = h;
      }
    }
    const u = s;
    let c;
    if (s.s === Kf)
      c = s.v;
    else if (c = e.apply(null, arguments), a++, n) {
      const d = ((p = o == null ? void 0 : o.deref) == null ? void 0 : p.call(o)) ?? o;
      d != null && n(d, c) && (c = d, a !== 0 && a--), o = typeof c == "object" && c !== null || typeof c == "function" ? new JS(c) : c;
    }
    return u.s = Kf, u.v = c, c;
  }
  return i.clearCache = () => {
    r = cs(), i.resetResultsCount();
  }, i.resultsCount = () => a, i.resetResultsCount = () => {
    a = 0;
  }, i;
}
function Uh(e, ...t) {
  const r = typeof e == "function" ? {
    memoize: e,
    memoizeOptions: t
  } : e, n = (...o) => {
    let a = 0, i = 0, s, l = {}, u = o.pop();
    typeof u == "object" && (l = u, u = o.pop()), qS(
      u,
      `createSelector expects an output function after the inputs, but received: [${typeof u}]`
    );
    const c = {
      ...r,
      ...l
    }, {
      memoize: p,
      memoizeOptions: d = [],
      argsMemoize: f = ni,
      argsMemoizeOptions: m = [],
      devModeChecks: v = {}
    } = c, h = Gf(d), _ = Gf(m), g = KS(o), b = p(function() {
      return a++, u.apply(
        null,
        arguments
      );
    }, ...h);
    let x = !0;
    const E = f(function() {
      i++;
      const P = Qf(
        g,
        arguments
      );
      if (s = b.apply(null, P), process.env.NODE_ENV !== "production") {
        const { identityFunctionCheck: y, inputStabilityCheck: w } = XS(x, v);
        if (y.shouldRun && y.run(
          u,
          P,
          s
        ), w.shouldRun) {
          const S = Qf(
            g,
            arguments
          );
          w.run(
            { inputSelectorResults: P, inputSelectorResultsCopy: S },
            { memoize: p, memoizeOptions: h },
            arguments
          );
        }
        x && (x = !1);
      }
      return s;
    }, ..._);
    return Object.assign(E, {
      resultFunc: u,
      memoizedResultFunc: b,
      dependencies: g,
      dependencyRecomputations: () => i,
      resetDependencyRecomputations: () => {
        i = 0;
      },
      lastResult: () => s,
      recomputations: () => a,
      resetRecomputations: () => {
        a = 0;
      },
      memoize: p,
      argsMemoize: f
    });
  };
  return Object.assign(n, {
    withTypes: () => n
  }), n;
}
var qu = /* @__PURE__ */ Uh(ni), t2 = Object.assign(
  (e, t = qu) => {
    GS(
      e,
      `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof e}`
    );
    const r = Object.keys(e), n = r.map(
      (a) => e[a]
    );
    return t(
      n,
      (...a) => a.reduce((i, s, l) => (i[r[l]] = s, i), {})
    );
  },
  { withTypes: () => t2 }
), r2 = (...e) => {
  const t = Uh(...e), r = Object.assign((...n) => {
    const o = t(...n), a = (i, ...s) => o(jr(i) ? Yh(i) : i, ...s);
    return Object.assign(a, o), a;
  }, {
    withTypes: () => r
  });
  return r;
};
r2(ni);
var n2 = (e) => e && typeof e.match == "function";
function tr(e, t) {
  function r(...n) {
    if (t) {
      let o = t(...n);
      if (!o)
        throw new Error(process.env.NODE_ENV === "production" ? ft(0) : "prepareAction did not return an object");
      return {
        type: e,
        payload: o.payload,
        ..."meta" in o && {
          meta: o.meta
        },
        ..."error" in o && {
          error: o.error
        }
      };
    }
    return {
      type: e,
      payload: n[0]
    };
  }
  return r.toString = () => `${e}`, r.type = e, r.match = (n) => Ah(n) && n.type === e, r;
}
function Xf(e) {
  return Ur(e) ? xi(e, () => {
  }) : e;
}
function Zf(e, t, r) {
  if (e.has(t)) {
    let o = e.get(t);
    return r.update && (o = r.update(o, t, e), e.set(t, o)), o;
  }
  if (!r.insert)
    throw new Error(process.env.NODE_ENV === "production" ? ft(10) : "No insert provided for key not already in map");
  const n = r.insert(t, e);
  return e.set(t, n), n;
}
var $a = "RTK_autoBatch", Ca = () => (e) => ({
  payload: e,
  meta: {
    [$a]: !0
  }
});
process.env.NODE_ENV;
function Hh(e) {
  const t = {}, r = [];
  let n;
  const o = {
    addCase(a, i) {
      if (process.env.NODE_ENV !== "production") {
        if (r.length > 0)
          throw new Error(process.env.NODE_ENV === "production" ? ft(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        if (n)
          throw new Error(process.env.NODE_ENV === "production" ? ft(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
      }
      const s = typeof a == "string" ? a : a.type;
      if (!s)
        throw new Error(process.env.NODE_ENV === "production" ? ft(28) : "`builder.addCase` cannot be called with an empty action type");
      if (s in t)
        throw new Error(process.env.NODE_ENV === "production" ? ft(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${s}'`);
      return t[s] = i, o;
    },
    addMatcher(a, i) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? ft(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
      return r.push({
        matcher: a,
        reducer: i
      }), o;
    },
    addDefaultCase(a) {
      if (process.env.NODE_ENV !== "production" && n)
        throw new Error(process.env.NODE_ENV === "production" ? ft(31) : "`builder.addDefaultCase` can only be called once");
      return n = a, o;
    }
  };
  return e(o), [t, r, n];
}
function o2(e) {
  return typeof e == "function";
}
function a2(e, t) {
  if (process.env.NODE_ENV !== "production" && typeof t == "object")
    throw new Error(process.env.NODE_ENV === "production" ? ft(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
  let [r, n, o] = Hh(t), a;
  if (o2(e))
    a = () => Xf(e());
  else {
    const s = Xf(e);
    a = () => s;
  }
  function i(s = a(), l) {
    let u = [r[l.type], ...n.filter(({
      matcher: c
    }) => c(l)).map(({
      reducer: c
    }) => c)];
    return u.filter((c) => !!c).length === 0 && (u = [o]), u.reduce((c, p) => {
      if (p)
        if (jr(c)) {
          const f = p(c, l);
          return f === void 0 ? c : f;
        } else {
          if (Ur(c))
            return xi(c, (d) => p(d, l));
          {
            const d = p(c, l);
            if (d === void 0) {
              if (c === null)
                return c;
              throw new Error(process.env.NODE_ENV === "production" ? ft(9) : "A case reducer on a non-draftable value must not return undefined");
            }
            return d;
          }
        }
      return c;
    }, s);
  }
  return i.getInitialState = a, i;
}
var i2 = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW", Gu = (e = 21) => {
  let t = "", r = e;
  for (; r--; )
    t += i2[Math.random() * 64 | 0];
  return t;
}, Vh = (e, t) => n2(e) ? e.match(t) : e(t);
function Pn(...e) {
  return (t) => e.some((r) => Vh(r, t));
}
function Ha(...e) {
  return (t) => e.every((r) => Vh(r, t));
}
function sl(e, t) {
  if (!e || !e.meta)
    return !1;
  const r = typeof e.meta.requestId == "string", n = t.indexOf(e.meta.requestStatus) > -1;
  return r && n;
}
function _i(e) {
  return typeof e[0] == "function" && "pending" in e[0] && "fulfilled" in e[0] && "rejected" in e[0];
}
function Qu(...e) {
  return e.length === 0 ? (t) => sl(t, ["pending"]) : _i(e) ? Pn(...e.map((t) => t.pending)) : Qu()(e[0]);
}
function Zo(...e) {
  return e.length === 0 ? (t) => sl(t, ["rejected"]) : _i(e) ? Pn(...e.map((t) => t.rejected)) : Zo()(e[0]);
}
function ll(...e) {
  const t = (r) => r && r.meta && r.meta.rejectedWithValue;
  return e.length === 0 ? Ha(Zo(...e), t) : _i(e) ? Ha(Zo(...e), t) : ll()(e[0]);
}
function to(...e) {
  return e.length === 0 ? (t) => sl(t, ["fulfilled"]) : _i(e) ? Pn(...e.map((t) => t.fulfilled)) : to()(e[0]);
}
function Vc(...e) {
  return e.length === 0 ? (t) => sl(t, ["pending", "fulfilled", "rejected"]) : _i(e) ? Pn(...e.flatMap((t) => [t.pending, t.rejected, t.fulfilled])) : Vc()(e[0]);
}
var s2 = ["name", "message", "stack", "code"], Jl = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    Bn(this, "_type");
    this.payload = e, this.meta = t;
  }
}, Jf = class {
  constructor(e, t) {
    /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */
    Bn(this, "_type");
    this.payload = e, this.meta = t;
  }
}, l2 = (e) => {
  if (typeof e == "object" && e !== null) {
    const t = {};
    for (const r of s2)
      typeof e[r] == "string" && (t[r] = e[r]);
    return t;
  }
  return {
    message: String(e)
  };
}, ep = /* @__PURE__ */ (() => {
  function e(t, r, n) {
    const o = tr(t + "/fulfilled", (l, u, c, p) => ({
      payload: l,
      meta: {
        ...p || {},
        arg: c,
        requestId: u,
        requestStatus: "fulfilled"
      }
    })), a = tr(t + "/pending", (l, u, c) => ({
      payload: void 0,
      meta: {
        ...c || {},
        arg: u,
        requestId: l,
        requestStatus: "pending"
      }
    })), i = tr(t + "/rejected", (l, u, c, p, d) => ({
      payload: p,
      error: (n && n.serializeError || l2)(l || "Rejected"),
      meta: {
        ...d || {},
        arg: c,
        requestId: u,
        rejectedWithValue: !!p,
        requestStatus: "rejected",
        aborted: (l == null ? void 0 : l.name) === "AbortError",
        condition: (l == null ? void 0 : l.name) === "ConditionError"
      }
    }));
    function s(l) {
      return (u, c, p) => {
        const d = n != null && n.idGenerator ? n.idGenerator(l) : Gu(), f = new AbortController();
        let m, v;
        function h(g) {
          v = g, f.abort();
        }
        const _ = async function() {
          var x, E;
          let g;
          try {
            let O = (x = n == null ? void 0 : n.condition) == null ? void 0 : x.call(n, l, {
              getState: c,
              extra: p
            });
            if (u2(O) && (O = await O), O === !1 || f.signal.aborted)
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            const P = new Promise((y, w) => {
              m = () => {
                w({
                  name: "AbortError",
                  message: v || "Aborted"
                });
              }, f.signal.addEventListener("abort", m);
            });
            u(a(d, l, (E = n == null ? void 0 : n.getPendingMeta) == null ? void 0 : E.call(n, {
              requestId: d,
              arg: l
            }, {
              getState: c,
              extra: p
            }))), g = await Promise.race([P, Promise.resolve(r(l, {
              dispatch: u,
              getState: c,
              extra: p,
              requestId: d,
              signal: f.signal,
              abort: h,
              rejectWithValue: (y, w) => new Jl(y, w),
              fulfillWithValue: (y, w) => new Jf(y, w)
            })).then((y) => {
              if (y instanceof Jl)
                throw y;
              return y instanceof Jf ? o(y.payload, d, l, y.meta) : o(y, d, l);
            })]);
          } catch (O) {
            g = O instanceof Jl ? i(null, d, l, O.payload, O.meta) : i(O, d, l);
          } finally {
            m && f.signal.removeEventListener("abort", m);
          }
          return n && !n.dispatchConditionRejection && i.match(g) && g.meta.condition || u(g), g;
        }();
        return Object.assign(_, {
          abort: h,
          requestId: d,
          arg: l,
          unwrap() {
            return _.then(c2);
          }
        });
      };
    }
    return Object.assign(s, {
      pending: a,
      rejected: i,
      fulfilled: o,
      settled: Pn(i, o),
      typePrefix: t
    });
  }
  return e.withTypes = () => e, e;
})();
function c2(e) {
  if (e.meta && e.meta.rejectedWithValue)
    throw e.payload;
  if (e.error)
    throw e.error;
  return e.payload;
}
function u2(e) {
  return e !== null && typeof e == "object" && typeof e.then == "function";
}
var d2 = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function f2(e, t) {
  return `${e}/${t}`;
}
function p2({
  creators: e
} = {}) {
  var r;
  const t = (r = e == null ? void 0 : e.asyncThunk) == null ? void 0 : r[d2];
  return function(o) {
    const {
      name: a,
      reducerPath: i = a
    } = o;
    if (!a)
      throw new Error(process.env.NODE_ENV === "production" ? ft(11) : "`name` is a required option for createSlice");
    typeof process < "u" && process.env.NODE_ENV === "development" && o.initialState === void 0 && console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
    const s = (typeof o.reducers == "function" ? o.reducers(h2()) : o.reducers) || {}, l = Object.keys(s), u = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    }, c = {
      addCase(b, x) {
        const E = typeof b == "string" ? b : b.type;
        if (!E)
          throw new Error(process.env.NODE_ENV === "production" ? ft(12) : "`context.addCase` cannot be called with an empty action type");
        if (E in u.sliceCaseReducersByType)
          throw new Error(process.env.NODE_ENV === "production" ? ft(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + E);
        return u.sliceCaseReducersByType[E] = x, c;
      },
      addMatcher(b, x) {
        return u.sliceMatchers.push({
          matcher: b,
          reducer: x
        }), c;
      },
      exposeAction(b, x) {
        return u.actionCreators[b] = x, c;
      },
      exposeCaseReducer(b, x) {
        return u.sliceCaseReducersByName[b] = x, c;
      }
    };
    l.forEach((b) => {
      const x = s[b], E = {
        reducerName: b,
        type: f2(a, b),
        createNotation: typeof o.reducers == "function"
      };
      v2(x) ? b2(E, x, c, t) : g2(E, x, c);
    });
    function p() {
      if (process.env.NODE_ENV !== "production" && typeof o.extraReducers == "object")
        throw new Error(process.env.NODE_ENV === "production" ? ft(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
      const [b = {}, x = [], E = void 0] = typeof o.extraReducers == "function" ? Hh(o.extraReducers) : [o.extraReducers], O = {
        ...b,
        ...u.sliceCaseReducersByType
      };
      return a2(o.initialState, (P) => {
        for (let y in O)
          P.addCase(y, O[y]);
        for (let y of u.sliceMatchers)
          P.addMatcher(y.matcher, y.reducer);
        for (let y of x)
          P.addMatcher(y.matcher, y.reducer);
        E && P.addDefaultCase(E);
      });
    }
    const d = (b) => b, f = /* @__PURE__ */ new Map();
    let m;
    function v(b, x) {
      return m || (m = p()), m(b, x);
    }
    function h() {
      return m || (m = p()), m.getInitialState();
    }
    function _(b, x = !1) {
      function E(P) {
        let y = P[b];
        if (typeof y > "u") {
          if (x)
            y = h();
          else if (process.env.NODE_ENV !== "production")
            throw new Error(process.env.NODE_ENV === "production" ? ft(15) : "selectSlice returned undefined for an uninjected slice reducer");
        }
        return y;
      }
      function O(P = d) {
        const y = Zf(f, x, {
          insert: () => /* @__PURE__ */ new WeakMap()
        });
        return Zf(y, P, {
          insert: () => {
            const w = {};
            for (const [S, k] of Object.entries(o.selectors ?? {}))
              w[S] = m2(k, P, h, x);
            return w;
          }
        });
      }
      return {
        reducerPath: b,
        getSelectors: O,
        get selectors() {
          return O(E);
        },
        selectSlice: E
      };
    }
    const g = {
      name: a,
      reducer: v,
      actions: u.actionCreators,
      caseReducers: u.sliceCaseReducersByName,
      getInitialState: h,
      ..._(i),
      injectInto(b, {
        reducerPath: x,
        ...E
      } = {}) {
        const O = x ?? i;
        return b.inject({
          reducerPath: O,
          reducer: v
        }, E), {
          ...g,
          ..._(O, !0)
        };
      }
    };
    return g;
  };
}
function m2(e, t, r, n) {
  function o(a, ...i) {
    let s = t(a);
    if (typeof s > "u") {
      if (n)
        s = r();
      else if (process.env.NODE_ENV !== "production")
        throw new Error(process.env.NODE_ENV === "production" ? ft(16) : "selectState returned undefined for an uninjected slice reducer");
    }
    return e(s, ...i);
  }
  return o.unwrapped = e, o;
}
var Io = /* @__PURE__ */ p2();
function h2() {
  function e(t, r) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator: t,
      ...r
    };
  }
  return e.withTypes = () => e, {
    reducer(t) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [t.name](...r) {
          return t(...r);
        }
      }[t.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(t, r) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare: t,
        reducer: r
      };
    },
    asyncThunk: e
  };
}
function g2({
  type: e,
  reducerName: t,
  createNotation: r
}, n, o) {
  let a, i;
  if ("reducer" in n) {
    if (r && !y2(n))
      throw new Error(process.env.NODE_ENV === "production" ? ft(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    a = n.reducer, i = n.prepare;
  } else
    a = n;
  o.addCase(e, a).exposeCaseReducer(t, a).exposeAction(t, i ? tr(e, i) : tr(e));
}
function v2(e) {
  return e._reducerDefinitionType === "asyncThunk";
}
function y2(e) {
  return e._reducerDefinitionType === "reducerWithPrepare";
}
function b2({
  type: e,
  reducerName: t
}, r, n, o) {
  if (!o)
    throw new Error(process.env.NODE_ENV === "production" ? ft(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  const {
    payloadCreator: a,
    fulfilled: i,
    pending: s,
    rejected: l,
    settled: u,
    options: c
  } = r, p = o(e, a, c);
  n.exposeAction(t, p), i && n.addCase(p.fulfilled, i), s && n.addCase(p.pending, s), l && n.addCase(p.rejected, l), u && n.addMatcher(p.settled, u), n.exposeCaseReducer(t, {
    fulfilled: i || us,
    pending: s || us,
    rejected: l || us,
    settled: u || us
  });
}
function us() {
}
var w2 = (e, t) => {
  if (typeof e != "function")
    throw new Error(process.env.NODE_ENV === "production" ? ft(32) : `${t} is not a function`);
}, Ku = "listenerMiddleware", x2 = (e) => {
  let {
    type: t,
    actionCreator: r,
    matcher: n,
    predicate: o,
    effect: a
  } = e;
  if (t)
    o = tr(t).match;
  else if (r)
    t = r.type, o = r.match;
  else if (n)
    o = n;
  else if (!o) throw new Error(process.env.NODE_ENV === "production" ? ft(21) : "Creating or removing a listener requires one of the known fields for matching an action");
  return w2(a, "options.listener"), {
    predicate: o,
    type: t,
    effect: a
  };
}, _2 = Object.assign((e) => {
  const {
    type: t,
    predicate: r,
    effect: n
  } = x2(e);
  return {
    id: Gu(),
    effect: n,
    type: t,
    predicate: r,
    pending: /* @__PURE__ */ new Set(),
    unsubscribe: () => {
      throw new Error(process.env.NODE_ENV === "production" ? ft(22) : "Unsubscribe not initialized");
    }
  };
}, {
  withTypes: () => _2
}), S2 = Object.assign(tr(`${Ku}/add`), {
  withTypes: () => S2
});
tr(`${Ku}/removeAll`);
var E2 = Object.assign(tr(`${Ku}/remove`), {
  withTypes: () => E2
});
function ft(e) {
  return `Minified Redux Toolkit error #${e}; visit https://redux-toolkit.js.org/Errors?code=${e} for the full message or use the non-minified dev environment for full errors. `;
}
var zh = /* @__PURE__ */ ((e) => (e.uninitialized = "uninitialized", e.pending = "pending", e.fulfilled = "fulfilled", e.rejected = "rejected", e))(zh || {});
function T2(e) {
  return {
    status: e,
    isUninitialized: e === "uninitialized",
    isLoading: e === "pending",
    isSuccess: e === "fulfilled",
    isError: e === "rejected"
    /* rejected */
  };
}
var tp = (e) => [].concat(...e);
function k2() {
  return typeof navigator > "u" || navigator.onLine === void 0 ? !0 : navigator.onLine;
}
function O2() {
  return typeof document > "u" ? !0 : document.visibilityState !== "hidden";
}
var rp = So;
function qh(e, t) {
  if (e === t || !(rp(e) && rp(t) || Array.isArray(e) && Array.isArray(t)))
    return t;
  const r = Object.keys(t), n = Object.keys(e);
  let o = r.length === n.length;
  const a = Array.isArray(t) ? [] : {};
  for (const i of r)
    a[i] = qh(e[i], t[i]), o && (o = e[i] === a[i]);
  return o ? e : a;
}
var np = class {
  constructor(e, t = void 0) {
    this.value = e, this.meta = t;
  }
}, Xu = /* @__PURE__ */ tr("__rtkq/focused"), Gh = /* @__PURE__ */ tr("__rtkq/unfocused"), Zu = /* @__PURE__ */ tr("__rtkq/online"), Qh = /* @__PURE__ */ tr("__rtkq/offline");
function Kh(e) {
  return e.type === "query";
}
function D2(e) {
  return e.type === "mutation";
}
function Ju(e, t, r, n, o, a) {
  return N2(e) ? e(t, r, n, o).map(zc).map(a) : Array.isArray(e) ? e.map(zc).map(a) : [];
}
function N2(e) {
  return typeof e == "function";
}
function zc(e) {
  return typeof e == "string" ? {
    type: e
  } : e;
}
function op(e) {
  return e != null;
}
function zo(e) {
  let t = 0;
  for (const r in e)
    t++;
  return t;
}
function C2(e, t) {
  return e.catch(t);
}
var oi = Symbol("forceQueryFn"), qc = (e) => typeof e[oi] == "function";
function P2({
  serializeQueryArgs: e,
  queryThunk: t,
  mutationThunk: r,
  api: n,
  context: o
}) {
  const a = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), {
    unsubscribeQueryResult: s,
    removeMutationResult: l,
    updateSubscriptionOptions: u
  } = n.internalActions;
  return {
    buildInitiateQuery: v,
    buildInitiateMutation: h,
    getRunningQueryThunk: c,
    getRunningMutationThunk: p,
    getRunningQueriesThunk: d,
    getRunningMutationsThunk: f
  };
  function c(_, g) {
    return (b) => {
      var O;
      const x = o.endpointDefinitions[_], E = e({
        queryArgs: g,
        endpointDefinition: x,
        endpointName: _
      });
      return (O = a.get(b)) == null ? void 0 : O[E];
    };
  }
  function p(_, g) {
    return (b) => {
      var x;
      return (x = i.get(b)) == null ? void 0 : x[g];
    };
  }
  function d() {
    return (_) => Object.values(a.get(_) || {}).filter(op);
  }
  function f() {
    return (_) => Object.values(i.get(_) || {}).filter(op);
  }
  function m(_) {
    if (process.env.NODE_ENV !== "production") {
      if (m.triggered)
        return;
      const g = _(n.internalActions.internal_getRTKQSubscriptions());
      if (m.triggered = !0, typeof g != "object" || typeof (g == null ? void 0 : g.type) == "string")
        throw new Error(process.env.NODE_ENV === "production" ? ft(34) : `Warning: Middleware for RTK-Query API at reducerPath "${n.reducerPath}" has not been added to the store.
You must add the middleware for RTK-Query to function correctly!`);
    }
  }
  function v(_, g) {
    const b = (x, {
      subscribe: E = !0,
      forceRefetch: O,
      subscriptionOptions: P,
      [oi]: y,
      ...w
    } = {}) => (S, k) => {
      var q;
      const T = e({
        queryArgs: x,
        endpointDefinition: g,
        endpointName: _
      }), R = t({
        ...w,
        type: "query",
        subscribe: E,
        forceRefetch: O,
        subscriptionOptions: P,
        endpointName: _,
        originalArgs: x,
        queryCacheKey: T,
        [oi]: y
      }), I = n.endpoints[_].select(x), C = S(R), A = I(k());
      m(S);
      const {
        requestId: D,
        abort: N
      } = C, M = A.requestId !== D, W = (q = a.get(S)) == null ? void 0 : q[T], B = () => I(k()), j = Object.assign(y ? (
        // a query has been forced (upsertQueryData)
        // -> we want to resolve it once data has been written with the data that will be written
        C.then(B)
      ) : M && !W ? (
        // a query has been skipped due to a condition and we do not have any currently running query
        // -> we want to resolve it immediately with the current data
        Promise.resolve(A)
      ) : (
        // query just started or one is already in flight
        // -> wait for the running query, then resolve with data from after that
        Promise.all([W, C]).then(B)
      ), {
        arg: x,
        requestId: D,
        subscriptionOptions: P,
        queryCacheKey: T,
        abort: N,
        async unwrap() {
          const se = await j;
          if (se.isError)
            throw se.error;
          return se.data;
        },
        refetch: () => S(b(x, {
          subscribe: !1,
          forceRefetch: !0
        })),
        unsubscribe() {
          E && S(s({
            queryCacheKey: T,
            requestId: D
          }));
        },
        updateSubscriptionOptions(se) {
          j.subscriptionOptions = se, S(u({
            endpointName: _,
            requestId: D,
            queryCacheKey: T,
            options: se
          }));
        }
      });
      if (!W && !M && !y) {
        const se = a.get(S) || {};
        se[T] = j, a.set(S, se), j.then(() => {
          delete se[T], zo(se) || a.delete(S);
        });
      }
      return j;
    };
    return b;
  }
  function h(_) {
    return (g, {
      track: b = !0,
      fixedCacheKey: x
    } = {}) => (E, O) => {
      const P = r({
        type: "mutation",
        endpointName: _,
        originalArgs: g,
        track: b,
        fixedCacheKey: x
      }), y = E(P);
      m(E);
      const {
        requestId: w,
        abort: S,
        unwrap: k
      } = y, T = C2(y.unwrap().then((A) => ({
        data: A
      })), (A) => ({
        error: A
      })), R = () => {
        E(l({
          requestId: w,
          fixedCacheKey: x
        }));
      }, I = Object.assign(T, {
        arg: y.arg,
        requestId: w,
        abort: S,
        unwrap: k,
        reset: R
      }), C = i.get(E) || {};
      return i.set(E, C), C[w] = I, I.then(() => {
        delete C[w], zo(C) || i.delete(E);
      }), x && (C[x] = I, I.then(() => {
        C[x] === I && (delete C[x], zo(C) || i.delete(E));
      })), I;
    };
  }
}
function ap(e) {
  return e;
}
function M2({
  reducerPath: e,
  baseQuery: t,
  context: {
    endpointDefinitions: r
  },
  serializeQueryArgs: n,
  api: o,
  assertTagType: a
}) {
  const i = (g, b, x, E) => (O, P) => {
    const y = r[g], w = n({
      queryArgs: b,
      endpointDefinition: y,
      endpointName: g
    });
    if (O(o.internalActions.queryResultPatched({
      queryCacheKey: w,
      patches: x
    })), !E)
      return;
    const S = o.endpoints[g].select(b)(
      // Work around TS 4.1 mismatch
      P()
    ), k = Ju(y.providesTags, S.data, void 0, b, {}, a);
    O(o.internalActions.updateProvidedBy({
      queryCacheKey: w,
      providedTags: k
    }));
  }, s = (g, b, x, E = !0) => (O, P) => {
    const w = o.endpoints[g].select(b)(
      // Work around TS 4.1 mismatch
      P()
    );
    let S = {
      patches: [],
      inversePatches: [],
      undo: () => O(o.util.patchQueryData(g, b, S.inversePatches, E))
    };
    if (w.status === "uninitialized")
      return S;
    let k;
    if ("data" in w)
      if (Ur(w.data)) {
        const [T, R, I] = jh(w.data, x);
        S.patches.push(...R), S.inversePatches.push(...I), k = T;
      } else
        k = x(w.data), S.patches.push({
          op: "replace",
          path: [],
          value: k
        }), S.inversePatches.push({
          op: "replace",
          path: [],
          value: w.data
        });
    return S.patches.length === 0 || O(o.util.patchQueryData(g, b, S.patches, E)), S;
  }, l = (g, b, x) => (E) => E(o.endpoints[g].initiate(b, {
    subscribe: !1,
    forceRefetch: !0,
    [oi]: () => ({
      data: x
    })
  })), u = async (g, {
    signal: b,
    abort: x,
    rejectWithValue: E,
    fulfillWithValue: O,
    dispatch: P,
    getState: y,
    extra: w
  }) => {
    const S = r[g.endpointName];
    try {
      let k = ap, T;
      const R = {
        signal: b,
        abort: x,
        dispatch: P,
        getState: y,
        extra: w,
        endpoint: g.endpointName,
        type: g.type,
        forced: g.type === "query" ? c(g, y()) : void 0
      }, I = g.type === "query" ? g[oi] : void 0;
      if (I ? T = I() : S.query ? (T = await t(S.query(g.originalArgs), R, S.extraOptions), S.transformResponse && (k = S.transformResponse)) : T = await S.queryFn(g.originalArgs, R, S.extraOptions, (C) => t(C, R, S.extraOptions)), typeof process < "u" && process.env.NODE_ENV === "development") {
        const C = S.query ? "`baseQuery`" : "`queryFn`";
        let A;
        if (!T)
          A = `${C} did not return anything.`;
        else if (typeof T != "object")
          A = `${C} did not return an object.`;
        else if (T.error && T.data)
          A = `${C} returned an object containing both \`error\` and \`result\`.`;
        else if (T.error === void 0 && T.data === void 0)
          A = `${C} returned an object containing neither a valid \`error\` and \`result\`. At least one of them should not be \`undefined\``;
        else
          for (const D of Object.keys(T))
            if (D !== "error" && D !== "data" && D !== "meta") {
              A = `The object returned by ${C} has the unknown property ${D}.`;
              break;
            }
        A && console.error(`Error encountered handling the endpoint ${g.endpointName}.
              ${A}
              It needs to return an object with either the shape \`{ data: <value> }\` or \`{ error: <value> }\` that may contain an optional \`meta\` property.
              Object returned was:`, T);
      }
      if (T.error)
        throw new np(T.error, T.meta);
      return O(await k(T.data, T.meta, g.originalArgs), {
        fulfilledTimeStamp: Date.now(),
        baseQueryMeta: T.meta,
        [$a]: !0
      });
    } catch (k) {
      let T = k;
      if (T instanceof np) {
        let R = ap;
        S.query && S.transformErrorResponse && (R = S.transformErrorResponse);
        try {
          return E(await R(T.value, T.meta, g.originalArgs), {
            baseQueryMeta: T.meta,
            [$a]: !0
          });
        } catch (I) {
          T = I;
        }
      }
      throw typeof process < "u" && process.env.NODE_ENV !== "production" ? console.error(`An unhandled error occurred processing a request for the endpoint "${g.endpointName}".
In the case of an unhandled error, no tags will be "provided" or "invalidated".`, T) : console.error(T), T;
    }
  };
  function c(g, b) {
    var y, w, S;
    const x = (w = (y = b[e]) == null ? void 0 : y.queries) == null ? void 0 : w[g.queryCacheKey], E = (S = b[e]) == null ? void 0 : S.config.refetchOnMountOrArgChange, O = x == null ? void 0 : x.fulfilledTimeStamp, P = g.forceRefetch ?? (g.subscribe && E);
    return P ? P === !0 || (Number(/* @__PURE__ */ new Date()) - Number(O)) / 1e3 >= P : !1;
  }
  const p = ep(`${e}/executeQuery`, u, {
    getPendingMeta() {
      return {
        startedTimeStamp: Date.now(),
        [$a]: !0
      };
    },
    condition(g, {
      getState: b
    }) {
      var S, k, T;
      const x = b(), E = (k = (S = x[e]) == null ? void 0 : S.queries) == null ? void 0 : k[g.queryCacheKey], O = E == null ? void 0 : E.fulfilledTimeStamp, P = g.originalArgs, y = E == null ? void 0 : E.originalArgs, w = r[g.endpointName];
      return qc(g) ? !0 : (E == null ? void 0 : E.status) === "pending" ? !1 : c(g, x) || Kh(w) && ((T = w == null ? void 0 : w.forceRefetch) != null && T.call(w, {
        currentArg: P,
        previousArg: y,
        endpointState: E,
        state: x
      })) ? !0 : !O;
    },
    dispatchConditionRejection: !0
  }), d = ep(`${e}/executeMutation`, u, {
    getPendingMeta() {
      return {
        startedTimeStamp: Date.now(),
        [$a]: !0
      };
    }
  }), f = (g) => "force" in g, m = (g) => "ifOlderThan" in g, v = (g, b, x) => (E, O) => {
    const P = f(x) && x.force, y = m(x) && x.ifOlderThan, w = (k = !0) => {
      const T = {
        forceRefetch: k,
        isPrefetch: !0
      };
      return o.endpoints[g].initiate(b, T);
    }, S = o.endpoints[g].select(b)(O());
    if (P)
      E(w());
    else if (y) {
      const k = S == null ? void 0 : S.fulfilledTimeStamp;
      if (!k) {
        E(w());
        return;
      }
      (Number(/* @__PURE__ */ new Date()) - Number(new Date(k))) / 1e3 >= y && E(w());
    } else
      E(w(!1));
  };
  function h(g) {
    return (b) => {
      var x, E;
      return ((E = (x = b == null ? void 0 : b.meta) == null ? void 0 : x.arg) == null ? void 0 : E.endpointName) === g;
    };
  }
  function _(g, b) {
    return {
      matchPending: Ha(Qu(g), h(b)),
      matchFulfilled: Ha(to(g), h(b)),
      matchRejected: Ha(Zo(g), h(b))
    };
  }
  return {
    queryThunk: p,
    mutationThunk: d,
    prefetch: v,
    updateQueryData: s,
    upsertQueryData: l,
    patchQueryData: i,
    buildMatchThunkActions: _
  };
}
function Xh(e, t, r, n) {
  return Ju(r[e.meta.arg.endpointName][t], to(e) ? e.payload : void 0, ll(e) ? e.payload : void 0, e.meta.arg.originalArgs, "baseQueryMeta" in e.meta ? e.meta.baseQueryMeta : void 0, n);
}
function ds(e, t, r) {
  const n = e[t];
  n && r(n);
}
function ai(e) {
  return ("arg" in e ? e.arg.fixedCacheKey : e.fixedCacheKey) ?? e.requestId;
}
function ip(e, t, r) {
  const n = e[ai(t)];
  n && r(n);
}
var Pa = {};
function R2({
  reducerPath: e,
  queryThunk: t,
  mutationThunk: r,
  context: {
    endpointDefinitions: n,
    apiUid: o,
    extractRehydrationInfo: a,
    hasRehydrationInfo: i
  },
  assertTagType: s,
  config: l
}) {
  const u = tr(`${e}/resetApiState`), c = Io({
    name: `${e}/queries`,
    initialState: Pa,
    reducers: {
      removeQueryResult: {
        reducer(b, {
          payload: {
            queryCacheKey: x
          }
        }) {
          delete b[x];
        },
        prepare: Ca()
      },
      queryResultPatched: {
        reducer(b, {
          payload: {
            queryCacheKey: x,
            patches: E
          }
        }) {
          ds(b, x, (O) => {
            O.data = qf(O.data, E.concat());
          });
        },
        prepare: Ca()
      }
    },
    extraReducers(b) {
      b.addCase(t.pending, (x, {
        meta: E,
        meta: {
          arg: O
        }
      }) => {
        var y;
        const P = qc(O);
        x[y = O.queryCacheKey] ?? (x[y] = {
          status: "uninitialized",
          endpointName: O.endpointName
        }), ds(x, O.queryCacheKey, (w) => {
          w.status = "pending", w.requestId = P && w.requestId ? (
            // for `upsertQuery` **updates**, keep the current `requestId`
            w.requestId
          ) : (
            // for normal queries or `upsertQuery` **inserts** always update the `requestId`
            E.requestId
          ), O.originalArgs !== void 0 && (w.originalArgs = O.originalArgs), w.startedTimeStamp = E.startedTimeStamp;
        });
      }).addCase(t.fulfilled, (x, {
        meta: E,
        payload: O
      }) => {
        ds(x, E.arg.queryCacheKey, (P) => {
          if (P.requestId !== E.requestId && !qc(E.arg))
            return;
          const {
            merge: y
          } = n[E.arg.endpointName];
          if (P.status = "fulfilled", y)
            if (P.data !== void 0) {
              const {
                fulfilledTimeStamp: w,
                arg: S,
                baseQueryMeta: k,
                requestId: T
              } = E;
              let R = xi(P.data, (I) => y(I, O, {
                arg: S.originalArgs,
                baseQueryMeta: k,
                fulfilledTimeStamp: w,
                requestId: T
              }));
              P.data = R;
            } else
              P.data = O;
          else
            P.data = n[E.arg.endpointName].structuralSharing ?? !0 ? qh(jr(P.data) ? AS(P.data) : P.data, O) : O;
          delete P.error, P.fulfilledTimeStamp = E.fulfilledTimeStamp;
        });
      }).addCase(t.rejected, (x, {
        meta: {
          condition: E,
          arg: O,
          requestId: P
        },
        error: y,
        payload: w
      }) => {
        ds(x, O.queryCacheKey, (S) => {
          if (!E) {
            if (S.requestId !== P)
              return;
            S.status = "rejected", S.error = w ?? y;
          }
        });
      }).addMatcher(i, (x, E) => {
        const {
          queries: O
        } = a(E);
        for (const [P, y] of Object.entries(O))
          // do not rehydrate entries that were currently in flight.
          ((y == null ? void 0 : y.status) === "fulfilled" || (y == null ? void 0 : y.status) === "rejected") && (x[P] = y);
      });
    }
  }), p = Io({
    name: `${e}/mutations`,
    initialState: Pa,
    reducers: {
      removeMutationResult: {
        reducer(b, {
          payload: x
        }) {
          const E = ai(x);
          E in b && delete b[E];
        },
        prepare: Ca()
      }
    },
    extraReducers(b) {
      b.addCase(r.pending, (x, {
        meta: E,
        meta: {
          requestId: O,
          arg: P,
          startedTimeStamp: y
        }
      }) => {
        P.track && (x[ai(E)] = {
          requestId: O,
          status: "pending",
          endpointName: P.endpointName,
          startedTimeStamp: y
        });
      }).addCase(r.fulfilled, (x, {
        payload: E,
        meta: O
      }) => {
        O.arg.track && ip(x, O, (P) => {
          P.requestId === O.requestId && (P.status = "fulfilled", P.data = E, P.fulfilledTimeStamp = O.fulfilledTimeStamp);
        });
      }).addCase(r.rejected, (x, {
        payload: E,
        error: O,
        meta: P
      }) => {
        P.arg.track && ip(x, P, (y) => {
          y.requestId === P.requestId && (y.status = "rejected", y.error = E ?? O);
        });
      }).addMatcher(i, (x, E) => {
        const {
          mutations: O
        } = a(E);
        for (const [P, y] of Object.entries(O))
          // do not rehydrate entries that were currently in flight.
          ((y == null ? void 0 : y.status) === "fulfilled" || (y == null ? void 0 : y.status) === "rejected") && // only rehydrate endpoints that were persisted using a `fixedCacheKey`
          P !== (y == null ? void 0 : y.requestId) && (x[P] = y);
      });
    }
  }), d = Io({
    name: `${e}/invalidation`,
    initialState: Pa,
    reducers: {
      updateProvidedBy: {
        reducer(b, x) {
          var P, y;
          const {
            queryCacheKey: E,
            providedTags: O
          } = x.payload;
          for (const w of Object.values(b))
            for (const S of Object.values(w)) {
              const k = S.indexOf(E);
              k !== -1 && S.splice(k, 1);
            }
          for (const {
            type: w,
            id: S
          } of O) {
            const k = (P = b[w] ?? (b[w] = {}))[y = S || "__internal_without_id"] ?? (P[y] = []);
            k.includes(E) || k.push(E);
          }
        },
        prepare: Ca()
      }
    },
    extraReducers(b) {
      b.addCase(c.actions.removeQueryResult, (x, {
        payload: {
          queryCacheKey: E
        }
      }) => {
        for (const O of Object.values(x))
          for (const P of Object.values(O)) {
            const y = P.indexOf(E);
            y !== -1 && P.splice(y, 1);
          }
      }).addMatcher(i, (x, E) => {
        var P, y;
        const {
          provided: O
        } = a(E);
        for (const [w, S] of Object.entries(O))
          for (const [k, T] of Object.entries(S)) {
            const R = (P = x[w] ?? (x[w] = {}))[y = k || "__internal_without_id"] ?? (P[y] = []);
            for (const I of T)
              R.includes(I) || R.push(I);
          }
      }).addMatcher(Pn(to(t), ll(t)), (x, E) => {
        const O = Xh(E, "providesTags", n, s), {
          queryCacheKey: P
        } = E.meta.arg;
        d.caseReducers.updateProvidedBy(x, d.actions.updateProvidedBy({
          queryCacheKey: P,
          providedTags: O
        }));
      });
    }
  }), f = Io({
    name: `${e}/subscriptions`,
    initialState: Pa,
    reducers: {
      updateSubscriptionOptions(b, x) {
      },
      unsubscribeQueryResult(b, x) {
      },
      internal_getRTKQSubscriptions() {
      }
    }
  }), m = Io({
    name: `${e}/internalSubscriptions`,
    initialState: Pa,
    reducers: {
      subscriptionsUpdated: {
        reducer(b, x) {
          return qf(b, x.payload);
        },
        prepare: Ca()
      }
    }
  }), v = Io({
    name: `${e}/config`,
    initialState: {
      online: k2(),
      focused: O2(),
      middlewareRegistered: !1,
      ...l
    },
    reducers: {
      middlewareRegistered(b, {
        payload: x
      }) {
        b.middlewareRegistered = b.middlewareRegistered === "conflict" || o !== x ? "conflict" : !0;
      }
    },
    extraReducers: (b) => {
      b.addCase(Zu, (x) => {
        x.online = !0;
      }).addCase(Qh, (x) => {
        x.online = !1;
      }).addCase(Xu, (x) => {
        x.focused = !0;
      }).addCase(Gh, (x) => {
        x.focused = !1;
      }).addMatcher(i, (x) => ({
        ...x
      }));
    }
  }), h = MS({
    queries: c.reducer,
    mutations: p.reducer,
    provided: d.reducer,
    subscriptions: m.reducer,
    config: v.reducer
  }), _ = (b, x) => h(u.match(x) ? void 0 : b, x), g = {
    ...v.actions,
    ...c.actions,
    ...f.actions,
    ...m.actions,
    ...p.actions,
    ...d.actions,
    resetApiState: u
  };
  return {
    reducer: _,
    actions: g
  };
}
var yo = /* @__PURE__ */ Symbol.for("RTKQ/skipToken"), Zh = {
  status: "uninitialized"
  /* uninitialized */
}, sp = /* @__PURE__ */ xi(Zh, () => {
}), lp = /* @__PURE__ */ xi(Zh, () => {
});
function A2({
  serializeQueryArgs: e,
  reducerPath: t,
  createSelector: r
}) {
  const n = (p) => sp, o = (p) => lp;
  return {
    buildQuerySelector: s,
    buildMutationSelector: l,
    selectInvalidatedBy: u,
    selectCachedArgsForQuery: c
  };
  function a(p) {
    return {
      ...p,
      ...T2(p.status)
    };
  }
  function i(p) {
    const d = p[t];
    if (process.env.NODE_ENV !== "production" && !d) {
      if (i.triggered)
        return d;
      i.triggered = !0, console.error(`Error: No data found at \`state.${t}\`. Did you forget to add the reducer to the store?`);
    }
    return d;
  }
  function s(p, d) {
    return (f) => {
      const m = e({
        queryArgs: f,
        endpointDefinition: d,
        endpointName: p
      });
      return r(f === yo ? n : (_) => {
        var g, b;
        return ((b = (g = i(_)) == null ? void 0 : g.queries) == null ? void 0 : b[m]) ?? sp;
      }, a);
    };
  }
  function l() {
    return (p) => {
      let d;
      return typeof p == "object" ? d = ai(p) ?? yo : d = p, r(d === yo ? o : (v) => {
        var h, _;
        return ((_ = (h = i(v)) == null ? void 0 : h.mutations) == null ? void 0 : _[d]) ?? lp;
      }, a);
    };
  }
  function u(p, d) {
    const f = p[t], m = /* @__PURE__ */ new Set();
    for (const v of d.map(zc)) {
      const h = f.provided[v.type];
      if (!h)
        continue;
      let _ = (v.id !== void 0 ? (
        // id given: invalidate all queries that provide this type & id
        h[v.id]
      ) : (
        // no id: invalidate all queries that provide this type
        tp(Object.values(h))
      )) ?? [];
      for (const g of _)
        m.add(g);
    }
    return tp(Array.from(m.values()).map((v) => {
      const h = f.queries[v];
      return h ? [{
        queryCacheKey: v,
        endpointName: h.endpointName,
        originalArgs: h.originalArgs
      }] : [];
    }));
  }
  function c(p, d) {
    return Object.values(p[t].queries).filter(
      (f) => (f == null ? void 0 : f.endpointName) === d && f.status !== "uninitialized"
      /* uninitialized */
    ).map((f) => f.originalArgs);
  }
}
var Fo = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, cp = ({
  endpointName: e,
  queryArgs: t
}) => {
  let r = "";
  const n = Fo == null ? void 0 : Fo.get(t);
  if (typeof n == "string")
    r = n;
  else {
    const o = JSON.stringify(t, (a, i) => (i = typeof i == "bigint" ? {
      $bigint: i.toString()
    } : i, i = So(i) ? Object.keys(i).sort().reduce((s, l) => (s[l] = i[l], s), {}) : i, i));
    So(t) && (Fo == null || Fo.set(t, o)), r = o;
  }
  return `${e}(${r})`;
};
function I2(...e) {
  return function(r) {
    const n = ni((u) => {
      var c;
      return (c = r.extractRehydrationInfo) == null ? void 0 : c.call(r, u, {
        reducerPath: r.reducerPath ?? "api"
      });
    }), o = {
      reducerPath: "api",
      keepUnusedDataFor: 60,
      refetchOnMountOrArgChange: !1,
      refetchOnFocus: !1,
      refetchOnReconnect: !1,
      invalidationBehavior: "delayed",
      ...r,
      extractRehydrationInfo: n,
      serializeQueryArgs(u) {
        let c = cp;
        if ("serializeQueryArgs" in u.endpointDefinition) {
          const p = u.endpointDefinition.serializeQueryArgs;
          c = (d) => {
            const f = p(d);
            return typeof f == "string" ? f : cp({
              ...d,
              queryArgs: f
            });
          };
        } else r.serializeQueryArgs && (c = r.serializeQueryArgs);
        return c(u);
      },
      tagTypes: [...r.tagTypes || []]
    }, a = {
      endpointDefinitions: {},
      batch(u) {
        u();
      },
      apiUid: Gu(),
      extractRehydrationInfo: n,
      hasRehydrationInfo: ni((u) => n(u) != null)
    }, i = {
      injectEndpoints: l,
      enhanceEndpoints({
        addTagTypes: u,
        endpoints: c
      }) {
        if (u)
          for (const p of u)
            o.tagTypes.includes(p) || o.tagTypes.push(p);
        if (c)
          for (const [p, d] of Object.entries(c))
            typeof d == "function" ? d(a.endpointDefinitions[p]) : Object.assign(a.endpointDefinitions[p] || {}, d);
        return i;
      }
    }, s = e.map((u) => u.init(i, o, a));
    function l(u) {
      const c = u.endpoints({
        query: (p) => ({
          ...p,
          type: "query"
          /* query */
        }),
        mutation: (p) => ({
          ...p,
          type: "mutation"
          /* mutation */
        })
      });
      for (const [p, d] of Object.entries(c)) {
        if (u.overrideExisting !== !0 && p in a.endpointDefinitions) {
          if (u.overrideExisting === "throw")
            throw new Error(process.env.NODE_ENV === "production" ? ft(39) : `called \`injectEndpoints\` to override already-existing endpointName ${p} without specifying \`overrideExisting: true\``);
          typeof process < "u" && process.env.NODE_ENV === "development" && console.error(`called \`injectEndpoints\` to override already-existing endpointName ${p} without specifying \`overrideExisting: true\``);
          continue;
        }
        a.endpointDefinitions[p] = d;
        for (const f of s)
          f.injectEndpoint(p, d);
      }
      return i;
    }
    return i.injectEndpoints({
      endpoints: r.endpoints
    });
  };
}
function F2(e) {
  for (let t in e)
    return !1;
  return !0;
}
var L2 = 2147483647 / 1e3 - 1, $2 = ({
  reducerPath: e,
  api: t,
  queryThunk: r,
  context: n,
  internalState: o
}) => {
  const {
    removeQueryResult: a,
    unsubscribeQueryResult: i
  } = t.internalActions, s = Pn(i.match, r.fulfilled, r.rejected);
  function l(d) {
    const f = o.currentSubscriptions[d];
    return !!f && !F2(f);
  }
  const u = {}, c = (d, f, m) => {
    var v;
    if (s(d)) {
      const h = f.getState()[e], {
        queryCacheKey: _
      } = i.match(d) ? d.payload : d.meta.arg;
      p(_, (v = h.queries[_]) == null ? void 0 : v.endpointName, f, h.config);
    }
    if (t.util.resetApiState.match(d))
      for (const [h, _] of Object.entries(u))
        _ && clearTimeout(_), delete u[h];
    if (n.hasRehydrationInfo(d)) {
      const h = f.getState()[e], {
        queries: _
      } = n.extractRehydrationInfo(d);
      for (const [g, b] of Object.entries(_))
        p(g, b == null ? void 0 : b.endpointName, f, h.config);
    }
  };
  function p(d, f, m, v) {
    const h = n.endpointDefinitions[f], _ = (h == null ? void 0 : h.keepUnusedDataFor) ?? v.keepUnusedDataFor;
    if (_ === 1 / 0)
      return;
    const g = Math.max(0, Math.min(_, L2));
    if (!l(d)) {
      const b = u[d];
      b && clearTimeout(b), u[d] = setTimeout(() => {
        l(d) || m.dispatch(a({
          queryCacheKey: d
        })), delete u[d];
      }, g * 1e3);
    }
  }
  return c;
}, W2 = ({
  reducerPath: e,
  context: t,
  context: {
    endpointDefinitions: r
  },
  mutationThunk: n,
  queryThunk: o,
  api: a,
  assertTagType: i,
  refetchQuery: s,
  internalState: l
}) => {
  const {
    removeQueryResult: u
  } = a.internalActions, c = Pn(to(n), ll(n)), p = Pn(to(n, o), Zo(n, o));
  let d = [];
  const f = (h, _) => {
    c(h) ? v(Xh(h, "invalidatesTags", r, i), _) : p(h) ? v([], _) : a.util.invalidateTags.match(h) && v(Ju(h.payload, void 0, void 0, void 0, void 0, i), _);
  };
  function m(h) {
    var _, g;
    for (const b in h.queries)
      if (((_ = h.queries[b]) == null ? void 0 : _.status) === "pending")
        return !0;
    for (const b in h.mutations)
      if (((g = h.mutations[b]) == null ? void 0 : g.status) === "pending")
        return !0;
    return !1;
  }
  function v(h, _) {
    const g = _.getState(), b = g[e];
    if (d.push(...h), b.config.invalidationBehavior === "delayed" && m(b))
      return;
    const x = d;
    if (d = [], x.length === 0)
      return;
    const E = a.util.selectInvalidatedBy(g, x);
    t.batch(() => {
      const O = Array.from(E.values());
      for (const {
        queryCacheKey: P
      } of O) {
        const y = b.queries[P], w = l.currentSubscriptions[P] ?? {};
        y && (zo(w) === 0 ? _.dispatch(u({
          queryCacheKey: P
        })) : y.status !== "uninitialized" && _.dispatch(s(y, P)));
      }
    });
  }
  return f;
}, Y2 = ({
  reducerPath: e,
  queryThunk: t,
  api: r,
  refetchQuery: n,
  internalState: o
}) => {
  const a = {}, i = (d, f) => {
    (r.internalActions.updateSubscriptionOptions.match(d) || r.internalActions.unsubscribeQueryResult.match(d)) && l(d.payload, f), (t.pending.match(d) || t.rejected.match(d) && d.meta.condition) && l(d.meta.arg, f), (t.fulfilled.match(d) || t.rejected.match(d) && !d.meta.condition) && s(d.meta.arg, f), r.util.resetApiState.match(d) && c();
  };
  function s({
    queryCacheKey: d
  }, f) {
    const m = f.getState()[e], v = m.queries[d], h = o.currentSubscriptions[d];
    if (!v || v.status === "uninitialized")
      return;
    const {
      lowestPollingInterval: _,
      skipPollingIfUnfocused: g
    } = p(h);
    if (!Number.isFinite(_))
      return;
    const b = a[d];
    b != null && b.timeout && (clearTimeout(b.timeout), b.timeout = void 0);
    const x = Date.now() + _;
    a[d] = {
      nextPollTimestamp: x,
      pollingInterval: _,
      timeout: setTimeout(() => {
        (m.config.focused || !g) && f.dispatch(n(v, d)), s({
          queryCacheKey: d
        }, f);
      }, _)
    };
  }
  function l({
    queryCacheKey: d
  }, f) {
    const v = f.getState()[e].queries[d], h = o.currentSubscriptions[d];
    if (!v || v.status === "uninitialized")
      return;
    const {
      lowestPollingInterval: _
    } = p(h);
    if (!Number.isFinite(_)) {
      u(d);
      return;
    }
    const g = a[d], b = Date.now() + _;
    (!g || b < g.nextPollTimestamp) && s({
      queryCacheKey: d
    }, f);
  }
  function u(d) {
    const f = a[d];
    f != null && f.timeout && clearTimeout(f.timeout), delete a[d];
  }
  function c() {
    for (const d of Object.keys(a))
      u(d);
  }
  function p(d = {}) {
    let f = !1, m = Number.POSITIVE_INFINITY;
    for (let v in d)
      d[v].pollingInterval && (m = Math.min(d[v].pollingInterval, m), f = d[v].skipPollingIfUnfocused || f);
    return {
      lowestPollingInterval: m,
      skipPollingIfUnfocused: f
    };
  }
  return i;
}, B2 = ({
  reducerPath: e,
  context: t,
  api: r,
  refetchQuery: n,
  internalState: o
}) => {
  const {
    removeQueryResult: a
  } = r.internalActions, i = (l, u) => {
    Xu.match(l) && s(u, "refetchOnFocus"), Zu.match(l) && s(u, "refetchOnReconnect");
  };
  function s(l, u) {
    const c = l.getState()[e], p = c.queries, d = o.currentSubscriptions;
    t.batch(() => {
      for (const f of Object.keys(d)) {
        const m = p[f], v = d[f];
        if (!v || !m)
          continue;
        (Object.values(v).some((_) => _[u] === !0) || Object.values(v).every((_) => _[u] === void 0) && c.config[u]) && (zo(v) === 0 ? l.dispatch(a({
          queryCacheKey: f
        })) : m.status !== "uninitialized" && l.dispatch(n(m, f)));
      }
    });
  }
  return i;
}, up = new Error("Promise never resolved before cacheEntryRemoved."), j2 = ({
  api: e,
  reducerPath: t,
  context: r,
  queryThunk: n,
  mutationThunk: o,
  internalState: a
}) => {
  const i = Vc(n), s = Vc(o), l = to(n, o), u = {}, c = (f, m, v) => {
    const h = p(f);
    if (n.pending.match(f)) {
      const _ = v[t].queries[h], g = m.getState()[t].queries[h];
      !_ && g && d(f.meta.arg.endpointName, f.meta.arg.originalArgs, h, m, f.meta.requestId);
    } else if (o.pending.match(f))
      m.getState()[t].mutations[h] && d(f.meta.arg.endpointName, f.meta.arg.originalArgs, h, m, f.meta.requestId);
    else if (l(f)) {
      const _ = u[h];
      _ != null && _.valueResolved && (_.valueResolved({
        data: f.payload,
        meta: f.meta.baseQueryMeta
      }), delete _.valueResolved);
    } else if (e.internalActions.removeQueryResult.match(f) || e.internalActions.removeMutationResult.match(f)) {
      const _ = u[h];
      _ && (delete u[h], _.cacheEntryRemoved());
    } else if (e.util.resetApiState.match(f))
      for (const [_, g] of Object.entries(u))
        delete u[_], g.cacheEntryRemoved();
  };
  function p(f) {
    return i(f) ? f.meta.arg.queryCacheKey : s(f) ? f.meta.arg.fixedCacheKey ?? f.meta.requestId : e.internalActions.removeQueryResult.match(f) ? f.payload.queryCacheKey : e.internalActions.removeMutationResult.match(f) ? ai(f.payload) : "";
  }
  function d(f, m, v, h, _) {
    const g = r.endpointDefinitions[f], b = g == null ? void 0 : g.onCacheEntryAdded;
    if (!b)
      return;
    let x = {};
    const E = new Promise((k) => {
      x.cacheEntryRemoved = k;
    }), O = Promise.race([new Promise((k) => {
      x.valueResolved = k;
    }), E.then(() => {
      throw up;
    })]);
    O.catch(() => {
    }), u[v] = x;
    const P = e.endpoints[f].select(g.type === "query" ? m : v), y = h.dispatch((k, T, R) => R), w = {
      ...h,
      getCacheEntry: () => P(h.getState()),
      requestId: _,
      extra: y,
      updateCachedData: g.type === "query" ? (k) => h.dispatch(e.util.updateQueryData(f, m, k)) : void 0,
      cacheDataLoaded: O,
      cacheEntryRemoved: E
    }, S = b(m, w);
    Promise.resolve(S).catch((k) => {
      if (k !== up)
        throw k;
    });
  }
  return c;
}, U2 = ({
  api: e,
  context: t,
  queryThunk: r,
  mutationThunk: n
}) => {
  const o = Qu(r, n), a = Zo(r, n), i = to(r, n), s = {};
  return (u, c) => {
    var p, d;
    if (o(u)) {
      const {
        requestId: f,
        arg: {
          endpointName: m,
          originalArgs: v
        }
      } = u.meta, h = t.endpointDefinitions[m], _ = h == null ? void 0 : h.onQueryStarted;
      if (_) {
        const g = {}, b = new Promise((P, y) => {
          g.resolve = P, g.reject = y;
        });
        b.catch(() => {
        }), s[f] = g;
        const x = e.endpoints[m].select(h.type === "query" ? v : f), E = c.dispatch((P, y, w) => w), O = {
          ...c,
          getCacheEntry: () => x(c.getState()),
          requestId: f,
          extra: E,
          updateCachedData: h.type === "query" ? (P) => c.dispatch(e.util.updateQueryData(m, v, P)) : void 0,
          queryFulfilled: b
        };
        _(v, O);
      }
    } else if (i(u)) {
      const {
        requestId: f,
        baseQueryMeta: m
      } = u.meta;
      (p = s[f]) == null || p.resolve({
        data: u.payload,
        meta: m
      }), delete s[f];
    } else if (a(u)) {
      const {
        requestId: f,
        rejectedWithValue: m,
        baseQueryMeta: v
      } = u.meta;
      (d = s[f]) == null || d.reject({
        error: u.payload ?? u.error,
        isUnhandledError: !m,
        meta: v
      }), delete s[f];
    }
  };
}, H2 = ({
  api: e,
  context: {
    apiUid: t
  },
  reducerPath: r
}) => (n, o) => {
  var a, i;
  e.util.resetApiState.match(n) && o.dispatch(e.internalActions.middlewareRegistered(t)), typeof process < "u" && process.env.NODE_ENV === "development" && e.internalActions.middlewareRegistered.match(n) && n.payload === t && ((i = (a = o.getState()[r]) == null ? void 0 : a.config) == null ? void 0 : i.middlewareRegistered) === "conflict" && console.warn(`There is a mismatch between slice and middleware for the reducerPath "${r}".
You can only have one api per reducer path, this will lead to crashes in various situations!${r === "api" ? `
If you have multiple apis, you *have* to specify the reducerPath option when using createApi!` : ""}`);
}, V2 = ({
  api: e,
  queryThunk: t,
  internalState: r
}) => {
  const n = `${e.reducerPath}/subscriptions`;
  let o = null, a = null;
  const {
    updateSubscriptionOptions: i,
    unsubscribeQueryResult: s
  } = e.internalActions, l = (f, m) => {
    var h, _, g;
    if (i.match(m)) {
      const {
        queryCacheKey: b,
        requestId: x,
        options: E
      } = m.payload;
      return (h = f == null ? void 0 : f[b]) != null && h[x] && (f[b][x] = E), !0;
    }
    if (s.match(m)) {
      const {
        queryCacheKey: b,
        requestId: x
      } = m.payload;
      return f[b] && delete f[b][x], !0;
    }
    if (e.internalActions.removeQueryResult.match(m))
      return delete f[m.payload.queryCacheKey], !0;
    if (t.pending.match(m)) {
      const {
        meta: {
          arg: b,
          requestId: x
        }
      } = m, E = f[_ = b.queryCacheKey] ?? (f[_] = {});
      return E[`${x}_running`] = {}, b.subscribe && (E[x] = b.subscriptionOptions ?? E[x] ?? {}), !0;
    }
    let v = !1;
    if (t.fulfilled.match(m) || t.rejected.match(m)) {
      const b = f[m.meta.arg.queryCacheKey] || {}, x = `${m.meta.requestId}_running`;
      v || (v = !!b[x]), delete b[x];
    }
    if (t.rejected.match(m)) {
      const {
        meta: {
          condition: b,
          arg: x,
          requestId: E
        }
      } = m;
      if (b && x.subscribe) {
        const O = f[g = x.queryCacheKey] ?? (f[g] = {});
        O[E] = x.subscriptionOptions ?? O[E] ?? {}, v = !0;
      }
    }
    return v;
  }, u = () => r.currentSubscriptions, d = {
    getSubscriptions: u,
    getSubscriptionCount: (f) => {
      const v = u()[f] ?? {};
      return zo(v);
    },
    isRequestSubscribed: (f, m) => {
      var h;
      const v = u();
      return !!((h = v == null ? void 0 : v[f]) != null && h[m]);
    }
  };
  return (f, m) => {
    if (o || (o = JSON.parse(JSON.stringify(r.currentSubscriptions))), e.util.resetApiState.match(f))
      return o = r.currentSubscriptions = {}, a = null, [!0, !1];
    if (e.internalActions.internal_getRTKQSubscriptions.match(f))
      return [!1, d];
    const v = l(r.currentSubscriptions, f);
    let h = !0;
    if (v) {
      a || (a = setTimeout(() => {
        const b = JSON.parse(JSON.stringify(r.currentSubscriptions)), [, x] = jh(o, () => b);
        m.next(e.internalActions.subscriptionsUpdated(x)), o = b, a = null;
      }, 500));
      const _ = typeof f.type == "string" && !!f.type.startsWith(n), g = t.rejected.match(f) && f.meta.condition && !!f.meta.arg.subscribe;
      h = !_ && !g;
    }
    return [h, !1];
  };
};
function z2(e) {
  const {
    reducerPath: t,
    queryThunk: r,
    api: n,
    context: o
  } = e, {
    apiUid: a
  } = o, i = {
    invalidateTags: tr(`${t}/invalidateTags`)
  }, s = (p) => p.type.startsWith(`${t}/`), l = [H2, $2, W2, Y2, j2, U2];
  return {
    middleware: (p) => {
      let d = !1;
      const m = {
        ...e,
        internalState: {
          currentSubscriptions: {}
        },
        refetchQuery: c,
        isThisApiSliceAction: s
      }, v = l.map((g) => g(m)), h = V2(m), _ = B2(m);
      return (g) => (b) => {
        if (!Ah(b))
          return g(b);
        d || (d = !0, p.dispatch(n.internalActions.middlewareRegistered(a)));
        const x = {
          ...p,
          next: g
        }, E = p.getState(), [O, P] = h(b, x, E);
        let y;
        if (O ? y = g(b) : y = P, p.getState()[t] && (_(b, x, E), s(b) || o.hasRehydrationInfo(b)))
          for (let w of v)
            w(b, x, E);
        return y;
      };
    },
    actions: i
  };
  function c(p, d, f = {}) {
    return r({
      type: "query",
      endpointName: p.endpointName,
      originalArgs: p.originalArgs,
      subscribe: !1,
      forceRefetch: !0,
      queryCacheKey: d,
      ...f
    });
  }
}
function Vn(e, ...t) {
  return Object.assign(e, ...t);
}
var dp = /* @__PURE__ */ Symbol(), q2 = ({
  createSelector: e = qu
} = {}) => ({
  name: dp,
  init(t, {
    baseQuery: r,
    tagTypes: n,
    reducerPath: o,
    serializeQueryArgs: a,
    keepUnusedDataFor: i,
    refetchOnMountOrArgChange: s,
    refetchOnFocus: l,
    refetchOnReconnect: u,
    invalidationBehavior: c
  }, p) {
    US();
    const d = (N) => (typeof process < "u" && process.env.NODE_ENV === "development" && (n.includes(N.type) || console.error(`Tag type '${N.type}' was used, but not specified in \`tagTypes\`!`)), N);
    Object.assign(t, {
      reducerPath: o,
      endpoints: {},
      internalActions: {
        onOnline: Zu,
        onOffline: Qh,
        onFocus: Xu,
        onFocusLost: Gh
      },
      util: {}
    });
    const {
      queryThunk: f,
      mutationThunk: m,
      patchQueryData: v,
      updateQueryData: h,
      upsertQueryData: _,
      prefetch: g,
      buildMatchThunkActions: b
    } = M2({
      baseQuery: r,
      reducerPath: o,
      context: p,
      api: t,
      serializeQueryArgs: a,
      assertTagType: d
    }), {
      reducer: x,
      actions: E
    } = R2({
      context: p,
      queryThunk: f,
      mutationThunk: m,
      reducerPath: o,
      assertTagType: d,
      config: {
        refetchOnFocus: l,
        refetchOnReconnect: u,
        refetchOnMountOrArgChange: s,
        keepUnusedDataFor: i,
        reducerPath: o,
        invalidationBehavior: c
      }
    });
    Vn(t.util, {
      patchQueryData: v,
      updateQueryData: h,
      upsertQueryData: _,
      prefetch: g,
      resetApiState: E.resetApiState
    }), Vn(t.internalActions, E);
    const {
      middleware: O,
      actions: P
    } = z2({
      reducerPath: o,
      context: p,
      queryThunk: f,
      mutationThunk: m,
      api: t,
      assertTagType: d
    });
    Vn(t.util, P), Vn(t, {
      reducer: x,
      middleware: O
    });
    const {
      buildQuerySelector: y,
      buildMutationSelector: w,
      selectInvalidatedBy: S,
      selectCachedArgsForQuery: k
    } = A2({
      serializeQueryArgs: a,
      reducerPath: o,
      createSelector: e
    });
    Vn(t.util, {
      selectInvalidatedBy: S,
      selectCachedArgsForQuery: k
    });
    const {
      buildInitiateQuery: T,
      buildInitiateMutation: R,
      getRunningMutationThunk: I,
      getRunningMutationsThunk: C,
      getRunningQueriesThunk: A,
      getRunningQueryThunk: D
    } = P2({
      queryThunk: f,
      mutationThunk: m,
      api: t,
      serializeQueryArgs: a,
      context: p
    });
    return Vn(t.util, {
      getRunningMutationThunk: I,
      getRunningMutationsThunk: C,
      getRunningQueryThunk: D,
      getRunningQueriesThunk: A
    }), {
      name: dp,
      injectEndpoint(N, M) {
        var B;
        const W = t;
        (B = W.endpoints)[N] ?? (B[N] = {}), Kh(M) ? Vn(W.endpoints[N], {
          name: N,
          select: y(N, M),
          initiate: T(N, M)
        }, b(f, N)) : D2(M) && Vn(W.endpoints[N], {
          name: N,
          select: w(),
          initiate: R(N)
        }, b(m, N));
      }
    };
  }
});
function G2(e) {
  return e.type === "query";
}
function Q2(e) {
  return e.type === "mutation";
}
function fs(e, ...t) {
  return Object.assign(e, ...t);
}
function ec(e) {
  return e.replace(e[0], e[0].toUpperCase());
}
var Lo = WeakMap ? /* @__PURE__ */ new WeakMap() : void 0, K2 = ({
  endpointName: e,
  queryArgs: t
}) => {
  let r = "";
  const n = Lo == null ? void 0 : Lo.get(t);
  if (typeof n == "string")
    r = n;
  else {
    const o = JSON.stringify(t, (a, i) => (i = typeof i == "bigint" ? {
      $bigint: i.toString()
    } : i, i = So(i) ? Object.keys(i).sort().reduce((s, l) => (s[l] = i[l], s), {}) : i, i));
    So(t) && (Lo == null || Lo.set(t, o)), r = o;
  }
  return `${e}(${r})`;
}, tc = Symbol();
function fp(e, t, r, n) {
  const o = ae(() => ({
    queryArgs: e,
    serialized: typeof e == "object" ? t({
      queryArgs: e,
      endpointDefinition: r,
      endpointName: n
    }) : e
  }), [e, t, r, n]), a = ce(o);
  return ge(() => {
    a.current.serialized !== o.serialized && (a.current = o);
  }, [o]), a.current.serialized === o.serialized ? a.current.queryArgs : e;
}
function rc(e) {
  const t = ce(e);
  return ge(() => {
    Ya(t.current, e) || (t.current = e);
  }, [e]), Ya(t.current, e) ? t.current : e;
}
var X2 = typeof window < "u" && window.document && window.document.createElement ? pi : ge, Z2 = (e) => e.isUninitialized ? {
  ...e,
  isUninitialized: !1,
  isFetching: !0,
  isLoading: e.data === void 0,
  status: zh.pending
} : e;
function J2({
  api: e,
  moduleOptions: {
    batch: t,
    hooks: {
      useDispatch: r,
      useSelector: n,
      useStore: o
    },
    unstable__sideEffectsInRender: a,
    createSelector: i
  },
  serializeQueryArgs: s,
  context: l
}) {
  const u = a ? (m) => m() : ge;
  return {
    buildQueryHooks: d,
    buildMutationHook: f,
    usePrefetch: p
  };
  function c(m, v, h) {
    if (v != null && v.endpointName && m.isUninitialized) {
      const {
        endpointName: O
      } = v, P = l.endpointDefinitions[O];
      s({
        queryArgs: v.originalArgs,
        endpointDefinition: P,
        endpointName: O
      }) === s({
        queryArgs: h,
        endpointDefinition: P,
        endpointName: O
      }) && (v = void 0);
    }
    let _ = m.isSuccess ? m.data : v == null ? void 0 : v.data;
    _ === void 0 && (_ = m.data);
    const g = _ !== void 0, b = m.isLoading, x = (!v || v.isLoading || v.isUninitialized) && !g && b, E = m.isSuccess || b && g;
    return {
      ...m,
      data: _,
      currentData: m.data,
      isFetching: b,
      isLoading: x,
      isSuccess: E
    };
  }
  function p(m, v) {
    const h = r(), _ = rc(v);
    return Le((g, b) => h(e.util.prefetch(m, g, {
      ..._,
      ...b
    })), [m, h, _]);
  }
  function d(m) {
    const v = (g, {
      refetchOnReconnect: b,
      refetchOnFocus: x,
      refetchOnMountOrArgChange: E,
      skip: O = !1,
      pollingInterval: P = 0,
      skipPollingIfUnfocused: y = !1
    } = {}) => {
      const {
        initiate: w
      } = e.endpoints[m], S = r(), k = ce(void 0);
      if (!k.current) {
        const W = S(e.internalActions.internal_getRTKQSubscriptions());
        if (process.env.NODE_ENV !== "production" && (typeof W != "object" || typeof (W == null ? void 0 : W.type) == "string"))
          throw new Error(process.env.NODE_ENV === "production" ? ft(37) : `Warning: Middleware for RTK-Query API at reducerPath "${e.reducerPath}" has not been added to the store.
    You must add the middleware for RTK-Query to function correctly!`);
        k.current = W;
      }
      const T = fp(
        O ? yo : g,
        // Even if the user provided a per-endpoint `serializeQueryArgs` with
        // a consistent return value, _here_ we want to use the default behavior
        // so we can tell if _anything_ actually changed. Otherwise, we can end up
        // with a case where the query args did change but the serialization doesn't,
        // and then we never try to initiate a refetch.
        K2,
        l.endpointDefinitions[m],
        m
      ), R = rc({
        refetchOnReconnect: b,
        refetchOnFocus: x,
        pollingInterval: P,
        skipPollingIfUnfocused: y
      }), I = ce(!1), C = ce(void 0);
      let {
        queryCacheKey: A,
        requestId: D
      } = C.current || {}, N = !1;
      A && D && (N = k.current.isRequestSubscribed(A, D));
      const M = !N && I.current;
      return u(() => {
        I.current = N;
      }), u(() => {
        M && (C.current = void 0);
      }, [M]), u(() => {
        var j;
        const W = C.current;
        if (typeof process < "u" && process.env.NODE_ENV === "removeMeOnCompilation" && console.log(M), T === yo) {
          W == null || W.unsubscribe(), C.current = void 0;
          return;
        }
        const B = (j = C.current) == null ? void 0 : j.subscriptionOptions;
        if (!W || W.arg !== T) {
          W == null || W.unsubscribe();
          const q = S(w(T, {
            subscriptionOptions: R,
            forceRefetch: E
          }));
          C.current = q;
        } else R !== B && W.updateSubscriptionOptions(R);
      }, [S, w, E, T, R, M]), ge(() => () => {
        var W;
        (W = C.current) == null || W.unsubscribe(), C.current = void 0;
      }, []), ae(() => ({
        /**
         * A method to manually refetch data for the query
         */
        refetch: () => {
          var W;
          if (!C.current)
            throw new Error(process.env.NODE_ENV === "production" ? ft(38) : "Cannot refetch a query that has not been started yet.");
          return (W = C.current) == null ? void 0 : W.refetch();
        }
      }), []);
    }, h = ({
      refetchOnReconnect: g,
      refetchOnFocus: b,
      pollingInterval: x = 0,
      skipPollingIfUnfocused: E = !1
    } = {}) => {
      const {
        initiate: O
      } = e.endpoints[m], P = r(), [y, w] = me(tc), S = ce(void 0), k = rc({
        refetchOnReconnect: g,
        refetchOnFocus: b,
        pollingInterval: x,
        skipPollingIfUnfocused: E
      });
      u(() => {
        var C, A;
        const I = (C = S.current) == null ? void 0 : C.subscriptionOptions;
        k !== I && ((A = S.current) == null || A.updateSubscriptionOptions(k));
      }, [k]);
      const T = ce(k);
      u(() => {
        T.current = k;
      }, [k]);
      const R = Le(function(I, C = !1) {
        let A;
        return t(() => {
          var D;
          (D = S.current) == null || D.unsubscribe(), S.current = A = P(O(I, {
            subscriptionOptions: T.current,
            forceRefetch: !C
          })), w(I);
        }), A;
      }, [P, O]);
      return ge(() => () => {
        var I;
        (I = S == null ? void 0 : S.current) == null || I.unsubscribe();
      }, []), ge(() => {
        y !== tc && !S.current && R(y, !0);
      }, [y, R]), ae(() => [R, y], [R, y]);
    }, _ = (g, {
      skip: b = !1,
      selectFromResult: x
    } = {}) => {
      const {
        select: E
      } = e.endpoints[m], O = fp(b ? yo : g, s, l.endpointDefinitions[m], m), P = ce(void 0), y = ae(() => i([E(O), (R, I) => I, (R) => O], c, {
        memoizeOptions: {
          resultEqualityCheck: Ya
        }
      }), [E, O]), w = ae(() => x ? i([y], x, {
        devModeChecks: {
          identityFunctionCheck: "never"
        }
      }) : y, [y, x]), S = n((R) => w(R, P.current), Ya), k = o(), T = y(k.getState(), P.current);
      return X2(() => {
        P.current = T;
      }, [T]), S;
    };
    return {
      useQueryState: _,
      useQuerySubscription: v,
      useLazyQuerySubscription: h,
      useLazyQuery(g) {
        const [b, x] = h(g), E = _(x, {
          ...g,
          skip: x === tc
        }), O = ae(() => ({
          lastArg: x
        }), [x]);
        return ae(() => [b, E, O], [b, E, O]);
      },
      useQuery(g, b) {
        const x = v(g, b), E = _(g, {
          selectFromResult: g === yo || b != null && b.skip ? void 0 : Z2,
          ...b
        }), {
          data: O,
          status: P,
          isLoading: y,
          isSuccess: w,
          isError: S,
          error: k
        } = E;
        return uf({
          data: O,
          status: P,
          isLoading: y,
          isSuccess: w,
          isError: S,
          error: k
        }), ae(() => ({
          ...E,
          ...x
        }), [E, x]);
      }
    };
  }
  function f(m) {
    return ({
      selectFromResult: v,
      fixedCacheKey: h
    } = {}) => {
      const {
        select: _,
        initiate: g
      } = e.endpoints[m], b = r(), [x, E] = me();
      ge(() => () => {
        x != null && x.arg.fixedCacheKey || x == null || x.reset();
      }, [x]);
      const O = Le(function(B) {
        const j = b(g(B, {
          fixedCacheKey: h
        }));
        return E(j), j;
      }, [b, g, h]), {
        requestId: P
      } = x || {}, y = ae(() => _({
        fixedCacheKey: h,
        requestId: x == null ? void 0 : x.requestId
      }), [h, x, _]), w = ae(() => v ? i([y], v) : y, [v, y]), S = n(w, Ya), k = h == null ? x == null ? void 0 : x.arg.originalArgs : void 0, T = Le(() => {
        t(() => {
          x && E(void 0), h && b(e.internalActions.removeMutationResult({
            requestId: P,
            fixedCacheKey: h
          }));
        });
      }, [b, h, x, P]), {
        endpointName: R,
        data: I,
        status: C,
        isLoading: A,
        isSuccess: D,
        isError: N,
        error: M
      } = S;
      uf({
        endpointName: R,
        data: I,
        status: C,
        isLoading: A,
        isSuccess: D,
        isError: N,
        error: M
      });
      const W = ae(() => ({
        ...S,
        originalArgs: k,
        reset: T
      }), [S, k, T]);
      return ae(() => [O, W], [O, W]);
    };
  }
}
function eE(e) {
  let t = 0;
  for (const r in e)
    t++;
  return t;
}
var tE = /* @__PURE__ */ Symbol(), rE = ({
  batch: e = y1,
  hooks: t = {
    useDispatch: b1,
    useSelector: w1,
    useStore: x1
  },
  createSelector: r = qu,
  unstable__sideEffectsInRender: n = !1,
  ...o
} = {}) => {
  if (process.env.NODE_ENV !== "production") {
    const a = ["useDispatch", "useSelector", "useStore"];
    let i = !1;
    for (const s of a)
      if (eE(o) > 0 && (o[s] && (i || (console.warn("As of RTK 2.0, the hooks now need to be specified as one object, provided under a `hooks` key:\n`reactHooksModule({ hooks: { useDispatch, useSelector, useStore } })`"), i = !0)), t[s] = o[s]), typeof t[s] != "function")
        throw new Error(process.env.NODE_ENV === "production" ? ft(36) : `When using custom hooks for context, all ${a.length} hooks need to be provided: ${a.join(", ")}.
Hook ${s} was either not provided or not a function.`);
  }
  return {
    name: tE,
    init(a, {
      serializeQueryArgs: i
    }, s) {
      const l = a, {
        buildQueryHooks: u,
        buildMutationHook: c,
        usePrefetch: p
      } = J2({
        api: a,
        moduleOptions: {
          batch: e,
          hooks: t,
          unstable__sideEffectsInRender: n,
          createSelector: r
        },
        serializeQueryArgs: i,
        context: s
      });
      return fs(l, {
        usePrefetch: p
      }), fs(s, {
        batch: e
      }), {
        injectEndpoint(d, f) {
          if (G2(f)) {
            const {
              useQuery: m,
              useLazyQuery: v,
              useLazyQuerySubscription: h,
              useQueryState: _,
              useQuerySubscription: g
            } = u(d);
            fs(l.endpoints[d], {
              useQuery: m,
              useLazyQuery: v,
              useLazyQuerySubscription: h,
              useQueryState: _,
              useQuerySubscription: g
            }), a[`use${ec(d)}Query`] = m, a[`useLazy${ec(d)}Query`] = v;
          } else if (Q2(f)) {
            const m = c(d);
            fs(l.endpoints[d], {
              useMutation: m
            }), a[`use${ec(d)}Mutation`] = m;
          }
        }
      };
    }
  };
}, nc = /* @__PURE__ */ I2(q2(), rE());
const Gs = class Gs {
  constructor(t) {
    Bn(this, "baseQuery");
    Bn(this, "_apiConfigs");
    Bn(this, "_reducers", {});
    Bn(this, "_middlewares", []);
    this.baseQuery = t.baseQuery, this._apiConfigs = {
      auth: Ff,
      site: Bf,
      public: Yf
    };
  }
  createApis() {
    const t = nc({
      ...Ff,
      baseQuery: this.baseQuery.auth
    }), r = nc({
      ...Bf,
      baseQuery: this.baseQuery.site
    }), n = nc({
      ...Yf,
      baseQuery: this.baseQuery.public
    }), o = [];
    t && o.push(t.middleware), r && o.push(r.middleware), n && o.push(n.middleware), this._middlewares = o;
    const a = {};
    return t && (a[t.reducerPath] = t.reducer), r && (a[r.reducerPath] = r.reducer), n && (a[n.reducerPath] = n.reducer), this._reducers = a, {
      auth: t,
      site: r,
      public: n
    };
  }
  //
  static getInstance(t) {
    return this.instance || (this.instance = new Gs(t)), this.instance;
  }
  apiConfigs() {
    return this._apiConfigs;
  }
  reducers() {
    return this._reducers;
  }
  middlewares() {
    return this._middlewares;
  }
};
Bn(Gs, "instance");
let Gc = Gs;
const eM = Gc, nE = (e) => /* @__PURE__ */ ue(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "14",
    height: "14",
    viewBox: "0 0 14 14",
    fill: "none",
    className: "text-content-secondary",
    children: [
      /* @__PURE__ */ L(
        "mask",
        {
          id: "mask0_3277_6300",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "14",
          height: "14",
          children: /* @__PURE__ */ L(
            "rect",
            {
              width: "14",
              height: "14",
              fill: "currentColor"
            }
          )
        }
      ),
      /* @__PURE__ */ L("g", { mask: "url(#mask0_3277_6300)", children: /* @__PURE__ */ L(
        "path",
        {
          d: "M5.17578 10.5C4.87498 10.5 4.61748 10.3929 4.4033 10.1787C4.18912 9.96455 4.08203 9.70706 4.08203 9.40625V2.40625C4.08203 2.10544 4.18912 1.84795 4.4033 1.63377C4.61748 1.41959 4.87498 1.3125 5.17578 1.3125H10.4258C10.7266 1.3125 10.9841 1.41959 11.1983 1.63377C11.4124 1.84795 11.5195 2.10544 11.5195 2.40625V9.40625C11.5195 9.70706 11.4124 9.96455 11.1983 10.1787C10.9841 10.3929 10.7266 10.5 10.4258 10.5H5.17578ZM5.17578 9.40625H10.4258V2.40625H5.17578V9.40625ZM2.98828 12.6875C2.68748 12.6875 2.42998 12.5804 2.2158 12.3662C2.00162 12.152 1.89453 11.8946 1.89453 11.5938V4.04688C1.89453 3.89618 1.948 3.76736 2.05495 3.66042C2.16189 3.55347 2.29071 3.5 2.44141 3.5C2.5921 3.5 2.72092 3.55347 2.82786 3.66042C2.93481 3.76736 2.98828 3.89618 2.98828 4.04688V11.5938H8.78516C8.93585 11.5938 9.06467 11.6472 9.17161 11.7542C9.27856 11.8611 9.33203 11.9899 9.33203 12.1406C9.33203 12.2913 9.27856 12.4201 9.17161 12.5271C9.06467 12.634 8.93585 12.6875 8.78516 12.6875H2.98828Z",
          fill: "currentColor"
        }
      ) })
    ]
  }
), oE = ({
  className: e,
  classes: t,
  onTxIdCopyClick: r,
  time: n,
  status: o,
  statusLabel: a = o || "",
  title: i,
  isPositive: s,
  amount: l,
  txId: u,
  currency: c,
  timeFormat: p = "DD-MM-YYYY HH:mm",
  variant: d = "compact",
  extraSubTitles: f
}) => {
  const { themeClasses: m } = Ge("Transaction", t, e, {
    variant: !l || s ? "positive" : "negative"
  });
  return /* @__PURE__ */ ue("div", { className: V("flex items-center justify-between", m == null ? void 0 : m.root), children: [
    d === "compact" && /* @__PURE__ */ L(Gt, { children: /* @__PURE__ */ ue("div", { className: V("flex flex-grow flex-col"), children: [
      /* @__PURE__ */ ue("div", { className: V("flex items-center justify-between", m == null ? void 0 : m.label), children: [
        i,
        !!n && /* @__PURE__ */ L("span", { className: V(m == null ? void 0 : m.timestamp), children: ie(n).format(p) })
      ] }),
      /* @__PURE__ */ ue("div", { className: "mt-2 flex items-center justify-between", children: [
        /* @__PURE__ */ L("div", { children: u && /* @__PURE__ */ ue(
          "span",
          {
            className: V("flex items-center gap-x-1", m == null ? void 0 : m.idLabel),
            onClick: () => r == null ? void 0 : r(u),
            children: [
              `${u}`,
              /* @__PURE__ */ L(nE, { className: "cursor-pointer" })
            ]
          }
        ) }),
        /* @__PURE__ */ ue("div", { children: [
          /* @__PURE__ */ L("span", { className: V(m == null ? void 0 : m.amount), children: l }),
          /* @__PURE__ */ L("span", { className: V(m == null ? void 0 : m.amount, "pl-1 font-normal !leading-4"), children: c })
        ] })
      ] })
    ] }) }),
    d === "expanded" && /* @__PURE__ */ L(Gt, { children: /* @__PURE__ */ ue("div", { className: V("flex flex-grow flex-col"), children: [
      /* @__PURE__ */ ue("div", { className: V("flex items-center justify-between", m == null ? void 0 : m.label), children: [
        i,
        !!n && /* @__PURE__ */ L("span", { className: V(m == null ? void 0 : m.timestamp), children: ie(n).format(p) })
      ] }),
      f == null ? void 0 : f.map((v, h) => /* @__PURE__ */ L(
        "div",
        {
          className: V("text-sm", m == null ? void 0 : m.extraSubtitle),
          children: v
        },
        h
      )),
      /* @__PURE__ */ ue("div", { className: "mt-2 flex items-center justify-between", children: [
        /* @__PURE__ */ L("div", { children: a && o && /* @__PURE__ */ L(
          TE,
          {
            className: "capitalize",
            label: a.replace(/-/g, " "),
            variant: aE(o)
          }
        ) }),
        /* @__PURE__ */ ue("div", { children: [
          /* @__PURE__ */ L("span", { className: V(m == null ? void 0 : m.amount), children: l }),
          /* @__PURE__ */ L("span", { className: V(m == null ? void 0 : m.amount, "pl-1 font-normal !leading-4"), children: c })
        ] })
      ] })
    ] }) })
  ] });
}, aE = (e) => {
  switch (e) {
    case uo.Pending:
      return "yellow";
    case uo.Processing:
      return "blue";
    case uo.Completed:
      return "green";
    case uo.Error:
      return "rose";
    case uo.Cancelled:
    case uo.Timeout:
    default:
      return "gray";
  }
}, Jh = oE, tM = ({
  className: e,
  classes: t,
  transaction: r,
  timeFormat: n = "DD-MM-YYYY HH:mm",
  statusLabel: o,
  title: a,
  onTxIdCopyClick: i
}) => {
  const { title: s, timestamp: l, amount: u, status: c, currency: p, type: d, txIndex: f, remark: m } = r, { content: v, isPositive: h } = ae(() => iE({ amount: u, type: d }), [u, d]), _ = ae(() => {
    const g = [];
    return m && g.push(m), g;
  }, [m]);
  return /* @__PURE__ */ L(
    Jh,
    {
      className: e,
      classes: t,
      amount: v,
      currency: p,
      title: a ?? s,
      status: c,
      statusLabel: o == null ? void 0 : o.replace(/-/g, " "),
      isPositive: h,
      time: l,
      timeFormat: n,
      onTxIdCopyClick: i,
      txId: f,
      variant: "expanded",
      extraSubTitles: _
    }
  );
}, iE = ({
  amount: e,
  type: t
}) => {
  const r = mi(e);
  let n = !1, o = "";
  switch (t) {
    case Wo.Withdraw:
      o += "-", n = !1;
      break;
    case Wo.Deposit:
      o += "+", n = !0;
      break;
    case Wo.Adjustment:
    case Wo.Transfer:
    case Wo.Promotion:
    default:
      n = r.isPositive(), o += n ? "+" : "-";
      break;
  }
  return o += Y1(r.abs()), {
    content: o,
    isPositive: n
  };
}, sE = (e) => {
  const t = mi(e);
  let r = "";
  return t.isPositive() ? r += "+" : t.isNegative() && (r += "-"), r += W1(t.abs(), 2), r;
}, rM = ({
  className: e,
  classes: t,
  transaction: r,
  timeFormat: n = "DD-MM-YYYY HH:mm",
  statusLabel: o,
  title: a,
  onTxIdCopyClick: i
}) => {
  const { title: s, timestamp: l, amount: u, status: c, currency: p, txIndex: d } = r, f = u.isPositive();
  return /* @__PURE__ */ L(
    Jh,
    {
      className: e,
      classes: t,
      amount: sE(u),
      currency: p,
      title: a ?? s,
      status: c,
      statusLabel: o,
      isPositive: f,
      time: l,
      timeFormat: n,
      onTxIdCopyClick: i,
      txId: d == null ? void 0 : d.slice(-12)
    }
  );
};
function ed(e) {
  return /* @__PURE__ */ ue(
    "svg",
    {
      "aria-hidden": "true",
      role: "status",
      className: V("inline animate-spin", e.className),
      viewBox: "0 0 100 101",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ L(
          "path",
          {
            d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          }
        ),
        /* @__PURE__ */ L(
          "path",
          {
            d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
            fill: "currentColor"
          }
        )
      ]
    }
  );
}
ed.defaultProps = {
  color: "white"
};
const e0 = (e) => /* @__PURE__ */ Q.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Q.createElement("path", { d: "M16.6 7.45825L11.1667 12.8916C10.525 13.5333 9.47502 13.5333 8.83336 12.8916L3.40002 7.45825", stroke: "currentColor", strokeWidth: 2, strokeMiterlimit: 10, strokeLinecap: "round", strokeLinejoin: "round" })), lE = (e) => /* @__PURE__ */ Q.createElement("svg", { width: 39, height: 40, viewBox: "0 0 39 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...e }, /* @__PURE__ */ Q.createElement("g", { id: "Star" }, /* @__PURE__ */ Q.createElement("g", { id: "Blured", filter: "url(#filter0_f_6365_5900)" }, /* @__PURE__ */ Q.createElement("path", { d: "M23.0565 4.4751L20.4658 19.3735L34.9479 23.7259L20.0495 21.1352L15.6971 35.6173L18.2878 20.7189L3.80566 16.3665L18.7041 18.9572L23.0565 4.4751Z", fill: "url(#paint0_radial_6365_5900)", fillOpacity: 0.5 })), /* @__PURE__ */ Q.createElement("g", { id: "Clear", filter: "url(#filter1_f_6365_5900)" }, /* @__PURE__ */ Q.createElement("path", { d: "M21.9063 9.34107L20.1252 19.5837L30.0817 22.576L19.839 20.7949L16.8467 30.7514L18.6278 20.5087L8.67138 17.5164L18.9141 19.2975L21.9063 9.34107Z", fill: "url(#paint1_radial_6365_5900)", fillOpacity: 0.25 }))), /* @__PURE__ */ Q.createElement("defs", null, /* @__PURE__ */ Q.createElement("filter", { id: "filter0_f_6365_5900", x: 2.80566, y: 3.4751, width: 33.1426, height: 33.1423, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ Q.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ Q.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), /* @__PURE__ */ Q.createElement("feGaussianBlur", { stdDeviation: 0.5, result: "effect1_foregroundBlur_6365_5900" })), /* @__PURE__ */ Q.createElement("filter", { id: "filter1_f_6365_5900", x: 8.4209, y: 9.09106, width: 21.9111, height: 21.9104, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" }, /* @__PURE__ */ Q.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }), /* @__PURE__ */ Q.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "BackgroundImageFix", result: "shape" }), /* @__PURE__ */ Q.createElement("feGaussianBlur", { stdDeviation: 0.125, result: "effect1_foregroundBlur_6365_5900" })), /* @__PURE__ */ Q.createElement("radialGradient", { id: "paint0_radial_6365_5900", cx: 0, cy: 0, r: 1, gradientUnits: "userSpaceOnUse", gradientTransform: "translate(19.3768 20.0462) rotate(103.296) scale(16)" }, /* @__PURE__ */ Q.createElement("stop", { stopColor: "#FAE68D" }), /* @__PURE__ */ Q.createElement("stop", { offset: 1, stopColor: "white", stopOpacity: 0.02 })), /* @__PURE__ */ Q.createElement("radialGradient", { id: "paint1_radial_6365_5900", cx: 0, cy: 0, r: 1, gradientUnits: "userSpaceOnUse", gradientTransform: "translate(19.3765 20.0462) rotate(103.296) scale(11)" }, /* @__PURE__ */ Q.createElement("stop", { stopColor: "#FAE68D" }), /* @__PURE__ */ Q.createElement("stop", { offset: 1, stopColor: "white", stopOpacity: 0.02 })))), cE = ({
  classes: e,
  className: t,
  variant: r = "ghost",
  size: n = "md",
  value: o,
  defaultValue: a,
  onChange: i,
  placeholder: s = "Languages",
  title: l = "Languages",
  languages: u,
  closeOnSelect: c = !0
}) => {
  const { themeClasses: p } = Ge("LanguageSelector", e, t, {
    variant: r,
    modifier: n
  }), [d, f] = me(a), [m, v] = me(!1);
  ge(() => {
    o && f(o);
  }, [o]);
  const h = (x) => {
    i && i(x), c && _();
  }, _ = Le(() => {
    v(!1);
  }, []), g = Le(() => {
    v(!0);
  }, []), b = (x) => {
    f(x), h(x);
  };
  return /* @__PURE__ */ ue(Gt, { children: [
    /* @__PURE__ */ ue(
      "button",
      {
        onClick: g,
        className: V(p == null ? void 0 : p.root),
        children: [
          !!d && /* @__PURE__ */ ue("span", { className: "flex items-center", children: [
            /* @__PURE__ */ L(
              "img",
              {
                src: d.flagURL,
                alt: d == null ? void 0 : d.name,
                className: V("flex-shrink-0", p == null ? void 0 : p.flag)
              }
            ),
            /* @__PURE__ */ L("span", { className: V("mx-2 line-clamp-1 block text-ellipsis whitespace-nowrap", p == null ? void 0 : p.label), children: d.name })
          ] }),
          !d && /* @__PURE__ */ L(
            "span",
            {
              className: V("line-clamp-1 block text-ellipsis whitespace-nowrap pl-2 text-center", p == null ? void 0 : p.label),
              children: s
            }
          ),
          /* @__PURE__ */ L(e0, { className: V("ml-auto flex-shrink-0", p == null ? void 0 : p.arrow) })
        ]
      }
    ),
    /* @__PURE__ */ ue(
      qC,
      {
        open: m,
        onClose: _,
        placement: "bottom",
        children: [
          /* @__PURE__ */ L(QC, { title: l }),
          /* @__PURE__ */ L(
            gE,
            {
              className: "mx-8 mb-6 mt-6",
              options: u.map((x) => ({ id: x.code, imgUrl: x.flagURL, name: x.name })),
              selectedOption: d && {
                id: d.code,
                imgUrl: d.flagURL,
                name: d.name
              },
              imageVariant: "circular",
              handleOnSelect: (x) => b({
                code: x.id,
                name: x.name ?? "",
                flagURL: x.imgUrl ?? ""
              })
            }
          )
        ]
      }
    )
  ] });
}, nM = cE, uE = (e) => /* @__PURE__ */ L(
  "svg",
  {
    width: "24",
    height: "18",
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e,
    children: /* @__PURE__ */ L(
      "path",
      {
        d: "M11.4012 5.27488C11.5612 5.27488 11.7112 5.33488 11.8212 5.45488C11.8412 5.48488 11.8712 5.51488 11.8912 5.54488L14.5012 8.15488L17.1212 5.53488C17.1212 5.53488 17.1612 5.47488 17.1912 5.45488C17.3612 5.28488 17.6212 5.23488 17.8412 5.32488C18.0612 5.41488 18.2112 5.63488 18.2112 5.87488C18.2112 6.03488 18.1512 6.18488 18.0412 6.29488L15.3512 9.00488L17.9712 11.6149C17.9712 11.6149 18.0312 11.6549 18.0512 11.6849C18.2212 11.8549 18.2712 12.1149 18.1812 12.3349C18.0912 12.5549 17.8712 12.7049 17.6312 12.7049C17.4712 12.7049 17.3212 12.6449 17.2112 12.5349L14.5112 9.84488L11.8212 12.5449H11.8112C11.7612 12.5849 11.6912 12.6349 11.6212 12.6649C11.4012 12.7549 11.1412 12.7049 10.9712 12.5349C10.8612 12.4249 10.7912 12.2749 10.7912 12.1149C10.7912 11.9549 10.8512 11.8049 10.9712 11.6949C11.0012 11.6649 11.0312 11.6449 11.0712 11.6149L13.6712 9.01488L10.9712 6.31488C10.9212 6.25488 10.8712 6.18488 10.8412 6.11488C10.7512 5.89488 10.8012 5.63488 10.9712 5.46488C11.0812 5.35488 11.2312 5.28488 11.3912 5.28488L11.4012 5.27488ZM18.4712 1.33488H11.0812C10.9912 1.33488 10.9112 1.33488 10.8312 1.33488C10.6812 1.33488 10.5312 1.33488 10.3412 1.33488C10.0112 1.33488 9.67123 1.36488 9.35123 1.42488C9.05123 1.47488 8.77123 1.57488 8.50123 1.70488C8.24123 1.83488 7.99123 2.01488 7.78123 2.22488C7.78123 2.22488 7.76123 2.24488 7.73123 2.27488C7.67123 2.33488 7.66123 2.35488 7.64123 2.37488C7.54123 2.46488 7.45123 2.55488 7.36123 2.64488C7.31123 2.69488 7.26123 2.74488 7.21123 2.79488L7.03123 2.97488L4.73123 5.27488C4.73123 5.27488 4.69123 5.31488 4.68123 5.32488C4.64123 5.36488 4.59123 5.41488 4.54123 5.45488L4.48123 5.51488C4.48123 5.51488 4.45123 5.54488 4.44123 5.55488L4.40123 5.59488L4.35123 5.64488L2.29123 7.70488C2.29123 7.70488 2.21123 7.79488 2.15123 7.84488C2.15123 7.84488 2.12456 7.87155 2.07123 7.92488C2.07123 7.92488 1.99123 8.00488 1.91123 8.08488C1.76123 8.22488 1.63123 8.38488 1.50123 8.54488L1.46123 8.59488C1.46123 8.59488 1.40123 8.67488 1.38123 8.71488C1.33123 8.89488 1.33123 9.07488 1.38123 9.25488C1.40123 9.29488 1.43123 9.33488 1.46123 9.37488L1.50123 9.42488C1.63123 9.58488 1.77123 9.73488 1.93123 9.89488C1.96123 9.92488 1.99123 9.95488 2.02123 9.99488L2.18123 10.1549C2.18123 10.1549 2.25123 10.2249 2.28123 10.2549L4.35123 12.3249L4.51123 12.4749C4.51123 12.4749 4.54123 12.5049 4.55123 12.5149C4.63123 12.5949 4.66123 12.6249 4.69123 12.6549C4.69123 12.6549 4.71123 12.6749 4.74123 12.7049L7.04123 15.0149C7.21123 15.1849 7.28123 15.2549 7.38123 15.3549C7.50123 15.4749 7.57123 15.5449 7.65123 15.6249C7.67123 15.6449 7.67123 15.6449 7.74123 15.7249C7.76123 15.7449 7.78123 15.7649 7.79123 15.7749C8.00123 15.9849 8.24123 16.1649 8.50123 16.2949C8.77123 16.4349 9.06123 16.5249 9.35123 16.5749C9.68123 16.6249 10.0112 16.6549 10.3512 16.6649C10.5212 16.6649 10.6812 16.6649 10.8412 16.6649H18.6812C18.8212 16.6649 18.9712 16.6649 19.1812 16.6649C19.5212 16.6649 19.8512 16.6349 20.1812 16.5749C20.4812 16.5249 20.7712 16.4249 21.0412 16.2949C21.3112 16.1549 21.5512 15.9849 21.7612 15.7749C21.9712 15.5649 22.1512 15.3149 22.2912 15.0549C22.4312 14.7849 22.5212 14.4949 22.5712 14.1949C22.6212 13.8649 22.6512 13.5249 22.6612 13.1749C22.6612 13.0749 22.6612 12.9949 22.6612 12.8049C22.6612 12.7649 22.6612 12.7449 22.6612 12.7249V5.23488C22.6612 5.23488 22.6612 5.21488 22.6612 5.19488C22.6612 5.07488 22.6612 5.02488 22.6612 4.96488C22.6612 4.90488 22.6612 4.85488 22.6612 4.79488C22.6612 4.46488 22.6312 4.12488 22.5712 3.80488C22.5212 3.50488 22.4212 3.21488 22.2912 2.95488C22.1512 2.68488 21.9812 2.44488 21.7712 2.23488C21.5612 2.02488 21.3212 1.84488 21.0612 1.71488C20.7912 1.57488 20.5012 1.48488 20.2212 1.43488C19.8912 1.38488 19.5612 1.35488 19.2212 1.34488C19.0412 1.34488 18.8812 1.34488 18.7312 1.34488C18.6512 1.34488 18.5812 1.34488 18.4812 1.34488L18.4712 1.33488ZM18.5612 0.00488281H18.7212C18.8812 0.00488281 19.0512 0.00488281 19.2312 0.00488281C19.6312 0.00488281 20.0312 0.0448828 20.4312 0.114883C20.8612 0.184883 21.2712 0.324883 21.6612 0.524883C22.0512 0.724883 22.4112 0.984883 22.7212 1.29488C23.0312 1.60488 23.2912 1.95488 23.4912 2.35488C23.6812 2.74488 23.8212 3.15488 23.8912 3.58488C23.9512 3.97488 23.9912 4.37488 23.9912 4.76488C23.9912 4.82488 23.9912 4.87488 23.9912 4.94488C23.9912 5.01488 23.9912 5.06488 23.9912 5.18488C23.9912 5.21822 23.9912 5.25488 23.9912 5.29488V12.6949C23.9912 12.7349 23.9912 12.7749 23.9912 12.8149C23.9912 13.0049 23.9912 13.0949 23.9912 13.1949C23.9912 13.5949 23.9512 14.0049 23.8812 14.4049C23.8112 14.8349 23.6712 15.2549 23.4712 15.6449C23.2712 16.0349 23.0112 16.3949 22.7012 16.7049C22.3912 17.0149 22.0312 17.2749 21.6312 17.4749C21.2412 17.6749 20.8212 17.8049 20.3912 17.8849C19.9912 17.9549 19.5912 17.9849 19.1912 17.9949C18.9812 17.9949 18.8212 17.9949 18.6712 17.9949H10.8212C10.6512 17.9949 10.4812 17.9949 10.3112 17.9949C9.91123 17.9949 9.51123 17.9549 9.11123 17.8849C8.68123 17.8149 8.27123 17.6749 7.88123 17.4749C7.49123 17.2749 7.13123 17.0149 6.84123 16.7249C6.82123 16.7049 6.80123 16.6849 6.75123 16.6349C6.62123 16.5049 6.54123 16.4249 6.41123 16.3049C6.37123 16.2649 6.34123 16.2349 6.30123 16.1949L6.07123 15.9649L3.79123 13.6849C3.72123 13.6149 3.68123 13.5749 3.61123 13.5149C3.57123 13.4749 3.54123 13.4449 3.50123 13.4049L3.38123 13.2849L1.31123 11.2049L1.27123 11.1649L1.17123 11.0549C1.17123 11.0549 1.15123 11.0349 1.13123 11.0149C1.06123 10.9449 1.00123 10.8849 0.971228 10.8449C0.801228 10.6749 0.631228 10.4949 0.481228 10.3049C0.341228 10.1549 0.221228 9.97488 0.141228 9.78488L0.121228 9.72488C-0.028772 9.26488 -0.028772 8.76488 0.121228 8.29488L0.141228 8.23488C0.221228 8.04488 0.341228 7.86488 0.481228 7.71488C0.631228 7.52488 0.801228 7.34488 0.961228 7.18488C1.03123 7.11488 1.08123 7.05488 1.14123 6.99488L1.17123 6.96488C1.17123 6.96488 1.18123 6.95488 1.19123 6.94488C1.24123 6.89488 1.28123 6.85488 1.32123 6.81488L3.39123 4.74488L3.44123 4.69488C3.44123 4.69488 3.46123 4.67488 3.48123 4.65488C3.53123 4.60488 3.56123 4.57488 3.59123 4.54488C3.65123 4.48488 3.71123 4.42488 3.78123 4.35488L3.80123 4.33488C3.80123 4.33488 3.83123 4.30488 3.85123 4.28488L3.93123 4.20488C3.93123 4.20488 3.96123 4.17488 3.98123 4.15488L4.11123 4.02488C4.11123 4.02488 4.16123 3.97488 4.19123 3.94488L4.81123 3.32488C4.98123 3.15488 5.17123 2.96488 5.38123 2.75488L6.08123 2.05488C6.18123 1.95488 6.27123 1.86488 6.35123 1.79488L6.42123 1.72488C6.52123 1.62488 6.62123 1.53488 6.72123 1.42488C6.81123 1.33488 6.82123 1.32488 6.83123 1.30488C7.14123 0.994883 7.49123 0.734883 7.89123 0.534883C8.28123 0.344883 8.69123 0.204883 9.12123 0.124883C9.51123 0.0648828 9.91123 0.0248828 10.3012 0.0248828C10.4912 0.0248828 10.6612 0.0248828 10.8112 0.0248828C10.8712 0.0248828 10.9212 0.0248828 10.9812 0.0248828H18.5512L18.5612 0.00488281Z",
        fill: e.color ?? "white"
      }
    )
  }
), dE = ({ classes: e, className: t, variant: r = "primary", onKeyPress: n, disabled: o }) => {
  const { themeClasses: a } = Ge("NumberPad", e, t, {
    variant: r
  }), i = (s, l) => {
    s.preventDefault(), s.stopPropagation(), n == null || n(l.toString());
  };
  return /* @__PURE__ */ ue("div", { className: V("grid h-fit w-fit grid-cols-3 gap-6", a == null ? void 0 : a.root), children: [
    Array.from({ length: 9 }, (s, l) => /* @__PURE__ */ L(
      Ko,
      {
        variant: r,
        classes: {
          "root&": "!h-20 !w-20 rounded-full",
          "label&": "text-[25px] font-normal [font-feature-settings:'clig'_off,'liga'_off]"
        },
        onClick: (u) => i(u, String(l + 1)),
        disabled: o,
        children: l + 1
      },
      l
    )),
    /* @__PURE__ */ L("div", {}),
    /* @__PURE__ */ L(
      Ko,
      {
        variant: r,
        classes: {
          "root&": "!h-20 w-20 rounded-full",
          "label&": "text-[25px] font-normal [font-feature-settings:'clig'_off,'liga'_off]"
        },
        onClick: (s) => i(s, String(0)),
        disabled: o,
        children: "0"
      }
    ),
    /* @__PURE__ */ L(
      Ko,
      {
        variant: r,
        classes: {
          "root&": "!h-20 w-20 rounded-full",
          "label&": "text-[25px] font-normal [font-feature-settings:'clig'_off,'liga'_off]"
        },
        onClick: (s) => i(s, "backspace"),
        disabled: o,
        children: /* @__PURE__ */ L(uE, {})
      }
    )
  ] });
}, oM = dE, fE = 24 * 60 * 60 * 3, pE = "pwa-reminder", mE = ({
  children: e,
  reminderPeriod: t = fE,
  reminderKey: r = pE,
  hideOnPWA: n = !0,
  onInstalled: o,
  onDismissed: a,
  withInstructions: i = !0,
  instructionOptions: s,
  onInstallable: l
}) => {
  const [u, c] = me(!1), p = ce(), [d, f] = me(!1), [m, v] = me(!1), { dueAt: h, updateDueAt: _ } = Z_(r);
  ge(() => {
    l == null || l(u);
  }, [u, l]), ge(() => {
    if (!(h ? ie().isAfter(h) : !0) || n && sessionStorage.getItem("display-mode") === "standalone")
      return;
    const O = (y) => {
      y.preventDefault(), p.current = y, c(!0);
    }, P = () => {
      o == null || o();
    };
    return window.addEventListener("beforeinstallprompt", O), window.addEventListener("appinstalled", P), () => {
      window.removeEventListener("beforeinstallprompt", O), window.removeEventListener("appinstalled", P);
    };
  }, [n, h, o]);
  const g = Le(() => {
    var E, O;
    c(!1), (E = p.current) == null || E.prompt(), (O = p.current) == null || O.userChoice.then((P) => {
      P.outcome === "accepted" ? o == null || o() : (c(!0), a == null || a());
    });
  }, [a, o]), b = Le(() => {
    _(ie().add(t, "seconds")), c(!1);
  }, [t, _]), x = Le(() => {
    if (S1() || E1()) {
      f(!0);
      return;
    }
    if (T1()) {
      v(!0);
      return;
    }
    g();
  }, [g]);
  return /* @__PURE__ */ ue(Gt, { children: [
    u && e(x, b),
    /* @__PURE__ */ L(
      su,
      {
        open: d,
        onClose: () => f(!1),
        title: s == null ? void 0 : s.openExtBrowser.title,
        classes: {
          "title&": "!mb-4"
        },
        children: /* @__PURE__ */ L(
          "video",
          {
            autoPlay: !0,
            loop: !0,
            muted: !0,
            playsInline: !0,
            className: "rounded-xl",
            children: /* @__PURE__ */ L(
              "source",
              {
                src: s == null ? void 0 : s.openExtBrowser.videoSrc,
                type: "video/mp4"
              }
            )
          }
        )
      }
    ),
    /* @__PURE__ */ L(
      su,
      {
        open: m,
        onClose: () => v(!1),
        title: s == null ? void 0 : s.openShareAddHomeScreen.title,
        classes: {
          "title&": "!mb-4"
        },
        children: /* @__PURE__ */ L(
          "video",
          {
            autoPlay: !0,
            loop: !0,
            muted: !0,
            playsInline: !0,
            className: "rounded-xl",
            children: /* @__PURE__ */ L(
              "source",
              {
                src: s == null ? void 0 : s.openShareAddHomeScreen.videoSrc,
                type: "video/mp4"
              }
            )
          }
        )
      }
    )
  ] });
}, aM = mE, hE = ({
  classes: e,
  className: t,
  selectedOption: r,
  options: n,
  handleOnSelect: o,
  imageVariant: a
}) => {
  const { themeClasses: i } = Ge("SelectOptions", e, t, {
    variant: a
  });
  return /* @__PURE__ */ L(xE, { className: V(i == null ? void 0 : i.root), children: n.map((s) => {
    const { id: l, imgUrl: u, name: c } = s, p = (r == null ? void 0 : r.id) === s.id;
    return /* @__PURE__ */ ue(
      "div",
      {
        onClick: () => o(s),
        className: "flex w-full items-center p-4 first:rounded-t-md last:rounded-b-md",
        children: [
          u && /* @__PURE__ */ L(
            "img",
            {
              src: u,
              alt: c,
              className: V(i == null ? void 0 : i.image)
            }
          ),
          c && /* @__PURE__ */ L("span", { className: V("text-content-base ml-3 text-base"), children: c }),
          /* @__PURE__ */ L(
            xD,
            {
              checked: p,
              onChange: () => o(s),
              className: "ml-auto",
              variant: "filled"
            }
          )
        ]
      },
      l
    );
  }) });
}, gE = hE, vE = ({ classes: e, isShown: t, children: r, icon: n }) => {
  const { themeClasses: o } = Ge("WarningWrapper", e), a = ae(() => t ? n || /* @__PURE__ */ L(
    "span",
    {
      className: V(
        "absolute -top-1 right-0 z-10 flex h-5 w-5 items-center justify-center rounded-full bg-pink-500 text-sm",
        o == null ? void 0 : o.span
      ),
      children: "!"
    }
  ) : null, [t, n, o == null ? void 0 : o.span]);
  return /* @__PURE__ */ ue("div", { className: V("relative", o == null ? void 0 : o.root), children: [
    r,
    a
  ] });
}, iM = vE, yE = ({ text: e, onSuccess: t, onError: r, className: n, classes: o, children: a }) => {
  const { themeClasses: i } = Ge("CopyWrapper", o, n);
  return /* @__PURE__ */ L(
    "span",
    {
      onClick: async () => {
        if (e !== void 0)
          try {
            await $1(e), t == null || t();
          } catch {
            r == null || r();
          }
      },
      className: V("w-fit px-2 flex cursor-pointer items-center justify-center", i == null ? void 0 : i.root),
      children: a || e
    }
  );
}, sM = yE, bE = ({ classes: e, className: t, subTitle: r, title: n, icon: o, size: a = "md" }) => {
  const { themeClasses: i } = Ge("EmptyState", e, t, {
    modifier: a
  });
  return /* @__PURE__ */ ue("div", { className: V(i == null ? void 0 : i.root), children: [
    o,
    n && /* @__PURE__ */ L(
      "h3",
      {
        className: V(i == null ? void 0 : i.title, {
          "mt-1": !!o
        }),
        children: n
      }
    ),
    n && /* @__PURE__ */ L("p", { className: V(i == null ? void 0 : i.subTitle), children: r })
  ] });
}, lM = bE, cM = ({
  html: e,
  as: t,
  ...r
}) => {
  const n = ae(() => e ? r_(e) : "", [e]);
  return /* @__PURE__ */ L(
    t || "div",
    {
      ...r,
      dangerouslySetInnerHTML: { __html: n }
    }
  );
}, wE = ({ children: e, classes: t, className: r }) => {
  const { themeClasses: n } = Ge("List", t, r);
  return /* @__PURE__ */ L("div", { className: V("flex flex-col", n == null ? void 0 : n.root), children: e });
}, xE = wE, _E = ({ percent: e, children: t, classes: r, className: n }) => {
  const { themeClasses: o } = Ge("ProgressBar", r, n), a = Math.round(e * 100);
  return /* @__PURE__ */ ue("div", { className: V("relative h-3 rounded-full bg-darkBrand-800", o == null ? void 0 : o.root), children: [
    /* @__PURE__ */ ue("div", { className: "absolute left-0.5 top-0.5 h-2 w-[calc(100%-2px)]", children: [
      /* @__PURE__ */ L(
        "div",
        {
          className: "absolute left-0 top-0 h-full w-[calc(100%-2px)] rounded-full bg-timerProgressBar bg-no-repeat",
          style: {
            backgroundPosition: "right,left",
            backgroundSize: `${100 - a}% 100%,100% 100%`
          }
        }
      ),
      /* @__PURE__ */ L(
        "div",
        {
          className: "bg-timerProgressStripes absolute left-0 top-0 h-full",
          style: {
            width: `${a}%`,
            backgroundSize: "70px 70px"
          }
        }
      )
    ] }),
    /* @__PURE__ */ L("div", { className: "absolute left-0 top-0 ml-1.5 h-full w-[calc(100%-12px)]", children: /* @__PURE__ */ L(
      "div",
      {
        style: {
          left: `${a}%`,
          filter: "drop-shadow(0px 0px 6px var(--tw-shadow-color))"
        },
        className: V(
          "absolute top-[-1px] h-[14px] w-[14px] -translate-x-1/2 rounded-full border-2 border-white border-opacity-60 bg-brand-600 shadow-brand-600 drop-shadow-md"
        )
      }
    ) })
  ] });
}, uM = _E, SE = ({ classes: e, className: t, count: r = 1 }) => {
  const { themeClasses: n } = Ge("Skeleton", e, t);
  return /* @__PURE__ */ L(Gt, { children: Array.from({
    length: r
  }).map((o, a) => /* @__PURE__ */ L(
    "div",
    {
      className: V(n == null ? void 0 : n.root, t)
    },
    "skeleton-" + a
  )) });
}, dM = SE, EE = ({ className: e, classes: t, label: r, variant: n }) => {
  const { themeClasses: o } = Ge("StatusChip", t, e, { variant: n });
  return /* @__PURE__ */ ue("div", { className: V("flex items-center justify-center", o == null ? void 0 : o.root), children: [
    /* @__PURE__ */ L("span", { className: V(o == null ? void 0 : o.dot) }),
    /* @__PURE__ */ L("span", { className: V(o == null ? void 0 : o.label), children: r })
  ] });
}, TE = EE, t0 = typeof document < "u" ? G.useLayoutEffect : () => {
};
function kE(e) {
  const t = ce(null);
  return t0(() => {
    t.current = e;
  }, [
    e
  ]), Le((...r) => {
    const n = t.current;
    return n == null ? void 0 : n(...r);
  }, []);
}
const Si = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, bo = (e) => e && "window" in e && e.window === e ? e : Si(e).defaultView || window;
function OE(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((r) => e.test(r.brand))) || e.test(window.navigator.userAgent);
}
function DE(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function NE() {
  return DE(/^Mac/i);
}
function CE() {
  return OE(/Android/i);
}
function PE(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : CE() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
class ME {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, r) {
    this.nativeEvent = r, this.target = r.target, this.currentTarget = r.currentTarget, this.relatedTarget = r.relatedTarget, this.bubbles = r.bubbles, this.cancelable = r.cancelable, this.defaultPrevented = r.defaultPrevented, this.eventPhase = r.eventPhase, this.isTrusted = r.isTrusted, this.timeStamp = r.timeStamp, this.type = t;
  }
}
function r0(e) {
  let t = ce({
    isFocused: !1,
    observer: null
  });
  t0(() => {
    const n = t.current;
    return () => {
      n.observer && (n.observer.disconnect(), n.observer = null);
    };
  }, []);
  let r = kE((n) => {
    e == null || e(n);
  });
  return Le((n) => {
    if (n.target instanceof HTMLButtonElement || n.target instanceof HTMLInputElement || n.target instanceof HTMLTextAreaElement || n.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let o = n.target, a = (i) => {
        t.current.isFocused = !1, o.disabled && r(new ME("blur", i)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      o.addEventListener("focusout", a, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && o.disabled) {
          var i;
          (i = t.current.observer) === null || i === void 0 || i.disconnect();
          let s = o === document.activeElement ? null : document.activeElement;
          o.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: s
          })), o.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: s
          }));
        }
      }), t.current.observer.observe(o, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    r
  ]);
}
function RE(e) {
  let { isDisabled: t, onFocus: r, onBlur: n, onFocusChange: o } = e;
  const a = Le((l) => {
    if (l.target === l.currentTarget)
      return n && n(l), o && o(!1), !0;
  }, [
    n,
    o
  ]), i = r0(a), s = Le((l) => {
    const u = Si(l.target);
    l.target === l.currentTarget && u.activeElement === l.target && (r && r(l), o && o(!0), i(l));
  }, [
    o,
    r,
    i
  ]);
  return {
    focusProps: {
      onFocus: !t && (r || o || n) ? s : void 0,
      onBlur: !t && (n || o) ? a : void 0
    }
  };
}
let Ei = null, Qc = /* @__PURE__ */ new Set(), Va = /* @__PURE__ */ new Map(), Oo = !1, Kc = !1;
const AE = {
  Tab: !0,
  Escape: !0
};
function td(e, t) {
  for (let r of Qc) r(e, t);
}
function IE(e) {
  return !(e.metaKey || !NE() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Is(e) {
  Oo = !0, IE(e) && (Ei = "keyboard", td("keyboard", e));
}
function Pr(e) {
  Ei = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (Oo = !0, td("pointer", e));
}
function n0(e) {
  PE(e) && (Oo = !0, Ei = "virtual");
}
function o0(e) {
  e.target === window || e.target === document || (!Oo && !Kc && (Ei = "virtual", td("virtual", e)), Oo = !1, Kc = !1);
}
function a0() {
  Oo = !1, Kc = !0;
}
function Xc(e) {
  if (typeof window > "u" || Va.get(bo(e))) return;
  const t = bo(e), r = Si(e);
  let n = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    Oo = !0, n.apply(this, arguments);
  }, r.addEventListener("keydown", Is, !0), r.addEventListener("keyup", Is, !0), r.addEventListener("click", n0, !0), t.addEventListener("focus", o0, !0), t.addEventListener("blur", a0, !1), typeof PointerEvent < "u" ? (r.addEventListener("pointerdown", Pr, !0), r.addEventListener("pointermove", Pr, !0), r.addEventListener("pointerup", Pr, !0)) : (r.addEventListener("mousedown", Pr, !0), r.addEventListener("mousemove", Pr, !0), r.addEventListener("mouseup", Pr, !0)), t.addEventListener("beforeunload", () => {
    i0(e);
  }, {
    once: !0
  }), Va.set(t, {
    focus: n
  });
}
const i0 = (e, t) => {
  const r = bo(e), n = Si(e);
  t && n.removeEventListener("DOMContentLoaded", t), Va.has(r) && (r.HTMLElement.prototype.focus = Va.get(r).focus, n.removeEventListener("keydown", Is, !0), n.removeEventListener("keyup", Is, !0), n.removeEventListener("click", n0, !0), r.removeEventListener("focus", o0, !0), r.removeEventListener("blur", a0, !1), typeof PointerEvent < "u" ? (n.removeEventListener("pointerdown", Pr, !0), n.removeEventListener("pointermove", Pr, !0), n.removeEventListener("pointerup", Pr, !0)) : (n.removeEventListener("mousedown", Pr, !0), n.removeEventListener("mousemove", Pr, !0), n.removeEventListener("mouseup", Pr, !0)), Va.delete(r));
};
function FE(e) {
  const t = Si(e);
  let r;
  return t.readyState !== "loading" ? Xc(e) : (r = () => {
    Xc(e);
  }, t.addEventListener("DOMContentLoaded", r)), () => i0(e, r);
}
typeof document < "u" && FE();
function s0() {
  return Ei !== "pointer";
}
const LE = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function $E(e, t, r) {
  var n;
  const o = typeof window < "u" ? bo(r == null ? void 0 : r.target).HTMLInputElement : HTMLInputElement, a = typeof window < "u" ? bo(r == null ? void 0 : r.target).HTMLTextAreaElement : HTMLTextAreaElement, i = typeof window < "u" ? bo(r == null ? void 0 : r.target).HTMLElement : HTMLElement, s = typeof window < "u" ? bo(r == null ? void 0 : r.target).KeyboardEvent : KeyboardEvent;
  return e = e || (r == null ? void 0 : r.target) instanceof o && !LE.has(r == null || (n = r.target) === null || n === void 0 ? void 0 : n.type) || (r == null ? void 0 : r.target) instanceof a || (r == null ? void 0 : r.target) instanceof i && (r == null ? void 0 : r.target.isContentEditable), !(e && t === "keyboard" && r instanceof s && !AE[r.key]);
}
function WE(e, t, r) {
  Xc(), ge(() => {
    let n = (o, a) => {
      $E(!!(r != null && r.isTextInput), o, a) && e(s0());
    };
    return Qc.add(n), () => {
      Qc.delete(n);
    };
  }, t);
}
function YE(e) {
  let { isDisabled: t, onBlurWithin: r, onFocusWithin: n, onFocusWithinChange: o } = e, a = ce({
    isFocusWithin: !1
  }), i = Le((u) => {
    a.current.isFocusWithin && !u.currentTarget.contains(u.relatedTarget) && (a.current.isFocusWithin = !1, r && r(u), o && o(!1));
  }, [
    r,
    o,
    a
  ]), s = r0(i), l = Le((u) => {
    !a.current.isFocusWithin && document.activeElement === u.target && (n && n(u), o && o(!0), a.current.isFocusWithin = !0, s(u));
  }, [
    n,
    o,
    s
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: l,
      onBlur: i
    }
  };
}
let Fs = !1, oc = 0;
function Zc() {
  Fs = !0, setTimeout(() => {
    Fs = !1;
  }, 50);
}
function pp(e) {
  e.pointerType === "touch" && Zc();
}
function BE() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", pp) : document.addEventListener("touchend", Zc), oc++, () => {
      oc--, !(oc > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", pp) : document.removeEventListener("touchend", Zc));
    };
}
function Ti(e) {
  let { onHoverStart: t, onHoverChange: r, onHoverEnd: n, isDisabled: o } = e, [a, i] = me(!1), s = ce({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  ge(BE, []);
  let { hoverProps: l, triggerHoverEnd: u } = ae(() => {
    let c = (f, m) => {
      if (s.pointerType = m, o || m === "touch" || s.isHovered || !f.currentTarget.contains(f.target)) return;
      s.isHovered = !0;
      let v = f.currentTarget;
      s.target = v, t && t({
        type: "hoverstart",
        target: v,
        pointerType: m
      }), r && r(!0), i(!0);
    }, p = (f, m) => {
      if (s.pointerType = "", s.target = null, m === "touch" || !s.isHovered) return;
      s.isHovered = !1;
      let v = f.currentTarget;
      n && n({
        type: "hoverend",
        target: v,
        pointerType: m
      }), r && r(!1), i(!1);
    }, d = {};
    return typeof PointerEvent < "u" ? (d.onPointerEnter = (f) => {
      Fs && f.pointerType === "mouse" || c(f, f.pointerType);
    }, d.onPointerLeave = (f) => {
      !o && f.currentTarget.contains(f.target) && p(f, f.pointerType);
    }) : (d.onTouchStart = () => {
      s.ignoreEmulatedMouseEvents = !0;
    }, d.onMouseEnter = (f) => {
      !s.ignoreEmulatedMouseEvents && !Fs && c(f, "mouse"), s.ignoreEmulatedMouseEvents = !1;
    }, d.onMouseLeave = (f) => {
      !o && f.currentTarget.contains(f.target) && p(f, "mouse");
    }), {
      hoverProps: d,
      triggerHoverEnd: p
    };
  }, [
    t,
    r,
    n,
    o,
    s
  ]);
  return ge(() => {
    o && u({
      currentTarget: s.target
    }, s.pointerType);
  }, [
    o
  ]), {
    hoverProps: l,
    isHovered: a
  };
}
function ca(e = {}) {
  let { autoFocus: t = !1, isTextInput: r, within: n } = e, o = ce({
    isFocused: !1,
    isFocusVisible: t || s0()
  }), [a, i] = me(!1), [s, l] = me(() => o.current.isFocused && o.current.isFocusVisible), u = Le(() => l(o.current.isFocused && o.current.isFocusVisible), []), c = Le((f) => {
    o.current.isFocused = f, i(f), u();
  }, [
    u
  ]);
  WE((f) => {
    o.current.isFocusVisible = f, u();
  }, [], {
    isTextInput: r
  });
  let { focusProps: p } = RE({
    isDisabled: n,
    onFocusChange: c
  }), { focusWithinProps: d } = YE({
    isDisabled: !n,
    onFocusWithinChange: c
  });
  return {
    isFocused: a,
    isFocusVisible: s,
    focusProps: n ? d : p
  };
}
var jE = Object.defineProperty, UE = (e, t, r) => t in e ? jE(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, ac = (e, t, r) => (UE(e, typeof t != "symbol" ? t + "" : t, r), r);
let HE = class {
  constructor() {
    ac(this, "current", this.detect()), ac(this, "handoffState", "pending"), ac(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, _o = new HE();
function Qr(e) {
  return _o.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
function ki(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Kr() {
  let e = [], t = { addEventListener(r, n, o, a) {
    return r.addEventListener(n, o, a), t.add(() => r.removeEventListener(n, o, a));
  }, requestAnimationFrame(...r) {
    let n = requestAnimationFrame(...r);
    return t.add(() => cancelAnimationFrame(n));
  }, nextFrame(...r) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...r));
  }, setTimeout(...r) {
    let n = setTimeout(...r);
    return t.add(() => clearTimeout(n));
  }, microTask(...r) {
    let n = { current: !0 };
    return ki(() => {
      n.current && r[0]();
    }), t.add(() => {
      n.current = !1;
    });
  }, style(r, n, o) {
    let a = r.style.getPropertyValue(n);
    return Object.assign(r.style, { [n]: o }), this.add(() => {
      Object.assign(r.style, { [n]: a });
    });
  }, group(r) {
    let n = Kr();
    return r(n), this.add(() => n.dispose());
  }, add(r) {
    return e.includes(r) || e.push(r), () => {
      let n = e.indexOf(r);
      if (n >= 0) for (let o of e.splice(n, 1)) o();
    };
  }, dispose() {
    for (let r of e.splice(0)) r();
  } };
  return t;
}
function An() {
  let [e] = me(Kr);
  return ge(() => () => e.dispose(), [e]), e;
}
let Ye = (e, t) => {
  _o.isServer ? ge(e, t) : pi(e, t);
};
function ir(e) {
  let t = ce(e);
  return Ye(() => {
    t.current = e;
  }, [e]), t;
}
let ee = function(e) {
  let t = ir(e);
  return G.useCallback((...r) => t.current(...r), [t]);
};
function VE(e) {
  let t = e.width / 2, r = e.height / 2;
  return { top: e.clientY - r, right: e.clientX + t, bottom: e.clientY + r, left: e.clientX - t };
}
function zE(e, t) {
  return !(!e || !t || e.right < t.left || e.left > t.right || e.bottom < t.top || e.top > t.bottom);
}
function Oi({ disabled: e = !1 } = {}) {
  let t = ce(null), [r, n] = me(!1), o = An(), a = ee(() => {
    t.current = null, n(!1), o.dispose();
  }), i = ee((s) => {
    if (o.dispose(), t.current === null) {
      t.current = s.currentTarget, n(!0);
      {
        let l = Qr(s.currentTarget);
        o.addEventListener(l, "pointerup", a, !1), o.addEventListener(l, "pointermove", (u) => {
          if (t.current) {
            let c = VE(u);
            n(zE(c, t.current.getBoundingClientRect()));
          }
        }, !1), o.addEventListener(l, "pointercancel", a, !1);
      }
    }
  });
  return { pressed: r, pressProps: e ? {} : { onPointerDown: i, onPointerUp: a, onClick: a } };
}
let qE = $e(void 0);
function rd() {
  return Oe(qE);
}
function Jc(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
function Ze(e, t, ...r) {
  if (e in t) {
    let o = t[e];
    return typeof o == "function" ? o(...r) : o;
  }
  let n = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((o) => `"${o}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(n, Ze), n;
}
var Qt = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Qt || {}), Xn = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(Xn || {});
function Ie({ ourProps: e, theirProps: t, slot: r, defaultTag: n, features: o, visible: a = !0, name: i, mergeRefs: s }) {
  s = s ?? GE;
  let l = l0(t, e);
  if (a) return ps(l, r, n, i, s);
  let u = o ?? 0;
  if (u & 2) {
    let { static: c = !1, ...p } = l;
    if (c) return ps(p, r, n, i, s);
  }
  if (u & 1) {
    let { unmount: c = !0, ...p } = l;
    return Ze(c ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return ps({ ...p, hidden: !0, style: { display: "none" } }, r, n, i, s);
    } });
  }
  return ps(l, r, n, i, s);
}
function ps(e, t = {}, r, n, o) {
  let { as: a = r, children: i, refName: s = "ref", ...l } = ic(e, ["unmount", "static"]), u = e.ref !== void 0 ? { [s]: e.ref } : {}, c = typeof i == "function" ? i(t) : i;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(t)), l["aria-labelledby"] && l["aria-labelledby"] === l.id && (l["aria-labelledby"] = void 0);
  let p = {};
  if (t) {
    let d = !1, f = [];
    for (let [m, v] of Object.entries(t)) typeof v == "boolean" && (d = !0), v === !0 && f.push(m.replace(/([A-Z])/g, (h) => `-${h.toLowerCase()}`));
    if (d) {
      p["data-headlessui-state"] = f.join(" ");
      for (let m of f) p[`data-${m}`] = "";
    }
  }
  if (a === jt && (Object.keys(qn(l)).length > 0 || Object.keys(qn(p)).length > 0)) if (!pm(c) || Array.isArray(c) && c.length > 1) {
    if (Object.keys(qn(l)).length > 0) throw new Error(['Passing props on "Fragment"!', "", `The current component <${n} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(qn(l)).concat(Object.keys(qn(p))).map((d) => `  - ${d}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((d) => `  - ${d}`).join(`
`)].join(`
`));
  } else {
    let d = c.props, f = d == null ? void 0 : d.className, m = typeof f == "function" ? (..._) => Jc(f(..._), l.className) : Jc(f, l.className), v = m ? { className: m } : {}, h = l0(c.props, qn(ic(l, ["ref"])));
    for (let _ in p) _ in h && delete p[_];
    return p1(c, Object.assign({}, h, p, u, { ref: o(c.ref, u.ref) }, v));
  }
  return m1(a, Object.assign({}, ic(l, ["ref"]), a !== jt && u, a !== jt && p), c);
}
function Di() {
  let e = ce([]), t = Le((r) => {
    for (let n of e.current) n != null && (typeof n == "function" ? n(r) : n.current = r);
  }, []);
  return (...r) => {
    if (!r.every((n) => n == null)) return e.current = r, t;
  };
}
function GE(...e) {
  return e.every((t) => t == null) ? void 0 : (t) => {
    for (let r of e) r != null && (typeof r == "function" ? r(t) : r.current = t);
  };
}
function l0(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let o in n) o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  if (t.disabled || t["aria-disabled"]) for (let n in r) /^(on(?:Click|Pointer|Mouse|Key)(?:Down|Up|Press)?)$/.test(n) && (r[n] = [(o) => {
    var a;
    return (a = o == null ? void 0 : o.preventDefault) == null ? void 0 : a.call(o);
  }]);
  for (let n in r) Object.assign(t, { [n](o, ...a) {
    let i = r[n];
    for (let s of i) {
      if ((o instanceof Event || (o == null ? void 0 : o.nativeEvent) instanceof Event) && o.defaultPrevented) return;
      s(o, ...a);
    }
  } });
  return t;
}
function Hr(...e) {
  if (e.length === 0) return {};
  if (e.length === 1) return e[0];
  let t = {}, r = {};
  for (let n of e) for (let o in n) o.startsWith("on") && typeof n[o] == "function" ? (r[o] != null || (r[o] = []), r[o].push(n[o])) : t[o] = n[o];
  for (let n in r) Object.assign(t, { [n](...o) {
    let a = r[n];
    for (let i of a) i == null || i(...o);
  } });
  return t;
}
function Ae(e) {
  var t;
  return Object.assign(na(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function qn(e) {
  let t = Object.assign({}, e);
  for (let r in t) t[r] === void 0 && delete t[r];
  return t;
}
function ic(e, t = []) {
  let r = Object.assign({}, e);
  for (let n of t) n in r && delete r[n];
  return r;
}
function QE(e, t, r) {
  let [n, o] = me(r), a = e !== void 0, i = ce(a), s = ce(!1), l = ce(!1);
  return a && !i.current && !s.current ? (s.current = !0, i.current = a, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !a && i.current && !l.current && (l.current = !0, i.current = a, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [a ? e : n, ee((u) => (a || o(u), t == null ? void 0 : t(u)))];
}
function KE(e) {
  let [t] = me(e);
  return t;
}
function c0(e = {}, t = null, r = []) {
  for (let [n, o] of Object.entries(e)) d0(r, u0(t, n), o);
  return r;
}
function u0(e, t) {
  return e ? e + "[" + t + "]" : t;
}
function d0(e, t, r) {
  if (Array.isArray(r)) for (let [n, o] of r.entries()) d0(e, u0(t, n.toString()), o);
  else r instanceof Date ? e.push([t, r.toISOString()]) : typeof r == "boolean" ? e.push([t, r ? "1" : "0"]) : typeof r == "string" ? e.push([t, r]) : typeof r == "number" ? e.push([t, `${r}`]) : r == null ? e.push([t, ""]) : c0(r, t, e);
}
function XE(e) {
  var t, r;
  let n = (t = e == null ? void 0 : e.form) != null ? t : e.closest("form");
  if (n) {
    for (let o of n.elements) if (o !== e && (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image")) {
      o.click();
      return;
    }
    (r = n.requestSubmit) == null || r.call(n);
  }
}
let ZE = "span";
var cn = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(cn || {});
function JE(e, t) {
  var r;
  let { features: n = 1, ...o } = e, a = { ref: t, "aria-hidden": (n & 2) === 2 ? !0 : (r = o["aria-hidden"]) != null ? r : void 0, hidden: (n & 4) === 4 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return Ie({ ourProps: a, theirProps: o, slot: {}, defaultTag: ZE, name: "Hidden" });
}
let un = Ae(JE), eT = $e(null);
function tT({ children: e }) {
  let t = Oe(eT);
  if (!t) return G.createElement(G.Fragment, null, e);
  let { target: r } = t;
  return r ? hm(G.createElement(G.Fragment, null, e), r) : null;
}
function rT({ data: e, form: t, disabled: r, onReset: n, overrides: o }) {
  let [a, i] = me(null), s = An();
  return ge(() => {
    if (n && a) return s.addEventListener(a, "reset", n);
  }, [a, t, n]), G.createElement(tT, null, G.createElement(nT, { setForm: i, formId: t }), c0(e).map(([l, u]) => G.createElement(un, { features: cn.Hidden, ...qn({ key: l, as: "input", type: "hidden", hidden: !0, readOnly: !0, form: t, disabled: r, name: l, value: u, ...o }) })));
}
function nT({ setForm: e, formId: t }) {
  return ge(() => {
    if (t) {
      let r = document.getElementById(t);
      r && e(r);
    }
  }, [e, t]), t ? null : G.createElement(un, { features: cn.Hidden, as: "input", type: "hidden", hidden: !0, readOnly: !0, ref: (r) => {
    if (!r) return;
    let n = r.closest("form");
    n && e(n);
  } });
}
let oT = $e(void 0);
function f0() {
  return Oe(oT);
}
function Ni(e) {
  let t = e.parentElement, r = null;
  for (; t && !(t instanceof HTMLFieldSetElement); ) t instanceof HTMLLegendElement && (r = t), t = t.parentElement;
  let n = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return n && aT(r) ? !1 : n;
}
function aT(e) {
  if (!e) return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement) return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let p0 = Symbol();
function nd(e, t = !0) {
  return Object.assign(e, { [p0]: t });
}
function Ue(...e) {
  let t = ce(e);
  ge(() => {
    t.current = e;
  }, [e]);
  let r = ee((n) => {
    for (let o of t.current) o != null && (typeof o == "function" ? o(n) : o.current = n);
  });
  return e.every((n) => n == null || (n == null ? void 0 : n[p0])) ? void 0 : r;
}
let cl = $e(null);
cl.displayName = "DescriptionContext";
function m0() {
  let e = Oe(cl);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, m0), t;
  }
  return e;
}
function iT() {
  var e, t;
  return (t = (e = Oe(cl)) == null ? void 0 : e.value) != null ? t : void 0;
}
function h0() {
  let [e, t] = me([]);
  return [e.length > 0 ? e.join(" ") : void 0, ae(() => function(r) {
    let n = ee((a) => (t((i) => [...i, a]), () => t((i) => {
      let s = i.slice(), l = s.indexOf(a);
      return l !== -1 && s.splice(l, 1), s;
    }))), o = ae(() => ({ register: n, slot: r.slot, name: r.name, props: r.props, value: r.value }), [n, r.slot, r.name, r.props, r.value]);
    return G.createElement(cl.Provider, { value: o }, r.children);
  }, [t])];
}
let sT = "p";
function lT(e, t) {
  let r = xt(), n = rd(), { id: o = `headlessui-description-${r}`, ...a } = e, i = m0(), s = Ue(t);
  Ye(() => i.register(o), [o, i.register]);
  let l = n || !1, u = ae(() => ({ ...i.slot, disabled: l }), [i.slot, l]), c = { ref: s, ...i.props, id: o };
  return Ie({ ourProps: c, theirProps: a, slot: u, defaultTag: sT, name: i.name || "Description" });
}
let cT = Ae(lT), uT = Object.assign(cT, {});
var ye = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(ye || {});
let ul = $e(null);
ul.displayName = "LabelContext";
function od() {
  let e = Oe(ul);
  if (e === null) {
    let t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, od), t;
  }
  return e;
}
function g0(e) {
  var t, r, n;
  let o = (r = (t = Oe(ul)) == null ? void 0 : t.value) != null ? r : void 0;
  return ((n = e == null ? void 0 : e.length) != null ? n : 0) > 0 ? [o, ...e].filter(Boolean).join(" ") : o;
}
function ad({ inherit: e = !1 } = {}) {
  let t = g0(), [r, n] = me([]), o = e ? [t, ...r].filter(Boolean) : r;
  return [o.length > 0 ? o.join(" ") : void 0, ae(() => function(a) {
    let i = ee((l) => (n((u) => [...u, l]), () => n((u) => {
      let c = u.slice(), p = c.indexOf(l);
      return p !== -1 && c.splice(p, 1), c;
    }))), s = ae(() => ({ register: i, slot: a.slot, name: a.name, props: a.props, value: a.value }), [i, a.slot, a.name, a.props, a.value]);
    return G.createElement(ul.Provider, { value: s }, a.children);
  }, [n])];
}
let dT = "label";
function fT(e, t) {
  var r;
  let n = xt(), o = od(), a = f0(), i = rd(), { id: s = `headlessui-label-${n}`, htmlFor: l = a ?? ((r = o.props) == null ? void 0 : r.htmlFor), passive: u = !1, ...c } = e, p = Ue(t);
  Ye(() => o.register(s), [s, o.register]);
  let d = ee((h) => {
    let _ = h.currentTarget;
    if (_ instanceof HTMLLabelElement && h.preventDefault(), o.props && "onClick" in o.props && typeof o.props.onClick == "function" && o.props.onClick(h), _ instanceof HTMLLabelElement) {
      let g = document.getElementById(_.htmlFor);
      if (g) {
        let b = g.getAttribute("disabled");
        if (b === "true" || b === "") return;
        let x = g.getAttribute("aria-disabled");
        if (x === "true" || x === "") return;
        (g instanceof HTMLInputElement && (g.type === "radio" || g.type === "checkbox") || g.role === "radio" || g.role === "checkbox" || g.role === "switch") && g.click(), g.focus({ preventScroll: !0 });
      }
    }
  }), f = i || !1, m = ae(() => ({ ...o.slot, disabled: f }), [o.slot, f]), v = { ref: p, ...o.props, id: s, htmlFor: l, onClick: d };
  return u && ("onClick" in v && (delete v.htmlFor, delete v.onClick), "onClick" in c && delete c.onClick), Ie({ ourProps: v, theirProps: c, slot: m, defaultTag: l ? dT : "div", name: o.name || "Label" });
}
let pT = Ae(fT), mT = Object.assign(pT, {}), hT = $e(() => {
});
function id({ value: e, children: t }) {
  return G.createElement(hT.Provider, { value: e }, t);
}
function gT(e, t) {
  return e !== null && t !== null && typeof e == "object" && typeof t == "object" && "id" in e && "id" in t ? e.id === t.id : e === t;
}
function vT(e = gT) {
  return Le((t, r) => {
    if (typeof e == "string") {
      let n = e;
      return (t == null ? void 0 : t[n]) === (r == null ? void 0 : r[n]);
    }
    return e(t, r);
  }, [e]);
}
function yT(e) {
  if (e === null) return { width: 0, height: 0 };
  let { width: t, height: r } = e.getBoundingClientRect();
  return { width: t, height: r };
}
function sd(e, t = !1) {
  let [r, n] = Co(() => ({}), {}), o = ae(() => yT(e), [e, r]);
  return Ye(() => {
    if (!e) return;
    let a = new ResizeObserver(n);
    return a.observe(e), () => {
      a.disconnect();
    };
  }, [e]), t ? { width: `${o.width}px`, height: `${o.height}px` } : o;
}
let bT = class extends Map {
  constructor(t) {
    super(), this.factory = t;
  }
  get(t) {
    let r = super.get(t);
    return r === void 0 && (r = this.factory(t), this.set(t, r)), r;
  }
};
function v0(e, t) {
  let r = e(), n = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return r;
  }, subscribe(o) {
    return n.add(o), () => n.delete(o);
  }, dispatch(o, ...a) {
    let i = t[o].call(r, ...a);
    i && (r = i, n.forEach((s) => s()));
  } };
}
function y0(e) {
  return h1(e.subscribe, e.getSnapshot, e.getSnapshot);
}
let wT = new bT(() => v0(() => [], { ADD(e) {
  return this.includes(e) ? this : [...this, e];
}, REMOVE(e) {
  let t = this.indexOf(e);
  if (t === -1) return this;
  let r = this.slice();
  return r.splice(t, 1), r;
} }));
function ua(e, t) {
  let r = wT.get(t), n = xt(), o = y0(r);
  if (Ye(() => {
    if (e) return r.dispatch("ADD", n), () => r.dispatch("REMOVE", n);
  }, [r, e]), !e) return !1;
  let a = o.indexOf(n), i = o.length;
  return a === -1 && (a = i, i += 1), a === i - 1;
}
let eu = /* @__PURE__ */ new Map(), za = /* @__PURE__ */ new Map();
function mp(e) {
  var t;
  let r = (t = za.get(e)) != null ? t : 0;
  return za.set(e, r + 1), r !== 0 ? () => hp(e) : (eu.set(e, { "aria-hidden": e.getAttribute("aria-hidden"), inert: e.inert }), e.setAttribute("aria-hidden", "true"), e.inert = !0, () => hp(e));
}
function hp(e) {
  var t;
  let r = (t = za.get(e)) != null ? t : 1;
  if (r === 1 ? za.delete(e) : za.set(e, r - 1), r !== 1) return;
  let n = eu.get(e);
  n && (n["aria-hidden"] === null ? e.removeAttribute("aria-hidden") : e.setAttribute("aria-hidden", n["aria-hidden"]), e.inert = n.inert, eu.delete(e));
}
function ld(e, { allowed: t, disallowed: r } = {}) {
  let n = ua(e, "inert-others");
  Ye(() => {
    var o, a;
    if (!n) return;
    let i = Kr();
    for (let l of (o = r == null ? void 0 : r()) != null ? o : []) l && i.add(mp(l));
    let s = (a = t == null ? void 0 : t()) != null ? a : [];
    for (let l of s) {
      if (!l) continue;
      let u = Qr(l);
      if (!u) continue;
      let c = l.parentElement;
      for (; c && c !== u.body; ) {
        for (let p of c.children) s.some((d) => p.contains(d)) || i.add(mp(p));
        c = c.parentElement;
      }
    }
    return i.dispose;
  }, [n, t, r]);
}
function dl(e, t, r) {
  let n = ir((o) => {
    let a = o.getBoundingClientRect();
    a.x === 0 && a.y === 0 && a.width === 0 && a.height === 0 && r();
  });
  ge(() => {
    if (!e) return;
    let o = t === null ? null : t instanceof HTMLElement ? t : t.current;
    if (!o) return;
    let a = Kr();
    if (typeof ResizeObserver < "u") {
      let i = new ResizeObserver(() => n.current(o));
      i.observe(o), a.add(() => i.disconnect());
    }
    if (typeof IntersectionObserver < "u") {
      let i = new IntersectionObserver(() => n.current(o));
      i.observe(o), a.add(() => i.disconnect());
    }
    return () => a.dispose();
  }, [t, n, e]);
}
let Ls = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(","), xT = ["[data-autofocus]"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var Xe = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e[e.AutoFocus = 64] = "AutoFocus", e))(Xe || {}), nn = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(nn || {}), _T = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(_T || {});
function Ci(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(Ls)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
function ST(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(xT)).sort((t, r) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (r.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var Pi = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(Pi || {});
function Mi(e, t = 0) {
  var r;
  return e === ((r = Qr(e)) == null ? void 0 : r.body) ? !1 : Ze(t, { 0() {
    return e.matches(Ls);
  }, 1() {
    let n = e;
    for (; n !== null; ) {
      if (n.matches(Ls)) return !0;
      n = n.parentElement;
    }
    return !1;
  } });
}
function b0(e) {
  let t = Qr(e);
  Kr().nextFrame(() => {
    t && !Mi(t.activeElement, 0) && an(e);
  });
}
var ET = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(ET || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function an(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let TT = ["textarea", "input"].join(",");
function kT(e) {
  var t, r;
  return (r = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, TT)) != null ? r : !1;
}
function Zn(e, t = (r) => r) {
  return e.slice().sort((r, n) => {
    let o = t(r), a = t(n);
    if (o === null || a === null) return 0;
    let i = o.compareDocumentPosition(a);
    return i & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : i & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function w0(e, t) {
  return At(Ci(), t, { relativeTo: e });
}
function At(e, t, { sorted: r = !0, relativeTo: n = null, skipElements: o = [] } = {}) {
  let a = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, i = Array.isArray(e) ? r ? Zn(e) : e : t & 64 ? ST(e) : Ci(e);
  o.length > 0 && i.length > 1 && (i = i.filter((f) => !o.some((m) => m != null && "current" in m ? (m == null ? void 0 : m.current) === f : m === f))), n = n ?? a.activeElement;
  let s = (() => {
    if (t & 5) return 1;
    if (t & 10) return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), l = (() => {
    if (t & 1) return 0;
    if (t & 2) return Math.max(0, i.indexOf(n)) - 1;
    if (t & 4) return Math.max(0, i.indexOf(n)) + 1;
    if (t & 8) return i.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, c = 0, p = i.length, d;
  do {
    if (c >= p || c + p <= 0) return 0;
    let f = l + c;
    if (t & 16) f = (f + p) % p;
    else {
      if (f < 0) return 3;
      if (f >= p) return 1;
    }
    d = i[f], d == null || d.focus(u), c += s;
  } while (d !== a.activeElement);
  return t & 6 && kT(d) && d.select(), 2;
}
function x0() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function OT() {
  return /Android/gi.test(window.navigator.userAgent);
}
function DT() {
  return x0() || OT();
}
function Ma(e, t, r, n) {
  let o = ir(r);
  ge(() => {
    if (!e) return;
    function a(i) {
      o.current(i);
    }
    return document.addEventListener(t, a, n), () => document.removeEventListener(t, a, n);
  }, [e, t, n]);
}
function _0(e, t, r, n) {
  let o = ir(r);
  ge(() => {
    if (!e) return;
    function a(i) {
      o.current(i);
    }
    return window.addEventListener(t, a, n), () => window.removeEventListener(t, a, n);
  }, [e, t, n]);
}
const gp = 30;
function fl(e, t, r) {
  let n = ua(e, "outside-click"), o = ir(r), a = Le(function(l, u) {
    if (l.defaultPrevented) return;
    let c = u(l);
    if (c === null || !c.getRootNode().contains(c) || !c.isConnected) return;
    let p = function d(f) {
      return typeof f == "function" ? d(f()) : Array.isArray(f) || f instanceof Set ? f : [f];
    }(t);
    for (let d of p) if (d !== null && (d.contains(c) || l.composed && l.composedPath().includes(d))) return;
    return !Mi(c, Pi.Loose) && c.tabIndex !== -1 && l.preventDefault(), o.current(l, c);
  }, [o, t]), i = ce(null);
  Ma(n, "pointerdown", (l) => {
    var u, c;
    i.current = ((c = (u = l.composedPath) == null ? void 0 : u.call(l)) == null ? void 0 : c[0]) || l.target;
  }, !0), Ma(n, "mousedown", (l) => {
    var u, c;
    i.current = ((c = (u = l.composedPath) == null ? void 0 : u.call(l)) == null ? void 0 : c[0]) || l.target;
  }, !0), Ma(n, "click", (l) => {
    DT() || i.current && (a(l, () => i.current), i.current = null);
  }, !0);
  let s = ce({ x: 0, y: 0 });
  Ma(n, "touchstart", (l) => {
    s.current.x = l.touches[0].clientX, s.current.y = l.touches[0].clientY;
  }, !0), Ma(n, "touchend", (l) => {
    let u = { x: l.changedTouches[0].clientX, y: l.changedTouches[0].clientY };
    if (!(Math.abs(u.x - s.current.x) >= gp || Math.abs(u.y - s.current.y) >= gp)) return a(l, () => l.target instanceof HTMLElement ? l.target : null);
  }, !0), _0(n, "blur", (l) => a(l, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
function gn(...e) {
  return ae(() => Qr(...e), [...e]);
}
function cd(e, t, r, n) {
  let o = ir(r);
  ge(() => {
    e = e ?? window;
    function a(i) {
      o.current(i);
    }
    return e.addEventListener(t, a, n), () => e.removeEventListener(t, a, n);
  }, [e, t, n]);
}
function Ri(e, t) {
  return ae(() => {
    var r;
    if (e.type) return e.type;
    let n = (r = e.as) != null ? r : "button";
    if (typeof n == "string" && n.toLowerCase() === "button" || (t == null ? void 0 : t.tagName) === "BUTTON" && !t.hasAttribute("type")) return "button";
  }, [e.type, e.as, t]);
}
function NT() {
  let e;
  return { before({ doc: t }) {
    var r;
    let n = t.documentElement, o = (r = t.defaultView) != null ? r : window;
    e = Math.max(0, o.innerWidth - n.clientWidth);
  }, after({ doc: t, d: r }) {
    let n = t.documentElement, o = Math.max(0, n.clientWidth - n.offsetWidth), a = Math.max(0, e - o);
    r.style(n, "paddingRight", `${a}px`);
  } };
}
function CT() {
  return x0() ? { before({ doc: e, d: t, meta: r }) {
    function n(o) {
      return r.containers.flatMap((a) => a()).some((a) => a.contains(o));
    }
    t.microTask(() => {
      var o;
      if (window.getComputedStyle(e.documentElement).scrollBehavior !== "auto") {
        let s = Kr();
        s.style(e.documentElement, "scrollBehavior", "auto"), t.add(() => t.microTask(() => s.dispose()));
      }
      let a = (o = window.scrollY) != null ? o : window.pageYOffset, i = null;
      t.addEventListener(e, "click", (s) => {
        if (s.target instanceof HTMLElement) try {
          let l = s.target.closest("a");
          if (!l) return;
          let { hash: u } = new URL(l.href), c = e.querySelector(u);
          c && !n(c) && (i = c);
        } catch {
        }
      }, !0), t.addEventListener(e, "touchstart", (s) => {
        if (s.target instanceof HTMLElement) if (n(s.target)) {
          let l = s.target;
          for (; l.parentElement && n(l.parentElement); ) l = l.parentElement;
          t.style(l, "overscrollBehavior", "contain");
        } else t.style(s.target, "touchAction", "none");
      }), t.addEventListener(e, "touchmove", (s) => {
        if (s.target instanceof HTMLElement) {
          if (s.target.tagName === "INPUT") return;
          if (n(s.target)) {
            let l = s.target;
            for (; l.parentElement && l.dataset.headlessuiPortal !== "" && !(l.scrollHeight > l.clientHeight || l.scrollWidth > l.clientWidth); ) l = l.parentElement;
            l.dataset.headlessuiPortal === "" && s.preventDefault();
          } else s.preventDefault();
        }
      }, { passive: !1 }), t.add(() => {
        var s;
        let l = (s = window.scrollY) != null ? s : window.pageYOffset;
        a !== l && window.scrollTo(0, a), i && i.isConnected && (i.scrollIntoView({ block: "nearest" }), i = null);
      });
    });
  } } : {};
}
function PT() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function MT(e) {
  let t = {};
  for (let r of e) Object.assign(t, r(t));
  return t;
}
let wo = v0(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var r;
  let n = (r = this.get(e)) != null ? r : { doc: e, count: 0, d: Kr(), meta: /* @__PURE__ */ new Set() };
  return n.count++, n.meta.add(t), this.set(e, n), this;
}, POP(e, t) {
  let r = this.get(e);
  return r && (r.count--, r.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: r }) {
  let n = { doc: e, d: t, meta: MT(r) }, o = [CT(), NT(), PT()];
  o.forEach(({ before: a }) => a == null ? void 0 : a(n)), o.forEach(({ after: a }) => a == null ? void 0 : a(n));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
wo.subscribe(() => {
  let e = wo.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [r] of e) t.set(r, r.documentElement.style.overflow);
  for (let r of e.values()) {
    let n = t.get(r.doc) === "hidden", o = r.count !== 0;
    (o && !n || !o && n) && wo.dispatch(r.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", r), r.count === 0 && wo.dispatch("TEARDOWN", r);
  }
});
function RT(e, t, r = () => ({ containers: [] })) {
  let n = y0(wo), o = t ? n.get(t) : void 0, a = o ? o.count > 0 : !1;
  return Ye(() => {
    if (!(!t || !e)) return wo.dispatch("PUSH", t, r), () => wo.dispatch("POP", t, r);
  }, [e, t]), a;
}
function pl(e, t, r = () => [document.body]) {
  let n = ua(e, "scroll-lock");
  RT(n, t, (o) => {
    var a;
    return { containers: [...(a = o.containers) != null ? a : [], r] };
  });
}
function vp(e) {
  return [e.screenX, e.screenY];
}
function S0() {
  let e = ce([-1, -1]);
  return { wasMoved(t) {
    let r = vp(t);
    return e.current[0] === r[0] && e.current[1] === r[1] ? !1 : (e.current = r, !0);
  }, update(t) {
    e.current = vp(t);
  } };
}
function AT(e = 0) {
  let [t, r] = me(e), n = Le((l) => r(l), [t]), o = Le((l) => r((u) => u | l), [t]), a = Le((l) => (t & l) === l, [t]), i = Le((l) => r((u) => u & ~l), [r]), s = Le((l) => r((u) => u ^ l), [r]);
  return { flags: t, setFlag: n, addFlag: o, hasFlag: a, removeFlag: i, toggleFlag: s };
}
var yp;
typeof process < "u" && typeof globalThis < "u" && ((yp = process == null ? void 0 : process.env) == null ? void 0 : yp.NODE_ENV) === "test" && typeof Element.prototype.getAnimations > "u" && (Element.prototype.getAnimations = function() {
  return console.warn(["Headless UI has polyfilled `Element.prototype.getAnimations` for your tests.", "Please install a proper polyfill e.g. `jsdom-testing-mocks`, to silence these warnings.", "", "Example usage:", "```js", "import { mockAnimationsApi } from 'jsdom-testing-mocks'", "mockAnimationsApi()", "```"].join(`
`)), [];
});
var IT = ((e) => (e[e.None = 0] = "None", e[e.Closed = 1] = "Closed", e[e.Enter = 2] = "Enter", e[e.Leave = 4] = "Leave", e))(IT || {});
function da(e) {
  let t = {};
  for (let r in e) e[r] === !0 && (t[`data-${r}`] = "");
  return t;
}
function fa(e, t, r, n) {
  let [o, a] = me(r), { hasFlag: i, addFlag: s, removeFlag: l } = AT(e && o ? 3 : 0), u = ce(!1), c = ce(!1), p = An();
  return Ye(() => {
    var d;
    if (e) {
      if (r && a(!0), !t) {
        r && s(3);
        return;
      }
      return (d = n == null ? void 0 : n.start) == null || d.call(n, r), FT(t, { inFlight: u, prepare() {
        c.current ? c.current = !1 : c.current = u.current, u.current = !0, !c.current && (r ? (s(3), l(4)) : (s(4), l(2)));
      }, run() {
        c.current ? r ? (l(3), s(4)) : (l(4), s(3)) : r ? l(1) : s(1);
      }, done() {
        var f;
        c.current && typeof t.getAnimations == "function" && t.getAnimations().length > 0 || (u.current = !1, l(7), r || a(!1), (f = n == null ? void 0 : n.end) == null || f.call(n, r));
      } });
    }
  }, [e, r, t, p]), e ? [o, { closed: i(1), enter: i(2), leave: i(4), transition: i(2) || i(4) }] : [r, { closed: void 0, enter: void 0, leave: void 0, transition: void 0 }];
}
function FT(e, { prepare: t, run: r, done: n, inFlight: o }) {
  let a = Kr();
  return $T(e, { prepare: t, inFlight: o }), a.nextFrame(() => {
    r(), a.requestAnimationFrame(() => {
      a.add(LT(e, n));
    });
  }), a.dispose;
}
function LT(e, t) {
  var r, n;
  let o = Kr();
  if (!e) return o.dispose;
  let a = !1;
  o.add(() => {
    a = !0;
  });
  let i = (n = (r = e.getAnimations) == null ? void 0 : r.call(e).filter((s) => s instanceof CSSTransition)) != null ? n : [];
  return i.length === 0 ? (t(), o.dispose) : (Promise.allSettled(i.map((s) => s.finished)).then(() => {
    a || t();
  }), o.dispose);
}
function $T(e, { inFlight: t, prepare: r }) {
  if (t != null && t.current) {
    r();
    return;
  }
  let n = e.style.transition;
  e.style.transition = "none", r(), e.offsetHeight, e.style.transition = n;
}
function WT(e, { container: t, accept: r, walk: n }) {
  let o = ce(r), a = ce(n);
  ge(() => {
    o.current = r, a.current = n;
  }, [r, n]), Ye(() => {
    if (!t || !e) return;
    let i = Qr(t);
    if (!i) return;
    let s = o.current, l = a.current, u = Object.assign((p) => s(p), { acceptNode: s }), c = i.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, u, !1);
    for (; c.nextNode(); ) l(c.currentNode);
  }, [t, e, o, a]);
}
function ud(e, t) {
  let r = ce([]), n = ee(e);
  ge(() => {
    let o = [...r.current];
    for (let [a, i] of t.entries()) if (r.current[a] !== i) {
      let s = n(t, o);
      return r.current = t, s;
    }
  }, [n, ...t]);
}
function pa(e) {
  return E0(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function hr(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function In(e) {
  var t;
  return (t = (E0(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function E0(e) {
  return e instanceof Node || e instanceof hr(e).Node;
}
function Jt(e) {
  return e instanceof Element || e instanceof hr(e).Element;
}
function dn(e) {
  return e instanceof HTMLElement || e instanceof hr(e).HTMLElement;
}
function bp(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof hr(e).ShadowRoot;
}
function Ai(e) {
  const {
    overflow: t,
    overflowX: r,
    overflowY: n,
    display: o
  } = Vr(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + n + r) && !["inline", "contents"].includes(o);
}
function YT(e) {
  return ["table", "td", "th"].includes(pa(e));
}
function dd(e) {
  const t = fd(), r = Vr(e);
  return r.transform !== "none" || r.perspective !== "none" || (r.containerType ? r.containerType !== "normal" : !1) || !t && (r.backdropFilter ? r.backdropFilter !== "none" : !1) || !t && (r.filter ? r.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((n) => (r.willChange || "").includes(n)) || ["paint", "layout", "strict", "content"].some((n) => (r.contain || "").includes(n));
}
function BT(e) {
  let t = ro(e);
  for (; dn(t) && !Jo(t); ) {
    if (dd(t))
      return t;
    t = ro(t);
  }
  return null;
}
function fd() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function Jo(e) {
  return ["html", "body", "#document"].includes(pa(e));
}
function Vr(e) {
  return hr(e).getComputedStyle(e);
}
function ml(e) {
  return Jt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function ro(e) {
  if (pa(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    bp(e) && e.host || // Fallback.
    In(e)
  );
  return bp(t) ? t.host : t;
}
function T0(e) {
  const t = ro(e);
  return Jo(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : dn(t) && Ai(t) ? t : T0(t);
}
function ii(e, t, r) {
  var n;
  t === void 0 && (t = []), r === void 0 && (r = !0);
  const o = T0(e), a = o === ((n = e.ownerDocument) == null ? void 0 : n.body), i = hr(o);
  return a ? t.concat(i, i.visualViewport || [], Ai(o) ? o : [], i.frameElement && r ? ii(i.frameElement) : []) : t.concat(o, ii(o, [], r));
}
function jT() {
  const e = navigator.userAgentData;
  return e && Array.isArray(e.brands) ? e.brands.map((t) => {
    let {
      brand: r,
      version: n
    } = t;
    return r + "/" + n;
  }).join(" ") : navigator.userAgent;
}
const Jn = Math.min, pr = Math.max, $s = Math.round, ms = Math.floor, no = (e) => ({
  x: e,
  y: e
}), UT = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, HT = {
  start: "end",
  end: "start"
};
function wp(e, t, r) {
  return pr(e, Jn(t, r));
}
function Ii(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function oo(e) {
  return e.split("-")[0];
}
function Fi(e) {
  return e.split("-")[1];
}
function k0(e) {
  return e === "x" ? "y" : "x";
}
function O0(e) {
  return e === "y" ? "height" : "width";
}
function Li(e) {
  return ["top", "bottom"].includes(oo(e)) ? "y" : "x";
}
function D0(e) {
  return k0(Li(e));
}
function VT(e, t, r) {
  r === void 0 && (r = !1);
  const n = Fi(e), o = D0(e), a = O0(o);
  let i = o === "x" ? n === (r ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (i = Ws(i)), [i, Ws(i)];
}
function zT(e) {
  const t = Ws(e);
  return [tu(e), t, tu(t)];
}
function tu(e) {
  return e.replace(/start|end/g, (t) => HT[t]);
}
function qT(e, t, r) {
  const n = ["left", "right"], o = ["right", "left"], a = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return r ? t ? o : n : t ? n : o;
    case "left":
    case "right":
      return t ? a : i;
    default:
      return [];
  }
}
function GT(e, t, r, n) {
  const o = Fi(e);
  let a = qT(oo(e), r === "start", n);
  return o && (a = a.map((i) => i + "-" + o), t && (a = a.concat(a.map(tu)))), a;
}
function Ws(e) {
  return e.replace(/left|right|bottom|top/g, (t) => UT[t]);
}
function QT(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function KT(e) {
  return typeof e != "number" ? QT(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ys(e) {
  const {
    x: t,
    y: r,
    width: n,
    height: o
  } = e;
  return {
    width: n,
    height: o,
    top: r,
    left: t,
    right: t + n,
    bottom: r + o,
    x: t,
    y: r
  };
}
function xp(e, t, r) {
  let {
    reference: n,
    floating: o
  } = e;
  const a = Li(t), i = D0(t), s = O0(i), l = oo(t), u = a === "y", c = n.x + n.width / 2 - o.width / 2, p = n.y + n.height / 2 - o.height / 2, d = n[s] / 2 - o[s] / 2;
  let f;
  switch (l) {
    case "top":
      f = {
        x: c,
        y: n.y - o.height
      };
      break;
    case "bottom":
      f = {
        x: c,
        y: n.y + n.height
      };
      break;
    case "right":
      f = {
        x: n.x + n.width,
        y: p
      };
      break;
    case "left":
      f = {
        x: n.x - o.width,
        y: p
      };
      break;
    default:
      f = {
        x: n.x,
        y: n.y
      };
  }
  switch (Fi(t)) {
    case "start":
      f[i] -= d * (r && u ? -1 : 1);
      break;
    case "end":
      f[i] += d * (r && u ? -1 : 1);
      break;
  }
  return f;
}
const XT = async (e, t, r) => {
  const {
    placement: n = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: i
  } = r, s = a.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let u = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: c,
    y: p
  } = xp(u, n, l), d = n, f = {}, m = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: h,
      fn: _
    } = s[v], {
      x: g,
      y: b,
      data: x,
      reset: E
    } = await _({
      x: c,
      y: p,
      initialPlacement: n,
      placement: d,
      strategy: o,
      middlewareData: f,
      rects: u,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = g ?? c, p = b ?? p, f = {
      ...f,
      [h]: {
        ...f[h],
        ...x
      }
    }, E && m <= 50 && (m++, typeof E == "object" && (E.placement && (d = E.placement), E.rects && (u = E.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : E.rects), {
      x: c,
      y: p
    } = xp(u, d, l)), v = -1);
  }
  return {
    x: c,
    y: p,
    placement: d,
    strategy: o,
    middlewareData: f
  };
};
async function hl(e, t) {
  var r;
  t === void 0 && (t = {});
  const {
    x: n,
    y: o,
    platform: a,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: p = "floating",
    altBoundary: d = !1,
    padding: f = 0
  } = Ii(t, e), m = KT(f), h = s[d ? p === "floating" ? "reference" : "floating" : p], _ = Ys(await a.getClippingRect({
    element: (r = await (a.isElement == null ? void 0 : a.isElement(h))) == null || r ? h : h.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: c,
    strategy: l
  })), g = p === "floating" ? {
    x: n,
    y: o,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, b = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), x = await (a.isElement == null ? void 0 : a.isElement(b)) ? await (a.getScale == null ? void 0 : a.getScale(b)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, E = Ys(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: g,
    offsetParent: b,
    strategy: l
  }) : g);
  return {
    top: (_.top - E.top + m.top) / x.y,
    bottom: (E.bottom - _.bottom + m.bottom) / x.y,
    left: (_.left - E.left + m.left) / x.x,
    right: (E.right - _.right + m.right) / x.x
  };
}
const ZT = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var r, n;
      const {
        placement: o,
        middlewareData: a,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: c = !0,
        crossAxis: p = !0,
        fallbackPlacements: d,
        fallbackStrategy: f = "bestFit",
        fallbackAxisSideDirection: m = "none",
        flipAlignment: v = !0,
        ...h
      } = Ii(e, t);
      if ((r = a.arrow) != null && r.alignmentOffset)
        return {};
      const _ = oo(o), g = oo(s) === s, b = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), x = d || (g || !v ? [Ws(s)] : zT(s));
      !d && m !== "none" && x.push(...GT(s, v, m, b));
      const E = [s, ...x], O = await hl(t, h), P = [];
      let y = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (c && P.push(O[_]), p) {
        const T = VT(o, i, b);
        P.push(O[T[0]], O[T[1]]);
      }
      if (y = [...y, {
        placement: o,
        overflows: P
      }], !P.every((T) => T <= 0)) {
        var w, S;
        const T = (((w = a.flip) == null ? void 0 : w.index) || 0) + 1, R = E[T];
        if (R)
          return {
            data: {
              index: T,
              overflows: y
            },
            reset: {
              placement: R
            }
          };
        let I = (S = y.filter((C) => C.overflows[0] <= 0).sort((C, A) => C.overflows[1] - A.overflows[1])[0]) == null ? void 0 : S.placement;
        if (!I)
          switch (f) {
            case "bestFit": {
              var k;
              const C = (k = y.map((A) => [A.placement, A.overflows.filter((D) => D > 0).reduce((D, N) => D + N, 0)]).sort((A, D) => A[1] - D[1])[0]) == null ? void 0 : k[0];
              C && (I = C);
              break;
            }
            case "initialPlacement":
              I = s;
              break;
          }
        if (o !== I)
          return {
            reset: {
              placement: I
            }
          };
      }
      return {};
    }
  };
};
async function JT(e, t) {
  const {
    placement: r,
    platform: n,
    elements: o
  } = e, a = await (n.isRTL == null ? void 0 : n.isRTL(o.floating)), i = oo(r), s = Fi(r), l = Li(r) === "y", u = ["left", "top"].includes(i) ? -1 : 1, c = a && l ? -1 : 1, p = Ii(t, e);
  let {
    mainAxis: d,
    crossAxis: f,
    alignmentAxis: m
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...p
  };
  return s && typeof m == "number" && (f = s === "end" ? m * -1 : m), l ? {
    x: f * c,
    y: d * u
  } : {
    x: d * u,
    y: f * c
  };
}
const e4 = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var r, n;
      const {
        x: o,
        y: a,
        placement: i,
        middlewareData: s
      } = t, l = await JT(t, e);
      return i === ((r = s.offset) == null ? void 0 : r.placement) && (n = s.arrow) != null && n.alignmentOffset ? {} : {
        x: o + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, t4 = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: r,
        y: n,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (h) => {
            let {
              x: _,
              y: g
            } = h;
            return {
              x: _,
              y: g
            };
          }
        },
        ...l
      } = Ii(e, t), u = {
        x: r,
        y: n
      }, c = await hl(t, l), p = Li(oo(o)), d = k0(p);
      let f = u[d], m = u[p];
      if (a) {
        const h = d === "y" ? "top" : "left", _ = d === "y" ? "bottom" : "right", g = f + c[h], b = f - c[_];
        f = wp(g, f, b);
      }
      if (i) {
        const h = p === "y" ? "top" : "left", _ = p === "y" ? "bottom" : "right", g = m + c[h], b = m - c[_];
        m = wp(g, m, b);
      }
      const v = s.fn({
        ...t,
        [d]: f,
        [p]: m
      });
      return {
        ...v,
        data: {
          x: v.x - r,
          y: v.y - n
        }
      };
    }
  };
}, r4 = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: r,
        rects: n,
        platform: o,
        elements: a
      } = t, {
        apply: i = () => {
        },
        ...s
      } = Ii(e, t), l = await hl(t, s), u = oo(r), c = Fi(r), p = Li(r) === "y", {
        width: d,
        height: f
      } = n.floating;
      let m, v;
      u === "top" || u === "bottom" ? (m = u, v = c === (await (o.isRTL == null ? void 0 : o.isRTL(a.floating)) ? "start" : "end") ? "left" : "right") : (v = u, m = c === "end" ? "top" : "bottom");
      const h = f - l.top - l.bottom, _ = d - l.left - l.right, g = Jn(f - l[m], h), b = Jn(d - l[v], _), x = !t.middlewareData.shift;
      let E = g, O = b;
      if (p ? O = c || x ? Jn(b, _) : _ : E = c || x ? Jn(g, h) : h, x && !c) {
        const y = pr(l.left, 0), w = pr(l.right, 0), S = pr(l.top, 0), k = pr(l.bottom, 0);
        p ? O = d - 2 * (y !== 0 || w !== 0 ? y + w : pr(l.left, l.right)) : E = f - 2 * (S !== 0 || k !== 0 ? S + k : pr(l.top, l.bottom));
      }
      await i({
        ...t,
        availableWidth: O,
        availableHeight: E
      });
      const P = await o.getDimensions(a.floating);
      return d !== P.width || f !== P.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function N0(e) {
  const t = Vr(e);
  let r = parseFloat(t.width) || 0, n = parseFloat(t.height) || 0;
  const o = dn(e), a = o ? e.offsetWidth : r, i = o ? e.offsetHeight : n, s = $s(r) !== a || $s(n) !== i;
  return s && (r = a, n = i), {
    width: r,
    height: n,
    $: s
  };
}
function pd(e) {
  return Jt(e) ? e : e.contextElement;
}
function qo(e) {
  const t = pd(e);
  if (!dn(t))
    return no(1);
  const r = t.getBoundingClientRect(), {
    width: n,
    height: o,
    $: a
  } = N0(t);
  let i = (a ? $s(r.width) : r.width) / n, s = (a ? $s(r.height) : r.height) / o;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const n4 = /* @__PURE__ */ no(0);
function C0(e) {
  const t = hr(e);
  return !fd() || !t.visualViewport ? n4 : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function o4(e, t, r) {
  return t === void 0 && (t = !1), !r || t && r !== hr(e) ? !1 : t;
}
function Do(e, t, r, n) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  const o = e.getBoundingClientRect(), a = pd(e);
  let i = no(1);
  t && (n ? Jt(n) && (i = qo(n)) : i = qo(e));
  const s = o4(a, r, n) ? C0(a) : no(0);
  let l = (o.left + s.x) / i.x, u = (o.top + s.y) / i.y, c = o.width / i.x, p = o.height / i.y;
  if (a) {
    const d = hr(a), f = n && Jt(n) ? hr(n) : n;
    let m = d, v = m.frameElement;
    for (; v && n && f !== m; ) {
      const h = qo(v), _ = v.getBoundingClientRect(), g = Vr(v), b = _.left + (v.clientLeft + parseFloat(g.paddingLeft)) * h.x, x = _.top + (v.clientTop + parseFloat(g.paddingTop)) * h.y;
      l *= h.x, u *= h.y, c *= h.x, p *= h.y, l += b, u += x, m = hr(v), v = m.frameElement;
    }
  }
  return Ys({
    width: c,
    height: p,
    x: l,
    y: u
  });
}
const a4 = [":popover-open", ":modal"];
function md(e) {
  return a4.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function i4(e) {
  let {
    elements: t,
    rect: r,
    offsetParent: n,
    strategy: o
  } = e;
  const a = o === "fixed", i = In(n), s = t ? md(t.floating) : !1;
  if (n === i || s && a)
    return r;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = no(1);
  const c = no(0), p = dn(n);
  if ((p || !p && !a) && ((pa(n) !== "body" || Ai(i)) && (l = ml(n)), dn(n))) {
    const d = Do(n);
    u = qo(n), c.x = d.x + n.clientLeft, c.y = d.y + n.clientTop;
  }
  return {
    width: r.width * u.x,
    height: r.height * u.y,
    x: r.x * u.x - l.scrollLeft * u.x + c.x,
    y: r.y * u.y - l.scrollTop * u.y + c.y
  };
}
function s4(e) {
  return Array.from(e.getClientRects());
}
function P0(e) {
  return Do(In(e)).left + ml(e).scrollLeft;
}
function l4(e) {
  const t = In(e), r = ml(e), n = e.ownerDocument.body, o = pr(t.scrollWidth, t.clientWidth, n.scrollWidth, n.clientWidth), a = pr(t.scrollHeight, t.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -r.scrollLeft + P0(e);
  const s = -r.scrollTop;
  return Vr(n).direction === "rtl" && (i += pr(t.clientWidth, n.clientWidth) - o), {
    width: o,
    height: a,
    x: i,
    y: s
  };
}
function c4(e, t) {
  const r = hr(e), n = In(e), o = r.visualViewport;
  let a = n.clientWidth, i = n.clientHeight, s = 0, l = 0;
  if (o) {
    a = o.width, i = o.height;
    const u = fd();
    (!u || u && t === "fixed") && (s = o.offsetLeft, l = o.offsetTop);
  }
  return {
    width: a,
    height: i,
    x: s,
    y: l
  };
}
function u4(e, t) {
  const r = Do(e, !0, t === "fixed"), n = r.top + e.clientTop, o = r.left + e.clientLeft, a = dn(e) ? qo(e) : no(1), i = e.clientWidth * a.x, s = e.clientHeight * a.y, l = o * a.x, u = n * a.y;
  return {
    width: i,
    height: s,
    x: l,
    y: u
  };
}
function _p(e, t, r) {
  let n;
  if (t === "viewport")
    n = c4(e, r);
  else if (t === "document")
    n = l4(In(e));
  else if (Jt(t))
    n = u4(t, r);
  else {
    const o = C0(e);
    n = {
      ...t,
      x: t.x - o.x,
      y: t.y - o.y
    };
  }
  return Ys(n);
}
function M0(e, t) {
  const r = ro(e);
  return r === t || !Jt(r) || Jo(r) ? !1 : Vr(r).position === "fixed" || M0(r, t);
}
function d4(e, t) {
  const r = t.get(e);
  if (r)
    return r;
  let n = ii(e, [], !1).filter((s) => Jt(s) && pa(s) !== "body"), o = null;
  const a = Vr(e).position === "fixed";
  let i = a ? ro(e) : e;
  for (; Jt(i) && !Jo(i); ) {
    const s = Vr(i), l = dd(i);
    !l && s.position === "fixed" && (o = null), (a ? !l && !o : !l && s.position === "static" && !!o && ["absolute", "fixed"].includes(o.position) || Ai(i) && !l && M0(e, i)) ? n = n.filter((c) => c !== i) : o = s, i = ro(i);
  }
  return t.set(e, n), n;
}
function f4(e) {
  let {
    element: t,
    boundary: r,
    rootBoundary: n,
    strategy: o
  } = e;
  const i = [...r === "clippingAncestors" ? md(t) ? [] : d4(t, this._c) : [].concat(r), n], s = i[0], l = i.reduce((u, c) => {
    const p = _p(t, c, o);
    return u.top = pr(p.top, u.top), u.right = Jn(p.right, u.right), u.bottom = Jn(p.bottom, u.bottom), u.left = pr(p.left, u.left), u;
  }, _p(t, s, o));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function p4(e) {
  const {
    width: t,
    height: r
  } = N0(e);
  return {
    width: t,
    height: r
  };
}
function m4(e, t, r) {
  const n = dn(t), o = In(t), a = r === "fixed", i = Do(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = no(0);
  if (n || !n && !a)
    if ((pa(t) !== "body" || Ai(o)) && (s = ml(t)), n) {
      const p = Do(t, !0, a, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else o && (l.x = P0(o));
  const u = i.left + s.scrollLeft - l.x, c = i.top + s.scrollTop - l.y;
  return {
    x: u,
    y: c,
    width: i.width,
    height: i.height
  };
}
function sc(e) {
  return Vr(e).position === "static";
}
function Sp(e, t) {
  return !dn(e) || Vr(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function R0(e, t) {
  const r = hr(e);
  if (md(e))
    return r;
  if (!dn(e)) {
    let o = ro(e);
    for (; o && !Jo(o); ) {
      if (Jt(o) && !sc(o))
        return o;
      o = ro(o);
    }
    return r;
  }
  let n = Sp(e, t);
  for (; n && YT(n) && sc(n); )
    n = Sp(n, t);
  return n && Jo(n) && sc(n) && !dd(n) ? r : n || BT(e) || r;
}
const h4 = async function(e) {
  const t = this.getOffsetParent || R0, r = this.getDimensions, n = await r(e.floating);
  return {
    reference: m4(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function g4(e) {
  return Vr(e).direction === "rtl";
}
const v4 = {
  convertOffsetParentRelativeRectToViewportRelativeRect: i4,
  getDocumentElement: In,
  getClippingRect: f4,
  getOffsetParent: R0,
  getElementRects: h4,
  getClientRects: s4,
  getDimensions: p4,
  getScale: qo,
  isElement: Jt,
  isRTL: g4
};
function y4(e, t) {
  let r = null, n;
  const o = In(e);
  function a() {
    var s;
    clearTimeout(n), (s = r) == null || s.disconnect(), r = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: u,
      top: c,
      width: p,
      height: d
    } = e.getBoundingClientRect();
    if (s || t(), !p || !d)
      return;
    const f = ms(c), m = ms(o.clientWidth - (u + p)), v = ms(o.clientHeight - (c + d)), h = ms(u), g = {
      rootMargin: -f + "px " + -m + "px " + -v + "px " + -h + "px",
      threshold: pr(0, Jn(1, l)) || 1
    };
    let b = !0;
    function x(E) {
      const O = E[0].intersectionRatio;
      if (O !== l) {
        if (!b)
          return i();
        O ? i(!1, O) : n = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      b = !1;
    }
    try {
      r = new IntersectionObserver(x, {
        ...g,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      r = new IntersectionObserver(x, g);
    }
    r.observe(e);
  }
  return i(!0), a;
}
function b4(e, t, r, n) {
  n === void 0 && (n = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = n, u = pd(e), c = o || a ? [...u ? ii(u) : [], ...ii(t)] : [];
  c.forEach((_) => {
    o && _.addEventListener("scroll", r, {
      passive: !0
    }), a && _.addEventListener("resize", r);
  });
  const p = u && s ? y4(u, r) : null;
  let d = -1, f = null;
  i && (f = new ResizeObserver((_) => {
    let [g] = _;
    g && g.target === u && f && (f.unobserve(t), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var b;
      (b = f) == null || b.observe(t);
    })), r();
  }), u && !l && f.observe(u), f.observe(t));
  let m, v = l ? Do(e) : null;
  l && h();
  function h() {
    const _ = Do(e);
    v && (_.x !== v.x || _.y !== v.y || _.width !== v.width || _.height !== v.height) && r(), v = _, m = requestAnimationFrame(h);
  }
  return r(), () => {
    var _;
    c.forEach((g) => {
      o && g.removeEventListener("scroll", r), a && g.removeEventListener("resize", r);
    }), p == null || p(), (_ = f) == null || _.disconnect(), f = null, l && cancelAnimationFrame(m);
  };
}
const lc = hl, w4 = e4, x4 = t4, _4 = ZT, S4 = r4, E4 = (e, t, r) => {
  const n = /* @__PURE__ */ new Map(), o = {
    platform: v4,
    ...r
  }, a = {
    ...o.platform,
    _c: n
  };
  return XT(e, t, {
    ...o,
    platform: a
  });
};
var _s = typeof document < "u" ? pi : ge;
function Bs(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let r, n, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (r = e.length, r !== t.length) return !1;
      for (n = r; n-- !== 0; )
        if (!Bs(e[n], t[n]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), r = o.length, r !== Object.keys(t).length)
      return !1;
    for (n = r; n-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[n]))
        return !1;
    for (n = r; n-- !== 0; ) {
      const a = o[n];
      if (!(a === "_owner" && e.$$typeof) && !Bs(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function A0(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Ep(e, t) {
  const r = A0(e);
  return Math.round(t * r) / r;
}
function Tp(e) {
  const t = Q.useRef(e);
  return _s(() => {
    t.current = e;
  }), t;
}
function T4(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: r = "absolute",
    middleware: n = [],
    platform: o,
    elements: {
      reference: a,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [c, p] = Q.useState({
    x: 0,
    y: 0,
    strategy: r,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [d, f] = Q.useState(n);
  Bs(d, n) || f(n);
  const [m, v] = Q.useState(null), [h, _] = Q.useState(null), g = Q.useCallback((D) => {
    D !== O.current && (O.current = D, v(D));
  }, []), b = Q.useCallback((D) => {
    D !== P.current && (P.current = D, _(D));
  }, []), x = a || m, E = i || h, O = Q.useRef(null), P = Q.useRef(null), y = Q.useRef(c), w = l != null, S = Tp(l), k = Tp(o), T = Q.useCallback(() => {
    if (!O.current || !P.current)
      return;
    const D = {
      placement: t,
      strategy: r,
      middleware: d
    };
    k.current && (D.platform = k.current), E4(O.current, P.current, D).then((N) => {
      const M = {
        ...N,
        isPositioned: !0
      };
      R.current && !Bs(y.current, M) && (y.current = M, _1.flushSync(() => {
        p(M);
      }));
    });
  }, [d, t, r, k]);
  _s(() => {
    u === !1 && y.current.isPositioned && (y.current.isPositioned = !1, p((D) => ({
      ...D,
      isPositioned: !1
    })));
  }, [u]);
  const R = Q.useRef(!1);
  _s(() => (R.current = !0, () => {
    R.current = !1;
  }), []), _s(() => {
    if (x && (O.current = x), E && (P.current = E), x && E) {
      if (S.current)
        return S.current(x, E, T);
      T();
    }
  }, [x, E, T, S, w]);
  const I = Q.useMemo(() => ({
    reference: O,
    floating: P,
    setReference: g,
    setFloating: b
  }), [g, b]), C = Q.useMemo(() => ({
    reference: x,
    floating: E
  }), [x, E]), A = Q.useMemo(() => {
    const D = {
      position: r,
      left: 0,
      top: 0
    };
    if (!C.floating)
      return D;
    const N = Ep(C.floating, c.x), M = Ep(C.floating, c.y);
    return s ? {
      ...D,
      transform: "translate(" + N + "px, " + M + "px)",
      ...A0(C.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: r,
      left: N,
      top: M
    };
  }, [r, s, C.floating, c.x, c.y]);
  return Q.useMemo(() => ({
    ...c,
    update: T,
    refs: I,
    elements: C,
    floatingStyles: A
  }), [c, T, I, C, A]);
}
const I0 = (e, t) => ({
  ...w4(e),
  options: [e, t]
}), k4 = (e, t) => ({
  ...x4(e),
  options: [e, t]
}), O4 = (e, t) => ({
  ..._4(e),
  options: [e, t]
}), D4 = (e, t) => ({
  ...S4(e),
  options: [e, t]
}), F0 = {
  ...Q
}, N4 = F0.useInsertionEffect, C4 = N4 || ((e) => e());
function L0(e) {
  const t = Q.useRef(() => {
    if (process.env.NODE_ENV !== "production")
      throw new Error("Cannot call an event handler while rendering.");
  });
  return C4(() => {
    t.current = e;
  }), Q.useCallback(function() {
    for (var r = arguments.length, n = new Array(r), o = 0; o < r; o++)
      n[o] = arguments[o];
    return t.current == null ? void 0 : t.current(...n);
  }, []);
}
var ru = typeof document < "u" ? pi : ge;
let kp = !1, P4 = 0;
const Op = () => (
  // Ensure the id is unique with multiple independent versions of Floating UI
  // on <React 18
  "floating-ui-" + Math.random().toString(36).slice(2, 6) + P4++
);
function M4() {
  const [e, t] = Q.useState(() => kp ? Op() : void 0);
  return ru(() => {
    e == null && t(Op());
  }, []), Q.useEffect(() => {
    kp = !0;
  }, []), e;
}
const R4 = F0.useId, A4 = R4 || M4;
let si;
process.env.NODE_ENV !== "production" && (si = /* @__PURE__ */ new Set());
function I4() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const o = "Floating UI: " + r.join(" ");
  if (!((e = si) != null && e.has(o))) {
    var a;
    (a = si) == null || a.add(o), console.warn(o);
  }
}
function F4() {
  for (var e, t = arguments.length, r = new Array(t), n = 0; n < t; n++)
    r[n] = arguments[n];
  const o = "Floating UI: " + r.join(" ");
  if (!((e = si) != null && e.has(o))) {
    var a;
    (a = si) == null || a.add(o), console.error(o);
  }
}
function L4() {
  const e = /* @__PURE__ */ new Map();
  return {
    emit(t, r) {
      var n;
      (n = e.get(t)) == null || n.forEach((o) => o(r));
    },
    on(t, r) {
      e.set(t, [...e.get(t) || [], r]);
    },
    off(t, r) {
      var n;
      e.set(t, ((n = e.get(t)) == null ? void 0 : n.filter((o) => o !== r)) || []);
    }
  };
}
const $4 = /* @__PURE__ */ Q.createContext(null), W4 = /* @__PURE__ */ Q.createContext(null), Y4 = () => {
  var e;
  return ((e = Q.useContext($4)) == null ? void 0 : e.id) || null;
}, B4 = () => Q.useContext(W4);
function j4(e) {
  const {
    open: t = !1,
    onOpenChange: r,
    elements: n
  } = e, o = A4(), a = Q.useRef({}), [i] = Q.useState(() => L4()), s = Y4() != null;
  if (process.env.NODE_ENV !== "production") {
    const f = n.reference;
    f && !Jt(f) && F4("Cannot pass a virtual element to the `elements.reference` option,", "as it must be a real DOM element. Use `refs.setPositionReference()`", "instead.");
  }
  const [l, u] = Q.useState(n.reference), c = L0((f, m, v) => {
    a.current.openEvent = f ? m : void 0, i.emit("openchange", {
      open: f,
      event: m,
      reason: v,
      nested: s
    }), r == null || r(f, m, v);
  }), p = Q.useMemo(() => ({
    setPositionReference: u
  }), []), d = Q.useMemo(() => ({
    reference: l || n.reference || null,
    floating: n.floating || null,
    domReference: n.reference
  }), [l, n.reference, n.floating]);
  return Q.useMemo(() => ({
    dataRef: a,
    open: t,
    onOpenChange: c,
    elements: d,
    events: i,
    floatingId: o,
    refs: p
  }), [t, c, d, i, o, p]);
}
function U4(e) {
  e === void 0 && (e = {});
  const {
    nodeId: t
  } = e, r = j4({
    ...e,
    elements: {
      reference: null,
      floating: null,
      ...e.elements
    }
  }), n = e.rootContext || r, o = n.elements, [a, i] = Q.useState(null), [s, l] = Q.useState(null), c = (o == null ? void 0 : o.reference) || a, p = Q.useRef(null), d = B4();
  ru(() => {
    c && (p.current = c);
  }, [c]);
  const f = T4({
    ...e,
    elements: {
      ...o,
      ...s && {
        reference: s
      }
    }
  }), m = Q.useCallback((b) => {
    const x = Jt(b) ? {
      getBoundingClientRect: () => b.getBoundingClientRect(),
      contextElement: b
    } : b;
    l(x), f.refs.setReference(x);
  }, [f.refs]), v = Q.useCallback((b) => {
    (Jt(b) || b === null) && (p.current = b, i(b)), (Jt(f.refs.reference.current) || f.refs.reference.current === null || // Don't allow setting virtual elements using the old technique back to
    // `null` to support `positionReference` + an unstable `reference`
    // callback ref.
    b !== null && !Jt(b)) && f.refs.setReference(b);
  }, [f.refs]), h = Q.useMemo(() => ({
    ...f.refs,
    setReference: v,
    setPositionReference: m,
    domReference: p
  }), [f.refs, v, m]), _ = Q.useMemo(() => ({
    ...f.elements,
    domReference: c
  }), [f.elements, c]), g = Q.useMemo(() => ({
    ...f,
    ...n,
    refs: h,
    elements: _,
    nodeId: t
  }), [f, h, _, t, n]);
  return ru(() => {
    n.dataRef.current.floatingContext = g;
    const b = d == null ? void 0 : d.nodesRef.current.find((x) => x.id === t);
    b && (b.context = g);
  }), Q.useMemo(() => ({
    ...f,
    context: g,
    refs: h,
    elements: _
  }), [f, h, _, g]);
}
const Dp = "active", Np = "selected";
function cc(e, t, r) {
  const n = /* @__PURE__ */ new Map(), o = r === "item";
  let a = e;
  if (o && e) {
    const {
      [Dp]: i,
      [Np]: s,
      ...l
    } = e;
    a = l;
  }
  return {
    ...r === "floating" && {
      tabIndex: -1
    },
    ...a,
    ...t.map((i) => {
      const s = i ? i[r] : null;
      return typeof s == "function" ? e ? s(e) : null : s;
    }).concat(e).reduce((i, s) => (s && Object.entries(s).forEach((l) => {
      let [u, c] = l;
      if (!(o && [Dp, Np].includes(u)))
        if (u.indexOf("on") === 0) {
          if (n.has(u) || n.set(u, []), typeof c == "function") {
            var p;
            (p = n.get(u)) == null || p.push(c), i[u] = function() {
              for (var d, f = arguments.length, m = new Array(f), v = 0; v < f; v++)
                m[v] = arguments[v];
              return (d = n.get(u)) == null ? void 0 : d.map((h) => h(...m)).find((h) => h !== void 0);
            };
          }
        } else
          i[u] = c;
    }), i), {})
  };
}
function H4(e) {
  e === void 0 && (e = []);
  const t = e, r = Q.useCallback(
    (a) => cc(a, e, "reference"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), n = Q.useCallback(
    (a) => cc(a, e, "floating"),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    t
  ), o = Q.useCallback(
    (a) => cc(a, e, "item"),
    // Granularly check for `item` changes, because the `getItemProps` getter
    // should be as referentially stable as possible since it may be passed as
    // a prop to many components. All `item` key values must therefore be
    // memoized.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    e.map((a) => a == null ? void 0 : a.item)
  );
  return Q.useMemo(() => ({
    getReferenceProps: r,
    getFloatingProps: n,
    getItemProps: o
  }), [r, n, o]);
}
function Cp(e, t) {
  return {
    ...e,
    rects: {
      ...e.rects,
      floating: {
        ...e.rects.floating,
        height: t
      }
    }
  };
}
const V4 = (e) => ({
  name: "inner",
  options: e,
  async fn(t) {
    const {
      listRef: r,
      overflowRef: n,
      onFallbackChange: o,
      offset: a = 0,
      index: i = 0,
      minItemsVisible: s = 4,
      referenceOverflowThreshold: l = 0,
      scrollRef: u,
      ...c
    } = e, {
      rects: p,
      elements: {
        floating: d
      }
    } = t, f = r.current[i];
    if (process.env.NODE_ENV !== "production" && (t.placement.startsWith("bottom") || I4('`placement` side must be "bottom" when using the `inner`', "middleware.")), !f)
      return {};
    const m = {
      ...t,
      ...await I0(-f.offsetTop - d.clientTop - p.reference.height / 2 - f.offsetHeight / 2 - a).fn(t)
    }, v = (u == null ? void 0 : u.current) || d, h = await lc(Cp(m, v.scrollHeight), c), _ = await lc(m, {
      ...c,
      elementContext: "reference"
    }), g = Math.max(0, h.top), b = m.y + g, x = Math.max(0, v.scrollHeight - g - Math.max(0, h.bottom));
    return v.style.maxHeight = x + "px", v.scrollTop = g, o && (v.offsetHeight < f.offsetHeight * Math.min(s, r.current.length - 1) - 1 || _.top >= -l || _.bottom >= -l ? zt(() => o(!0)) : zt(() => o(!1))), n && (n.current = await lc(Cp({
      ...m,
      y: b
    }, v.offsetHeight), c)), {
      y: b
    };
  }
});
function z4(e, t) {
  const {
    open: r,
    elements: n
  } = e, {
    enabled: o = !0,
    overflowRef: a,
    scrollRef: i,
    onChange: s
  } = t, l = L0(s), u = Q.useRef(!1), c = Q.useRef(null), p = Q.useRef(null);
  return Q.useEffect(() => {
    if (!o)
      return;
    function d(m) {
      if (m.ctrlKey || !f || a.current == null)
        return;
      const v = m.deltaY, h = a.current.top >= -0.5, _ = a.current.bottom >= -0.5, g = f.scrollHeight - f.clientHeight, b = v < 0 ? -1 : 1, x = v < 0 ? "max" : "min";
      f.scrollHeight <= f.clientHeight || (!h && v > 0 || !_ && v < 0 ? (m.preventDefault(), zt(() => {
        l((E) => E + Math[x](v, g * b));
      })) : /firefox/i.test(jT()) && (f.scrollTop += v));
    }
    const f = (i == null ? void 0 : i.current) || n.floating;
    if (r && f)
      return f.addEventListener("wheel", d), requestAnimationFrame(() => {
        c.current = f.scrollTop, a.current != null && (p.current = {
          ...a.current
        });
      }), () => {
        c.current = null, p.current = null, f.removeEventListener("wheel", d);
      };
  }, [o, r, n.floating, a, i, l]), Q.useMemo(() => o ? {
    floating: {
      onKeyDown() {
        u.current = !0;
      },
      onWheel() {
        u.current = !1;
      },
      onPointerMove() {
        u.current = !1;
      },
      onScroll() {
        const d = (i == null ? void 0 : i.current) || n.floating;
        if (!(!a.current || !d || !u.current)) {
          if (c.current !== null) {
            const f = d.scrollTop - c.current;
            (a.current.bottom < -0.5 && f < -1 || a.current.top < -0.5 && f > 1) && zt(() => l((m) => m + f));
          }
          requestAnimationFrame(() => {
            c.current = d.scrollTop;
          });
        }
      }
    }
  } : {}, [o, a, n.floating, i, l]);
}
let ma = $e({ styles: void 0, setReference: () => {
}, setFloating: () => {
}, getReferenceProps: () => ({}), getFloatingProps: () => ({}), slot: {} });
ma.displayName = "FloatingContext";
let hd = $e(null);
hd.displayName = "PlacementContext";
function gd(e) {
  return ae(() => e ? typeof e == "string" ? { to: e } : e : null, [e]);
}
function vd() {
  return Oe(ma).setReference;
}
function $0() {
  return Oe(ma).getReferenceProps;
}
function yd() {
  let { getFloatingProps: e, slot: t } = Oe(ma);
  return Le((...r) => Object.assign({}, e(...r), { "data-anchor": t.anchor }), [e, t]);
}
function bd(e = null) {
  e === !1 && (e = null), typeof e == "string" && (e = { to: e });
  let t = Oe(hd), r = ae(() => e, [JSON.stringify(e, typeof HTMLElement < "u" ? (o, a) => a instanceof HTMLElement ? a.outerHTML : a : void 0)]);
  Ye(() => {
    t == null || t(r ?? null);
  }, [t, r]);
  let n = Oe(ma);
  return ae(() => [n.setFloating, e ? n.styles : {}], [n.setFloating, e, n.styles]);
}
let Pp = 4;
function wd({ children: e, enabled: t = !0 }) {
  let [r, n] = me(null), [o, a] = me(0), i = ce(null), [s, l] = me(null);
  q4(s);
  let u = t && r !== null && s !== null, { to: c = "bottom", gap: p = 0, offset: d = 0, padding: f = 0, inner: m } = G4(r, s), [v, h = "center"] = c.split(" ");
  Ye(() => {
    u && a(0);
  }, [u]);
  let { refs: _, floatingStyles: g, context: b } = U4({ open: u, placement: v === "selection" ? h === "center" ? "bottom" : `bottom-${h}` : h === "center" ? `${v}` : `${v}-${h}`, strategy: "absolute", transform: !1, middleware: [I0({ mainAxis: v === "selection" ? 0 : p, crossAxis: d }), k4({ padding: f }), v !== "selection" && O4({ padding: f }), v === "selection" && m ? V4({ ...m, padding: f, overflowRef: i, offset: o, minItemsVisible: Pp, referenceOverflowThreshold: f, onFallbackChange(k) {
    var T, R;
    if (!k) return;
    let I = b.elements.floating;
    if (!I) return;
    let C = parseFloat(getComputedStyle(I).scrollPaddingBottom) || 0, A = Math.min(Pp, I.childElementCount), D = 0, N = 0;
    for (let M of (R = (T = b.elements.floating) == null ? void 0 : T.childNodes) != null ? R : []) if (M instanceof HTMLElement) {
      let W = M.offsetTop, B = W + M.clientHeight + C, j = I.scrollTop, q = j + I.clientHeight;
      if (W >= j && B <= q) A--;
      else {
        N = Math.max(0, Math.min(B, q) - Math.max(W, j)), D = M.clientHeight;
        break;
      }
    }
    A >= 1 && a((M) => {
      let W = D * A - N + C;
      return M >= W ? M : W;
    });
  } }) : null, D4({ padding: f, apply({ availableWidth: k, availableHeight: T, elements: R }) {
    Object.assign(R.floating.style, { overflow: "auto", maxWidth: `${k}px`, maxHeight: `min(var(--anchor-max-height, 100vh), ${T}px)` });
  } })].filter(Boolean), whileElementsMounted: b4 }), [x = v, E = h] = b.placement.split("-");
  v === "selection" && (x = "selection");
  let O = ae(() => ({ anchor: [x, E].filter(Boolean).join(" ") }), [x, E]), P = z4(b, { overflowRef: i, onChange: a }), { getReferenceProps: y, getFloatingProps: w } = H4([P]), S = ee((k) => {
    l(k), _.setFloating(k);
  });
  return Q.createElement(hd.Provider, { value: n }, Q.createElement(ma.Provider, { value: { setFloating: S, setReference: _.setReference, styles: g, getReferenceProps: y, getFloatingProps: w, slot: O } }, e));
}
function q4(e) {
  Ye(() => {
    if (!e) return;
    let t = new MutationObserver(() => {
      let r = window.getComputedStyle(e).maxHeight, n = parseFloat(r);
      if (isNaN(n)) return;
      let o = parseInt(r);
      isNaN(o) || n !== o && (e.style.maxHeight = `${Math.ceil(n)}px`);
    });
    return t.observe(e, { attributes: !0, attributeFilter: ["style"] }), () => {
      t.disconnect();
    };
  }, [e]);
}
function G4(e, t) {
  var r, n, o;
  let a = uc((r = e == null ? void 0 : e.gap) != null ? r : "var(--anchor-gap, 0)", t), i = uc((n = e == null ? void 0 : e.offset) != null ? n : "var(--anchor-offset, 0)", t), s = uc((o = e == null ? void 0 : e.padding) != null ? o : "var(--anchor-padding, 0)", t);
  return { ...e, gap: a, offset: i, padding: s };
}
function uc(e, t, r = void 0) {
  let n = An(), o = ee((l, u) => {
    if (l == null) return [r, null];
    if (typeof l == "number") return [l, null];
    if (typeof l == "string") {
      if (!u) return [r, null];
      let c = Mp(l, u);
      return [c, (p) => {
        let d = W0(l);
        {
          let f = d.map((m) => window.getComputedStyle(u).getPropertyValue(m));
          n.requestAnimationFrame(function m() {
            n.nextFrame(m);
            let v = !1;
            for (let [_, g] of d.entries()) {
              let b = window.getComputedStyle(u).getPropertyValue(g);
              if (f[_] !== b) {
                f[_] = b, v = !0;
                break;
              }
            }
            if (!v) return;
            let h = Mp(l, u);
            c !== h && (p(h), c = h);
          });
        }
        return n.dispose;
      }];
    }
    return [r, null];
  }), a = ae(() => o(e, t)[0], [e, t]), [i = a, s] = me();
  return Ye(() => {
    let [l, u] = o(e, t);
    if (s(l), !!u) return u(s);
  }, [e, t]), i;
}
function W0(e) {
  let t = /var\((.*)\)/.exec(e);
  if (t) {
    let r = t[1].indexOf(",");
    if (r === -1) return [t[1]];
    let n = t[1].slice(0, r).trim(), o = t[1].slice(r + 1).trim();
    return o ? [n, ...W0(o)] : [n];
  }
  return [];
}
function Mp(e, t) {
  let r = document.createElement("div");
  t.appendChild(r), r.style.setProperty("margin-top", "0px", "important"), r.style.setProperty("margin-top", e, "important");
  let n = parseFloat(window.getComputedStyle(r).marginTop) || 0;
  return t.removeChild(r), n;
}
function Q4(e, t) {
  let [r, n] = me(t);
  return !e && r !== t && n(t), e ? r : t;
}
let gl = $e(null);
gl.displayName = "OpenClosedContext";
var st = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(st || {});
function Fn() {
  return Oe(gl);
}
function $i({ value: e, children: t }) {
  return G.createElement(gl.Provider, { value: e }, t);
}
function xd({ children: e }) {
  return G.createElement(gl.Provider, { value: null }, e);
}
function K4(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
let Gn = [];
K4(() => {
  function e(t) {
    if (!(t.target instanceof HTMLElement) || t.target === document.body || Gn[0] === t.target) return;
    let r = t.target;
    r = r.closest(Ls), Gn.unshift(r ?? t.target), Gn = Gn.filter((n) => n != null && n.isConnected), Gn.splice(10);
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function X4(e) {
  throw new Error("Unexpected object: " + e);
}
var je = ((e) => (e[e.First = 0] = "First", e[e.Previous = 1] = "Previous", e[e.Next = 2] = "Next", e[e.Last = 3] = "Last", e[e.Specific = 4] = "Specific", e[e.Nothing = 5] = "Nothing", e))(je || {});
function Go(e, t) {
  let r = t.resolveItems();
  if (r.length <= 0) return null;
  let n = t.resolveActiveIndex(), o = n ?? -1;
  switch (e.focus) {
    case 0: {
      for (let a = 0; a < r.length; ++a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 1: {
      o === -1 && (o = r.length);
      for (let a = o - 1; a >= 0; --a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 2: {
      for (let a = o + 1; a < r.length; ++a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 3: {
      for (let a = r.length - 1; a >= 0; --a) if (!t.resolveDisabled(r[a], a, r)) return a;
      return n;
    }
    case 4: {
      for (let a = 0; a < r.length; ++a) if (t.resolveId(r[a], a, r) === e.id) return a;
      return n;
    }
    case 5:
      return null;
    default:
      X4(e);
  }
}
function Y0(e) {
  let t = ee(e), r = ce(!1);
  ge(() => (r.current = !1, () => {
    r.current = !0, ki(() => {
      r.current && t();
    });
  }), [t]);
}
function Z4() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in Q ? ((t) => t.useSyncExternalStore)(Q)(() => () => {
  }, () => !1, () => !e) : !1;
}
function Wi() {
  let e = Z4(), [t, r] = Q.useState(_o.isHandoffComplete);
  return t && _o.isHandoffComplete === !1 && r(!1), Q.useEffect(() => {
    t !== !0 && r(!0);
  }, [t]), Q.useEffect(() => _o.handoff(), []), e ? !1 : t;
}
let B0 = $e(!1);
function J4() {
  return Oe(B0);
}
function Rp(e) {
  return G.createElement(B0.Provider, { value: e.force }, e.children);
}
function e3(e) {
  let t = J4(), r = Oe(U0), n = gn(e), [o, a] = me(() => {
    var i;
    if (!t && r !== null) return (i = r.current) != null ? i : null;
    if (_o.isServer) return null;
    let s = n == null ? void 0 : n.getElementById("headlessui-portal-root");
    if (s) return s;
    if (n === null) return null;
    let l = n.createElement("div");
    return l.setAttribute("id", "headlessui-portal-root"), n.body.appendChild(l);
  });
  return ge(() => {
    o !== null && (n != null && n.body.contains(o) || n == null || n.body.appendChild(o));
  }, [o, n]), ge(() => {
    t || r !== null && a(r.current);
  }, [r, a, t]), o;
}
let j0 = jt, t3 = Ae(function(e, t) {
  let r = e, n = ce(null), o = Ue(nd((c) => {
    n.current = c;
  }), t), a = gn(n), i = e3(n), [s] = me(() => {
    var c;
    return _o.isServer ? null : (c = a == null ? void 0 : a.createElement("div")) != null ? c : null;
  }), l = Oe(nu), u = Wi();
  return Ye(() => {
    !i || !s || i.contains(s) || (s.setAttribute("data-headlessui-portal", ""), i.appendChild(s));
  }, [i, s]), Ye(() => {
    if (s && l) return l.register(s);
  }, [l, s]), Y0(() => {
    var c;
    !i || !s || (s instanceof Node && i.contains(s) && i.removeChild(s), i.childNodes.length <= 0 && ((c = i.parentElement) == null || c.removeChild(i)));
  }), u ? !i || !s ? null : hm(Ie({ ourProps: { ref: o }, theirProps: r, slot: {}, defaultTag: j0, name: "Portal" }), s) : null;
});
function r3(e, t) {
  let r = Ue(t), { enabled: n = !0, ...o } = e;
  return n ? G.createElement(t3, { ...o, ref: r }) : Ie({ ourProps: { ref: r }, theirProps: o, slot: {}, defaultTag: j0, name: "Portal" });
}
let n3 = jt, U0 = $e(null);
function o3(e, t) {
  let { target: r, ...n } = e, o = { ref: Ue(t) };
  return G.createElement(U0.Provider, { value: r }, Ie({ ourProps: o, theirProps: n, defaultTag: n3, name: "Popover.Group" }));
}
let nu = $e(null);
function H0() {
  let e = Oe(nu), t = ce([]), r = ee((a) => (t.current.push(a), e && e.register(a), () => n(a))), n = ee((a) => {
    let i = t.current.indexOf(a);
    i !== -1 && t.current.splice(i, 1), e && e.unregister(a);
  }), o = ae(() => ({ register: r, unregister: n, portals: t }), [r, n, t]);
  return [t, ae(() => function({ children: a }) {
    return G.createElement(nu.Provider, { value: o }, a);
  }, [o])];
}
let a3 = Ae(r3), V0 = Ae(o3), vl = Object.assign(a3, { Group: V0 });
function i3(e, t = typeof document < "u" ? document.defaultView : null, r) {
  let n = ua(e, "escape");
  cd(t, "keydown", (o) => {
    n && (o.defaultPrevented || o.key === ye.Escape && r(o));
  });
}
function s3() {
  var e;
  let [t] = me(() => typeof window < "u" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null), [r, n] = me((e = t == null ? void 0 : t.matches) != null ? e : !1);
  return Ye(() => {
    if (!t) return;
    function o(a) {
      n(a.matches);
    }
    return t.addEventListener("change", o), () => t.removeEventListener("change", o);
  }, [t]), r;
}
function z0({ defaultContainers: e = [], portals: t, mainTreeNode: r } = {}) {
  let n = gn(r), o = ee(() => {
    var a, i;
    let s = [];
    for (let l of e) l !== null && (l instanceof HTMLElement ? s.push(l) : "current" in l && l.current instanceof HTMLElement && s.push(l.current));
    if (t != null && t.current) for (let l of t.current) s.push(l);
    for (let l of (a = n == null ? void 0 : n.querySelectorAll("html > *, body > *")) != null ? a : []) l !== document.body && l !== document.head && l instanceof HTMLElement && l.id !== "headlessui-portal-root" && (r && (l.contains(r) || l.contains((i = r == null ? void 0 : r.getRootNode()) == null ? void 0 : i.host)) || s.some((u) => l.contains(u)) || s.push(l));
    return s;
  });
  return { resolveContainers: o, contains: ee((a) => o().some((i) => i.contains(a))) };
}
let q0 = $e(null);
function js({ children: e, node: t }) {
  let [r, n] = me(null), o = _d(t ?? r);
  return G.createElement(q0.Provider, { value: o }, e, o === null && G.createElement(un, { features: cn.Hidden, ref: (a) => {
    var i, s;
    if (a) {
      for (let l of (s = (i = Qr(a)) == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? s : []) if (l !== document.body && l !== document.head && l instanceof HTMLElement && l != null && l.contains(a)) {
        n(l);
        break;
      }
    }
  } }));
}
function _d(e = null) {
  var t;
  return (t = Oe(q0)) != null ? t : e;
}
function yl() {
  let e = ce(!1);
  return Ye(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
var mr = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(mr || {});
function Sd() {
  let e = ce(0);
  return _0(!0, "keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function G0(e) {
  if (!e) return /* @__PURE__ */ new Set();
  if (typeof e == "function") return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let r of e.current) r.current instanceof HTMLElement && t.add(r.current);
  return t;
}
let l3 = "div";
var ho = ((e) => (e[e.None = 0] = "None", e[e.InitialFocus = 1] = "InitialFocus", e[e.TabLock = 2] = "TabLock", e[e.FocusLock = 4] = "FocusLock", e[e.RestoreFocus = 8] = "RestoreFocus", e[e.AutoFocus = 16] = "AutoFocus", e))(ho || {});
function c3(e, t) {
  let r = ce(null), n = Ue(r, t), { initialFocus: o, initialFocusFallback: a, containers: i, features: s = 15, ...l } = e;
  Wi() || (s = 0);
  let u = gn(r);
  p3(s, { ownerDocument: u });
  let c = m3(s, { ownerDocument: u, container: r, initialFocus: o, initialFocusFallback: a });
  h3(s, { ownerDocument: u, container: r, containers: i, previousActiveElement: c });
  let p = Sd(), d = ee((_) => {
    let g = r.current;
    g && ((b) => b())(() => {
      Ze(p.current, { [mr.Forwards]: () => {
        At(g, Xe.First, { skipElements: [_.relatedTarget, a] });
      }, [mr.Backwards]: () => {
        At(g, Xe.Last, { skipElements: [_.relatedTarget, a] });
      } });
    });
  }), f = ua(!!(s & 2), "focus-trap#tab-lock"), m = An(), v = ce(!1), h = { ref: n, onKeyDown(_) {
    _.key == "Tab" && (v.current = !0, m.requestAnimationFrame(() => {
      v.current = !1;
    }));
  }, onBlur(_) {
    if (!(s & 4)) return;
    let g = G0(i);
    r.current instanceof HTMLElement && g.add(r.current);
    let b = _.relatedTarget;
    b instanceof HTMLElement && b.dataset.headlessuiFocusGuard !== "true" && (Q0(g, b) || (v.current ? At(r.current, Ze(p.current, { [mr.Forwards]: () => Xe.Next, [mr.Backwards]: () => Xe.Previous }) | Xe.WrapAround, { relativeTo: _.target }) : _.target instanceof HTMLElement && an(_.target)));
  } };
  return G.createElement(G.Fragment, null, f && G.createElement(un, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: d, features: cn.Focusable }), Ie({ ourProps: h, theirProps: l, defaultTag: l3, name: "FocusTrap" }), f && G.createElement(un, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: d, features: cn.Focusable }));
}
let u3 = Ae(c3), d3 = Object.assign(u3, { features: ho });
function f3(e = !0) {
  let t = ce(Gn.slice());
  return ud(([r], [n]) => {
    n === !0 && r === !1 && ki(() => {
      t.current.splice(0);
    }), n === !1 && r === !0 && (t.current = Gn.slice());
  }, [e, Gn, t]), ee(() => {
    var r;
    return (r = t.current.find((n) => n != null && n.isConnected)) != null ? r : null;
  });
}
function p3(e, { ownerDocument: t }) {
  let r = !!(e & 8), n = f3(r);
  ud(() => {
    r || (t == null ? void 0 : t.activeElement) === (t == null ? void 0 : t.body) && an(n());
  }, [r]), Y0(() => {
    r && an(n());
  });
}
function m3(e, { ownerDocument: t, container: r, initialFocus: n, initialFocusFallback: o }) {
  let a = ce(null), i = ua(!!(e & 1), "focus-trap#initial-focus"), s = yl();
  return ud(() => {
    if (e === 0) return;
    if (!i) {
      o != null && o.current && an(o.current);
      return;
    }
    let l = r.current;
    l && ki(() => {
      if (!s.current) return;
      let u = t == null ? void 0 : t.activeElement;
      if (n != null && n.current) {
        if ((n == null ? void 0 : n.current) === u) {
          a.current = u;
          return;
        }
      } else if (l.contains(u)) {
        a.current = u;
        return;
      }
      if (n != null && n.current) an(n.current);
      else {
        if (e & 16) {
          if (At(l, Xe.First | Xe.AutoFocus) !== nn.Error) return;
        } else if (At(l, Xe.First) !== nn.Error) return;
        if (o != null && o.current && (an(o.current), (t == null ? void 0 : t.activeElement) === o.current)) return;
        console.warn("There are no focusable elements inside the <FocusTrap />");
      }
      a.current = t == null ? void 0 : t.activeElement;
    });
  }, [o, i, e]), a;
}
function h3(e, { ownerDocument: t, container: r, containers: n, previousActiveElement: o }) {
  let a = yl(), i = !!(e & 4);
  cd(t == null ? void 0 : t.defaultView, "focus", (s) => {
    if (!i || !a.current) return;
    let l = G0(n);
    r.current instanceof HTMLElement && l.add(r.current);
    let u = o.current;
    if (!u) return;
    let c = s.target;
    c && c instanceof HTMLElement ? Q0(l, c) ? (o.current = c, an(c)) : (s.preventDefault(), s.stopPropagation(), an(u)) : an(o.current);
  }, !0);
}
function Q0(e, t) {
  for (let r of e) if (r.contains(t)) return !0;
  return !1;
}
function K0(e) {
  var t;
  return !!(e.enter || e.enterFrom || e.enterTo || e.leave || e.leaveFrom || e.leaveTo) || ((t = e.as) != null ? t : Z0) !== jt || G.Children.count(e.children) === 1;
}
let bl = $e(null);
bl.displayName = "TransitionContext";
var g3 = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(g3 || {});
function v3() {
  let e = Oe(bl);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function y3() {
  let e = Oe(wl);
  if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let wl = $e(null);
wl.displayName = "NestingContext";
function xl(e) {
  return "children" in e ? xl(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function X0(e, t) {
  let r = ir(e), n = ce([]), o = yl(), a = An(), i = ee((f, m = Xn.Hidden) => {
    let v = n.current.findIndex(({ el: h }) => h === f);
    v !== -1 && (Ze(m, { [Xn.Unmount]() {
      n.current.splice(v, 1);
    }, [Xn.Hidden]() {
      n.current[v].state = "hidden";
    } }), a.microTask(() => {
      var h;
      !xl(n) && o.current && ((h = r.current) == null || h.call(r));
    }));
  }), s = ee((f) => {
    let m = n.current.find(({ el: v }) => v === f);
    return m ? m.state !== "visible" && (m.state = "visible") : n.current.push({ el: f, state: "visible" }), () => i(f, Xn.Unmount);
  }), l = ce([]), u = ce(Promise.resolve()), c = ce({ enter: [], leave: [] }), p = ee((f, m, v) => {
    l.current.splice(0), t && (t.chains.current[m] = t.chains.current[m].filter(([h]) => h !== f)), t == null || t.chains.current[m].push([f, new Promise((h) => {
      l.current.push(h);
    })]), t == null || t.chains.current[m].push([f, new Promise((h) => {
      Promise.all(c.current[m].map(([_, g]) => g)).then(() => h());
    })]), m === "enter" ? u.current = u.current.then(() => t == null ? void 0 : t.wait.current).then(() => v(m)) : v(m);
  }), d = ee((f, m, v) => {
    Promise.all(c.current[m].splice(0).map(([h, _]) => _)).then(() => {
      var h;
      (h = l.current.shift()) == null || h();
    }).then(() => v(m));
  });
  return ae(() => ({ children: n, register: s, unregister: i, onStart: p, onStop: d, wait: u, chains: c }), [s, i, n, p, d, c, u]);
}
let Z0 = jt, J0 = Qt.RenderStrategy;
function b3(e, t) {
  var r, n;
  let { transition: o = !0, beforeEnter: a, afterEnter: i, beforeLeave: s, afterLeave: l, enter: u, enterFrom: c, enterTo: p, entered: d, leave: f, leaveFrom: m, leaveTo: v, ...h } = e, [_, g] = me(null), b = ce(null), x = K0(e), E = Ue(...x ? [b, t, g] : t === null ? [] : [t]), O = (r = h.unmount) == null || r ? Xn.Unmount : Xn.Hidden, { show: P, appear: y, initial: w } = v3(), [S, k] = me(P ? "visible" : "hidden"), T = y3(), { register: R, unregister: I } = T;
  Ye(() => R(b), [R, b]), Ye(() => {
    if (O === Xn.Hidden && b.current) {
      if (P && S !== "visible") {
        k("visible");
        return;
      }
      return Ze(S, { hidden: () => I(b), visible: () => R(b) });
    }
  }, [S, b, R, I, P, O]);
  let C = Wi();
  Ye(() => {
    if (x && C && S === "visible" && b.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [b, S, C, x]);
  let A = w && !y, D = y && P && w, N = ce(!1), M = X0(() => {
    N.current || (k("hidden"), I(b));
  }, T), W = ee((le) => {
    N.current = !0;
    let ke = le ? "enter" : "leave";
    M.onStart(b, ke, (at) => {
      at === "enter" ? a == null || a() : at === "leave" && (s == null || s());
    });
  }), B = ee((le) => {
    let ke = le ? "enter" : "leave";
    N.current = !1, M.onStop(b, ke, (at) => {
      at === "enter" ? i == null || i() : at === "leave" && (l == null || l());
    }), ke === "leave" && !xl(M) && (k("hidden"), I(b));
  });
  ge(() => {
    x && o || (W(P), B(P));
  }, [P, x, o]);
  let j = !(!o || !x || !C || A), [, q] = fa(j, _, P, { start: W, end: B }), se = qn({ ref: E, className: ((n = Jc(h.className, D && u, D && c, q.enter && u, q.enter && q.closed && c, q.enter && !q.closed && p, q.leave && f, q.leave && !q.closed && m, q.leave && q.closed && v, !q.transition && P && d)) == null ? void 0 : n.trim()) || void 0, ...da(q) }), te = 0;
  return S === "visible" && (te |= st.Open), S === "hidden" && (te |= st.Closed), q.enter && (te |= st.Opening), q.leave && (te |= st.Closing), G.createElement(wl.Provider, { value: M }, G.createElement($i, { value: te }, Ie({ ourProps: se, theirProps: h, defaultTag: Z0, features: J0, visible: S === "visible", name: "Transition.Child" })));
}
function w3(e, t) {
  let { show: r, appear: n = !1, unmount: o = !0, ...a } = e, i = ce(null), s = K0(e), l = Ue(...s ? [i, t] : t === null ? [] : [t]);
  Wi();
  let u = Fn();
  if (r === void 0 && u !== null && (r = (u & st.Open) === st.Open), r === void 0) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [c, p] = me(r ? "visible" : "hidden"), d = X0(() => {
    r || p("hidden");
  }), [f, m] = me(!0), v = ce([r]);
  Ye(() => {
    f !== !1 && v.current[v.current.length - 1] !== r && (v.current.push(r), m(!1));
  }, [v, r]);
  let h = ae(() => ({ show: r, appear: n, initial: f }), [r, n, f]);
  Ye(() => {
    r ? p("visible") : !xl(d) && i.current !== null && p("hidden");
  }, [r, d]);
  let _ = { unmount: o }, g = ee(() => {
    var x;
    f && m(!1), (x = e.beforeEnter) == null || x.call(e);
  }), b = ee(() => {
    var x;
    f && m(!1), (x = e.beforeLeave) == null || x.call(e);
  });
  return G.createElement(wl.Provider, { value: d }, G.createElement(bl.Provider, { value: h }, Ie({ ourProps: { ..._, as: jt, children: G.createElement(eg, { ref: l, ..._, ...a, beforeEnter: g, beforeLeave: b }) }, theirProps: {}, defaultTag: jt, features: J0, visible: c === "visible", name: "Transition" })));
}
function x3(e, t) {
  let r = Oe(bl) !== null, n = Fn() !== null;
  return G.createElement(G.Fragment, null, !r && n ? G.createElement(ou, { ref: t, ...e }) : G.createElement(eg, { ref: t, ...e }));
}
let ou = Ae(w3), eg = Ae(b3), Qo = Ae(x3), tg = Object.assign(ou, { Child: Qo, Root: ou });
var _3 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(_3 || {}), S3 = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(S3 || {});
let E3 = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, Ed = $e(null);
Ed.displayName = "DialogContext";
function _l(e) {
  let t = Oe(Ed);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, _l), r;
  }
  return t;
}
function T3(e, t) {
  return Ze(t.type, E3, e, t);
}
let Ap = Ae(function(e, t) {
  let r = xt(), { id: n = `headlessui-dialog-${r}`, open: o, onClose: a, initialFocus: i, role: s = "dialog", autoFocus: l = !0, __demoMode: u = !1, unmount: c = !1, ...p } = e, d = ce(!1);
  s = function() {
    return s === "dialog" || s === "alertdialog" ? s : (d.current || (d.current = !0, console.warn(`Invalid role [${s}] passed to <Dialog />. Only \`dialog\` and and \`alertdialog\` are supported. Using \`dialog\` instead.`)), "dialog");
  }();
  let f = Fn();
  o === void 0 && f !== null && (o = (f & st.Open) === st.Open);
  let m = ce(null), v = Ue(m, t), h = gn(m), _ = o ? 0 : 1, [g, b] = Co(T3, { titleId: null, descriptionId: null, panelRef: Wa() }), x = ee(() => a(!1)), E = ee((W) => b({ type: 0, id: W })), O = Wi() ? _ === 0 : !1, [P, y] = H0(), w = { get current() {
    var W;
    return (W = g.panelRef.current) != null ? W : m.current;
  } }, S = _d(), { resolveContainers: k } = z0({ mainTreeNode: S, portals: P, defaultContainers: [w] }), T = f !== null ? (f & st.Closing) === st.Closing : !1;
  ld(u || T ? !1 : O, { allowed: ee(() => {
    var W, B;
    return [(B = (W = m.current) == null ? void 0 : W.closest("[data-headlessui-portal]")) != null ? B : null];
  }), disallowed: ee(() => {
    var W;
    return [(W = S == null ? void 0 : S.closest("body > *:not(#headlessui-portal-root)")) != null ? W : null];
  }) }), fl(O, k, (W) => {
    W.preventDefault(), x();
  }), i3(O, h == null ? void 0 : h.defaultView, (W) => {
    W.preventDefault(), W.stopPropagation(), document.activeElement && "blur" in document.activeElement && typeof document.activeElement.blur == "function" && document.activeElement.blur(), x();
  }), pl(u || T ? !1 : O, h, k), dl(O, m, x);
  let [R, I] = h0(), C = ae(() => [{ dialogState: _, close: x, setTitleId: E, unmount: c }, g], [_, g, x, E, c]), A = ae(() => ({ open: _ === 0 }), [_]), D = { ref: v, id: n, role: s, tabIndex: -1, "aria-modal": u ? void 0 : _ === 0 ? !0 : void 0, "aria-labelledby": g.titleId, "aria-describedby": R, unmount: c }, N = !s3(), M = ho.None;
  return O && !u && (M |= ho.RestoreFocus, M |= ho.TabLock, l && (M |= ho.AutoFocus), N && (M |= ho.InitialFocus)), G.createElement(xd, null, G.createElement(Rp, { force: !0 }, G.createElement(vl, null, G.createElement(Ed.Provider, { value: C }, G.createElement(V0, { target: m }, G.createElement(Rp, { force: !1 }, G.createElement(I, { slot: A }, G.createElement(y, null, G.createElement(d3, { initialFocus: i, initialFocusFallback: m, containers: k, features: M }, G.createElement(id, { value: x }, Ie({ ourProps: D, theirProps: p, slot: A, defaultTag: k3, features: O3, visible: _ === 0, name: "Dialog" })))))))))));
}), k3 = "div", O3 = Qt.RenderStrategy | Qt.Static;
function D3(e, t) {
  let { transition: r = !1, open: n, ...o } = e, a = Fn(), i = e.hasOwnProperty("open") || a !== null, s = e.hasOwnProperty("onClose");
  if (!i && !s) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!i) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!s) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (!a && typeof e.open != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${e.open}`);
  if (typeof e.onClose != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${e.onClose}`);
  return (n !== void 0 || r) && !o.static ? G.createElement(js, null, G.createElement(tg, { show: n, transition: r, unmount: o.unmount }, G.createElement(Ap, { ref: t, ...o }))) : G.createElement(js, null, G.createElement(Ap, { ref: t, open: n, ...o }));
}
let N3 = "div";
function C3(e, t) {
  let r = xt(), { id: n = `headlessui-dialog-panel-${r}`, transition: o = !1, ...a } = e, [{ dialogState: i, unmount: s }, l] = _l("Dialog.Panel"), u = Ue(t, l.panelRef), c = ae(() => ({ open: i === 0 }), [i]), p = ee((f) => {
    f.stopPropagation();
  }), d = { ref: u, id: n, onClick: p };
  return G.createElement(o ? Qo : jt, { ...o ? { unmount: s } : {} }, Ie({ ourProps: d, theirProps: a, slot: c, defaultTag: N3, name: "Dialog.Panel" }));
}
let P3 = "div";
function M3(e, t) {
  let { transition: r = !1, ...n } = e, [{ dialogState: o, unmount: a }] = _l("Dialog.Backdrop"), i = ae(() => ({ open: o === 0 }), [o]), s = { ref: t, "aria-hidden": !0 };
  return G.createElement(r ? Qo : jt, { ...r ? { unmount: a } : {} }, Ie({ ourProps: s, theirProps: n, slot: i, defaultTag: P3, name: "Dialog.Backdrop" }));
}
let R3 = "h2";
function A3(e, t) {
  let r = xt(), { id: n = `headlessui-dialog-title-${r}`, ...o } = e, [{ dialogState: a, setTitleId: i }] = _l("Dialog.Title"), s = Ue(t);
  ge(() => (i(n), () => i(null)), [n, i]);
  let l = ae(() => ({ open: a === 0 }), [a]);
  return Ie({ ourProps: { ref: s, id: n }, theirProps: o, slot: l, defaultTag: R3, name: "Dialog.Title" });
}
let I3 = Ae(D3), rg = Ae(C3), F3 = Ae(M3), ng = Ae(A3), L3 = Object.assign(I3, { Panel: rg, Title: ng, Description: uT });
var Ip;
let $3 = (Ip = G.startTransition) != null ? Ip : function(e) {
  e();
};
var W3 = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(W3 || {}), Y3 = ((e) => (e[e.ToggleDisclosure = 0] = "ToggleDisclosure", e[e.CloseDisclosure = 1] = "CloseDisclosure", e[e.SetButtonId = 2] = "SetButtonId", e[e.SetPanelId = 3] = "SetPanelId", e[e.SetButtonElement = 4] = "SetButtonElement", e[e.SetPanelElement = 5] = "SetPanelElement", e))(Y3 || {});
let B3 = { 0: (e) => ({ ...e, disclosureState: Ze(e.disclosureState, { 0: 1, 1: 0 }) }), 1: (e) => e.disclosureState === 1 ? e : { ...e, disclosureState: 1 }, 2(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 3(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
}, 4(e, t) {
  return e.buttonElement === t.element ? e : { ...e, buttonElement: t.element };
}, 5(e, t) {
  return e.panelElement === t.element ? e : { ...e, panelElement: t.element };
} }, Td = $e(null);
Td.displayName = "DisclosureContext";
function kd(e) {
  let t = Oe(Td);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, kd), r;
  }
  return t;
}
let Od = $e(null);
Od.displayName = "DisclosureAPIContext";
function og(e) {
  let t = Oe(Od);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, og), r;
  }
  return t;
}
let Dd = $e(null);
Dd.displayName = "DisclosurePanelContext";
function j3() {
  return Oe(Dd);
}
function U3(e, t) {
  return Ze(t.type, B3, e, t);
}
let H3 = jt;
function V3(e, t) {
  let { defaultOpen: r = !1, ...n } = e, o = ce(null), a = Ue(t, nd((m) => {
    o.current = m;
  }, e.as === void 0 || e.as === jt)), i = Co(U3, { disclosureState: r ? 0 : 1, buttonElement: null, panelElement: null, buttonId: null, panelId: null }), [{ disclosureState: s, buttonId: l }, u] = i, c = ee((m) => {
    u({ type: 1 });
    let v = Qr(o);
    if (!v || !l) return;
    let h = m ? m instanceof HTMLElement ? m : m.current instanceof HTMLElement ? m.current : v.getElementById(l) : v.getElementById(l);
    h == null || h.focus();
  }), p = ae(() => ({ close: c }), [c]), d = ae(() => ({ open: s === 0, close: c }), [s, c]), f = { ref: a };
  return G.createElement(Td.Provider, { value: i }, G.createElement(Od.Provider, { value: p }, G.createElement(id, { value: c }, G.createElement($i, { value: Ze(s, { 0: st.Open, 1: st.Closed }) }, Ie({ ourProps: f, theirProps: n, slot: d, defaultTag: H3, name: "Disclosure" })))));
}
let z3 = "button";
function q3(e, t) {
  let r = xt(), { id: n = `headlessui-disclosure-button-${r}`, disabled: o = !1, autoFocus: a = !1, ...i } = e, [s, l] = kd("Disclosure.Button"), u = j3(), c = u === null ? !1 : u === s.panelId, p = ce(null), d = Ue(p, t, ee((S) => {
    if (!c) return l({ type: 4, element: S });
  })), f = Di();
  ge(() => {
    if (!c) return l({ type: 2, buttonId: n }), () => {
      l({ type: 2, buttonId: null });
    };
  }, [n, l, c]);
  let m = ee((S) => {
    var k;
    if (c) {
      if (s.disclosureState === 1) return;
      switch (S.key) {
        case ye.Space:
        case ye.Enter:
          S.preventDefault(), S.stopPropagation(), l({ type: 0 }), (k = s.buttonElement) == null || k.focus();
          break;
      }
    } else switch (S.key) {
      case ye.Space:
      case ye.Enter:
        S.preventDefault(), S.stopPropagation(), l({ type: 0 });
        break;
    }
  }), v = ee((S) => {
    switch (S.key) {
      case ye.Space:
        S.preventDefault();
        break;
    }
  }), h = ee((S) => {
    var k;
    Ni(S.currentTarget) || o || (c ? (l({ type: 0 }), (k = s.buttonElement) == null || k.focus()) : l({ type: 0 }));
  }), { isFocusVisible: _, focusProps: g } = ca({ autoFocus: a }), { isHovered: b, hoverProps: x } = Ti({ isDisabled: o }), { pressed: E, pressProps: O } = Oi({ disabled: o }), P = ae(() => ({ open: s.disclosureState === 0, hover: b, active: E, disabled: o, focus: _, autofocus: a }), [s, b, E, _, o, a]), y = Ri(e, s.buttonElement), w = Hr(c ? { ref: d, type: y, disabled: o || void 0, autoFocus: a, onKeyDown: m, onClick: h } : { ref: d, id: n, type: y, "aria-expanded": s.disclosureState === 0, "aria-controls": s.panelElement ? s.panelId : void 0, disabled: o || void 0, autoFocus: a, onKeyDown: m, onKeyUp: v, onClick: h }, g, x, O);
  return Ie({ mergeRefs: f, ourProps: w, theirProps: i, slot: P, defaultTag: z3, name: "Disclosure.Button" });
}
let G3 = "div", Q3 = Qt.RenderStrategy | Qt.Static;
function K3(e, t) {
  let r = xt(), { id: n = `headlessui-disclosure-panel-${r}`, transition: o = !1, ...a } = e, [i, s] = kd("Disclosure.Panel"), { close: l } = og("Disclosure.Panel"), u = Di(), [c, p] = me(null), d = Ue(t, ee((g) => {
    $3(() => s({ type: 5, element: g }));
  }), p);
  ge(() => (s({ type: 3, panelId: n }), () => {
    s({ type: 3, panelId: null });
  }), [n, s]);
  let f = Fn(), [m, v] = fa(o, c, f !== null ? (f & st.Open) === st.Open : i.disclosureState === 0), h = ae(() => ({ open: i.disclosureState === 0, close: l }), [i.disclosureState, l]), _ = { ref: d, id: n, ...da(v) };
  return G.createElement(xd, null, G.createElement(Dd.Provider, { value: i.panelId }, Ie({ mergeRefs: u, ourProps: _, theirProps: a, slot: h, defaultTag: G3, features: Q3, visible: m, name: "Disclosure.Panel" })));
}
let X3 = Ae(V3), Z3 = Ae(q3), J3 = Ae(K3), mM = Object.assign(X3, { Button: Z3, Panel: J3 });
function ag(e, t) {
  let r = ce({ left: 0, top: 0 });
  if (Ye(() => {
    if (!t) return;
    let o = t.getBoundingClientRect();
    o && (r.current = o);
  }, [e, t]), t == null || !e || t === document.activeElement) return !1;
  let n = t.getBoundingClientRect();
  return n.top !== r.current.top || n.left !== r.current.left;
}
let Fp = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
function Lp(e) {
  var t, r;
  let n = (t = e.innerText) != null ? t : "", o = e.cloneNode(!0);
  if (!(o instanceof HTMLElement)) return n;
  let a = !1;
  for (let s of o.querySelectorAll('[hidden],[aria-hidden],[role="img"]')) s.remove(), a = !0;
  let i = a ? (r = o.innerText) != null ? r : "" : n;
  return Fp.test(i) && (i = i.replace(Fp, "")), i;
}
function ek(e) {
  let t = e.getAttribute("aria-label");
  if (typeof t == "string") return t.trim();
  let r = e.getAttribute("aria-labelledby");
  if (r) {
    let n = r.split(" ").map((o) => {
      let a = document.getElementById(o);
      if (a) {
        let i = a.getAttribute("aria-label");
        return typeof i == "string" ? i.trim() : Lp(a).trim();
      }
      return null;
    }).filter(Boolean);
    if (n.length > 0) return n.join(", ");
  }
  return Lp(e).trim();
}
function ig(e) {
  let t = ce(""), r = ce("");
  return ee(() => {
    let n = e.current;
    if (!n) return "";
    let o = n.innerText;
    if (t.current === o) return r.current;
    let a = ek(n).trim().toLowerCase();
    return t.current = o, r.current = a, a;
  });
}
var tk = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(tk || {}), rk = ((e) => (e[e.Single = 0] = "Single", e[e.Multi = 1] = "Multi", e))(rk || {}), nk = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(nk || {}), ok = ((e) => (e[e.OpenListbox = 0] = "OpenListbox", e[e.CloseListbox = 1] = "CloseListbox", e[e.GoToOption = 2] = "GoToOption", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterOption = 5] = "RegisterOption", e[e.UnregisterOption = 6] = "UnregisterOption", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetOptionsElement = 8] = "SetOptionsElement", e))(ok || {});
function dc(e, t = (r) => r) {
  let r = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, n = Zn(t(e.options.slice()), (a) => a.dataRef.current.domRef.current), o = r ? n.indexOf(r) : null;
  return o === -1 && (o = null), { options: n, activeOptionIndex: o };
}
let ak = { 1(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 ? e : { ...e, activeOptionIndex: null, listboxState: 1, __demoMode: !1 };
}, 0(e) {
  if (e.dataRef.current.disabled || e.listboxState === 0) return e;
  let t = e.activeOptionIndex, { isSelected: r } = e.dataRef.current, n = e.options.findIndex((o) => r(o.dataRef.current.value));
  return n !== -1 && (t = n), { ...e, listboxState: 0, activeOptionIndex: t, __demoMode: !1 };
}, 2(e, t) {
  var r, n, o, a, i;
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  let s = { ...e, searchQuery: "", activationTrigger: (r = t.trigger) != null ? r : 1, __demoMode: !1 };
  if (t.focus === je.Nothing) return { ...s, activeOptionIndex: null };
  if (t.focus === je.Specific) return { ...s, activeOptionIndex: e.options.findIndex((c) => c.id === t.id) };
  if (t.focus === je.Previous) {
    let c = e.activeOptionIndex;
    if (c !== null) {
      let p = e.options[c].dataRef.current.domRef, d = Go(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (f) => f.id, resolveDisabled: (f) => f.dataRef.current.disabled });
      if (d !== null) {
        let f = e.options[d].dataRef.current.domRef;
        if (((n = p.current) == null ? void 0 : n.previousElementSibling) === f.current || ((o = f.current) == null ? void 0 : o.previousElementSibling) === null) return { ...s, activeOptionIndex: d };
      }
    }
  } else if (t.focus === je.Next) {
    let c = e.activeOptionIndex;
    if (c !== null) {
      let p = e.options[c].dataRef.current.domRef, d = Go(t, { resolveItems: () => e.options, resolveActiveIndex: () => e.activeOptionIndex, resolveId: (f) => f.id, resolveDisabled: (f) => f.dataRef.current.disabled });
      if (d !== null) {
        let f = e.options[d].dataRef.current.domRef;
        if (((a = p.current) == null ? void 0 : a.nextElementSibling) === f.current || ((i = f.current) == null ? void 0 : i.nextElementSibling) === null) return { ...s, activeOptionIndex: d };
      }
    }
  }
  let l = dc(e), u = Go(t, { resolveItems: () => l.options, resolveActiveIndex: () => l.activeOptionIndex, resolveId: (c) => c.id, resolveDisabled: (c) => c.dataRef.current.disabled });
  return { ...s, ...l, activeOptionIndex: u };
}, 3: (e, t) => {
  if (e.dataRef.current.disabled || e.listboxState === 1) return e;
  let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), o = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + r).concat(e.options.slice(0, e.activeOptionIndex + r)) : e.options).find((i) => {
    var s;
    return !i.dataRef.current.disabled && ((s = i.dataRef.current.textValue) == null ? void 0 : s.startsWith(n));
  }), a = o ? e.options.indexOf(o) : -1;
  return a === -1 || a === e.activeOptionIndex ? { ...e, searchQuery: n } : { ...e, searchQuery: n, activeOptionIndex: a, activationTrigger: 1 };
}, 4(e) {
  return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : { ...e, searchQuery: "" };
}, 5: (e, t) => {
  let r = { id: t.id, dataRef: t.dataRef }, n = dc(e, (o) => [...o, r]);
  return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (n.activeOptionIndex = n.options.indexOf(r)), { ...e, ...n };
}, 6: (e, t) => {
  let r = dc(e, (n) => {
    let o = n.findIndex((a) => a.id === t.id);
    return o !== -1 && n.splice(o, 1), n;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.optionsElement === t.element ? e : { ...e, optionsElement: t.element } }, Nd = $e(null);
Nd.displayName = "ListboxActionsContext";
function Sl(e) {
  let t = Oe(Nd);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Sl), r;
  }
  return t;
}
let El = $e(null);
El.displayName = "ListboxDataContext";
function Yi(e) {
  let t = Oe(El);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Yi), r;
  }
  return t;
}
function ik(e, t) {
  return Ze(t.type, ak, e, t);
}
let sk = jt;
function lk(e, t) {
  var r;
  let n = rd(), { value: o, defaultValue: a, form: i, name: s, onChange: l, by: u, invalid: c = !1, disabled: p = n || !1, horizontal: d = !1, multiple: f = !1, __demoMode: m = !1, ...v } = e;
  const h = d ? "horizontal" : "vertical";
  let _ = Ue(t), g = KE(a), [b = f ? [] : void 0, x] = QE(o, l, g), [E, O] = Co(ik, { dataRef: Wa(), listboxState: m ? 0 : 1, options: [], searchQuery: "", activeOptionIndex: null, activationTrigger: 1, optionsVisible: !1, buttonElement: null, optionsElement: null, __demoMode: m }), P = ce({ static: !1, hold: !1 }), y = ce(/* @__PURE__ */ new Map()), w = vT(u), S = Le((pe) => Ze(k.mode, { 1: () => b.some((Z) => w(Z, pe)), 0: () => w(b, pe) }), [b]), k = ae(() => ({ ...E, value: b, disabled: p, invalid: c, mode: f ? 1 : 0, orientation: h, compare: w, isSelected: S, optionsPropsRef: P, listRef: y }), [b, p, c, f, E, y]);
  Ye(() => {
    E.dataRef.current = k;
  }, [k]);
  let T = k.listboxState === 0;
  fl(T, [k.buttonElement, k.optionsElement], (pe, Z) => {
    var Pe;
    O({ type: 1 }), Mi(Z, Pi.Loose) || (pe.preventDefault(), (Pe = k.buttonElement) == null || Pe.focus());
  });
  let R = ae(() => ({ open: k.listboxState === 0, disabled: p, invalid: c, value: b }), [k, p, b, c]), I = ee((pe) => {
    let Z = k.options.find((Pe) => Pe.id === pe);
    Z && B(Z.dataRef.current.value);
  }), C = ee(() => {
    if (k.activeOptionIndex !== null) {
      let { dataRef: pe, id: Z } = k.options[k.activeOptionIndex];
      B(pe.current.value), O({ type: 2, focus: je.Specific, id: Z });
    }
  }), A = ee(() => O({ type: 0 })), D = ee(() => O({ type: 1 })), N = An(), M = ee((pe, Z, Pe) => {
    N.dispose(), N.microTask(() => pe === je.Specific ? O({ type: 2, focus: je.Specific, id: Z, trigger: Pe }) : O({ type: 2, focus: pe, trigger: Pe }));
  }), W = ee((pe, Z) => (O({ type: 5, id: pe, dataRef: Z }), () => O({ type: 6, id: pe }))), B = ee((pe) => Ze(k.mode, { 0() {
    return x == null ? void 0 : x(pe);
  }, 1() {
    let Z = k.value.slice(), Pe = Z.findIndex((J) => w(J, pe));
    return Pe === -1 ? Z.push(pe) : Z.splice(Pe, 1), x == null ? void 0 : x(Z);
  } })), j = ee((pe) => O({ type: 3, value: pe })), q = ee(() => O({ type: 4 })), se = ee((pe) => {
    O({ type: 7, element: pe });
  }), te = ee((pe) => {
    O({ type: 8, element: pe });
  }), le = ae(() => ({ onChange: B, registerOption: W, goToOption: M, closeListbox: D, openListbox: A, selectActiveOption: C, selectOption: I, search: j, clearSearch: q, setButtonElement: se, setOptionsElement: te }), []), [ke, at] = ad({ inherit: !0 }), _t = { ref: _ }, Pt = Le(() => {
    if (g !== void 0) return x == null ? void 0 : x(g);
  }, [x, g]);
  return G.createElement(at, { value: ke, props: { htmlFor: (r = k.buttonElement) == null ? void 0 : r.id }, slot: { open: k.listboxState === 0, disabled: p } }, G.createElement(wd, null, G.createElement(Nd.Provider, { value: le }, G.createElement(El.Provider, { value: k }, G.createElement($i, { value: Ze(k.listboxState, { 0: st.Open, 1: st.Closed }) }, s != null && b != null && G.createElement(rT, { disabled: p, data: { [s]: b }, form: i, onReset: Pt }), Ie({ ourProps: _t, theirProps: v, slot: R, defaultTag: sk, name: "Listbox" }))))));
}
let ck = "button";
function uk(e, t) {
  var r;
  let n = Yi("Listbox.Button"), o = Sl("Listbox.Button"), a = xt(), i = f0(), { id: s = i || `headlessui-listbox-button-${a}`, disabled: l = n.disabled || !1, autoFocus: u = !1, ...c } = e, p = Di(), d = Ue(t, vd(), o.setButtonElement), f = $0(), m = ee((T) => {
    switch (T.key) {
      case ye.Enter:
        XE(T.currentTarget);
        break;
      case ye.Space:
      case ye.ArrowDown:
        T.preventDefault(), zt(() => o.openListbox()), n.value || o.goToOption(je.First);
        break;
      case ye.ArrowUp:
        T.preventDefault(), zt(() => o.openListbox()), n.value || o.goToOption(je.Last);
        break;
    }
  }), v = ee((T) => {
    switch (T.key) {
      case ye.Space:
        T.preventDefault();
        break;
    }
  }), h = ee((T) => {
    var R;
    if (Ni(T.currentTarget)) return T.preventDefault();
    n.listboxState === 0 ? (zt(() => o.closeListbox()), (R = n.buttonElement) == null || R.focus({ preventScroll: !0 })) : (T.preventDefault(), o.openListbox());
  }), _ = ee((T) => T.preventDefault()), g = g0([s]), b = iT(), { isFocusVisible: x, focusProps: E } = ca({ autoFocus: u }), { isHovered: O, hoverProps: P } = Ti({ isDisabled: l }), { pressed: y, pressProps: w } = Oi({ disabled: l }), S = ae(() => ({ open: n.listboxState === 0, active: y || n.listboxState === 0, disabled: l, invalid: n.invalid, value: n.value, hover: O, focus: x, autofocus: u }), [n.listboxState, n.value, l, O, x, y, n.invalid, u]), k = Hr(f(), { ref: d, id: s, type: Ri(e, n.buttonElement), "aria-haspopup": "listbox", "aria-controls": (r = n.optionsElement) == null ? void 0 : r.id, "aria-expanded": n.listboxState === 0, "aria-labelledby": g, "aria-describedby": b, disabled: l || void 0, autoFocus: u, onKeyDown: m, onKeyUp: v, onKeyPress: _, onClick: h }, E, P, w);
  return Ie({ mergeRefs: p, ourProps: k, theirProps: c, slot: S, defaultTag: ck, name: "Listbox.Button" });
}
let sg = $e(!1), dk = "div", fk = Qt.RenderStrategy | Qt.Static;
function pk(e, t) {
  var r, n;
  let o = xt(), { id: a = `headlessui-listbox-options-${o}`, anchor: i, portal: s = !1, modal: l = !0, transition: u = !1, ...c } = e, p = gd(i), [d, f] = me(null);
  p && (s = !0);
  let m = Yi("Listbox.Options"), v = Sl("Listbox.Options"), h = gn(m.optionsElement), _ = Fn(), [g, b] = fa(u, d, _ !== null ? (_ & st.Open) === st.Open : m.listboxState === 0);
  dl(g, m.buttonElement, v.closeListbox);
  let x = m.__demoMode ? !1 : l && m.listboxState === 0;
  pl(x, h);
  let E = m.__demoMode ? !1 : l && m.listboxState === 0;
  ld(E, { allowed: Le(() => [m.buttonElement, m.optionsElement], [m.buttonElement, m.optionsElement]) });
  let O = m.listboxState !== 0, P = ag(O, m.buttonElement) ? !1 : g, y = g && m.listboxState === 1, w = Q4(y, m.value), S = ee((j) => m.compare(w, j)), k = ae(() => {
    var j;
    if (p == null || !((j = p == null ? void 0 : p.to) != null && j.includes("selection"))) return null;
    let q = m.options.findIndex((se) => S(se.dataRef.current.value));
    return q === -1 && (q = 0), q;
  }, [p, m.options]), T = (() => {
    if (p == null) return;
    if (k === null) return { ...p, inner: void 0 };
    let j = Array.from(m.listRef.current.values());
    return { ...p, inner: { listRef: { current: j }, index: k } };
  })(), [R, I] = bd(T), C = yd(), A = Ue(t, p ? R : null, v.setOptionsElement, f), D = An();
  ge(() => {
    var j;
    let q = m.optionsElement;
    q && m.listboxState === 0 && q !== ((j = Qr(q)) == null ? void 0 : j.activeElement) && (q == null || q.focus({ preventScroll: !0 }));
  }, [m.listboxState, m.optionsElement]);
  let N = ee((j) => {
    var q, se;
    switch (D.dispose(), j.key) {
      case ye.Space:
        if (m.searchQuery !== "") return j.preventDefault(), j.stopPropagation(), v.search(j.key);
      case ye.Enter:
        if (j.preventDefault(), j.stopPropagation(), m.activeOptionIndex !== null) {
          let { dataRef: te } = m.options[m.activeOptionIndex];
          v.onChange(te.current.value);
        }
        m.mode === 0 && (zt(() => v.closeListbox()), (q = m.buttonElement) == null || q.focus({ preventScroll: !0 }));
        break;
      case Ze(m.orientation, { vertical: ye.ArrowDown, horizontal: ye.ArrowRight }):
        return j.preventDefault(), j.stopPropagation(), v.goToOption(je.Next);
      case Ze(m.orientation, { vertical: ye.ArrowUp, horizontal: ye.ArrowLeft }):
        return j.preventDefault(), j.stopPropagation(), v.goToOption(je.Previous);
      case ye.Home:
      case ye.PageUp:
        return j.preventDefault(), j.stopPropagation(), v.goToOption(je.First);
      case ye.End:
      case ye.PageDown:
        return j.preventDefault(), j.stopPropagation(), v.goToOption(je.Last);
      case ye.Escape:
        j.preventDefault(), j.stopPropagation(), zt(() => v.closeListbox()), (se = m.buttonElement) == null || se.focus({ preventScroll: !0 });
        return;
      case ye.Tab:
        j.preventDefault(), j.stopPropagation(), zt(() => v.closeListbox()), w0(m.buttonElement, j.shiftKey ? Xe.Previous : Xe.Next);
        break;
      default:
        j.key.length === 1 && (v.search(j.key), D.setTimeout(() => v.clearSearch(), 350));
        break;
    }
  }), M = (r = m.buttonElement) == null ? void 0 : r.id, W = ae(() => ({ open: m.listboxState === 0 }), [m.listboxState]), B = Hr(p ? C() : {}, { id: a, ref: A, "aria-activedescendant": m.activeOptionIndex === null || (n = m.options[m.activeOptionIndex]) == null ? void 0 : n.id, "aria-multiselectable": m.mode === 1 ? !0 : void 0, "aria-labelledby": M, "aria-orientation": m.orientation, onKeyDown: N, role: "listbox", tabIndex: m.listboxState === 0 ? 0 : void 0, style: { ...c.style, ...I, "--button-width": sd(m.buttonElement, !0).width }, ...da(b) });
  return G.createElement(vl, { enabled: s ? e.static || g : !1 }, G.createElement(El.Provider, { value: m.mode === 1 ? m : { ...m, isSelected: S } }, Ie({ ourProps: B, theirProps: c, slot: W, defaultTag: dk, features: fk, visible: P, name: "Listbox.Options" })));
}
let mk = "div";
function hk(e, t) {
  let r = xt(), { id: n = `headlessui-listbox-option-${r}`, disabled: o = !1, value: a, ...i } = e, s = Oe(sg) === !0, l = Yi("Listbox.Option"), u = Sl("Listbox.Option"), c = l.activeOptionIndex !== null ? l.options[l.activeOptionIndex].id === n : !1, p = l.isSelected(a), d = ce(null), f = ig(d), m = ir({ disabled: o, value: a, domRef: d, get textValue() {
    return f();
  } }), v = Ue(t, d, (y) => {
    y ? l.listRef.current.set(n, y) : l.listRef.current.delete(n);
  });
  Ye(() => {
    if (!l.__demoMode && l.listboxState === 0 && c && l.activationTrigger !== 0) return Kr().requestAnimationFrame(() => {
      var y, w;
      (w = (y = d.current) == null ? void 0 : y.scrollIntoView) == null || w.call(y, { block: "nearest" });
    });
  }, [d, c, l.__demoMode, l.listboxState, l.activationTrigger, l.activeOptionIndex]), Ye(() => {
    if (!s) return u.registerOption(n, m);
  }, [m, n, s]);
  let h = ee((y) => {
    var w;
    if (o) return y.preventDefault();
    u.onChange(a), l.mode === 0 && (zt(() => u.closeListbox()), (w = l.buttonElement) == null || w.focus({ preventScroll: !0 }));
  }), _ = ee(() => {
    if (o) return u.goToOption(je.Nothing);
    u.goToOption(je.Specific, n);
  }), g = S0(), b = ee((y) => {
    g.update(y), !o && (c || u.goToOption(je.Specific, n, 0));
  }), x = ee((y) => {
    g.wasMoved(y) && (o || c || u.goToOption(je.Specific, n, 0));
  }), E = ee((y) => {
    g.wasMoved(y) && (o || c && u.goToOption(je.Nothing));
  }), O = ae(() => ({ active: c, focus: c, selected: p, disabled: o, selectedOption: p && s }), [c, p, o, s]);
  return !p && s ? null : Ie({ ourProps: s ? {} : { id: n, ref: v, role: "option", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, "aria-selected": p, disabled: void 0, onClick: h, onFocus: _, onPointerEnter: b, onMouseEnter: b, onPointerMove: x, onMouseMove: x, onPointerLeave: E, onMouseLeave: E }, theirProps: i, slot: O, defaultTag: mk, name: "Listbox.Option" });
}
let gk = jt;
function vk(e, t) {
  let { options: r, placeholder: n, ...o } = e, a = { ref: Ue(t) }, i = Yi("ListboxSelectedOption"), s = ae(() => ({}), []), l = i.value === void 0 || i.value === null || i.mode === 1 && Array.isArray(i.value) && i.value.length === 0;
  return G.createElement(sg.Provider, { value: !0 }, Ie({ ourProps: a, theirProps: { ...o, children: G.createElement(G.Fragment, null, n && l ? n : r) }, slot: s, defaultTag: gk, name: "ListboxSelectedOption" }));
}
let yk = Ae(lk), lg = Ae(uk), bk = mT, cg = Ae(pk), ug = Ae(hk), wk = Ae(vk), xk = Object.assign(yk, { Button: lg, Label: bk, Options: cg, Option: ug, SelectedOption: wk });
var _k = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(_k || {}), Sk = ((e) => (e[e.Pointer = 0] = "Pointer", e[e.Other = 1] = "Other", e))(Sk || {}), Ek = ((e) => (e[e.OpenMenu = 0] = "OpenMenu", e[e.CloseMenu = 1] = "CloseMenu", e[e.GoToItem = 2] = "GoToItem", e[e.Search = 3] = "Search", e[e.ClearSearch = 4] = "ClearSearch", e[e.RegisterItem = 5] = "RegisterItem", e[e.UnregisterItem = 6] = "UnregisterItem", e[e.SetButtonElement = 7] = "SetButtonElement", e[e.SetItemsElement = 8] = "SetItemsElement", e))(Ek || {});
function fc(e, t = (r) => r) {
  let r = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, n = Zn(t(e.items.slice()), (a) => a.dataRef.current.domRef.current), o = r ? n.indexOf(r) : null;
  return o === -1 && (o = null), { items: n, activeItemIndex: o };
}
let Tk = { 1(e) {
  return e.menuState === 1 ? e : { ...e, activeItemIndex: null, menuState: 1 };
}, 0(e) {
  return e.menuState === 0 ? e : { ...e, __demoMode: !1, menuState: 0 };
}, 2: (e, t) => {
  var r, n, o, a, i;
  if (e.menuState === 1) return e;
  let s = { ...e, searchQuery: "", activationTrigger: (r = t.trigger) != null ? r : 1, __demoMode: !1 };
  if (t.focus === je.Nothing) return { ...s, activeItemIndex: null };
  if (t.focus === je.Specific) return { ...s, activeItemIndex: e.items.findIndex((c) => c.id === t.id) };
  if (t.focus === je.Previous) {
    let c = e.activeItemIndex;
    if (c !== null) {
      let p = e.items[c].dataRef.current.domRef, d = Go(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (f) => f.id, resolveDisabled: (f) => f.dataRef.current.disabled });
      if (d !== null) {
        let f = e.items[d].dataRef.current.domRef;
        if (((n = p.current) == null ? void 0 : n.previousElementSibling) === f.current || ((o = f.current) == null ? void 0 : o.previousElementSibling) === null) return { ...s, activeItemIndex: d };
      }
    }
  } else if (t.focus === je.Next) {
    let c = e.activeItemIndex;
    if (c !== null) {
      let p = e.items[c].dataRef.current.domRef, d = Go(t, { resolveItems: () => e.items, resolveActiveIndex: () => e.activeItemIndex, resolveId: (f) => f.id, resolveDisabled: (f) => f.dataRef.current.disabled });
      if (d !== null) {
        let f = e.items[d].dataRef.current.domRef;
        if (((a = p.current) == null ? void 0 : a.nextElementSibling) === f.current || ((i = f.current) == null ? void 0 : i.nextElementSibling) === null) return { ...s, activeItemIndex: d };
      }
    }
  }
  let l = fc(e), u = Go(t, { resolveItems: () => l.items, resolveActiveIndex: () => l.activeItemIndex, resolveId: (c) => c.id, resolveDisabled: (c) => c.dataRef.current.disabled });
  return { ...s, ...l, activeItemIndex: u };
}, 3: (e, t) => {
  let r = e.searchQuery !== "" ? 0 : 1, n = e.searchQuery + t.value.toLowerCase(), o = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + r).concat(e.items.slice(0, e.activeItemIndex + r)) : e.items).find((i) => {
    var s;
    return ((s = i.dataRef.current.textValue) == null ? void 0 : s.startsWith(n)) && !i.dataRef.current.disabled;
  }), a = o ? e.items.indexOf(o) : -1;
  return a === -1 || a === e.activeItemIndex ? { ...e, searchQuery: n } : { ...e, searchQuery: n, activeItemIndex: a, activationTrigger: 1 };
}, 4(e) {
  return e.searchQuery === "" ? e : { ...e, searchQuery: "", searchActiveItemIndex: null };
}, 5: (e, t) => {
  let r = fc(e, (n) => [...n, { id: t.id, dataRef: t.dataRef }]);
  return { ...e, ...r };
}, 6: (e, t) => {
  let r = fc(e, (n) => {
    let o = n.findIndex((a) => a.id === t.id);
    return o !== -1 && n.splice(o, 1), n;
  });
  return { ...e, ...r, activationTrigger: 1 };
}, 7: (e, t) => e.buttonElement === t.element ? e : { ...e, buttonElement: t.element }, 8: (e, t) => e.itemsElement === t.element ? e : { ...e, itemsElement: t.element } }, Cd = $e(null);
Cd.displayName = "MenuContext";
function Tl(e) {
  let t = Oe(Cd);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Tl), r;
  }
  return t;
}
function kk(e, t) {
  return Ze(t.type, Tk, e, t);
}
let Ok = jt;
function Dk(e, t) {
  let { __demoMode: r = !1, ...n } = e, o = Co(kk, { __demoMode: r, menuState: r ? 0 : 1, buttonElement: null, itemsElement: null, items: [], searchQuery: "", activeItemIndex: null, activationTrigger: 1 }), [{ menuState: a, itemsElement: i, buttonElement: s }, l] = o, u = Ue(t);
  fl(a === 0, [s, i], (f, m) => {
    l({ type: 1 }), Mi(m, Pi.Loose) || (f.preventDefault(), s == null || s.focus());
  });
  let c = ee(() => {
    l({ type: 1 });
  }), p = ae(() => ({ open: a === 0, close: c }), [a, c]), d = { ref: u };
  return G.createElement(wd, null, G.createElement(Cd.Provider, { value: o }, G.createElement($i, { value: Ze(a, { 0: st.Open, 1: st.Closed }) }, Ie({ ourProps: d, theirProps: n, slot: p, defaultTag: Ok, name: "Menu" }))));
}
let Nk = "button";
function Ck(e, t) {
  var r;
  let n = xt(), { id: o = `headlessui-menu-button-${n}`, disabled: a = !1, autoFocus: i = !1, ...s } = e, [l, u] = Tl("Menu.Button"), c = $0(), p = Di(), d = Ue(t, vd(), ee((y) => u({ type: 7, element: y }))), f = ee((y) => {
    switch (y.key) {
      case ye.Space:
      case ye.Enter:
      case ye.ArrowDown:
        y.preventDefault(), y.stopPropagation(), zt(() => u({ type: 0 })), u({ type: 2, focus: je.First });
        break;
      case ye.ArrowUp:
        y.preventDefault(), y.stopPropagation(), zt(() => u({ type: 0 })), u({ type: 2, focus: je.Last });
        break;
    }
  }), m = ee((y) => {
    switch (y.key) {
      case ye.Space:
        y.preventDefault();
        break;
    }
  }), v = ee((y) => {
    var w;
    if (Ni(y.currentTarget)) return y.preventDefault();
    a || (l.menuState === 0 ? (zt(() => u({ type: 1 })), (w = l.buttonElement) == null || w.focus({ preventScroll: !0 })) : (y.preventDefault(), u({ type: 0 })));
  }), { isFocusVisible: h, focusProps: _ } = ca({ autoFocus: i }), { isHovered: g, hoverProps: b } = Ti({ isDisabled: a }), { pressed: x, pressProps: E } = Oi({ disabled: a }), O = ae(() => ({ open: l.menuState === 0, active: x || l.menuState === 0, disabled: a, hover: g, focus: h, autofocus: i }), [l, g, h, x, a, i]), P = Hr(c(), { ref: d, id: o, type: Ri(e, l.buttonElement), "aria-haspopup": "menu", "aria-controls": (r = l.itemsElement) == null ? void 0 : r.id, "aria-expanded": l.menuState === 0, disabled: a || void 0, autoFocus: i, onKeyDown: f, onKeyUp: m, onClick: v }, _, b, E);
  return Ie({ mergeRefs: p, ourProps: P, theirProps: s, slot: O, defaultTag: Nk, name: "Menu.Button" });
}
let Pk = "div", Mk = Qt.RenderStrategy | Qt.Static;
function Rk(e, t) {
  var r, n;
  let o = xt(), { id: a = `headlessui-menu-items-${o}`, anchor: i, portal: s = !1, modal: l = !0, transition: u = !1, ...c } = e, p = gd(i), [d, f] = Tl("Menu.Items"), [m, v] = bd(p), h = yd(), [_, g] = me(null), b = Ue(t, p ? m : null, ee((D) => f({ type: 8, element: D })), g), x = gn(d.itemsElement);
  p && (s = !0);
  let E = Fn(), [O, P] = fa(u, _, E !== null ? (E & st.Open) === st.Open : d.menuState === 0);
  dl(O, d.buttonElement, () => {
    f({ type: 1 });
  });
  let y = d.__demoMode ? !1 : l && d.menuState === 0;
  pl(y, x);
  let w = d.__demoMode ? !1 : l && d.menuState === 0;
  ld(w, { allowed: Le(() => [d.buttonElement, d.itemsElement], [d.buttonElement, d.itemsElement]) });
  let S = d.menuState !== 0, k = ag(S, d.buttonElement) ? !1 : O;
  ge(() => {
    let D = d.itemsElement;
    D && d.menuState === 0 && D !== (x == null ? void 0 : x.activeElement) && D.focus({ preventScroll: !0 });
  }, [d.menuState, d.itemsElement, x]), WT(d.menuState === 0, { container: d.itemsElement, accept(D) {
    return D.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : D.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(D) {
    D.setAttribute("role", "none");
  } });
  let T = An(), R = ee((D) => {
    var N, M, W;
    switch (T.dispose(), D.key) {
      case ye.Space:
        if (d.searchQuery !== "") return D.preventDefault(), D.stopPropagation(), f({ type: 3, value: D.key });
      case ye.Enter:
        if (D.preventDefault(), D.stopPropagation(), f({ type: 1 }), d.activeItemIndex !== null) {
          let { dataRef: B } = d.items[d.activeItemIndex];
          (M = (N = B.current) == null ? void 0 : N.domRef.current) == null || M.click();
        }
        b0(d.buttonElement);
        break;
      case ye.ArrowDown:
        return D.preventDefault(), D.stopPropagation(), f({ type: 2, focus: je.Next });
      case ye.ArrowUp:
        return D.preventDefault(), D.stopPropagation(), f({ type: 2, focus: je.Previous });
      case ye.Home:
      case ye.PageUp:
        return D.preventDefault(), D.stopPropagation(), f({ type: 2, focus: je.First });
      case ye.End:
      case ye.PageDown:
        return D.preventDefault(), D.stopPropagation(), f({ type: 2, focus: je.Last });
      case ye.Escape:
        D.preventDefault(), D.stopPropagation(), zt(() => f({ type: 1 })), (W = d.buttonElement) == null || W.focus({ preventScroll: !0 });
        break;
      case ye.Tab:
        D.preventDefault(), D.stopPropagation(), zt(() => f({ type: 1 })), w0(d.buttonElement, D.shiftKey ? Xe.Previous : Xe.Next);
        break;
      default:
        D.key.length === 1 && (f({ type: 3, value: D.key }), T.setTimeout(() => f({ type: 4 }), 350));
        break;
    }
  }), I = ee((D) => {
    switch (D.key) {
      case ye.Space:
        D.preventDefault();
        break;
    }
  }), C = ae(() => ({ open: d.menuState === 0 }), [d.menuState]), A = Hr(p ? h() : {}, { "aria-activedescendant": d.activeItemIndex === null || (r = d.items[d.activeItemIndex]) == null ? void 0 : r.id, "aria-labelledby": (n = d.buttonElement) == null ? void 0 : n.id, id: a, onKeyDown: R, onKeyUp: I, role: "menu", tabIndex: d.menuState === 0 ? 0 : void 0, ref: b, style: { ...c.style, ...v, "--button-width": sd(d.buttonElement, !0).width }, ...da(P) });
  return G.createElement(vl, { enabled: s ? e.static || O : !1 }, Ie({ ourProps: A, theirProps: c, slot: C, defaultTag: Pk, features: Mk, visible: k, name: "Menu.Items" }));
}
let Ak = jt;
function Ik(e, t) {
  let r = xt(), { id: n = `headlessui-menu-item-${r}`, disabled: o = !1, ...a } = e, [i, s] = Tl("Menu.Item"), l = i.activeItemIndex !== null ? i.items[i.activeItemIndex].id === n : !1, u = ce(null), c = Ue(t, u);
  Ye(() => {
    if (!i.__demoMode && i.menuState === 0 && l && i.activationTrigger !== 0) return Kr().requestAnimationFrame(() => {
      var w, S;
      (S = (w = u.current) == null ? void 0 : w.scrollIntoView) == null || S.call(w, { block: "nearest" });
    });
  }, [i.__demoMode, u, l, i.menuState, i.activationTrigger, i.activeItemIndex]);
  let p = ig(u), d = ce({ disabled: o, domRef: u, get textValue() {
    return p();
  } });
  Ye(() => {
    d.current.disabled = o;
  }, [d, o]), Ye(() => (s({ type: 5, id: n, dataRef: d }), () => s({ type: 6, id: n })), [d, n]);
  let f = ee(() => {
    s({ type: 1 });
  }), m = ee((w) => {
    if (o) return w.preventDefault();
    s({ type: 1 }), b0(i.buttonElement);
  }), v = ee(() => {
    if (o) return s({ type: 2, focus: je.Nothing });
    s({ type: 2, focus: je.Specific, id: n });
  }), h = S0(), _ = ee((w) => {
    h.update(w), !o && (l || s({ type: 2, focus: je.Specific, id: n, trigger: 0 }));
  }), g = ee((w) => {
    h.wasMoved(w) && (o || l || s({ type: 2, focus: je.Specific, id: n, trigger: 0 }));
  }), b = ee((w) => {
    h.wasMoved(w) && (o || l && s({ type: 2, focus: je.Nothing }));
  }), [x, E] = ad(), [O, P] = h0(), y = ae(() => ({ active: l, focus: l, disabled: o, close: f }), [l, o, f]);
  return G.createElement(E, null, G.createElement(P, null, Ie({ ourProps: { id: n, ref: c, role: "menuitem", tabIndex: o === !0 ? void 0 : -1, "aria-disabled": o === !0 ? !0 : void 0, "aria-labelledby": x, "aria-describedby": O, disabled: void 0, onClick: m, onFocus: v, onPointerEnter: _, onMouseEnter: _, onPointerMove: g, onMouseMove: g, onPointerLeave: b, onMouseLeave: b }, theirProps: a, slot: y, defaultTag: Ak, name: "Menu.Item" })));
}
let Fk = "div";
function Lk(e, t) {
  let [r, n] = ad();
  return G.createElement(n, null, Ie({ ourProps: { ref: t, "aria-labelledby": r, role: "group" }, theirProps: e, slot: {}, defaultTag: Fk, name: "Menu.Section" }));
}
let $k = "header";
function Wk(e, t) {
  let r = xt(), { id: n = `headlessui-menu-heading-${r}`, ...o } = e, a = od();
  Ye(() => a.register(n), [n, a.register]);
  let i = { id: n, ref: t, role: "presentation", ...a.props };
  return Ie({ ourProps: i, theirProps: o, slot: {}, defaultTag: $k, name: "Menu.Heading" });
}
let Yk = "div";
function Bk(e, t) {
  return Ie({ ourProps: { ref: t, role: "separator" }, theirProps: e, slot: {}, defaultTag: Yk, name: "Menu.Separator" });
}
let jk = Ae(Dk), Uk = Ae(Ck), Hk = Ae(Rk), Vk = Ae(Ik), zk = Ae(Lk), qk = Ae(Wk), Gk = Ae(Bk), hM = Object.assign(jk, { Button: Uk, Items: Hk, Item: Vk, Section: zk, Heading: qk, Separator: Gk });
var Qk = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(Qk || {}), Kk = ((e) => (e[e.TogglePopover = 0] = "TogglePopover", e[e.ClosePopover = 1] = "ClosePopover", e[e.SetButton = 2] = "SetButton", e[e.SetButtonId = 3] = "SetButtonId", e[e.SetPanel = 4] = "SetPanel", e[e.SetPanelId = 5] = "SetPanelId", e))(Kk || {});
let Xk = { 0: (e) => ({ ...e, popoverState: Ze(e.popoverState, { 0: 1, 1: 0 }), __demoMode: !1 }), 1(e) {
  return e.popoverState === 1 ? e : { ...e, popoverState: 1, __demoMode: !1 };
}, 2(e, t) {
  return e.button === t.button ? e : { ...e, button: t.button };
}, 3(e, t) {
  return e.buttonId === t.buttonId ? e : { ...e, buttonId: t.buttonId };
}, 4(e, t) {
  return e.panel === t.panel ? e : { ...e, panel: t.panel };
}, 5(e, t) {
  return e.panelId === t.panelId ? e : { ...e, panelId: t.panelId };
} }, Pd = $e(null);
Pd.displayName = "PopoverContext";
function kl(e) {
  let t = Oe(Pd);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, kl), r;
  }
  return t;
}
let Ol = $e(null);
Ol.displayName = "PopoverAPIContext";
function Md(e) {
  let t = Oe(Ol);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Popover /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Md), r;
  }
  return t;
}
let Rd = $e(null);
Rd.displayName = "PopoverGroupContext";
function dg() {
  return Oe(Rd);
}
let Dl = $e(null);
Dl.displayName = "PopoverPanelContext";
function Zk() {
  return Oe(Dl);
}
function Jk(e, t) {
  return Ze(t.type, Xk, e, t);
}
let eO = "div";
function tO(e, t) {
  var r;
  let { __demoMode: n = !1, ...o } = e, a = ce(null), i = Ue(t, nd((N) => {
    a.current = N;
  })), s = ce([]), l = Co(Jk, { __demoMode: n, popoverState: n ? 0 : 1, buttons: s, button: null, buttonId: null, panel: null, panelId: null, beforePanelSentinel: Wa(), afterPanelSentinel: Wa(), afterButtonSentinel: Wa() }), [{ popoverState: u, button: c, buttonId: p, panel: d, panelId: f, beforePanelSentinel: m, afterPanelSentinel: v, afterButtonSentinel: h }, _] = l, g = gn((r = a.current) != null ? r : c), b = ae(() => {
    if (!c || !d) return !1;
    for (let se of document.querySelectorAll("body > *")) if (Number(se == null ? void 0 : se.contains(c)) ^ Number(se == null ? void 0 : se.contains(d))) return !0;
    let N = Ci(), M = N.indexOf(c), W = (M + N.length - 1) % N.length, B = (M + 1) % N.length, j = N[W], q = N[B];
    return !d.contains(j) && !d.contains(q);
  }, [c, d]), x = ir(p), E = ir(f), O = ae(() => ({ buttonId: x, panelId: E, close: () => _({ type: 1 }) }), [x, E, _]), P = dg(), y = P == null ? void 0 : P.registerPopover, w = ee(() => {
    var N;
    return (N = P == null ? void 0 : P.isFocusWithinPopoverGroup()) != null ? N : (g == null ? void 0 : g.activeElement) && ((c == null ? void 0 : c.contains(g.activeElement)) || (d == null ? void 0 : d.contains(g.activeElement)));
  });
  ge(() => y == null ? void 0 : y(O), [y, O]);
  let [S, k] = H0(), T = _d(c), R = z0({ mainTreeNode: T, portals: S, defaultContainers: [c, d] });
  cd(g == null ? void 0 : g.defaultView, "focus", (N) => {
    var M, W, B, j, q, se;
    N.target !== window && N.target instanceof HTMLElement && u === 0 && (w() || c && d && (R.contains(N.target) || (W = (M = m.current) == null ? void 0 : M.contains) != null && W.call(M, N.target) || (j = (B = v.current) == null ? void 0 : B.contains) != null && j.call(B, N.target) || (se = (q = h.current) == null ? void 0 : q.contains) != null && se.call(q, N.target) || _({ type: 1 })));
  }, !0), fl(u === 0, R.resolveContainers, (N, M) => {
    _({ type: 1 }), Mi(M, Pi.Loose) || (N.preventDefault(), c == null || c.focus());
  });
  let I = ee((N) => {
    _({ type: 1 });
    let M = N ? N instanceof HTMLElement ? N : "current" in N && N.current instanceof HTMLElement ? N.current : c : c;
    M == null || M.focus();
  }), C = ae(() => ({ close: I, isPortalled: b }), [I, b]), A = ae(() => ({ open: u === 0, close: I }), [u, I]), D = { ref: i };
  return G.createElement(js, { node: T }, G.createElement(wd, null, G.createElement(Dl.Provider, { value: null }, G.createElement(Pd.Provider, { value: l }, G.createElement(Ol.Provider, { value: C }, G.createElement(id, { value: I }, G.createElement($i, { value: Ze(u, { 0: st.Open, 1: st.Closed }) }, G.createElement(k, null, Ie({ ourProps: D, theirProps: o, slot: A, defaultTag: eO, name: "Popover" })))))))));
}
let rO = "button";
function nO(e, t) {
  let r = xt(), { id: n = `headlessui-popover-button-${r}`, disabled: o = !1, autoFocus: a = !1, ...i } = e, [s, l] = kl("Popover.Button"), { isPortalled: u } = Md("Popover.Button"), c = ce(null), p = `headlessui-focus-sentinel-${xt()}`, d = dg(), f = d == null ? void 0 : d.closeOthers, m = Zk() !== null;
  ge(() => {
    if (!m) return l({ type: 3, buttonId: n }), () => {
      l({ type: 3, buttonId: null });
    };
  }, [m, n, l]);
  let [v] = me(() => Symbol()), h = Ue(c, t, vd(), ee((M) => {
    if (!m) {
      if (M) s.buttons.current.push(v);
      else {
        let W = s.buttons.current.indexOf(v);
        W !== -1 && s.buttons.current.splice(W, 1);
      }
      s.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), M && l({ type: 2, button: M });
    }
  })), _ = Ue(c, t), g = gn(c), b = ee((M) => {
    var W, B, j;
    if (m) {
      if (s.popoverState === 1) return;
      switch (M.key) {
        case ye.Space:
        case ye.Enter:
          M.preventDefault(), (B = (W = M.target).click) == null || B.call(W), l({ type: 1 }), (j = s.button) == null || j.focus();
          break;
      }
    } else switch (M.key) {
      case ye.Space:
      case ye.Enter:
        M.preventDefault(), M.stopPropagation(), s.popoverState === 1 && (f == null || f(s.buttonId)), l({ type: 0 });
        break;
      case ye.Escape:
        if (s.popoverState !== 0) return f == null ? void 0 : f(s.buttonId);
        if (!c.current || g != null && g.activeElement && !c.current.contains(g.activeElement)) return;
        M.preventDefault(), M.stopPropagation(), l({ type: 1 });
        break;
    }
  }), x = ee((M) => {
    m || M.key === ye.Space && M.preventDefault();
  }), E = ee((M) => {
    var W, B;
    Ni(M.currentTarget) || o || (m ? (l({ type: 1 }), (W = s.button) == null || W.focus()) : (M.preventDefault(), M.stopPropagation(), s.popoverState === 1 && (f == null || f(s.buttonId)), l({ type: 0 }), (B = s.button) == null || B.focus()));
  }), O = ee((M) => {
    M.preventDefault(), M.stopPropagation();
  }), { isFocusVisible: P, focusProps: y } = ca({ autoFocus: a }), { isHovered: w, hoverProps: S } = Ti({ isDisabled: o }), { pressed: k, pressProps: T } = Oi({ disabled: o }), R = s.popoverState === 0, I = ae(() => ({ open: R, active: k || R, disabled: o, hover: w, focus: P, autofocus: a }), [R, w, P, k, o, a]), C = Ri(e, s.button), A = Hr(m ? { ref: _, type: C, onKeyDown: b, onClick: E, disabled: o || void 0, autoFocus: a } : { ref: h, id: s.buttonId, type: C, "aria-expanded": s.popoverState === 0, "aria-controls": s.panel ? s.panelId : void 0, disabled: o || void 0, autoFocus: a, onKeyDown: b, onKeyUp: x, onClick: E, onMouseDown: O }, y, S, T), D = Sd(), N = ee(() => {
    let M = s.panel;
    if (!M) return;
    function W() {
      Ze(D.current, { [mr.Forwards]: () => At(M, Xe.First), [mr.Backwards]: () => At(M, Xe.Last) }) === nn.Error && At(Ci().filter((B) => B.dataset.headlessuiFocusGuard !== "true"), Ze(D.current, { [mr.Forwards]: Xe.Next, [mr.Backwards]: Xe.Previous }), { relativeTo: s.button });
    }
    W();
  });
  return G.createElement(G.Fragment, null, Ie({ ourProps: A, theirProps: i, slot: I, defaultTag: rO, name: "Popover.Button" }), R && !m && u && G.createElement(un, { id: p, ref: s.afterButtonSentinel, features: cn.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: N }));
}
let oO = "div", aO = Qt.RenderStrategy | Qt.Static;
function fg(e, t) {
  let r = xt(), { id: n = `headlessui-popover-backdrop-${r}`, transition: o = !1, ...a } = e, [{ popoverState: i }, s] = kl("Popover.Backdrop"), [l, u] = me(null), c = Ue(t, u), p = Fn(), [d, f] = fa(o, l, p !== null ? (p & st.Open) === st.Open : i === 0), m = ee((_) => {
    if (Ni(_.currentTarget)) return _.preventDefault();
    s({ type: 1 });
  }), v = ae(() => ({ open: i === 0 }), [i]), h = { ref: c, id: n, "aria-hidden": !0, onClick: m, ...da(f) };
  return Ie({ ourProps: h, theirProps: a, slot: v, defaultTag: oO, features: aO, visible: d, name: "Popover.Backdrop" });
}
let iO = "div", sO = Qt.RenderStrategy | Qt.Static;
function lO(e, t) {
  let r = xt(), { id: n = `headlessui-popover-panel-${r}`, focus: o = !1, anchor: a, portal: i = !1, modal: s = !1, transition: l = !1, ...u } = e, [c, p] = kl("Popover.Panel"), { close: d, isPortalled: f } = Md("Popover.Panel"), m = `headlessui-focus-sentinel-before-${r}`, v = `headlessui-focus-sentinel-after-${r}`, h = ce(null), _ = gd(a), [g, b] = bd(_), x = yd();
  _ && (i = !0);
  let [E, O] = me(null), P = Ue(h, t, _ ? g : null, ee((W) => p({ type: 4, panel: W })), O), y = gn(h), w = Di();
  Ye(() => (p({ type: 5, panelId: n }), () => {
    p({ type: 5, panelId: null });
  }), [n, p]);
  let S = Fn(), [k, T] = fa(l, E, S !== null ? (S & st.Open) === st.Open : c.popoverState === 0);
  dl(k, c.button, () => {
    p({ type: 1 });
  });
  let R = c.__demoMode ? !1 : s && k;
  pl(R, y);
  let I = ee((W) => {
    var B;
    switch (W.key) {
      case ye.Escape:
        if (c.popoverState !== 0 || !h.current || y != null && y.activeElement && !h.current.contains(y.activeElement)) return;
        W.preventDefault(), W.stopPropagation(), p({ type: 1 }), (B = c.button) == null || B.focus();
        break;
    }
  });
  ge(() => {
    var W;
    e.static || c.popoverState === 1 && ((W = e.unmount) == null || W) && p({ type: 4, panel: null });
  }, [c.popoverState, e.unmount, e.static, p]), ge(() => {
    if (c.__demoMode || !o || c.popoverState !== 0 || !h.current) return;
    let W = y == null ? void 0 : y.activeElement;
    h.current.contains(W) || At(h.current, Xe.First);
  }, [c.__demoMode, o, h.current, c.popoverState]);
  let C = ae(() => ({ open: c.popoverState === 0, close: d }), [c.popoverState, d]), A = Hr(_ ? x() : {}, { ref: P, id: n, onKeyDown: I, onBlur: o && c.popoverState === 0 ? (W) => {
    var B, j, q, se, te;
    let le = W.relatedTarget;
    le && h.current && ((B = h.current) != null && B.contains(le) || (p({ type: 1 }), ((q = (j = c.beforePanelSentinel.current) == null ? void 0 : j.contains) != null && q.call(j, le) || (te = (se = c.afterPanelSentinel.current) == null ? void 0 : se.contains) != null && te.call(se, le)) && le.focus({ preventScroll: !0 })));
  } : void 0, tabIndex: -1, style: { ...u.style, ...b, "--button-width": sd(c.button, !0).width }, ...da(T) }), D = Sd(), N = ee(() => {
    let W = h.current;
    if (!W) return;
    function B() {
      Ze(D.current, { [mr.Forwards]: () => {
        var j;
        At(W, Xe.First) === nn.Error && ((j = c.afterPanelSentinel.current) == null || j.focus());
      }, [mr.Backwards]: () => {
        var j;
        (j = c.button) == null || j.focus({ preventScroll: !0 });
      } });
    }
    B();
  }), M = ee(() => {
    let W = h.current;
    if (!W) return;
    function B() {
      Ze(D.current, { [mr.Forwards]: () => {
        if (!c.button) return;
        let j = Ci(), q = j.indexOf(c.button), se = j.slice(0, q + 1), te = [...j.slice(q + 1), ...se];
        for (let le of te.slice()) if (le.dataset.headlessuiFocusGuard === "true" || E != null && E.contains(le)) {
          let ke = te.indexOf(le);
          ke !== -1 && te.splice(ke, 1);
        }
        At(te, Xe.First, { sorted: !1 });
      }, [mr.Backwards]: () => {
        var j;
        At(W, Xe.Previous) === nn.Error && ((j = c.button) == null || j.focus());
      } });
    }
    B();
  });
  return G.createElement(xd, null, G.createElement(Dl.Provider, { value: n }, G.createElement(Ol.Provider, { value: { close: d, isPortalled: f } }, G.createElement(vl, { enabled: i ? e.static || k : !1 }, k && f && G.createElement(un, { id: m, ref: c.beforePanelSentinel, features: cn.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: N }), Ie({ mergeRefs: w, ourProps: A, theirProps: u, slot: C, defaultTag: iO, features: sO, visible: k, name: "Popover.Panel" }), k && f && G.createElement(un, { id: v, ref: c.afterPanelSentinel, features: cn.Focusable, "data-headlessui-focus-guard": !0, as: "button", type: "button", onFocus: M })))));
}
let cO = "div";
function uO(e, t) {
  let r = ce(null), n = Ue(r, t), [o, a] = me([]), i = ee((m) => {
    a((v) => {
      let h = v.indexOf(m);
      if (h !== -1) {
        let _ = v.slice();
        return _.splice(h, 1), _;
      }
      return v;
    });
  }), s = ee((m) => (a((v) => [...v, m]), () => i(m))), l = ee(() => {
    var m;
    let v = Qr(r);
    if (!v) return !1;
    let h = v.activeElement;
    return (m = r.current) != null && m.contains(h) ? !0 : o.some((_) => {
      var g, b;
      return ((g = v.getElementById(_.buttonId.current)) == null ? void 0 : g.contains(h)) || ((b = v.getElementById(_.panelId.current)) == null ? void 0 : b.contains(h));
    });
  }), u = ee((m) => {
    for (let v of o) v.buttonId.current !== m && v.close();
  }), c = ae(() => ({ registerPopover: s, unregisterPopover: i, isFocusWithinPopoverGroup: l, closeOthers: u }), [s, i, l, u]), p = ae(() => ({}), []), d = e, f = { ref: n };
  return G.createElement(js, null, G.createElement(Rd.Provider, { value: c }, Ie({ ourProps: f, theirProps: d, slot: p, defaultTag: cO, name: "Popover.Group" })));
}
let dO = Ae(tO), fO = Ae(nO), pO = Ae(fg), mO = Ae(fg), hO = Ae(lO), gO = Ae(uO), gM = Object.assign(dO, { Button: fO, Backdrop: mO, Overlay: pO, Panel: hO, Group: gO });
function vO({ onFocus: e }) {
  let [t, r] = me(!0), n = yl();
  return t ? G.createElement(un, { as: "button", type: "button", features: cn.Focusable, onFocus: (o) => {
    o.preventDefault();
    let a, i = 50;
    function s() {
      if (i-- <= 0) {
        a && cancelAnimationFrame(a);
        return;
      }
      if (e()) {
        if (cancelAnimationFrame(a), !n.current) return;
        r(!1);
        return;
      }
      a = requestAnimationFrame(s);
    }
    a = requestAnimationFrame(s);
  } }) : null;
}
const pg = Q.createContext(null);
function yO() {
  return { groups: /* @__PURE__ */ new Map(), get(e, t) {
    var r;
    let n = this.groups.get(e);
    n || (n = /* @__PURE__ */ new Map(), this.groups.set(e, n));
    let o = (r = n.get(t)) != null ? r : 0;
    n.set(t, o + 1);
    let a = Array.from(n.keys()).indexOf(t);
    function i() {
      let s = n.get(t);
      s > 1 ? n.set(t, s - 1) : n.delete(t);
    }
    return [a, i];
  } };
}
function bO({ children: e }) {
  let t = Q.useRef(yO());
  return Q.createElement(pg.Provider, { value: t }, e);
}
function mg(e) {
  let t = Q.useContext(pg);
  if (!t) throw new Error("You must wrap your component in a <StableCollection>");
  let r = Q.useId(), [n, o] = t.current.get(e, r);
  return Q.useEffect(() => o, []), n;
}
var wO = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(wO || {}), xO = ((e) => (e[e.Less = -1] = "Less", e[e.Equal = 0] = "Equal", e[e.Greater = 1] = "Greater", e))(xO || {}), _O = ((e) => (e[e.SetSelectedIndex = 0] = "SetSelectedIndex", e[e.RegisterTab = 1] = "RegisterTab", e[e.UnregisterTab = 2] = "UnregisterTab", e[e.RegisterPanel = 3] = "RegisterPanel", e[e.UnregisterPanel = 4] = "UnregisterPanel", e))(_O || {});
let SO = { 0(e, t) {
  var r;
  let n = Zn(e.tabs, (c) => c.current), o = Zn(e.panels, (c) => c.current), a = n.filter((c) => {
    var p;
    return !((p = c.current) != null && p.hasAttribute("disabled"));
  }), i = { ...e, tabs: n, panels: o };
  if (t.index < 0 || t.index > n.length - 1) {
    let c = Ze(Math.sign(t.index - e.selectedIndex), { [-1]: () => 1, 0: () => Ze(Math.sign(t.index), { [-1]: () => 0, 0: () => 0, 1: () => 1 }), 1: () => 0 });
    if (a.length === 0) return i;
    let p = Ze(c, { 0: () => n.indexOf(a[0]), 1: () => n.indexOf(a[a.length - 1]) });
    return { ...i, selectedIndex: p === -1 ? e.selectedIndex : p };
  }
  let s = n.slice(0, t.index), l = [...n.slice(t.index), ...s].find((c) => a.includes(c));
  if (!l) return i;
  let u = (r = n.indexOf(l)) != null ? r : e.selectedIndex;
  return u === -1 && (u = e.selectedIndex), { ...i, selectedIndex: u };
}, 1(e, t) {
  if (e.tabs.includes(t.tab)) return e;
  let r = e.tabs[e.selectedIndex], n = Zn([...e.tabs, t.tab], (a) => a.current), o = e.selectedIndex;
  return e.info.current.isControlled || (o = n.indexOf(r), o === -1 && (o = e.selectedIndex)), { ...e, tabs: n, selectedIndex: o };
}, 2(e, t) {
  return { ...e, tabs: e.tabs.filter((r) => r !== t.tab) };
}, 3(e, t) {
  return e.panels.includes(t.panel) ? e : { ...e, panels: Zn([...e.panels, t.panel], (r) => r.current) };
}, 4(e, t) {
  return { ...e, panels: e.panels.filter((r) => r !== t.panel) };
} }, Ad = $e(null);
Ad.displayName = "TabsDataContext";
function ea(e) {
  let t = Oe(Ad);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, ea), r;
  }
  return t;
}
let Id = $e(null);
Id.displayName = "TabsActionsContext";
function Fd(e) {
  let t = Oe(Id);
  if (t === null) {
    let r = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(r, Fd), r;
  }
  return t;
}
function EO(e, t) {
  return Ze(t.type, SO, e, t);
}
let TO = "div";
function kO(e, t) {
  let { defaultIndex: r = 0, vertical: n = !1, manual: o = !1, onChange: a, selectedIndex: i = null, ...s } = e;
  const l = n ? "vertical" : "horizontal", u = o ? "manual" : "auto";
  let c = i !== null, p = ir({ isControlled: c }), d = Ue(t), [f, m] = Co(EO, { info: p, selectedIndex: i ?? r, tabs: [], panels: [] }), v = ae(() => ({ selectedIndex: f.selectedIndex }), [f.selectedIndex]), h = ir(a || (() => {
  })), _ = ir(f.tabs), g = ae(() => ({ orientation: l, activation: u, ...f }), [l, u, f]), b = ee((w) => (m({ type: 1, tab: w }), () => m({ type: 2, tab: w }))), x = ee((w) => (m({ type: 3, panel: w }), () => m({ type: 4, panel: w }))), E = ee((w) => {
    O.current !== w && h.current(w), c || m({ type: 0, index: w });
  }), O = ir(c ? e.selectedIndex : f.selectedIndex), P = ae(() => ({ registerTab: b, registerPanel: x, change: E }), []);
  Ye(() => {
    m({ type: 0, index: i ?? r });
  }, [i]), Ye(() => {
    if (O.current === void 0 || f.tabs.length <= 0) return;
    let w = Zn(f.tabs, (S) => S.current);
    w.some((S, k) => f.tabs[k] !== S) && E(w.indexOf(f.tabs[O.current]));
  });
  let y = { ref: d };
  return G.createElement(bO, null, G.createElement(Id.Provider, { value: P }, G.createElement(Ad.Provider, { value: g }, g.tabs.length <= 0 && G.createElement(vO, { onFocus: () => {
    var w, S;
    for (let k of _.current) if (((w = k.current) == null ? void 0 : w.tabIndex) === 0) return (S = k.current) == null || S.focus(), !0;
    return !1;
  } }), Ie({ ourProps: y, theirProps: s, slot: v, defaultTag: TO, name: "Tabs" }))));
}
let OO = "div";
function DO(e, t) {
  let { orientation: r, selectedIndex: n } = ea("Tab.List"), o = Ue(t), a = ae(() => ({ selectedIndex: n }), [n]);
  return Ie({ ourProps: { ref: o, role: "tablist", "aria-orientation": r }, theirProps: e, slot: a, defaultTag: OO, name: "Tabs.List" });
}
let NO = "button";
function CO(e, t) {
  var r, n;
  let o = xt(), { id: a = `headlessui-tabs-tab-${o}`, disabled: i = !1, autoFocus: s = !1, ...l } = e, { orientation: u, activation: c, selectedIndex: p, tabs: d, panels: f } = ea("Tab"), m = Fd("Tab"), v = ea("Tab"), [h, _] = me(null), g = ce(null), b = Ue(g, t, _);
  Ye(() => m.registerTab(g), [m, g]);
  let x = mg("tabs"), E = d.indexOf(g);
  E === -1 && (E = x);
  let O = E === p, P = ee((W) => {
    var B;
    let j = W();
    if (j === nn.Success && c === "auto") {
      let q = (B = Qr(g)) == null ? void 0 : B.activeElement, se = v.tabs.findIndex((te) => te.current === q);
      se !== -1 && m.change(se);
    }
    return j;
  }), y = ee((W) => {
    let B = d.map((j) => j.current).filter(Boolean);
    if (W.key === ye.Space || W.key === ye.Enter) {
      W.preventDefault(), W.stopPropagation(), m.change(E);
      return;
    }
    switch (W.key) {
      case ye.Home:
      case ye.PageUp:
        return W.preventDefault(), W.stopPropagation(), P(() => At(B, Xe.First));
      case ye.End:
      case ye.PageDown:
        return W.preventDefault(), W.stopPropagation(), P(() => At(B, Xe.Last));
    }
    if (P(() => Ze(u, { vertical() {
      return W.key === ye.ArrowUp ? At(B, Xe.Previous | Xe.WrapAround) : W.key === ye.ArrowDown ? At(B, Xe.Next | Xe.WrapAround) : nn.Error;
    }, horizontal() {
      return W.key === ye.ArrowLeft ? At(B, Xe.Previous | Xe.WrapAround) : W.key === ye.ArrowRight ? At(B, Xe.Next | Xe.WrapAround) : nn.Error;
    } })) === nn.Success) return W.preventDefault();
  }), w = ce(!1), S = ee(() => {
    var W;
    w.current || (w.current = !0, (W = g.current) == null || W.focus({ preventScroll: !0 }), m.change(E), ki(() => {
      w.current = !1;
    }));
  }), k = ee((W) => {
    W.preventDefault();
  }), { isFocusVisible: T, focusProps: R } = ca({ autoFocus: s }), { isHovered: I, hoverProps: C } = Ti({ isDisabled: i }), { pressed: A, pressProps: D } = Oi({ disabled: i }), N = ae(() => ({ selected: O, hover: I, active: A, focus: T, autofocus: s, disabled: i }), [O, I, T, A, s, i]), M = Hr({ ref: b, onKeyDown: y, onMouseDown: k, onClick: S, id: a, role: "tab", type: Ri(e, h), "aria-controls": (n = (r = f[E]) == null ? void 0 : r.current) == null ? void 0 : n.id, "aria-selected": O, tabIndex: O ? 0 : -1, disabled: i || void 0, autoFocus: s }, R, C, D);
  return Ie({ ourProps: M, theirProps: l, slot: N, defaultTag: NO, name: "Tabs.Tab" });
}
let PO = "div";
function MO(e, t) {
  let { selectedIndex: r } = ea("Tab.Panels"), n = Ue(t), o = ae(() => ({ selectedIndex: r }), [r]);
  return Ie({ ourProps: { ref: n }, theirProps: e, slot: o, defaultTag: PO, name: "Tabs.Panels" });
}
let RO = "div", AO = Qt.RenderStrategy | Qt.Static;
function IO(e, t) {
  var r, n, o, a;
  let i = xt(), { id: s = `headlessui-tabs-panel-${i}`, tabIndex: l = 0, ...u } = e, { selectedIndex: c, tabs: p, panels: d } = ea("Tab.Panel"), f = Fd("Tab.Panel"), m = ce(null), v = Ue(m, t);
  Ye(() => f.registerPanel(m), [f, m]);
  let h = mg("panels"), _ = d.indexOf(m);
  _ === -1 && (_ = h);
  let g = _ === c, { isFocusVisible: b, focusProps: x } = ca(), E = ae(() => ({ selected: g, focus: b }), [g, b]), O = Hr({ ref: v, id: s, role: "tabpanel", "aria-labelledby": (n = (r = p[_]) == null ? void 0 : r.current) == null ? void 0 : n.id, tabIndex: g ? l : -1 }, x);
  return !g && ((o = u.unmount) == null || o) && !((a = u.static) != null && a) ? G.createElement(un, { "aria-hidden": "true", ...O }) : Ie({ ourProps: O, theirProps: u, slot: E, defaultTag: RO, features: AO, visible: g, name: "Tabs.Panel" });
}
let FO = Ae(CO), LO = Ae(kO), $O = Ae(DO), WO = Ae(MO), YO = Ae(IO), vM = Object.assign(FO, { Group: LO, List: $O, Panels: WO, Panel: YO });
const BO = (e) => /* @__PURE__ */ ue(
  "svg",
  {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
      /* @__PURE__ */ L(
        "mask",
        {
          id: "mask0_3150_7718",
          style: {
            maskType: "alpha"
          },
          maskUnits: "userSpaceOnUse",
          x: "0",
          y: "0",
          width: "24",
          height: "24",
          children: /* @__PURE__ */ L(
            "rect",
            {
              width: "24",
              height: "24",
              fill: "#D9D9D9"
            }
          )
        }
      ),
      /* @__PURE__ */ L("g", { mask: "url(#mask0_3150_7718)", children: /* @__PURE__ */ L(
        "path",
        {
          d: "M7.84922 12.9377L12.6742 17.7627C12.8659 17.9544 12.9596 18.1752 12.9555 18.4252C12.9513 18.6752 12.8534 18.896 12.6617 19.0877C12.4701 19.271 12.2492 19.3648 11.9992 19.3689C11.7492 19.3731 11.5284 19.2794 11.3367 19.0877L4.91172 12.6627C4.82005 12.571 4.7513 12.4689 4.70547 12.3564C4.65964 12.2439 4.63672 12.1252 4.63672 12.0002C4.63672 11.8752 4.65964 11.7564 4.70547 11.6439C4.7513 11.5314 4.82005 11.4294 4.91172 11.3377L11.3367 4.9127C11.5201 4.72936 11.7388 4.6377 11.993 4.6377C12.2471 4.6377 12.4701 4.72936 12.6617 4.9127C12.8534 5.10436 12.9492 5.32728 12.9492 5.58145C12.9492 5.83561 12.8534 6.05853 12.6617 6.2502L7.84922 11.0627H18.8117C19.0701 11.0627 19.2909 11.1544 19.4742 11.3377C19.6576 11.521 19.7492 11.7419 19.7492 12.0002C19.7492 12.2585 19.6576 12.4794 19.4742 12.6627C19.2909 12.846 19.0701 12.9377 18.8117 12.9377H7.84922Z",
          fill: "#EBE9FF"
        }
      ) })
    ]
  }
), jO = ({ classes: e, className: t, variant: r = "circular", ...n }) => {
  const { themeClasses: o } = Ge("BackButton", e, t, {
    variant: r
  });
  return /* @__PURE__ */ L(
    "button",
    {
      className: V(o == null ? void 0 : o.root),
      ...n,
      children: /* @__PURE__ */ L(
        BO,
        {
          color: "rgba(179,162,215,1)",
          className: V(o == null ? void 0 : o.icon)
        }
      )
    }
  );
}, yM = jO;
var UO = typeof global == "object" && global && global.Object === Object && global, HO = typeof self == "object" && self && self.Object === Object && self, hg = UO || HO || Function("return this")(), Us = hg.Symbol, gg = Object.prototype, VO = gg.hasOwnProperty, zO = gg.toString, Ra = Us ? Us.toStringTag : void 0;
function qO(e) {
  var t = VO.call(e, Ra), r = e[Ra];
  try {
    e[Ra] = void 0;
    var n = !0;
  } catch {
  }
  var o = zO.call(e);
  return n && (t ? e[Ra] = r : delete e[Ra]), o;
}
var GO = Object.prototype, QO = GO.toString;
function KO(e) {
  return QO.call(e);
}
var XO = "[object Null]", ZO = "[object Undefined]", $p = Us ? Us.toStringTag : void 0;
function JO(e) {
  return e == null ? e === void 0 ? ZO : XO : $p && $p in Object(e) ? qO(e) : KO(e);
}
function eD(e) {
  return e != null && typeof e == "object";
}
var tD = "[object Symbol]";
function rD(e) {
  return typeof e == "symbol" || eD(e) && JO(e) == tD;
}
var nD = /\s/;
function oD(e) {
  for (var t = e.length; t-- && nD.test(e.charAt(t)); )
    ;
  return t;
}
var aD = /^\s+/;
function iD(e) {
  return e && e.slice(0, oD(e) + 1).replace(aD, "");
}
function Hs(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var Wp = NaN, sD = /^[-+]0x[0-9a-f]+$/i, lD = /^0b[01]+$/i, cD = /^0o[0-7]+$/i, uD = parseInt;
function Yp(e) {
  if (typeof e == "number")
    return e;
  if (rD(e))
    return Wp;
  if (Hs(e)) {
    var t = typeof e.valueOf == "function" ? e.valueOf() : e;
    e = Hs(t) ? t + "" : t;
  }
  if (typeof e != "string")
    return e === 0 ? e : +e;
  e = iD(e);
  var r = lD.test(e);
  return r || cD.test(e) ? uD(e.slice(2), r ? 2 : 8) : sD.test(e) ? Wp : +e;
}
var pc = function() {
  return hg.Date.now();
}, dD = "Expected a function", fD = Math.max, pD = Math.min;
function mD(e, t, r) {
  var n, o, a, i, s, l, u = 0, c = !1, p = !1, d = !0;
  if (typeof e != "function")
    throw new TypeError(dD);
  t = Yp(t) || 0, Hs(r) && (c = !!r.leading, p = "maxWait" in r, a = p ? fD(Yp(r.maxWait) || 0, t) : a, d = "trailing" in r ? !!r.trailing : d);
  function f(O) {
    var P = n, y = o;
    return n = o = void 0, u = O, i = e.apply(y, P), i;
  }
  function m(O) {
    return u = O, s = setTimeout(_, t), c ? f(O) : i;
  }
  function v(O) {
    var P = O - l, y = O - u, w = t - P;
    return p ? pD(w, a - y) : w;
  }
  function h(O) {
    var P = O - l, y = O - u;
    return l === void 0 || P >= t || P < 0 || p && y >= a;
  }
  function _() {
    var O = pc();
    if (h(O))
      return g(O);
    s = setTimeout(_, v(O));
  }
  function g(O) {
    return s = void 0, d && n ? f(O) : (n = o = void 0, i);
  }
  function b() {
    s !== void 0 && clearTimeout(s), u = 0, n = l = o = s = void 0;
  }
  function x() {
    return s === void 0 ? i : g(pc());
  }
  function E() {
    var O = pc(), P = h(O);
    if (n = arguments, o = this, l = O, P) {
      if (s === void 0)
        return m(l);
      if (p)
        return clearTimeout(s), s = setTimeout(_, t), f(l);
    }
    return s === void 0 && (s = setTimeout(_, t)), i;
  }
  return E.cancel = b, E.flush = x, E;
}
var hD = "Expected a function";
function gD(e, t, r) {
  var n = !0, o = !0;
  if (typeof e != "function")
    throw new TypeError(hD);
  return Hs(r) && (n = "leading" in r ? !!r.leading : n, o = "trailing" in r ? !!r.trailing : o), mD(e, t, {
    leading: n,
    maxWait: t,
    trailing: o
  });
}
const vD = ({
  classes: e,
  className: t,
  children: r,
  variant: n = "primary",
  size: o = "md",
  icon: a,
  iconPosition: i = "left",
  loading: s = !1,
  disabledOnLoading: l = !0,
  ignorePointerEventsOnLoading: u = !0,
  loader: c,
  throttleIn: p,
  onClick: d,
  shiny: f,
  ...m
}) => {
  const { themeClasses: v } = Ge("Button", e, t, {
    variant: n,
    modifier: o
  }), h = ae(() => l && s || m.disabled, [m.disabled, l, s]), _ = Le(() => {
    if (d && !h)
      return p ? gD(d, p) : d;
  }, [d, h, p]), g = ae(
    () => /* @__PURE__ */ L(
      "button",
      {
        className: V(v == null ? void 0 : v.root, {
          "pointer-events-none": u && s
        }),
        ...m,
        disabled: h,
        onClick: _(),
        children: /* @__PURE__ */ L("div", { className: V(v == null ? void 0 : v.label), children: s ? c || /* @__PURE__ */ L(ed, { className: V(v == null ? void 0 : v.spinner) }) : /* @__PURE__ */ ue(Gt, { children: [
          a && i === "left" && a,
          r,
          a && i === "right" && a
        ] }) })
      }
    ),
    [
      m,
      r,
      a,
      i,
      u,
      h,
      c,
      s,
      v == null ? void 0 : v.label,
      v == null ? void 0 : v.root,
      v == null ? void 0 : v.spinner,
      _
    ]
  );
  return f ? /* @__PURE__ */ ue("div", { className: V("relative", v == null ? void 0 : v.shinyWrapper), children: [
    /* @__PURE__ */ L("span", { className: V("ui-sdk__button--shiny absolute opacity-90", v == null ? void 0 : v.shiny) }),
    g
  ] }) : g;
}, Ko = vD, yD = ({
  classes: e,
  className: t,
  children: r,
  variant: n = "contained",
  size: o = "md",
  icon: a,
  loading: i = !1,
  ...s
}) => {
  const { themeClasses: l } = Ge("ButtonIcon", e, t, {
    variant: n,
    modifier: o
  });
  return /* @__PURE__ */ L(
    "button",
    {
      className: V(l == null ? void 0 : l.root),
      ...s,
      disabled: i || s.disabled,
      children: /* @__PURE__ */ L("span", { className: V(l == null ? void 0 : l.icon), children: a })
    }
  );
}, bM = yD, bD = ({ className: e }) => /* @__PURE__ */ ue(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none",
    className: e,
    children: [
      /* @__PURE__ */ ue("g", { filter: "url(#filter0_d_3277_8971)", children: [
        /* @__PURE__ */ L(
          "mask",
          {
            id: "mask0_3277_8971",
            style: {
              maskType: "alpha"
            },
            maskUnits: "userSpaceOnUse",
            x: "0",
            y: "0",
            width: "18",
            height: "18",
            children: /* @__PURE__ */ L(
              "rect",
              {
                width: "18",
                height: "18",
                fill: "#D9D9D9"
              }
            )
          }
        ),
        /* @__PURE__ */ L("g", { mask: "url(#mask0_3277_8971)", children: /* @__PURE__ */ L(
          "path",
          {
            d: "M7.16435 11.2102L13.44 4.93453C13.6108 4.76366 13.8112 4.67822 14.0411 4.67822C14.271 4.67822 14.4714 4.76366 14.6424 4.93453C14.8133 5.10553 14.8987 5.30835 14.8987 5.54297C14.8987 5.7776 14.8133 5.98041 14.6424 6.15141L7.76566 13.0424C7.59466 13.2133 7.39422 13.2987 7.16435 13.2987C6.93447 13.2987 6.73404 13.2133 6.56304 13.0424L3.34704 9.82641C3.17616 9.65541 3.0931 9.4526 3.09785 9.21797C3.1026 8.98335 3.19041 8.78054 3.36129 8.60954C3.53229 8.43866 3.7351 8.35322 3.96972 8.35322C4.20435 8.35322 4.40716 8.43866 4.57816 8.60954L7.16435 11.2102Z",
            fill: "#EBE9FF"
          }
        ) })
      ] }),
      /* @__PURE__ */ L("defs", { children: /* @__PURE__ */ ue(
        "filter",
        {
          id: "filter0_d_3277_8971",
          x: "0",
          y: "0",
          width: "18.5",
          height: "19",
          filterUnits: "userSpaceOnUse",
          "color-interpolation-filters": "sRGB",
          children: [
            /* @__PURE__ */ L(
              "feFlood",
              {
                "flood-opacity": "0",
                result: "BackgroundImageFix"
              }
            ),
            /* @__PURE__ */ L(
              "feColorMatrix",
              {
                in: "SourceAlpha",
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                result: "hardAlpha"
              }
            ),
            /* @__PURE__ */ L(
              "feOffset",
              {
                dx: "0.5",
                dy: "1"
              }
            ),
            /* @__PURE__ */ L(
              "feComposite",
              {
                in2: "hardAlpha",
                operator: "out"
              }
            ),
            /* @__PURE__ */ L(
              "feColorMatrix",
              {
                type: "matrix",
                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
              }
            ),
            /* @__PURE__ */ L(
              "feBlend",
              {
                mode: "normal",
                in2: "BackgroundImageFix",
                result: "effect1_dropShadow_3277_8971"
              }
            ),
            /* @__PURE__ */ L(
              "feBlend",
              {
                mode: "normal",
                in: "SourceGraphic",
                in2: "effect1_dropShadow_3277_8971",
                result: "shape"
              }
            )
          ]
        }
      ) })
    ]
  }
), wD = ({ classes: e, className: t, variant: r = "outlined", size: n = "md", ...o }) => {
  const { themeClasses: a } = Ge("Checkbox", e, t, {
    variant: r,
    modifier: n
  });
  return /* @__PURE__ */ ue("div", { className: V("relative transition-colors", a == null ? void 0 : a.root), children: [
    /* @__PURE__ */ L(
      "input",
      {
        type: "checkbox",
        className: V("peer/checkbox", a == null ? void 0 : a.input),
        ...o
      }
    ),
    /* @__PURE__ */ L(
      bD,
      {
        className: V(
          "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 opacity-0 transition-opacity peer-checked/checkbox:opacity-90",
          a == null ? void 0 : a.symbol
        )
      }
    )
  ] });
}, xD = wD;
var Bp = function(e) {
  return typeof e == "object" && e !== null;
}, _D = function(e) {
  var t = e.value, r = t === void 0 ? "" : t, n = e.numInputs, o = n === void 0 ? 4 : n, a = e.onChange, i = e.onPaste, s = e.renderInput, l = e.shouldAutoFocus, u = l === void 0 ? !1 : l, c = e.inputType, p = c === void 0 ? "text" : c, d = e.renderSeparator, f = e.placeholder, m = e.containerStyle, v = e.inputStyle, h = e.skipDefaultStyles, _ = h === void 0 ? !1 : h, g = G.useState(0), b = g[0], x = g[1], E = G.useRef([]), O = function() {
    return r ? r.toString().split("") : [];
  }, P = p === "number" || p === "tel";
  G.useEffect(function() {
    E.current = E.current.slice(0, o);
  }, [o]), G.useEffect(function() {
    var M;
    u && ((M = E.current[0]) === null || M === void 0 || M.focus());
  }, [u]);
  var y = function() {
    if (typeof f == "string") {
      if (f.length === o)
        return f;
      f.length > 0 && console.error("Length of the placeholder should be equal to the number of inputs.");
    }
  }, w = function(M) {
    var W = P ? !isNaN(Number(M)) : typeof M == "string";
    return W && M.trim().length === 1;
  }, S = function(M) {
    var W = M.target.value;
    w(W) && (A(W), C(b + 1));
  }, k = function(M) {
    var W = M.nativeEvent, B = M.target.value;
    if (!w(B)) {
      if (B.length === o) {
        var j = B.split("").some(function(q) {
          return !w(q);
        });
        j || (D(B.split("")), C(o - 1));
      }
      W.data === null && W.inputType === "deleteContentBackward" && (M.preventDefault(), A(""), C(b - 1)), M.target.value = "";
    }
  }, T = function(M) {
    return function(W) {
      x(W), M.target.select();
    };
  }, R = function() {
    x(b - 1);
  }, I = function(M) {
    var W = O();
    [M.code, M.key].includes("Backspace") ? (M.preventDefault(), A(""), C(b - 1)) : M.code === "Delete" ? (M.preventDefault(), A("")) : M.code === "ArrowLeft" ? (M.preventDefault(), C(b - 1)) : M.code === "ArrowRight" || M.key === W[b] ? (M.preventDefault(), C(b + 1)) : (M.code === "Spacebar" || M.code === "Space" || M.code === "ArrowUp" || M.code === "ArrowDown") && M.preventDefault();
  }, C = function(M) {
    var W, B, j = Math.max(Math.min(o - 1, M), 0);
    E.current[j] && ((W = E.current[j]) === null || W === void 0 || W.focus(), (B = E.current[j]) === null || B === void 0 || B.select(), x(j));
  }, A = function(M) {
    var W = O();
    W[b] = M[0], D(W);
  }, D = function(M) {
    var W = M.join("");
    a(W);
  }, N = function(M) {
    var W;
    M.preventDefault();
    var B = O(), j = b, q = M.clipboardData.getData("text/plain").slice(0, o - b).split("");
    if (!(P && q.some(function(te) {
      return isNaN(Number(te));
    }))) {
      for (var se = 0; se < o; ++se)
        se >= b && q.length > 0 && (B[se] = (W = q.shift()) !== null && W !== void 0 ? W : "", j++);
      C(j), D(B);
    }
  };
  return G.createElement("div", { style: Object.assign({ display: "flex", alignItems: "center" }, Bp(m) && m), className: typeof m == "string" ? m : void 0, onPaste: i }, Array.from({ length: o }, function(M, W) {
    return W;
  }).map(function(M) {
    var W, B, j;
    return G.createElement(
      G.Fragment,
      { key: M },
      s({
        value: (W = O()[M]) !== null && W !== void 0 ? W : "",
        placeholder: (j = (B = y()) === null || B === void 0 ? void 0 : B[M]) !== null && j !== void 0 ? j : void 0,
        ref: function(q) {
          return E.current[M] = q;
        },
        onChange: S,
        onFocus: function(q) {
          return T(q)(M);
        },
        onBlur: R,
        onKeyDown: I,
        onPaste: N,
        autoComplete: "off",
        "aria-label": "Please enter OTP character ".concat(M + 1),
        style: Object.assign(_ ? {} : { width: "1em", textAlign: "center" }, Bp(v) ? v : {}),
        className: typeof v == "string" ? v : void 0,
        type: p,
        inputMode: P ? "numeric" : "text",
        onInput: k
      }, M),
      M < o - 1 && (typeof d == "function" ? d(M) : d)
    );
  }));
};
const SD = ({
  classes: e,
  className: t,
  length: r,
  type: n = "number",
  onChange: o,
  onComplete: a,
  value: i = "",
  readonly: s = !1,
  shouldAutoFocus: l,
  loading: u,
  disabled: c,
  error: p,
  helperText: d,
  displayHelperText: f,
  variant: m = "contained",
  t: v,
  helperTextClasses: h
}) => {
  const { themeClasses: _ } = Ge("CodeField", e, t, {
    variant: m
  }), [g, b] = me(i);
  ge(() => {
    b(i);
  }, [i]), ge(() => {
    o == null || o(g), String(g).length === r && (a == null || a(g));
  }, [g, r]);
  const x = Le(
    (E) => {
      var P;
      const O = (P = E == null ? void 0 : E.clipboardData) == null ? void 0 : P.getData("text");
      if (!O) {
        b("");
        return;
      }
      if (/^\d+$/.test(O))
        if (O.length >= r) {
          const y = O.substring(0, r);
          b(y);
        } else
          b(O);
      else
        b("");
    },
    [r]
  );
  return ge(() => {
    if (u) {
      const E = document.getElementsByClassName("code-input");
      for (let O = 0; O < E.length; O++)
        E[O].setSelectionRange(0, 0), E[O].blur();
    }
  }, [u]), /* @__PURE__ */ ue("div", { className: V("w-fit", _ == null ? void 0 : _.root), children: [
    /* @__PURE__ */ ue(
      "div",
      {
        className: V("relative flex w-fit", {
          "pointer-events-none": s
        }),
        onClick: (E) => {
          s && (E.preventDefault(), E.stopPropagation());
        },
        children: [
          u && /* @__PURE__ */ L("div", { className: "animate-fade-in absolute left-0 top-0 z-10 flex h-full w-full items-center justify-center", children: /* @__PURE__ */ L(ed, { className: "h-1/2" }) }),
          /* @__PURE__ */ L(
            _D,
            {
              shouldAutoFocus: l,
              value: g,
              onChange: (E) => {
                b(E);
              },
              onPaste: x,
              numInputs: r,
              renderSeparator: /* @__PURE__ */ L("div", { className: V("w-1 flex-shrink-0") }),
              renderInput: (E) => /* @__PURE__ */ L(
                TC,
                {
                  ...E,
                  type: n,
                  inputMode: "numeric",
                  disabled: u || c,
                  error: p,
                  classes: {
                    "root&": V("h-[50px] min-[300px]:w-[44px] min-[360px]:w-[50px]", {
                      "opacity-80": u
                    }),
                    "input&": V(
                      "code-input !h-full !w-full px-0 text-center font-bold min-[300px]:!text-[32px] min-[360px]:!text-[30px]",
                      _ == null ? void 0 : _.input
                    ),
                    "input_error&": "border-2"
                  }
                }
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ L(
      Qd,
      {
        error: p,
        helperText: d,
        alwaysDisplay: f,
        t: v,
        ...h,
        className: V("mt-2", h == null ? void 0 : h.className)
      }
    )
  ] });
}, wM = SD;
function Ve(e) {
  const t = Object.prototype.toString.call(e);
  return e instanceof Date || typeof e == "object" && t === "[object Date]" ? new e.constructor(+e) : typeof e == "number" || t === "[object Number]" || typeof e == "string" || t === "[object String]" ? new Date(e) : /* @__PURE__ */ new Date(NaN);
}
function br(e, t) {
  return e instanceof Date ? new e.constructor(t) : new Date(t);
}
function Zt(e, t) {
  const r = Ve(e);
  return isNaN(t) ? br(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function zr(e, t) {
  const r = Ve(e);
  if (isNaN(t)) return br(e, NaN);
  if (!t)
    return r;
  const n = r.getDate(), o = br(e, r.getTime());
  o.setMonth(r.getMonth() + t + 1, 0);
  const a = o.getDate();
  return n >= a ? o : (r.setFullYear(
    o.getFullYear(),
    o.getMonth(),
    n
  ), r);
}
const Ld = 6048e5, ED = 864e5;
let TD = {};
function Bi() {
  return TD;
}
function fn(e, t) {
  var s, l, u, c;
  const r = Bi(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? r.weekStartsOn ?? ((c = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, o = Ve(e), a = o.getDay(), i = (a < n ? 7 : 0) + a - n;
  return o.setDate(o.getDate() - i), o.setHours(0, 0, 0, 0), o;
}
function No(e) {
  return fn(e, { weekStartsOn: 1 });
}
function vg(e) {
  const t = Ve(e), r = t.getFullYear(), n = br(e, 0);
  n.setFullYear(r + 1, 0, 4), n.setHours(0, 0, 0, 0);
  const o = No(n), a = br(e, 0);
  a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0);
  const i = No(a);
  return t.getTime() >= o.getTime() ? r + 1 : t.getTime() >= i.getTime() ? r : r - 1;
}
function ta(e) {
  const t = Ve(e);
  return t.setHours(0, 0, 0, 0), t;
}
function Vs(e) {
  const t = Ve(e), r = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return r.setUTCFullYear(t.getFullYear()), +e - +r;
}
function on(e, t) {
  const r = ta(e), n = ta(t), o = +r - Vs(r), a = +n - Vs(n);
  return Math.round((o - a) / ED);
}
function kD(e) {
  const t = vg(e), r = br(e, 0);
  return r.setFullYear(t, 0, 4), r.setHours(0, 0, 0, 0), No(r);
}
function au(e, t) {
  const r = t * 7;
  return Zt(e, r);
}
function OD(e, t) {
  return zr(e, t * 12);
}
function DD(e) {
  let t;
  return e.forEach(function(r) {
    const n = Ve(r);
    (t === void 0 || t < n || isNaN(Number(n))) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function ND(e) {
  let t;
  return e.forEach((r) => {
    const n = Ve(r);
    (!t || t > n || isNaN(+n)) && (t = n);
  }), t || /* @__PURE__ */ new Date(NaN);
}
function sr(e, t) {
  const r = ta(e), n = ta(t);
  return +r == +n;
}
function $d(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function CD(e) {
  if (!$d(e) && typeof e != "number")
    return !1;
  const t = Ve(e);
  return !isNaN(Number(t));
}
function li(e, t) {
  const r = Ve(e), n = Ve(t), o = r.getFullYear() - n.getFullYear(), a = r.getMonth() - n.getMonth();
  return o * 12 + a;
}
function PD(e, t, r) {
  const n = fn(e, r), o = fn(t, r), a = +n - Vs(n), i = +o - Vs(o);
  return Math.round((a - i) / Ld);
}
function Wd(e) {
  const t = Ve(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(23, 59, 59, 999), t;
}
function lr(e) {
  const t = Ve(e);
  return t.setDate(1), t.setHours(0, 0, 0, 0), t;
}
function yg(e) {
  const t = Ve(e), r = br(e, 0);
  return r.setFullYear(t.getFullYear(), 0, 1), r.setHours(0, 0, 0, 0), r;
}
function Yd(e, t) {
  var s, l, u, c;
  const r = Bi(), n = (t == null ? void 0 : t.weekStartsOn) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? r.weekStartsOn ?? ((c = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : c.weekStartsOn) ?? 0, o = Ve(e), a = o.getDay(), i = (a < n ? -7 : 0) + 6 - (a - n);
  return o.setDate(o.getDate() + i), o.setHours(23, 59, 59, 999), o;
}
function bg(e) {
  return Yd(e, { weekStartsOn: 1 });
}
const MD = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, RD = (e, t, r) => {
  let n;
  const o = MD[e];
  return typeof o == "string" ? n = o : t === 1 ? n = o.one : n = o.other.replace("{{count}}", t.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + n : n + " ago" : n;
};
function mc(e) {
  return (t = {}) => {
    const r = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[r] || e.formats[e.defaultWidth];
  };
}
const AD = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, ID = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, FD = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, LD = {
  date: mc({
    formats: AD,
    defaultWidth: "full"
  }),
  time: mc({
    formats: ID,
    defaultWidth: "full"
  }),
  dateTime: mc({
    formats: FD,
    defaultWidth: "full"
  })
}, $D = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, WD = (e, t, r, n) => $D[e];
function Aa(e) {
  return (t, r) => {
    const n = r != null && r.context ? String(r.context) : "standalone";
    let o;
    if (n === "formatting" && e.formattingValues) {
      const i = e.defaultFormattingWidth || e.defaultWidth, s = r != null && r.width ? String(r.width) : i;
      o = e.formattingValues[s] || e.formattingValues[i];
    } else {
      const i = e.defaultWidth, s = r != null && r.width ? String(r.width) : e.defaultWidth;
      o = e.values[s] || e.values[i];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const YD = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, BD = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, jD = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, UD = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, HD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, VD = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, zD = (e, t) => {
  const r = Number(e), n = r % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, qD = {
  ordinalNumber: zD,
  era: Aa({
    values: YD,
    defaultWidth: "wide"
  }),
  quarter: Aa({
    values: BD,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: Aa({
    values: jD,
    defaultWidth: "wide"
  }),
  day: Aa({
    values: UD,
    defaultWidth: "wide"
  }),
  dayPeriod: Aa({
    values: HD,
    defaultWidth: "wide",
    formattingValues: VD,
    defaultFormattingWidth: "wide"
  })
};
function Ia(e) {
  return (t, r = {}) => {
    const n = r.width, o = n && e.matchPatterns[n] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const i = a[0], s = n && e.parsePatterns[n] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? QD(s, (p) => p.test(i)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      GD(s, (p) => p.test(i))
    );
    let u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = r.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      r.valueCallback(u)
    ) : u;
    const c = t.slice(i.length);
    return { value: u, rest: c };
  };
}
function GD(e, t) {
  for (const r in e)
    if (Object.prototype.hasOwnProperty.call(e, r) && t(e[r]))
      return r;
}
function QD(e, t) {
  for (let r = 0; r < e.length; r++)
    if (t(e[r]))
      return r;
}
function KD(e) {
  return (t, r = {}) => {
    const n = t.match(e.matchPattern);
    if (!n) return null;
    const o = n[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let i = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    i = r.valueCallback ? r.valueCallback(i) : i;
    const s = t.slice(o.length);
    return { value: i, rest: s };
  };
}
const XD = /^(\d+)(th|st|nd|rd)?/i, ZD = /\d+/i, JD = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, e8 = {
  any: [/^b/i, /^(a|c)/i]
}, t8 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, r8 = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, n8 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, o8 = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, a8 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, i8 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, s8 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, l8 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, c8 = {
  ordinalNumber: KD({
    matchPattern: XD,
    parsePattern: ZD,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Ia({
    matchPatterns: JD,
    defaultMatchWidth: "wide",
    parsePatterns: e8,
    defaultParseWidth: "any"
  }),
  quarter: Ia({
    matchPatterns: t8,
    defaultMatchWidth: "wide",
    parsePatterns: r8,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Ia({
    matchPatterns: n8,
    defaultMatchWidth: "wide",
    parsePatterns: o8,
    defaultParseWidth: "any"
  }),
  day: Ia({
    matchPatterns: a8,
    defaultMatchWidth: "wide",
    parsePatterns: i8,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ia({
    matchPatterns: s8,
    defaultMatchWidth: "any",
    parsePatterns: l8,
    defaultParseWidth: "any"
  })
}, wg = {
  code: "en-US",
  formatDistance: RD,
  formatLong: LD,
  formatRelative: WD,
  localize: qD,
  match: c8,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function u8(e) {
  const t = Ve(e);
  return on(t, yg(t)) + 1;
}
function xg(e) {
  const t = Ve(e), r = +No(t) - +kD(t);
  return Math.round(r / Ld) + 1;
}
function _g(e, t) {
  var c, p, d, f;
  const r = Ve(e), n = r.getFullYear(), o = Bi(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((p = (c = t == null ? void 0 : t.locale) == null ? void 0 : c.options) == null ? void 0 : p.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((f = (d = o.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = br(e, 0);
  i.setFullYear(n + 1, 0, a), i.setHours(0, 0, 0, 0);
  const s = fn(i, t), l = br(e, 0);
  l.setFullYear(n, 0, a), l.setHours(0, 0, 0, 0);
  const u = fn(l, t);
  return r.getTime() >= s.getTime() ? n + 1 : r.getTime() >= u.getTime() ? n : n - 1;
}
function d8(e, t) {
  var s, l, u, c;
  const r = Bi(), n = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((l = (s = t == null ? void 0 : t.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((c = (u = r.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? 1, o = _g(e, t), a = br(e, 0);
  return a.setFullYear(o, 0, n), a.setHours(0, 0, 0, 0), fn(a, t);
}
function Sg(e, t) {
  const r = Ve(e), n = +fn(r, t) - +d8(r, t);
  return Math.round(n / Ld) + 1;
}
function it(e, t) {
  const r = e < 0 ? "-" : "", n = Math.abs(e).toString().padStart(t, "0");
  return r + n;
}
const zn = {
  // Year
  y(e, t) {
    const r = e.getFullYear(), n = r > 0 ? r : 1 - r;
    return it(t === "yy" ? n % 100 : n, t.length);
  },
  // Month
  M(e, t) {
    const r = e.getMonth();
    return t === "M" ? String(r + 1) : it(r + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return it(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const r = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return it(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return it(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return it(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return it(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const r = t.length, n = e.getMilliseconds(), o = Math.trunc(
      n * Math.pow(10, r - 3)
    );
    return it(o, t.length);
  }
}, $o = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, jp = {
  // Era
  G: function(e, t, r) {
    const n = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" });
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      case "GGGG":
      default:
        return r.era(n, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, r) {
    if (t === "yo") {
      const n = e.getFullYear(), o = n > 0 ? n : 1 - n;
      return r.ordinalNumber(o, { unit: "year" });
    }
    return zn.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, r, n) {
    const o = _g(e, n), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const i = a % 100;
      return it(i, 2);
    }
    return t === "Yo" ? r.ordinalNumber(a, { unit: "year" }) : it(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const r = vg(e);
    return it(r, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const r = e.getFullYear();
    return it(r, t.length);
  },
  // Quarter
  Q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "Q":
        return String(n);
      case "QQ":
        return it(n, 2);
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, r) {
    const n = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      case "q":
        return String(n);
      case "qq":
        return it(n, 2);
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return zn.M(e, t);
      case "Mo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, r) {
    const n = e.getMonth();
    switch (t) {
      case "L":
        return String(n + 1);
      case "LL":
        return it(n + 1, 2);
      case "Lo":
        return r.ordinalNumber(n + 1, { unit: "month" });
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, r, n) {
    const o = Sg(e, n);
    return t === "wo" ? r.ordinalNumber(o, { unit: "week" }) : it(o, t.length);
  },
  // ISO week of year
  I: function(e, t, r) {
    const n = xg(e);
    return t === "Io" ? r.ordinalNumber(n, { unit: "week" }) : it(n, t.length);
  },
  // Day of the month
  d: function(e, t, r) {
    return t === "do" ? r.ordinalNumber(e.getDate(), { unit: "date" }) : zn.d(e, t);
  },
  // Day of year
  D: function(e, t, r) {
    const n = u8(e);
    return t === "Do" ? r.ordinalNumber(n, { unit: "dayOfYear" }) : it(n, t.length);
  },
  // Day of week
  E: function(e, t, r) {
    const n = e.getDay();
    switch (t) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, r, n) {
    const o = e.getDay(), a = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "e":
        return String(a);
      case "ee":
        return it(a, 2);
      case "eo":
        return r.ordinalNumber(a, { unit: "day" });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, r, n) {
    const o = e.getDay(), a = (o - n.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      case "c":
        return String(a);
      case "cc":
        return it(a, t.length);
      case "co":
        return r.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, r) {
    const n = e.getDay(), o = n === 0 ? 7 : n;
    switch (t) {
      case "i":
        return String(o);
      case "ii":
        return it(o, t.length);
      case "io":
        return r.ordinalNumber(o, { unit: "day" });
      case "iii":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(n, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(n, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, r) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, r) {
    const n = e.getHours();
    let o;
    switch (n === 12 ? o = $o.noon : n === 0 ? o = $o.midnight : o = n / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, r) {
    const n = e.getHours();
    let o;
    switch (n >= 17 ? o = $o.evening : n >= 12 ? o = $o.afternoon : n >= 4 ? o = $o.morning : o = $o.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, r) {
    if (t === "ho") {
      let n = e.getHours() % 12;
      return n === 0 && (n = 12), r.ordinalNumber(n, { unit: "hour" });
    }
    return zn.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, r) {
    return t === "Ho" ? r.ordinalNumber(e.getHours(), { unit: "hour" }) : zn.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, r) {
    const n = e.getHours() % 12;
    return t === "Ko" ? r.ordinalNumber(n, { unit: "hour" }) : it(n, t.length);
  },
  // Hour [1-24]
  k: function(e, t, r) {
    let n = e.getHours();
    return n === 0 && (n = 24), t === "ko" ? r.ordinalNumber(n, { unit: "hour" }) : it(n, t.length);
  },
  // Minute
  m: function(e, t, r) {
    return t === "mo" ? r.ordinalNumber(e.getMinutes(), { unit: "minute" }) : zn.m(e, t);
  },
  // Second
  s: function(e, t, r) {
    return t === "so" ? r.ordinalNumber(e.getSeconds(), { unit: "second" }) : zn.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return zn.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, r) {
    const n = e.getTimezoneOffset();
    if (n === 0)
      return "Z";
    switch (t) {
      case "X":
        return Hp(n);
      case "XXXX":
      case "XX":
        return mo(n);
      case "XXXXX":
      case "XXX":
      default:
        return mo(n, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "x":
        return Hp(n);
      case "xxxx":
      case "xx":
        return mo(n);
      case "xxxxx":
      case "xxx":
      default:
        return mo(n, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Up(n, ":");
      case "OOOO":
      default:
        return "GMT" + mo(n, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, r) {
    const n = e.getTimezoneOffset();
    switch (t) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Up(n, ":");
      case "zzzz":
      default:
        return "GMT" + mo(n, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, r) {
    const n = Math.trunc(e.getTime() / 1e3);
    return it(n, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, r) {
    const n = e.getTime();
    return it(n, t.length);
  }
};
function Up(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), o = Math.trunc(n / 60), a = n % 60;
  return a === 0 ? r + String(o) : r + String(o) + t + it(a, 2);
}
function Hp(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + it(Math.abs(e) / 60, 2) : mo(e, t);
}
function mo(e, t = "") {
  const r = e > 0 ? "-" : "+", n = Math.abs(e), o = it(Math.trunc(n / 60), 2), a = it(n % 60, 2);
  return r + o + t + a;
}
const Vp = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, Eg = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, f8 = (e, t) => {
  const r = e.match(/(P+)(p+)?/) || [], n = r[1], o = r[2];
  if (!o)
    return Vp(e, t);
  let a;
  switch (n) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", Vp(n, t)).replace("{{time}}", Eg(o, t));
}, p8 = {
  p: Eg,
  P: f8
}, m8 = /^D+$/, h8 = /^Y+$/, g8 = ["D", "DD", "YY", "YYYY"];
function v8(e) {
  return m8.test(e);
}
function y8(e) {
  return h8.test(e);
}
function b8(e, t, r) {
  const n = w8(e, t, r);
  if (console.warn(n), g8.includes(e)) throw new RangeError(n);
}
function w8(e, t, r) {
  const n = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${n} to the input \`${r}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const x8 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, _8 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, S8 = /^'([^]*?)'?$/, E8 = /''/g, T8 = /[a-zA-Z]/;
function Mo(e, t, r) {
  var c, p, d, f, m, v, h, _;
  const n = Bi(), o = (r == null ? void 0 : r.locale) ?? n.locale ?? wg, a = (r == null ? void 0 : r.firstWeekContainsDate) ?? ((p = (c = r == null ? void 0 : r.locale) == null ? void 0 : c.options) == null ? void 0 : p.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((f = (d = n.locale) == null ? void 0 : d.options) == null ? void 0 : f.firstWeekContainsDate) ?? 1, i = (r == null ? void 0 : r.weekStartsOn) ?? ((v = (m = r == null ? void 0 : r.locale) == null ? void 0 : m.options) == null ? void 0 : v.weekStartsOn) ?? n.weekStartsOn ?? ((_ = (h = n.locale) == null ? void 0 : h.options) == null ? void 0 : _.weekStartsOn) ?? 0, s = Ve(e);
  if (!CD(s))
    throw new RangeError("Invalid time value");
  let l = t.match(_8).map((g) => {
    const b = g[0];
    if (b === "p" || b === "P") {
      const x = p8[b];
      return x(g, o.formatLong);
    }
    return g;
  }).join("").match(x8).map((g) => {
    if (g === "''")
      return { isToken: !1, value: "'" };
    const b = g[0];
    if (b === "'")
      return { isToken: !1, value: k8(g) };
    if (jp[b])
      return { isToken: !0, value: g };
    if (b.match(T8))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + b + "`"
      );
    return { isToken: !1, value: g };
  });
  o.localize.preprocessor && (l = o.localize.preprocessor(s, l));
  const u = {
    firstWeekContainsDate: a,
    weekStartsOn: i,
    locale: o
  };
  return l.map((g) => {
    if (!g.isToken) return g.value;
    const b = g.value;
    (!(r != null && r.useAdditionalWeekYearTokens) && y8(b) || !(r != null && r.useAdditionalDayOfYearTokens) && v8(b)) && b8(b, t, String(e));
    const x = jp[b[0]];
    return x(s, b, o.localize, u);
  }).join("");
}
function k8(e) {
  const t = e.match(S8);
  return t ? t[1].replace(E8, "'") : e;
}
function O8(e) {
  const t = Ve(e), r = t.getFullYear(), n = t.getMonth(), o = br(e, 0);
  return o.setFullYear(r, n + 1, 0), o.setHours(0, 0, 0, 0), o.getDate();
}
function D8(e) {
  return Math.trunc(+Ve(e) / 1e3);
}
function N8(e) {
  const t = Ve(e), r = t.getMonth();
  return t.setFullYear(t.getFullYear(), r + 1, 0), t.setHours(0, 0, 0, 0), t;
}
function C8(e, t) {
  return PD(
    N8(e),
    lr(e),
    t
  ) + 1;
}
function iu(e, t) {
  const r = Ve(e), n = Ve(t);
  return r.getTime() > n.getTime();
}
function Tg(e, t) {
  const r = Ve(e), n = Ve(t);
  return +r < +n;
}
function Bd(e, t) {
  const r = Ve(e), n = Ve(t);
  return r.getFullYear() === n.getFullYear() && r.getMonth() === n.getMonth();
}
function P8(e, t) {
  const r = Ve(e), n = Ve(t);
  return r.getFullYear() === n.getFullYear();
}
function hc(e, t) {
  return Zt(e, -t);
}
function gc(e, t) {
  const r = Ve(e), n = r.getFullYear(), o = r.getDate(), a = br(e, 0);
  a.setFullYear(n, t, 15), a.setHours(0, 0, 0, 0);
  const i = O8(a);
  return r.setMonth(t, Math.min(o, i)), r;
}
function zp(e, t) {
  const r = Ve(e);
  return isNaN(+r) ? br(e, NaN) : (r.setFullYear(t), r);
}
var Te = function() {
  return Te = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, Te.apply(this, arguments);
};
function M8(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function kg(e, t, r) {
  for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
function ji(e) {
  return e.mode === "multiple";
}
function Ui(e) {
  return e.mode === "range";
}
function Nl(e) {
  return e.mode === "single";
}
var R8 = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function A8(e, t) {
  return Mo(e, "LLLL y", t);
}
function I8(e, t) {
  return Mo(e, "d", t);
}
function F8(e, t) {
  return Mo(e, "LLLL", t);
}
function L8(e) {
  return "".concat(e);
}
function $8(e, t) {
  return Mo(e, "cccccc", t);
}
function W8(e, t) {
  return Mo(e, "yyyy", t);
}
var Y8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: A8,
  formatDay: I8,
  formatMonthCaption: F8,
  formatWeekNumber: L8,
  formatWeekdayName: $8,
  formatYearCaption: W8
}), B8 = function(e, t, r) {
  return Mo(e, "do MMMM (EEEE)", r);
}, j8 = function() {
  return "Month: ";
}, U8 = function() {
  return "Go to next month";
}, H8 = function() {
  return "Go to previous month";
}, V8 = function(e, t) {
  return Mo(e, "cccc", t);
}, z8 = function(e) {
  return "Week n. ".concat(e);
}, q8 = function() {
  return "Year: ";
}, G8 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: B8,
  labelMonthDropdown: j8,
  labelNext: U8,
  labelPrevious: H8,
  labelWeekNumber: z8,
  labelWeekday: V8,
  labelYearDropdown: q8
});
function Q8() {
  var e = "buttons", t = R8, r = wg, n = {}, o = {}, a = 1, i = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: e,
    classNames: t,
    formatters: Y8,
    labels: G8,
    locale: r,
    modifiersClassNames: n,
    modifiers: o,
    numberOfMonths: a,
    styles: i,
    today: s,
    mode: "default"
  };
}
function K8(e) {
  var t = e.fromYear, r = e.toYear, n = e.fromMonth, o = e.toMonth, a = e.fromDate, i = e.toDate;
  return n ? a = lr(n) : t && (a = new Date(t, 0, 1)), o ? i = Wd(o) : r && (i = new Date(r, 11, 31)), {
    fromDate: a ? ta(a) : void 0,
    toDate: i ? ta(i) : void 0
  };
}
var Og = $e(void 0);
function X8(e) {
  var t, r = e.initialProps, n = Q8(), o = K8(r), a = o.fromDate, i = o.toDate, s = (t = r.captionLayout) !== null && t !== void 0 ? t : n.captionLayout;
  s !== "buttons" && (!a || !i) && (s = "buttons");
  var l;
  (Nl(r) || ji(r) || Ui(r)) && (l = r.onSelect);
  var u = Te(Te(Te({}, n), r), { captionLayout: s, classNames: Te(Te({}, n.classNames), r.classNames), components: Te({}, r.components), formatters: Te(Te({}, n.formatters), r.formatters), fromDate: a, labels: Te(Te({}, n.labels), r.labels), mode: r.mode || n.mode, modifiers: Te(Te({}, n.modifiers), r.modifiers), modifiersClassNames: Te(Te({}, n.modifiersClassNames), r.modifiersClassNames), onSelect: l, styles: Te(Te({}, n.styles), r.styles), toDate: i });
  return L(Og.Provider, { value: u, children: e.children });
}
function pt() {
  var e = Oe(Og);
  if (!e)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return e;
}
function Dg(e) {
  var t = pt(), r = t.locale, n = t.classNames, o = t.styles, a = t.formatters.formatCaption;
  return L("div", { className: n.caption_label, style: o.caption_label, "aria-live": "polite", role: "presentation", id: e.id, children: a(e.displayMonth, { locale: r }) });
}
function Z8(e) {
  return L("svg", Te({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, e, { children: L("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function Ng(e) {
  var t, r, n = e.onChange, o = e.value, a = e.children, i = e.caption, s = e.className, l = e.style, u = pt(), c = (r = (t = u.components) === null || t === void 0 ? void 0 : t.IconDropdown) !== null && r !== void 0 ? r : Z8;
  return ue("div", { className: s, style: l, children: [L("span", { className: u.classNames.vhidden, children: e["aria-label"] }), L("select", { name: e.name, "aria-label": e["aria-label"], className: u.classNames.dropdown, style: u.styles.dropdown, value: o, onChange: n, children: a }), ue("div", { className: u.classNames.caption_label, style: u.styles.caption_label, "aria-hidden": "true", children: [i, L(c, { className: u.classNames.dropdown_icon, style: u.styles.dropdown_icon })] })] });
}
function J8(e) {
  var t, r = pt(), n = r.fromDate, o = r.toDate, a = r.styles, i = r.locale, s = r.formatters.formatMonthCaption, l = r.classNames, u = r.components, c = r.labels.labelMonthDropdown;
  if (!n)
    return L(Gt, {});
  if (!o)
    return L(Gt, {});
  var p = [];
  if (P8(n, o))
    for (var d = lr(n), f = n.getMonth(); f <= o.getMonth(); f++)
      p.push(gc(d, f));
  else
    for (var d = lr(/* @__PURE__ */ new Date()), f = 0; f <= 11; f++)
      p.push(gc(d, f));
  var m = function(h) {
    var _ = Number(h.target.value), g = gc(lr(e.displayMonth), _);
    e.onChange(g);
  }, v = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : Ng;
  return L(v, { name: "months", "aria-label": c(), className: l.dropdown_month, style: a.dropdown_month, onChange: m, value: e.displayMonth.getMonth(), caption: s(e.displayMonth, { locale: i }), children: p.map(function(h) {
    return L("option", { value: h.getMonth(), children: s(h, { locale: i }) }, h.getMonth());
  }) });
}
function eN(e) {
  var t, r = e.displayMonth, n = pt(), o = n.fromDate, a = n.toDate, i = n.locale, s = n.styles, l = n.classNames, u = n.components, c = n.formatters.formatYearCaption, p = n.labels.labelYearDropdown, d = [];
  if (!o)
    return L(Gt, {});
  if (!a)
    return L(Gt, {});
  for (var f = o.getFullYear(), m = a.getFullYear(), v = f; v <= m; v++)
    d.push(zp(yg(/* @__PURE__ */ new Date()), v));
  var h = function(g) {
    var b = zp(lr(r), Number(g.target.value));
    e.onChange(b);
  }, _ = (t = u == null ? void 0 : u.Dropdown) !== null && t !== void 0 ? t : Ng;
  return L(_, { name: "years", "aria-label": p(), className: l.dropdown_year, style: s.dropdown_year, onChange: h, value: r.getFullYear(), caption: c(r, { locale: i }), children: d.map(function(g) {
    return L("option", { value: g.getFullYear(), children: c(g, { locale: i }) }, g.getFullYear());
  }) });
}
function tN(e, t) {
  var r = me(e), n = r[0], o = r[1], a = t === void 0 ? n : t;
  return [a, o];
}
function rN(e) {
  var t = e.month, r = e.defaultMonth, n = e.today, o = t || r || n || /* @__PURE__ */ new Date(), a = e.toDate, i = e.fromDate, s = e.numberOfMonths, l = s === void 0 ? 1 : s;
  if (a && li(a, o) < 0) {
    var u = -1 * (l - 1);
    o = zr(a, u);
  }
  return i && li(o, i) < 0 && (o = i), lr(o);
}
function nN() {
  var e = pt(), t = rN(e), r = tN(t, e.month), n = r[0], o = r[1], a = function(i) {
    var s;
    if (!e.disableNavigation) {
      var l = lr(i);
      o(l), (s = e.onMonthChange) === null || s === void 0 || s.call(e, l);
    }
  };
  return [n, a];
}
function oN(e, t) {
  for (var r = t.reverseMonths, n = t.numberOfMonths, o = lr(e), a = lr(zr(o, n)), i = li(a, o), s = [], l = 0; l < i; l++) {
    var u = zr(o, l);
    s.push(u);
  }
  return r && (s = s.reverse()), s;
}
function aN(e, t) {
  if (!t.disableNavigation) {
    var r = t.toDate, n = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = n ? a : 1, s = lr(e);
    if (!r)
      return zr(s, i);
    var l = li(r, e);
    if (!(l < a))
      return zr(s, i);
  }
}
function iN(e, t) {
  if (!t.disableNavigation) {
    var r = t.fromDate, n = t.pagedNavigation, o = t.numberOfMonths, a = o === void 0 ? 1 : o, i = n ? a : 1, s = lr(e);
    if (!r)
      return zr(s, -i);
    var l = li(s, r);
    if (!(l <= 0))
      return zr(s, -i);
  }
}
var Cg = $e(void 0);
function sN(e) {
  var t = pt(), r = nN(), n = r[0], o = r[1], a = oN(n, t), i = aN(n, t), s = iN(n, t), l = function(p) {
    return a.some(function(d) {
      return Bd(p, d);
    });
  }, u = function(p, d) {
    l(p) || (d && Tg(p, d) ? o(zr(p, 1 + t.numberOfMonths * -1)) : o(p));
  }, c = {
    currentMonth: n,
    displayMonths: a,
    goToMonth: o,
    goToDate: u,
    previousMonth: s,
    nextMonth: i,
    isDateDisplayed: l
  };
  return L(Cg.Provider, { value: c, children: e.children });
}
function Hi() {
  var e = Oe(Cg);
  if (!e)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return e;
}
function qp(e) {
  var t, r = pt(), n = r.classNames, o = r.styles, a = r.components, i = Hi().goToMonth, s = function(c) {
    i(zr(c, e.displayIndex ? -e.displayIndex : 0));
  }, l = (t = a == null ? void 0 : a.CaptionLabel) !== null && t !== void 0 ? t : Dg, u = L(l, { id: e.id, displayMonth: e.displayMonth });
  return ue("div", { className: n.caption_dropdowns, style: o.caption_dropdowns, children: [L("div", { className: n.vhidden, children: u }), L(J8, { onChange: s, displayMonth: e.displayMonth }), L(eN, { onChange: s, displayMonth: e.displayMonth })] });
}
function lN(e) {
  return L("svg", Te({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: L("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function cN(e) {
  return L("svg", Te({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, e, { children: L("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var zs = na(function(e, t) {
  var r = pt(), n = r.classNames, o = r.styles, a = [n.button_reset, n.button];
  e.className && a.push(e.className);
  var i = a.join(" "), s = Te(Te({}, o.button_reset), o.button);
  return e.style && Object.assign(s, e.style), L("button", Te({}, e, { ref: t, type: "button", className: i, style: s }));
});
function uN(e) {
  var t, r, n = pt(), o = n.dir, a = n.locale, i = n.classNames, s = n.styles, l = n.labels, u = l.labelPrevious, c = l.labelNext, p = n.components;
  if (!e.nextMonth && !e.previousMonth)
    return L(Gt, {});
  var d = u(e.previousMonth, { locale: a }), f = [
    i.nav_button,
    i.nav_button_previous
  ].join(" "), m = c(e.nextMonth, { locale: a }), v = [
    i.nav_button,
    i.nav_button_next
  ].join(" "), h = (t = p == null ? void 0 : p.IconRight) !== null && t !== void 0 ? t : cN, _ = (r = p == null ? void 0 : p.IconLeft) !== null && r !== void 0 ? r : lN;
  return ue("div", { className: i.nav, style: s.nav, children: [!e.hidePrevious && L(zs, { name: "previous-month", "aria-label": d, className: f, style: s.nav_button_previous, disabled: !e.previousMonth, onClick: e.onPreviousClick, children: o === "rtl" ? L(h, { className: i.nav_icon, style: s.nav_icon }) : L(_, { className: i.nav_icon, style: s.nav_icon }) }), !e.hideNext && L(zs, { name: "next-month", "aria-label": m, className: v, style: s.nav_button_next, disabled: !e.nextMonth, onClick: e.onNextClick, children: o === "rtl" ? L(_, { className: i.nav_icon, style: s.nav_icon }) : L(h, { className: i.nav_icon, style: s.nav_icon }) })] });
}
function Gp(e) {
  var t = pt().numberOfMonths, r = Hi(), n = r.previousMonth, o = r.nextMonth, a = r.goToMonth, i = r.displayMonths, s = i.findIndex(function(m) {
    return Bd(e.displayMonth, m);
  }), l = s === 0, u = s === i.length - 1, c = t > 1 && (l || !u), p = t > 1 && (u || !l), d = function() {
    n && a(n);
  }, f = function() {
    o && a(o);
  };
  return L(uN, { displayMonth: e.displayMonth, hideNext: c, hidePrevious: p, nextMonth: o, previousMonth: n, onPreviousClick: d, onNextClick: f });
}
function dN(e) {
  var t, r = pt(), n = r.classNames, o = r.disableNavigation, a = r.styles, i = r.captionLayout, s = r.components, l = (t = s == null ? void 0 : s.CaptionLabel) !== null && t !== void 0 ? t : Dg, u;
  return o ? u = L(l, { id: e.id, displayMonth: e.displayMonth }) : i === "dropdown" ? u = L(qp, { displayMonth: e.displayMonth, id: e.id }) : i === "dropdown-buttons" ? u = ue(Gt, { children: [L(qp, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id }), L(Gp, { displayMonth: e.displayMonth, displayIndex: e.displayIndex, id: e.id })] }) : u = ue(Gt, { children: [L(l, { id: e.id, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), L(Gp, { displayMonth: e.displayMonth, id: e.id })] }), L("div", { className: n.caption, style: a.caption, children: u });
}
function fN(e) {
  var t = pt(), r = t.footer, n = t.styles, o = t.classNames.tfoot;
  return r ? L("tfoot", { className: o, style: n.tfoot, children: L("tr", { children: L("td", { colSpan: 8, children: r }) }) }) : L(Gt, {});
}
function pN(e, t, r) {
  for (var n = r ? No(/* @__PURE__ */ new Date()) : fn(/* @__PURE__ */ new Date(), { locale: e, weekStartsOn: t }), o = [], a = 0; a < 7; a++) {
    var i = Zt(n, a);
    o.push(i);
  }
  return o;
}
function mN() {
  var e = pt(), t = e.classNames, r = e.styles, n = e.showWeekNumber, o = e.locale, a = e.weekStartsOn, i = e.ISOWeek, s = e.formatters.formatWeekdayName, l = e.labels.labelWeekday, u = pN(o, a, i);
  return ue("tr", { style: r.head_row, className: t.head_row, children: [n && L("td", { style: r.head_cell, className: t.head_cell }), u.map(function(c, p) {
    return L("th", { scope: "col", className: t.head_cell, style: r.head_cell, "aria-label": l(c, { locale: o }), children: s(c, { locale: o }) }, p);
  })] });
}
function hN() {
  var e, t = pt(), r = t.classNames, n = t.styles, o = t.components, a = (e = o == null ? void 0 : o.HeadRow) !== null && e !== void 0 ? e : mN;
  return L("thead", { style: n.head, className: r.head, children: L(a, {}) });
}
function gN(e) {
  var t = pt(), r = t.locale, n = t.formatters.formatDay;
  return L(Gt, { children: n(e.date, { locale: r }) });
}
var jd = $e(void 0);
function vN(e) {
  if (!ji(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return L(jd.Provider, { value: t, children: e.children });
  }
  return L(yN, { initialProps: e.initialProps, children: e.children });
}
function yN(e) {
  var t = e.initialProps, r = e.children, n = t.selected, o = t.min, a = t.max, i = function(u, c, p) {
    var d, f;
    (d = t.onDayClick) === null || d === void 0 || d.call(t, u, c, p);
    var m = !!(c.selected && o && (n == null ? void 0 : n.length) === o);
    if (!m) {
      var v = !!(!c.selected && a && (n == null ? void 0 : n.length) === a);
      if (!v) {
        var h = n ? kg([], n) : [];
        if (c.selected) {
          var _ = h.findIndex(function(g) {
            return sr(u, g);
          });
          h.splice(_, 1);
        } else
          h.push(u);
        (f = t.onSelect) === null || f === void 0 || f.call(t, h, u, c, p);
      }
    }
  }, s = {
    disabled: []
  };
  n && s.disabled.push(function(u) {
    var c = a && n.length > a - 1, p = n.some(function(d) {
      return sr(d, u);
    });
    return !!(c && !p);
  });
  var l = {
    selected: n,
    onDayClick: i,
    modifiers: s
  };
  return L(jd.Provider, { value: l, children: r });
}
function Ud() {
  var e = Oe(jd);
  if (!e)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return e;
}
function bN(e, t) {
  var r = t || {}, n = r.from, o = r.to;
  return n && o ? sr(o, e) && sr(n, e) ? void 0 : sr(o, e) ? { from: o, to: void 0 } : sr(n, e) ? void 0 : iu(n, e) ? { from: e, to: o } : { from: n, to: e } : o ? iu(e, o) ? { from: o, to: e } : { from: e, to: o } : n ? Tg(e, n) ? { from: e, to: n } : { from: n, to: e } : { from: e, to: void 0 };
}
var Hd = $e(void 0);
function wN(e) {
  if (!Ui(e.initialProps)) {
    var t = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return L(Hd.Provider, { value: t, children: e.children });
  }
  return L(xN, { initialProps: e.initialProps, children: e.children });
}
function xN(e) {
  var t = e.initialProps, r = e.children, n = t.selected, o = n || {}, a = o.from, i = o.to, s = t.min, l = t.max, u = function(f, m, v) {
    var h, _;
    (h = t.onDayClick) === null || h === void 0 || h.call(t, f, m, v);
    var g = bN(f, n);
    (_ = t.onSelect) === null || _ === void 0 || _.call(t, g, f, m, v);
  }, c = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (a ? (c.range_start = [a], i ? (c.range_end = [i], sr(a, i) || (c.range_middle = [
    {
      after: a,
      before: i
    }
  ])) : c.range_end = [a]) : i && (c.range_start = [i], c.range_end = [i]), s && (a && !i && c.disabled.push({
    after: hc(a, s - 1),
    before: Zt(a, s - 1)
  }), a && i && c.disabled.push({
    after: a,
    before: Zt(a, s - 1)
  }), !a && i && c.disabled.push({
    after: hc(i, s - 1),
    before: Zt(i, s - 1)
  })), l) {
    if (a && !i && (c.disabled.push({
      before: Zt(a, -l + 1)
    }), c.disabled.push({
      after: Zt(a, l - 1)
    })), a && i) {
      var p = on(i, a) + 1, d = l - p;
      c.disabled.push({
        before: hc(a, d)
      }), c.disabled.push({
        after: Zt(i, d)
      });
    }
    !a && i && (c.disabled.push({
      before: Zt(i, -l + 1)
    }), c.disabled.push({
      after: Zt(i, l - 1)
    }));
  }
  return L(Hd.Provider, { value: { selected: n, onDayClick: u, modifiers: c }, children: r });
}
function Vd() {
  var e = Oe(Hd);
  if (!e)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return e;
}
function Ss(e) {
  return Array.isArray(e) ? kg([], e) : e !== void 0 ? [e] : [];
}
function _N(e) {
  var t = {};
  return Object.entries(e).forEach(function(r) {
    var n = r[0], o = r[1];
    t[n] = Ss(o);
  }), t;
}
var qr;
(function(e) {
  e.Outside = "outside", e.Disabled = "disabled", e.Selected = "selected", e.Hidden = "hidden", e.Today = "today", e.RangeStart = "range_start", e.RangeEnd = "range_end", e.RangeMiddle = "range_middle";
})(qr || (qr = {}));
var SN = qr.Selected, Sn = qr.Disabled, EN = qr.Hidden, TN = qr.Today, vc = qr.RangeEnd, yc = qr.RangeMiddle, bc = qr.RangeStart, kN = qr.Outside;
function ON(e, t, r) {
  var n, o = (n = {}, n[SN] = Ss(e.selected), n[Sn] = Ss(e.disabled), n[EN] = Ss(e.hidden), n[TN] = [e.today], n[vc] = [], n[yc] = [], n[bc] = [], n[kN] = [], n);
  return e.fromDate && o[Sn].push({ before: e.fromDate }), e.toDate && o[Sn].push({ after: e.toDate }), ji(e) ? o[Sn] = o[Sn].concat(t.modifiers[Sn]) : Ui(e) && (o[Sn] = o[Sn].concat(r.modifiers[Sn]), o[bc] = r.modifiers[bc], o[yc] = r.modifiers[yc], o[vc] = r.modifiers[vc]), o;
}
var Pg = $e(void 0);
function DN(e) {
  var t = pt(), r = Ud(), n = Vd(), o = ON(t, r, n), a = _N(t.modifiers), i = Te(Te({}, o), a);
  return L(Pg.Provider, { value: i, children: e.children });
}
function Mg() {
  var e = Oe(Pg);
  if (!e)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return e;
}
function NN(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function CN(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function PN(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function MN(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function RN(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function AN(e, t) {
  var r, n = t.from, o = t.to;
  if (n && o) {
    var a = on(o, n) < 0;
    a && (r = [o, n], n = r[0], o = r[1]);
    var i = on(e, n) >= 0 && on(o, e) >= 0;
    return i;
  }
  return o ? sr(o, e) : n ? sr(n, e) : !1;
}
function IN(e) {
  return $d(e);
}
function FN(e) {
  return Array.isArray(e) && e.every($d);
}
function LN(e, t) {
  return t.some(function(r) {
    if (typeof r == "boolean")
      return r;
    if (IN(r))
      return sr(e, r);
    if (FN(r))
      return r.includes(e);
    if (CN(r))
      return AN(e, r);
    if (RN(r))
      return r.dayOfWeek.includes(e.getDay());
    if (NN(r)) {
      var n = on(r.before, e), o = on(r.after, e), a = n > 0, i = o < 0, s = iu(r.before, r.after);
      return s ? i && a : a || i;
    }
    return PN(r) ? on(e, r.after) > 0 : MN(r) ? on(r.before, e) > 0 : typeof r == "function" ? r(e) : !1;
  });
}
function zd(e, t, r) {
  var n = Object.keys(t).reduce(function(a, i) {
    var s = t[i];
    return LN(e, s) && a.push(i), a;
  }, []), o = {};
  return n.forEach(function(a) {
    return o[a] = !0;
  }), r && !Bd(e, r) && (o.outside = !0), o;
}
function $N(e, t) {
  for (var r = lr(e[0]), n = Wd(e[e.length - 1]), o, a, i = r; i <= n; ) {
    var s = zd(i, t), l = !s.disabled && !s.hidden;
    if (!l) {
      i = Zt(i, 1);
      continue;
    }
    if (s.selected)
      return i;
    s.today && !a && (a = i), o || (o = i), i = Zt(i, 1);
  }
  return a || o;
}
var WN = 365;
function Rg(e, t) {
  var r = t.moveBy, n = t.direction, o = t.context, a = t.modifiers, i = t.retry, s = i === void 0 ? { count: 0, lastFocused: e } : i, l = o.weekStartsOn, u = o.fromDate, c = o.toDate, p = o.locale, d = {
    day: Zt,
    week: au,
    month: zr,
    year: OD,
    startOfWeek: function(h) {
      return o.ISOWeek ? No(h) : fn(h, { locale: p, weekStartsOn: l });
    },
    endOfWeek: function(h) {
      return o.ISOWeek ? bg(h) : Yd(h, { locale: p, weekStartsOn: l });
    }
  }, f = d[r](e, n === "after" ? 1 : -1);
  n === "before" && u ? f = DD([u, f]) : n === "after" && c && (f = ND([c, f]));
  var m = !0;
  if (a) {
    var v = zd(f, a);
    m = !v.disabled && !v.hidden;
  }
  return m ? f : s.count > WN ? s.lastFocused : Rg(f, {
    moveBy: r,
    direction: n,
    context: o,
    modifiers: a,
    retry: Te(Te({}, s), { count: s.count + 1 })
  });
}
var Ag = $e(void 0);
function YN(e) {
  var t = Hi(), r = Mg(), n = me(), o = n[0], a = n[1], i = me(), s = i[0], l = i[1], u = $N(t.displayMonths, r), c = o ?? (s && t.isDateDisplayed(s)) ? s : u, p = function() {
    l(o), a(void 0);
  }, d = function(h) {
    a(h);
  }, f = pt(), m = function(h, _) {
    if (o) {
      var g = Rg(o, {
        moveBy: h,
        direction: _,
        context: f,
        modifiers: r
      });
      sr(o, g) || (t.goToDate(g, o), d(g));
    }
  }, v = {
    focusedDay: o,
    focusTarget: c,
    blur: p,
    focus: d,
    focusDayAfter: function() {
      return m("day", "after");
    },
    focusDayBefore: function() {
      return m("day", "before");
    },
    focusWeekAfter: function() {
      return m("week", "after");
    },
    focusWeekBefore: function() {
      return m("week", "before");
    },
    focusMonthBefore: function() {
      return m("month", "before");
    },
    focusMonthAfter: function() {
      return m("month", "after");
    },
    focusYearBefore: function() {
      return m("year", "before");
    },
    focusYearAfter: function() {
      return m("year", "after");
    },
    focusStartOfWeek: function() {
      return m("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return m("endOfWeek", "after");
    }
  };
  return L(Ag.Provider, { value: v, children: e.children });
}
function qd() {
  var e = Oe(Ag);
  if (!e)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return e;
}
function BN(e, t) {
  var r = Mg(), n = zd(e, r, t);
  return n;
}
var Gd = $e(void 0);
function jN(e) {
  if (!Nl(e.initialProps)) {
    var t = {
      selected: void 0
    };
    return L(Gd.Provider, { value: t, children: e.children });
  }
  return L(UN, { initialProps: e.initialProps, children: e.children });
}
function UN(e) {
  var t = e.initialProps, r = e.children, n = function(a, i, s) {
    var l, u, c;
    if ((l = t.onDayClick) === null || l === void 0 || l.call(t, a, i, s), i.selected && !t.required) {
      (u = t.onSelect) === null || u === void 0 || u.call(t, void 0, a, i, s);
      return;
    }
    (c = t.onSelect) === null || c === void 0 || c.call(t, a, a, i, s);
  }, o = {
    selected: t.selected,
    onDayClick: n
  };
  return L(Gd.Provider, { value: o, children: r });
}
function Ig() {
  var e = Oe(Gd);
  if (!e)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return e;
}
function HN(e, t) {
  var r = pt(), n = Ig(), o = Ud(), a = Vd(), i = qd(), s = i.focusDayAfter, l = i.focusDayBefore, u = i.focusWeekAfter, c = i.focusWeekBefore, p = i.blur, d = i.focus, f = i.focusMonthBefore, m = i.focusMonthAfter, v = i.focusYearBefore, h = i.focusYearAfter, _ = i.focusStartOfWeek, g = i.focusEndOfWeek, b = function(D) {
    var N, M, W, B;
    Nl(r) ? (N = n.onDayClick) === null || N === void 0 || N.call(n, e, t, D) : ji(r) ? (M = o.onDayClick) === null || M === void 0 || M.call(o, e, t, D) : Ui(r) ? (W = a.onDayClick) === null || W === void 0 || W.call(a, e, t, D) : (B = r.onDayClick) === null || B === void 0 || B.call(r, e, t, D);
  }, x = function(D) {
    var N;
    d(e), (N = r.onDayFocus) === null || N === void 0 || N.call(r, e, t, D);
  }, E = function(D) {
    var N;
    p(), (N = r.onDayBlur) === null || N === void 0 || N.call(r, e, t, D);
  }, O = function(D) {
    var N;
    (N = r.onDayMouseEnter) === null || N === void 0 || N.call(r, e, t, D);
  }, P = function(D) {
    var N;
    (N = r.onDayMouseLeave) === null || N === void 0 || N.call(r, e, t, D);
  }, y = function(D) {
    var N;
    (N = r.onDayPointerEnter) === null || N === void 0 || N.call(r, e, t, D);
  }, w = function(D) {
    var N;
    (N = r.onDayPointerLeave) === null || N === void 0 || N.call(r, e, t, D);
  }, S = function(D) {
    var N;
    (N = r.onDayTouchCancel) === null || N === void 0 || N.call(r, e, t, D);
  }, k = function(D) {
    var N;
    (N = r.onDayTouchEnd) === null || N === void 0 || N.call(r, e, t, D);
  }, T = function(D) {
    var N;
    (N = r.onDayTouchMove) === null || N === void 0 || N.call(r, e, t, D);
  }, R = function(D) {
    var N;
    (N = r.onDayTouchStart) === null || N === void 0 || N.call(r, e, t, D);
  }, I = function(D) {
    var N;
    (N = r.onDayKeyUp) === null || N === void 0 || N.call(r, e, t, D);
  }, C = function(D) {
    var N;
    switch (D.key) {
      case "ArrowLeft":
        D.preventDefault(), D.stopPropagation(), r.dir === "rtl" ? s() : l();
        break;
      case "ArrowRight":
        D.preventDefault(), D.stopPropagation(), r.dir === "rtl" ? l() : s();
        break;
      case "ArrowDown":
        D.preventDefault(), D.stopPropagation(), u();
        break;
      case "ArrowUp":
        D.preventDefault(), D.stopPropagation(), c();
        break;
      case "PageUp":
        D.preventDefault(), D.stopPropagation(), D.shiftKey ? v() : f();
        break;
      case "PageDown":
        D.preventDefault(), D.stopPropagation(), D.shiftKey ? h() : m();
        break;
      case "Home":
        D.preventDefault(), D.stopPropagation(), _();
        break;
      case "End":
        D.preventDefault(), D.stopPropagation(), g();
        break;
    }
    (N = r.onDayKeyDown) === null || N === void 0 || N.call(r, e, t, D);
  }, A = {
    onClick: b,
    onFocus: x,
    onBlur: E,
    onKeyDown: C,
    onKeyUp: I,
    onMouseEnter: O,
    onMouseLeave: P,
    onPointerEnter: y,
    onPointerLeave: w,
    onTouchCancel: S,
    onTouchEnd: k,
    onTouchMove: T,
    onTouchStart: R
  };
  return A;
}
function VN() {
  var e = pt(), t = Ig(), r = Ud(), n = Vd(), o = Nl(e) ? t.selected : ji(e) ? r.selected : Ui(e) ? n.selected : void 0;
  return o;
}
function zN(e) {
  return Object.values(qr).includes(e);
}
function qN(e, t) {
  var r = [e.classNames.day];
  return Object.keys(t).forEach(function(n) {
    var o = e.modifiersClassNames[n];
    if (o)
      r.push(o);
    else if (zN(n)) {
      var a = e.classNames["day_".concat(n)];
      a && r.push(a);
    }
  }), r;
}
function GN(e, t) {
  var r = Te({}, e.styles.day);
  return Object.keys(t).forEach(function(n) {
    var o;
    r = Te(Te({}, r), (o = e.modifiersStyles) === null || o === void 0 ? void 0 : o[n]);
  }), r;
}
function QN(e, t, r) {
  var n, o, a, i = pt(), s = qd(), l = BN(e, t), u = HN(e, l), c = VN(), p = !!(i.onDayClick || i.mode !== "default");
  ge(function() {
    var O;
    l.outside || s.focusedDay && p && sr(s.focusedDay, e) && ((O = r.current) === null || O === void 0 || O.focus());
  }, [
    s.focusedDay,
    e,
    r,
    p,
    l.outside
  ]);
  var d = qN(i, l).join(" "), f = GN(i, l), m = !!(l.outside && !i.showOutsideDays || l.hidden), v = (a = (o = i.components) === null || o === void 0 ? void 0 : o.DayContent) !== null && a !== void 0 ? a : gN, h = L(v, { date: e, displayMonth: t, activeModifiers: l }), _ = {
    style: f,
    className: d,
    children: h,
    role: "gridcell"
  }, g = s.focusTarget && sr(s.focusTarget, e) && !l.outside, b = s.focusedDay && sr(s.focusedDay, e), x = Te(Te(Te({}, _), (n = { disabled: l.disabled, role: "gridcell" }, n["aria-selected"] = l.selected, n.tabIndex = b || g ? 0 : -1, n)), u), E = {
    isButton: p,
    isHidden: m,
    activeModifiers: l,
    selectedDays: c,
    buttonProps: x,
    divProps: _
  };
  return E;
}
function KN(e) {
  var t = ce(null), r = QN(e.date, e.displayMonth, t);
  return r.isHidden ? L("div", { role: "gridcell" }) : r.isButton ? L(zs, Te({ name: "day", ref: t }, r.buttonProps)) : L("div", Te({}, r.divProps));
}
function XN(e) {
  var t = e.number, r = e.dates, n = pt(), o = n.onWeekNumberClick, a = n.styles, i = n.classNames, s = n.locale, l = n.labels.labelWeekNumber, u = n.formatters.formatWeekNumber, c = u(Number(t), { locale: s });
  if (!o)
    return L("span", { className: i.weeknumber, style: a.weeknumber, children: c });
  var p = l(Number(t), { locale: s }), d = function(f) {
    o(t, r, f);
  };
  return L(zs, { name: "week-number", "aria-label": p, className: i.weeknumber, style: a.weeknumber, onClick: d, children: c });
}
function ZN(e) {
  var t, r, n = pt(), o = n.styles, a = n.classNames, i = n.showWeekNumber, s = n.components, l = (t = s == null ? void 0 : s.Day) !== null && t !== void 0 ? t : KN, u = (r = s == null ? void 0 : s.WeekNumber) !== null && r !== void 0 ? r : XN, c;
  return i && (c = L("td", { className: a.cell, style: o.cell, children: L(u, { number: e.weekNumber, dates: e.dates }) })), ue("tr", { className: a.row, style: o.row, children: [c, e.dates.map(function(p) {
    return L("td", { className: a.cell, style: o.cell, role: "presentation", children: L(l, { displayMonth: e.displayMonth, date: p }) }, D8(p));
  })] });
}
function Qp(e, t, r) {
  for (var n = r != null && r.ISOWeek ? bg(t) : Yd(t, r), o = r != null && r.ISOWeek ? No(e) : fn(e, r), a = on(n, o), i = [], s = 0; s <= a; s++)
    i.push(Zt(o, s));
  var l = i.reduce(function(u, c) {
    var p = r != null && r.ISOWeek ? xg(c) : Sg(c, r), d = u.find(function(f) {
      return f.weekNumber === p;
    });
    return d ? (d.dates.push(c), u) : (u.push({
      weekNumber: p,
      dates: [c]
    }), u);
  }, []);
  return l;
}
function JN(e, t) {
  var r = Qp(lr(e), Wd(e), t);
  if (t != null && t.useFixedWeeks) {
    var n = C8(e, t);
    if (n < 6) {
      var o = r[r.length - 1], a = o.dates[o.dates.length - 1], i = au(a, 6 - n), s = Qp(au(a, 1), i, t);
      r.push.apply(r, s);
    }
  }
  return r;
}
function eC(e) {
  var t, r, n, o = pt(), a = o.locale, i = o.classNames, s = o.styles, l = o.hideHead, u = o.fixedWeeks, c = o.components, p = o.weekStartsOn, d = o.firstWeekContainsDate, f = o.ISOWeek, m = JN(e.displayMonth, {
    useFixedWeeks: !!u,
    ISOWeek: f,
    locale: a,
    weekStartsOn: p,
    firstWeekContainsDate: d
  }), v = (t = c == null ? void 0 : c.Head) !== null && t !== void 0 ? t : hN, h = (r = c == null ? void 0 : c.Row) !== null && r !== void 0 ? r : ZN, _ = (n = c == null ? void 0 : c.Footer) !== null && n !== void 0 ? n : fN;
  return ue("table", { id: e.id, className: i.table, style: s.table, role: "grid", "aria-labelledby": e["aria-labelledby"], children: [!l && L(v, {}), L("tbody", { className: i.tbody, style: s.tbody, children: m.map(function(g) {
    return L(h, { displayMonth: e.displayMonth, dates: g.dates, weekNumber: g.weekNumber }, g.weekNumber);
  }) }), L(_, { displayMonth: e.displayMonth })] });
}
function tC() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var rC = tC() ? pi : ge, wc = !1, nC = 0;
function Kp() {
  return "react-day-picker-".concat(++nC);
}
function oC(e) {
  var t, r = e ?? (wc ? Kp() : null), n = me(r), o = n[0], a = n[1];
  return rC(function() {
    o === null && a(Kp());
  }, []), ge(function() {
    wc === !1 && (wc = !0);
  }, []), (t = e ?? o) !== null && t !== void 0 ? t : void 0;
}
function aC(e) {
  var t, r, n = pt(), o = n.dir, a = n.classNames, i = n.styles, s = n.components, l = Hi().displayMonths, u = oC(n.id ? "".concat(n.id, "-").concat(e.displayIndex) : void 0), c = n.id ? "".concat(n.id, "-grid-").concat(e.displayIndex) : void 0, p = [a.month], d = i.month, f = e.displayIndex === 0, m = e.displayIndex === l.length - 1, v = !f && !m;
  o === "rtl" && (t = [f, m], m = t[0], f = t[1]), f && (p.push(a.caption_start), d = Te(Te({}, d), i.caption_start)), m && (p.push(a.caption_end), d = Te(Te({}, d), i.caption_end)), v && (p.push(a.caption_between), d = Te(Te({}, d), i.caption_between));
  var h = (r = s == null ? void 0 : s.Caption) !== null && r !== void 0 ? r : dN;
  return ue("div", { className: p.join(" "), style: d, children: [L(h, { id: u, displayMonth: e.displayMonth, displayIndex: e.displayIndex }), L(eC, { id: c, "aria-labelledby": u, displayMonth: e.displayMonth })] }, e.displayIndex);
}
function iC(e) {
  var t = pt(), r = t.classNames, n = t.styles;
  return L("div", { className: r.months, style: n.months, children: e.children });
}
function sC(e) {
  var t, r, n = e.initialProps, o = pt(), a = qd(), i = Hi(), s = me(!1), l = s[0], u = s[1];
  ge(function() {
    o.initialFocus && a.focusTarget && (l || (a.focus(a.focusTarget), u(!0)));
  }, [
    o.initialFocus,
    l,
    a.focus,
    a.focusTarget,
    a
  ]);
  var c = [o.classNames.root, o.className];
  o.numberOfMonths > 1 && c.push(o.classNames.multiple_months), o.showWeekNumber && c.push(o.classNames.with_weeknumber);
  var p = Te(Te({}, o.styles.root), o.style), d = Object.keys(n).filter(function(m) {
    return m.startsWith("data-");
  }).reduce(function(m, v) {
    var h;
    return Te(Te({}, m), (h = {}, h[v] = n[v], h));
  }, {}), f = (r = (t = n.components) === null || t === void 0 ? void 0 : t.Months) !== null && r !== void 0 ? r : iC;
  return L("div", Te({ className: c.join(" "), style: p, dir: o.dir, id: o.id, nonce: n.nonce, title: n.title, lang: n.lang }, d, { children: L(f, { children: i.displayMonths.map(function(m, v) {
    return L(aC, { displayIndex: v, displayMonth: m }, v);
  }) }) }));
}
function lC(e) {
  var t = e.children, r = M8(e, ["children"]);
  return L(X8, { initialProps: r, children: L(sN, { children: L(jN, { initialProps: r, children: L(vN, { initialProps: r, children: L(wN, { initialProps: r, children: L(DN, { children: L(YN, { children: t }) }) }) }) }) }) });
}
function cC(e) {
  return L(lC, Te({}, e, { children: L(sC, { initialProps: e }) }));
}
function xM({
  range: e,
  setRange: t,
  fromYear: r,
  toYear: n,
  fromDate: o,
  fromMonth: a,
  toDate: i,
  toMonth: s,
  locale: l
}) {
  return /* @__PURE__ */ L(
    cC,
    {
      mode: "range",
      captionLayout: "dropdown-buttons",
      numberOfMonths: 1,
      showOutsideDays: !0,
      weekStartsOn: 1,
      selected: e,
      onSelect: t,
      fixedWeeks: !0,
      fromYear: r,
      toYear: n,
      modifiers: {
        today: [/* @__PURE__ */ new Date()]
      },
      modifiersClassNames: {
        today: "today"
      },
      fromMonth: a,
      toMonth: s,
      fromDate: o,
      toDate: i,
      locale: l
    }
  );
}
const uC = ({ t: e, classes: t, className: r, helperText: n, error: o, alwaysDisplay: a }) => {
  const { themeClasses: i } = Ge("FieldHelperText", t, r), s = a || !!n;
  return /* @__PURE__ */ ue(
    "div",
    {
      className: V("max-h-0", i == null ? void 0 : i.root, {
        "max-h-5": s
      }),
      children: [
        !!n && !a && /* @__PURE__ */ L("div", { className: V("h-5", i == null ? void 0 : i.helperText, o ? i == null ? void 0 : i.errorText : ""), children: ff(e, n) }),
        a && /* @__PURE__ */ L("div", { className: V("h-5", i == null ? void 0 : i.helperText, o ? i == null ? void 0 : i.errorText : ""), children: ff(e, n) })
      ]
    }
  );
}, Qd = uC;
var ct = function() {
  return ct = Object.assign || function(t) {
    for (var r, n = 1, o = arguments.length; n < o; n++) {
      r = arguments[n];
      for (var a in r) Object.prototype.hasOwnProperty.call(r, a) && (t[a] = r[a]);
    }
    return t;
  }, ct.apply(this, arguments);
};
function dC(e, t) {
  var r = {};
  for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, n = Object.getOwnPropertySymbols(e); o < n.length; o++)
      t.indexOf(n[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[o]) && (r[n[o]] = e[n[o]]);
  return r;
}
function fr(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, o = t.length, a; n < o; n++)
    (a || !(n in t)) && (a || (a = Array.prototype.slice.call(t, 0, n)), a[n] = t[n]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var pn = function(e) {
  return e.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}, fC = { k: 1e3, m: 1e6, b: 1e9 }, pC = function(e, t) {
  t === void 0 && (t = ".");
  var r = new RegExp("(\\d+(".concat(pn(t), "\\d*)?)([kmb])$"), "i"), n = e.match(r);
  if (n) {
    var o = n[1], a = n[3], i = fC[a.toLowerCase()];
    return Number(o.replace(t, ".")) * i;
  }
}, mC = function(e, t) {
  t === void 0 && (t = ",");
  var r = new RegExp(pn(t), "g");
  return e.replace(r, "");
}, hC = function(e, t) {
  var r = pn(t.join("")), n = new RegExp("[^\\d".concat(r, "]"), "gi");
  return e.replace(n, "");
}, xc = function(e) {
  var t = e.value, r = e.groupSeparator, n = r === void 0 ? "," : r, o = e.decimalSeparator, a = o === void 0 ? "." : o, i = e.allowDecimals, s = i === void 0 ? !0 : i, l = e.decimalsLimit, u = l === void 0 ? 2 : l, c = e.allowNegativeValue, p = c === void 0 ? !0 : c, d = e.disableAbbreviations, f = d === void 0 ? !1 : d, m = e.prefix, v = m === void 0 ? "" : m, h = e.transformRawValue, _ = h === void 0 ? function(W) {
    return W;
  } : h, g = _(t);
  if (g === "-")
    return g;
  var b = f ? [] : ["k", "m", "b"], x = new RegExp("((^|\\D)-\\d)|(-".concat(pn(v), ")")), E = x.test(g), O = RegExp("(\\d+)-?".concat(pn(v))).exec(t) || [], P = O[0], y = O[1], w = v ? P ? g.replace(P, "").concat(y) : g.replace(v, "") : g, S = mC(w, n), k = hC(S, fr([
    n,
    a
  ], b, !0)), T = k;
  if (!f) {
    if (b.some(function(W) {
      return W === k.toLowerCase().replace(a, "");
    }))
      return "";
    var R = pC(k, a);
    R && (T = String(R));
  }
  var I = E && p ? "-" : "";
  if (a && T.includes(a)) {
    var C = k.split(a), A = C[0], D = C[1], N = u && D ? D.slice(0, u) : D, M = s ? "".concat(a).concat(N) : "";
    return "".concat(I).concat(A).concat(M);
  }
  return "".concat(I).concat(T);
}, gC = function(e, t, r) {
  if (r !== void 0 && e.length > 1) {
    if (r === 0)
      return e.replace(t, "");
    if (e.includes(t)) {
      var n = e.split(t), o = n[0], a = n[1];
      if (a.length === r)
        return e;
      if (a.length > r)
        return "".concat(o).concat(t).concat(a.slice(0, r));
    }
    var i = e.length > r ? new RegExp("(\\d+)(\\d{".concat(r, "})")) : new RegExp("(\\d)(\\d+)"), s = e.match(i);
    if (s) {
      var o = s[1], a = s[2];
      return "".concat(o).concat(t).concat(a);
    }
  }
  return e;
}, Fg = function(e, t) {
  var r = t.groupSeparator, n = r === void 0 ? "," : r, o = t.decimalSeparator, a = o === void 0 ? "." : o, i = new RegExp("\\d([^".concat(pn(n)).concat(pn(a), "0-9]+)")), s = e.match(i);
  return s ? s[1] : void 0;
}, Fa = function(e) {
  var t = e.value, r = e.decimalSeparator, n = e.intlConfig, o = e.decimalScale, a = e.prefix, i = a === void 0 ? "" : a, s = e.suffix, l = s === void 0 ? "" : s;
  if (t === "" || t === void 0)
    return "";
  if (t === "-")
    return "-";
  var u = new RegExp("^\\d?-".concat(i ? "".concat(pn(i), "?") : "", "\\d")).test(t), c = r !== "." ? vC(t, r, u) : t;
  r && r !== "-" && c.startsWith(r) && (c = "0" + c);
  var p = {
    minimumFractionDigits: o || 0,
    maximumFractionDigits: 20
  }, d = n ? new Intl.NumberFormat(n.locale, n.currency ? ct(ct({}, p), { style: "currency", currency: n.currency }) : p) : new Intl.NumberFormat(void 0, p), f = d.formatToParts(Number(c)), m = yC(f, e), v = Fg(m, ct({}, e)), h = t.slice(-1) === r ? r : "", _ = c.match(RegExp("\\d+\\.(\\d+)")) || [], g = _[1];
  return o === void 0 && g && r && (m.includes(r) ? m = m.replace(RegExp("(\\d+)(".concat(pn(r), ")(\\d+)"), "g"), "$1$2".concat(g)) : v && !l ? m = m.replace(v, "".concat(r).concat(g).concat(v)) : m = "".concat(m).concat(r).concat(g)), l && h ? "".concat(m).concat(h).concat(l) : v && h ? m.replace(v, "".concat(h).concat(v)) : v && l ? m.replace(v, "".concat(h).concat(l)) : [m, h, l].join("");
}, vC = function(e, t, r) {
  var n = e;
  return t && t !== "." && (n = n.replace(RegExp(pn(t), "g"), "."), r && t === "-" && (n = "-".concat(n.slice(1)))), n;
}, yC = function(e, t) {
  var r = t.prefix, n = t.groupSeparator, o = t.decimalSeparator, a = t.decimalScale, i = t.disableGroupSeparators, s = i === void 0 ? !1 : i;
  return e.reduce(function(l, u, c) {
    var p = u.type, d = u.value;
    return c === 0 && r ? p === "minusSign" ? [d, r] : p === "currency" ? fr(fr([], l, !0), [r], !1) : [r, d] : p === "currency" ? r ? l : fr(fr([], l, !0), [d], !1) : p === "group" ? s ? l : fr(fr([], l, !0), [n !== void 0 ? n : d], !1) : p === "decimal" ? a !== void 0 && a === 0 ? l : fr(fr([], l, !0), [o !== void 0 ? o : d], !1) : p === "fraction" ? fr(fr([], l, !0), [a !== void 0 ? d.slice(0, a) : d], !1) : fr(fr([], l, !0), [d], !1);
  }, [""]).join("");
}, bC = {
  currencySymbol: "",
  groupSeparator: "",
  decimalSeparator: "",
  prefix: "",
  suffix: ""
}, wC = function(e) {
  var t = e || {}, r = t.locale, n = t.currency, o = r ? new Intl.NumberFormat(r, n ? { currency: n, style: "currency" } : void 0) : new Intl.NumberFormat();
  return o.formatToParts(1000.1).reduce(function(a, i, s) {
    return i.type === "currency" ? s === 0 ? ct(ct({}, a), { currencySymbol: i.value, prefix: i.value }) : ct(ct({}, a), { currencySymbol: i.value, suffix: i.value }) : i.type === "group" ? ct(ct({}, a), { groupSeparator: i.value }) : i.type === "decimal" ? ct(ct({}, a), { decimalSeparator: i.value }) : a;
  }, bC);
}, Xp = function(e) {
  return RegExp(/\d/, "gi").test(e);
}, xC = function(e, t, r) {
  if (t === void 0 && (t = "."), r === void 0 || e === "" || e === void 0)
    return e;
  if (!e.match(/\d/g))
    return "";
  var n = e.split(t), o = n[0], a = n[1];
  if (r === 0)
    return o;
  var i = a || "";
  if (i.length < r)
    for (; i.length < r; )
      i += "0";
  else
    i = i.slice(0, r);
  return "".concat(o).concat(t).concat(i);
}, _C = function(e) {
  var t = e.selectionStart, r = e.value, n = e.lastKeyStroke, o = e.stateValue, a = e.groupSeparator, i = t, s = r;
  if (o && i) {
    var l = r.split("");
    return n === "Backspace" && o[i] === a && (l.splice(i - 1, 1), i -= 1), n === "Delete" && o[i] === a && (l.splice(i, 1), i += 1), s = l.join(""), { modifiedValue: s, cursorPosition: i };
  }
  return { modifiedValue: s, cursorPosition: t };
}, Lg = na(function(e, t) {
  var r = e.allowDecimals, n = r === void 0 ? !0 : r, o = e.allowNegativeValue, a = o === void 0 ? !0 : o, i = e.id, s = e.name, l = e.className, u = e.customInput, c = e.decimalsLimit, p = e.defaultValue, d = e.disabled, f = d === void 0 ? !1 : d, m = e.maxLength, v = e.value, h = e.onValueChange, _ = e.fixedDecimalLength, g = e.placeholder, b = e.decimalScale, x = e.prefix, E = e.suffix, O = e.intlConfig, P = e.step, y = e.min, w = e.max, S = e.disableGroupSeparators, k = S === void 0 ? !1 : S, T = e.disableAbbreviations, R = T === void 0 ? !1 : T, I = e.decimalSeparator, C = e.groupSeparator, A = e.onChange, D = e.onFocus, N = e.onBlur, M = e.onKeyDown, W = e.onKeyUp, B = e.transformRawValue, j = e.formatValueOnBlur, q = j === void 0 ? !0 : j, se = dC(e, ["allowDecimals", "allowNegativeValue", "id", "name", "className", "customInput", "decimalsLimit", "defaultValue", "disabled", "maxLength", "value", "onValueChange", "fixedDecimalLength", "placeholder", "decimalScale", "prefix", "suffix", "intlConfig", "step", "min", "max", "disableGroupSeparators", "disableAbbreviations", "decimalSeparator", "groupSeparator", "onChange", "onFocus", "onBlur", "onKeyDown", "onKeyUp", "transformRawValue", "formatValueOnBlur"]);
  if (I && Xp(I))
    throw new Error("decimalSeparator cannot be a number");
  if (C && Xp(C))
    throw new Error("groupSeparator cannot be a number");
  var te = ae(function() {
    return wC(O);
  }, [O]), le = I || te.decimalSeparator || "", ke = C || te.groupSeparator || "";
  if (le && ke && le === ke && k === !1)
    throw new Error("decimalSeparator cannot be the same as groupSeparator");
  var at = {
    decimalSeparator: le,
    groupSeparator: ke,
    disableGroupSeparators: k,
    intlConfig: O,
    prefix: x || te.prefix,
    suffix: E
  }, _t = {
    decimalSeparator: le,
    groupSeparator: ke,
    allowDecimals: n,
    decimalsLimit: c || _ || 2,
    allowNegativeValue: a,
    disableAbbreviations: R,
    prefix: x || te.prefix,
    transformRawValue: B
  }, Pt = me(function() {
    return p != null ? Fa(ct(ct({}, at), { decimalScale: b, value: String(p) })) : v != null ? Fa(ct(ct({}, at), { decimalScale: b, value: String(v) })) : "";
  }), pe = Pt[0], Z = Pt[1], Pe = me(!1), J = Pe[0], Ne = Pe[1], St = me(0), Et = St[0], Ft = St[1], nr = me(0), Xr = nr[0], vn = nr[1], yn = me(null), Zr = yn[0], xr = yn[1], Mt = ce(null);
  g1(t, function() {
    return Mt.current;
  });
  var Kt = function(ve, we) {
    Ne(!0);
    var Se = _C({
      selectionStart: we,
      value: ve,
      lastKeyStroke: Zr,
      stateValue: pe,
      groupSeparator: ke
    }), Je = Se.modifiedValue, et = Se.cursorPosition, Lt = xc(ct({ value: Je }, _t));
    if (!(m && Lt.replace(/-/g, "").length > m)) {
      if (Lt === "" || Lt === "-" || Lt === le) {
        h && h(void 0, s, { float: null, formatted: "", value: "" }), Z(Lt), Ft(1);
        return;
      }
      var $n = le ? Lt.replace(le, ".") : Lt, mt = parseFloat($n), Sr = Fa(ct({ value: Lt }, at));
      if (et != null) {
        var Jr = et + (Sr.length - ve.length);
        Jr = Jr <= 0 ? x ? x.length : 0 : Jr, Ft(Jr), vn(Xr + 1);
      }
      if (Z(Sr), h) {
        var io = {
          float: mt,
          formatted: Sr,
          value: Lt
        };
        h(Lt, s, io);
      }
    }
  }, bn = function(ve) {
    var we = ve.target, Se = we.value, Je = we.selectionStart;
    Kt(Se, Je), A && A(ve);
  }, _r = function(ve) {
    return D && D(ve), pe ? pe.length : 0;
  }, Ln = function(ve) {
    var we = ve.target.value, Se = xc(ct({ value: we }, _t));
    if (Se === "-" || Se === le || !Se) {
      Z(""), N && N(ve);
      return;
    }
    var Je = gC(Se, le, _), et = xC(Je, le, b !== void 0 ? b : _), Lt = parseFloat(et.replace(le, ".")), $n = Fa(ct(ct({}, at), { value: et }));
    h && q && h(et, s, {
      float: Lt,
      formatted: $n,
      value: et
    }), Z($n), N && N(ve);
  }, $ = function(ve) {
    var we = ve.key;
    if (xr(we), P && (we === "ArrowUp" || we === "ArrowDown")) {
      ve.preventDefault(), Ft(pe.length);
      var Se = parseFloat(v != null ? String(v).replace(le, ".") : xc(ct({ value: pe }, _t))) || 0, Je = we === "ArrowUp" ? Se + P : Se - P;
      if (y !== void 0 && Je < Number(y) || w !== void 0 && Je > Number(w))
        return;
      var et = String(P).includes(".") ? Number(String(P).split(".")[1].length) : void 0;
      Kt(String(et ? Je.toFixed(et) : Je).replace(".", le));
    }
    M && M(ve);
  }, K = function(ve) {
    var we = ve.key, Se = ve.currentTarget.selectionStart;
    if (we !== "ArrowUp" && we !== "ArrowDown" && pe !== "-") {
      var Je = Fg(pe, { groupSeparator: ke, decimalSeparator: le });
      if (Je && Se && Se > pe.length - Je.length && Mt.current) {
        var et = pe.length - Je.length;
        Mt.current.setSelectionRange(et, et);
      }
    }
    W && W(ve);
  };
  ge(function() {
    v == null && p == null && Z("");
  }, [p, v]), ge(function() {
    J && pe !== "-" && Mt.current && document.activeElement === Mt.current && Mt.current.setSelectionRange(Et, Et);
  }, [pe, Et, Mt, J, Xr]);
  var z = function() {
    return v != null && pe !== "-" && (!le || pe !== le) ? Fa(ct(ct({}, at), { decimalScale: J ? void 0 : b, value: String(v) })) : pe;
  }, be = ct({ type: "text", inputMode: "decimal", id: i, name: s, className: l, onChange: bn, onBlur: Ln, onFocus: _r, onKeyDown: $, onKeyUp: K, placeholder: g, disabled: f, value: z(), ref: Mt }, se);
  if (u) {
    var Ce = u;
    return G.createElement(Ce, ct({}, be));
  }
  return G.createElement("input", ct({}, be));
});
Lg.displayName = "CurrencyInput";
const SC = ({
  classes: e,
  className: t,
  variant: r,
  disabled: n,
  size: o = "md",
  error: a,
  helperText: i,
  value: s,
  placeholder: l,
  allowDecimals: u,
  allowNegativeValue: c,
  onChange: p,
  currency: d,
  displayHelperText: f,
  helperTextClasses: m,
  t: v
}) => {
  const { themeClasses: h } = Ge("NumberField", e, t, {
    variant: r,
    modifier: o
  }), _ = r === "currency";
  return /* @__PURE__ */ ue("div", { className: V(h == null ? void 0 : h.root), children: [
    /* @__PURE__ */ ue(
      "div",
      {
        className: V(h == null ? void 0 : h.inputContainer, {
          [(h == null ? void 0 : h.inputContainerError) ?? ""]: !!a,
          "cursor-not-allowed opacity-60": n
        }),
        children: [
          /* @__PURE__ */ L(
            Lg,
            {
              className: V(
                "h-full w-full bg-transparent text-center text-2xl font-bold outline-none",
                {
                  "h-8 text-center text-2xl": _
                },
                h == null ? void 0 : h.input
              ),
              value: s === 0 ? "" : s,
              placeholder: l,
              disabled: n,
              allowDecimals: u,
              allowNegativeValue: c,
              onValueChange: (g) => {
                p == null || p(g ?? "");
              }
            }
          ),
          d && _ && /* @__PURE__ */ L("div", { className: V(h == null ? void 0 : h.currency), children: (v == null ? void 0 : v(d)) ?? d })
        ]
      }
    ),
    /* @__PURE__ */ L(
      Qd,
      {
        error: a,
        helperText: i,
        alwaysDisplay: f,
        t: v,
        ...m
      }
    )
  ] });
}, _M = SC;
function SM({
  value: e,
  label: t,
  options: r,
  onChange: n,
  renderValue: o,
  renderOption: a,
  className: i,
  classes: s,
  helperText: l,
  error: u,
  disabled: c = !1,
  placeholder: p,
  icon: d,
  dropdownGap: f = 32,
  size: m = "md",
  optionIconPlaceholder: v
}) {
  var E, O;
  const { themeClasses: h } = Ge("Select", s, i, {
    modifier: m
  }), _ = xt(), g = e ? (E = r.find(({ value: P }) => P === e)) == null ? void 0 : E.label : p ?? "", b = e ? ((O = r.find(({ value: P }) => P === e)) == null ? void 0 : O.icon) ?? d : d, x = Le(() => {
    _ && f && L1(50).then(() => {
      const P = document.getElementById(_);
      if (!P) return;
      const y = getComputedStyle(P), w = parseInt(y.maxHeight.replace("px", ""));
      P.style.setProperty("--anchor-max-height", `${w - f}px`);
    });
  }, [f, _]);
  return /* @__PURE__ */ ue("label", { className: V(h == null ? void 0 : h.root), children: [
    typeof t == "string" ? /* @__PURE__ */ L("span", { className: V(h == null ? void 0 : h.label), children: t }) : t,
    /* @__PURE__ */ ue(
      xk,
      {
        value: e,
        onChange: n,
        disabled: c,
        children: [
          /* @__PURE__ */ L(
            lg,
            {
              onClick: x,
              className: V(h == null ? void 0 : h.select, u ? "!border-rose-500 focus:!border-rose-500" : ""),
              children: /* @__PURE__ */ ue("div", { className: "flex w-full items-center justify-between", children: [
                /* @__PURE__ */ ue("div", { className: "flex items-center gap-2", children: [
                  !!b && /* @__PURE__ */ L("div", { className: V("max-h-8 max-w-8"), children: b }),
                  o && e ? o(e) : /* @__PURE__ */ L("div", { className: V("truncate", h == null ? void 0 : h.placeHolder), children: g })
                ] }),
                /* @__PURE__ */ L(e0, { className: V("truncate", h == null ? void 0 : h.iconDropdown) })
              ] })
            }
          ),
          /* @__PURE__ */ L(
            cg,
            {
              anchor: "bottom",
              transition: !0,
              className: V(h == null ? void 0 : h.optionsContainer),
              id: _,
              children: r.map((P) => /* @__PURE__ */ L(
                ug,
                {
                  value: P.value,
                  className: V(h == null ? void 0 : h.option),
                  children: ({ focus: y, selected: w }) => /* @__PURE__ */ L(
                    "div",
                    {
                      className: V({
                        [(h == null ? void 0 : h.selectedOption) ?? ""]: w
                      }),
                      children: a ? a(P) : /* @__PURE__ */ ue("div", { className: "flex items-center gap-x-2", children: [
                        P.icon ?? v,
                        P.label
                      ] })
                    }
                  )
                },
                P.value
              ))
            }
          )
        ]
      }
    ),
    !!l && /* @__PURE__ */ L("div", { className: V(h == null ? void 0 : h.helperText, u ? h == null ? void 0 : h.errorText : ""), children: l })
  ] });
}
const EC = na(
  ({
    classes: e,
    className: t,
    icon: r,
    helperText: n,
    error: o,
    displayHelperText: a = !1,
    size: i = "md",
    t: s,
    helperTextClasses: l,
    ...u
  }, c) => {
    const p = ae(() => u.disabled ? "disabled" : o ? "error" : "normal", [o, u.disabled]), { themeClasses: d } = Ge("TextField", e, t, {
      variant: p,
      modifier: i
    });
    return /* @__PURE__ */ ue("div", { className: V("relative", d == null ? void 0 : d.root), children: [
      !!r && /* @__PURE__ */ L("div", { className: V("absolute", d == null ? void 0 : d.iconContainer), children: r }),
      /* @__PURE__ */ L(
        "input",
        {
          className: V(d == null ? void 0 : d.input, {
            "pl-9": !!r && i === "sm",
            "pl-12": !!r && i === "md",
            "pl-14": !!r && i === "lg",
            "pl-16": !!r && i === "xl"
          }),
          ...u,
          ref: c
        }
      ),
      /* @__PURE__ */ L(
        Qd,
        {
          error: o,
          helperText: n,
          alwaysDisplay: a,
          t: s,
          ...l
        }
      )
    ] });
  }
), TC = EC, kC = ({ className: e, children: t, classes: r }) => {
  const { themeClasses: n } = Ge("Page", r, e);
  return /* @__PURE__ */ L("div", { className: V("flex min-h-dvh w-full max-w-md flex-col", n == null ? void 0 : n.root), children: t });
}, EM = kC, OC = na(({ children: e, className: t }, r) => /* @__PURE__ */ L(
  "main",
  {
    className: V("flex flex-grow flex-col", t),
    ref: r,
    children: e
  }
)), TM = OC, DC = ({ children: e, className: t, classes: r, fixed: n }) => {
  const { themeClasses: o } = Ge("PageFooter", r, t);
  return /* @__PURE__ */ L(
    "footer",
    {
      className: V("flex-shrink-0", o == null ? void 0 : o.root, {
        "fixed bottom-0 left-0 h-fit w-full": n
      }),
      children: e
    }
  );
}, kM = DC, NC = ({ children: e, className: t, classes: r, fixed: n }) => {
  const { themeClasses: o } = Ge("PageHeader", r, t);
  return /* @__PURE__ */ L(
    "header",
    {
      className: V(
        "flex-shrink-0",
        {
          "fixed left-0 top-0 h-fit w-full": n
        },
        o == null ? void 0 : o.root
      ),
      children: e
    }
  );
}, OM = NC, CC = ({
  children: e,
  variant: t = "solid",
  className: r,
  classes: n,
  label: o,
  backButton: a,
  rightButton: i
}) => {
  const { themeClasses: s } = Ge("PageTitle", n, r, {
    variant: t
  });
  return /* @__PURE__ */ ue("div", { className: V("flex flex-col items-center", s == null ? void 0 : s.root), children: [
    /* @__PURE__ */ ue("div", { className: "relative flex w-full items-center", children: [
      t === "solid" && /* @__PURE__ */ L("span", { className: V("mx-auto", s == null ? void 0 : s.label), children: o }),
      t === "gradient-yellow" && /* @__PURE__ */ ue("div", { className: "relative h-[35px] w-full", children: [
        /* @__PURE__ */ L("span", { className: V("absolute left-1/2 top-[1px] -translate-x-1/2", s == null ? void 0 : s.label), children: o }),
        /* @__PURE__ */ L("span", { className: V("absolute left-1/2 top-0 -translate-x-1/2", s == null ? void 0 : s.labelOverlay), children: o }),
        /* @__PURE__ */ L("span", { className: V("absolute left-1/2 -translate-x-[50%] -translate-y-[16px]", s == null ? void 0 : s.star), children: /* @__PURE__ */ L(lE, {}) })
      ] }),
      t === "gradient-purple" && /* @__PURE__ */ ue("div", { className: "relative h-[35px] w-full", children: [
        /* @__PURE__ */ L("span", { className: V("absolute left-1/2 top-[1px] -translate-x-1/2", s == null ? void 0 : s.label), children: o }),
        /* @__PURE__ */ L("span", { className: V("absolute left-1/2 top-0 -translate-x-1/2", s == null ? void 0 : s.labelOverlay), children: o })
      ] }),
      /* @__PURE__ */ L("div", { className: "absolute left-0", children: a }),
      /* @__PURE__ */ L("div", { className: "absolute right-0", children: i })
    ] }),
    e
  ] });
}, DM = CC;
function NM({ animationClassName: e = "animate-fade-out", className: t }) {
  return /* @__PURE__ */ L(
    "div",
    {
      className: V(
        "bg-secondary-700 pointer-events-none fixed right-0 top-0 h-screen w-screen bg-opacity-25 lg:hidden",
        e,
        t
      )
    }
  );
}
const PC = ({ classes: e, className: t, children: r }) => {
  const { themeClasses: n } = Ge("BottomNavigation", e, t);
  return /* @__PURE__ */ ue("div", { className: V("relative h-[56px]", n == null ? void 0 : n.root, t), children: [
    /* @__PURE__ */ L("div", { className: "absolute left-0 top-0 h-[1px] w-full bg-[rgba(255,255,255,0.02)]" }),
    /* @__PURE__ */ L("nav", { className: V("", n == null ? void 0 : n.container), children: r })
  ] });
}, CM = PC, MC = ({
  classes: e,
  icon: t,
  active: r,
  variant: n = "normal",
  href: o,
  label: a,
  className: i,
  onClick: s
}) => {
  const { themeClasses: l } = Ge("BottomNavigationAction", e, i, {
    variant: n + (r ? ":active" : "")
  }), u = Le(() => {
    s == null || s(o);
  }, [s, o]);
  return /* @__PURE__ */ ue(
    "button",
    {
      onClick: u,
      className: V("relative flex h-full flex-col items-center justify-end", l == null ? void 0 : l.root, i, {
        "bg-bottomNavBtnIndicatorActive": r
      }),
      children: [
        t,
        /* @__PURE__ */ L("span", { className: V("", l == null ? void 0 : l.label), children: a }),
        /* @__PURE__ */ L("div", { className: V("absolute bottom-0 left-1/2 w-[24px] -translate-x-1/2 rounded-t", l == null ? void 0 : l.indicator) })
      ]
    }
  );
}, PM = MC, RC = ({
  classes: e,
  className: t,
  variant: r = "primary",
  direction: n = "horizontal",
  tabActions: o,
  onChange: a,
  currentTab: i,
  autoSelect: s = !1,
  toggle: l = !1
}) => {
  const { themeClasses: u } = Ge("TabNavigation", e, t, {
    variant: r,
    modifier: n
  }), [c, p] = me(
    i || (s ? o[0] : void 0)
  ), d = Le(
    (f) => {
      var m;
      if ((m = f.onClick) == null || m.call(f), l && (c == null ? void 0 : c.id) === f.id) {
        a == null || a(void 0), p(void 0);
        return;
      }
      a == null || a(f), p(f);
    },
    [c == null ? void 0 : c.id, a, l]
  );
  return ge(() => {
    s || p(i);
  }, [s, i]), /* @__PURE__ */ L("div", { className: V(u == null ? void 0 : u.root), children: o.map((f, m) => {
    var h, _;
    let v = r;
    return (c == null ? void 0 : c.id) === f.id && (v = r === "primary" ? "secondary" : "primary"), /* @__PURE__ */ L(
      Ko,
      {
        onClick: () => d == null ? void 0 : d(f),
        variant: v,
        size: f.size,
        className: V(u == null ? void 0 : u.tab, (h = f.styles) == null ? void 0 : h.className, {
          "h-[56px] !w-[64px] rounded-md px-2 py-3": n === "horizontal",
          "h-[43px] w-full p-2": n === "vertical"
        }),
        classes: {
          ...(_ = f.styles) == null ? void 0 : _.classes,
          root_primary: "bg-primary-dark",
          root_secondary: "bg-tabNavSecondary"
        },
        children: /* @__PURE__ */ ue(
          "div",
          {
            className: V("flex gap-1", {
              "flex-col items-center justify-between": n === "horizontal",
              "flex-row": n === "vertical"
            }),
            children: [
              f.icon,
              !!f.label && /* @__PURE__ */ L("span", { className: "text-xs font-semibold", children: f.label })
            ]
          }
        )
      },
      f.id
    );
  }) });
}, MM = RC, AC = ({ classes: e, children: t, className: r, variant: n = "primary", size: o = "md" }) => {
  const { themeClasses: a } = Ge("Card", e, r, {
    variant: n,
    modifier: o
  });
  return /* @__PURE__ */ L("div", { className: V(a == null ? void 0 : a.root), children: t });
}, RM = AC;
function su({
  open: e,
  onClose: t,
  transition: r = !1,
  title: n,
  children: o,
  className: a,
  classes: i,
  zIndex: s = 10
}) {
  const { themeClasses: l } = Ge("Dialog", i, a);
  return /* @__PURE__ */ ue(
    L3,
    {
      open: e,
      onClose: t,
      className: V(l == null ? void 0 : l.root),
      children: [
        /* @__PURE__ */ L(
          F3,
          {
            className: V(l == null ? void 0 : l.backDrop),
            transition: r,
            style: {
              zIndex: s
            }
          }
        ),
        /* @__PURE__ */ L(
          "div",
          {
            className: V(l == null ? void 0 : l.containerWrapper),
            style: {
              zIndex: s + 1
            },
            children: /* @__PURE__ */ ue(
              rg,
              {
                transition: r,
                className: V(l == null ? void 0 : l.container),
                style: {
                  zIndex: s + 2
                },
                children: [
                  typeof n == "string" ? /* @__PURE__ */ L(ng, { className: V(l == null ? void 0 : l.title), children: n }) : n,
                  o
                ]
              }
            )
          }
        )
      ]
    }
  );
}
const IC = "Left", FC = "Right", LC = "Up", $C = "Down", jo = {
  delta: 10,
  preventScrollOnSwipe: !1,
  rotationAngle: 0,
  trackMouse: !1,
  trackTouch: !0,
  swipeDuration: 1 / 0,
  touchEventOptions: { passive: !0 }
}, lu = {
  first: !0,
  initial: [0, 0],
  start: 0,
  swiping: !1,
  xy: [0, 0]
}, Zp = "mousemove", Jp = "mouseup", WC = "touchend", YC = "touchmove", BC = "touchstart";
function jC(e, t, r, n) {
  return e > t ? r > 0 ? FC : IC : n > 0 ? $C : LC;
}
function em(e, t) {
  if (t === 0)
    return e;
  const r = Math.PI / 180 * t, n = e[0] * Math.cos(r) + e[1] * Math.sin(r), o = e[1] * Math.cos(r) - e[0] * Math.sin(r);
  return [n, o];
}
function UC(e, t) {
  const r = (c) => {
    const p = "touches" in c;
    p && c.touches.length > 1 || e((d, f) => {
      f.trackMouse && !p && (document.addEventListener(Zp, n), document.addEventListener(Jp, i));
      const { clientX: m, clientY: v } = p ? c.touches[0] : c, h = em([m, v], f.rotationAngle);
      return f.onTouchStartOrOnMouseDown && f.onTouchStartOrOnMouseDown({ event: c }), Object.assign(Object.assign(Object.assign({}, d), lu), { initial: h.slice(), xy: h, start: c.timeStamp || 0 });
    });
  }, n = (c) => {
    e((p, d) => {
      const f = "touches" in c;
      if (f && c.touches.length > 1)
        return p;
      if (c.timeStamp - p.start > d.swipeDuration)
        return p.swiping ? Object.assign(Object.assign({}, p), { swiping: !1 }) : p;
      const { clientX: m, clientY: v } = f ? c.touches[0] : c, [h, _] = em([m, v], d.rotationAngle), g = h - p.xy[0], b = _ - p.xy[1], x = Math.abs(g), E = Math.abs(b), O = (c.timeStamp || 0) - p.start, P = Math.sqrt(x * x + E * E) / (O || 1), y = [g / (O || 1), b / (O || 1)], w = jC(x, E, g, b), S = typeof d.delta == "number" ? d.delta : d.delta[w.toLowerCase()] || jo.delta;
      if (x < S && E < S && !p.swiping)
        return p;
      const k = {
        absX: x,
        absY: E,
        deltaX: g,
        deltaY: b,
        dir: w,
        event: c,
        first: p.first,
        initial: p.initial,
        velocity: P,
        vxvy: y
      };
      k.first && d.onSwipeStart && d.onSwipeStart(k), d.onSwiping && d.onSwiping(k);
      let T = !1;
      return (d.onSwiping || d.onSwiped || d[`onSwiped${w}`]) && (T = !0), T && d.preventScrollOnSwipe && d.trackTouch && c.cancelable && c.preventDefault(), Object.assign(Object.assign({}, p), {
        // first is now always false
        first: !1,
        eventData: k,
        swiping: !0
      });
    });
  }, o = (c) => {
    e((p, d) => {
      let f;
      if (p.swiping && p.eventData) {
        if (c.timeStamp - p.start < d.swipeDuration) {
          f = Object.assign(Object.assign({}, p.eventData), { event: c }), d.onSwiped && d.onSwiped(f);
          const m = d[`onSwiped${f.dir}`];
          m && m(f);
        }
      } else
        d.onTap && d.onTap({ event: c });
      return d.onTouchEndOrOnMouseUp && d.onTouchEndOrOnMouseUp({ event: c }), Object.assign(Object.assign(Object.assign({}, p), lu), { eventData: f });
    });
  }, a = () => {
    document.removeEventListener(Zp, n), document.removeEventListener(Jp, i);
  }, i = (c) => {
    a(), o(c);
  }, s = (c, p) => {
    let d = () => {
    };
    if (c && c.addEventListener) {
      const f = Object.assign(Object.assign({}, jo.touchEventOptions), p.touchEventOptions), m = [
        [BC, r, f],
        // preventScrollOnSwipe option supersedes touchEventOptions.passive
        [
          YC,
          n,
          Object.assign(Object.assign({}, f), p.preventScrollOnSwipe ? { passive: !1 } : {})
        ],
        [WC, o, f]
      ];
      m.forEach(([v, h, _]) => c.addEventListener(v, h, _)), d = () => m.forEach(([v, h]) => c.removeEventListener(v, h));
    }
    return d;
  }, u = {
    ref: (c) => {
      c !== null && e((p, d) => {
        if (p.el === c)
          return p;
        const f = {};
        return p.el && p.el !== c && p.cleanUpTouch && (p.cleanUpTouch(), f.cleanUpTouch = void 0), d.trackTouch && c && (f.cleanUpTouch = s(c, d)), Object.assign(Object.assign(Object.assign({}, p), { el: c }), f);
      });
    }
  };
  return t.trackMouse && (u.onMouseDown = r), [u, s];
}
function HC(e, t, r, n) {
  return !t.trackTouch || !e.el ? (e.cleanUpTouch && e.cleanUpTouch(), Object.assign(Object.assign({}, e), { cleanUpTouch: void 0 })) : e.cleanUpTouch ? t.preventScrollOnSwipe !== r.preventScrollOnSwipe || t.touchEventOptions.passive !== r.touchEventOptions.passive ? (e.cleanUpTouch(), Object.assign(Object.assign({}, e), { cleanUpTouch: n(e.el, t) })) : e : Object.assign(Object.assign({}, e), { cleanUpTouch: n(e.el, t) });
}
function VC(e) {
  const { trackMouse: t } = e, r = Q.useRef(Object.assign({}, lu)), n = Q.useRef(Object.assign({}, jo)), o = Q.useRef(Object.assign({}, n.current));
  o.current = Object.assign({}, n.current), n.current = Object.assign(Object.assign({}, jo), e);
  let a;
  for (a in jo)
    n.current[a] === void 0 && (n.current[a] = jo[a]);
  const [i, s] = Q.useMemo(() => UC((l) => r.current = l(r.current, n.current), { trackMouse: t }), [t]);
  return r.current = HC(r.current, n.current, o.current, s), i;
}
const zC = {
  top: {
    ...D1,
    ...C1
  },
  bottom: {
    ...O1,
    ...N1
  },
  left: {
    ...R1,
    ...A1
  },
  right: {
    ...P1,
    ...M1
  }
};
function qC({
  open: e,
  onClose: t,
  placement: r = "bottom",
  preload: n = !1,
  onBackdropClick: o = t,
  classes: a,
  className: i,
  children: s,
  floatingHandle: l,
  safeZone: u,
  variant: c = "compact",
  hideHandler: p
}) {
  const { themeClasses: d } = Ge("Drawer", a, i, {
    variant: c
  }), [f, m] = me(!1), v = VC({
    onSwipedDown: t,
    trackTouch: !0,
    trackMouse: !0,
    onSwipeStart: (h) => {
      h.dir === "Down" && m(!0);
    },
    onSwiped: (h) => {
      m(!1);
    }
  });
  return ge(() => {
    e ? document.body.style.overflowY = "hidden" : document.body.style.overflowY = "auto";
  }, [e]), /* @__PURE__ */ L(Gt, { children: /* @__PURE__ */ L(
    tg,
    {
      show: e,
      unmount: !n,
      appear: !0,
      children: /* @__PURE__ */ ue("div", { className: V(d == null ? void 0 : d.root), children: [
        /* @__PURE__ */ L(
          Qo,
          {
            unmount: !n,
            appear: !0,
            children: /* @__PURE__ */ L(
              "div",
              {
                onClick: o,
                className: V(d == null ? void 0 : d.backDrop)
              }
            )
          }
        ),
        /* @__PURE__ */ L(Qo, { children: /* @__PURE__ */ L(
          "div",
          {
            className: V("grow transition duration-300 data-[closed]:opacity-0", d == null ? void 0 : d.gap, {
              "max-h-full": c === "compact",
              "max-h-0": c === "full-screen"
            })
          }
        ) }),
        /* @__PURE__ */ L(Qo, { ...zC[r], children: /* @__PURE__ */ ue(
          "div",
          {
            className: V("relative z-20 transition-all", d == null ? void 0 : d.container, {
              "mt-10": r === "bottom",
              "mb-10": r === "top",
              "mr-10": r === "left",
              "ml-10": r === "right",
              [(d == null ? void 0 : d.safeZone) ?? ""]: !!u,
              "!m-0": c === "full-screen",
              "translate-y-2": f
            }),
            children: [
              c === "compact" && /* @__PURE__ */ L(
                "div",
                {
                  ...v,
                  className: V("absolute -top-4 left-0 z-50 h-12 w-full")
                }
              ),
              !p && /* @__PURE__ */ L(
                "div",
                {
                  className: V("flex-shrink-0 overflow-hidden transition-[max-height]", d == null ? void 0 : d.drawerTop, {
                    "absolute left-0 top-0 w-full": l,
                    "max-h-0": c === "full-screen",
                    "!max-h-[12px]": c === "compact"
                  }),
                  children: /* @__PURE__ */ L(
                    "div",
                    {
                      className: V("mt-2 h-1 w-9 rounded-lg bg-white/15 transition-[background-color]", {
                        "!bg-white": f
                      })
                    }
                  )
                }
              ),
              /* @__PURE__ */ L("div", { className: V("overflow-y-auto", d == null ? void 0 : d.drawerBody), children: s })
            ]
          }
        ) })
      ] })
    }
  ) });
}
const GC = ({
  classes: e,
  className: t,
  icon: r,
  title: n,
  subTitle: o,
  backButton: a,
  closeButton: i,
  size: s = "md"
}) => {
  const { themeClasses: l } = Ge("DrawerTitle", e, t, {
    modifier: s
  });
  return /* @__PURE__ */ ue("div", { className: V("relative", l == null ? void 0 : l.root), children: [
    a && /* @__PURE__ */ L("span", { className: V("absolute", l == null ? void 0 : l.backButtonWrapper), children: a }),
    i && /* @__PURE__ */ L("span", { className: V("absolute", l == null ? void 0 : l.closeButtonWrapper), children: i }),
    /* @__PURE__ */ ue("div", { className: V("flex items-center justify-center space-x-3"), children: [
      r,
      /* @__PURE__ */ L("span", { className: V("inline-block", l == null ? void 0 : l.title), children: n })
    ] }),
    o && /* @__PURE__ */ L("p", { className: V(l == null ? void 0 : l.subTitle), children: o })
  ] });
}, QC = GC, KC = ({ className: e, imgClassName: t, ...r }) => /* @__PURE__ */ L("span", { className: V(e, "bg-black [-webkit-mask:linear-gradient(#fff_0_0)]"), children: /* @__PURE__ */ L(
  "img",
  {
    ...r,
    className: V(t),
    alt: r.alt || ""
  }
) }), AM = KC;
var XC = !1;
function ZC(e) {
  if (e.sheet)
    return e.sheet;
  for (var t = 0; t < document.styleSheets.length; t++)
    if (document.styleSheets[t].ownerNode === e)
      return document.styleSheets[t];
}
function JC(e) {
  var t = document.createElement("style");
  return t.setAttribute("data-emotion", e.key), e.nonce !== void 0 && t.setAttribute("nonce", e.nonce), t.appendChild(document.createTextNode("")), t.setAttribute("data-s", ""), t;
}
var eP = /* @__PURE__ */ function() {
  function e(r) {
    var n = this;
    this._insertTag = function(o) {
      var a;
      n.tags.length === 0 ? n.insertionPoint ? a = n.insertionPoint.nextSibling : n.prepend ? a = n.container.firstChild : a = n.before : a = n.tags[n.tags.length - 1].nextSibling, n.container.insertBefore(o, a), n.tags.push(o);
    }, this.isSpeedy = r.speedy === void 0 ? !XC : r.speedy, this.tags = [], this.ctr = 0, this.nonce = r.nonce, this.key = r.key, this.container = r.container, this.prepend = r.prepend, this.insertionPoint = r.insertionPoint, this.before = null;
  }
  var t = e.prototype;
  return t.hydrate = function(n) {
    n.forEach(this._insertTag);
  }, t.insert = function(n) {
    this.ctr % (this.isSpeedy ? 65e3 : 1) === 0 && this._insertTag(JC(this));
    var o = this.tags[this.tags.length - 1];
    if (this.isSpeedy) {
      var a = ZC(o);
      try {
        a.insertRule(n, a.cssRules.length);
      } catch {
      }
    } else
      o.appendChild(document.createTextNode(n));
    this.ctr++;
  }, t.flush = function() {
    this.tags.forEach(function(n) {
      var o;
      return (o = n.parentNode) == null ? void 0 : o.removeChild(n);
    }), this.tags = [], this.ctr = 0;
  }, e;
}(), Vt = "-ms-", qs = "-moz-", Qe = "-webkit-", $g = "comm", Kd = "rule", Xd = "decl", tP = "@import", Wg = "@keyframes", rP = "@layer", nP = Math.abs, Cl = String.fromCharCode, oP = Object.assign;
function aP(e, t) {
  return Bt(e, 0) ^ 45 ? (((t << 2 ^ Bt(e, 0)) << 2 ^ Bt(e, 1)) << 2 ^ Bt(e, 2)) << 2 ^ Bt(e, 3) : 0;
}
function Yg(e) {
  return e.trim();
}
function iP(e, t) {
  return (e = t.exec(e)) ? e[0] : e;
}
function Ke(e, t, r) {
  return e.replace(t, r);
}
function cu(e, t) {
  return e.indexOf(t);
}
function Bt(e, t) {
  return e.charCodeAt(t) | 0;
}
function ci(e, t, r) {
  return e.slice(t, r);
}
function en(e) {
  return e.length;
}
function Zd(e) {
  return e.length;
}
function hs(e, t) {
  return t.push(e), e;
}
function sP(e, t) {
  return e.map(t).join("");
}
var Pl = 1, ra = 1, Bg = 0, ur = 0, Nt = 0, ha = "";
function Ml(e, t, r, n, o, a, i) {
  return { value: e, root: t, parent: r, type: n, props: o, children: a, line: Pl, column: ra, length: i, return: "" };
}
function La(e, t) {
  return oP(Ml("", null, null, "", null, null, 0), e, { length: -e.length }, t);
}
function lP() {
  return Nt;
}
function cP() {
  return Nt = ur > 0 ? Bt(ha, --ur) : 0, ra--, Nt === 10 && (ra = 1, Pl--), Nt;
}
function gr() {
  return Nt = ur < Bg ? Bt(ha, ur++) : 0, ra++, Nt === 10 && (ra = 1, Pl++), Nt;
}
function sn() {
  return Bt(ha, ur);
}
function Es() {
  return ur;
}
function Vi(e, t) {
  return ci(ha, e, t);
}
function ui(e) {
  switch (e) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function jg(e) {
  return Pl = ra = 1, Bg = en(ha = e), ur = 0, [];
}
function Ug(e) {
  return ha = "", e;
}
function Ts(e) {
  return Yg(Vi(ur - 1, uu(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function uP(e) {
  for (; (Nt = sn()) && Nt < 33; )
    gr();
  return ui(e) > 2 || ui(Nt) > 3 ? "" : " ";
}
function dP(e, t) {
  for (; --t && gr() && !(Nt < 48 || Nt > 102 || Nt > 57 && Nt < 65 || Nt > 70 && Nt < 97); )
    ;
  return Vi(e, Es() + (t < 6 && sn() == 32 && gr() == 32));
}
function uu(e) {
  for (; gr(); )
    switch (Nt) {
      case e:
        return ur;
      case 34:
      case 39:
        e !== 34 && e !== 39 && uu(Nt);
        break;
      case 40:
        e === 41 && uu(e);
        break;
      case 92:
        gr();
        break;
    }
  return ur;
}
function fP(e, t) {
  for (; gr() && e + Nt !== 57; )
    if (e + Nt === 84 && sn() === 47)
      break;
  return "/*" + Vi(t, ur - 1) + "*" + Cl(e === 47 ? e : gr());
}
function pP(e) {
  for (; !ui(sn()); )
    gr();
  return Vi(e, ur);
}
function mP(e) {
  return Ug(ks("", null, null, null, [""], e = jg(e), 0, [0], e));
}
function ks(e, t, r, n, o, a, i, s, l) {
  for (var u = 0, c = 0, p = i, d = 0, f = 0, m = 0, v = 1, h = 1, _ = 1, g = 0, b = "", x = o, E = a, O = n, P = b; h; )
    switch (m = g, g = gr()) {
      case 40:
        if (m != 108 && Bt(P, p - 1) == 58) {
          cu(P += Ke(Ts(g), "&", "&\f"), "&\f") != -1 && (_ = -1);
          break;
        }
      case 34:
      case 39:
      case 91:
        P += Ts(g);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        P += uP(m);
        break;
      case 92:
        P += dP(Es() - 1, 7);
        continue;
      case 47:
        switch (sn()) {
          case 42:
          case 47:
            hs(hP(fP(gr(), Es()), t, r), l);
            break;
          default:
            P += "/";
        }
        break;
      case 123 * v:
        s[u++] = en(P) * _;
      case 125 * v:
      case 59:
      case 0:
        switch (g) {
          case 0:
          case 125:
            h = 0;
          case 59 + c:
            _ == -1 && (P = Ke(P, /\f/g, "")), f > 0 && en(P) - p && hs(f > 32 ? rm(P + ";", n, r, p - 1) : rm(Ke(P, " ", "") + ";", n, r, p - 2), l);
            break;
          case 59:
            P += ";";
          default:
            if (hs(O = tm(P, t, r, u, c, o, s, b, x = [], E = [], p), a), g === 123)
              if (c === 0)
                ks(P, t, O, O, x, a, p, s, E);
              else
                switch (d === 99 && Bt(P, 3) === 110 ? 100 : d) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    ks(e, O, O, n && hs(tm(e, O, O, 0, 0, o, s, b, o, x = [], p), E), o, E, p, s, n ? x : E);
                    break;
                  default:
                    ks(P, O, O, O, [""], E, 0, s, E);
                }
        }
        u = c = f = 0, v = _ = 1, b = P = "", p = i;
        break;
      case 58:
        p = 1 + en(P), f = m;
      default:
        if (v < 1) {
          if (g == 123)
            --v;
          else if (g == 125 && v++ == 0 && cP() == 125)
            continue;
        }
        switch (P += Cl(g), g * v) {
          case 38:
            _ = c > 0 ? 1 : (P += "\f", -1);
            break;
          case 44:
            s[u++] = (en(P) - 1) * _, _ = 1;
            break;
          case 64:
            sn() === 45 && (P += Ts(gr())), d = sn(), c = p = en(b = P += pP(Es())), g++;
            break;
          case 45:
            m === 45 && en(P) == 2 && (v = 0);
        }
    }
  return a;
}
function tm(e, t, r, n, o, a, i, s, l, u, c) {
  for (var p = o - 1, d = o === 0 ? a : [""], f = Zd(d), m = 0, v = 0, h = 0; m < n; ++m)
    for (var _ = 0, g = ci(e, p + 1, p = nP(v = i[m])), b = e; _ < f; ++_)
      (b = Yg(v > 0 ? d[_] + " " + g : Ke(g, /&\f/g, d[_]))) && (l[h++] = b);
  return Ml(e, t, r, o === 0 ? Kd : s, l, u, c);
}
function hP(e, t, r) {
  return Ml(e, t, r, $g, Cl(lP()), ci(e, 2, -2), 0);
}
function rm(e, t, r, n) {
  return Ml(e, t, r, Xd, ci(e, 0, n), ci(e, n + 1, -1), n);
}
function Xo(e, t) {
  for (var r = "", n = Zd(e), o = 0; o < n; o++)
    r += t(e[o], o, e, t) || "";
  return r;
}
function gP(e, t, r, n) {
  switch (e.type) {
    case rP:
      if (e.children.length) break;
    case tP:
    case Xd:
      return e.return = e.return || e.value;
    case $g:
      return "";
    case Wg:
      return e.return = e.value + "{" + Xo(e.children, n) + "}";
    case Kd:
      e.value = e.props.join(",");
  }
  return en(r = Xo(e.children, n)) ? e.return = e.value + "{" + r + "}" : "";
}
function vP(e) {
  var t = Zd(e);
  return function(r, n, o, a) {
    for (var i = "", s = 0; s < t; s++)
      i += e[s](r, n, o, a) || "";
    return i;
  };
}
function yP(e) {
  return function(t) {
    t.root || (t = t.return) && e(t);
  };
}
function bP(e) {
  var t = /* @__PURE__ */ Object.create(null);
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var wP = function(t, r, n) {
  for (var o = 0, a = 0; o = a, a = sn(), o === 38 && a === 12 && (r[n] = 1), !ui(a); )
    gr();
  return Vi(t, ur);
}, xP = function(t, r) {
  var n = -1, o = 44;
  do
    switch (ui(o)) {
      case 0:
        o === 38 && sn() === 12 && (r[n] = 1), t[n] += wP(ur - 1, r, n);
        break;
      case 2:
        t[n] += Ts(o);
        break;
      case 4:
        if (o === 44) {
          t[++n] = sn() === 58 ? "&\f" : "", r[n] = t[n].length;
          break;
        }
      default:
        t[n] += Cl(o);
    }
  while (o = gr());
  return t;
}, _P = function(t, r) {
  return Ug(xP(jg(t), r));
}, nm = /* @__PURE__ */ new WeakMap(), SP = function(t) {
  if (!(t.type !== "rule" || !t.parent || // positive .length indicates that this rule contains pseudo
  // negative .length indicates that this rule has been already prefixed
  t.length < 1)) {
    for (var r = t.value, n = t.parent, o = t.column === n.column && t.line === n.line; n.type !== "rule"; )
      if (n = n.parent, !n) return;
    if (!(t.props.length === 1 && r.charCodeAt(0) !== 58 && !nm.get(n)) && !o) {
      nm.set(t, !0);
      for (var a = [], i = _P(r, a), s = n.props, l = 0, u = 0; l < i.length; l++)
        for (var c = 0; c < s.length; c++, u++)
          t.props[u] = a[l] ? i[l].replace(/&\f/g, s[c]) : s[c] + " " + i[l];
    }
  }
}, EP = function(t) {
  if (t.type === "decl") {
    var r = t.value;
    // charcode for l
    r.charCodeAt(0) === 108 && // charcode for b
    r.charCodeAt(2) === 98 && (t.return = "", t.value = "");
  }
};
function Hg(e, t) {
  switch (aP(e, t)) {
    case 5103:
      return Qe + "print-" + e + e;
    case 5737:
    case 4201:
    case 3177:
    case 3433:
    case 1641:
    case 4457:
    case 2921:
    case 5572:
    case 6356:
    case 5844:
    case 3191:
    case 6645:
    case 3005:
    case 6391:
    case 5879:
    case 5623:
    case 6135:
    case 4599:
    case 4855:
    case 4215:
    case 6389:
    case 5109:
    case 5365:
    case 5621:
    case 3829:
      return Qe + e + e;
    case 5349:
    case 4246:
    case 4810:
    case 6968:
    case 2756:
      return Qe + e + qs + e + Vt + e + e;
    case 6828:
    case 4268:
      return Qe + e + Vt + e + e;
    case 6165:
      return Qe + e + Vt + "flex-" + e + e;
    case 5187:
      return Qe + e + Ke(e, /(\w+).+(:[^]+)/, Qe + "box-$1$2" + Vt + "flex-$1$2") + e;
    case 5443:
      return Qe + e + Vt + "flex-item-" + Ke(e, /flex-|-self/, "") + e;
    case 4675:
      return Qe + e + Vt + "flex-line-pack" + Ke(e, /align-content|flex-|-self/, "") + e;
    case 5548:
      return Qe + e + Vt + Ke(e, "shrink", "negative") + e;
    case 5292:
      return Qe + e + Vt + Ke(e, "basis", "preferred-size") + e;
    case 6060:
      return Qe + "box-" + Ke(e, "-grow", "") + Qe + e + Vt + Ke(e, "grow", "positive") + e;
    case 4554:
      return Qe + Ke(e, /([^-])(transform)/g, "$1" + Qe + "$2") + e;
    case 6187:
      return Ke(Ke(Ke(e, /(zoom-|grab)/, Qe + "$1"), /(image-set)/, Qe + "$1"), e, "") + e;
    case 5495:
    case 3959:
      return Ke(e, /(image-set\([^]*)/, Qe + "$1$`$1");
    case 4968:
      return Ke(Ke(e, /(.+:)(flex-)?(.*)/, Qe + "box-pack:$3" + Vt + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + Qe + e + e;
    case 4095:
    case 3583:
    case 4068:
    case 2532:
      return Ke(e, /(.+)-inline(.+)/, Qe + "$1$2") + e;
    case 8116:
    case 7059:
    case 5753:
    case 5535:
    case 5445:
    case 5701:
    case 4933:
    case 4677:
    case 5533:
    case 5789:
    case 5021:
    case 4765:
      if (en(e) - 1 - t > 6) switch (Bt(e, t + 1)) {
        case 109:
          if (Bt(e, t + 4) !== 45) break;
        case 102:
          return Ke(e, /(.+:)(.+)-([^]+)/, "$1" + Qe + "$2-$3$1" + qs + (Bt(e, t + 3) == 108 ? "$3" : "$2-$3")) + e;
        case 115:
          return ~cu(e, "stretch") ? Hg(Ke(e, "stretch", "fill-available"), t) + e : e;
      }
      break;
    case 4949:
      if (Bt(e, t + 1) !== 115) break;
    case 6444:
      switch (Bt(e, en(e) - 3 - (~cu(e, "!important") && 10))) {
        case 107:
          return Ke(e, ":", ":" + Qe) + e;
        case 101:
          return Ke(e, /(.+:)([^;!]+)(;|!.+)?/, "$1" + Qe + (Bt(e, 14) === 45 ? "inline-" : "") + "box$3$1" + Qe + "$2$3$1" + Vt + "$2box$3") + e;
      }
      break;
    case 5936:
      switch (Bt(e, t + 11)) {
        case 114:
          return Qe + e + Vt + Ke(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
        case 108:
          return Qe + e + Vt + Ke(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
        case 45:
          return Qe + e + Vt + Ke(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
      }
      return Qe + e + Vt + e + e;
  }
  return e;
}
var TP = function(t, r, n, o) {
  if (t.length > -1 && !t.return) switch (t.type) {
    case Xd:
      t.return = Hg(t.value, t.length);
      break;
    case Wg:
      return Xo([La(t, {
        value: Ke(t.value, "@", "@" + Qe)
      })], o);
    case Kd:
      if (t.length) return sP(t.props, function(a) {
        switch (iP(a, /(::plac\w+|:read-\w+)/)) {
          case ":read-only":
          case ":read-write":
            return Xo([La(t, {
              props: [Ke(a, /:(read-\w+)/, ":" + qs + "$1")]
            })], o);
          case "::placeholder":
            return Xo([La(t, {
              props: [Ke(a, /:(plac\w+)/, ":" + Qe + "input-$1")]
            }), La(t, {
              props: [Ke(a, /:(plac\w+)/, ":" + qs + "$1")]
            }), La(t, {
              props: [Ke(a, /:(plac\w+)/, Vt + "input-$1")]
            })], o);
        }
        return "";
      });
  }
}, kP = [TP], OP = function(t) {
  var r = t.key;
  if (r === "css") {
    var n = document.querySelectorAll("style[data-emotion]:not([data-s])");
    Array.prototype.forEach.call(n, function(v) {
      var h = v.getAttribute("data-emotion");
      h.indexOf(" ") !== -1 && (document.head.appendChild(v), v.setAttribute("data-s", ""));
    });
  }
  var o = t.stylisPlugins || kP, a = {}, i, s = [];
  i = t.container || document.head, Array.prototype.forEach.call(
    // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll('style[data-emotion^="' + r + ' "]'),
    function(v) {
      for (var h = v.getAttribute("data-emotion").split(" "), _ = 1; _ < h.length; _++)
        a[h[_]] = !0;
      s.push(v);
    }
  );
  var l, u = [SP, EP];
  {
    var c, p = [gP, yP(function(v) {
      c.insert(v);
    })], d = vP(u.concat(o, p)), f = function(h) {
      return Xo(mP(h), d);
    };
    l = function(h, _, g, b) {
      c = g, f(h ? h + "{" + _.styles + "}" : _.styles), b && (m.inserted[_.name] = !0);
    };
  }
  var m = {
    key: r,
    sheet: new eP({
      key: r,
      container: i,
      nonce: t.nonce,
      speedy: t.speedy,
      prepend: t.prepend,
      insertionPoint: t.insertionPoint
    }),
    nonce: t.nonce,
    inserted: a,
    registered: {},
    insert: l
  };
  return m.sheet.hydrate(s), m;
}, du = { exports: {} }, tt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var om;
function DP() {
  if (om) return tt;
  om = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
  function b(E) {
    if (typeof E == "object" && E !== null) {
      var O = E.$$typeof;
      switch (O) {
        case t:
          switch (E = E.type, E) {
            case l:
            case u:
            case n:
            case a:
            case o:
            case p:
              return E;
            default:
              switch (E = E && E.$$typeof, E) {
                case s:
                case c:
                case m:
                case f:
                case i:
                  return E;
                default:
                  return O;
              }
          }
        case r:
          return O;
      }
    }
  }
  function x(E) {
    return b(E) === u;
  }
  return tt.AsyncMode = l, tt.ConcurrentMode = u, tt.ContextConsumer = s, tt.ContextProvider = i, tt.Element = t, tt.ForwardRef = c, tt.Fragment = n, tt.Lazy = m, tt.Memo = f, tt.Portal = r, tt.Profiler = a, tt.StrictMode = o, tt.Suspense = p, tt.isAsyncMode = function(E) {
    return x(E) || b(E) === l;
  }, tt.isConcurrentMode = x, tt.isContextConsumer = function(E) {
    return b(E) === s;
  }, tt.isContextProvider = function(E) {
    return b(E) === i;
  }, tt.isElement = function(E) {
    return typeof E == "object" && E !== null && E.$$typeof === t;
  }, tt.isForwardRef = function(E) {
    return b(E) === c;
  }, tt.isFragment = function(E) {
    return b(E) === n;
  }, tt.isLazy = function(E) {
    return b(E) === m;
  }, tt.isMemo = function(E) {
    return b(E) === f;
  }, tt.isPortal = function(E) {
    return b(E) === r;
  }, tt.isProfiler = function(E) {
    return b(E) === a;
  }, tt.isStrictMode = function(E) {
    return b(E) === o;
  }, tt.isSuspense = function(E) {
    return b(E) === p;
  }, tt.isValidElementType = function(E) {
    return typeof E == "string" || typeof E == "function" || E === n || E === u || E === a || E === o || E === p || E === d || typeof E == "object" && E !== null && (E.$$typeof === m || E.$$typeof === f || E.$$typeof === i || E.$$typeof === s || E.$$typeof === c || E.$$typeof === h || E.$$typeof === _ || E.$$typeof === g || E.$$typeof === v);
  }, tt.typeOf = b, tt;
}
var rt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var am;
function NP() {
  return am || (am = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, d = e ? Symbol.for("react.suspense_list") : 60120, f = e ? Symbol.for("react.memo") : 60115, m = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, h = e ? Symbol.for("react.fundamental") : 60117, _ = e ? Symbol.for("react.responder") : 60118, g = e ? Symbol.for("react.scope") : 60119;
    function b(Z) {
      return typeof Z == "string" || typeof Z == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Z === n || Z === u || Z === a || Z === o || Z === p || Z === d || typeof Z == "object" && Z !== null && (Z.$$typeof === m || Z.$$typeof === f || Z.$$typeof === i || Z.$$typeof === s || Z.$$typeof === c || Z.$$typeof === h || Z.$$typeof === _ || Z.$$typeof === g || Z.$$typeof === v);
    }
    function x(Z) {
      if (typeof Z == "object" && Z !== null) {
        var Pe = Z.$$typeof;
        switch (Pe) {
          case t:
            var J = Z.type;
            switch (J) {
              case l:
              case u:
              case n:
              case a:
              case o:
              case p:
                return J;
              default:
                var Ne = J && J.$$typeof;
                switch (Ne) {
                  case s:
                  case c:
                  case m:
                  case f:
                  case i:
                    return Ne;
                  default:
                    return Pe;
                }
            }
          case r:
            return Pe;
        }
      }
    }
    var E = l, O = u, P = s, y = i, w = t, S = c, k = n, T = m, R = f, I = r, C = a, A = o, D = p, N = !1;
    function M(Z) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), W(Z) || x(Z) === l;
    }
    function W(Z) {
      return x(Z) === u;
    }
    function B(Z) {
      return x(Z) === s;
    }
    function j(Z) {
      return x(Z) === i;
    }
    function q(Z) {
      return typeof Z == "object" && Z !== null && Z.$$typeof === t;
    }
    function se(Z) {
      return x(Z) === c;
    }
    function te(Z) {
      return x(Z) === n;
    }
    function le(Z) {
      return x(Z) === m;
    }
    function ke(Z) {
      return x(Z) === f;
    }
    function at(Z) {
      return x(Z) === r;
    }
    function _t(Z) {
      return x(Z) === a;
    }
    function Pt(Z) {
      return x(Z) === o;
    }
    function pe(Z) {
      return x(Z) === p;
    }
    rt.AsyncMode = E, rt.ConcurrentMode = O, rt.ContextConsumer = P, rt.ContextProvider = y, rt.Element = w, rt.ForwardRef = S, rt.Fragment = k, rt.Lazy = T, rt.Memo = R, rt.Portal = I, rt.Profiler = C, rt.StrictMode = A, rt.Suspense = D, rt.isAsyncMode = M, rt.isConcurrentMode = W, rt.isContextConsumer = B, rt.isContextProvider = j, rt.isElement = q, rt.isForwardRef = se, rt.isFragment = te, rt.isLazy = le, rt.isMemo = ke, rt.isPortal = at, rt.isProfiler = _t, rt.isStrictMode = Pt, rt.isSuspense = pe, rt.isValidElementType = b, rt.typeOf = x;
  }()), rt;
}
process.env.NODE_ENV === "production" ? du.exports = DP() : du.exports = NP();
var CP = du.exports, Vg = CP, PP = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, MP = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, zg = {};
zg[Vg.ForwardRef] = PP;
zg[Vg.Memo] = MP;
var RP = !0;
function qg(e, t, r) {
  var n = "";
  return r.split(" ").forEach(function(o) {
    e[o] !== void 0 ? t.push(e[o] + ";") : n += o + " ";
  }), n;
}
var Jd = function(t, r, n) {
  var o = t.key + "-" + r.name;
  // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (n === !1 || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  RP === !1) && t.registered[o] === void 0 && (t.registered[o] = r.styles);
}, Gg = function(t, r, n) {
  Jd(t, r, n);
  var o = t.key + "-" + r.name;
  if (t.inserted[r.name] === void 0) {
    var a = r;
    do
      t.insert(r === a ? "." + o : "", a, t.sheet, !0), a = a.next;
    while (a !== void 0);
  }
};
function AP(e) {
  for (var t = 0, r, n = 0, o = e.length; o >= 4; ++n, o -= 4)
    r = e.charCodeAt(n) & 255 | (e.charCodeAt(++n) & 255) << 8 | (e.charCodeAt(++n) & 255) << 16 | (e.charCodeAt(++n) & 255) << 24, r = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16), r ^= /* k >>> r: */
    r >>> 24, t = /* Math.imul(k, m): */
    (r & 65535) * 1540483477 + ((r >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  switch (o) {
    case 3:
      t ^= (e.charCodeAt(n + 2) & 255) << 16;
    case 2:
      t ^= (e.charCodeAt(n + 1) & 255) << 8;
    case 1:
      t ^= e.charCodeAt(n) & 255, t = /* Math.imul(h, m): */
      (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16);
  }
  return t ^= t >>> 13, t = /* Math.imul(h, m): */
  (t & 65535) * 1540483477 + ((t >>> 16) * 59797 << 16), ((t ^ t >>> 15) >>> 0).toString(36);
}
var IP = {
  animationIterationCount: 1,
  aspectRatio: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  scale: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
}, FP = !1, LP = /[A-Z]|^ms/g, $P = /_EMO_([^_]+?)_([^]*?)_EMO_/g, Qg = function(t) {
  return t.charCodeAt(1) === 45;
}, im = function(t) {
  return t != null && typeof t != "boolean";
}, _c = /* @__PURE__ */ bP(function(e) {
  return Qg(e) ? e : e.replace(LP, "-$&").toLowerCase();
}), sm = function(t, r) {
  switch (t) {
    case "animation":
    case "animationName":
      if (typeof r == "string")
        return r.replace($P, function(n, o, a) {
          return tn = {
            name: o,
            styles: a,
            next: tn
          }, o;
        });
  }
  return IP[t] !== 1 && !Qg(t) && typeof r == "number" && r !== 0 ? r + "px" : r;
}, WP = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function di(e, t, r) {
  if (r == null)
    return "";
  var n = r;
  if (n.__emotion_styles !== void 0)
    return n;
  switch (typeof r) {
    case "boolean":
      return "";
    case "object": {
      var o = r;
      if (o.anim === 1)
        return tn = {
          name: o.name,
          styles: o.styles,
          next: tn
        }, o.name;
      var a = r;
      if (a.styles !== void 0) {
        var i = a.next;
        if (i !== void 0)
          for (; i !== void 0; )
            tn = {
              name: i.name,
              styles: i.styles,
              next: tn
            }, i = i.next;
        var s = a.styles + ";";
        return s;
      }
      return YP(e, t, r);
    }
    case "function": {
      if (e !== void 0) {
        var l = tn, u = r(e);
        return tn = l, di(e, t, u);
      }
      break;
    }
  }
  var c = r;
  if (t == null)
    return c;
  var p = t[c];
  return p !== void 0 ? p : c;
}
function YP(e, t, r) {
  var n = "";
  if (Array.isArray(r))
    for (var o = 0; o < r.length; o++)
      n += di(e, t, r[o]) + ";";
  else
    for (var a in r) {
      var i = r[a];
      if (typeof i != "object") {
        var s = i;
        t != null && t[s] !== void 0 ? n += a + "{" + t[s] + "}" : im(s) && (n += _c(a) + ":" + sm(a, s) + ";");
      } else {
        if (a === "NO_COMPONENT_SELECTOR" && FP)
          throw new Error(WP);
        if (Array.isArray(i) && typeof i[0] == "string" && (t == null || t[i[0]] === void 0))
          for (var l = 0; l < i.length; l++)
            im(i[l]) && (n += _c(a) + ":" + sm(a, i[l]) + ";");
        else {
          var u = di(e, t, i);
          switch (a) {
            case "animation":
            case "animationName": {
              n += _c(a) + ":" + u + ";";
              break;
            }
            default:
              n += a + "{" + u + "}";
          }
        }
      }
    }
  return n;
}
var lm = /label:\s*([^\s;\n{]+)\s*(;|$)/g, tn;
function ef(e, t, r) {
  if (e.length === 1 && typeof e[0] == "object" && e[0] !== null && e[0].styles !== void 0)
    return e[0];
  var n = !0, o = "";
  tn = void 0;
  var a = e[0];
  if (a == null || a.raw === void 0)
    n = !1, o += di(r, t, a);
  else {
    var i = a;
    o += i[0];
  }
  for (var s = 1; s < e.length; s++)
    if (o += di(r, t, e[s]), n) {
      var l = a;
      o += l[s];
    }
  lm.lastIndex = 0;
  for (var u = "", c; (c = lm.exec(o)) !== null; )
    u += "-" + c[1];
  var p = AP(o) + u;
  return {
    name: p,
    styles: o,
    next: tn
  };
}
var BP = function(t) {
  return t();
}, jP = Q.useInsertionEffect ? Q.useInsertionEffect : !1, Kg = jP || BP, fu = !1, Xg = /* @__PURE__ */ Q.createContext(
  // we're doing this to avoid preconstruct's dead code elimination in this one case
  // because this module is primarily intended for the browser and node
  // but it's also required in react native and similar environments sometimes
  // and we could have a special build just for that
  // but this is much easier and the native packages
  // might use a different theme context in the future anyway
  typeof HTMLElement < "u" ? /* @__PURE__ */ OP({
    key: "css"
  }) : null
);
Xg.Provider;
var Zg = function(t) {
  return /* @__PURE__ */ na(function(r, n) {
    var o = Oe(Xg);
    return t(r, o, n);
  });
}, Jg = /* @__PURE__ */ Q.createContext({}), tf = {}.hasOwnProperty, pu = "__EMOTION_TYPE_PLEASE_DO_NOT_USE__", UP = function(t, r) {
  var n = {};
  for (var o in r)
    tf.call(r, o) && (n[o] = r[o]);
  return n[pu] = t, n;
}, HP = function(t) {
  var r = t.cache, n = t.serialized, o = t.isStringTag;
  return Jd(r, n, o), Kg(function() {
    return Gg(r, n, o);
  }), null;
}, VP = /* @__PURE__ */ Zg(
  /* <any, any> */
  function(e, t, r) {
    var n = e.css;
    typeof n == "string" && t.registered[n] !== void 0 && (n = t.registered[n]);
    var o = e[pu], a = [n], i = "";
    typeof e.className == "string" ? i = qg(t.registered, a, e.className) : e.className != null && (i = e.className + " ");
    var s = ef(a, void 0, Q.useContext(Jg));
    i += t.key + "-" + s.name;
    var l = {};
    for (var u in e)
      tf.call(e, u) && u !== "css" && u !== pu && !fu && (l[u] = e[u]);
    return l.className = i, r && (l.ref = r), /* @__PURE__ */ Q.createElement(Q.Fragment, null, /* @__PURE__ */ Q.createElement(HP, {
      cache: t,
      serialized: s,
      isStringTag: typeof o == "string"
    }), /* @__PURE__ */ Q.createElement(o, l));
  }
), zP = VP;
function e1() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return ef(t);
}
var oe = function() {
  var t = e1.apply(void 0, arguments), r = "animation-" + t.name;
  return {
    name: r,
    styles: "@keyframes " + r + "{" + t.styles + "}",
    anim: 1,
    toString: function() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
}, qP = function e(t) {
  for (var r = t.length, n = 0, o = ""; n < r; n++) {
    var a = t[n];
    if (a != null) {
      var i = void 0;
      switch (typeof a) {
        case "boolean":
          break;
        case "object": {
          if (Array.isArray(a))
            i = e(a);
          else {
            i = "";
            for (var s in a)
              a[s] && s && (i && (i += " "), i += s);
          }
          break;
        }
        default:
          i = a;
      }
      i && (o && (o += " "), o += i);
    }
  }
  return o;
};
function GP(e, t, r) {
  var n = [], o = qg(e, n, r);
  return n.length < 2 ? r : o + t(n);
}
var QP = function(t) {
  var r = t.cache, n = t.serializedArr;
  return Kg(function() {
    for (var o = 0; o < n.length; o++)
      Gg(r, n[o], !1);
  }), null;
}, Sc = /* @__PURE__ */ Zg(function(e, t) {
  var r = !1, n = [], o = function() {
    if (r && fu)
      throw new Error("css can only be used during render");
    for (var u = arguments.length, c = new Array(u), p = 0; p < u; p++)
      c[p] = arguments[p];
    var d = ef(c, t.registered);
    return n.push(d), Jd(t, d, !1), t.key + "-" + d.name;
  }, a = function() {
    if (r && fu)
      throw new Error("cx can only be used during render");
    for (var u = arguments.length, c = new Array(u), p = 0; p < u; p++)
      c[p] = arguments[p];
    return GP(t.registered, o, qP(c));
  }, i = {
    css: o,
    cx: a,
    theme: Q.useContext(Jg)
  }, s = e.children(i);
  return r = !0, /* @__PURE__ */ Q.createElement(Q.Fragment, null, /* @__PURE__ */ Q.createElement(QP, {
    cache: t,
    serializedArr: n
  }), s);
}), KP = Ec.Fragment;
function Yt(e, t, r) {
  return tf.call(t, "css") ? Ec.jsx(zP, UP(e, t), r) : Ec.jsx(e, t, r);
}
var XP = Object.defineProperty, ZP = (e, t, r) => t in e ? XP(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[t] = r, gs = (e, t, r) => ZP(e, typeof t != "symbol" ? t + "" : t, r), mu = /* @__PURE__ */ new Map(), vs = /* @__PURE__ */ new WeakMap(), cm = 0, JP = void 0;
function e5(e) {
  return e ? (vs.has(e) || (cm += 1, vs.set(e, cm.toString())), vs.get(e)) : "0";
}
function t5(e) {
  return Object.keys(e).sort().filter(
    (t) => e[t] !== void 0
  ).map((t) => `${t}_${t === "root" ? e5(e.root) : e[t]}`).toString();
}
function r5(e) {
  const t = t5(e);
  let r = mu.get(t);
  if (!r) {
    const n = /* @__PURE__ */ new Map();
    let o;
    const a = new IntersectionObserver((i) => {
      i.forEach((s) => {
        var l;
        const u = s.isIntersecting && o.some((c) => s.intersectionRatio >= c);
        e.trackVisibility && typeof s.isVisible > "u" && (s.isVisible = u), (l = n.get(s.target)) == null || l.forEach((c) => {
          c(u, s);
        });
      });
    }, e);
    o = a.thresholds || (Array.isArray(e.threshold) ? e.threshold : [e.threshold || 0]), r = {
      id: t,
      observer: a,
      elements: n
    }, mu.set(t, r);
  }
  return r;
}
function t1(e, t, r = {}, n = JP) {
  if (typeof window.IntersectionObserver > "u" && n !== void 0) {
    const l = e.getBoundingClientRect();
    return t(n, {
      isIntersecting: n,
      target: e,
      intersectionRatio: typeof r.threshold == "number" ? r.threshold : 0,
      time: 0,
      boundingClientRect: l,
      intersectionRect: l,
      rootBounds: l
    }), () => {
    };
  }
  const { id: o, observer: a, elements: i } = r5(r), s = i.get(e) || [];
  return i.has(e) || i.set(e, s), s.push(t), a.observe(e), function() {
    s.splice(s.indexOf(t), 1), s.length === 0 && (i.delete(e), a.unobserve(e)), i.size === 0 && (a.disconnect(), mu.delete(o));
  };
}
function n5(e) {
  return typeof e.children != "function";
}
var um = class extends Q.Component {
  constructor(e) {
    super(e), gs(this, "node", null), gs(this, "_unobserveCb", null), gs(this, "handleNode", (t) => {
      this.node && (this.unobserve(), !t && !this.props.triggerOnce && !this.props.skip && this.setState({ inView: !!this.props.initialInView, entry: void 0 })), this.node = t || null, this.observeNode();
    }), gs(this, "handleChange", (t, r) => {
      t && this.props.triggerOnce && this.unobserve(), n5(this.props) || this.setState({ inView: t, entry: r }), this.props.onChange && this.props.onChange(t, r);
    }), this.state = {
      inView: !!e.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve(), this.observeNode();
  }
  componentDidUpdate(e) {
    (e.rootMargin !== this.props.rootMargin || e.root !== this.props.root || e.threshold !== this.props.threshold || e.skip !== this.props.skip || e.trackVisibility !== this.props.trackVisibility || e.delay !== this.props.delay) && (this.unobserve(), this.observeNode());
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold: e,
      root: t,
      rootMargin: r,
      trackVisibility: n,
      delay: o,
      fallbackInView: a
    } = this.props;
    this._unobserveCb = t1(
      this.node,
      this.handleChange,
      {
        threshold: e,
        root: t,
        rootMargin: r,
        // @ts-ignore
        trackVisibility: n,
        // @ts-ignore
        delay: o
      },
      a
    );
  }
  unobserve() {
    this._unobserveCb && (this._unobserveCb(), this._unobserveCb = null);
  }
  render() {
    const { children: e } = this.props;
    if (typeof e == "function") {
      const { inView: f, entry: m } = this.state;
      return e({ inView: f, entry: m, ref: this.handleNode });
    }
    const {
      as: t,
      triggerOnce: r,
      threshold: n,
      root: o,
      rootMargin: a,
      onChange: i,
      skip: s,
      trackVisibility: l,
      delay: u,
      initialInView: c,
      fallbackInView: p,
      ...d
    } = this.props;
    return Q.createElement(
      t || "div",
      { ref: this.handleNode, ...d },
      e
    );
  }
};
function r1({
  threshold: e,
  delay: t,
  trackVisibility: r,
  rootMargin: n,
  root: o,
  triggerOnce: a,
  skip: i,
  initialInView: s,
  fallbackInView: l,
  onChange: u
} = {}) {
  var c;
  const [p, d] = Q.useState(null), f = Q.useRef(), [m, v] = Q.useState({
    inView: !!s,
    entry: void 0
  });
  f.current = u, Q.useEffect(
    () => {
      if (i || !p) return;
      let b;
      return b = t1(
        p,
        (x, E) => {
          v({
            inView: x,
            entry: E
          }), f.current && f.current(x, E), E.isIntersecting && a && b && (b(), b = void 0);
        },
        {
          root: o,
          rootMargin: n,
          threshold: e,
          // @ts-ignore
          trackVisibility: r,
          // @ts-ignore
          delay: t
        },
        l
      ), () => {
        b && b();
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(e) ? e.toString() : e,
      p,
      o,
      n,
      a,
      i,
      r,
      l,
      t
    ]
  );
  const h = (c = m.entry) == null ? void 0 : c.target, _ = Q.useRef();
  !p && h && !a && !i && _.current !== h && (_.current = h, v({
    inView: !!s,
    entry: void 0
  }));
  const g = [d, m.inView, m.entry];
  return g.ref = g[0], g.inView = g[1], g.entry = g[2], g;
}
var hu = { exports: {} }, nt = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dm;
function o5() {
  if (dm) return nt;
  dm = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), m;
  m = Symbol.for("react.module.reference");
  function v(h) {
    if (typeof h == "object" && h !== null) {
      var _ = h.$$typeof;
      switch (_) {
        case e:
          switch (h = h.type, h) {
            case r:
            case o:
            case n:
            case u:
            case c:
              return h;
            default:
              switch (h = h && h.$$typeof, h) {
                case s:
                case i:
                case l:
                case d:
                case p:
                case a:
                  return h;
                default:
                  return _;
              }
          }
        case t:
          return _;
      }
    }
  }
  return nt.ContextConsumer = i, nt.ContextProvider = a, nt.Element = e, nt.ForwardRef = l, nt.Fragment = r, nt.Lazy = d, nt.Memo = p, nt.Portal = t, nt.Profiler = o, nt.StrictMode = n, nt.Suspense = u, nt.SuspenseList = c, nt.isAsyncMode = function() {
    return !1;
  }, nt.isConcurrentMode = function() {
    return !1;
  }, nt.isContextConsumer = function(h) {
    return v(h) === i;
  }, nt.isContextProvider = function(h) {
    return v(h) === a;
  }, nt.isElement = function(h) {
    return typeof h == "object" && h !== null && h.$$typeof === e;
  }, nt.isForwardRef = function(h) {
    return v(h) === l;
  }, nt.isFragment = function(h) {
    return v(h) === r;
  }, nt.isLazy = function(h) {
    return v(h) === d;
  }, nt.isMemo = function(h) {
    return v(h) === p;
  }, nt.isPortal = function(h) {
    return v(h) === t;
  }, nt.isProfiler = function(h) {
    return v(h) === o;
  }, nt.isStrictMode = function(h) {
    return v(h) === n;
  }, nt.isSuspense = function(h) {
    return v(h) === u;
  }, nt.isSuspenseList = function(h) {
    return v(h) === c;
  }, nt.isValidElementType = function(h) {
    return typeof h == "string" || typeof h == "function" || h === r || h === o || h === n || h === u || h === c || h === f || typeof h == "object" && h !== null && (h.$$typeof === d || h.$$typeof === p || h.$$typeof === a || h.$$typeof === i || h.$$typeof === l || h.$$typeof === m || h.getModuleId !== void 0);
  }, nt.typeOf = v, nt;
}
var ot = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var fm;
function a5() {
  return fm || (fm = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), n = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), c = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), d = Symbol.for("react.lazy"), f = Symbol.for("react.offscreen"), m = !1, v = !1, h = !1, _ = !1, g = !1, b;
    b = Symbol.for("react.module.reference");
    function x(J) {
      return !!(typeof J == "string" || typeof J == "function" || J === r || J === o || g || J === n || J === u || J === c || _ || J === f || m || v || h || typeof J == "object" && J !== null && (J.$$typeof === d || J.$$typeof === p || J.$$typeof === a || J.$$typeof === i || J.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      J.$$typeof === b || J.getModuleId !== void 0));
    }
    function E(J) {
      if (typeof J == "object" && J !== null) {
        var Ne = J.$$typeof;
        switch (Ne) {
          case e:
            var St = J.type;
            switch (St) {
              case r:
              case o:
              case n:
              case u:
              case c:
                return St;
              default:
                var Et = St && St.$$typeof;
                switch (Et) {
                  case s:
                  case i:
                  case l:
                  case d:
                  case p:
                  case a:
                    return Et;
                  default:
                    return Ne;
                }
            }
          case t:
            return Ne;
        }
      }
    }
    var O = i, P = a, y = e, w = l, S = r, k = d, T = p, R = t, I = o, C = n, A = u, D = c, N = !1, M = !1;
    function W(J) {
      return N || (N = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function B(J) {
      return M || (M = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function j(J) {
      return E(J) === i;
    }
    function q(J) {
      return E(J) === a;
    }
    function se(J) {
      return typeof J == "object" && J !== null && J.$$typeof === e;
    }
    function te(J) {
      return E(J) === l;
    }
    function le(J) {
      return E(J) === r;
    }
    function ke(J) {
      return E(J) === d;
    }
    function at(J) {
      return E(J) === p;
    }
    function _t(J) {
      return E(J) === t;
    }
    function Pt(J) {
      return E(J) === o;
    }
    function pe(J) {
      return E(J) === n;
    }
    function Z(J) {
      return E(J) === u;
    }
    function Pe(J) {
      return E(J) === c;
    }
    ot.ContextConsumer = O, ot.ContextProvider = P, ot.Element = y, ot.ForwardRef = w, ot.Fragment = S, ot.Lazy = k, ot.Memo = T, ot.Portal = R, ot.Profiler = I, ot.StrictMode = C, ot.Suspense = A, ot.SuspenseList = D, ot.isAsyncMode = W, ot.isConcurrentMode = B, ot.isContextConsumer = j, ot.isContextProvider = q, ot.isElement = se, ot.isForwardRef = te, ot.isFragment = le, ot.isLazy = ke, ot.isMemo = at, ot.isPortal = _t, ot.isProfiler = Pt, ot.isStrictMode = pe, ot.isSuspense = Z, ot.isSuspenseList = Pe, ot.isValidElementType = x, ot.typeOf = E;
  }()), ot;
}
process.env.NODE_ENV === "production" ? hu.exports = o5() : hu.exports = a5();
var i5 = hu.exports;
oe`
  from,
  20%,
  53%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0);
  }

  40%,
  43% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -30px, 0) scaleY(1.1);
  }

  70% {
    animation-timing-function: cubic-bezier(0.755, 0.05, 0.855, 0.06);
    transform: translate3d(0, -15px, 0) scaleY(1.05);
  }

  80% {
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    transform: translate3d(0, 0, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, -4px, 0) scaleY(1.02);
  }
`;
oe`
  from,
  50%,
  to {
    opacity: 1;
  }

  25%,
  75% {
    opacity: 0;
  }
`;
oe`
  0% {
    transform: translateX(0);
  }

  6.5% {
    transform: translateX(-6px) rotateY(-9deg);
  }

  18.5% {
    transform: translateX(5px) rotateY(7deg);
  }

  31.5% {
    transform: translateX(-3px) rotateY(-5deg);
  }

  43.5% {
    transform: translateX(2px) rotateY(3deg);
  }

  50% {
    transform: translateX(0);
  }
`;
oe`
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.3);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.3);
  }

  70% {
    transform: scale(1);
  }
`;
oe`
  from,
  11.1%,
  to {
    transform: translate3d(0, 0, 0);
  }

  22.2% {
    transform: skewX(-12.5deg) skewY(-12.5deg);
  }

  33.3% {
    transform: skewX(6.25deg) skewY(6.25deg);
  }

  44.4% {
    transform: skewX(-3.125deg) skewY(-3.125deg);
  }

  55.5% {
    transform: skewX(1.5625deg) skewY(1.5625deg);
  }

  66.6% {
    transform: skewX(-0.78125deg) skewY(-0.78125deg);
  }

  77.7% {
    transform: skewX(0.390625deg) skewY(0.390625deg);
  }

  88.8% {
    transform: skewX(-0.1953125deg) skewY(-0.1953125deg);
  }
`;
oe`
  from {
    transform: scale3d(1, 1, 1);
  }

  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;
oe`
  from {
    transform: scale3d(1, 1, 1);
  }

  30% {
    transform: scale3d(1.25, 0.75, 1);
  }

  40% {
    transform: scale3d(0.75, 1.25, 1);
  }

  50% {
    transform: scale3d(1.15, 0.85, 1);
  }

  65% {
    transform: scale3d(0.95, 1.05, 1);
  }

  75% {
    transform: scale3d(1.05, 0.95, 1);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;
oe`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
`;
oe`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(10px, 0, 0);
  }
`;
oe`
  from,
  to {
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    transform: translate3d(0, -10px, 0);
  }

  20%,
  40%,
  60%,
  80% {
    transform: translate3d(0, 10px, 0);
  }
`;
oe`
  20% {
    transform: rotate3d(0, 0, 1, 15deg);
  }

  40% {
    transform: rotate3d(0, 0, 1, -10deg);
  }

  60% {
    transform: rotate3d(0, 0, 1, 5deg);
  }

  80% {
    transform: rotate3d(0, 0, 1, -5deg);
  }

  to {
    transform: rotate3d(0, 0, 1, 0deg);
  }
`;
oe`
  from {
    transform: scale3d(1, 1, 1);
  }

  10%,
  20% {
    transform: scale3d(0.9, 0.9, 0.9) rotate3d(0, 0, 1, -3deg);
  }

  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, 3deg);
  }

  40%,
  60%,
  80% {
    transform: scale3d(1.1, 1.1, 1.1) rotate3d(0, 0, 1, -3deg);
  }

  to {
    transform: scale3d(1, 1, 1);
  }
`;
oe`
  from {
    transform: translate3d(0, 0, 0);
  }

  15% {
    transform: translate3d(-25%, 0, 0) rotate3d(0, 0, 1, -5deg);
  }

  30% {
    transform: translate3d(20%, 0, 0) rotate3d(0, 0, 1, 3deg);
  }

  45% {
    transform: translate3d(-15%, 0, 0) rotate3d(0, 0, 1, -3deg);
  }

  60% {
    transform: translate3d(10%, 0, 0) rotate3d(0, 0, 1, 2deg);
  }

  75% {
    transform: translate3d(-5%, 0, 0) rotate3d(0, 0, 1, -1deg);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
const n1 = oe`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
function s5({
  duration: e = 1e3,
  delay: t = 0,
  timingFunction: r = "ease",
  keyframes: n = n1,
  iterationCount: o = 1
}) {
  return e1`
    animation-duration: ${e}ms;
    animation-timing-function: ${r};
    animation-delay: ${t}ms;
    animation-name: ${n};
    animation-direction: normal;
    animation-fill-mode: both;
    animation-iteration-count: ${o};

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }
  `;
}
function l5(e) {
  return e == null;
}
function c5(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean";
}
function o1(e, t) {
  return (r) => r ? e() : t();
}
function fi(e) {
  return o1(e, () => null);
}
function gu(e) {
  return fi(() => ({ opacity: 0 }))(e);
}
const a1 = (e) => {
  const {
    cascade: t = !1,
    damping: r = 0.5,
    delay: n = 0,
    duration: o = 1e3,
    fraction: a = 0,
    keyframes: i = n1,
    triggerOnce: s = !1,
    className: l,
    style: u,
    childClassName: c,
    childStyle: p,
    children: d,
    onVisibilityChange: f
  } = e, m = ae(
    () => s5({
      keyframes: i,
      duration: o
    }),
    [o, i]
  );
  return l5(d) ? null : c5(d) ? /* @__PURE__ */ Yt(d5, { ...e, animationStyles: m, children: String(d) }) : i5.isFragment(d) ? /* @__PURE__ */ Yt(i1, { ...e, animationStyles: m }) : /* @__PURE__ */ Yt(KP, { children: v1.map(d, (v, h) => {
    if (!pm(v)) return null;
    const _ = n + (t ? h * o * r : 0);
    switch (v.type) {
      case "ol":
      case "ul":
        return /* @__PURE__ */ Yt(Sc, { children: ({ cx: g }) => /* @__PURE__ */ Yt(
          v.type,
          {
            ...v.props,
            className: g(l, v.props.className),
            style: Object.assign({}, u, v.props.style),
            children: /* @__PURE__ */ Yt(a1, { ...e, children: v.props.children })
          }
        ) });
      case "li":
        return /* @__PURE__ */ Yt(
          um,
          {
            threshold: a,
            triggerOnce: s,
            onChange: f,
            children: ({ inView: g, ref: b }) => /* @__PURE__ */ Yt(Sc, { children: ({ cx: x }) => /* @__PURE__ */ Yt(
              v.type,
              {
                ...v.props,
                ref: b,
                className: x(c, v.props.className),
                css: fi(() => m)(g),
                style: Object.assign(
                  {},
                  p,
                  v.props.style,
                  gu(!g),
                  {
                    animationDelay: _ + "ms"
                  }
                )
              }
            ) })
          }
        );
      default:
        return /* @__PURE__ */ Yt(
          um,
          {
            threshold: a,
            triggerOnce: s,
            onChange: f,
            children: ({ inView: g, ref: b }) => /* @__PURE__ */ Yt(
              "div",
              {
                ref: b,
                className: l,
                css: fi(() => m)(g),
                style: Object.assign({}, u, gu(!g), {
                  animationDelay: _ + "ms"
                }),
                children: /* @__PURE__ */ Yt(Sc, { children: ({ cx: x }) => /* @__PURE__ */ Yt(
                  v.type,
                  {
                    ...v.props,
                    className: x(c, v.props.className),
                    style: Object.assign(
                      {},
                      p,
                      v.props.style
                    )
                  }
                ) })
              }
            )
          }
        );
    }
  }) });
}, u5 = {
  display: "inline-block",
  whiteSpace: "pre"
}, d5 = (e) => {
  const {
    animationStyles: t,
    cascade: r = !1,
    damping: n = 0.5,
    delay: o = 0,
    duration: a = 1e3,
    fraction: i = 0,
    triggerOnce: s = !1,
    className: l,
    style: u,
    children: c,
    onVisibilityChange: p
  } = e, { ref: d, inView: f } = r1({
    triggerOnce: s,
    threshold: i,
    onChange: p
  });
  return o1(
    () => /* @__PURE__ */ Yt(
      "div",
      {
        ref: d,
        className: l,
        style: Object.assign({}, u, u5),
        children: c.split("").map((m, v) => /* @__PURE__ */ Yt(
          "span",
          {
            css: fi(() => t)(f),
            style: {
              animationDelay: o + v * a * n + "ms"
            },
            children: m
          },
          v
        ))
      }
    ),
    () => /* @__PURE__ */ Yt(i1, { ...e, children: c })
  )(r);
}, i1 = (e) => {
  const {
    animationStyles: t,
    fraction: r = 0,
    triggerOnce: n = !1,
    className: o,
    style: a,
    children: i,
    onVisibilityChange: s
  } = e, { ref: l, inView: u } = r1({
    triggerOnce: n,
    threshold: r,
    onChange: s
  });
  return /* @__PURE__ */ Yt(
    "div",
    {
      ref: l,
      className: o,
      css: fi(() => t)(u),
      style: Object.assign({}, a, gu(!u)),
      children: i
    }
  );
};
oe`
  from,
  20%,
  40%,
  60%,
  80%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  20% {
    transform: scale3d(1.1, 1.1, 1.1);
  }

  40% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  60% {
    opacity: 1;
    transform: scale3d(1.03, 1.03, 1.03);
  }

  80% {
    transform: scale3d(0.97, 0.97, 0.97);
  }

  to {
    opacity: 1;
    transform: scale3d(1, 1, 1);
  }
`;
oe`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: translate3d(0, -3000px, 0) scaleY(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, 25px, 0) scaleY(0.9);
  }

  75% {
    transform: translate3d(0, -10px, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, 5px, 0) scaleY(0.985);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    transform: translate3d(-3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(25px, 0, 0) scaleX(1);
  }

  75% {
    transform: translate3d(-10px, 0, 0) scaleX(0.98);
  }

  90% {
    transform: translate3d(5px, 0, 0) scaleX(0.995);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(3000px, 0, 0) scaleX(3);
  }

  60% {
    opacity: 1;
    transform: translate3d(-25px, 0, 0) scaleX(1);
  }

  75% {
    transform: translate3d(10px, 0, 0) scaleX(0.98);
  }

  90% {
    transform: translate3d(-5px, 0, 0) scaleX(0.995);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from,
  60%,
  75%,
  90%,
  to {
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  from {
    opacity: 0;
    transform: translate3d(0, 3000px, 0) scaleY(5);
  }

  60% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  75% {
    transform: translate3d(0, 10px, 0) scaleY(0.95);
  }

  90% {
    transform: translate3d(0, -5px, 0) scaleY(0.985);
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  20% {
    transform: scale3d(0.9, 0.9, 0.9);
  }

  50%,
  55% {
    opacity: 1;
    transform: scale3d(1.1, 1.1, 1.1);
  }

  to {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }
`;
oe`
  20% {
    transform: translate3d(0, 10px, 0) scaleY(0.985);
  }

  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, -20px, 0) scaleY(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0) scaleY(3);
  }
`;
oe`
  20% {
    opacity: 1;
    transform: translate3d(20px, 0, 0) scaleX(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0) scaleX(2);
  }
`;
oe`
  20% {
    opacity: 1;
    transform: translate3d(-20px, 0, 0) scaleX(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0) scaleX(2);
  }
`;
oe`
  20% {
    transform: translate3d(0, -10px, 0) scaleY(0.985);
  }

  40%,
  45% {
    opacity: 1;
    transform: translate3d(0, 20px, 0) scaleY(0.9);
  }

  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0) scaleY(3);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
  }
`;
oe`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 100%, 0);
  }
`;
oe`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 100%, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, 2000px, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(-2000px, 0, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(2000px, 0, 0);
  }
`;
oe`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(-100%, -100%, 0);
  }
`;
oe`
  from {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }

  to {
    opacity: 0;
    transform: translate3d(100%, -100%, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(0, -2000px, 0);
  }
`;
oe`
  from {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, -360deg);
    animation-timing-function: ease-out;
  }

  40% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -190deg);
    animation-timing-function: ease-out;
  }

  50% {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 150px)
      rotate3d(0, 1, 0, -170deg);
    animation-timing-function: ease-in;
  }

  80% {
    transform: perspective(400px) scale3d(0.95, 0.95, 0.95) translate3d(0, 0, 0)
      rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }

  to {
    transform: perspective(400px) scale3d(1, 1, 1) translate3d(0, 0, 0) rotate3d(0, 1, 0, 0deg);
    animation-timing-function: ease-in;
  }
`;
oe`
  from {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(1, 0, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(1, 0, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;
oe`
  from {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    animation-timing-function: ease-in;
    opacity: 0;
  }

  40% {
    transform: perspective(400px) rotate3d(0, 1, 0, -20deg);
    animation-timing-function: ease-in;
  }

  60% {
    transform: perspective(400px) rotate3d(0, 1, 0, 10deg);
    opacity: 1;
  }

  80% {
    transform: perspective(400px) rotate3d(0, 1, 0, -5deg);
  }

  to {
    transform: perspective(400px);
  }
`;
oe`
  from {
    transform: perspective(400px);
  }

  30% {
    transform: perspective(400px) rotate3d(1, 0, 0, -20deg);
    opacity: 1;
  }

  to {
    transform: perspective(400px) rotate3d(1, 0, 0, 90deg);
    opacity: 0;
  }
`;
oe`
  from {
    transform: perspective(400px);
  }

  30% {
    transform: perspective(400px) rotate3d(0, 1, 0, -15deg);
    opacity: 1;
  }

  to {
    transform: perspective(400px) rotate3d(0, 1, 0, 90deg);
    opacity: 0;
  }
`;
oe`
  0% {
    animation-timing-function: ease-in-out;
  }

  20%,
  60% {
    transform: rotate3d(0, 0, 1, 80deg);
    animation-timing-function: ease-in-out;
  }

  40%,
  80% {
    transform: rotate3d(0, 0, 1, 60deg);
    animation-timing-function: ease-in-out;
    opacity: 1;
  }

  to {
    transform: translate3d(0, 700px, 0);
    opacity: 0;
  }
`;
oe`
  from {
    opacity: 0;
    transform: scale(0.1) rotate(30deg);
    transform-origin: center bottom;
  }

  50% {
    transform: rotate(-10deg);
  }

  70% {
    transform: rotate(3deg);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
`;
oe`
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0) rotate3d(0, 0, 1, -120deg);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0) rotate3d(0, 0, 1, 120deg);
  }
`;
oe`
  from {
    transform: rotate3d(0, 0, 1, -200deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;
oe`
  from {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;
oe`
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;
oe`
  from {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;
oe`
  from {
    transform: rotate3d(0, 0, 1, -90deg);
    opacity: 0;
  }

  to {
    transform: translate3d(0, 0, 0);
    opacity: 1;
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 200deg);
    opacity: 0;
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 45deg);
    opacity: 0;
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, -45deg);
    opacity: 0;
  }
`;
oe`
  from {
    opacity: 1;
  }

  to {
    transform: rotate3d(0, 0, 1, 90deg);
    opacity: 0;
  }
`;
oe`
  from {
    transform: translate3d(0, -100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    transform: translate3d(100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
`;
oe`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
`;
oe`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(-100%, 0, 0);
  }
`;
oe`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(100%, 0, 0);
  }
`;
oe`
  from {
    transform: translate3d(0, 0, 0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, -100%, 0);
  }
`;
oe`
  from {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  50% {
    opacity: 1;
  }
`;
oe`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;
oe`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(-1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;
oe`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(1000px, 0, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-10px, 0, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;
oe`
  from {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 1000px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  60% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;
oe`
  from {
    opacity: 1;
  }

  50% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3);
  }

  to {
    opacity: 0;
  }
`;
oe`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, -60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, 2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;
oe`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(42px, 0, 0);
  }

  to {
    opacity: 0;
    transform: scale(0.1) translate3d(-2000px, 0, 0);
  }
`;
oe`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(-42px, 0, 0);
  }

  to {
    opacity: 0;
    transform: scale(0.1) translate3d(2000px, 0, 0);
  }
`;
oe`
  40% {
    opacity: 1;
    transform: scale3d(0.475, 0.475, 0.475) translate3d(0, 60px, 0);
    animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  to {
    opacity: 0;
    transform: scale3d(0.1, 0.1, 0.1) translate3d(0, -2000px, 0);
    animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1);
  }
`;
const f5 = oe`
  from {
    opacity: 0;
    transform: translate3d(0, 16px, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
`, p5 = ({ keyframes: e, ...t }) => /* @__PURE__ */ L(
  a1,
  {
    keyframes: f5,
    ...t
  }
), IM = p5, s1 = ({
  animation: e,
  children: t,
  group: r = !1,
  ...n
}) => /* @__PURE__ */ L(e, { ...n, children: r ? /* @__PURE__ */ L("div", { children: t }) : t });
s1.DAMPLING = {
  FASTEST: 0.1,
  FAST: 0.3,
  MEDIUM: 0.5,
  SLOW: 0.7,
  SLOWEST: 1
};
const FM = s1, m5 = ({
  children: e,
  classes: t,
  className: r,
  variant: n,
  size: o,
  withCancelButton: a = !0,
  withConfirmButton: i = !0,
  messages: s,
  onConfirm: l,
  onCancel: u,
  onClose: c,
  title: p,
  content: d,
  open: f = !1,
  dialogClasses: m,
  zIndex: v
}) => {
  const { themeClasses: h } = Ge("Prompt", t, r, {
    variant: n,
    modifier: o
  });
  return /* @__PURE__ */ ue(
    su,
    {
      open: f,
      onClose: c,
      classes: m,
      transition: !0,
      title: p,
      className: V(h == null ? void 0 : h.root),
      zIndex: v,
      children: [
        /* @__PURE__ */ L("div", { className: V("mb-6 text-center text-base", h == null ? void 0 : h.content), children: d }),
        /* @__PURE__ */ ue("div", { className: "flex items-center justify-center gap-x-2", children: [
          a && /* @__PURE__ */ L(
            Ko,
            {
              variant: "secondary",
              onClick: (_) => {
                u == null || u(_), c();
              },
              className: "max-w-[100px] capitalize",
              size: "sm",
              children: s == null ? void 0 : s.cancel
            }
          ),
          i && /* @__PURE__ */ L(
            Ko,
            {
              variant: "primary",
              onClick: l,
              className: "max-w-[100px] capitalize",
              size: "sm",
              children: s == null ? void 0 : s.confirm
            }
          )
        ] })
      ]
    }
  );
}, LM = m5;
function h5(e, t) {
  if (t.env === "production" && "serviceWorker" in navigator) {
    if (new URL(t.publicUrl, e.location.href).origin !== e.location.origin)
      return;
    e.addEventListener("load", () => {
      const n = `${t.publicUrl}/${t.fileName}`;
      !!(e.location.hostname === "localhost" || // [::1] is the IPv6 localhost address.
      e.location.hostname === "[::1]" || // 127.0.0.0/8 are considered localhost for IPv4.
      e.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)) ? (v5(e, n, t), navigator.serviceWorker.ready.then(() => {
        console.log(
          "This web app is being served cache-first by a service worker. To learn more, visit https://cra.link/PWA"
        );
      })) : l1(e, n, t);
    });
  }
}
async function g5(e, t, r) {
  if (!r.notificationURI) return;
  let n;
  try {
    if (n = await r.getVersion(), !n) throw new Error("Invalid version");
    const o = sessionStorage.getItem(r.storageKeyVersion ?? "");
    if (n && o === n)
      return;
  } catch (o) {
    console.log("Error on fetching version:", o);
  }
  try {
    const o = await fetch(r.notificationURI + r.notificationInfoEndpoint, {
      method: "GET"
    }), {
      result: {
        subscribeEndpoint: a,
        vapidKey: i
        // skip
      }
    } = await o.json(), l = new URLSearchParams(e.location.search).get(r.notificationTestParam ?? "");
    if (a) {
      let u = await t.pushManager.getSubscription();
      if (!u && i) {
        let c = !1;
        try {
          u = await t.pushManager.subscribe({
            userVisibleOnly: !0,
            applicationServerKey: i
          });
        } catch (p) {
          console.log(p), "message" in p && p.message.startsWith("Registration failed - A subscription with a different applicationServerKey") && (c = !0);
        }
        c && u && await u.unsubscribe();
      }
      if (u) {
        const c = window.location.hostname ?? "", p = sessionStorage.getItem(r.storageKeyMemberId ?? vu) ?? void 0;
        try {
          await fetch(r.notificationURI + a, {
            method: "POST",
            body: JSON.stringify({
              subscription: u,
              client: l ?? c,
              accountId: r.accountId,
              memberId: p
            }),
            headers: {
              "Content-Type": "application/json"
            }
          }), sessionStorage.setItem(r.storageKeyVersion ?? ym, n ?? "");
        } catch (d) {
          console.log("Subscribe Error", d);
        }
      }
    }
  } catch (o) {
    console.log("Fetching notification info failed", o);
  }
}
function l1(e, t, r) {
  navigator.serviceWorker.register(t).then((n) => (n.onupdatefound = () => {
    const o = n.installing;
    o != null && (o.onstatechange = () => {
      o.state === "installed" && (navigator.serviceWorker.controller ? (console.log(
        "New content is available and will be used when all tabs for this page are closed. See https://cra.link/PWA."
      ), r && r.onUpdate ? r.onUpdate(n) : n.update().then(() => {
        "reload" in e.location && e.location.reload();
      })) : (console.log("Content is cached for offline use."), r && r.onSuccess && r.onSuccess(n)));
    });
  }, navigator.serviceWorker.ready)).then(async (n) => {
    await g5(e, n, r);
  }).catch((n) => {
    console.error("Error during service worker registration:", n);
  });
}
function v5(e, t, r) {
  fetch(t, {
    headers: { "Service-Worker": "script" }
  }).then((n) => {
    const o = n.headers.get("content-type");
    n.status === 404 || o != null && o.indexOf("javascript") === -1 ? navigator.serviceWorker.ready.then((a) => {
      a.unregister().then(() => {
        sessionStorage.clear(), "reload" in e.location && e.location.reload();
      });
    }) : l1(e, t, r);
  }).catch(() => {
    console.log("No internet connection found. App is running in offline mode.");
  });
}
function y5() {
  "serviceWorker" in navigator && navigator.serviceWorker.ready.then((e) => {
    e.unregister().then(() => sessionStorage.clear());
  }).catch((e) => {
    console.error(e.message);
  });
}
const $M = (e, t) => (t.notificationInfoEndpoint = t.notificationInfoEndpoint ?? "/notification/info", t.storageKeyVersion = t.storageKeyVersion ?? ym, t.storageKeyMemberId = t.storageKeyMemberId ?? vu, t.fileName = t.fileName ?? "service-worker.js", {
  register: () => h5(e, t),
  unregister: y5
}), WM = (e, { offlineUrl: t, cacheVersionKey: r, getVersion: n }) => {
  e.addEventListener("fetch", (o) => {
    o.respondWith(
      caches.match(o.request).then((a) => a || fetch(o.request)).catch(() => caches.match(t))
    );
  }), e.addEventListener("activate", async (o) => {
    o.waitUntil(
      (async () => {
        try {
          const a = await n(), i = await caches.keys();
          let s = !1;
          const l = r + a;
          await Promise.all(
            i.map(async (u) => {
              l !== u && (await caches.delete(u), s = !0);
            })
          ), await self.clients.claim(), s ? (console.log("New version found: ", a), (await self.clients.matchAll({ type: "window" })).forEach((c) => c.navigate(c.url))) : console.log("No new cache version, skipping reload");
        } catch (a) {
          console.error("Error in service worker activation", a);
        }
      })()
    );
  }), e.addEventListener("install", (o) => {
    e.skipWaiting(), o.waitUntil(
      (async () => {
        const a = await n(), i = r + a;
        (await caches.open(i)).addAll(["/"]);
      })()
    );
  });
}, YM = (e, { defaultIcon: t, defaultAppUrl: r, enable: n }) => {
  n && (e.addEventListener("push", async function(o) {
    if (console.log(o), !o.data) return;
    const a = await o.data.json();
    let { title: i, icon: s, ...l } = a;
    o.waitUntil(
      this.registration.showNotification(i, {
        icon: s ?? t,
        ...l
      })
    );
  }), e.addEventListener("notificationclick", async function(o) {
    var i;
    o.notification.close();
    let a = self.location.origin;
    if ((i = o.notification.data) != null && i.action)
      switch (o.notification.data.action.type) {
        case lo.OPEN_LINK_CURRENT_PAGE:
        case lo.OPEN_LINK_NEW_WINDOW:
        case lo.OPEN_LINK_NEW_TAB:
          a = o.notification.data.action.target;
          break;
        case lo.LOAD_PAGE:
      }
    o.waitUntil(
      e.clients.matchAll({ type: "window" }).then((s) => {
        var l, u, c, p;
        for (let d = 0; d < s.length; d++) {
          let f = s[d];
          if ((l = o.notification.data) != null && l.action) {
            if (f.url === a && "focus" in f)
              return f.focus();
          } else if (f.url.includes(a) && "focus" in f)
            return f.focus();
        }
        if ((u = e.clients) != null && u.openWindow)
          switch ((p = (c = o.notification.data) == null ? void 0 : c.action) == null ? void 0 : p.type) {
            case lo.OPEN_LINK_CURRENT_PAGE:
              if (s.length > 0) {
                const d = s[s.length - 1];
                return d.focus().then(() => "navigate" in d ? d.navigate(a) : e.clients.openWindow(a));
              } else
                return e.clients.openWindow(a);
            case lo.OPEN_LINK_NEW_WINDOW:
            case lo.OPEN_LINK_NEW_TAB:
            default:
              return e.clients.openWindow(a);
          }
      })
    );
  }));
};
export {
  eM as APIClient,
  O5 as APIErrorCodes,
  bv as AccountVariableKey,
  wv as AccountVariableType,
  C5 as BN_ONE,
  F1 as BN_ZERO,
  yM as BackButton,
  W5 as BankConfigConvertSpec,
  I5 as BankListModelConvertSpec,
  ao as BaseModelConvertSpec,
  CM as BottomNavigation,
  PM as BottomNavigationAction,
  Ko as Button,
  bM as ButtonIcon,
  RM as Card,
  pv as CashBackType,
  xD as Checkbox,
  wM as CodeField,
  sM as CopyWrapper,
  I1 as DEFAULT_TRANSITION_DURATION,
  xM as DateRangePicker,
  K5 as DefaultTheme,
  _v as DepositMethodType,
  su as Dialog,
  qC as Drawer,
  QC as DrawerTitle,
  lM as EmptyState,
  IM as FadeUpSmall,
  Qd as FieldHelperText,
  Ee as FieldType,
  X5 as FlatTheme,
  Rv as FundingMethodConvertSpec,
  Cv as FundingMethodDepositMethod,
  Mv as FundingMethodKey,
  Dv as FundingMethodStatus,
  Nv as FundingMethodType,
  Pv as FundingMethodWithdrawMethod,
  Dm as FundingModelConvertSpec,
  uo as FundingStatus,
  tM as FundingTransaction,
  cv as FundingTxPayDataType,
  Wo as FundingType,
  yv as GameCategoryStatus,
  hv as GameGatewayType,
  $5 as GameProviderSpecs,
  vv as GameProviderStatus,
  gv as GameProviderType,
  L5 as GameSpecs,
  mv as GameStatus,
  rM as GameTransaction,
  uv as GameTxModelConvertSpec,
  lv as GameTxType,
  uT as HLDescription,
  L3 as HLDialog,
  F3 as HLDialogBackdrop,
  rg as HLDialogPanel,
  ng as HLDialogTitle,
  mM as HLDisclosure,
  Z3 as HLDisclosureButton,
  J3 as HLDisclosurePanel,
  hM as HLMenu,
  Uk as HLMenuButton,
  Vk as HLMenuItem,
  Hk as HLMenuItems,
  gM as HLPopover,
  mO as HLPopoverBackdrop,
  fO as HLPopoverButton,
  hO as HLPopoverPanel,
  vM as HLTab,
  LO as HLTabGroup,
  $O as HLTabList,
  YO as HLTabPanel,
  WO as HLTabPanels,
  tg as HLTransition,
  Qo as HLTransitionChild,
  cM as HTMLSanitizer,
  nM as LanguageSelector,
  xE as List,
  AM as MaskedImg,
  iv as MemberModelConvertSpec,
  ev as MemberStatus,
  Ev as MethodBankRequirement,
  lo as NOTIFICATION_ACTION,
  _M as NumberField,
  oM as NumberPad,
  aM as PWAInstaller,
  EM as Page,
  TM as PageContent,
  kM as PageFooter,
  OM as PageHeader,
  DM as PageTitle,
  NM as PageTransitionOverlay,
  xv as PaymentProviderKey,
  tv as PrivilegeDomain,
  vf as ProfileResponseConvertSpecs,
  uM as ProgressBar,
  LM as Prompt,
  D5 as REG_PHONE_10_DIGITS,
  N5 as REG_PHONE_11_DIGITS,
  kv as ReferralCommissionSettingsSpec,
  Ov as ReferralOverallSpec,
  gf as ReferralTxModelSpec,
  Tv as ReferralTxType,
  FM as RevealOnScroll,
  av as RewardsStatusSpecs,
  vu as SW_MEMBER_ID_STORAGE_KEY,
  ym as SW_VERSION_STORAGE_KEY,
  SM as Select,
  gE as SelectOptions,
  sv as SelfEntityModelConvertSpec,
  dM as Skeleton,
  TE as StatusChip,
  T5 as TRANSITION_IN_FADE,
  D1 as TRANSITION_IN_SLIDE_DOWN,
  P1 as TRANSITION_IN_SLIDE_LEFT,
  R1 as TRANSITION_IN_SLIDE_RIGHT,
  O1 as TRANSITION_IN_SLIDE_UP,
  k5 as TRANSITION_OUT_FADE,
  N1 as TRANSITION_OUT_SLIDE_DOWN,
  A1 as TRANSITION_OUT_SLIDE_LEFT,
  M1 as TRANSITION_OUT_SLIDE_RIGHT,
  C1 as TRANSITION_OUT_SLIDE_UP,
  MM as TabNavigation,
  TC as TextField,
  J5 as ThemeConsumer,
  Uu as ThemeContext,
  Z5 as ThemeProvider,
  Jh as Transaction,
  Av as WSEventType,
  ov as WalletModelConvertSpec,
  fv as WalletRewardPeriod,
  nv as WalletTxMethod,
  F5 as WalletTxModelConvertSpec,
  rv as WalletTxType,
  dv as WalletType,
  iM as WarningWrapper,
  Sv as WithdrawMethodType,
  pS as accountVariablesEndpoints,
  Ff as authAPIConfig,
  q_ as authTags,
  mS as bankAccountEndpoints,
  mi as bnOrZero,
  U5 as capitalize,
  V as cn,
  Za as convert,
  xh as convertAnyResult,
  Ac as convertListResult,
  wh as convertObjectResult,
  $1 as copyToClipboard,
  $M as createSWRegistration,
  L1 as delay,
  hS as depositMethodEndpoints,
  S1 as detectFbIab,
  T1 as detectIosDevice,
  E1 as detectLineIab,
  Y1 as fAmount,
  W1 as fNumber,
  gS as gamesEndpoints,
  K_ as getPersistedDueAt,
  r_ as htmlSanitizer,
  uS as infoEndpoints,
  B1 as isNumber,
  R5 as localizePhoneNumber,
  U_ as mergeClasses,
  H5 as normalizeUrl,
  P5 as numberOrZero,
  H_ as oauthEndpoints,
  j1 as parseBN,
  Mr as parseQs,
  z_ as passwordEndpoints,
  Rh as persistDueAt,
  Yf as publicAPIConfig,
  fS as publicTags,
  vS as referralEndpoints,
  cS as registerEndpoints,
  WM as registerSWCache,
  YM as registerSWNotification,
  yS as rewardsEndpoints,
  V_ as selfEndpoints,
  u_ as semver,
  dS as serverConfigEndpoints,
  Bf as siteAPIConfig,
  SS as siteTags,
  M5 as standardizePhoneNumber,
  j5 as storage,
  bS as termConditionsEndpoints,
  wS as topupEndpoints,
  xS as transactionEndpoints,
  Ix as transformAccessToken,
  B5 as transformAnyWithSpec,
  Ef as transformListWithSpec,
  Y5 as transformObjectWithSpec,
  dt as transformWithSpec,
  ff as translate,
  A5 as updatePushSubscription,
  G_ as useCallbackRef,
  V5 as useCustomEventsListener,
  Z_ as useDateAvailCheck,
  z5 as useHandleApiResponse,
  q5 as useInfiniteQuery,
  G5 as useResetScroll,
  Q5 as useStickyDetection,
  Ge as useThemePresetClasses,
  _S as withdrawEndpoints
};
